webpackJsonp([1],Array(140).concat([
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"modal-head background-light-pink text-center padding-tb-20\"\u003E\u003Ch2 class=\"fs-20 no-margin\"\u003EVOUS AVEZ UNE QUESTION ?\u003C\u002Fh2\u003E\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-light-pink\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contact-modal\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Cdiv ng-if=\"$root.dataFeature['contactForm'] &amp;&amp; !displayForm\"\u003E\u003Cdiv class=\"text-center\" ng-if=\"$root.dataFeature['contactForm'] &amp;&amp; !displayForm\"\u003E\u003Cp class=\"fw-500\"\u003ELa réponse se trouve sans doute dans notre FAQ !\u003Cbr\u003EC’est simple, rapide et accessible à tout moment !\u003C\u002Fp\u003E\u003Ca class=\"btn inline-block background-light-pink margin-tb-10 padding-tb-10\" ng-href=\"https:\u002F\u002Fassistance.plum.fr\" target=\"_blank\"\u003EJE POSE MA QUESTION\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Chr class=\"margin-tb-30\"\u003E\u003Cp\u003EVous n’avez pas trouvé de réponse dans notre FAQ ?\u003Cbr\u003ENotre service client sera ravi de vous aider :\u003C\u002Fp\u003E\u003Cdiv class=\"margin-tb-30 text-center\"\u003E\u003Cimg class=\"margin-bottom-10\" src=\"\u002Fassets\u002Fimg\u002Ftel-plm.svg\"\u003E\u003Cp\u003EDu lundi au vendredi, de 9h à 18h\u003C\u002Fp\u003E\u003Ca class=\"btn inline-block white background-bluegrey\" ng-href=\"{{contactTelephone.client.link}}\" ng-bind=\"contactTelephone.client.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-tb-30 text-center\" permission permission-only=\"'client'\"\u003E\u003Cimg class=\"margin-bottom-10\" src=\"\u002Fassets\u002Fimg\u002Ftel-enedis.svg\"\u003E\u003Cp\u003EEN CAS D’URGENCE\u003Cbr\u003EPour signaler une coupure générale ou un dysfonctionnement de votre compteur, contactez Enedis au\u003C\u002Fp\u003E\u003Ca class=\"btn inline-block white background-bluegrey\" ng-href=\"{{contactTelephone.emergency.link}}\" ng-bind=\"contactTelephone.emergency.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$root.dataFeature['contactForm'] &amp;&amp; displayForm\"\u003E\u003Cdiv class=\"form-header\"\u003E\u003Ch4\u003ECONTACT\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\" ng-if=\"form.isContactSent\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cp\u003EVotre message a été envoyé.\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-warning\" ng-click=\"close()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" name=\"form.api\" ng-if=\"!form.isContactSent\" ng-submit=\"gaEventsService.newEvent('click - Nous Ecrire - Envoi formulaire') &amp;&amp; sendMessage(form)\"\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"form.error.hasError\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp\u003EOups, il y eu un problème, votre message n'a pas été envoyé.\u003Cbr\u003E\u003Cbr\u003E\u003Cspan ng-bind=\"form.error.message\"\u003E\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003ELe plus simple est que vous nous écriviez à l'adresse\n\u003Ca class=\"underlined\" ng-href=\"mailto:{{mailAdresse.bonjour}}?subject={{form.model.selectedSubject.subject}}\"\u003E{{mailAdresse.bonjour}}\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv class=\"row form-group\" ng-if=\"!form.isCustomerIdDefined\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Clabel\u003EPrénom\u003Cinput type=\"text\" name=\"prenom\" ng-model=\"form.model.firstName\" placeholder=\"Prénom\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-if=\"!form.isCustomerIdDefined\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Clabel\u003ENom de famille\u003Cinput class=\"force-uppercase\" type=\"text\" name=\"nom\" ng-model=\"form.model.lastName\" placeholder=\"NOM\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Clabel\u003EAdresse e-mail\u003Cinput type=\"email\" name=\"email\" ng-model=\"form.model.email\" placeholder=\"votre@email.com\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Clabel\u003EObjet\u003Cselect class=\"form-control small\" name=\"subject\" ng-model=\"form.model.selectedSubject\" ng-options=\"cat.subject for cat in availableCategories\" required\u003E\u003Coption\u003E\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Clabel\u003EJoindre un fichier\u003Cinput type=\"file\" name=\"attachment\" nv-file-select uploader=\"uploader\"\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cspan ng-if=\"fileUploaderStatus === 'SENDING'\"\u003E\u003Ci class=\"spinner spinner-form\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"fileUploaderStatus === 'SUCCESS'\"\u003E\u003Ci class=\"fa fa-2x fa-check light-green\"\u003E\u003C\u002Fi\u003EFichier envoyé\u003C\u002Fspan\u003E\u003Cspan ng-if=\"fileUploaderStatus === 'FAIL'\"\u003E\u003Ci class=\"fa fa-2x fa-times dark-pink\"\u003E\u003C\u002Fi\u003EErreur lors de l'envoie: {{fileUploaderMessage}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Clabel\u003EMessage\u003Ctextarea name=\"body\" ng-model=\"form.model.body\" placeholder=\"Taper votre message ici...\" required\u003E\u003C\u002Ftextarea\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-if=\"!form.isCustomerIdDefined\" ng-class=\"{error: form.api.$submitted &amp;&amp; form.api.captcha.$error.required}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\"form.api.$submitted &amp;&amp; form.api.captcha.$error.required\"\u003E\u003C\u002Fi\u003E\u003Cdiv\u003E\u003Cdiv class=\"col-md-6\" vc-recaptcha name=\"captcha\" required key=\"captcha.key\" size=\"isMobile() ? 'compact' : 'normal'\" ng-model=\"form.model.captcha\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 form-message\" ng-class=\"{formmessage: !isMobile(), formmessagemob: isMobile()}\"\u003E\u003Cp ng-if=\"form.api.$submitted &amp;&amp; form.api.captcha.$error.required\"\u003ECette étape est conçue pour que nous nous assurions que c'est bien une personne\net non un ordinateur qui essaie de remplir le formulaire.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 form-footer\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': form.isContactSending}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"form.isContactSending || fileUploaderStatus === 'SENDING'\"\u003EEnvoyer le message\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _find = __webpack_require__(192);

var _find2 = _interopRequireDefault(_find);

var _get = __webpack_require__(8);

var _get2 = _interopRequireDefault(_get);

var _map = __webpack_require__(53);

var _map2 = _interopRequireDefault(_map);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Quotation second reading date locally => first reading date + 6 month
// The idea is to hide price after second reading date
var fetchSecondReadingDate = function fetchSecondReadingDate(values) {
    var item = (0, _find2.default)(values, 'nextReading');
    return item ? (0, _moment2.default)({ year: item.year, month: item.month - 1 }).add(6, 'month') : _moment2.default.invalid();
};

var mapTimetableItemToGraphData = function mapTimetableItemToGraphData(secondReadingDate) {
    return function (item) {
        var momentDate = (0, _moment2.default)({ year: item.year, month: item.month - 1 });
        return {
            date: momentDate.format('YYYY-MM-DD'),
            amount: Math.floor(item.total * 100) / 100,
            sleeked: Math.floor(item.sleeked * 100) / 100,
            nextReading: (0, _get2.default)(item, 'nextReading', false) || secondReadingDate.isSame(momentDate, 'month'),
            // Don't display price after second reading date
            amountDisplay: !secondReadingDate.isValid() || momentDate.isBefore(secondReadingDate, 'month')
        };
    };
};

function timelineToGraphData(values) {
    return (0, _map2.default)(values, mapTimetableItemToGraphData(fetchSecondReadingDate(values))).slice(0, 12);
}

exports.default = timelineToGraphData;

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cui-view\u003E\u003C\u002Fui-view\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cnav class=\"navbar navbar-default\" ng-class=\"{'background-marine': fromCommunity}\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"navbar-header\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2 default-form\"\u003E\u003Cdiv class=\"form-header\"\u003E\u003Ch4\u003E{{page === 'firstLogin' ? 'CONFIGURATION DE VOTRE MOT DE PASSE' : 'RÉINITIALISEZ VOTRE MOT DE PASSE'}}\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" ng-if=\"!sendResetPasswdSuccess\" ng-submit=\"sendResetPassword(user)\"\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"sendResetPasswd\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp ng-if=\"incorrectEmail\"\u003EAdresse e-mail inconnue\u003C\u002Fp\u003E\u003Cp ng-if=\"unknownError\"\u003ENous n'avons pas pu traiter votre demande de réinitialisation de mot de passe. Veuillez renouveler l'opération.\u003Cbr\u003EVous avez la possibilité de contacter directement le service client au\n\u003Ca class=\"underline\" ng-href=\"{{contactTelephone.anonymous.link}}\" ng-bind=\"contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\nafin de résoudre le problème.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EAdresse e-mail :\u003Cinput type=\"email\" name=\"email\" placeholder=\"votre@email.com\" ng-model=\"user.username\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 form-footer\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': isForgotPassword}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"isForgotPassword\"\u003EEnvoyer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cdiv class=\"form-container form-body\" ng-if=\"sendResetPasswdSuccess\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cp\u003ESi un compte existe avec l'adresse {{user.username}}, nous y avons envoyé un e-mail qui vous permettra de {{ page === 'firstLogin' ? 'définir' : 'redéfinir' }} votre mot de passe.\u003C\u002Fp\u003E\u003Cdiv class=\"text-right\"\u003E\u003Ca class=\"underlined side-text\" ui-sref=\"login({source: source, redirectTo: redirectTo})\"\u003EMe connecter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"subscriptionSummary\"\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"container-fluid background-white\" ng-submit=\"goToPayment()\" name=\"subscriptionSummaryForm\"\u003E\u003Cdiv class=\"row background-beige\" style=\"margin-top: 20px\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-8\"\u003E\u003Ch2\u003ERésumé de la proposition de contrat\u003C\u002Fh2\u003E\u003Ch4\u003EPour toute modification des informations ci-dessous, veuillez contacter notre service client.\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4\"\u003E\u003Cdiv class=\"panel-shadow text-center padding-15 margin-tb-20\" ng-if=\"contractDraft.account_category === 'small-business'\"\u003E\u003Cp class=\"fs-26 fw-600\"\u003E\u003Ca ng-href=\"contactTelephone.smallBusiness.link\"\u003E{{contactTelephone.smallBusiness.label}}\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp class=\"fw-500\"\u003E{{contactTelephone.smallBusiness.openingHour}}\u003Cbr\u003Eprix d’un appel local\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"panel-shadow text-center padding-15 margin-tb-20\" ng-if=\"contractDraft.account_category !== 'small-business'\"\u003E\u003Cp class=\"fs-26 fw-600\"\u003E\u003Ca ng-href=\"contactTelephone.client.link\"\u003E{{contactTelephone.client.label}}\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp class=\"fw-500\"\u003E{{contactTelephone.client.openingHour}}\u003Cbr\u003Eprix d’un appel local\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\" ng-if=\"contractDraft.id_ref_promo.length &amp;&amp; errorPromo\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"row error\"\u003E\u003Cdiv class=\"text-center\"\u003EOups ! Il semblerait qu'il y ait un petit souci avec votre code promo.\nContactez nous par e-mail :\n\u003Ca class=\"underline\" ng-href=\"mailto:bonjour@plum.fr\"\u003Ebonjour@plum.fr\u003C\u002Fa\u003E\nou par téléphone : {{ contactTelephone.client.label }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Ch3 class=\"title-separator title-separator-light-pink\"\u003EMes coordonnées\u003C\u002Fh3\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\" ng-if=\"contractDraft.account_category !== 'small-business'\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EN° de contrat\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.id }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ENom\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.sn }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EPrénom\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.givenname }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ETéléphone\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ formatTo0607(contractDraft.phone) }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EE-mail\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.mail }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\" ng-if=\"contractDraft.account_category === 'small-business'\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EN° de contrat\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.id }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ch4 class=\"margin-bottom-20 underlined\"\u003EInformations société\u003C\u002Fh4\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ERaison commerciale :\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.legal_name }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ESIRET\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.siret }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ECode NAF\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.business_code }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ch4 class=\"margin-bottom-20 underlined\"\u003ECoordonnées contact principal\u003C\u002Fh4\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ENom\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.sn }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EPrénom\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.givenname }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ETéléphone\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ formatTo0607(contractDraft.phone) }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EE-mail\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.mail }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\" ng-if=\"contractDraft.account_category !== 'small-business'\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003E&nbsp;\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E&nbsp;\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-if=\"contractDraft.sn2\"\u003E\u003Clabel class=\"col-sm-4\"\u003E2ème nom\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.sn2 }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-if=\"contractDraft.givenname2\"\u003E\u003Clabel class=\"col-sm-4\"\u003E2ème prénom\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.givenname2 }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ENuméro de voie\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.addr_num_street }} {{ contractDraft.addr_details }}\u003Cspan ng-if=\"contractDraft.addr_bat\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E{{ contractDraft.addr_bat }}\u003Cspan ng-if=\"contractDraft.addr_locality\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E{{ contractDraft.addr_locality }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ECode postal & ville\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.addr_post_code }} {{ contractDraft.addr_city_lbl }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\" ng-if=\"contractDraft.account_category === 'small-business'\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003E&nbsp;\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E&nbsp;\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ch4 class=\"margin-bottom-20 underlined\"\u003EAdresse de facturation\u003C\u002Fh4\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ENuméro de voie\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\" ng-if=\"contractDraft.bill_addr_num_street\"\u003E\u003Cp\u003E{{ contractDraft.bill_addr_num_street }} {{ contractDraft.bill_addr_details }}\u003Cspan ng-if=\"contractDraft.bill_addr_bat\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E{{ contractDraft.addr_bat }}\u003Cspan ng-if=\"contractDraft.bill_addr_locality\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E{{ contractDraft.bill_addr_locality }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\" ng-if=\"!contractDraft.bill_addr_num_street\"\u003E\u003Cp\u003E{{ contractDraft.addr_num_street }} {{ contractDraft.addr_details }}\u003Cspan ng-if=\"contractDraft.addr_bat\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E{{ contractDraft.addr_bat }}\u003Cspan ng-if=\"contractDraft.addr_locality\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E{{ contractDraft.addr_locality }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ECode postal & ville\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\" ng-if=\"contractDraft.bill_addr_num_street\"\u003E\u003Cp\u003E{{ contractDraft.bill_addr_post_code }} {{ contractDraft.bill_addr_city_lbl }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\" ng-if=\"!contractDraft.bill_addr_num_street\"\u003E\u003Cp\u003E{{ contractDraft.addr_post_code }} {{ contractDraft.addr_city_lbl }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr class=\"separator-2 separator-margin-lr-30 separator-beige margin-top-40 margin-bottom-20\"\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Ch3 class=\"title-separator title-separator-orange\"\u003EOffre\u003C\u002Fh3\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EPoint de livraison\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.id_prm }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EÉlectricité\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E100% renouvelable\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EÉchéancier\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ getSleekSentence() }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-if=\"contractDraft.sponsor_id\"\u003E\u003Clabel class=\"col-sm-4\"\u003EParrain\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.sponsor_id }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EOffre\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.providerOffer.label }}\n\u003Ci class=\"fa fa-info-circle clickable\" uib-popover=\"{{contractDraft.providerOffer.description}}\" popover-trigger=\"'outsideClick'\" popover-append-to-body=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EOption tarifaire\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.choosen_id_p_calendar ? formatCalendar(contractDraft.choosen_id_p_calendar) : formatCalendar(contractDraft.id_p_calendar) }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EPuissance\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.choosen_max_power ? contractDraft.choosen_max_power : contractDraft.max_power }} kVA\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-if=\"contractDraft.declared_cons\"\u003E\u003Clabel class=\"col-sm-4\"\u003EConsommation annuelle de référence\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\" ng-if=\"contractDraft.id_p_calendar === 'BASE'\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003EBASE\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp class=\"form-control-static\"\u003E{{ contractDraft.declared_cons.cons.BASE }} kWh\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\" ng-if=\"contractDraft.id_p_calendar === 'HPHC'\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003EHP\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp class=\"form-control-static\"\u003E{{ contractDraft.declared_cons.cons.HP }} kWh\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003EHC\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp class=\"form-control-static\"\u003E{{ contractDraft.declared_cons.cons.HC }} kWh\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-if=\"contractDraft.provider_offer === 'CAGNOTTE_TRV_PRO_U'\"\u003E\u003Clabel class=\"col-sm-12\"\u003E L'activation se fera automatiquement au 1er janvier 2021.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-12 margin-top-20\" ng-if=\"enedisPrestations.total &gt; 0\"\u003E\u003Cp class=\"col-lg-12\"\u003ECompte-tenu des caractéristiques suivantes :\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli ng-repeat=\"message in enedisPrestations.messages\"\u003E{{ message }}\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp class=\"col-lg-12\"\u003ELa prestation suivante sera réalisée par Enedis :\u003C\u002Fp\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-8\" ng-if=\"enedisPrestations.prestation\"\u003E{{ enedisPrestations.prestation.label }}\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cp\u003E{{ enedisPrestations.prestation.price | frAmount }}€\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-8\" ng-if=\"enedisPrestations.option\"\u003E{{ enedisPrestations.option.label }}\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cp\u003E{{ enedisPrestations.option.price | frAmount }}€\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"col-lg-12\"\u003ECette prestation sera facturée\n\u003Cb class=\"fw-500\"\u003E{{ enedisPrestations.total | frAmount }}€\u003C\u002Fb\u003E\nconformément au\n\u003Ca class=\"underlined\" href=\"https:\u002F\u002Fespace-client.plum.fr\u002Fdocumentation\u002Fprix_prestations_enedis_2019.pdf\" target=\"_blank\"\u003Ecatalogue des frais Enedis\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr class=\"separator-2 separator-margin-lr-30 separator-beige margin-top-40 margin-bottom-20\"\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Ch3 class=\"title-separator title-separator-waterblue\"\u003EMon moyen de paiement\u003C\u002Fh3\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EMode de paiement\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003EPrélèvement SEPA\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EProchains\u003Cbr\u003Eprélèvements\n\u003Ci class=\"fa fa-info-circle clickable\" uib-popover-template=\"'next-max-payment'\" popover-trigger=\"'outsideClick'\" popover-append-to-body=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003E{{ currentMonthTimeline.date | amDateFormat:'MMMM YYYY' }}\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp class=\"form-control-static\"\u003E{{ getAmountFromTimeline(currentMonthTimeline) | frAmount }}€ (prorata de votre mensualité)\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003E{{ nextMonthTimeline.date | amDateFormat:'MMMM YYYY' }}\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp class=\"form-control-static\"\u003E{{ getAmountFromTimeline(nextMonthTimeline) | frAmount }}€\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EProchaine\u003Cbr\u003Erégularisation\n\u003Ci class=\"fa fa-info-circle clickable\" uib-popover-template=\"'next-billing-date'\" popover-trigger=\"'outsideClick'\" popover-append-to-body=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003E{{ nextBillingDate | amDateFormat:'MMMM YYYY' }}\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr class=\"separator-2 separator-margin-lr-30 separator-beige margin-top-40 margin-bottom-20\"\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Ch3 class=\"title-separator title-separator-light-pink\"\u003EAcceptation de l’offre\u003C\u002Fh3\u003E\u003Cdiv class=\"row\" ng-class=\"{'error':  subscriptionSummaryForm.$submitted &amp;&amp; enablePayment !== true}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\" subscriptionSummaryForm.$submitted &amp;&amp; enablePayment !== true\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput id=\"accept-cgv\" type=\"checkbox\" ng-model=\"enablePayment\"\u003EJ'accepte sans réserve les&nbsp;\u003Ca class=\"underlined\" href=\"\u002Fdocumentation\u002Fcgv.pdf\" target=\"_blank\"\u003Econditions générales de vente de Plüm énergie\u003C\u002Fa\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-12 form-error\" ng-if=\" subscriptionSummaryForm.$submitted &amp;&amp; enablePayment !== true\"\u003E\u003Cp\u003EMerci de valider les conditions générales de vente\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput id=\"authorize-plum\" type=\"checkbox\" ng-model=\"form.hasConsentCurves\"\u003EJ’autorise Plüm énergie à collecter auprès d’Enedis, pour la durée de mon contrat, les informations sur ma consommation d’électricité \npar demie-heure. Cela permet à Plüm de m’aider à mieux consommer.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput id=\"authorize-plum\" type=\"checkbox\" ng-model=\"form.hasConsentIndex\"\u003EJ’autorise Plüm énergie à collecter auprès d’Enedis, pour la durée de mon contrat, les informations sur ma consommation d’électricité \njournalière et la puissance maximum atteinte. Cela permet à Plüm d’optimiser mon offre et de me conseiller efficacement.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-tb-20\" ng-if=\"!contractDraft.bypass_retractation\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"border-1 border-dark-pink padding-lr-15\"\u003E\u003Ch5 class=\"dark-pink fw-600\"\u003EC’est important !\u003C\u002Fh5\u003E\u003Cp\u003EPar défaut, votre délai de réflexion de 14 jours est gardé\net Plüm énergie n’activera pas votre contrat\n\u003Cstrong\u003Eavant le {{ retractEndDate | amDateFormat:'DD MMMM YYYY' }}.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003ERassurez-vous, à la fin de votre souscription,\nil vous sera possible d’initier le contrat dès maintenant !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"row margin-top-50\"\u003E\u003Cp\u003EEn cliquant sur « terminer », vous acceptez que Plüm énergie, en tant que responsable de traitement,\ntraite les données saisies dans ce formulaire, à des fins notamment, de traitement de votre souscription,\nd'aide à la finalisation de votre souscription, de création de votre compte client, d'études statistiques, de suivi qualité et de prospection commerciale.\nVos données seront conservées le temps nécessaire à la réalisation de ces opérations.\nElles sont destinées à nos services internes et à nos sous-traitants en gestion de la relation client\u003Cspan ng-if=\"contractDraft.id_ref_promo === 'LABANQUEPOSTALE' || contractDraft.provider_offer === 'ECO_CONSO+'\"\u003E, notamment notre partenaire La Banque Postale\u003C\u002Fspan\u003E.\u003Cbr\u003ECes données vous appartiennent.\nVous disposez donc d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition au traitement de celles-ci. \u003Ca class=\"underlined\" ng-if=\"!isDisplayedExtendedLegalNotice\" ng-click=\"showExtendedLegalNotice()\"\u003ELire la suite\u003C\u002Fa\u003E\u003Cspan ng-if=\"isDisplayedExtendedLegalNotice\"\u003EConformément à la Loi Informatique et Liberté Loi n° 78-17 du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données Règlement (UE) 2016\u002F679 du Parlement européen et du Conseil du 27 avril 2016 dit RGPD,\nvous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition au traitement de vos données.\u003Cbr\u003EVous pouvez exercer vos droits en nous écrivant par courriel à : {{ contactTelephone.data.email }}\nou par courrier postal à : Plüm énergie (DPO), 30 rue Proudhon, 93210 Saint-Denis.\nPour plus d'informations concernant le traitement de vos données consultez la \u003Ca class=\"link\" :href=\"`${urls.WEBSITE_COOKIES}`\" target=\"_blank\"\u003Epolitique des données\u003C\u002Fa\u003E.\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row background-beige margin-top-50 margin-bottom-150 padding-tb-20\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cdiv class=\"subscription-steps\"\u003E\u003Cdiv class=\"subscription-step\"\u003E\u003Cdiv class=\"subscription-step-inline\"\u003E\u003Cspan class=\"subscription-step-title\"\u003EMon devis\u003C\u002Fspan\u003E\u003Ci class=\"fa fa-check-circle fa-5x dark-green\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-step\"\u003E\u003Cdiv class=\"subscription-step-inline\"\u003E\u003Cspan class=\"subscription-step-title\"\u003EMes coordonnées\u003C\u002Fspan\u003E\u003Ci class=\"fa fa-check-circle fa-5x dark-green\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-step\"\u003E\u003Cdiv class=\"subscription-step-inline\"\u003E\u003Cspan class=\"subscription-step-title\"\u003EAcceptation des CGV\u003C\u002Fspan\u003E\u003Ci class=\"fa fa-circle-o fa-5x dark-pink\" aria-hidden=\"true\" ng-if=\"!enablePayment\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"fa fa-check-circle fa-5x dark-green\" aria-hidden=\"true\" ng-if=\"enablePayment\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-step\"\u003E\u003Cdiv class=\"subscription-step-inline\"\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" type=\"submit\" ng-disabled=\"isLoading\" ng-class=\"{'btn-spinner-loading': isLoading}\" id=\"btnFinishOrder\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cdiv class=\"subscription-steps visible-xs-flex\"\u003E\u003Cdiv class=\"subscription-step\"\u003E\u003Cdiv class=\"subscription-step-inline\"\u003E\u003Cspan class=\"subscription-step-title\"\u003EMon devis\u003C\u002Fspan\u003E\u003Ci class=\"fa fa-check-circle fa-3x dark-green\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-step\"\u003E\u003Cdiv class=\"subscription-step-inline\"\u003E\u003Cspan class=\"subscription-step-title\"\u003EMes coordonnées\u003C\u002Fspan\u003E\u003Ci class=\"fa fa-check-circle fa-3x dark-green\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-step\"\u003E\u003Cdiv class=\"subscription-step-inline\"\u003E\u003Cspan class=\"subscription-step-title\"\u003EAcceptation des CGV\u003C\u002Fspan\u003E\u003Ci class=\"fa fa-circle-o fa-3x dark-pink\" aria-hidden=\"true\" ng-if=\"!enablePayment\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"fa fa-check-circle fa-3x dark-green\" aria-hidden=\"true\" ng-if=\"enablePayment\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"button-wrapper visible-xs-block\"\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" type=\"submit\" ng-disabled=\"isLoading\" ng-class=\"{'btn-spinner-loading': isLoading}\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"next-max-payment\"\u003E\u003Cdiv\u003E\u003Cp\u003ECes mensualités sont calculées à partir des prévisions de votre consommation, pour chaque période de facturation.\u003C\u002Fp\u003E\u003Cp\u003EElles seront recalculées lors de votre prochaine facture de régularisation pour refléter au mieux votre consommation réelle.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"next-billing-date\"\u003E\u003Cdiv\u003E\u003Cp\u003EA partir de cette date, suite à la relève d'un technicien du service public Enedis, vous recevrez une facture de régularisation\npour ne payer que ce que vous avez consommé.\u003C\u002Fp\u003E\u003Cp\u003ESi vous avez consommé moins que notre estimation, nous vous rembourserons la différence.\u003C\u002Fp\u003E\u003Cp\u003ESi vous avez consommé plus que notre estimation, nous vous demanderons le complément.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"anonTerminationSummary\"\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Flogos\u002Fplum-circle.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003Cspan ng-if=\"!cancelMode\"\u003ERésiliation de votre contrat\u003C\u002Fspan\u003E\u003Cspan ng-if=\"cancelMode\"\u003EAnnulation de la résiliation de votre contrat\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogos\u002Fplum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"navbar-text\" ng-if=\"!cancelMode\"\u003ERésiliation de votre contrat\u003C\u002Fh2\u003E\u003Ch2 class=\"navbar-text\" ng-if=\"cancelMode\"\u003EAnnulation de la résiliation de votre contrat\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1 default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ERÉSUMÉ DE LA DEMANDE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-inline form-container form-body\" ng-submit=\"confirmTermination()\"\u003E\u003Cdiv ng-if=\"confirmed\"\u003E\u003Ch4\u003EVotre demande de résiliation a bien été acceptée par Enedis\u003C\u002Fh4\u003E\u003Cp\u003EIl faut compter généralement 5 à 10 jours pour que votre résiliation soit définitive.\u003C\u002Fp\u003E\u003Cp\u003EVous recevrez alors une confirmation par e-mail puis quelques temps après votre facture de clôture.\u003C\u002Fp\u003E\u003Cp ng-if=\"!token.hasOverdue &amp;&amp; reason.choice != 'SERVICE' &amp;&amp; reason.choice != 'TARIFF'\"\u003ESi, par ailleurs, vous souhaitez ouvrir un contrat dans un nouveau logement,\u003Ca class=\"underline\" ui-sref=\"subscription\"\u003Ecliquez sur ce lien&nbsp;\u003C\u002Fa\u003Eet laissez-vous guider.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-20\"\u003E\u003Cbutton class=\"btn background-light-pink\" ng-if=\"reason.choice === 'MOVE'\" type=\"button\" ui-sref=\"subscription\"\u003ESOUSCRIRE UN NOUVEAU CONTRAT\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ui-sref=\"landing\"\u003EREVENIR À LA PAGE D'ACCUEIL\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"cancelConfirmed\"\u003E\u003Ch4\u003EL'annulation de votre demande de résiliation a bien été prise en compte\u003C\u002Fh4\u003E\u003Cdiv class=\"form-actions margin-top-20\"\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ui-sref=\"landing\"\u003EREVENIR À LA PAGE D'ACCUEIL\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"error &amp;&amp; !confirmed &amp;&amp; !cancelConfirmed\"\u003E\u003Ci class=\"fa fa-warning hidden-xs\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp\u003E\u003Cstrong ng-if=\"!error.data.message\"\u003EUne erreur s'est produite.\u003C\u002Fstrong\u003E\u003Cstrong ng-if=\"error.data.message\"\u003E{{error.data.message}}\u003C\u002Fstrong\u003E\u003Cbr\u003E\u003Cbr\u003EVous avez la possibilité de contacter le service client au&nbsp;\u003Ca class=\"underline\" ng-href=\"{{contactTelephone.anonymous.link}}\" ng-bind=\"contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E&nbsp;afin de résoudre le problème.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!token\"\u003E\u003Cp\u003ELe lien a expiré, merci de contacter le service client au&nbsp;\u003Ca class=\"underline\" ng-href=\"{{contactTelephone.anonymous.link}}\" ng-bind=\"contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E&nbsp;afin de résoudre le problème.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-20\"\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ui-sref=\"landing\"\u003EREVENIR À LA PAGE D'ACCUEIL\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cspan ng-if=\"cancelMode\"\u003E\u003Cdiv ng-if=\"token &amp;&amp; !confirmed &amp;&amp; !cancelConfirmed\"\u003E\u003Cp\u003EPour annuler votre demande de résiliation, merci de cliquer sur le bouton confirmer\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': isLoading}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"button\" ng-click=\"cancelTermination()\"\u003ECONFIRMER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!cancelMode\"\u003E\u003Cdiv ng-if=\"token &amp;&amp; !confirmed &amp;&amp; !cancelConfirmed\"\u003E\u003Cp ng-if=\"!token.migratedLinky\"\u003E\u003Ci class=\"dark-pink\"\u003EAttention : la résiliation de votre contrat doit être demandée au plus tôt dans les 2 jours précédant votre départ du logement.\u003C\u002Fi\u003E\u003C\u002Fp\u003E\u003Cp\u003EVoici les informations relatives à votre demande :\u003C\u002Fp\u003E\u003Cdiv class=\"row marginb15\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EIDENTIFIANT CONTRAT :\u003C\u002Fp\u003E{{ token.id_contract }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EADRESSE DE LIVRAISON :\u003C\u002Fp\u003E{{ token.address }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row marginb15\" ng-if=\"token.migratedLinky\" ng-class=\"{error: !isEffectiveDateValid()}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\"!isEffectiveDateValid()\"\u003E\u003C\u002Fi\u003E\u003Cdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6\"\u003E\u003Clabel\u003EDATE DE RÉSILIATION SOUHAITÉE :\u003C\u002Flabel\u003E\u003Cdate-field date=\"payload.effectiveDate\"\u003E\u003C\u002Fdate-field\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 form-message\"\u003E\u003Cp ng-if=\"!isEffectiveDateValid()\"\u003ELa date de résiliation souhaitée doit être comprise entre\nle {{ effectiveDateMin | amDateFormat:'DD MMMM YYYY'}}\net le {{ effectiveDateMax | amDateFormat:'DD MMMM YYYY'}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cspan ng-if=\"!token.migratedLinky\"\u003E\u003Cp\u003EPour permettre la résiliation de votre contrat, merci d'indiquer votre relève de ce jour :\u003C\u002Fp\u003E\u003Cspan ng-if=\"token.id_p_calendar == 'BASE'\"\u003E\u003Cdiv class=\"row marginb15\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv style=\"display: inline; text-align: right;\"\u003EBASE :&nbsp;\u003C\u002Fdiv\u003E\u003Cinput class=\"form-control inline\" type=\"number\" pattern=\"[0-9]*\" required min=\"0\" ng-model=\"payload.reading.base\" maxlength=\"{{maxLength}}\" ng-disabled=\"payload.enedisEstimation\" style=\"width: 75px; min-width: auto; display: inline-block;\"\u003E\u003Cspan\u003E&nbsp;kWh\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"token.id_p_calendar == 'HPHC'\"\u003E\u003Cdiv class=\"row marginb15\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv style=\"display: inline; text-align: right;\"\u003EHEURES PLEINES :&nbsp;&nbsp;\u003C\u002Fdiv\u003E\u003Cinput class=\"form-control inline\" type=\"number\" pattern=\"[0-9]*\" required min=\"0\" ng-model=\"payload.reading.hp\" maxlength=\"{{maxLength}}\" ng-disabled=\"payload.enedisEstimation\" style=\"width: 75px; min-width: auto; display: inline-block;\"\u003E\u003Cspan\u003E&nbsp;kWh\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv style=\"display: inline; text-align: right;\"\u003EHEURES CREUSES :&nbsp;\u003C\u002Fdiv\u003E\u003Cinput class=\"form-control inline\" type=\"number\" pattern=\"[0-9]*\" required min=\"0\" ng-model=\"payload.reading.hc\" maxlength=\"{{maxLength}}\" ng-disabled=\"payload.enedisEstimation\" style=\"width: 75px; min-width: auto; display: inline-block;\"\u003E\u003Cspan\u003E&nbsp;kWh\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"row marginb15\"\u003E\u003Cdiv class=\"col-md-12\" ng-click=\"payload.enedisEstimation = !payload.enedisEstimation\" style=\"cursor: pointer;\"\u003E\u003Cspan class=\"fa fa-check-square-o\" ng-if=\"payload.enedisEstimation\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-square-o\" ng-if=\"!payload.enedisEstimation\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;&nbsp;Je ne peux pas fournir ma relève&nbsp;&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"row marginb15\"\u003E\u003Cdiv class=\"col-md-12\"\u003EIndiquez nous le motif principal de votre résiliation :\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row marginb15\"\u003E\u003Cdiv class=\"col-md-3\" ng-click=\"reason.choice = 'MOVE'\" style=\"cursor: pointer;\"\u003E\u003Cspan class=\"fa fa-check-square-o\" ng-if=\"reason.choice === 'MOVE'\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-square-o\" ng-if=\"reason.choice !== 'MOVE'\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;&nbsp;Je déménage&nbsp;&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4\" ng-click=\"reason.choice = 'TARIFF'\" style=\"cursor: pointer;\"\u003E\u003Cspan class=\"fa fa-check-square-o\" ng-if=\"reason.choice === 'TARIFF'\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-square-o\" ng-if=\"reason.choice !== 'TARIFF'\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;&nbsp;Je ne suis pas satisfait des tarifs&nbsp;&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-5\" ng-click=\"reason.choice = 'SERVICE'\" style=\"cursor: pointer;\"\u003E\u003Cspan class=\"fa fa-check-square-o\" ng-if=\"reason.choice === 'SERVICE'\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-square-o\" ng-if=\"reason.choice !== 'SERVICE'\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;&nbsp;Je ne suis pas satisfait du service Plüm&nbsp;&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row marginb15\"\u003E\u003Cdiv class=\"col-md-2\" ng-click=\"reason.choice = 'OTHER'\" style=\"cursor: pointer;\"\u003E\u003Cspan class=\"fa fa-check-square-o\" ng-if=\"reason.choice === 'OTHER'\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-square-o\" ng-if=\"reason.choice !== 'OTHER'\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;&nbsp;Autre&nbsp;&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Ctextarea ng-model=\"reason.text\" rows=\"2\" ng-focus=\"reason.choice = 'OTHER'\" style=\"min-height: auto;\"\u003E\u003C\u002Ftextarea\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': isLoading}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"isLoading || !canShoot()\"\u003ECONFIRMER MA RÉSILIATION\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ContractService.$inject = ["ContractStatus"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _includes2 = __webpack_require__(827);

var _includes3 = _interopRequireDefault(_includes2);

var _find2 = __webpack_require__(192);

var _find3 = _interopRequireDefault(_find2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _toNumber2 = __webpack_require__(131);

var _toNumber3 = _interopRequireDefault(_toNumber2);

var _isNil2 = __webpack_require__(206);

var _isNil3 = _interopRequireDefault(_isNil2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ContractService;

/** @ngInject */

function ContractService(ContractStatus) {
    var NEGATIVE_BALANCE_THRESHOLD = 1;
    var REGULATE_BTN_THRESHOLD = 0;
    var SUBSCRIPTION_CONTRACT_FINISHED = [ContractStatus.enService, ContractStatus.resilie, ContractStatus.retracte, ContractStatus.annule];

    var INVOICE_PAGE_ON_CONTRACT_STATUS = [ContractStatus.enRecouvrement, ContractStatus.resilie, ContractStatus.coupe, ContractStatus.resiliationDemande, ContractStatus.coupureDemande];

    var isNotFinishedContract = function isNotFinishedContract(contract) {
        return SUBSCRIPTION_CONTRACT_FINISHED.indexOf(contract.status) === -1;
    };
    var isContractGoalNotDefined = function isContractGoalNotDefined(c) {
        return (0, _isNil3.default)(c.id_ref_goal);
    };
    var isContractNegativeBalance = function isContractNegativeBalance(balanceThreshold) {
        return function (contract) {
            return (0, _toNumber3.default)((0, _get3.default)(contract, 'contractBalance.balance', 0)) < -(0, _toNumber3.default)(balanceThreshold);
        };
    };

    var findContract = function findContract(contracts, contractId) {
        return (0, _find3.default)(contracts, { id: contractId });
    };
    var findFirstGoalNotDefinedContract = function findFirstGoalNotDefinedContract(contracts) {
        return (0, _find3.default)(contracts, isContractGoalNotDefined);
    };
    var findFirstNotFinishedContract = function findFirstNotFinishedContract(contracts) {
        return (0, _find3.default)(contracts, isNotFinishedContract);
    };
    var findFirstUnpaidContract = function findFirstUnpaidContract(contracts) {
        var balanceThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NEGATIVE_BALANCE_THRESHOLD;
        return (0, _find3.default)(contracts, isContractNegativeBalance(balanceThreshold));
    };

    var getMyAccountStatusFromContract = function getMyAccountStatusFromContract(contract) {
        return (0, _includes3.default)(INVOICE_PAGE_ON_CONTRACT_STATUS, (0, _get3.default)(contract, 'status')) ? 'invoice' : 'account';
    };

    return {
        NEGATIVE_BALANCE_THRESHOLD: NEGATIVE_BALANCE_THRESHOLD,
        REGULATE_BTN_THRESHOLD: REGULATE_BTN_THRESHOLD,
        isContractNegativeBalance: isContractNegativeBalance,
        findContract: findContract,
        findFirstGoalNotDefinedContract: findFirstGoalNotDefinedContract,
        findFirstNotFinishedContract: findFirstNotFinishedContract,
        getMyAccountStatusFromContract: getMyAccountStatusFromContract,
        findFirstUnpaidContract: findFirstUnpaidContract
    };
}

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cimg class=\"close-modal\" src=\"\u002Fassets\u002Fimg\u002Fp-l-u-m-bouton-close.png\" ng-click=\"close()\"\u003E\u003Cdiv class=\"text-center offer-bloc\"\u003E\u003Cdiv class=\"row\" id=\"proofofres-modal\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1 text-center\"\u003E\u003Ch1 class=\"light darkish-pink\"\u003EVotre demande d'attestation de domicile\u003C\u002Fh1\u003E\u003Cp class=\"margin-top-20\"\u003ECliquez ci-dessous si vous souhaitez ajouter déclarer des personnes supplémentaires. \u003Cbr\u003E(max: 5 personnes)\u003Cbr\u003E\u003Cbr\u003E\u003C\u002Fp\u003E\u003Cul class=\"proofofres-people\"\u003E\u003Cli ng-show=\"people.length\"\u003E\u003Cspan class=\"civ\"\u003E\u003Clabel\u003ECivilité\u003C\u002Flabel\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Clabel\u003EPrénom\u003C\u002Flabel\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Clabel\u003ENom de famille\u003C\u002Flabel\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli ng-repeat=\"person in people track by $index\"\u003E\u003Cspan class=\"civ\"\u003E\u003Cselect ng-model=\"person.civ\" ng-init=\"person.civ = 'M.'\"\u003E\u003Coption value=\"M.\"\u003EM.\u003C\u002Foption\u003E\u003Coption value=\"Mme\"\u003EMme\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Cinput ng-model=\"people[$index].fn\" placeholder=\"Prénom\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Cinput class=\"force-uppercase\" ng-model=\"people[$index].ln\" placeholder=\"NOM\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"delete-person\"\u003E\u003Cspan ng-click=\"removePeople($index)\"\u003E\u003Ci class=\"fa fa-times\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"row\"\u003E\u003Cbutton class=\"btn-add-person\" ng-click=\"addPerson()\"\u003E\u003Ci class=\"fa fa-plus\"\u003E\u003C\u002Fi\u003EAjouter une personne\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2 col-sm-5 col-sm-offset-1 text-center bottom-btn\"\u003E\u003Cbutton class=\"btn btn-lg background-bluegrey\" ng-click=\"close()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2 col-sm-5 col-sm-offset-0 text-center bottom-btn\"\u003E\u003Ca class=\"btn btn-lg background-waterblue\" href=\"\u002Fapi-user\u002Fdocuments\u002F{{contractId}}\u002Fproofofresidence{{queryParams}}\" target=\"_blank\"\u003EGénérer\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(353);
module.exports = __webpack_require__(555);


/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(556);

__webpack_require__(557);

__webpack_require__(558);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */
if (['plum-energie.fr', 'espace-client.plum.fr'].indexOf(location.hostname) > -1) {
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };if (!f._fbq) f._fbq = n;
        n.push = n;n.loaded = !0;n.version = '2.0';n.queue = [];t = b.createElement(e);t.async = !0;
        t.src = v;s = b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    // Facebook multipixels https://developers.facebook.com/docs/facebook-pixel/events-advanced-use-cases/v2.12#multipixels
    fbq('init', '300876676956174'); // Plum Facebook Pixel
    fbq('init', '1395294264077293'); // Selectra Facebook Pixel
    fbq('track', 'PageView');
}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

var _jqueryBridget = __webpack_require__(559);

var _jqueryBridget2 = _interopRequireDefault(_jqueryBridget);

var _imagesloaded = __webpack_require__(560);

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

var _masonryLayout = __webpack_require__(561);

var _masonryLayout2 = _interopRequireDefault(_masonryLayout);

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(567);

__webpack_require__(568);

var _angularUiRouter = __webpack_require__(569);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularMasonry = __webpack_require__(570);

var _angularMasonry2 = _interopRequireDefault(_angularMasonry);

var _angularCookies = __webpack_require__(572);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularUiBootstrap = __webpack_require__(574);

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

var _angularMoment = __webpack_require__(576);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _uiSelect = __webpack_require__(578);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _angularResource = __webpack_require__(580);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularPermission = __webpack_require__(582);

var _angularPermission2 = _interopRequireDefault(_angularPermission);

var _angularBootstrapAffix = __webpack_require__(586);

var _angularBootstrapAffix2 = _interopRequireDefault(_angularBootstrapAffix);

var _angularUiMask = __webpack_require__(588);

var _angularUiMask2 = _interopRequireDefault(_angularUiMask);

var _angularAnimate = __webpack_require__(590);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _ngFocusIf = __webpack_require__(592);

var _ngFocusIf2 = _interopRequireDefault(_ngFocusIf);

var _angularNvd = __webpack_require__(594);

var _angularNvd2 = _interopRequireDefault(_angularNvd);

var _angularRecaptcha = __webpack_require__(597);

var _angularRecaptcha2 = _interopRequireDefault(_angularRecaptcha);

var _angularSanitize = __webpack_require__(599);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularClipboard = __webpack_require__(601);

var _angularClipboard2 = _interopRequireDefault(_angularClipboard);

__webpack_require__(602);

__webpack_require__(603);

__webpack_require__(604);

var _navigationLogger = __webpack_require__(605);

var _navigationLogger2 = _interopRequireDefault(_navigationLogger);

var _constants = __webpack_require__(606);

var _constants2 = _interopRequireDefault(_constants);

var _features = __webpack_require__(607);

var _features2 = _interopRequireDefault(_features);

var _moment = __webpack_require__(608);

var _moment2 = _interopRequireDefault(_moment);

var _tagmanager = __webpack_require__(609);

var _tagmanager2 = _interopRequireDefault(_tagmanager);

var _analytics = __webpack_require__(610);

var _analytics2 = _interopRequireDefault(_analytics);

var _roles = __webpack_require__(611);

var _roles2 = _interopRequireDefault(_roles);

var _routes = __webpack_require__(612);

var _routes2 = _interopRequireDefault(_routes);

var _states = __webpack_require__(706);

var _states2 = _interopRequireDefault(_states);

var _uiMask = __webpack_require__(707);

var _uiMask2 = _interopRequireDefault(_uiMask);

var _numeral = __webpack_require__(708);

var _numeral2 = _interopRequireDefault(_numeral);

var _directive = __webpack_require__(710);

var _directive2 = _interopRequireDefault(_directive);

var _chartInfo = __webpack_require__(712);

var _chartInfo2 = _interopRequireDefault(_chartInfo);

var _directive3 = __webpack_require__(714);

var _directive4 = _interopRequireDefault(_directive3);

var _directive5 = __webpack_require__(715);

var _directive6 = _interopRequireDefault(_directive5);

var _directive7 = __webpack_require__(717);

var _directive8 = _interopRequireDefault(_directive7);

var _clamp = __webpack_require__(719);

var _clamp2 = _interopRequireDefault(_clamp);

var _directive9 = __webpack_require__(720);

var _directive10 = _interopRequireDefault(_directive9);

var _emailForm = __webpack_require__(722);

var _emailForm2 = _interopRequireDefault(_emailForm);

var _dateField = __webpack_require__(724);

var _dateField2 = _interopRequireDefault(_dateField);

var _forceUppercase = __webpack_require__(729);

var _forceUppercase2 = _interopRequireDefault(_forceUppercase);

var _directive11 = __webpack_require__(730);

var _directive12 = _interopRequireDefault(_directive11);

var _navbarBackground = __webpack_require__(732);

var _navbarBackground2 = _interopRequireDefault(_navbarBackground);

var _navbarOpacity = __webpack_require__(733);

var _navbarOpacity2 = _interopRequireDefault(_navbarOpacity);

var _directive13 = __webpack_require__(734);

var _directive14 = _interopRequireDefault(_directive13);

var _directive15 = __webpack_require__(736);

var _directive16 = _interopRequireDefault(_directive15);

var _newsletterModal = __webpack_require__(740);

var _newsletterModal2 = _interopRequireDefault(_newsletterModal);

var _directive17 = __webpack_require__(742);

var _directive18 = _interopRequireDefault(_directive17);

var _directive19 = __webpack_require__(743);

var _directive20 = _interopRequireDefault(_directive19);

var _popin = __webpack_require__(744);

var _popin2 = _interopRequireDefault(_popin);

var _directive21 = __webpack_require__(747);

var _directive22 = _interopRequireDefault(_directive21);

var _directive23 = __webpack_require__(748);

var _directive24 = _interopRequireDefault(_directive23);

var _report = __webpack_require__(750);

var _report2 = _interopRequireDefault(_report);

var _scrollToNext = __webpack_require__(752);

var _scrollToNext2 = _interopRequireDefault(_scrollToNext);

var _subscriptionTimelineGraph = __webpack_require__(802);

var _subscriptionTimelineGraph2 = _interopRequireDefault(_subscriptionTimelineGraph);

var _updateTitle = __webpack_require__(803);

var _updateTitle2 = _interopRequireDefault(_updateTitle);

var _directive25 = __webpack_require__(804);

var _directive26 = _interopRequireDefault(_directive25);

var _compareTo = __webpack_require__(805);

var _compareTo2 = _interopRequireDefault(_compareTo);

var _reports = __webpack_require__(806);

var _reports2 = _interopRequireDefault(_reports);

var _resources = __webpack_require__(807);

var _resources2 = _interopRequireDefault(_resources);

var _adwords = __webpack_require__(808);

var _adwords2 = _interopRequireDefault(_adwords);

var _alerts = __webpack_require__(809);

var _alerts2 = _interopRequireDefault(_alerts);

var _api = __webpack_require__(810);

var _api2 = _interopRequireDefault(_api);

var _logout = __webpack_require__(811);

var _logout2 = _interopRequireDefault(_logout);

var _service = __webpack_require__(812);

var _service2 = _interopRequireDefault(_service);

var _userCommunity = __webpack_require__(813);

var _userCommunity2 = _interopRequireDefault(_userCommunity);

var _chart = __webpack_require__(814);

var _chart2 = _interopRequireDefault(_chart);

var _contract = __webpack_require__(320);

var _contract2 = _interopRequireDefault(_contract);

var _service3 = __webpack_require__(828);

var _service4 = _interopRequireDefault(_service3);

var _device = __webpack_require__(829);

var _device2 = _interopRequireDefault(_device);

var _errorcatcher = __webpack_require__(830);

var _errorcatcher2 = _interopRequireDefault(_errorcatcher);

var _featuresService = __webpack_require__(835);

var _featuresService2 = _interopRequireDefault(_featuresService);

var _capitalize = __webpack_require__(836);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _ceil = __webpack_require__(837);

var _ceil2 = _interopRequireDefault(_ceil);

var _clientId = __webpack_require__(838);

var _clientId2 = _interopRequireDefault(_clientId);

var _contractStatus = __webpack_require__(839);

var _contractStatus2 = _interopRequireDefault(_contractStatus);

var _elision = __webpack_require__(840);

var _elision2 = _interopRequireDefault(_elision);

var _frAmount = __webpack_require__(841);

var _frAmount2 = _interopRequireDefault(_frAmount);

var _iban = __webpack_require__(842);

var _iban2 = _interopRequireDefault(_iban);

var _phone = __webpack_require__(843);

var _phone2 = _interopRequireDefault(_phone);

var _prm = __webpack_require__(844);

var _prm2 = _interopRequireDefault(_prm);

var _integer = __webpack_require__(845);

var _integer2 = _interopRequireDefault(_integer);

var _decimals = __webpack_require__(846);

var _decimals2 = _interopRequireDefault(_decimals);

var _gaEventsService = __webpack_require__(847);

var _gaEventsService2 = _interopRequireDefault(_gaEventsService);

var _landscapeElements = __webpack_require__(848);

var _landscapeElements2 = _interopRequireDefault(_landscapeElements);

var _mobilePhone = __webpack_require__(849);

var _mobilePhone2 = _interopRequireDefault(_mobilePhone);

var _service5 = __webpack_require__(851);

var _service6 = _interopRequireDefault(_service5);

var _prmUtils = __webpack_require__(852);

var _prmUtils2 = _interopRequireDefault(_prmUtils);

var _filter = __webpack_require__(853);

var _filter2 = _interopRequireDefault(_filter);

var _references = __webpack_require__(854);

var _references2 = _interopRequireDefault(_references);

var _campaignLanding = __webpack_require__(855);

var _campaignLanding2 = _interopRequireDefault(_campaignLanding);

var _campaignLandingTemplate = __webpack_require__(856);

var _campaignLandingTemplate2 = _interopRequireDefault(_campaignLandingTemplate);

var _community = __webpack_require__(857);

var _community2 = _interopRequireDefault(_community);

var _terms = __webpack_require__(858);

var _terms2 = _interopRequireDefault(_terms);

var _confirm = __webpack_require__(859);

var _confirm2 = _interopRequireDefault(_confirm);

var _confirmChangeMail = __webpack_require__(860);

var _confirmChangeMail2 = _interopRequireDefault(_confirmChangeMail);

var _contactModal = __webpack_require__(861);

var _contactModal2 = _interopRequireDefault(_contactModal);

var _flow = __webpack_require__(862);

var _flow2 = _interopRequireDefault(_flow);

var _unergieFooter = __webpack_require__(863);

var _unergieFooter2 = _interopRequireDefault(_unergieFooter);

var _forgotPassword = __webpack_require__(865);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _hints = __webpack_require__(866);

var _hints2 = _interopRequireDefault(_hints);

var _home = __webpack_require__(867);

var _home2 = _interopRequireDefault(_home);

var _animatedOnVisible = __webpack_require__(868);

var _animatedOnVisible2 = _interopRequireDefault(_animatedOnVisible);

var _landing = __webpack_require__(869);

var _landing2 = _interopRequireDefault(_landing);

var _sendEvent = __webpack_require__(872);

var _sendEvent2 = _interopRequireDefault(_sendEvent);

var _controller = __webpack_require__(873);

var _controller2 = _interopRequireDefault(_controller);

var _login = __webpack_require__(874);

var _login2 = _interopRequireDefault(_login);

var _landscape = __webpack_require__(875);

var _landscape2 = _interopRequireDefault(_landscape);

var _controller3 = __webpack_require__(876);

var _controller4 = _interopRequireDefault(_controller3);

var _controller5 = __webpack_require__(877);

var _controller6 = _interopRequireDefault(_controller5);

var _navbarAccount = __webpack_require__(878);

var _navbarAccount2 = _interopRequireDefault(_navbarAccount);

var _controller7 = __webpack_require__(879);

var _controller8 = _interopRequireDefault(_controller7);

var _promo = __webpack_require__(880);

var _promo2 = _interopRequireDefault(_promo);

var _proofofresmodal = __webpack_require__(881);

var _proofofresmodal2 = _interopRequireDefault(_proofofresmodal);

var _selfReport = __webpack_require__(882);

var _selfReport2 = _interopRequireDefault(_selfReport);

var _selfReportImgValue = __webpack_require__(883);

var _selfReportImgValue2 = _interopRequireDefault(_selfReportImgValue);

var _selfReportStep = __webpack_require__(884);

var _selfReportStep2 = _interopRequireDefault(_selfReportStep);

var _selfReportStepImage = __webpack_require__(886);

var _selfReportStepImage2 = _interopRequireDefault(_selfReportStepImage);

var _signup = __webpack_require__(888);

var _signup2 = _interopRequireDefault(_signup);

var _sponsor = __webpack_require__(889);

var _sponsor2 = _interopRequireDefault(_sponsor);

var _subscriptionEnd = __webpack_require__(890);

var _subscriptionEnd2 = _interopRequireDefault(_subscriptionEnd);

var _subscriptionSummary = __webpack_require__(891);

var _subscriptionSummary2 = _interopRequireDefault(_subscriptionSummary);

var _anonPaymentSummary = __webpack_require__(892);

var _anonPaymentSummary2 = _interopRequireDefault(_anonPaymentSummary);

var _anonTerminationSummary = __webpack_require__(893);

var _anonTerminationSummary2 = _interopRequireDefault(_anonTerminationSummary);

var _account = __webpack_require__(896);

var _account2 = _interopRequireDefault(_account);

var _endSubscription = __webpack_require__(906);

var _endSubscription2 = _interopRequireDefault(_endSubscription);

var _invoice = __webpack_require__(923);

var _invoice2 = _interopRequireDefault(_invoice);

var _mandateConfirmation = __webpack_require__(967);

var _mandateConfirmation2 = _interopRequireDefault(_mandateConfirmation);

var _modal = __webpack_require__(970);

var _modal2 = _interopRequireDefault(_modal);

var _navbar = __webpack_require__(975);

var _navbar2 = _interopRequireDefault(_navbar);

var _paymentConfirmation = __webpack_require__(987);

var _paymentConfirmation2 = _interopRequireDefault(_paymentConfirmation);

var _vendorSignatureConfirmation = __webpack_require__(991);

var _vendorSignatureConfirmation2 = _interopRequireDefault(_vendorSignatureConfirmation);

var _personalInformation = __webpack_require__(994);

var _personalInformation2 = _interopRequireDefault(_personalInformation);

var _quotation = __webpack_require__(1014);

var _quotation2 = _interopRequireDefault(_quotation);

var _securityDepositSummary = __webpack_require__(1138);

var _securityDepositSummary2 = _interopRequireDefault(_securityDepositSummary);

var _subscription = __webpack_require__(1147);

var _subscription2 = _interopRequireDefault(_subscription);

var _subscriptionLanding = __webpack_require__(1179);

var _subscriptionLanding2 = _interopRequireDefault(_subscriptionLanding);

var _tracking = __webpack_require__(1186);

var _tracking2 = _interopRequireDefault(_tracking);

var _template = __webpack_require__(1190);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Required for angular-masonry
// 'smoothScroll'
// angularFileUpload
(0, _jqueryBridget2.default)('imagesloaded', _imagesloaded2.default, _jquery2.default); // ezfb

(0, _jqueryBridget2.default)('masonry', _masonryLayout2.default, _jquery2.default);

/* Angular styleguide to use https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.main', [
/* Common angular module */
_angularUiRouter2.default, _angularMasonry2.default, _angularCookies2.default, _angularUiBootstrap2.default, _angularMoment2.default, _uiSelect2.default, _angularResource2.default, _angularPermission2.default.permission, _angularPermission2.default.uiPermission, _angularBootstrapAffix2.default, _angularUiMask2.default, _angularAnimate2.default, _ngFocusIf2.default, _angularNvd2.default, _angularRecaptcha2.default, _angularSanitize2.default, _angularClipboard2.default.name, 'smoothScroll', 'angularFileUpload', 'ezfb',

/* Unergie component module */
_account2.default, _endSubscription2.default, _invoice2.default, _mandateConfirmation2.default, _modal2.default, _navbar2.default, _paymentConfirmation2.default, _vendorSignatureConfirmation2.default, _personalInformation2.default, _quotation2.default, _securityDepositSummary2.default, _subscription2.default, _subscriptionLanding2.default, _tracking2.default, _template2.default]).constant('RoomName', _constants2.default.RoomName).constant('ImplementationToText', _constants2.default.ImplementationToText).constant('MetterKind', _constants2.default.MetterKind).constant('MailAdresses', _constants2.default.MailAdresses).constant('RecaptchaKey', _constants2.default.RecaptchaKey).constant('ContactTelephone', _constants2.default.ContactTelephone).constant('ContactSubjects', _constants2.default.ContactSubjects).constant('ContractStatus', _constants2.default.ContractStatus).constant('UserStatus', _constants2.default.UserStatus).constant('ContractStatusLabel', _constants2.default.ContractStatusLabel).constant('PaymentStatus', _constants2.default.PaymentStatus).constant('PaymentModes', _constants2.default.PaymentModes).constant('CampaignLandingType', _constants2.default.CampaignLandingType).constant('CommonRegex', _constants2.default.CommonRegex).constant('StaticTariff', _constants2.default.StaticTariff).constant('LandingPageLink', _constants2.default.landingPageLink).factory('Contract', _resources2.default.Contract).factory('ContractDraft', _resources2.default.ContractDraft).factory('User', _resources2.default.User).factory('Hint', _resources2.default.Hint).factory('Community', _resources2.default.Community).factory('BillingAddress', _resources2.default.BillingAddress).factory('Features', _resources2.default.Features).factory('LandscapeQuestions', _resources2.default.LandscapeQuestions).factory('ProviderInfo', _resources2.default.ProviderInfo).factory('DataAccessReferences', _resources2.default.DataAccessReferences).factory('DataAccessVariables', _resources2.default.DataAccessVariables).factory('CampaignLanding', _resources2.default.CampaignLanding).factory('RefGoals', _resources2.default.RefGoals).factory('Contact', _resources2.default.Contact).factory('LogNavigation', _resources2.default.LogNavigation).factory('NavError', _resources2.default.NavError).factory('TariffResource', _resources2.default.TariffResource).factory('SelfReport', _resources2.default.SelfReport).factory('BillingAcc', _resources2.default.BillingAcc).factory('Invoice', _resources2.default.Invoice).factory('AnonPayment', _resources2.default.AnonPayment).factory('AnonTermination', _resources2.default.AnonTermination).factory('SecurityDeposit', _resources2.default.SecurityDeposit).factory('ErrorCatcher', _errorcatcher2.default).factory('ApiService', _api2.default).factory('featuresService', _featuresService2.default).factory('ReportManager', _reports2.default).factory('AdwordsService', _adwords2.default).factory('AlertManager', _alerts2.default).factory('LogoutService', _logout2.default).factory('BubblesService', _service2.default).factory('userCommunityService', _userCommunity2.default).factory('Chart', _chart2.default).factory('Tokens', _resources2.default.Tokens).config(_routes2.default).config( /** @ngInject */["ezfbProvider", function (ezfbProvider) {
    // Set up FB
    ezfbProvider.setLocale('fr_FR');
    ezfbProvider.setInitParams({
        appId: '119786712027642',
        version: 'v2.10'
    });
}]).run(_tagmanager2.default).run(_analytics2.default).run(_features2.default).run(_moment2.default).run(_navigationLogger2.default).run(_roles2.default).run(_states2.default).run(_uiMask2.default).run(_numeral2.default).controller('homeCtrl', _home2.default).controller('landingCtrl', _landing2.default).directive('avatar', _directive2.default).directive('chartInfo', _chartInfo2.default).directive('chartMonth', _directive4.default).directive('chartPotImage', _directive6.default).directive('circleRating', _directive8.default).directive('clamp', _clamp2.default).directive('cookiesBar', _directive10.default).directive('emailForm', _emailForm2.default).directive('dateField', _dateField2.default).directive('forceUppercase', _forceUppercase2.default).directive('hint', _directive12.default).directive('navbarWhiteBackground', _navbarBackground2.default).directive('navbarOpacity', _navbarOpacity2.default).directive('landscapeCanvas', _directive14.default).directive('landscapeForm', _directive16.default).directive('newsletterModal', _newsletterModal2.default).directive('noApplyClick', _directive18.default).directive('plumFeature', _directive20.default).directive('popin', _popin2.default).directive('potBalance', _directive22.default).directive('potDivision', _directive24.default).directive('report', _report2.default).directive('scrollToNext', _scrollToNext2.default).directive('subscriptionTimelineGraph', _subscriptionTimelineGraph2.default).directive('updateTitle', _updateTitle2.default).directive('birthdate', _directive26.default).directive('compareTo', _compareTo2.default).factory('ContractService', _contract2.default).factory('CookiesService', _service4.default).factory('DeviceChecker', _device2.default).filter('capitalize', _capitalize2.default).filter('ceil', _ceil2.default).filter('clientId', _clientId2.default).filter('contractStatus', _contractStatus2.default).filter('elision', _elision2.default).filter('frAmount', _frAmount2.default).filter('iban', _iban2.default).filter('phone', _phone2.default).filter('prm', _prm2.default).filter('integer', _integer2.default).filter('decimals', _decimals2.default).factory('gaEventsService', _gaEventsService2.default).factory('LandscapeElements', _landscapeElements2.default).factory('MobilePhone', _mobilePhone2.default).factory('PotManager', _service6.default).factory('PrmUtilsService', _prmUtils2.default).filter('rawHtml', _filter2.default).factory('ReferencesService', _references2.default).controller('campaignLandingCtrl', _campaignLanding2.default).directive('campaignLandingTemplate', _campaignLandingTemplate2.default).controller('communityCtrl', _community2.default).controller('termsCtrl', _terms2.default).controller('confirmCtrl', _confirm2.default).controller('confirmChangeMailCtrl', _confirmChangeMail2.default).controller('contactModalCtrl', _contactModal2.default).controller('flowCtrl', _flow2.default).directive('unergieFooter', _unergieFooter2.default).controller('forgotPasswordCtrl', _forgotPassword2.default).controller('hintsCtrl', _hints2.default).directive('animatedOnVisible', _animatedOnVisible2.default).directive('scrollSendEvent', _sendEvent2.default).controller('linkyModalCtrl', _controller2.default).controller('loginCtrl', _login2.default).controller('landscapeCtrl', _landscape2.default).controller('logoutCtrl', _controller4.default).controller('myMeterCtrl', _controller6.default).controller('navbarAccountCtrl', _navbarAccount2.default).controller('offerCtrl', _controller8.default).controller('promoCtrl', _promo2.default).controller('proofOfResModalCtrl', _proofofresmodal2.default).controller('selfReportCtrl', _selfReport2.default).directive('selfReportImgValue', _selfReportImgValue2.default).directive('selfReportStep', _selfReportStep2.default).directive('selfReportStepImage', _selfReportStepImage2.default).controller('signupCtrl', _signup2.default).controller('sponsorCtrl', _sponsor2.default).controller('subscriptionSummaryCtrl', _subscriptionSummary2.default).controller('subscriptionEndCtrl', _subscriptionEnd2.default).controller('anonPaymentSummaryCtrl', _anonPaymentSummary2.default).controller('anonTerminationSummaryCtrl', _anonTerminationSummary2.default).name;

/***/ }),
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navigationLoggerRun.$inject = ["$rootScope", "$stateParams", "$cookies", "$location", "LogNavigation", "PermPermissionStore"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navigationLoggerRun;

/** @ngInject */

function navigationLoggerRun($rootScope, $stateParams, $cookies, $location, LogNavigation, PermPermissionStore) {
    return $rootScope.$on('$stateChangeSuccess', function (event, next, current) {
        if ($stateParams.from) {
            $cookies.put('providerPartner', $stateParams.from, { expires: (0, _moment2.default)().add(1, 'day').toDate() });
        }
        $stateParams.from = null;
        return __guard__(PermPermissionStore.getStore().client, function (x) {
            return x.validatePermission().then(function () {
                if (next.url !== '/logout') {
                    LogNavigation.log({ url: next.url, additionalInfo: current });
                }
            });
        });
    });
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    RoomName: {
        'Logement': 'housing',
        'Cuisine': 'kitchen',
        'Salle de bain': 'bathroom',
        'Chambre': 'bedroom',
        'Pièce à vivre': 'living'
    },
    ImplementationToText: {
        1: 'Facile',
        2: 'Moyenne',
        3: 'Difficile'
    },
    MetterKind: {
        linky: 'LINKY'
    },
    MailAdresses: {
        commande: 'commande@plum.fr',
        bonjour: 'bonjour@plum.fr'
    },
    RecaptchaKey: {
        'local.unergie.com': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'int.unergie.com': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'preprod.plum-energie.fr': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'plum-energie.fr': '6LcTpiMTAAAAAOU1KsMWBgc-F3skMEIMqXOOBBDE',
        'espace-client.int.plum.fr': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'espace-client.preprod.plum.fr': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'espace-client.plum.fr': '6LcTpiMTAAAAAOU1KsMWBgc-F3skMEIMqXOOBBDE'
    },
    landingPageLink: {
        'local.unergie.com': 'http://local.plum.fr:3005',
        'int.unergie.com': 'https://int.plum.fr',
        'preprod.plum-energie.fr': 'https://preprod.plum.fr',
        'plum-energie.fr': 'https://plum.fr',
        'espace-client.int.plum.fr': 'https://int.plum.fr',
        'espace-client.preprod.plum.fr': 'https://preprod.plum.fr',
        'espace-client.plum.fr': 'https://plum.fr'
    },
    ContactTelephone: {
        emergency: {
            link: 'tel:+33972675092',
            label: '09 72 67 50 92'
        },
        anonymous: {
            link: 'tel:+33977558030',
            label: '09 77 55 80 30'
        },
        client: {
            link: 'tel:+33977558030',
            label: '09 77 55 80 30',
            openingHour: 'en semaine, de 9h à 18h'
        },
        data: {
            email: 'données-personnelles@plum.fr'
        },
        smallBusiness: {
            link: 'tel:+33176490179',
            label: '01 76 49 01 79',
            openingHour: 'en semaine, de 9h à 18h'
        },
        media: {
            email: 'rp@plum-energie.com',
            link: 'tel:+33626141490',
            label: '06 26 14 14 90'
        },
        offreCinqVingtCinq: {
            link: 'tel:+33975182046',
            label: '09 75 18 20 46'
        },
        offreFlashTrente: {
            link: 'tel:+33974593484',
            label: '09 74 59 34 84'
        },
        offrePrintemps2018: {
            link: 'tel:+33975182046',
            label: '09 75 18 20 46'
        },
        offreEte2018: {
            link: 'tel:+33977558030',
            label: '09 77 55 80 30'
        },
        offreEte2018Plum: {
            link: 'tel:+33977556768',
            label: '09 77 55 67 68',
            openingHour: 'du lundi au vendredi, de 9h à 18h'
        },
        offreEte2018Selectra: {
            link: 'tel:+33974593484',
            label: '09 74 59 34 84',
            openingHour: 'du lundi au samedi, de 9h à 18h'
        },
        offreRentree2018: {
            link: 'tel:+33975182046',
            label: '09 75 18 20 46',
            openingHour: 'du lundi au vendredi, de 9h à 18h'
        },
        offreAutomne2018: {
            link: 'tel:+33975182046',
            label: '09 75 18 20 46',
            openingHour: 'du lundi au vendredi, de 9h à 18h'
        }
    },
    ContactSubjects: {
        anonymous: [{ type: 'question', subject: 'L’offre Plüm - vous hésitez encore ?' }, { type: 'problem', subject: 'Service client - on peut vous aider !' }, { type: undefined, subject: 'Améliorez Plüm - idée d’amélioration ou bug' }, { type: 'question', subject: 'Journaliste - on répond aussi à vos questions :)' }, { type: undefined, subject: 'Job - rejoignez-nous !' }],
        client: [{ type: 'question', subject: 'J’ai une question sur mes factures' }, { type: 'question', subject: 'J’ai une question sur l’espace client' }, { type: 'question', subject: 'J’ai un problème sur l’espace client' }, { type: undefined, subject: 'J’ai une suggestion' }, { type: 'problem', subject: 'J’ai trouvé un bug' }]
    },
    ContractStatus: {
        initial: 0,
        demandeTransmise: 1,
        enService: 2,
        enRecouvrement: 3,
        resilie: 4,
        coupe: 5,
        autre: 6,
        refuseParEnedis: 9,
        resiliationDemande: 14,
        coupureDemande: 15,
        enAttenteEcheancier: 80,
        enAttenteReleve: 81,
        duplicat: 84,
        retracte: 90,
        annule: 91,
        enAttente: 92
    },
    UserStatus: {
        activeNoContract: 1,
        activeWithContracts: 2,
        activeFinishedContracts: 3
    },
    ContractStatusLabel: {
        0: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        1: { timelineStep: 2, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        2: { timelineStep: 4, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        3: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        4: { timelineStep: 0, termsView: 'STATE-CONTRACT-TERMINATED', isWaitingAction: false },
        5: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        6: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        9: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        10: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        14: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        15: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        80: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        81: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        82: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        83: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        84: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        90: { timelineStep: 0, termsView: 'STATE-CONTRACT-CANCELED', isWaitingAction: false },
        91: { timelineStep: 0, termsView: 'STATE-CONTRACT-CANCELED', isWaitingAction: false },
        92: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        unknown: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false }
    },
    PaymentStatus: {
        0: 'Programmé', // 'A transmettre'
        10: 'En cours de traitement', // 'En traitement'
        11: 'En cours de traitement', // 'En traitement CB'
        40: 'En cours de traitement', // 'En attente validation'
        50: 'En cours de traitement', // 'Transmis à slimpay'
        51: 'En cours de traitement', // 'En traitement Odoo'
        55: 'Payé', // 'Référencé Odoo'
        70: 'Rejeté', // 'Annulé'
        90: 'Rejeté', // 'En erreur'
        91: 'Rejeté', // 'Non présenté'
        93: 'Rejeté', // 'rTransaction'
        94: 'Rejeté', // 'Traitement rTransac'
        95: 'Rejeté', // 'rTransac dans Odoo'
        96: 'Rejeté', // 'rTransac rejoué'
        98: 'Rejeté' // 'Consommation de l\'avance'
    },
    PaymentModes: {
        CASH: 'Espèce',
        CB: 'Carte bancaire',
        CHECK: 'Chèque',
        ENERGY_CHECK: 'Chèque énergie',
        POT: 'Cagnotte',
        SEPA: 'Prélèvement bancaire',
        ENERGY_CHECK_BURN: 'Chèque énergie'
    },
    CampaignLandingType: {
        VISITE: 100,
        SUBSCRIBE: 110
    },
    CommonRegex: {
        fullname: /^[a-zA-ZÀ-ÿ][ 'a-zA-ZÀ-ÿ-]*['a-zA-ZÀ-ÿ]$/i,
        phone: {
            'all': /^(0|(00|\+)33)[6-7][0-9]{8}$/,
            'plus33': /^(\+33)[6-7][0-9]{8}$/,
            '0033': /^(0033)[6-7][0-9]{8}$/,
            '06or07': /^(0)[6-7][0-9]{8}$/
        }
    },
    StaticTariff: {
        plum: {
            base: {
                3: {
                    abo: 5.74,
                    base: 0.1508
                },
                6: {
                    abo: 8.92,
                    base: 0.1424
                },
                9: {
                    abo: 10.42,
                    base: 0.1438
                },
                12: {
                    abo: 11.96,
                    base: 0.1438
                },
                15: {
                    abo: 13.5,
                    base: 0.1438
                },
                18: {
                    abo: 15.27,
                    base: 0.1438
                },
                24: {
                    abo: 18.41,
                    base: 0.1438
                },
                30: {
                    abo: 21.79,
                    base: 0.1438
                },
                36: {
                    abo: 24.46,
                    base: 0.1438
                }
            },
            hphc: {
                6: {
                    abo: 10.06,
                    hp: 0.1545,
                    hc: 0.1209
                },
                9: {
                    abo: 12.25,
                    hp: 0.1545,
                    hc: 0.1209
                },
                12: {
                    abo: 14.26,
                    hp: 0.1545,
                    hc: 0.1209
                },
                15: {
                    abo: 16.12,
                    hp: 0.1545,
                    hc: 0.1209
                },
                18: {
                    abo: 17.83,
                    hp: 0.1545,
                    hc: 0.1209
                },
                24: {
                    abo: 21.83,
                    hp: 0.1545,
                    hc: 0.1209
                },
                30: {
                    abo: 23.53,
                    hp: 0.1545,
                    hc: 0.1209
                },
                36: {
                    abo: 26.39,
                    hp: 0.1545,
                    hc: 0.1209
                }
            }
        },
        edf: {
            base: {
                3: {
                    abo: 5.74,
                    base: 0.1555
                },
                6: {
                    abo: 8.92,
                    base: 0.1467
                },
                9: {
                    abo: 10.42,
                    base: 0.1483
                },
                12: {
                    abo: 11.96,
                    base: 0.1483
                },
                15: {
                    abo: 13.5,
                    base: 0.1483
                },
                18: {
                    abo: 15.27,
                    base: 0.1483
                },
                24: {
                    abo: 18.41,
                    base: 0.1483
                },
                30: {
                    abo: 21.79,
                    base: 0.1483
                },
                36: {
                    abo: 24.46,
                    base: 0.1483
                }
            },
            hphc: {
                6: {
                    abo: 10.06,
                    hp: 0.1593,
                    hc: 0.1244
                },
                9: {
                    abo: 12.25,
                    hp: 0.1593,
                    hc: 0.1244
                },
                12: {
                    abo: 14.26,
                    hp: 0.1593,
                    hc: 0.1244
                },
                15: {
                    abo: 16.12,
                    hp: 0.1593,
                    hc: 0.1244
                },
                18: {
                    abo: 17.83,
                    hp: 0.1593,
                    hc: 0.1244
                },
                24: {
                    abo: 21.83,
                    hp: 0.1593,
                    hc: 0.1244
                },
                30: {
                    abo: 23.53,
                    hp: 0.1593,
                    hc: 0.1244
                },
                36: {
                    abo: 26.39,
                    hp: 0.1593,
                    hc: 0.1244
                }
            }
        }
    }
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


featuresRun.$inject = ["featuresService", "$rootScope"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = featuresRun;

/** @ngInject */

function featuresRun(featuresService, $rootScope) {
    $rootScope.$on('$stateChangeStart', function (event, next, current) {
        featuresService.reset();
        featuresService.getFeaturesPromise().then(function (features) {
            $rootScope.dataFeature = features;
        });
    });
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


momentRun.$inject = ["amMoment"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = momentRun;

/** @ngInject */

function momentRun(amMoment) {
    amMoment.changeLocale('fr');
}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


tagManagerRun.$inject = ["$window", "$location"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint no-spaced-func: "warn"*/
/* eslint func-call-spacing: "warn"*/
/* eslint no-unexpected-multiline: "warn"*/

/** @ngInject */
function tagManagerRun($window, $location) {
    var trackerId = void 0;
    if (['local.unergie.com', 'espace-client.int.plum.fr', 'espace-client.preprod.plum.fr'].indexOf($location.host()) > -1) {
        trackerId = 'GTM-MVKHSXZ';
    }
    if (['plum-energie.fr', 'espace-client.plum.fr'].indexOf($location.host()) > -1) {
        trackerId = 'GTM-WL84WGW';
    }

    // Google Tag Manager
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0];
        var j = d.createElement(s);
        var dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + trackerId + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', trackerId);
}

exports.default = tagManagerRun;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


analyticsRun.$inject = ["$rootScope", "$window", "$location"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = analyticsRun;

/** @ngInject */

function analyticsRun($rootScope, $window, $location) {
    // Google Analytics
    (function (i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
        };

        i[r].l = Number(new Date());
        a = s.createElement(o);
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    var trackerId = void 0;
    if (['espace-client.int.plum.fr', 'espace-client.preprod.plum.fr'].indexOf($location.host()) > -1) {
        trackerId = 'UA-77876022-5';
    }
    if (['plum-energie.fr', 'espace-client.plum.fr'].indexOf($location.host()) > -1) {
        trackerId = 'UA-77876022-4';
    }

    if (trackerId) {
        $window.ga('create', trackerId, 'auto');
        $rootScope.$on('$stateChangeSuccess', function (event) {
            $window.ga('send', 'pageview', '/' + $location.path());

            // GA CAMPAIGN TRACKING
            if (localStorage.id_campaign) {
                $window.ga('send', {
                    hitType: 'pageview',
                    eventCategory: localStorage.id_campaign,
                    eventAction: 'stateChange - ' + $location.path(),
                    eventLabel: localStorage.id_campaign + ' Campaign Page View'
                });
            }
        });
    }
}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


rolesRun.$inject = ["$cookies", "$q", "PermPermissionStore", "ApiService", "UserStatus"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rolesRun;

/** @ngInject */

function rolesRun($cookies, $q, PermPermissionStore, ApiService, UserStatus) {
    PermPermissionStore.definePermission('user', function () {
        return Boolean($cookies.get('ssoStatus'));
    });
    PermPermissionStore.definePermission('anonymous', function () {
        return !$cookies.get('ssoStatus');
    });
    return PermPermissionStore.definePermission('client', function () {
        if ($cookies.get('ssoStatus')) {
            var deferred = $q.defer();
            ApiService.fetchUserInfo().then(function (userInfo) {
                if ([UserStatus.activeWithContracts, UserStatus.activeFinishedContracts].indexOf(userInfo.status) > -1) {
                    localStorage.hideDashboard = true;
                    return deferred.resolve();
                }
                return deferred.reject();
            }).catch(function (error) {
                return deferred.reject();
            });
            return deferred.promise;
        }
        return false;
    });
}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider", "$qProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _defaultTo2 = __webpack_require__(71);

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

var _filter2 = __webpack_require__(82);

var _filter3 = _interopRequireDefault(_filter2);

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _timeline = __webpack_require__(191);

var _timeline2 = _interopRequireDefault(_timeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = routesConfig;


var redirectSelfcareV2 = function redirectSelfcareV2() {
    if (window.location.host.indexOf('local') !== -1) {
        window.location = 'https://local.unergie.com:3010/';
    } else {
        window.location = 'https://' + window.location.host + '/v2';
    }
};

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider, $qProvider) {
    $stateProvider.state('home', {
        url: '?from&utm_source&utm_medium&utm_campaign',
        abstract: true,
        controller: 'homeCtrl',
        template: __webpack_require__(676)(),
        resolve: {
            features: ["featuresService", function features(featuresService) {
                return featuresService.getFeatures();
            }]
        }
    }).state('offer', {
        url: '',
        abstract: true,
        parent: 'navbar',
        template: __webpack_require__(288)(),
        controller: 'offerCtrl',
        data: {
            showFold: true
        }
    }).state('landing', {
        url: '/',
        parent: 'home',
        template: __webpack_require__(678)(),
        controller: 'landingCtrl',
        params: {
            shouldOpenPriceForm: false
        },
        data: {
            pageTitle: 'L’offre'
        },
        resolve: {
            defaultRedirection: ["$state", "$stateParams", "$q", "$window", "PermPermissionStore", "DeviceChecker", function defaultRedirection($state, $stateParams, $q, $window, PermPermissionStore, DeviceChecker) {
                var deferred = $q.defer();
                var isClient = __guard__(PermPermissionStore.getStore().client, function (x) {
                    return x.validatePermission();
                });

                isClient.then(function () {
                    if (DeviceChecker.isMobile()) {
                        $state.go('dashboard', { shouldOpenPriceForm: $stateParams.shouldOpenPriceForm });
                    } else {
                        $state.go('account', { shouldOpenPriceForm: $stateParams.shouldOpenPriceForm });
                    }
                    deferred.reject();
                }).catch(function () {
                    var isUser = __guard__(PermPermissionStore.getStore().user, function (x) {
                        return x.validatePermission();
                    });
                    isUser.then(function () {
                        $state.go('community');
                        deferred.reject();
                    }).catch(function () {
                        if ($window.location.host.indexOf('local') === -1) {
                            $window.location.href = 'https://' + $window.location.host;
                            deferred.reject();
                        }
                        deferred.resolve();
                    });
                });
                return deferred.promise;
            }]
        }
    }).state('landingPrice', {
        url: '/tarifs',
        resolve: {
            // This is a hack - Need to use angular-ui-router: 1.0.0 minimum for better redirectTo
            redirectTo: ["$state", "$q", function redirectTo($state, $q) {
                $state.go('landing', { shouldOpenPriceForm: true });
                return $q.reject();
            }]
        }
    }).state('whatsMyMeter', {
        parent: 'offer',
        url: '/offre/quel-est-mon-compteur',
        template: __webpack_require__(679)(),
        data: {
            pageTitle: 'Quel est mon compteur',
            showHeader: false
        }
    }).state('myMeter', {
        parent: 'offer',
        url: '/offre/compteur',
        template: __webpack_require__(680)(),
        controller: 'myMeterCtrl',
        data: {
            showHeader: false
        }
    }).state('myMeter.linky', {
        url: '/linky',
        template: __webpack_require__(681)(),
        data: {
            pageTitle: 'Compteur Linky'
        }
    }).state('myMeter.classique', {
        url: '/classique',
        template: __webpack_require__(682)(),
        data: {
            pageTitle: 'Compteur Classique'
        }
    }).state('login', {
        parent: 'home',
        url: '/me-connecter?source&redirectTo',
        template: __webpack_require__(683)(),
        params: {
            transactionStatus: null,
            transactionErrorCode: null,
            signatureOperationResult: null,
            transactionId: null,
            order_reference: null,
            processId: null,
            key: null,
            bulk_purchase: null
        },
        controller: 'loginCtrl',
        data: {
            pageTitle: 'Me connecter',
            permissions: {
                only: ['anonymous'],
                redirectTo: 'landing'
            }
        },
        resolve: {
            redirectTo: function redirectTo() {
                redirectSelfcareV2();
            }
        }
    }).state('logout', {
        parent: 'home',
        url: '/logout',
        controller: 'logoutCtrl',
        data: {
            pageTitle: 'Se déconnecter',
            permissions: {
                except: ['anonymous'],
                redirectTo: 'landing'
            }
        }
    }).state('forgotPassword', {
        parent: 'home',
        url: '/reinitialisation-mot-de-passe?source&redirectTo',
        template: __webpack_require__(289)(),
        controller: 'forgotPasswordCtrl',
        data: {
            pageTitle: 'Réinitialisez votre mot de passe',
            permissions: {
                only: ['anonymous'],
                redirectTo: 'landing'
            }
        }
    }).state('firstLogin', {
        parent: 'home',
        url: '/choix-mot-de-passe?source&redirectTo',
        template: __webpack_require__(289)(),
        controller: 'forgotPasswordCtrl',
        data: {
            pageTitle: 'Choisir votre mot de passe',
            permissions: {
                only: ['anonymous'],
                redirectTo: 'landing'
            }
        }
    }).state('signup', {
        parent: 'home',
        url: '/m-inscrire?source&redirectTo&parrainage&promo',
        template: __webpack_require__(684)(),
        controller: 'signupCtrl',
        data: {
            pageTitle: 'M’inscrire',
            permissions: {
                only: ['anonymous'],
                redirectTo: function redirectTo(rejectedPermission, transitionProperties) {
                    return {
                        state: transitionProperties.toParams.redirectTo
                    };
                }
            }
        }
    }).state('confirm', {
        parent: 'home',
        url: '/confirm-email?token&source&redirectTo',
        params: {
            transactionStatus: null,
            transactionErrorCode: null,
            signatureOperationResult: null,
            transactionId: null,
            order_reference: null,
            processId: null,
            key: null,
            bulk_purchase: null
        },
        template: __webpack_require__(685)(),
        controller: 'confirmCtrl',
        data: {
            pageTitle: 'Confirmer email',
            permissions: {
                only: ['anonymous'],
                redirectTo: 'landing'
            }
        },
        resolve: {
            userInfo: ["$stateParams", "User", "$q", "ErrorCatcher", function userInfo($stateParams, User, $q, ErrorCatcher) {
                return User.getInfoByToken({ token: $stateParams.token }).$promise.then(function (userInfo) {
                    return $q.resolve({ hasUserInfo: true });
                }).catch(function (error) {
                    if (error.status !== 404) {
                        ErrorCatcher.catchError(error);
                    }
                    return $q.resolve({ hasUserInfo: false });
                });
            }]
        }
    }).state('confirmChangeMail', {
        parent: 'home',
        url: '/modif-email/:processId?key',
        template: __webpack_require__(686)(),
        controller: 'confirmChangeMailCtrl',
        data: {
            pageTitle: 'Confirmer changement email',
            permissions: {
                only: ['user'],
                redirectTo: function redirectTo(rejectedPermission, transitionProperties) {
                    return {
                        state: 'login',
                        params: (0, _assign3.default)({}, transitionProperties.toParams, { redirectTo: 'confirmChangeMail' })
                    };
                }
            }
        },
        resolve: {
            isChangeMailSuccess: ["$q", "$stateParams", "ErrorCatcher", "User", function isChangeMailSuccess($q, $stateParams, ErrorCatcher, User) {
                return User.confirmNewEmail({ processId: $stateParams.processId }, { key: $stateParams.key }).$promise.then(function () {
                    return $q.resolve(true);
                }).catch(function (error) {
                    ErrorCatcher.catchErrorWithoutRedirect(error);
                    return $q.resolve(false);
                });
            }]
        }
    }).state('navbar', {
        parent: 'home',
        url: '?contractId',
        abstract: true,
        controller: 'navbarCtrl',
        template: __webpack_require__(687)(),
        data: {
            showNavOnMobile: false
        },
        resolve: {
            userInfo: ["$stateParams", "ApiService", "PermPermissionStore", function userInfo($stateParams, ApiService, PermPermissionStore) {
                return __guard__(PermPermissionStore.getStore().client, function (x) {
                    return x.validatePermission().then(function () {
                        var userInfo$ = ApiService.fetchUserInfo();
                        if ($stateParams.contractId) {
                            return userInfo$.then(function (response) {
                                var selectedContract = (0, _filter3.default)(response.contracts, { id: $stateParams.contractId })[0];
                                response.contractSelected = (0, _defaultTo3.default)(selectedContract, response.contractSelected);
                                return response;
                            });
                        }
                        return userInfo$;
                    });
                });
            }],
            pot: ["PotManager", "PermPermissionStore", function pot(PotManager, PermPermissionStore) {
                return __guard__(PermPermissionStore.getStore().client, function (x) {
                    return x.validatePermission().then(function () {
                        return PotManager.getPotBalance();
                    }).catch(function () {
                        return false;
                    });
                });
            }],
            userAction: ["User", "PermPermissionStore", function userAction(User, PermPermissionStore) {
                return __guard__(PermPermissionStore.getStore().client, function (x) {
                    return x.validatePermission().then(function () {
                        return User.getUa();
                    }).catch(function () {
                        return false;
                    });
                });
            }]
        }
    }).state('dashboard', {
        url: '/mon-tableau-de-bord',
        parent: 'navbar',
        params: {
            shouldOpenPriceForm: false
        },
        data: {
            showNavOnMobile: true
        }
    }).state('flow', {
        // parent: 'navbar'
        url: '/le-fil-plum-energie',
        template: __webpack_require__(688)(),
        controller: 'flowCtrl',
        data: {
            pageTitle: 'Le fil plüm énergie',
            permissions: {
                except: ['anonymous', 'user'],
                redirectTo: 'landing'
            }
        }
    }).state('hints', {
        parent: 'navbar',
        url: '/conseils',
        template: __webpack_require__(689)(),
        controller: 'hintsCtrl',
        params: {
            shouldOpenPriceForm: false
        },
        resolve: {
            hints: ["Hint", "ErrorCatcher", "$q", function hints(Hint, ErrorCatcher, $q) {
                return Hint.getAll().$promise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.reject(error);
                });
            }]
        },
        data: {
            pageTitle: 'Les conseils',
            permissions: {
                only: ['client'],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'hints'
                        }
                    },
                    default: 'login'
                }
            }
        }
    }).state('tracking', {
        parent: 'navbar',
        url: '/suivi-conso',
        template: __webpack_require__(690)(),
        controller: 'trackingCtrl',
        data: {
            pageTitle: 'Mon suivi conso',
            permissions: {
                only: ['client'],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'tracking'
                        }
                    },
                    default: 'login'
                }
            }
        },
        resolve: {
            activeContract: ["$q", "$state", "ContractStatus", "userInfo", function activeContract($q, $state, ContractStatus, userInfo) {
                if (userInfo.status !== ContractStatus.resilie) {
                    return $q.resolve(userInfo.contractSelected);
                }
                $state.go('landing');
                return $q.reject(userInfo.contractSelected);
            }],
            contractCons: ["userInfo", "Contract", "featuresService", "ErrorCatcher", "$q", function contractCons(userInfo, Contract, featuresService, ErrorCatcher, $q) {
                var startDate = (0, _moment2.default)().subtract(6, 'months').format('MMYYYY');
                return featuresService.getFeaturesPromise().then(function (dataFeature) {
                    var route = dataFeature.myConsV2 === false ? 'myCons' : 'myConsV2';

                    return Contract[route]({ id: userInfo.contractSelected.id, start: startDate }).$promise.catch(function (error) {
                        ErrorCatcher.catchError(error);
                        // return $q.reject(error)
                    });
                });
            }],
            landscapeQuestions: ["ApiService", "userInfo", "LandscapeQuestions", "ErrorCatcher", "$q", function landscapeQuestions(ApiService, userInfo, LandscapeQuestions, ErrorCatcher, $q) {
                // will change when other merge will be approved
                return ApiService.fetchFeatures().then(function (response) {
                    if (response.landscape) {
                        var contractId = void 0;
                        if (userInfo.contractSelected) {
                            contractId = userInfo.contractSelected.id;
                        } else {
                            return false;
                        }

                        var landscapeQs = LandscapeQuestions.search({ category: 'c-est-parti', id_contract: contractId });
                        return landscapeQs.$promise.catch(function (error) {
                            ErrorCatcher.catchError(error);
                            return $q.resolve([]);
                        });
                    }
                    return true;
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.reject(error);
                });
            }]
        }
    }).state('navbarAccount', {
        parent: 'navbar',
        abstract: true,
        controller: 'navbarAccountCtrl',
        template: __webpack_require__(691)()
    }).state('account', {
        parent: 'navbarAccount',
        url: '/mon-compte',
        template: __webpack_require__(692)(),
        controller: 'accountCtrl',
        data: {
            pageTitle: 'Contrat',
            permissions: {
                only: ['client'],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'account'
                        }
                    },
                    default: 'login'
                }
            }
        },
        resolve: {
            redirectTo: function redirectTo() {
                redirectSelfcareV2();
            },
            billingAddress: ["ApiService", "User", "ErrorCatcher", "$q", function billingAddress(ApiService, User, ErrorCatcher, $q) {
                return User.getBillingAddress().$promise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.reject(error);
                });
            }]
        }
    }).state('invoice', {
        parent: 'navbarAccount',
        url: '/mes-factures?transactionStatus&transactionId',
        template: __webpack_require__(693)(),
        controller: 'invoiceCtrl',
        data: {
            pageTitle: 'Mes factures',
            permissions: {
                only: ['client'],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'invoice'
                        }
                    },
                    default: 'login'
                }
            }
        },
        resolve: {
            redirectTo: function redirectTo() {
                redirectSelfcareV2();
            },
            invoices: ["userInfo", "Contract", "ErrorCatcher", "$q", function invoices(userInfo, Contract, ErrorCatcher, $q) {
                return Contract.getInvoices({ id: userInfo.contractSelected.id }).$promise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.resolve({ currentSituation: {}, invoices: [] });
                });
            }],
            transaction: ["$q", "$stateParams", "ErrorCatcher", "Invoice", "DataAccessVariables", function transaction($q, $stateParams, ErrorCatcher, Invoice, DataAccessVariables) {
                if ((0, _isEmpty3.default)($stateParams.transactionId)) {
                    return $q.resolve({});
                }
                var transactionResult = {
                    transactionStatus: $stateParams.transactionStatus,
                    transactionId: $stateParams.transactionId
                };
                if ($stateParams.transactionId.split('_')[0] === 'DEPOSIT') {
                    return DataAccessVariables.get({ variables: 'DEPOSIT_AMOUNT' }).$promise.then(function (response) {
                        return (0, _assign3.default)({}, transactionResult, { payment: { amount: response.DEPOSIT_AMOUNT } });
                    }).catch(function (error) {
                        ErrorCatcher.catchError(error);
                        return transactionResult;
                    });
                }
                return Invoice.getPayment({ payment_id: $stateParams.transactionId }).$promise.then(function (result) {
                    return (0, _assign3.default)({}, result, { payment: result });
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return transactionResult;
                });
            }]
        }
    }).state('personalInformation', {
        parent: 'navbarAccount',
        url: '/infos-personnelles',
        template: __webpack_require__(694)(),
        controller: 'personalInformationCtrl',
        data: {
            pageTitle: 'Info personnelles',
            permissions: {
                only: ['client'],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'personalInformation'
                        }
                    },
                    default: 'login'
                }
            }
        }
    }).state('community', {
        parent: 'home',
        url: '/communaute?contact',
        template: __webpack_require__(695)(),
        controller: 'communityCtrl',
        data: {
            pageTitle: 'La communauté'
        }
    }).state('terms', {
        parent: 'home',
        url: '/mentions-legales',
        template: __webpack_require__(696)(),
        controller: 'termsCtrl',
        data: {
            pageTitle: 'Mentions legales'
        },
        resolve: {
            providerInfo: ["ProviderInfo", function providerInfo(ProviderInfo) {
                return ProviderInfo.get().$promise.then(function (response) {
                    return response;
                }).catch(function (error) {
                    console.log('Cannot fetch provider info');
                });
            }]
        }
    }).state('sponsor', {
        url: '/parrainage/:sponsorId',
        parent: 'home',
        controller: 'sponsorCtrl',
        data: {
            pageTitle: 'Sponsor'
        }
    }).state('promo', {
        url: '/promo/:promoId',
        parent: 'home',
        controller: 'promoCtrl',
        data: {
            pageTitle: 'Promo'
        }
    }).state('subscription', {
        url: '/old-souscription',
        params: {
            bulk_purchase: null
        },
        resolve: {
            // This is a hack - Need to use angular-ui-router: 1.0.0 minimum for better redirectTo
            redirectTo: ["$window", "$stateParams", function redirectTo($window, $stateParams) {
                var ufcQuery = $stateParams.bulk_purchase === 'ufc' ? '/achat-groupe?token=' + localStorage.bulkPurchaseSubscriptionToken : '';
                if ($window.location.host.indexOf('local') !== -1) {
                    $window.location.href = 'https://local.unergie.com:3008' + ufcQuery;
                } else {
                    $window.location.href = 'https://' + $window.location.host + '/souscription' + ufcQuery;
                }
            }]
        }
    })
    // .state('subscription', {
    //     url: '/souscription',
    //     template: require('../states/subscription/subscription.jade')(),
    //     parent: 'home',
    //     controller: 'subscriptionCtrl',
    //     resolve: {
    //         contractDraft($q, $stateParams, ContractDraft, ErrorCatcher) {
    //             return ContractDraft.get({ create: true }).$promise
    //             .then((data) => {
    //                 const civMapping = {
    //                     'm.': 'M.',
    //                     'mme': 'Mme',
    //                     'monsieur': 'M.',
    //                     'madame': 'Mme',
    //                 }
    //                 return _.assign({}, data, _.omitBy($stateParams, _.isNil), {
    //                     civ: _.get(civMapping, _.toLower($stateParams.civ), 'M.'),
    //                     utm_source: $stateParams.utm_source,
    //                     utm_medium: $stateParams.utm_medium,
    //                     utm_campaign: $stateParams.utm_campaign,
    //                 })
    //             }).catch((error) => {
    //                 ErrorCatcher.catchError(error)
    //                 return $q.reject(error)
    //             })
    //         },
    //     },
    //     data: {
    //         pageTitle: 'Souscription',
    //         isPartnerSubscription: true,
    //     },
    // })
    .state('landscape', {
        url: '/landscape?id',
        template: __webpack_require__(697)(),
        controller: 'landscapeCtrl',
        resolve: {
            contractDraft: ["$q", "$stateParams", "ContractDraft", "ErrorCatcher", function contractDraft($q, $stateParams, ContractDraft, ErrorCatcher) {
                return ContractDraft.get({}).$promise.then(function (data) {
                    return data;
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.reject(error);
                });
            }]
        },
        data: {
            pageTitle: 'Landscape'
        }
    }).state('subscriptionEnd', {
        parent: 'home',
        url: '/souscription/fin',
        template: __webpack_require__(698)(),
        controller: 'subscriptionEndCtrl',
        params: {
            email: null
        },
        resolve: {
            enabledFeature: ["$q", "$state", "featuresService", function enabledFeature($q, $state, featuresService) {
                return featuresService.getFeaturesPromise().then(function (dataFeature) {
                    if (!dataFeature.subscriptionShowroom) {
                        $state.go('landing');
                        return $q.reject();
                    }
                });
            }]
        },
        data: {
            pageTitle: 'Souscription',
            permissions: {
                only: ['anonymous'],
                redirectTo: 'landing'
            }
        }
    }).state('landingOffrePrintemps2018', {
        parent: 'home',
        url: '/offreAchatGroupePrintemps2018?civ&givenname&sn&mail&id_prm&id_ref_promo',
        template: __webpack_require__(699)(),
        controller: 'landingOffrePrintemps2018Ctrl',
        resolve: {
            enabledFeature: ["$q", "$state", "featuresService", function enabledFeature($q, $state, featuresService) {
                return featuresService.getFeaturesPromise().then(function (dataFeature) {
                    if (!dataFeature.subscriptionOffrePrintemps2018) {
                        $state.go('landing');
                        return $q.reject(false);
                    }
                    return $q.resolve(true);
                });
            }]
        }
    }).state('landingOffreRentree2018', {
        parent: 'home',
        url: '/offreAchatGroupeRentree2018?civ&givenname&sn&mail&id_prm&ville&prep',
        template: __webpack_require__(700)(),
        controller: 'landingOffreRentree2018Ctrl',
        resolve: {
            enabledFeature: ["$q", "$state", "ContractDraft", function enabledFeature($q, $state, ContractDraft) {
                return ContractDraft.getOfferSelectable({ provider_offer: 'OFFRE_RENTREE_2018' }).$promise.then(function (selectableResult) {
                    if (!selectableResult.selectable) {
                        $state.go('landing');
                        return $q.reject(false);
                    }
                    return $q.resolve(true);
                });
            }]
        }
    }).state('subscriptionSummarySignup', {
        url: '/souscription/resume/:token',
        template: __webpack_require__(290)(),
        controller: 'subscriptionSummaryCtrl',
        resolve: {
            subscriptionToken: ["$q", "$state", "$stateParams", "User", function subscriptionToken($q, $state, $stateParams, User) {
                localStorage.removeItem('subscriptionToken');
                var token = $stateParams.token;

                if (!token) {
                    redirectSelfcareV2();
                } else {
                    return User.getInfoByToken({ token: token }).$promise.then(function (userInfo) {
                        if (userInfo.type === 'SUBSCRIPTION') {
                            localStorage.subscriptionToken = token;
                            return $q.resolve(token);
                        } else if (userInfo.active) {
                            $state.go('subscriptionSummary');
                            return $q.reject();
                        }
                        $state.go('confirm', { token: token });
                        return $q.reject();
                    }).catch(function (error) {
                        redirectSelfcareV2();
                        return $q.reject();
                    });
                }
            }],
            contractDraft: ["$state", "$q", "ContractDraft", "ErrorCatcher", "subscriptionToken", function contractDraft($state, $q, ContractDraft, ErrorCatcher, subscriptionToken /* subscriptionToken must be loaded before timeline */) {
                return ContractDraft.getByToken({ create: true, token: localStorage.subscriptionToken, notifySubscription: true }).$promise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    $state.go('landing');
                    return $q.reject(error);
                }).then(function (contractDraft) {
                    if (contractDraft.ready_to_checkout) {
                        return contractDraft;
                    }
                    $state.go('landing');
                    return $q.reject();
                });
            }],
            timeline: ["$q", "$state", "ContractDraft", "ErrorCatcher", "contractDraft", function timeline($q, $state, ContractDraft, ErrorCatcher, contractDraft /* contractDraft must be loaded before timeline */) {
                return ContractDraft.getTimetableByToken({ token: localStorage.subscriptionToken }, {}).$promise.then(function (values) {
                    return (0, _timeline2.default)(values);
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.resolve([]);
                });
            }]
        }
    }).state('subscriptionSummary', {
        url: '/souscription/resume',
        template: __webpack_require__(290)(),
        controller: 'subscriptionSummaryCtrl',
        resolve: {
            subscriptionToken: function subscriptionToken() {
                return null;
            },
            contractDraft: ["$state", "$q", "ContractDraft", "ErrorCatcher", function contractDraft($state, $q, ContractDraft, ErrorCatcher) {
                return ContractDraft.get({ create: true, withRelated: 'providerOffer,nextBillableDate' }).$promise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    $state.go('landing');
                    return $q.reject(error);
                }).then(function (contractDraft) {
                    if (contractDraft.ready_to_checkout) {
                        return contractDraft;
                    }
                    $state.go('landing');
                    return $q.reject();
                });
            }],
            timeline: ["$q", "$state", "ContractDraft", "ErrorCatcher", "contractDraft", function timeline($q, $state, ContractDraft, ErrorCatcher, contractDraft /* contractDraft must be loaded before loading timeline */) {
                var fnGetTimetable = contractDraft.estimated_v !== 0 ? 'getTimetableV2' : 'getTimetableV1';

                return ContractDraft[fnGetTimetable]().$promise.then(function (values) {
                    return (0, _timeline2.default)(values);
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.resolve([]);
                });
            }]
        },

        data: {
            pageTitle: 'Souscription',
            permissions: {
                only: ['user'],
                redirectTo: {
                    default: 'login'
                }
            }
        }
    }).state('anonPaymentSummary', {
        parent: 'home',
        url: '/regularisation/:tokenId',
        template: __webpack_require__(701)(),
        controller: 'anonPaymentSummaryCtrl',
        resolve: {
            paymentToken: ["$state", "$q", "$stateParams", "AnonPayment", "ErrorCatcher", function paymentToken($state, $q, $stateParams, AnonPayment, ErrorCatcher) {
                return AnonPayment.getToken({ tokenId: $stateParams.tokenId }).$promise.catch(function (error) {
                    return undefined;
                });
            }]
        },
        data: {
            pageTitle: 'Régularisation'
        }
    }).state('anonTerminationSummary', {
        parent: 'home',
        url: '/resiliation/:tokenId',
        template: __webpack_require__(291)(),
        controller: 'anonTerminationSummaryCtrl',
        resolve: {
            terminationToken: ["$stateParams", "AnonTermination", "ErrorCatcher", function terminationToken($stateParams, AnonTermination, ErrorCatcher) {
                return AnonTermination.getTerminationToken({ tokenId: $stateParams.tokenId }).$promise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return undefined;
                });
            }],
            cancel: function cancel() {
                return false;
            }
        },
        data: {
            pageTitle: 'Confirmer la résiliation'
        }
    }).state('anonCancelTerminationSummary', {
        parent: 'home',
        url: '/annuler-resiliation/:tokenId',
        template: __webpack_require__(291)(),
        controller: 'anonTerminationSummaryCtrl',
        resolve: {
            terminationToken: ["$stateParams", "AnonTermination", "ErrorCatcher", function terminationToken($stateParams, AnonTermination, ErrorCatcher) {
                return AnonTermination.getTerminationToken({ tokenId: $stateParams.tokenId }).$promise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return undefined;
                });
            }],
            cancel: function cancel() {
                return true;
            }
        },
        data: {
            pageTitle: 'Annuler la résiliation'
        }
    }).state('securityDepositAnonymous', {
        parent: 'home',
        url: '/depot-garantie/:tokenId',
        template: '<security-deposit-summary deposit-info="$ctrl.depositInfo" token-id="$ctrl.tokenId" contract-id="$ctrl.contractId"></security-deposit-summary>',
        controllerAs: '$ctrl',
        controller: ["$stateParams", "depositInfo", function controller($stateParams, depositInfo) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            this.depositInfo = depositInfo;
            this.tokenId = $stateParams.tokenId;
            this.contractId = $stateParams.contractId;
        }],

        resolve: {
            depositInfo: ["$stateParams", "SecurityDeposit", function depositInfo($stateParams, SecurityDeposit) {
                return SecurityDeposit.getToken({ tokenId: $stateParams.tokenId }).$promise.then(function (result) {
                    return (0, _assign3.default)({}, result, {
                        tokenId: $stateParams.tokenId,
                        isDepositNeeded: true
                    });
                }).catch(function () {
                    return undefined;
                });
            }]
        },
        data: {
            pageTitle: 'Dépôt de garantie'
        }
    }).state('securityDepositAuthenticated', {
        parent: 'home',
        url: '/depot-garantie/contrat/:contractId',
        template: '<security-deposit-summary deposit-info="$ctrl.depositInfo" token-id="$ctrl.tokenId" contract-id="$ctrl.contractId"></security-deposit-summary>',
        controllerAs: '$ctrl',
        controller: ["$stateParams", "depositInfo", function controller($stateParams, depositInfo) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            this.depositInfo = depositInfo;
            this.tokenId = $stateParams.tokenId;
            this.contractId = $stateParams.contractId;
        }],

        resolve: {
            depositInfo: ["$q", "$state", "$stateParams", "Contract", "ErrorCatcher", function depositInfo($q, $state, $stateParams, Contract, ErrorCatcher) {
                return Contract.isDepositNeeded({ id: $stateParams.contractId }).$promise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return {};
                }).then(function (result) {
                    if (result.depositNeeded === true) {
                        return $q.resolve({
                            contractId: $stateParams.contractId,
                            isDepositNeeded: result.depositNeeded
                        });
                    } else if (result.depositNeeded === false) {
                        $state.go('landing');
                        return $q.reject();
                    }
                    return $q.resolve(undefined);
                });
            }]
        },
        data: {
            pageTitle: 'Dépôt de garantie'
        }
    }).state('campaignLanding', {
        url: '/campagne/:id_campaign?tokenId',
        template: __webpack_require__(702)(),
        controller: 'campaignLandingCtrl',
        resolve: {
            currentCampaign: ["CampaignLanding", "$state", "$stateParams", function currentCampaign(CampaignLanding, $state, $stateParams) {
                return CampaignLanding.getCampaign({
                    id_campaign: $stateParams.id_campaign,
                    tokenId: $stateParams.tokenId
                }).$promise.catch(function (error) {
                    return $state.go('landing');
                });
            }]
        }
    }).state('confirmNewsletter', {
        parent: 'home',
        url: '/newsletter/:newsletterId/:answer',
        template: __webpack_require__(703)()
    }).state('quotationDefault', {
        parent: 'home',
        url: '/devis',
        resolve: {
            // This is a hack - Need to use angular-ui-router: 1.0.0 minimum for better redirectTo
            redirectTo: ["$state", "$q", function redirectTo($state, $q) {
                $state.go('quotation', { viewState: 'state-form-initial' });
                return $q.reject();
            }]
        }
    }).state('quotation', {
        parent: 'home',
        url: '/devis/:viewState',
        template: '<quotation ' + 'contract-draft="$ctrl.contractDraft" ' + 'landscape-questions="$ctrl.landscapeQuestions" ' + 'tariff-options="$ctrl.tariffOptions"' + 'view-state="$ctrl.viewState">' + '</quotation>',
        controllerAs: '$ctrl',
        controller: ["$stateParams", "contractDraft", "landscapeQuestions", "tariffOptions", function controller($stateParams, contractDraft, landscapeQuestions, tariffOptions) {
            // Remove template/controllerAs/controller and use component after upgrading to ui-router > 1.x
            var ctrl = this;
            ctrl.contractDraft = contractDraft;
            ctrl.landscapeQuestions = landscapeQuestions;
            ctrl.tariffOptions = tariffOptions;
            ctrl.viewState = $stateParams.viewState;
        }],

        resolve: {
            enabledFeature: ["$q", "$state", "featuresService", function enabledFeature($q, $state, featuresService) {
                return featuresService.getFeaturesPromise().then(function (dataFeature) {
                    if (!dataFeature.quotation) {
                        $state.go('landing');
                        return $q.reject();
                    }
                    return true;
                });
            }],
            contractDraft: ["ContractDraft", "ErrorCatcher", "$q", "enabledFeature", function contractDraft(ContractDraft, ErrorCatcher, $q, enabledFeature) {
                if (enabledFeature) {
                    return ContractDraft.get({ create: true }).$promise.catch(function (error) {
                        ErrorCatcher.catchError(error);
                        return $q.reject(error);
                    });
                }
                return $q.reject();
            }],
            landscapeQuestions: ["$q", "LandscapeQuestions", "ErrorCatcher", "contractDraft", "enabledFeature", function landscapeQuestions($q, LandscapeQuestions, ErrorCatcher, contractDraft, enabledFeature) {
                if (enabledFeature) {
                    return LandscapeQuestions.search({
                        category: 'c-est-parti',
                        id_contract: contractDraft.id,
                        draft: true
                    }).$promise.catch(function (error) {
                        ErrorCatcher.catchError(error);
                        return $q.reject(error);
                    });
                }
                return $q.reject();
            }],
            tariffOptions: ["$q", "ReferencesService", "ErrorCatcher", "enabledFeature", function tariffOptions($q, ReferencesService, ErrorCatcher, enabledFeature) {
                if (enabledFeature) {
                    return ReferencesService.getRefPromise('ot-ps').catch(function (error) {
                        ErrorCatcher.catchError(error);
                        return $q.reject(error);
                    });
                }
                return $q.reject();
            }]
        }
    }).state('callbackSlimpay', {
        parent: 'home',
        url: '/retour-slimpay?order_reference',
        resolve: {
            defaultRedirect: ["$q", "$state", "$stateParams", "AnonPayment", "ErrorCatcher", "Tokens", function defaultRedirect($q, $state, $stateParams, AnonPayment, ErrorCatcher, Tokens) {
                var deferred = $q.defer();
                AnonPayment.getOrderReference({ order_reference: $stateParams.order_reference }).$promise.then(function (orderReference) {
                    if (orderReference.bulk_purchase === 'ufc') {
                        if (orderReference.checkout_method === 'VENDOR') {
                            $state.go('vendorSignatureConfirmation', {
                                order_reference: $stateParams.order_reference,
                                transactionId: $stateParams.order_reference,
                                transactionStatus: orderReference.success ? 'success' : 'failure'
                            });
                        } else {
                            Tokens.getSignupToken({ token: localStorage.bulkPurchaseSubscriptionToken }, {}).$promise.then(function (tokenResponse) {
                                $state.go('confirm', {
                                    token: tokenResponse.token,
                                    transactionId: $stateParams.order_reference,
                                    transactionStatus: orderReference.success ? 'success' : 'failure',
                                    bulk_purchase: orderReference.bulk_purchase
                                });
                            }).catch(function (error) {
                                if (error.status === 409) {
                                    $state.go('login', {
                                        order_reference: $stateParams.order_reference,
                                        transactionId: $stateParams.order_reference,
                                        transactionStatus: orderReference.success ? 'success' : 'failure',
                                        bulk_purchase: orderReference.bulk_purchase
                                    });
                                }
                                return ErrorCatcher.catchErrorWithoutRedirect(error);
                            });
                        }
                    } else if (orderReference.type === 'MANDATE') {
                        $state.go('endSubscription', {
                            order_reference: $stateParams.order_reference,
                            transactionId: $stateParams.order_reference,
                            transactionStatus: orderReference.success ? 'success' : 'failure',
                            bulk_purchase: orderReference.bulk_purchase
                        });
                    } else if (orderReference.type === 'MANDATE_RESIGNATURE') {
                        $state.go('mandateConfirmation', {
                            order_reference: $stateParams.order_reference,
                            transactionId: $stateParams.order_reference,
                            transactionStatus: orderReference.success ? 'success' : 'failure',
                            bulk_purchase: orderReference.bulk_purchase
                        });
                    } else {
                        $state.go('paymentConfirmation', {
                            order_reference: $stateParams.order_reference,
                            transactionId: $stateParams.order_reference,
                            transactionStatus: orderReference.success ? 'success' : 'failure',
                            bulk_purchase: orderReference.bulk_purchase
                        });
                    }

                    deferred.reject();
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    $state.go('paymentConfirmation', { order_reference: $stateParams.order_reference, error: error, bulk_purchase: localStorage.bulkPurchaseSubscriptionToken ? 'ufc' : '' });
                    deferred.reject();
                });
                return deferred.promise;
            }]
        }
    }).state('endSubscription', {
        parent: 'home',
        url: '/confirmation-souscription?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference',
        template: __webpack_require__(704)(),
        controller: 'endSubscriptionCtrl',
        resolve: {
            contractDraft: ["$q", "ContractDraft", "ErrorCatcher", function contractDraft($q, ContractDraft, ErrorCatcher) {
                var getContractDraftPromise = void 0;
                if (localStorage.subscriptionToken) {
                    getContractDraftPromise = ContractDraft.getByToken({ create: false, silent: true, token: localStorage.subscriptionToken }).$promise;
                } else {
                    getContractDraftPromise = ContractDraft.get({ create: false, silent: true }).$promise;
                }
                return getContractDraftPromise.catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.reject(error);
                });
            }],
            isDepositNeeded: ["$q", "$state", "$stateParams", "Contract", "User", "ErrorCatcher", function isDepositNeeded($q, $state, $stateParams, Contract, User, ErrorCatcher) {
                var transactionContractId = (0, _get3.default)($stateParams, 'transactionId', (0, _get3.default)($stateParams, 'order_reference', '')).split('-')[0];
                var isDepositNeededPromise = void 0;
                if (localStorage.subscriptionToken) {
                    isDepositNeededPromise = Contract.isDepositNeededByToken({ token: localStorage.subscriptionToken }).$promise;
                } else if (!(0, _isEmpty3.default)(transactionContractId)) {
                    isDepositNeededPromise = Contract.isDepositNeeded({ id: transactionContractId }).$promise;
                } else {
                    // unknown transactionContractId, will check first contract in endSubscription
                    isDepositNeededPromise = $q.resolve({ depositNeeded: false });
                }
                return isDepositNeededPromise.then(function (isDepositResult) {
                    if (isDepositResult.depositNeeded) {
                        if (localStorage.subscriptionToken) {
                            $state.go('securityDepositAnonymous', { tokenId: localStorage.subscriptionToken, contractId: transactionContractId });
                        } else {
                            $state.go('securityDepositAuthenticated', { contractId: transactionContractId });
                        }
                        return $q.reject();
                    }
                    return $q.resolve({ contractId: transactionContractId, depositNeeded: isDepositResult.depositNeeded });
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.reject(error);
                });
            }],
            isSlimpaySuccess: ["$q", "$state", "$stateParams", "contractDraft", function isSlimpaySuccess($q, $state, $stateParams, contractDraft) {
                var transactionContractId = (0, _get3.default)($stateParams, 'transactionId', (0, _get3.default)($stateParams, 'order_reference', '')).split('-')[0];
                if ($stateParams.transactionStatus === 'failure' || contractDraft.id === transactionContractId && contractDraft.ready_to_checkout) {
                    $state.go('endSubscriptionSlimpayFailure', $stateParams);
                    return $q.reject();
                }
                return $q.resolve();
            }],
            shouldRedirectToLoginPage: ["$q", "$state", "$stateParams", "User", "ErrorCatcher", "isDepositNeeded", "isSlimpaySuccess", function shouldRedirectToLoginPage($q, $state, $stateParams, User, ErrorCatcher, isDepositNeeded, isSlimpaySuccess) {
                if (localStorage.subscriptionToken) {
                    return User.getInfoByToken({ token: localStorage.subscriptionToken }).$promise.then(function (userInfo) {
                        if (userInfo.active) {
                            $state.go('login', (0, _assign3.default)({}, $stateParams, { redirectTo: 'endSubscription' }));
                            return $q.reject();
                        }
                        $state.go('confirm', (0, _assign3.default)({}, $stateParams, { token: localStorage.subscriptionToken, redirectTo: 'endSubscription' }));
                        return $q.reject();
                    }).catch(function (error) {
                        ErrorCatcher.catchError(error);
                        return $q.reject(error);
                    });
                }
            }],
            userInfo: ["$q", "ApiService", "ErrorCatcher", "shouldRedirectToLoginPage", function userInfo($q, ApiService, ErrorCatcher, shouldRedirectToLoginPage /* required to be executed before userInfo */) {
                return ApiService.fetchUserInfo().catch(function (error) {
                    ErrorCatcher.catchError(error);
                    return $q.reject(error);
                });
            }]
        },
        data: {
            pageTitle: 'Souscription'
        }
    }).state('endSubscriptionSlimpayFailure', {
        parent: 'home',
        url: '/erreur-souscription?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference',
        template: __webpack_require__(705)(),
        controller: 'endSubscriptionSlimpayErrorCtrl'
    }).state('mandateConfirmation', {
        parent: 'home',
        url: '/confirmation-mandat?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference&cardOperationResult',
        template: '<mandate-confirmation transaction="$ctrl.transaction"></mandate-confirmation>',
        controllerAs: '$ctrl',
        controller: ["$stateParams", function controller($stateParams) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            var ctrl = this;
            ctrl.transaction = {
                transactionStatus: $stateParams.transactionStatus,
                transactionErrorCode: $stateParams.transactionErrorCode,
                signatureOperationResult: $stateParams.signatureOperationResult,
                transactionId: $stateParams.transactionId,
                order_reference: $stateParams.order_reference,
                cardOperationResult: $stateParams.cardOperationResult
            };
        }]
    }).state('vendorSignatureConfirmation', {
        parent: 'home',
        url: '/confirmation-signature-vendor?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference&cardOperationResult',
        template: '<vendor-signature-confirmation transaction="$ctrl.transaction"></vendor-signature-confirmation>',
        controllerAs: '$ctrl',
        controller: ["$stateParams", function controller($stateParams) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            var ctrl = this;
            ctrl.transaction = {
                transactionStatus: $stateParams.transactionStatus,
                transactionErrorCode: $stateParams.transactionErrorCode,
                signatureOperationResult: $stateParams.signatureOperationResult,
                transactionId: $stateParams.transactionId,
                order_reference: $stateParams.order_reference,
                cardOperationResult: $stateParams.cardOperationResult
            };
        }]
    }).state('paymentConfirmation', {
        parent: 'home',
        url: '/confirmation-paiement?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference&cardOperationResult',
        template: '<payment-confirmation transaction="$ctrl.transaction"></payment-confirmation>',
        controllerAs: '$ctrl',
        controller: ["$stateParams", "transaction", function controller($stateParams, transaction) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            var ctrl = this;
            ctrl.transaction = (0, _assign3.default)({}, transaction, {
                transactionStatus: $stateParams.transactionStatus,
                transactionErrorCode: $stateParams.transactionErrorCode,
                signatureOperationResult: $stateParams.signatureOperationResult,
                transactionId: $stateParams.transactionId,
                order_reference: $stateParams.order_reference,
                cardOperationResult: $stateParams.cardOperationResult
            });
        }],

        resolve: {
            transaction: ["$q", "$stateParams", "ErrorCatcher", "AnonPayment", "DataAccessVariables", "PermPermissionStore", function transaction($q, $stateParams, ErrorCatcher, AnonPayment, DataAccessVariables, PermPermissionStore) {
                if ((0, _isEmpty3.default)($stateParams.transactionId)) {
                    return $q.resolve({});
                }
                var transactionResult = {
                    transactionStatus: $stateParams.transactionStatus,
                    transactionId: (0, _defaultTo3.default)($stateParams.transactionId, $stateParams.order_reference)
                };
                if ($stateParams.transactionId.split('_')[0] === 'DEPOSIT') {
                    return DataAccessVariables.get({ variables: 'DEPOSIT_AMOUNT' }).$promise.then(function (response) {
                        return (0, _assign3.default)({}, transactionResult, { payment: { amount: response.DEPOSIT_AMOUNT } });
                    }).catch(function (error) {
                        ErrorCatcher.catchError(error);
                        return transactionResult;
                    });
                }
                return PermPermissionStore.getStore().client.validatePermission().then(function () {
                    return AnonPayment.getOrderReference({ order_reference: $stateParams.order_reference }).$promise.catch(function (error) {
                        ErrorCatcher.catchError(error);
                        return $q.reject(error);
                    });
                }).catch(function () {
                    return transactionResult;
                });
            }]
        }
    }).state('templateInfo', {
        url: '/template/info',
        template: '<template-info></template-info>',
        resolve: {
            isEnabled: ["$q", "$window", function isEnabled($q, $window) {
                if ($window.location.host.indexOf('local') > -1 || $window.location.host.indexOf('int') > -1) {
                    return $q.resolve();
                }
                return $q.reject();
            }]
        }
    });

    $urlRouterProvider.otherwise('/');

    $locationProvider.html5Mode(true).hashPrefix('!');

    // Should set to true but need to apply catch on every promise
    return $qProvider.errorOnUnhandledRejections(false);
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"alerts\"\u003E\u003Cuib-alert ng-repeat=\"alert in alerts\" type=\"{{alert.type}}\" dismiss-on-timeout=\"{{alert.timeout || 3000}}\" close=\"closeAlert($index)\"\u003E{{alert.msg}}\u003C\u002Fuib-alert\u003E\u003C\u002Fdiv\u003E\u003Ccookies-bar\u003E\u003C\u002Fcookies-bar\u003E\u003Cbutton class=\"btn background-waterblue\" id=\"newSCv2\" ng-click=\"openSelfcareV2()\"\u003EAller vers mon espace client\u003C\u002Fbutton\u003E\u003Cui-view\u003E\u003C\u002Fui-view\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 677 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"landing\"\u003E\u003Cdiv class=\"fixed-header-wrapper\"\u003E\u003Cdiv class=\"fixed-header-parent\"\u003E\u003Cdiv class=\"fixed-header-child\"\u003E\u003Cnav class=\"navbar navbar-landing-header navbar-white navbar-white-background visible-xs-block\"\u003E\u003Cdiv class=\"navbar-header\"\u003E\u003Ca class=\"navbar-brand\" ui-sref=\"landing\"\u003E\u003Cimg class=\"navbar-opacity\" alt=\"Plüm Energie\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Flogo.svg\"\u003E\u003C\u002Fa\u003E\u003Cbutton class=\"navbar-toggle\" type=\"button\" ng-click=\"toogleNavCollapsed()\"\u003E\u003Cspan class=\"sr-only\"\u003EMenu\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse\" uib-collapse=\"navCollapsed\"\u003E\u003Cul class=\"nav navbar-nav navbar-right\"\u003E\u003Cli\u003E\u003Ca ng-click=\"openContactModal()\"\u003ENous contacter\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Ca class=\"marine\" ng-click=\"gaEventsService.newEvent('click - La communauté')\" ui-sref=\"community\"\u003ELa communauté\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Ca ng-click=\"gaEventsService.newEvent('click - Logout')\" ui-sref=\"logout\"\u003EMe deconnecter\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Ca ng-click=\"gaEventsService.newEvent('click - Passez chez plum - Menu') &amp;&amp; openSubscriptionModal()\"\u003EPassez chez plüm !\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'anonymous'\"\u003E\u003Ca ng-click=\"gaEventsService.newEvent('click - Inscription')\" ui-sref=\"signup\"\u003EM'inscrire\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'anonymous'\"\u003E\u003Ca ng-click=\"gaEventsService.newEvent('click - Login')\" ui-sref=\"login\"\u003EMe connecter\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cnav class=\"navbar navbar-landing-header navbar-white navbar-white-background hidden-xs\"\u003E\u003Cdiv class=\"navbar-header\"\u003E\u003Ca class=\"navbar-brand\" ui-sref=\"landing\"\u003E\u003Cimg class=\"navbar-opacity\" alt=\"Plüm Energie\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Flogo.svg\"\u003E\u003C\u002Fa\u003E\u003Cbutton class=\"navbar-toggle\" type=\"button\" ng-click=\"toogleNavCollapsed()\"\u003E\u003Cspan class=\"sr-only\"\u003EMenu\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse\"\u003E\u003Cul class=\"nav navbar-nav navbar-right\"\u003E\u003Cli\u003E\u003Cbutton class=\"navbar-opacity btn btn-same-width background-light-pink outline round\" ng-click=\"openContactModal()\"\u003ENous contacter\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Cbutton class=\"navbar-opacity btn btn-same-width background-marine outline round\" ng-click=\"gaEventsService.newEvent('click - La communauté')\" ui-sref=\"community\"\u003ELa communauté\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-click=\"gaEventsService.newEvent('click - Logout')\" ui-sref=\"logout\"\u003EMe deconnecter\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-click=\"gaEventsService.newEvent('click - Passez chez plum - Menu') &amp;&amp; openSubscriptionModal()\"\u003EPassez chez plüm !\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'anonymous'\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-click=\"gaEventsService.newEvent('click - Inscription')\" ui-sref=\"signup\"\u003EM'inscrire\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'anonymous'\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-click=\"gaEventsService.newEvent('click - Login')\" ui-sref=\"login\"\u003EMe connecter\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cheader class=\"nav nav-landing stickBelow\"\u003E\u003Cdiv class=\"header-title visible-xs-block\"\u003E\u003Cimg alt=\"logo plum mobile\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Flogo.svg\"\u003E\u003Ch2\u003ELe fournisseur d’électricité\u003Cbr\u003E qui donne envie de changer\u003C\u002Fh2\u003E\u003Cbutton class=\"btn background-light-pink outline round\" scroll-to=\"section-1\" offset=\"72\"\u003EDécouvrir\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-title hidden-xs-block\"\u003E\u003Cimg alt=\"logo plum big\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Flogo.svg\"\u003E\u003Ch2\u003ELe fournisseur d’électricité\u003Cbr\u003E qui donne envie de changer\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Cdiv class=\"section\" id=\"section-1\" scroll-send-event=\"scroll 1 - vision conso\"\u003E\u003Cdiv class=\"section-top container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-5 col-sm-offset-1\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" alt=\"logo plum mobile\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Faccueil-oeil-mob.svg\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" alt=\"logo plum mobile\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Faccueil-oeil-dt.svg\"\u003E\u003Ch2\u003EUne vision plus claire de votre consommation d’électricité\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cimg class=\"ordi\" alt=\"Suivi conso\" animated-on-visible=\"enterRight\" src=\"\u002Fassets\u002Fimg\u002Fordi-suiviconso.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-bottom\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section\" id=\"section-2\" scroll-send-event=\"scroll 2 - cagnotte\"\u003E\u003Cdiv class=\"section-top container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-5 col-sm-offset-1\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" alt=\"logo plum mobile\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Faccueil-cagnotte-mob.svg\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" alt=\"logo plum mobile\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Faccueil-cagnotte-dt.svg\"\u003E\u003Ch2\u003ERegardez votre cagnotte grandir mois après mois\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cimg class=\"ordi\" alt=\"Cagnotte\" animated-on-visible=\"enterRight\" src=\"\u002Fassets\u002Fimg\u002Fordi-cagnotte.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-bottom\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section\" id=\"section-3\" scroll-send-event=\"scroll 3 - conseils\"\u003E\u003Cdiv class=\"section-top container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-5 col-sm-offset-1\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" alt=\"logo plum mobile\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Faccueil-ampoule-mob.svg\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" alt=\"logo plum mobile\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Faccueil-ampoule-dt.svg\"\u003E\u003Ch2\u003EParcourez les conseils pour faire encore mieux le mois prochain\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cimg class=\"ordi\" alt=\"Conseils\" animated-on-visible=\"enterRight\" src=\"\u002Fassets\u002Fimg\u002Fordi-conseils.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-bottom\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail\" id=\"detail-1\" scroll-send-event=\"scroll 4 - benefice\"\u003E\u003Cdiv class=\"detail-title\"\u003E\u003Ch2\u003ERejoignez ceux qui consomment\u003Cbr\u003E leur électricité plus intelligemment\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail-info\"\u003E\u003Cdiv class=\"block container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"block-icon col-lg-2 col-lg-offset-2 col-md-3 col-md-offset-2 col-sm-4 col-sm-offset-1 col-xs-12\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Fsmart-cagnotte-mob.svg\" alt=\"rapide\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fsmart-cagnotte-dt.svg\" alt=\"rapide\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-6 col-md-5 col-sm-6 col-xs-12\"\u003E\u003Ch3 class=\"light\"\u003ERÉCOMPENSE\u003C\u002Fh3\u003E\u003Cp\u003ENous sommes les seuls à récompenser en euros vos économies d’électricité ! Chaque mois, vous découvrez\nle montant de votre cagnotte en relevant votre compteur. De quoi alléger encore plus vos factures.\u003C\u002Fp\u003E\u003Ca class=\"popup\" ng-click=\"openFonctionnementCagnotteModal()\"\u003Evoir le fonctionnement de la cagnotte Plüm\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"block-icon col-lg-2 col-lg-offset-2 col-md-3 col-md-offset-2 col-sm-4 col-sm-offset-1 col-xs-12\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Fsmart-terre-mob.svg\" alt=\"libre\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fsmart-terre-dt.svg\" alt=\"libre\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-6 col-md-5 col-sm-6 col-xs-12\"\u003E\u003Ch3 class=\"light\"\u003EÉLECTRICITÉ VERTE\u003C\u002Fh3\u003E\u003Cp\u003ENotre électricité est garantie 100% renouvelable ! Et avec l'énergie que vous économisez,\nvous vous engagez pleinement en faveur du développement durable.\u003C\u002Fp\u003E\u003Ca class=\"popup\" ng-click=\"openTransitionEnergetiqueModal()\"\u003Een savoir plus sur la transition énergétique\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"block-icon col-lg-2 col-lg-offset-2 col-md-3 col-md-offset-2 col-sm-4 col-sm-offset-1 col-xs-12\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Fsmart-price-cut-mob.svg\" alt=\"sûr\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fsmart-price-cut-dt.svg\" alt=\"sûr\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-6 col-md-5 col-sm-6 col-xs-12\"\u003E\u003Ch3 class=\"light\"\u003EMOINS CHER\u003C\u002Fh3\u003E\u003Cp\u003EEt quelle que soit votre consommation, ça vous coûtera toujours moins cher que les tarifs réglementés.\u003C\u002Fp\u003E\u003Ca class=\"popup\" ng-click=\"openPriceModal()\"\u003Evoir nos tarifs\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink round\" ng-click=\"gaEventsService.newEvent('click - Devis - Home 1') &amp;&amp; openQuotation()\"\u003ECalculer mon devis !\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail\" id=\"detail-2\" scroll-send-event=\"scroll 4.5 - electricite verte\"\u003E\u003Cdiv class=\"detail-title\"\u003E\u003Ch2\u003EEn 2018, Plüm turbine au\u003Cbr\u003Erenouvelable Made in France !\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail-info\"\u003E\u003Cdiv class=\"block block-75\"\u003E\u003Cdiv class=\"flex-sm flex-space-between flex-align-items\"\u003E\u003Cdiv class=\"flex-6 padding-15\"\u003E\u003Cdiv\u003E\u003Ch3 class=\"light\"\u003ED’OÙ VIENT NOTRE ÉNERGIE ?\u003C\u002Fh3\u003E\u003Cp\u003EChaque euro dépensé par nos clients pour leur consommation d’électricité contribue\nà la filière renouvelable française. Cette garantie de traçabilité, nous l’achetons directement\nà des producteurs d’électricité de source hydraulique, situés sur le fil de la Seine.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch3 class=\"light\"\u003E100% HYDRO !\u003C\u002Fh3\u003E\u003Cp\u003EL’énergie hydraulique est produite par le courant qui agit sur des turbines. Celles-ci font fonctionner\nun alternateur qui produit de l’électricité.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch3 class=\"light\"\u003E100% LOCAL\u003C\u002Fh3\u003E\u003Cp\u003ENos producteurs sont situés sur le fil de la Seine. Côté ouest, près de Mantes-la-jolie (Méricourt),\nprès de Fontainebleau  (Thomery) et côté est, à proximité de la Bourgogne (Montereau-Fault-Yonne).\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch3 class=\"light\"\u003E100% PROPRE\u003C\u002Fh3\u003E\u003Cp\u003EL’électricité hydraulique est une source d’énergie dont la construction et l’utilisation ne rejettent\nni CO2 ni déchets polluants. Elle ne fait qu’utiliser la force de l’eau qui coule.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-6 text-right\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fbarrage.jpg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block\"\u003E\u003Cbutton class=\"btn btn-same-width background-marine round\" ng-click=\"gaEventsService.newEvent('click - Passez chez plum - Home 2') &amp;&amp; openSubscriptionModal()\"\u003EPassez chez Plüm !\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail\" id=\"detail-3\" scroll-send-event=\"scroll 5 - changer de fournisseur\"\u003E\u003Cdiv class=\"detail-title\"\u003E\u003Ch2\u003EChanger de fournisseur\u003Cbr\u003E en 1 clic, c’est possible ?\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail-info\"\u003E\u003Cdiv class=\"block container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"block-icon col-lg-2 col-lg-offset-2 col-md-3 col-md-offset-2 col-sm-4 col-sm-offset-1 col-xs-12\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Feasy-chrono-mob.svg\" alt=\"rapide\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Feasy-chrono-dt.svg\" alt=\"rapide\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-6 col-md-5 col-sm-6 col-xs-12\"\u003E\u003Ch3 class=\"light\"\u003ERAPIDE\u003C\u002Fh3\u003E\u003Cp\u003ETout ce qu’il vous faut, c’est l’identifiant de votre compteur et un RIB.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"block-icon col-lg-2 col-lg-offset-2 col-md-3 col-md-offset-2 col-sm-4 col-sm-offset-1 col-xs-12\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Feasy-bouclier-mob.svg\" alt=\"sûr\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Feasy-bouclier-dt.svg\" alt=\"sûr\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-6 col-md-5 col-sm-6 col-xs-12\"\u003E\u003Ch3 class=\"light\"\u003ETOTALEMENT SÛR\u003C\u002Fh3\u003E\u003Cp\u003EComme pour tous les Français, c’est le service public Enedis qui vous assure un service sans coupure.\nLes techniciens sont joignables 24h\u002F24, 7j\u002F7.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"block-icon col-lg-2 col-lg-offset-2 col-md-3 col-md-offset-2 col-sm-4 col-sm-offset-1 col-xs-12\"\u003E\u003Cimg class=\"vector-icon visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Feasy-statue-mob.svg\" alt=\"libre\"\u003E\u003Cimg class=\"vector-icon hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Feasy-statue-dt.svg\" alt=\"libre\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-6 col-md-5 col-sm-6 col-xs-12\"\u003E\u003Ch3 class=\"light\"\u003ESANS FRAIS, SANS ENGAGEMENT\u003C\u002Fh3\u003E\u003Cp\u003EOn ne vous facturera jamais de frais, même si vous décidez de retourner chez votre ancien fournisseur le lendemain.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block\"\u003E\u003Cbutton class=\"btn btn-same-width background-marine round\" ng-click=\"gaEventsService.newEvent('click - Passez chez plum - Home 2') &amp;&amp; openSubscriptionModal()\"\u003EPassez chez Plüm !\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cfooter class=\"text-center\" id=\"landing-footer\"\u003E\u003Cdiv class=\"action\"\u003E\u003Ca class=\"btn btn-same-width background-light-pink outline round\" ng-click=\"gaEventsService.newEvent('click - FAQ')\" href=\"https:\u002F\u002Fassistance.plum.fr\" target=\"_self\"\u003EFAQ\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"legal\"\u003E\u003Ca ng-click=\"gaEventsService.newEvent('click - Mentions Légales')\" ui-sref=\"terms\"\u003EMentions&nbsp;légales&nbsp;du&nbsp;site\u003C\u002Fa\u003E&nbsp; - &nbsp;\u003Ca ng-click=\"gaEventsService.newEvent('click - CGV')\" href=\"\u002Fdocumentation\u002Fcgv.pdf\" target=\"blank\"\u003EConditions&nbsp;générales&nbsp;de&nbsp;vente\u003C\u002Fa\u003E&nbsp; - &nbsp;\u003Ca ng-click=\"openPriceModal()\"\u003EVoir&nbsp;nos&nbsp;tarifs\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffooter\u003E\u003Cimg class=\"scroller-to-icon vector-icon\" scroll-to-next=\"#section-1 #section-2 #section-3 #detail-1 #detail-2 #detail-3 #landing-footer\" ng-if=\"isMobile()\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fmobile\u002Fflche-1.svg\"\u003E\u003Cimg class=\"scroller-to-icon vector-icon\" scroll-to-next=\"#section-1 #section-2 #section-3 #detail-1 #detail-2 #detail-3 #landing-footer\" ng-if=\"!isMobile()\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fflche-1.svg\"\u003E\u003Cdiv class=\"popins\"\u003E\u003Cpopin ng-if=\"specialOffer.isSponsor\" display-delay=\"500\" fold-delay=\"3500\"\u003E\u003Ch3\u003ECode parrainage saisi\u003C\u002Fh3\u003E\u003Cp\u003EVotre code parrainage  a bien été pris en compte, inscrivez vous pour en bénéficier.\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-click=\"gaEventsService.newEvent('click - Passez chez plum - Popin - Parrainage') &amp;&amp; openSubscriptionModal()\"\u003EPassez chez plüm !\u003C\u002Fbutton\u003E\u003C\u002Fpopin\u003E\u003Cpopin ng-if=\"specialOffer.isPromo\" display-delay=\"500\" fold-delay=\"3500\"\u003E\u003Ch3\u003ECode promo saisi\u003C\u002Fh3\u003E\u003Cp\u003EVotre code promo a bien été pris en compte, inscrivez vous pour en bénéficier.\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-click=\"gaEventsService.newEvent('click - Passez chez plum - Popin - Promo') &amp;&amp; openSubscriptionModal()\"\u003EPassez chez plüm !\u003C\u002Fbutton\u003E\u003C\u002Fpopin\u003E\u003Cpopin permission permission-only=\"'user'\" display-delay=\"500\"\u003E\u003Ch3\u003ENouveau client\u003C\u002Fh3\u003E\u003Cp\u003EBienvenue, vous êtes bien inscrit sur le site.\u003C\u002Fp\u003E\u003Cp\u003EContinuer votre souscription en passant chez Plüm énergie ou continuer à voir nos offres sur la page d'accueil.\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-click=\"gaEventsService.newEvent('click - Passez chez plum - Popin - Nouveau client') &amp;&amp; openSubscriptionModal()\"\u003EPassez chez plüm !\u003C\u002Fbutton\u003E\u003C\u002Fpopin\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cnewsletter-modal ng-if=\"$root.dataFeature['newsletterModal']\"\u003E\u003C\u002Fnewsletter-modal\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"container text-center\"\u003E\u003Cdiv class=\"offer-bloc\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-8 col-md-offset-2\"\u003E\u003Ch1 class=\"light darkish-pink\"\u003EComment êtes-vous équipé ?\u003C\u002Fh1\u003E\u003Cp class=\"margin-top-20\"\u003ESuivant le compteur installé chez vous, le principe de notre offre reste le même, mais le mode\nde fonctionnement change.\u003Cbr\u003EDepuis 2015, Enedis déploie les nouveaux compteurs Linky.\u003Cbr\u003E\nIls seront installés (sans frais) sur l’ensemble du territoire d’ici 2021.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-4 col-md-offset-1 meter-bloc background-white\" ui-sref=\"myMeter.linky\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcompteur_linky.png\"\u003E\u003Cdiv class=\"btn background-light-pink\"\u003EJ'ai un compteur Linky\u003C\u002Fdiv\u003E\u003Cp class=\"darkish-pink\"\u003EC'est simple, il est vert fluo.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4 col-md-offset-2 meter-bloc background-white\" ui-sref=\"myMeter.classique\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcompteur_classique.png\"\u003E\u003Cdiv class=\"btn background-light-pink\"\u003EJ'ai un compteur classique\u003C\u002Fdiv\u003E\u003Cp class=\"darkish-pink\"\u003EIl peut être gris, bleu, blanc ou noir.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-bottom-150\"\u003E\u003Cdiv class=\"col-md-12 text-center margin-top-40\"\u003E\u003Ca ng-click=\"openLinkyModal()\"\u003E\u003Ci class=\"fa fa-info-circle fa-fw waterblue large-icon\"\u003E\u003C\u002Fi\u003EPlus d'infos sur le nouveau compteur Linky d'Enedis ?\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12 text-center margin-top-40\"\u003E\u003Ca ng-click=\"openLinkyModal()\"\u003E\u003Ci class=\"fa fa-info-circle fa-fw waterblue large-icon\"\u003E\u003C\u002Fi\u003EPlus d'infos sur le nouveau compteur Linky d'Enedis ?\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12 text-center margin-top-60\"\u003E\u003Ca class=\"btn tab-left\" ng-class=\"{'tab-active': isActive('myMeter.linky')}\" ui-sref=\"myMeter.linky\"\u003EJ'ai un compteur Linky\u003C\u002Fa\u003E\u003Ca class=\"btn tab-right\" ng-class=\"{'tab-active': isActive('myMeter.classique')}\" ui-sref=\"myMeter.classique\"\u003EJ'ai un compteur classique\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"background-white offer-bloc text-center\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cui-view\u003E\u003C\u002Fui-view\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Ch1 class=\"light darkish-pink\"\u003EComment fonctionne Plüm énergie avec un compteur Linky ?\u003C\u002Fh1\u003E\u003Cp class=\"margin-top-20\"\u003EAvec Linky, c’est plus simple. Tous les mois, les compteurs envoient automatiquement le relevé\nde votre consommation. Plus la peine d’attendre 6 mois le passage d’un technicien pour la relève !\nPour plus de simplicité, notamment pour ceux de nos clients qui vont vivre le passage d’un compteur\nclassique à un compteur Linky, la cadence de 6 mois entre deux factures est conservée.\nPour savoir comment se déroule un semestre chez Plüm énergie, suivez le fil !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-10 col-xs-offset-1 background-flow margin-top-100\"\u003E\u003Cimg class=\"offer-flow-img\" src=\"\u002Fassets\u002Fimg\u002Ftitre-au-commencement.png\" alt=\"Au commencement du semestre\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 offer-flow-bloc margin-top-60\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fidea.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Nous estimons ensemble votre consommation\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EAu début de chaque semestre, nous commençons par estimer votre consommation à venir pour chacun\ndes 6 prochains mois, en nous basant sur toutes les informations dont nous disposons.\u003Cbr\u003E\nDe cette estimation découlent vos mensualités : nous prélevons donc chaque mois un montant en\neuros correspondant à votre consommation estimée (au tarif réglementé par l’État).\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"offer-flow-img margin-top-170\" src=\"\u002Fassets\u002Fimg\u002Ftitre-mois-semestre.png\" alt=\"Tous les mois durant le semestre\"\u003E\u003Cdiv class=\"row margin-top-130\"\u003E\u003Cdiv class=\"col-md-5 offer-flow-bloc\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fhouse-heart.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Fabriquez vos économies\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EÀ vous de jouer ! Grâce à votre suivi conso, aux conseils Plüm et à l’expertise de la communauté Plüm,\ncommencez les économies !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-5 col-md-offset-2 offer-flow-bloc margin-top-130\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcloud.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Nous affinons notre estimation en fonction de la météo\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EPour que vos économies soient calculées au plus juste, nous prenons en compte les données météo de chaque mois passé.\u003Cbr\u003E\nEn effet, s’il fait plus froid l’hiver, vous consommerez probablement plus d’électricité. Si l’hiver est rigoureux\nl’estimation est revue à la hausse ; si l’hiver est doux, elle est corrigée à la baisse. Cet ajustement est d’autant plus\nimportant que votre logement est sensible au froid (par exemple s’il est peu isolé et que votre chauffage est électrique).\n\u003Cbr\u003EAinsi corrigée des aléas du climat, cette estimation sert de base de comparaison pour calculer votre bonus.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-top-130-md-60\"\u003E\u003Cdiv class=\"col-md-5 offer-flow-bloc\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fpiggy-bank.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Nous créditons votre cagnotte\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EPour chaque mois où votre consommation réelle est inférieure à notre estimation, vous gagnez un bonus : nous\ncréditons la différence dans votre cagnotte. Les économies que vous avez fabriquées sont ainsi doublées !\n\u003Cbr\u003EPour les mois où votre consommation réelle est supérieure à notre estimation, il n’y a aucun malus.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-5 col-md-offset-2 offer-flow-bloc margin-top-130\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fheart.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Il y a une limite mais elle s'explique\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003ENotre bonus d’encouragement est limité, pour chaque mois, à 15% de votre consommation. L’explication est simple,\nau-delà de ces 15%, nous vendrions à perte. Mais si vous réussissez, avec notre aide, à réduire très fortement votre\nconsommation, vous êtes toujours gagnants ! Cette importante baisse se retrouvera directement sur votre facture et\nl’on viendra y ajouter le bonus max. de 15%.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-top-130-md-60\"\u003E\u003Cdiv class=\"col-md-5 offer-flow-bloc\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fpower-red.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Utilisez votre cagnotte\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EUne fois créditée, votre cagnotte peut être utilisée à tout moment et en un clic, pour réduire l’une de vos prochaines mensualités.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"offer-flow-img margin-top-100\" src=\"\u002Fassets\u002Fimg\u002Ftitre-fin-semestre.png\" alt=\"A la fin de chaque semestre\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 offer-flow-bloc margin-top-150\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fbill.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Voici votre facture\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EÀ la fin de chaque semestre, nous éditons votre facture. Si vous avez consommé plus que ce que nous avions estimé,\nc’est à ce moment que nous régularisons.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"offer-flow-img margin-top-80 background-white\" src=\"\u002Fassets\u002Fimg\u002Fplug.png\" alt=\"Prise électrique\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-bottom-150\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Et c'est reparti pour un tour !\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EUne fois le semestre terminé, nous réalisons une nouvelle estimation, qui sera d’autant plus fine\nque nous commencerons à mieux vous connaître, et tout recommence comme au semestre précédent.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Ch1 class=\"light darkish-pink\"\u003EComment fonctionne Plüm énergie avec un compteur classique ?\u003C\u002Fh1\u003E\u003Cp class=\"margin-top-20\"\u003EChez Plüm énergie, tout est cadencé par semestre, lorsque l’agent du service public de l’électricité\n(Enedis) passe dans votre foyer pour relever votre compteur. C’est à ce moment do nous disposons\nde l’information nécessaire pour faire le bilan, puis recommencer. Pour savoir comment se déroule un\nsemestre chez Plüm énergie, suivez le fil !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-10 col-xs-offset-1 background-flow margin-top-100\"\u003E\u003Cimg class=\"offer-flow-img\" src=\"\u002Fassets\u002Fimg\u002Ftitre-au-commencement.png\" alt=\"Au commencement du semestre\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 offer-flow-bloc margin-top-60\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fidea.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Nous estimons ensemble votre consommation\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EAu début de chaque semestre, nous commençons par estimer votre consommation à venir pour chacun\ndes 6 prochains mois, en nous basant sur toutes les informations dont nous disposons.\u003Cbr\u003E\nDe cette estimation découlent vos mensualités : nous prélevons donc chaque mois un montant en\neuros correspondant à votre consommation estimée (au tarif réglementé par l’État).\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"offer-flow-img margin-top-170\" src=\"\u002Fassets\u002Fimg\u002Ftitre-mois-semestre.png\" alt=\"Tous les mois durant le semestre\"\u003E\u003Cdiv class=\"row margin-top-130\"\u003E\u003Cdiv class=\"col-md-5 offer-flow-bloc\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fhouse-heart.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Fabriquez vos économies\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EÀ vous de jouer ! Grâce à votre suivi conso, aux conseils Plüm et à l’expertise de la communauté Plüm,\ncommencez les économies !\u003Cbr\u003EPour pouvoir suivre vos économies, nous permettre d’estimer vos gains et\nl’avancée de votre cagnotte, c’est facile : relevez vous-même chaque fin de mois votre compteur et\nindiquez simplement son état dans votre espace client Plüm.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-5 col-md-offset-2 offer-flow-bloc margin-top-130\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcloud.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Nous affinons notre estimation en fonction de la météo\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EPour que vos économies soient calculées au plus juste, nous prenons en compte les données météo de chaque mois passé.\u003Cbr\u003E\nEn effet, s’il fait plus froid l’hiver, vous consommerez probablement plus d’électricité. Si l’hiver est rigoureux\nl’estimation est revue à la hausse ; si l’hiver est doux, elle est corrigée à la baisse. Cet ajustement est d’autant plus\nimportant que votre logement est sensible au froid (par exemple s’il est peu isolé et que votre chauffage est électrique).\n\u003Cbr\u003EAinsi corrigée des aléas du climat, cette estimation sert de base de comparaison pour calculer votre bonus.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 offer-flow-bloc margin-top-150\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fclock.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Un peu de patience ...\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EC’est à la fin du semestre que votre cagnotte sera définitivement créditée. Une fois la relève\neffectuée par le technicien Enedis, nous disposerons en effet de votre consommation réelle.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"offer-flow-img margin-top-100\" src=\"\u002Fassets\u002Fimg\u002Ftitre-fin-semestre.png\" alt=\"A la fin de chaque semestre\"\u003E\u003Cdiv class=\"row margin-top-130\"\u003E\u003Cdiv class=\"col-md-5 offer-flow-bloc\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fpiggy-bank.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Nous créditons votre cagnotte\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EPour chaque mois où votre consommation réelle est inférieure à notre estimation, vous gagnez un bonus : nous\ncréditons la différence dans votre cagnotte. Les économies que vous avez fabriquées sont ainsi doublées !\n\u003Cbr\u003EPour les mois où votre consommation réelle est supérieure à notre estimation, il n’y a aucun malus.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-5 col-md-offset-2 offer-flow-bloc margin-top-130\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fheart.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Il y a une limite mais elle s'explique\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003ENotre bonus d’encouragement est limité, pour chaque mois, à 15% de votre consommation. L’explication est simple,\nau-delà de ces 15%, nous vendrions à perte. Mais si vous réussissez, avec notre aide, à réduire très fortement votre\nconsommation, vous êtes toujours gagnants ! Cette importante baisse se retrouvera directement sur votre facture et\nl’on viendra y ajouter le bonus max. de 15%.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-top-130-md-60\"\u003E\u003Cdiv class=\"col-md-5 offer-flow-bloc\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fpower-red.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Utilisez votre cagnotte\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EUne fois créditée, votre cagnotte peut être utilisée à tout moment et en un clic, pour réduire l’une de vos prochaines mensualités.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-5 col-md-offset-2 offer-flow-bloc margin-top-130\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fbill.png\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Voici votre facture\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EÀ la fin de chaque semestre, nous éditons votre facture. Si vous avez consommé plus que\nce que nous avions estimé, c’est à ce moment que nous régularisons.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"offer-flow-img margin-top-80 background-white\" src=\"\u002Fassets\u002Fimg\u002Fplug.png\" alt=\"Prise électrique\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-bottom-150\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Ch5 class=\"darkish-pink\"\u003E{{ \"Et c'est reparti pour un tour !\" | uppercase }}\u003C\u002Fh5\u003E\u003Cp\u003EUne fois le semestre terminé, nous réalisons une nouvelle estimation, qui sera d’autant plus fine\nque nous commencerons à mieux vous connaître, et tout recommence comme au semestre précédent.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cnav class=\"navbar navbar-default\" ng-class=\"{'background-marine': fromCommunity}\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-2 col-sm-2 col-xs-6\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"desktop-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-7 col-sm-8 col-xs-6 text-right\"\u003E\u003Cdiv ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Ca class=\"btn btn-subscribe dark-pink background-white\" ui-sref=\"subscription\"\u003EJe souscris\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2 default-form\"\u003E\u003Cdiv class=\"form-header\"\u003E\u003Ch4\u003ESAISISSEZ VOS IDENTIFIANTS\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" ng-submit=\"login(user)\"\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"loginError\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp ng-if=\"loginError\"\u003EL'e-mail et le mot de passe saisis ne correspondent pas.\u003Cbr\u003EMot de passe oublié ?&nbsp;\u003Ca class=\"error-link\" ng-click=\"sendResetPassword(user)\"\u003E \u003Cspan\u003ECliquez ici\u003C\u002Fspan\u003E, nous vous enverrons un e-mail pour en définir un nouveau.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"sendResetPasswd\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp ng-if=\"sendResetPasswdSuccess\"\u003ESi un compte existe avec l'adresse {{user.username}}, nous y avons envoyé un e-mail qui vous permettra de redéfinir votre mot de passe.\u003C\u002Fp\u003E\u003Cp ng-if=\"incorrectEmail\"\u003EAdresse e-mail inconnue\u003C\u002Fp\u003E\u003Cp ng-if=\"unknownError\"\u003ENous n'avons pas pu traiter votre demande de réinitialisation de mot de passe. Veuillez renouveler l'opération.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EAdresse e-mail :\u003Cinput type=\"email\" name=\"email\" placeholder=\"votre@email.com\" ng-model=\"user.username\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EMot de passe :\u003Cinput type=\"password\" name=\"password\" placeholder=\"*****\" ng-model=\"user.password\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 form-footer\"\u003E\u003Ca class=\"side-text underlined\" ui-sref=\"forgotPassword({source: source, redirectTo: redirectTo})\"\u003EMot de passe oublié ?\u003C\u002Fa\u003E\u003Ca class=\"side-text underlined\" ui-sref=\"firstLogin({source: source, redirectTo: redirectTo})\"\u003E1ère connexion ?\u003C\u002Fa\u003E\u003Cdiv class=\"spinner-group\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': isLogin}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"isLogin\"\u003EMe connecter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cnav class=\"navbar navbar-default\" ng-class=\"{'background-marine': fromCommunity}\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-2 col-sm-2 col-xs-6\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"desktop-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-8 col-sm-9 col-xs-6 text-right\"\u003E\u003Cdiv ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Ca class=\"btn btn-login background-waterblue\" ng-click=\"gaEventsService.newEvent('click - Login')\" ui-sref=\"login({source: source, redirectTo: redirectTo})\"\u003EMe connecter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1 default-form\"\u003E\u003Cdiv class=\"form-header\"\u003E\u003Ch4\u003ECRÉEZ VOTRE COMPTE PLÜM ÉNERGIE !\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\" ng-if=\"signedUp\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cp\u003ENous venons de vous envoyer un e-mail à l'adresse&nbsp;\u003Cstrong\u003E{{ newUser.email }}.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EVérifiez bien votre boîte-aux-lettres et cliquez sur le lien qui se trouve dans notre message.\u003C\u002Fp\u003E\u003Cp\u003EVotre compte Plüm sera ainsi créé et vous pourrez poursuivre votre commande.\u003C\u002Fp\u003E\u003Cdiv class=\"text-right\"\u003E\u003Ca class=\"underlined side-text\" ng-click=\"newSignUp()\"\u003EJe n'ai pas reçu d'e-mail\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" name=\"signupForm.form1\" ng-if=\"!signedUp\" ng-submit=\"gaEventsService.newEvent('click - Inscription - Envoi Formulaire') &amp;&amp; signUp(newUser)\"\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"signupError.isError\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp ng-if=\"signupError.code === 'DUPLICATE_EMAIL'\"\u003EUne erreur s'est produite, l'email est déjà utilisé.\nVous pouvez vous connecter&nbsp;\u003Ca class=\"underlined side-text\" ui-sref=\"login({source: source, redirectTo: redirectTo})\"\u003Een cliquant ici\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp ng-if=\"signupError.code === 'SERVICE_MSG'\"\u003E\u003Cspan ng-bind=\"signupError.message\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp ng-if=\"signupError.code === 'DEFAULT_MSG'\"\u003EUne erreur inattendue s'est produite. Votre demande d'inscription n'a pas été prise en compte.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003ECivilité\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput id=\"civility-mme\" type=\"radio\" name=\"civility\" ng-model=\"newUser.civ\" value=\"Mme\" required\u003EMadame\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput id=\"civility-m\" type=\"radio\" name=\"civility\" ng-model=\"newUser.civ\" value=\"M.\" required\u003EMonsieur\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: signupForm.form1.$submitted &amp;&amp; signupForm.form1.givenName.$error.pattern}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\"signupForm.form1.$submitted &amp;&amp; signupForm.form1.givenName.$error.pattern\"\u003E\u003C\u002Fi\u003E\u003Cdiv\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Clabel\u003EPrénom\u003Cinput type=\"text\" name=\"givenName\" ng-model=\"newUser.givenName\" ng-pattern=\"nameRegex\" placeholder=\"Prénom\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 form-message\" ng-class=\"{formmessage: !isMobile(), formmessagemob: isMobile()}\"\u003E\u003Cp ng-if=\"signupForm.form1.$submitted &amp;&amp; signupForm.form1.givenName.$error.pattern\"\u003ELe prénom ne doit contenir que des lettres.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: signupForm.form1.$submitted &amp;&amp; signupForm.form1.sn.$error.pattern}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\"signupForm.form1.$submitted &amp;&amp; signupForm.form1.sn.$error.pattern\"\u003E\u003C\u002Fi\u003E\u003Cdiv\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Clabel\u003ENom de famille\u003Cinput class=\"force-uppercase\" type=\"text\" name=\"sn\" ng-model=\"newUser.sn\" ng-pattern=\"nameRegex\" placeholder=\"NOM\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 form-message\" ng-class=\"{formmessage: !isMobile(), formmessagemob: isMobile()}\"\u003E\u003Cp ng-if=\"signupForm.form1.$submitted &amp;&amp; signupForm.form1.sn.$error.pattern\"\u003ELe nom de famille ne doit contenir que des lettres.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EAdresse e-mail\u003Cinput type=\"email\" name=\"email\" ng-model=\"newUser.email\" placeholder=\"votre@email.com\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: signupForm.form1.$submitted &amp;&amp; signupForm.form1.phoneNumber.$error.pattern}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\"signupForm.form1.$submitted &amp;&amp; signupForm.form1.phoneNumber.$error.pattern\"\u003E\u003C\u002Fi\u003E\u003Cdiv\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Clabel\u003ETéléphone portable (facultatif)\u003Cinput type=\"tel\" name=\"phoneNumber\" ng-pattern=\"phoneRegex\" maxlength=\"13\" placeholder=\"06... 07... +336...\" ng-model=\"phoneNumber\" ng-change=\"updateMobilePhone(phoneNumber)\"\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 form-message\" ng-class=\"{formmessage: !isMobile(), formmessagemob: isMobile()}\"\u003E\u003Cp ng-if=\"signupForm.form1.$submitted &amp;&amp; signupForm.form1.phoneNumber.$error.pattern\"\u003ELe numéro de téléphone portable saisi semble invalide. Vérifier le numéro ou laisser le champs vide.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: signupForm.form1.$submitted &amp;&amp; signupForm.form1.recaptcha.$error.required}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\"signupForm.form1.$submitted &amp;&amp; signupForm.form1.recaptcha.$error.required\"\u003E\u003C\u002Fi\u003E\u003Cdiv\u003E\u003Cdiv class=\"col-xs-12 col-lg-6\" vc-recaptcha name=\"recaptcha\" required key=\"captcha.key\" size=\"isMobile() ? 'compact' : 'normal'\" ng-model=\"newUser.captcha\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-lg-6 form-message\" ng-class=\"{formmessage: !isMobile(), formmessagemob: isMobile()}\"\u003E\u003Cp ng-if=\"signupForm.form1.$submitted &amp;&amp; signupForm.form1.recaptcha.$error.required\"\u003ECette étape est conçue pour que nous nous assurions que c'est bien une personne\net non un ordinateur qui essaie de remplir le formulaire.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 form-footer\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': isSignup}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"isSignup\"\u003ECréer mon compte\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cnav class=\"navbar navbar-default\" ng-class=\"{'background-marine': fromCommunity}\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"navbar-header\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2 default-form\" ng-if=\"!hasUserInfo\"\u003E\u003Cdiv class=\"form-header\"\u003E\u003Ch4\u003ELIEN EXPIRÉ\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cp\u003ELe lien utilisé pour réinitialiser votre mot de passe à expiré.\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez regénérer un lien en cliquant sur le bouton ci-dessous.\u003C\u002Fp\u003E\u003Cdiv class=\"row margin-top-40\"\u003E\u003Cdiv class=\"col-sm-6 col-sm-offset-6\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"forgotPassword\"\u003ERéinitialiser mot de passe\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2 default-form\" ng-if=\"hasUserInfo\"\u003E\u003Cdiv class=\"form-header\"\u003E\u003Ch4\u003ECHOISISSEZ VOTRE MOT DE PASSE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body form-confirm\" name=\"confirmForm.form1\" ng-submit=\"setPassword(password, passwordCheck)\"\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"error.confirm\"\u003E\u003Ci class=\"fa fa-warning hidden-xs\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp\u003EUne erreur inattendue s'est produite. Votre mot de passe n'a pas pu être enregistré.\u003Cbr\u003EVous avez la possibilité de contacter le service client au\n\u003Ca class=\"underline\" ng-href=\"{{contactTelephone.anonymous.link}}\" ng-bind=\"contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\nafin de résoudre le problème.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{focus: currentInput == 'password'}\"\u003E\u003Cdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6\"\u003E\u003Clabel\u003EMot de passe\u003Cdiv class=\"input-group\"\u003E\u003Cinput ng-focus=\"focus('password')\" ng-blur=\"focus('')\" type=\"{{passwordType}}\" id=\"password\" name=\"password\" required ng-model=\"password\" ng-change=\"updatePasswordStrength(password)\" placeholder=\"********\"\u003E\u003Cdiv class=\"input-group-addon\" ng-click=\"togglePasswordVisibility()\"\u003E\u003Ci class=\"fa\" ng-class=\"{'fa-eye': passwordType === 'text', 'fa-eye-slash': passwordType === 'password'}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 form-message\" ng-class=\"{formmessage: !isMobile(), formmessagemob: isMobile()}\"\u003E\u003Cp\u003EPour plus de sécurité, votre mot de passe doit être suffisamment long et pas trop simple (évitez par ex. : 1234 ou aaaa)\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: confirmForm.form1.$submitted &amp;&amp; confirmForm.form1.passwordCheck.$error.compareTo, focus: currentInput == 'passwordCheck'}\"\u003E\u003Ci class=\"fa fa-warning hidden-xs\" ng-if=\"confirmForm.form1.$submitted &amp;&amp; confirmForm.form1.passwordCheck.$error.compareTo\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Clabel\u003EConfirmation\u003Cdiv class=\"input-group\"\u003E\u003Cinput ng-focus=\"focus('passwordCheck')\" ng-blur=\"focus('')\" type=\"{{passwordType}}\" id=\"passwordCheck\" name=\"passwordCheck\" required compare-to=\"confirmForm.form1.password.$viewValue\" ng-model=\"passwordCheck\" placeholder=\"********\"\u003E\u003Cdiv class=\"input-group-addon\" ng-click=\"togglePasswordVisibility()\"\u003E\u003Ci class=\"fa\" ng-class=\"{'fa-eye': passwordType === 'text', 'fa-eye-slash': passwordType === 'password'}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 form-message\"\u003E\u003Cp ng-if=\"confirmForm.form1.$submitted &amp;&amp; confirmForm.form1.passwordCheck.$error.compareTo\"\u003ELes deux mots de passe saisis ne sont pas identiques.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cspan\u003ENiveau de sécurité du mot de passe\u003C\u002Fspan\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cdiv class=\"strength-meter\"\u003E\u003Cdiv class=\"strength-meter-fill\" data-strength=\"{{passwordStrengh}}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 center strength-meter-label\" data-strength=\"{{passwordStrengh}}\"\u003E\u003Cspan class=\"fa fa-check\" ng-if=\"passwordStrengh &gt;= minStrength\"\u003E&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-times\" ng-if=\"passwordStrengh &lt; minStrength\"\u003E&nbsp;\u003C\u002Fspan\u003E\u003Cspan\u003E{{scoreMeaning[passwordStrengh]}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-top-30\"\u003E\u003Cdiv class=\"col-xs-12 text-right\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': isSubmitting}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"isSubmitting || !passwordStrengh || passwordStrengh &lt; minStrength\" id=\"saveMDP\"\u003E\u003Cspan class=\"hidden-xs\"\u003EEnregistrer mon mot de passe\u003C\u002Fspan\u003E\u003Cspan class=\"visible-xs-block\"\u003EEnregistrer\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003Cspan\u003EChangement d'adresse email\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"navbar-text\"\u003EChangement d'adresse email\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1 default-form\" ng-if=\"!isChangeMailSuccess\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ECHANGEMENT D'ADRESSE EMAIL\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cp\u003EUne erreur s'est produite pendant le changement de mail\u003C\u002Fp\u003E\u003Cp\u003ENous vous invitons à relancer la procédure de changement de votre adresse email depuis vos informations personnelles.\u003C\u002Fp\u003E\u003Cp\u003ESi cette erreur persiste, contactez-nous au &nbsp;\u003Ca class=\"underlined\" ng-href=\"{{contactTelephone.client.link}}\" ng-bind=\"contactTelephone.client.label\"\u003E\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cdiv class=\"row margin-top-40\"\u003E\u003Cdiv class=\"col-sm-6 col-sm-offset-6\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"login\"\u003ESE CONNECTER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1 default-form\" ng-if=\"isChangeMailSuccess\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ECHANGEMENT D'ADRESSE EMAIL\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cp\u003ELe changement d'email est effectif.\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez consulter vos informations personnelles sur le portail.\u003C\u002Fp\u003E\u003Cdiv class=\"row margin-top-40\"\u003E\u003Cdiv class=\"col-sm-6 col-sm-offset-6\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"login\"\u003ESE CONNECTER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cheader class=\"block-collapsible-header nav nav-landing stickBelow\" ng-class=\"{headerMobile: isMobile(), headerDesktop: !isMobile()}\" ng-if=\"state.current.data.showHeader\" permission permission-except=\"'client'\"\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cimg alt=\"logo plum mobile\" src=\"\u002Fassets\u002Fimg\u002Flogo-landing-mob-2x.png\"\u003E\u003Ch2\u003ELe fournisseur d'électricité\u003Cbr\u003Equi donne envie de changer\u003C\u002Fh2\u003E\u003Cdiv\u003E\u003Ca ng-click=\"scrollDecouvrir()\"\u003EDécouvrir\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cimg alt=\"logo plum big\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum.svg\"\u003E\u003Ch2\u003ELe fournisseur d'électricité\u003Cbr\u003Equi donne envie de changer\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Cheader class=\"nav nav-plum\" nav-plum-scrollable ng-class=\"{'nav-plum-fixed': !showNavOnMobile}\"\u003E\u003Cdiv class=\"navbar-menu-mobile visible-xs-block\"\u003E\u003Cnavbar-menu\u003E\u003C\u002Fnavbar-menu\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navbar-dashboard\" ng-class=\"{'hidden-xs': !showNavOnMobile }\"\u003E\u003Cnavbar-dashboard\u003E\u003C\u002Fnavbar-dashboard\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navbar-menu-desktop hidden-xs\"\u003E\u003Cnavbar-menu\u003E\u003C\u002Fnavbar-menu\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navbar-menu-desktop-fixed hidden-xs\" bs-affix data-offset-top=\"{{getHeaderHeight()}}\"\u003E\u003Cnavbar-menu\u003E\u003C\u002Fnavbar-menu\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Cdiv class=\"nav-plum-fixed-margin-top\"\u003E\u003Cui-view\u003E\u003C\u002Fui-view\u003E\u003Cdiv ng-if=\"state.current.data.showFold\"\u003E\u003Cplum-feature feature-name=\"subscription\"\u003E\u003Cspan ng-if=\"$root.dataFeature['subscription']\"\u003E\u003Cdiv class=\"fold-wrapper\"\u003E\u003Cdiv class=\"fold-affix affix\" bs-affix data-offset-bottom=\"{{getFooterHeight()}}\"\u003E\u003Cdiv class=\"fold\"\u003E\u003Ca class=\"btn background-light-pink\" ui-sref=\"subscription\" ng-click=\"gaEventsService.newEvent('click - Souscription')\"\u003E\u003Cspan ng-if=\"!$root.dataFeature['newSubscribeNavbar']\"\u003EJe change de fournisseur\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$root.dataFeature['newSubscribeNavbar']\" permission permission-only=\"['anonymous', 'user']\" permission-except=\"'client'\"\u003EPASSER CHEZ PLÜM\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$root.dataFeature['newSubscribeNavbar']\" permission permission-only=\"'client'\"\u003EAJOUTER UN CONTRAT\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center background-white padding-bottom-10\" id=\"fold-bottom\"\u003E\u003Ca class=\"darkish-pink\" ui-sref=\"subscription\"\u003ECommencez l'expérience Plüm maintenant !\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fplum-feature\u003E\u003C\u002Fdiv\u003E\u003Cunergie-footer\u003E\u003C\u002Funergie-footer\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"container-fluid\"\u003E\u003Csection\u003E\u003Cdiv class=\"row\"\u003E\u003Carticle class=\"messaging col-xs-offset-3 col-xs-6\"\u003E\u003Ch2\u003EBonjour {{userInfo.givenname}}.\u003Cbr\u003EToute l'équipe plüm énergie vous souhaite la bienvenue.\u003C\u002Fh2\u003E\u003Cp\u003EVous y trouverez, concentré ici, tout ce que vous permettra de mieux maitriser votre consommation d’énergie au quotidien : l’avancement de votre profil PLÜM, les conseils de la semaine et ceux que vous avez mis en pratique, vos interactions avec la communauté PLÜM, etc.\u003Cbr\u003ETout ceci classé par mois.\u003C\u002Fp\u003E\u003Cp\u003ESans jamais pedre de vue notre but commun :\u003Cbr\u003Ealléger votre consommation d’énergie.\u003C\u002Fp\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Carticle class=\"main-panel col-xs-offset-3 col-xs-6 room-background\"\u003E\u003Ch3\u003ELe conseil de la semaine\u003C\u002Fh3\u003E\u003Cdiv class=\"content\"\u003E\u003Chint class=\"hint-flow large\" hint=\"hint\" state=\"flow\" large=\"hint.large\" ng-class=\"hint.room\"\u003E\u003C\u002Fhint\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"hint-sub-menu col-xs-10 col-xs-offset-1 visible-xs\"\u003E\u003Cdiv class=\"header col-xs-12\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cspan class=\"background-marine\"\u003ELes rubriques\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-2\"\u003E\u003Ci class=\"fa\" ng-init=\"navCollapsed = isMobile()\" ng-click=\"navCollapsed = !navCollapsed\" ng-class=\"{'fa-caret-down': navCollapsed, 'fa-caret-up': !navCollapsed}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse col-xs-12\" uib-collapse=\"navCollapsed\"\u003E\u003Cul class=\"nav navbar-nav nav-center\"\u003E\u003Cli ng-repeat=\"c in hintCategories\"\u003E\u003Ca href=\"\" scroll-to=\"{{c.id}}\" offset=\"150\" ng-class=\"{hide: c.hints.length == 0}\"\u003E{{ c.title }}\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container-fluid medium-navigation-wrapper hidden-xs\"\u003E\u003Cdiv class=\"navigation-bar visible-sm\" bs-affix data-offset-top=\"1030\"\u003E\u003Cdiv class=\"nav-links right hidden-xs hidden-sm\"\u003E\u003Cul\u003E\u003Cli\u003E\u003Ch4\u003E\u003Cinput type=\"text\" ng-model=\"searchString\" ng-change=\"searchHint()\"\u003E\u003C\u002Fh4\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ch3\u003E\u003Cspan class=\"fa fa-search\"\u003E&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"nav-links\"\u003E\u003Cul\u003E\u003Cli ng-repeat=\"c in hintCategories\"\u003E\u003Ca href=\"\" scroll-to=\"{{c.id}}\" offset=\"150\" ng-class=\"{hide: c.hints.length == 0}\"\u003E{{ c.title }}\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-bar hidden-sm hidden-xs\" bs-affix data-offset-top=\"380\"\u003E\u003Cdiv class=\"nav-links right hidden-xs hidden-sm\"\u003E\u003Cul\u003E\u003Cli\u003E\u003Ch4\u003E\u003Cinput type=\"text\" ng-model=\"searchString\" ng-change=\"searchHint()\"\u003E\u003C\u002Fh4\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ch3\u003E\u003Cspan class=\"fa fa-search\"\u003E&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"nav-links\"\u003E\u003Cul\u003E\u003Cli ng-repeat=\"c in hintCategories\"\u003E\u003Ca href=\"\" scroll-to=\"{{c.id}}\" offset=\"150\" ng-class=\"{hide: c.hints.length == 0}\"\u003E{{ c.title }}\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container-fluid\"\u003E\u003Csection\u003E\u003Carticle class=\"hints\"\u003E\u003Cdiv class=\"row hint-category\" ng-repeat=\"category in hintCategories\" id=\"{{ category.id }}\"\u003E\u003Cdiv class=\"row category-header\" ng-show=\"category.hints.length &gt; 0\"\u003ERUBRIQUE&nbsp;\u003Cdiv class=\"category-title\"\u003E{{category.title}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cmasonry class=\"row hidden-xs\" column-width=\"100\" load-images=\"false\" masonry-options=\"{isOriginLeft: $even}\"\u003E\u003Cdiv class=\"masonry-brick\" ng-repeat=\"hint in category.hints\" ng-class=\"{large: $first}\"\u003E\u003Chint ng-click=\"readHint(hint, $index, category)\" hint=\"hint\" state=\"hints\" large=\"$first\" hint-class=\"getHintClassDirective(hint.room[0])\" ng-class=\"[getHintClass(hint.room[0]), {'background-left': isLeft($parent.$parent.$index), 'background-right': isRight($parent.$parent.$index), large: $first}]\"\u003E\u003C\u002Fhint\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmasonry\u003E\u003Cmasonry class=\"row visible-xs\" column-width=\"100\" load-images=\"false\"\u003E\u003Cdiv class=\"masonry-brick col-xs-10\" ng-repeat=\"hint in category.hints\" ng-class=\"{'large-mobile': $first, 'col-xs-offset-1 normal-mobile': !$first}\"\u003E\u003Chint class=\"background-left-mobile\" ng-click=\"readHint(hint, $index, category)\" hint=\"hint\" state=\"hints\" large=\"$first\" hint-class=\"getHintClassDirective(hint.room[0])\" ng-class=\"[getHintClass(hint.room[0]), {large: $first}]\"\u003E\u003C\u002Fhint\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmasonry\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"container\"\u003E\u003Csection\u003E\u003Cdiv class=\"row\"\u003E\u003Carticle class=\"col-md-12\" ng-if=\"data.loading || data.graph.data !== null\"\u003E\u003Cdiv class=\"large-main-panel\" ng-if=\"data.loading\"\u003E\u003Ch3\u003EMon bilan conso\u003Cdiv class=\"spinner\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"large-main-panel\" ng-if=\"!data.loading\"\u003E\u003Ch3\u003EMon bilan conso\u003Cspan ng-if=\"!userIsBase\"\u003E&nbsp;- heures pleines \u002F heures creuses\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003Cdiv ng-class=\"{'chart-graph marginb30': isMobile()}\"\u003E\u003Cnvd3 class=\"chart-bar\" options=\"data.graph.options.multiBarChart\" data=\"data.graph.data\"\u003E\u003C\u002Fnvd3\u003E\u003Cdiv class=\"chart-axis chart-bar\"\u003E\u003Cdiv class=\"col-xs-1 padding-0\" ng-repeat=\"month in data.graph.info\" data-no-apply-click=\"data.graph.makeActive($index)\" ng-class=\"{ 'no-click': !month.clickable }\"\u003E\u003Cchart-month index=\"$index\" month=\"month.formattedDate\"\u003E\u003C\u002Fchart-month\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cchart-info has-pot=\"isSelectedContractHasPot()\" user-info=\"userInfo\" info=\"data.graph.info\"\u003E\u003C\u002Fchart-info\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Carticle class=\"col-md-12\" ng-if=\"!data.loading &amp;&amp; data.graph.data === null\"\u003E\u003Cdiv class=\"large-main-panel\"\u003E\u003Ch3\u003EMon bilan conso\u003Cp class=\"text-center\"\u003EVotre contrat est en cours d’élaboration.\u003Cbr\u003EVous pourrez le voir dans les tout prochains jours.\u003C\u002Fp\u003E\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection ng-if=\"isSelectedContractHasPot()\"\u003E\u003Cdiv class=\"row\"\u003E\u003Carticle class=\"col-md-8\" ng-class=\"{marginb30: isTab()}\"\u003E\u003Cdiv class=\"large-main-panel\"\u003E\u003Ch3\u003EMa cagnotte&nbsp;\u003Cspan class=\"fa fa-question-circle\" uib-popover-template=\"'pot-explanation'\" popover-trigger=\"mouseenter\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"pot-explanation\"\u003E\u003Cdiv\u003EVotre cagnotte se décompose en une partie estimée, pour le semestre en cours\net une partie directement utilisable, composée de vos bonus des semestres précédents.\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E\u003Cdiv class=\"user-pot-value user-large-pot-value large-amount\" ng-class=\"{'main-panel-value': !isMobile()}\"\u003E\u003Cpot-balance\u003E\u003C\u002Fpot-balance\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-80\" ng-if=\"!userContract.isLinkyCommunicating\"\u003E\u003Cp\u003EComment ce montant est-il calculé ?\u003C\u002Fp\u003E\u003Cpot-division pot=\"pot\" user-info=\"userInfo\"\u003E\u003C\u002Fpot-division\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sub-panel no-top-radius background-gold medium\"\u003E\u003Cpot-burn user-info=\"userInfo\"\u003E\u003C\u002Fpot-burn\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Carticle class=\"col-md-4\"\u003E\u003Cdiv class=\"large-main-panel\"\u003E\u003Ch3\u003EEstimer mes économies d'énergie\u003C\u002Fh3\u003E\u003Cp ng-if=\"!userContract.isLinkyCommunicating\"\u003EPour voir votre cagnotte augmenter, relevez votre compteur chaque début de mois.\u003C\u002Fp\u003E\u003Cdiv class=\"last-self-reading-date\"\u003E\u003Cdiv class=\"date-label\" ng-if=\"report.contract.lastReadings[0].index_nature == 'AUTO-RELEVE'\"\u003EDernière auto-relève\u003C\u002Fdiv\u003E\u003Cdiv class=\"date\" ng-if=\"report.contract.lastReadings[0].index_nature == 'AUTO-RELEVE'\"\u003E{{( report.contract.lastReadings[0].end_date | amDateFormat:'DD MMMM YYYY')}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cplum-feature feature-name=\"reports\"\u003E\u003Cspan ng-if=\"$root.dataFeature['reports']\"\u003E\u003Creport class=\"report light-report standalone-report\" user-info=\"userInfo\" contract-selected=\"contractSelected\"\u003E\u003C\u002Freport\u003E\u003C\u002Fspan\u003E\u003C\u002Fplum-feature\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Cplum-feature feature-name=\"landscape\"\u003E\u003Csection class=\"row-fluid\" id=\"landscape-form\" ng-if=\"$root.dataFeature['landscape']\"\u003E\u003Cdiv class=\"col-md-12 row window-height\"\u003E\u003Clandscape-form questions=\"landscapeQuestions\" contract-selected=\"userInfo.contractSelected\" display-end-modal=\"true\"\u003E\u003C\u002Flandscape-form\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fplum-feature\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"my-account-sub-menu col-xs-12 visible-xs\"\u003E\u003Cdiv class=\"header\" ng-init=\"navAccountCollapsed = true\" ng-click=\"navAccountCollapsed = !navAccountCollapsed\" ng-class=\"{'header-collapsed': navAccountCollapsed, 'header-expanded': !navAccountCollapsed}\"\u003E\u003Cspan class=\"background-lighter-pink\" ng-if=\"isActive('invoice')\"\u003EFactures et paiement\u003C\u002Fspan\u003E\u003Cspan class=\"background-lighter-pink\" ng-if=\"isActive('account')\"\u003EMon contrat\u003C\u002Fspan\u003E\u003Cspan class=\"background-lighter-pink\" ng-if=\"isActive('personalInformation')\"\u003EMes informations personnelles\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse col-xs-12\" uib-collapse=\"navAccountCollapsed\"\u003E\u003Cul class=\"nav navbar-nav nav-center\"\u003E\u003Cli ng-if=\"$root.dataFeature['invoice']\"\u003E\u003Ca ui-sref=\"invoice\" ng-class=\"{active: isActive('invoice')}\" ng-click=\"toogleNavAccountCollapsed()\"\u003EFactures et paiement\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ui-sref=\"account\" ng-class=\"{active: isActive('account')}\" ng-click=\"toogleNavAccountCollapsed()\"\u003EMon contrat\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli ng-if=\"$root.dataFeature['personalInformation']\"\u003E\u003Ca ui-sref=\"personalInformation\" ng-class=\"{active: isActive('personalInformation')}\" ng-click=\"toogleNavAccountCollapsed()\"\u003EMes informations personnelles\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ng-href=\"\u002Fcommunaute\u002Fuser\u002F{{userCommunityInfo.userslug}}\" ng-click=\"toogleNavAccountCollapsed()\" target=\"_self\"\u003EMon profil communauté\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli ng-if=\"$root.dataFeature['subscriptionAddNewContractBtn']\"\u003E\u003Cbutton class=\"btn btn-new-contract background-waterblue\" ui-sref=\"subscription\"\u003ENouveau contrat\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container-fluid medium-navigation-wrapper navigation-wrapper-lighter-pink hidden-xs\"\u003E\u003Cdiv class=\"navigation-bar\" bs-affix data-offset-top=\"{{getHeaderHeight()}}\"\u003E\u003Cdiv class=\"nav-links\"\u003E\u003Cul\u003E\u003Cli ng-if=\"$root.dataFeature['invoice']\"\u003E\u003Ca ui-sref=\"invoice\" ng-class=\"{active: isActive('invoice')}\"\u003EFactures et paiement\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ui-sref=\"account\" ng-class=\"{active: isActive('account')}\"\u003EMon contrat\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli ng-if=\"$root.dataFeature['personalInformation']\"\u003E\u003Ca ui-sref=\"personalInformation\" ng-class=\"{active: isActive('personalInformation')}\"\u003EMes informations personnelles\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ng-href=\"\u002Fcommunaute\u002Fuser\u002F{{userCommunityInfo.userslug}}\" target=\"_self\"\u003EMon profil communauté\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli ng-if=\"$root.dataFeature['subscriptionAddNewContractBtn']\"\u003E\u003Cbutton class=\"btn btn-new-contract background-waterblue\" ui-sref=\"subscription\"\u003ENouveau contrat\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cui-view\u003E\u003C\u002Fui-view\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container-fluid\"\u003E\u003Cdiv class=\"text-center margin-top-40 margin-bottom-50\"\u003ELE CONTRAT EST AU NOM DE\u003Ch1 class=\"margin-top-15 bold\"\u003E\u003Cspan\u003E{{ userInfo.givenname }} {{ userInfo.sn }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"userInfo.civ2\"\u003E\u003Cbr\u003Eet {{userInfo.givenname2}} {{userInfo.sn2}}\u003C\u002Fspan\u003E\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-lg-2 hidden-xs hidden-sm hidden-md\"\u003E\u003Cdiv class=\"margin-top-minus-60\"\u003E\u003Cdiv class=\"bidule-container\" ng-if=\"$root.dataFeature['retractation'] &amp;&amp; isUserContractCanRetract()\"\u003E\u003Cdiv class=\"bidule bidule-dark-pink bidule-button-account\"\u003E\u003Cdiv class=\"bidule-top\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bidule-bot\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn-bidule btn-skip-retract text-center\" ng-click=\"openSkipRetractModal()\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fskip-retract-icon.svg\"\u003E\u003Cp\u003EJE LANCE MA COMMANDE TOUT DE SUITE\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bidule-container\" ng-if=\"canDownloadContractCertificate()\"\u003E\u003Cdiv class=\"bidule bidule-dark-pink bidule-button-account\"\u003E\u003Cdiv class=\"bidule-top\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bidule-bot\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn-bidule btn-contract-certificate text-center\" href=\"\u002Fapi-user\u002Fdocuments\u002F{{userContract.id}}\u002Fcontractcertificate\" target=\"_blank\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcontrat-certificate.svg\"\u003E\u003Cp\u003EATTESTATION DE CONTRAT\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bidule-container\" ng-if=\"$root.dataFeature['proofOfResidence'] &amp;&amp; isUserContractActive()\"\u003E\u003Cdiv class=\"bidule bidule-dark-pink bidule-button-account\"\u003E\u003Cdiv class=\"bidule-top\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bidule-bot\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn-bidule btn-proofofresidence text-center\" ng-click=\"openProofOfResModal()\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fproof-of-residence.svg\"\u003E\u003Cp\u003EJUSTIFICATIF DE DOMICILE\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Carticle class=\"col-lg-8 margin-bottom-30\"\u003E\u003Cdiv class=\"large-main-panel my-contract margin-top-15\"\u003E\u003Cdiv class=\"row hidden-xs\" ng-if=\"canTerminate()\"\u003E\u003Cdiv class=\"col-sm-12 text-right\"\u003E\u003Cdiv class=\"inline-block\"\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" ng-click=\"redirectToTerminate()\"\u003EJE DÉMÉNAGE\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Caccount-status-timeline user-contract=\"userContract\" display-title=\"true\"\u003E\u003C\u002Faccount-status-timeline\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row visible-xs-block margin-bottom-30\" ng-if=\"canTerminate()\"\u003E\u003Cdiv class=\"col-xs-12 text-center\"\u003E\u003Cdiv class=\"inline-block\"\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" ng-click=\"redirectToTerminate()\"\u003EJE DÉMÉNAGE\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EOFFRE :\u003C\u002Fp\u003E{{userInfo.contractSelected.providerOffer.label}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15\"\u003E\u003Cdiv class=\"contract-field sponsor-field\"\u003E\u003Cp\u003EDÉTAIL DE VOTRE TARIF\u003C\u002Fp\u003E\u003Ca ng-href=\"\u002Fdocumentation\u002F{{ userInfo.contractSelected.providerOffer.fis ? userInfo.contractSelected.providerOffer.fis : 'fis.pdf' }}\" target=\"blank\"\u003E\u003Ci class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nConsulter la grille tarifaire\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15\"\u003E\u003Caccount-status user-contract=\"userContract\" is-retractable=\"isRetractable\"\u003E\u003C\u002Faccount-status\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EDATE DE DÉBUT DE CONTRAT :\u003C\u002Fp\u003E{{ startContractDate | date: 'dd\u002FMM\u002Fyyyy' }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-12 marginb15 separator-xlg\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EN° POINT DE LIVRAISON :\u003C\u002Fp\u003E{{ userInfo.contractSelected.prm.id | prm }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003ERÉFÉRENCE DU CONTRAT :\u003C\u002Fp\u003E{{ userInfo.contractSelected.id }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EADRESSE DE LA RÉSIDENCE :\u003C\u002Fp\u003E{{ userInfo.contractSelected.prm.addr_num_street }}\u003Cbr\u003E{{ userInfo.contractSelected.prm.addr_post_code }} {{ userInfo.contractSelected.prm.addr_city_lbl }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15 for-xlg-screens\"\u003E\u003Cdiv class=\"contract-field\" ng-if=\"!modifyBillAdd\"\u003E\u003Cp\u003EADRESSE DE FACTURATION :\u003C\u002Fp\u003E{{ userBillingAddress.addr_num_street }}\u003Cbr\u003E{{ userBillingAddress.addr_post_code }} {{ userBillingAddress.addr_city_lbl }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"modifyBillAdd\"\u003E\u003Clabel\u003ESaisissez votre nouvelle adresse de facturation :\u003C\u002Flabel\u003E\u003Cui-select class=\"col-xs-10 no-padding\" ng-model=\"newBillAdd\" on-select=\"selectLabel(newBillAdd)\"\u003E\u003Cui-select-match class=\"overflowhid\" placeholder=\"Entrez votre adresse\"\u003E{{$select.selected.label}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices class=\"col-xs-12\" repeat=\"billAddress in billAddresses\" refresh=\"refreshAddresses($select.search)\"\u003E\u003Cdiv ng-bind-html=\"billAddress.label\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15\" ng-class=\"{'hidden-xs hidden-sm': isTab() &amp;&amp; showNewBillAddUnsave || isTab() &amp;&amp; modifyBillAdd}\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EOPTION ET PUISSANCE SOUSCRITE :\u003C\u002Fp\u003E{{ userInfo.contractSelected.max_power }}\n{{ userInfo.contractSelected.power_unit }}\n-\n{{ userInfo.contractSelected.plan }}\n{{ userInfo.contractSelected.id_p_calendar !== 'BASE' ? userInfo.contractSelected.off_peak_label : '' }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 marginb15\" ng-class=\"{'hidden-xs hidden-sm': isTab() &amp;&amp; showNewBillAddUnsave || isTab() &amp;&amp; modifyBillAdd}\"\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userInfo.contractSelected.billing_modality\"\u003E\u003Cp\u003ETYPE DE FACTURATION\u003C\u002Fp\u003E{{ billingModalityMapper[userInfo.contractSelected.billing_modality] }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cplum-feature feature-name=\"modifyBillAdd\"\u003E\u003Cdiv class=\"col-md-6 col-offset-md-6 marginb15\" ng-if=\"$root.dataFeature['modifyBillAdd']\"\u003E\u003Cdiv class=\"contract-field padding-top-30\" ng-if=\"showNewBillAddUnsave\"\u003E\u003Cp\u003EADRESSE DE FACTURATION SÉLECTIONNÉE :\u003C\u002Fp\u003E{{ newBillAddSelected.addr_num_street }}\u003Cbr ng-if=\"newBillAddSelected.addr_details\"\u003E{{ newBillAddSelected.addr_details }}\u003Cbr ng-if=\"newBillAddSelected.addr_bat\"\u003E{{ newBillAddSelected.addr_bat }}\u003Cbr ng-if=\"newBillAddSelected.addr_locality\"\u003E{{ newBillAddSelected.addr_locality }}\u003Cbr\u003E{{ newBillAddSelected.addr_post_code }} {{ newBillAddSelected.addr_city_lbl }}\u003Cdiv class=\"form-group billAddDetails margin-top-20\"\u003E\u003Clabel for=\"details\"\u003ECompléments d'adresse\u003C\u002Flabel\u003E\u003Cinput class=\"col-xs-11\" id=\"details\" ng-model=\"newBillAddSelected.addr_details\" type=\"text\" placeholder=\"Indications complémentaires, ...\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group billAddDetails\"\u003E\u003Clabel for=\"batiment\"\u003EN° de Bâtiment\u003C\u002Flabel\u003E\u003Cinput class=\"col-xs-11\" id=\"batiment\" ng-model=\"newBillAddSelected.addr_bat\" type=\"text\" placeholder=\"A, ...\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group billAddDetails\"\u003E\u003Clabel for=\"locality\"\u003ELocalité\u003C\u002Flabel\u003E\u003Cinput class=\"col-xs-11\" id=\"locality\" ng-model=\"newBillAddSelected.addr_locality\" type=\"text\" placeholder=\"Lieu-dit, ...\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"account-modify-btn\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"btn-modify background-bluegrey\" ng-if=\"!modifyBillAdd\" ng-click=\"showInputBillAdd()\" target=\"_self\"\u003EModifier\u003Cdiv ng-if=\"modifyBillAdd\"\u003E\u003Cbutton class=\"btn-modify btn-warning\" type=\"button\" ng-click=\"cancelModifyBillAdd()\" target=\"_self\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn-modify btn-success\" type=\"button\" ng-class=\"{disabled: !enableBtnSaveBillAdd}\" ng-click=\"saveBillAdd(newBillAddSelected)\" target=\"_self\"\u003EEnregistrer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fplum-feature\u003E\u003Cdiv class=\"col-md-6 marginb15 hidden\" ng-class=\"{'visible-xs visible-sm': isTab() &amp;&amp; showNewBillAddUnsave || isTab() &amp;&amp; modifyBillAdd}\"\u003E\u003Cdiv class=\"contract-field-spec\" ng-class=\"{'margin-top-30': isTab() &amp;&amp; modifyBillAdd}\"\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EOFFRE :\u003C\u002Fp\u003E{{ userInfo.contractSelected.max_power }}\n{{ userInfo.contractSelected.power_unit }}\n-\n{{ userInfo.contractSelected.plan }}\n{{ userInfo.contractSelected.id_p_calendar !== 'BASE' ? userInfo.contractSelected.off_peak_label : '' }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-12 marginb15 separator-xlg\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 marginb15\"\u003E\u003Cdiv class=\"contract-field sponsor-field\"\u003E\u003Cp\u003ELIEN DE PARRAINAGE\u003C\u002Fp\u003E\u003Cdiv\u003E\u003Cspan class=\"subdetail\"\u003ESi vous souhaitez parrainer un(e) proche,\nvous avez la possibilité de lui partager votre lien personnalisé depuis lequel il ou elle pourra souscrire son contrat :\n{{ sponsorUrl }}.\u003Cspan ng-if=\"sponsorFee && sponsoredFee\"\u003E Le gain est de {{ sponsorFee }}€ dans la cagnotte du parrain et {{ sponsoredFee }}€ dans celle du filleul,\ndès lors que le contrat du filleul aura été activé.\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn background-marine margin-top-1O\" clipboard text=\"sponsorUrl\" uib-popover=\"Le lien a été copié dans le presse-papier\" popover-trigger=\"'outsideClick'\" popover-placement=\"right\" popover-popup-close-delay=\"2\"\u003ECopier\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"row\" ng-if=\"$root.dataFeature['proofOfResidence'] &amp;&amp; isUserContractActive()\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-1 visible-xs visible-sm visible-md\" ng-class=\"{'margin-top-minus-60': !isDesktop()}\"\u003E\u003Ca class=\"btn-bidule btn-proofofresidence text-center\" ng-click=\"openProofOfResModal()\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fproof-of-residence.svg\"\u003E\u003Cp\u003EJUSTIFICATIF DE DOMICILE\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"canDownloadContractCertificate()\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-1 visible-xs visible-sm visible-md\" ng-class=\"{'margin-top-minus-60': !isDesktop()}\"\u003E\u003Ca class=\"btn-bidule btn-contract-certificate text-center\" href=\"\u002Fapi-user\u002Fdocuments\u002F{{userContract.id}}\u002Fcontractcertificate\" target=\"_blank\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcontrat-certificate.svg\"\u003E\u003Cp\u003EATTESTATION DE CONTRAT\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$root.dataFeature['retractation'] &amp;&amp; isUserContractCanRetract()\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-1 visible-xs visible-sm visible-md\" ng-class=\"{'margin-top-minus-60': !isDesktop()}\"\u003E\u003Ca class=\"btn-bidule btn-skip-retract text-center\" ng-click=\"openSkipRetractModal()\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fskip-retract-icon.svg\"\u003E\u003Cp\u003EJE LANCE MA COMMANDE TOUT DE SUITE\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$root.dataFeature['retractation'] &amp;&amp; isUserContractCanRetract()\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-2 col-lg-2 col-lg-offset-10\" ng-class=\"{'margin-top-minus-60': !isDesktop()}\"\u003E\u003Cdiv class=\"bidule bidule-dark-pink bidule-button-account hidden-sm hidden-xs hidden-md\"\u003E\u003Cdiv class=\"bidule-top\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bidule-bot\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn-bidule btn-retract text-center\" ng-click=\"openRetractModal()\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fretract-icon.svg\"\u003E\u003Cp\u003EJ'ANNULE MA COMMANDE\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"main-container invoice\"\u003E\u003Cdiv class=\"container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-lg-2 hidden-xs hidden-sm hidden-md\"\u003E\u003Cdiv class=\"column-left\"\u003E\u003Cinvoice-bidule-sleek sleek=\"data.currentSituation.sleek\"\u003E\u003C\u002Finvoice-bidule-sleek\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Carticle class=\"col-lg-8 margin-bottom-30\"\u003E\u003Cinvoice-payment-table contract=\"userInfo.contractSelected\"\u003E\u003C\u002Finvoice-payment-table\u003E\u003Cinvoice-details ng-if=\"$root.dataFeature['invoiceDetails']\" invoices=\"data.invoices\"\u003E\u003C\u002Finvoice-details\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row visible-xs-inline visible-sm-inline visible-md-inline\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-sm-offset-3\"\u003E\u003Cinvoice-bidule-sleek sleek=\"data.currentSituation.sleek\"\u003E\u003C\u002Finvoice-bidule-sleek\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"main-container personal-information\"\u003E\u003Cdiv class=\"container-fluid\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-lg-2 hidden-xs hidden-sm hidden-md\"\u003E\u003Cdiv class=\"column-left\"\u003E\u003Cpersonal-info-sponsor-link customer-id=\"userInfo.customer_id\"\u003E\u003C\u002Fpersonal-info-sponsor-link\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Carticle class=\"col-lg-8 margin-bottom-30\"\u003E\u003Cpersonal-information-detail user-info=\"userInfo\"\u003E\u003C\u002Fpersonal-information-detail\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row visible-xs-inline visible-sm-inline visible-md-inline\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6\"\u003E\u003Cpersonal-info-sponsor-link customer-id=\"userInfo.customer_id\"\u003E\u003C\u002Fpersonal-info-sponsor-link\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cheader class=\"nav nav-community\" id=\"header\" ng-class=\"{bg_pattern_community: !isMobile()}\"\u003E\u003Cdiv class=\"community-menu\"\u003E\u003Cdiv class=\"navigation-wrapper\"\u003E\u003Cnav class=\"navbar navbar-white\" bs-affix data-offset-top=\"{{getHeaderHeight()}}\"\u003E\u003Cdiv class=\"container nav-container\"\u003E\u003Cdiv class=\"nav navbar-header\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Cimg class=\"desktop-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-small.png\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-community-mob.png\"\u003E\u003C\u002Fdiv\u003E\u003Cplum-feature feature-name=\"menus\" feature-callback=\"getCurrentStateInfo\"\u003E\u003Cul class=\"nav navbar-nav mobile-nav\"\u003E\u003Cli\u003E\u003Ca class=\"active\"\u003E{{ activeBurgerMenu }}\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fplum-feature\u003E\u003Cbutton class=\"navbar-toggle btn-burger-community\" ng-init=\"navCollapsed = isMobile()\" ng-click=\"navCollapsed = !navCollapsed\"\u003E\u003Cspan class=\"sr-only\"\u003EMenu\u003C\u002Fspan\u003E\u003Ci class=\"fa fa-bars burger-community\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse\" uib-collapse=\"navCollapsed\"\u003E\u003Cplum-feature feature-name=\"communityCounter\"\u003E\u003Cul class=\"nav navbar-nav\"\u003E\u003Cli\u003E\u003Ca ng-href=\"{{offerPageLink}}\"\u003EL'offre\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"visible-xs-block\"\u003E\u003Ca ui-sref=\"dashboard\" permission permission-only=\"'client'\"\u003EMon tableau de bord\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ui-sref=\"hints\" permission permission-only=\"'client'\"\u003ELes conseils\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ui-sref=\"community\" ng-class=\"{active: isActive('community')}\"\u003ELa communauté\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ui-sref=\"tracking\" permission permission-only=\"'client'\"\u003EMon suivi conso\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fplum-feature\u003E\u003Cul class=\"nav navbar-nav navbar-right\"\u003E\u003Cli permission permission-only=\"'client'\"\u003E\u003Cdiv class=\"btn-group-my-account btn-group\" ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Cbutton class=\"btn btn-my-account background-marine\" ng-click=\"redirectOnClick()\"\u003E\u003Cspan\u003EMon compte\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-logoff\" ng-click=\"logout()\"\u003E\u003Ci class=\"fa fa-power-off\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\" permission-except=\"'client'\"\u003E\u003Cdiv class=\"btn-group\" ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Ca class=\"btn btn-subscribe white background-marine\" ui-sref=\"subscription\"\u003E\u003Cspan\u003EJe souscris\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"\" ng-click=\"logout()\"\u003E\u003Ci class=\"fa fa-power-off\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'anonymous'\"\u003E\u003Cdiv ng-if=\"!$root.dataFeature['newSubscribeNavbar']\" ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Ca class=\"btn background-marine\" ui-sref=\"login({source: 'communaute'})\"\u003E\u003Cspan\u003EMe connecter\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca ui-sref=\"login({source: 'communaute'})\"\u003E\u003Ci class=\"fa fa-power-off\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"btn-group\" ng-if=\"$root.dataFeature['newSubscribeNavbar']\" ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Ca class=\"btn btn-login white background-waterblue\" ui-sref=\"login({source: 'communaute'})\"\u003EMe connecter\u003C\u002Fa\u003E\u003Ca class=\"btn btn-subscribe white background-marine\" ui-sref=\"subscription\"\u003EJe souscris\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"community-notif\" ng-if=\"isMobile()\"\u003E\u003Cul class=\"nav navbar-nav navbar-center\"\u003E\u003Cli\u003E\u003Cdiv class=\"button-text-icon\"\u003E\u003Ca class=\"btn background-white\" scroll-to=\"header\" callback-after=\"focusQuestionInput(true)\"\u003E\u003Cspan\u003EUne question ?\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"no-padding\" scroll-to=\"header\" callback-after=\"focusQuestionInput(true)\"\u003E\u003Ci class=\"fa fa-search\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn active background-waterblue\" href=\"https:\u002F\u002Fassistance.plum.fr\" target=\"_self\"\u003EFAQ\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Cdiv class=\"button-icon\"\u003E\u003Ca class=\"btn active background-waterblue\" href=\"\u002Fcommunaute\u002Fchats\" target=\"_self\"\u003E\u003Ci class=\"fa fa-fw\" data-content=\"{{userChatsCount}}\" ng-class=\"{unread: userChatsCount &gt; 0, 'fa-envelope': userChatsCount &gt; 0, 'fa-envelope-o': userChatsCount &lt; 1}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Cdiv class=\"button-icon\"\u003E\u003Ca class=\"btn active background-waterblue\" href=\"\u002Fcommunaute\u002Fnotifications\" target=\"_self\"\u003E\u003Ci class=\"fa fa-fw\" data-content=\"{{userNotificationsCount}}\" ng-class=\"{unread: userNotificationsCount &gt; 0, 'fa-bell': userNotificationsCount &gt; 0, 'fa-bell-o': userNotificationsCount &lt; 1}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"community-sub-menu col-xs-10 col-xs-offset-1\" ng-if=\"isMobile()\"\u003E\u003Cdiv class=\"header col-xs-12\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cspan class=\"background-marine\"\u003EAccueil\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-2\"\u003E\u003Ci class=\"fa\" ng-init=\"navCollapsed = isMobile()\" ng-click=\"navCollapsed = !navCollapsed\" ng-class=\"{'fa-caret-down': navCollapsed, 'fa-caret-up': !navCollapsed}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse col-xs-12\" uib-collapse=\"navCollapsed\"\u003E\u003Cul class=\"nav navbar-nav nav-center\"\u003E\u003Cli\u003E\u003Ca class=\"btn selected\" href=\"\u002F#communaute\" target=\"_self\"\u003EAccueil\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn\" href=\"\u002Fcommunaute\u002Fcategory\u002F5\u002Fchoisir-plüm\" target=\"_self\"\u003EChoisir Plüm\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn\" href=\"\u002Fcommunaute\u002Fcategory\u002F6\u002Futiliser-plüm\" target=\"_self\"\u003EUtiliser Plüm\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn\" href=\"\u002Fcommunaute\u002Fcategory\u002F7\u002Fagir-avec-plüm\" target=\"_self\"\u003EAgir avec Plüm\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn\" href=\"\u002Fcommunaute\u002Fcategory\u002F18\u002Fpartager\" target=\"_self\"\u003EPartager\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"community-form-mob col-xs-10 col-xs-offset-1\" ng-if=\"isMobile()\"\u003E\u003Cform ng-submit=\"search(searchValue)\"\u003E\u003Cinput type=\"text\" focus-if=\"questionIsFocused\" ng-blur=\"focusQuestionInput(false)\" ng-model=\"searchValue\" placeholder=\"Une question ?\"\u003E\u003Cbutton id=\"btn-search-com1\" type=\"submit\"\u003E\u003Ci class=\"fa fa-search background-waterblue\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"community-header\" ng-if=\"!isMobile()\"\u003E\u003Cdiv class=\"header-title\"\u003E\u003Ch1\u003ELa communauté Plüm\u003Cdiv class=\"energie-label\"\u003EÉnergie\u003C\u002Fdiv\u003E\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Ch4\u003EPlein de plumes réunies, ça donne des ailes. Ouverte à tous, la communauté Plüm\u003Cbr\u003Eest un espace d’entraide conçu pour le partage et l’échange.\u003Cbr\u003E\u003Cbr\u003EC’est votre première visite ? &nbsp;\u003Ca href=\"\u002Fcommunaute\u002Fcategory\u002F26\u002F\" target=\"_self\"\u003EConsultez la charte de la communauté.\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003Cform ng-submit=\"search(searchValue)\"\u003E\u003Cinput type=\"text\" focus-if=\"questionIsFocused\" ng-blur=\"focusQuestionInput(false)\" ng-model=\"searchValue\" placeholder=\"Une question ? La communauté peut vous répondre !\"\u003E\u003Cbutton id=\"btn-search-com2\" type=\"submit\"\u003E\u003Ci class=\"fa fa-search background-waterblue\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003Cdiv class=\"navigation-wrapper\"\u003E\u003Cnav class=\"navbar navbar-transparent\" bs-affix data-offset-top=\"400\"\u003E\u003Cdiv class=\"container nav-container\"\u003E\u003Cul class=\"nav navbar-nav nav-center\"\u003E\u003Cli\u003E\u003Ca class=\"btn active background-bluegrey\"\u003EAccueil\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn background-marine\" href=\"\u002Fcommunaute\u002Fcategory\u002F5\u002Fchoisir-plüm\" target=\"_self\"\u003EChoisir Plüm\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn background-marine\" href=\"\u002Fcommunaute\u002Fcategory\u002F6\u002Futiliser-plüm\" target=\"_self\"\u003EUtiliser Plüm\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn background-marine\" href=\"\u002Fcommunaute\u002Fcategory\u002F7\u002Fagir-avec-plüm\" target=\"_self\"\u003EAgir avec Plüm\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca class=\"btn background-marine\" href=\"\u002Fcommunaute\u002Fcategory\u002F18\u002Fpartager\" target=\"_self\"\u003EPartager\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cul class=\"nav navbar-nav navbar-right\" ng-if=\"!isMobile()\"\u003E\u003Cli\u003E\u003Cdiv class=\"button-text-icon\"\u003E\u003Ca class=\"btn background-white\" scroll-to=\"header\" callback-after=\"focusQuestionInput(true)\"\u003E\u003Cspan\u003EUne question ?\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"btn background-waterblue\" scroll-to=\"header\" callback-after=\"focusQuestionInput(true)\"\u003E\u003Ci class=\"fa fa-search\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli id=\"liFaq\"\u003E\u003Ca class=\"btn active background-waterblue\" href=\"\u002Fhttps:\u002F\u002Fassistance.plum.fr\" target=\"_self\"\u003EFAQ\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Cdiv class=\"button-icon\"\u003E\u003Ca class=\"btn active background-waterblue\" href=\"\u002Fcommunaute\u002Fchats\" target=\"_self\"\u003E\u003Ci class=\"fa fa-fw\" data-content=\"{{userChatsCount}}\" ng-class=\"{unread: userChatsCount &gt; 0, 'fa-envelope': userChatsCount &gt; 0, 'fa-envelope-o': userChatsCount &lt; 1}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\"\u003E\u003Cdiv class=\"button-icon\"\u003E\u003Ca class=\"btn active background-waterblue\" href=\"\u002Fcommunaute\u002Fnotifications\" target=\"_self\"\u003E\u003Ci class=\"fa fa-fw\" data-content=\"{{userNotificationsCount}}\" ng-class=\"{unread: userNotificationsCount &gt; 0, 'fa-bell': userNotificationsCount &gt; 0, 'fa-bell-o': userNotificationsCount &lt; 1}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Cdiv class=\"container\"\u003E\u003Csection itemscope itemtype=\"http:\u002F\u002Fwww.schema.org\u002FItemList\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-8 visible-xs visible-sm\"\u003E\u003Carticle class=\"large-main-panel padding-bottom-15 marginb15\"\u003E\u003Ch3\u003ELes discussions du moment\u003C\u002Fh3\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"topic in topics | limitTo: 3\"\u003E\u003Chr ng-if=\"!$first\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-9\"\u003E\u003Ch4\u003E\u003Cdiv class=\"col-xs-2 col-sm-2 no-padding text-right\"\u003E\u003Cspan class=\"fa-stack fa-2x\"\u003E\u003Ci class=\"fa fa-circle fa-stack-2x\" style=\"color:{{topic.category.bgColor}};\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"fa fa-stack-1x\" style=\"color:{{topic.category.color}};\" ng-class=\"topic.category.icon\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-10 col-sm-10 topicTitleDisc\"\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{topic.slug}}\" target=\"_self\" ng-bind-html=\"topic.title\"\u003E\u003C\u002Fa\u003E\u003Cspan class=\"book\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"book\" am-time-ago=\"topic.timestampISO\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-3 nbExchanges\"\u003E\u003Ch4\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{topic.slug}}\" target=\"_self\"\u003E\u003Cspan class=\"book post-count\"\u003E{{topic.postcount}} échanges\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"well well-padding-left\"\u003E\u003Cdiv\u003E\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{topic.teaser.user.userslug}}\" target=\"_self\" ng-if=\"topic.teaser\"\u003E\u003Cavatar user=\"topic.teaser.user\"\u003E\u003C\u002Favatar\u003E\u003C\u002Fa\u003E\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{topic.user.userslug}}\" target=\"_self\" ng-if=\"!topic.teaser\"\u003E\u003Cavatar user=\"topic.user\"\u003E\u003C\u002Favatar\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch4\u003E\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{topic.teaser.user.userslug}}\" target=\"_self\" ng-if=\"topic.teaser\"\u003E{{topic.teaser.user.userslug}}\u003C\u002Fa\u003E\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{topic.user.userslug}}\" target=\"_self\" ng-if=\"!topic.teaser\"\u003E{{topic.user.userslug}}\u003C\u002Fa\u003E\u003Cspan class=\"book\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"book\" am-time-ago=\"topic.lastposttimeISO\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003Ca ng-if=\"!topic.teaser\" href=\"\u002Fcommunaute\u002Ftopic\u002F{{topic.slug}}\" target=\"_self\"\u003E\u003C\u002Fa\u003E\u003Ca ng-if=\"topic.teaser\" href=\"\u002Fcommunaute\u002Ftopic\u002F{{topic.slug}}\u002F{{topic.teaser.index}}\" target=\"_self\"\u003E\u003Cdiv class=\"message-box\"\u003E\u003Cp class=\"view-more pull-right\"\u003EVoir la suite\u003C\u002Fp\u003E\u003Cp class=\"ellipsis\" ng-if=\"topic.teaser\" ng-bind-html=\"topic.teaser.content | rawHtml\"\u003E\u003C\u002Fp\u003E\u003Cp class=\"ellipsis\" ng-if=\"!topic.teaser\" ng-bind-html=\"topicMessages[topic.tid] | rawHtml\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-6 col-xs-offset-3\"\u003E\u003Ca class=\"btn background-bluegrey btn-panel\" href=\"\u002Fcommunaute\u002Fpopular\" target=\"_self\"\u003EVoir tout\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Cplum-feature feature-name=\"actuPlumHomepage\"\u003E\u003Carticle class=\"large-main-panel overflowhid padding-bottom-15 marginb15\" ng-if=\"$root.dataFeature['actuPlumHomepage']\"\u003E\u003Ch3\u003EL'actu Plüm\u003C\u002Fh3\u003E\u003Cdiv class=\"main-panel-value\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cdiv class=\"post-actu-plum\" ng-repeat=\"actuPost in actuPosts | limitTo: 3 | orderBy:actuPost.timestamp:true\"\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{actuPost.slug}}\" target=\"_self\"\u003E\u003Cdiv class=\"col-xs-12 overflowhid marginb15\"\u003E\u003Cdiv class=\"div-img-actu\"\u003E\u003Cimg class=\"img-responsive marginb15\" alt=\"Image Actu Plüm\" ng-src=\"{{actuPost.posts[0].imgUrl || '\u002Fassets\u002Fimg\u002Flogo-plum.svg'}}\"\u003E\u003C\u002Fdiv\u003E\u003Ch4 ng-bind-html=\"actuPost.title\"\u003E\u003C\u002Fh4\u003E\u003Cp class=\"noMargin actu-summary\" ng-bind-html=\"actuPost.posts[0].postText.text\"\u003E\u003C\u002Fp\u003E\u003Cp class=\"text-right margin-top-1O\"\u003E\u003Ca class=\"text-right underlined\" href=\"\u002Fcommunaute\u002Ftopic\u002F{{actuPost.slug}}\" target=\"_self\"\u003ELire la suite ...\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-6 col-xs-offset-3\"\u003E\u003Ca class=\"btn background-bluegrey btn-panel\" href=\"\u002Fcommunaute\u002Fcategory\u002F3\u002Fl-actu-plüm-énergie\" target=\"_self\"\u003EVoir tout\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Carticle class=\"large-main-panel faq-homepage-mob padding-bottom-15 marginb15\"\u003E\u003Ch3\u003EFAQ\u003C\u002Fh3\u003E\u003Cspan class=\"hidden-xs\"\u003E&nbsp;- Les dernières mises à jour\u003C\u002Fspan\u003E\u003Cdiv class=\"main-panel-value\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"faqRecentCat in faqRecentCats | limitTo: 3\"\u003E\u003Chr ng-if=\"!$first\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-9 faq-home-topic\"\u003E\u003Ch4\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{faqRecentCat.posts[0].topic.slug}}\" target=\"_self\" ng-bind-html=\"faqRecentCat.posts[0].topic.title\"\u003E\u003C\u002Fa\u003E\u003Cspan class=\"book\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"book\" am-time-ago=\"faqRecentCat.posts[0].timestampISO\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-3 text-right exchanges\"\u003E\u003Ch4\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{faqRecentCat.posts[0].topic.slug}}\" target=\"_self\"\u003E\u003Cspan class=\"book post-count\"\u003E{{faqRecentCat.totalPostCount}} échanges\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 faq-home-cat\"\u003E\u003Cspan\u003Edans\u003C\u002Fspan\u003E\u003Ch4\u003E\u003Cspan class=\"fa-stack fa-lg\"\u003E\u003Ci class=\"fa fa-circle fa-stack-2x\" style=\"color:#455469;\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"fa fa-question fa-stack-1x\" style=\"color:#dae4f1;\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{faqRecentCat.slug}}\" target=\"_self\"\u003E{{faqRecentCat.name}}\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-6 col-xs-offset-3\"\u003E\u003Ca class=\"btn background-bluegrey btn-panel\" href=\"\u002Fhttps:\u002F\u002Fassistance.plum.fr\" target=\"_self\"\u003EVoir tout\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fplum-feature\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4\"\u003E\u003Cdiv class=\"bidule bidule-dark-pink\" permission permission-only=\"'user'\" ng-if=\"userCommunityInfo\" ng-class=\"{'bidule-desktop': !isMobile(), 'bidule-mobile': isMobile()}\"\u003E\u003Cdiv ng-class=\"{'bidule-top': !isMobile()}\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-class=\"{'bidule-bot': !isMobile()}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Carticle class=\"panel-profile\" permission permission-only=\"'user'\" ng-if=\"userCommunityInfo\"\u003E\u003Cdiv class=\"panel-header background-light-pink\"\u003E\u003Cavatar user=\"userCommunityInfo\"\u003E\u003C\u002Favatar\u003E\u003Ch4\u003EBonjour {{ userCommunityInfo.username }} !\u003C\u002Fh4\u003E\u003Ca href=\"{{ '\u002Fcommunaute\u002Fuser\u002F' + userCommunityInfo.userslug + '\u002Fedit'}}\" target=\"_self\"\u003EÉditer mon profil\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"panel-container\"\u003E\u003Cul\u003E\u003Ch5\u003E{{ \"mon activité\" | uppercase }}\u003C\u002Fh5\u003E\u003Cli\u003E\u003Ca href=\"{{ '\u002Fcommunaute\u002Fuser\u002F' + userCommunityInfo.userslug + '\u002Fwatched'}}\" target=\"_self\"\u003E\u003Ci class=\"fa fa-comment-o\"\u003E\u003C\u002Fi\u003EMes sujets suivis\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca href=\"{{ '\u002Fcommunaute\u002Fuser\u002F' + userCommunityInfo.userslug + '\u002Ftopics'}}\" target=\"_self\"\u003E\u003Ci class=\"fa fa-commenting-o\"\u003E\u003C\u002Fi\u003EMes sujets démarrés\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca href=\"{{ '\u002Fcommunaute\u002Fuser\u002F' + userCommunityInfo.userslug + '\u002Fposts'}}\" target=\"_self\"\u003E\u003Ci class=\"fa fa-bars\"\u003E\u003C\u002Fi\u003EMon fil d'activité\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca href=\"\u002Fcommunaute\u002Fchats\" target=\"_self\"\u003E\u003Ci class=\"fa fa-envelope-o\"\u003E\u003C\u002Fi\u003EMes messages privés\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Ca class=\"btn background-light-pink\" href=\"\u002Fcommunaute\" target=\"_self\"\u003EVoir le forum au complet\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Carticle class=\"margin-top-15\"\u003E\u003Cdiv class=\"panel-header background-marine\"\u003E\u003Ch5\u003E{{ \"Les membres les plus actifs\" | uppercase }}\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"panel-container\"\u003E\u003Cdiv class=\"row user-container\" ng-repeat=\"user in mostActiveUsers | limitTo: 3\"\u003E\u003Chr ng-if=\"!$first\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cavatar user=\"user\"\u003E\u003C\u002Favatar\u003E\u003Ca class=\"well-padding-left\" href=\"\u002Fcommunaute\u002Fuser\u002F{{user.userslug}}\" target=\"_self\"\u003E\u003Ch6\u003E{{user.userslug}}\u003C\u002Fh6\u003E\u003Cdiv\u003E\u003Ci class=\"fa fa-pencil waterblue\"\u003E\u003C\u002Fi\u003E&nbsp;{{user.postcount}} {{ \"posts\" | uppercase }}\n&nbsp;|&nbsp;\u003Ci class=\"fa fa-star gold\"\u003E\u003C\u002Fi\u003E&nbsp;{{user.reputation}} {{ \"renomée\" | uppercase }}\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn background-bluegrey\" href=\"\u002Fcommunaute\u002Fusers\u002Fsort-posts\" target=\"_self\"\u003ETout afficher\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Carticle class=\"margin-top-15\"\u003E\u003Cdiv class=\"panel-header background-marine\"\u003E\u003Ch5\u003E{{ \"Membres en ligne\" | uppercase }}\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"panel-container\"\u003E\u003Cdiv class=\"user-container fixed-max-height-100\"\u003E\u003Ca class=\"userslug-list\" href=\"\u002Fcommunaute\u002Fuser\u002F{{user.userslug}}\" target=\"_self\" ng-repeat=\"user in onlineUsers\"\u003E\u003Ch6\u003E{{user.username}}\u003C\u002Fh6\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn background-bluegrey\" href=\"\u002Fcommunaute\u002Fusers\u002Fonline\" target=\"_self\"\u003ETout afficher\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Carticle class=\"margin-top-15\"\u003E\u003Cdiv class=\"panel-header background-marine\"\u003E\u003Ch5\u003E{{ \"Derniers inscrits\" | uppercase }}\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"panel-container\"\u003E\u003Cdiv class=\"user-container fixed-max-height-100\"\u003E\u003Ca class=\"userslug-list\" href=\"\u002Fcommunaute\u002Fuser\u002F{{user.userslug}}\" target=\"_self\" ng-repeat=\"user in recentlyJoinedUsers\"\u003E\u003Ch6\u003E{{user.username}}\u003C\u002Fh6\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn background-bluegrey\" href=\"\u002Fcommunaute\u002Fusers\" target=\"_self\"\u003ETout afficher\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-8 hidden-xs hidden-sm marginb15\"\u003E\u003Carticle class=\"large-main-panel\"\u003E\u003Ch3\u003ELes discussions du moment\u003C\u002Fh3\u003E\u003Cdiv class=\"main-panel-value\"\u003E\u003Ca class=\"btn background-bluegrey btn-panel\" href=\"\u002Fcommunaute\u002Fpopular\" target=\"_self\"\u003EVoir tout\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"topic in topics | limitTo: 3\" itemprop=\"itemListElement\" itemscope itemtype=\"http:\u002F\u002Fschema.org\u002FConversation\"\u003E\u003Cmeta itemprop=\"position\" content=\"{{$index}}\"\u003E\u003Chr ng-if=\"!$first\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-1 no-padding-right\"\u003E\u003Cspan class=\"fa-stack fa-2x\"\u003E\u003Ci class=\"fa fa-circle fa-stack-2x\" style=\"color:{{topic.category.bgColor}};\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"fa fa-stack-1x\" style=\"color:{{topic.category.color}};\" ng-class=\"topic.category.icon\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-11 no-padding\"\u003E\u003Cdiv class=\"col-md-9\"\u003E\u003Ch4 class=\"topic\"\u003E\u003Cmeta itemprop=\"name\" content=\"{{topic.title}}\"\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{topic.slug}}\" target=\"_self\" ng-bind-html=\"topic.title\" itemprop=\"URL\"\u003E\u003C\u002Fa\u003E\u003Cspan class=\"book\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E\u003Cmeta itemprop=\"datePublished\" content=\"{{topic.timestampISO}}\"\u003E\u003Cspan class=\"book\" am-time-ago=\"topic.timestampISO\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-3 text-right\"\u003E\u003Ch4\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{topic.slug}}\" target=\"_self\"\u003E\u003Cspan class=\"book post-count\"\u003E{{topic.postcount}} échanges\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-12\" itemprop=\"hasPart\" itemscope itemtype=\"http:\u002F\u002Fschema.org\u002FMessage\"\u003E\u003Cdiv class=\"well well-padding-left\"\u003E\u003Cdiv\u003E\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{topic.teaser.user.userslug}}\" target=\"_self\" ng-if=\"topic.teaser\"\u003E\u003Cavatar user=\"topic.teaser.user\"\u003E\u003C\u002Favatar\u003E\u003C\u002Fa\u003E\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{topic.user.userslug}}\" target=\"_self\" ng-if=\"!topic.teaser\"\u003E\u003Cavatar user=\"topic.user\"\u003E\u003C\u002Favatar\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch4\u003E\u003Cmeta ng-if=\"topic.teaser\" itemprop=\"author\" content=\"{{topic.teaser.user.userslug}}\"\u003E\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{topic.teaser.user.userslug}}\" target=\"_self\" ng-if=\"topic.teaser\"\u003E{{topic.teaser.user.userslug}}\u003C\u002Fa\u003E\u003Cmeta ng-if=\"!topic.teaser\" itemprop=\"author\" content=\"{{topic.user.userslug}}\"\u003E\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{topic.user.userslug}}\" target=\"_self\" ng-if=\"!topic.teaser\"\u003E{{topic.user.userslug}}\u003C\u002Fa\u003E\u003Cspan class=\"book\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E\u003Cmeta itemprop=\"datePublished\" content=\"{{topic.lastposttimeISO}}\"\u003E\u003Cspan class=\"book\" am-time-ago=\"topic.lastposttimeISO\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003Ca ng-if=\"!topic.teaser\" href=\"\u002Fcommunaute\u002Ftopic\u002F{{topic.slug}}\" target=\"_self\"\u003E\u003C\u002Fa\u003E\u003Ca ng-if=\"topic.teaser\" href=\"\u002Fcommunaute\u002Ftopic\u002F{{topic.slug}}\u002F{{topic.teaser.index}}\" target=\"_self\"\u003E\u003Cdiv class=\"message-box\"\u003E\u003Cp class=\"view-more pull-right\"\u003EVoir la suite\u003C\u002Fp\u003E\u003Cmeta ng-if=\"topic.teaser\" itemprop=\"text\" content=\"topic.teaser.content\"\u003E\u003Cp class=\"ellipsis\" ng-if=\"topic.teaser\" ng-bind-html=\"topic.teaser.content | rawHtml\"\u003E\u003C\u002Fp\u003E\u003Cmeta ng-if=\"!topic.teaser\" itemprop=\"text\" content=\"topicMessages[topic.tid]\"\u003E\u003Cp class=\"ellipsis\" ng-if=\"!topic.teaser\" ng-bind-html=\"topicMessages[topic.tid] | rawHtml\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-8 hidden-xs hidden-sm marginb15\" ng-if=\"$root.dataFeature['actuPlumHomepage']\"\u003E\u003Carticle class=\"large-main-panel overflowhid\"\u003E\u003Ch3\u003EL'actu Plüm\u003C\u002Fh3\u003E\u003Cdiv class=\"main-panel-value\"\u003E\u003Ca class=\"btn background-bluegrey btn-panel\" href=\"\u002Fcommunaute\u002Fcategory\u002F3\u002Fl-actu-plüm-énergie\" target=\"_self\"\u003EVoir tout\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cdiv class=\"post-actu-plum\" ng-repeat=\"actuPost in actuPosts | limitTo: 3 | orderBy:actuPost.timestamp:true\" itemprop=\"itemListElement\" itemscope itemtype=\"http:\u002F\u002Fschema.org\u002FListItem\"\u003E\u003Cmeta itemprop=\"position\" content=\"{{$index + 3}}\"\u003E\u003Clink itemprop=\"url\" ng-href=\"\u002Fcommunaute\u002Ftopic\u002F{{actuPost.slug}}\"\u003E\u003Ca ng-href=\"\u002Fcommunaute\u002Ftopic\u002F{{actuPost.slug}}\" target=\"_self\"\u003E\u003Cdiv class=\"col-md-4 overflowhid\"\u003E\u003Cdiv class=\"div-img-actu overflowhid\"\u003E\u003Clink itemprop=\"image\" ng-href=\"{{actuPost.posts[0].imgUrl || '\u002Fassets\u002Fimg\u002Flogo-plum.svg'}}\"\u003E\u003Cimg class=\"img-responsive marginb15\" alt=\"logo plüm\" ng-src=\"{{actuPost.posts[0].imgUrl || '\u002Fassets\u002Fimg\u002Flogo-plum.svg'}}\"\u003E\u003C\u002Fdiv\u003E\u003Ch4 ng-bind-html=\"actuPost.title\" itemprop=\"name\"\u003E\u003C\u002Fh4\u003E\u003Cspan class=\"noMargin actu-summary\" ng-bind-html=\"actuPost.posts[0].postText.text\" itemprop=\"description\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;[...]\u003C\u002Fspan\u003E\u003Cp class=\"text-right margin-top-1O\"\u003E\u003Ca class=\"text-right underlined\" ng-href=\"\u002Fcommunaute\u002Ftopic\u002F{{actuPost.slug}}\" target=\"_self\"\u003ELire la suite\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-8 hidden-xs hidden-sm\" ng-class=\"{'col-md-offset-4': !isClient}\"\u003E\u003Carticle class=\"large-main-panel faq-homepage\"\u003E\u003Ch3\u003EFAQ\u003C\u002Fh3\u003E\u003Cspan\u003E&nbsp;- Les dernières mises à jour\u003C\u002Fspan\u003E\u003Cdiv class=\"main-panel-value\"\u003E\u003Ca class=\"btn background-bluegrey btn-panel\" href=\"\u002Fhttps:\u002F\u002Fassistance.plum.fr\" target=\"_self\"\u003EVoir tout\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"faqRecentCat in faqRecentCats | limitTo: 3\" itemprop=\"itemListElement\" itemscope itemtype=\"http:\u002F\u002Fschema.org\u002FListItem\"\u003E\u003Cmeta itemprop=\"position\" content=\"{{$index + 6}}\"\u003E\u003Chr ng-if=\"!$first\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-9 faq-home-topic\"\u003E\u003Ch4\u003E\u003Cmeta itemprop=\"name\" content=\"{{faqRecentCat.posts[0].topic.title}}\"\u003E\u003Cmeta itemprop=\"datePublished\" content=\"{{topic.timestampISO}}\"\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{faqRecentCat.posts[0].topic.slug}}\" target=\"_self\" ng-bind-html=\"faqRecentCat.posts[0].topic.title\" itemprop=\"url\"\u003E\u003C\u002Fa\u003E\u003Cspan class=\"book\"\u003E&nbsp;-&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"book\" am-time-ago=\"faqRecentCat.posts[0].timestampISO\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-3 text-right exchanges-mob\"\u003E\u003Ch4 ng-if=\"faqRecentCat.messageCount.msgCount\"\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{faqRecentCat.posts[0].topic.slug}}\" target=\"_self\"\u003E\u003Cspan class=\"book post-count\"\u003E{{faqRecentCat.messageCount.msgCount}} échanges\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12 faq-home-cat\"\u003E\u003Cspan\u003Edans&nbsp;\u003C\u002Fspan\u003E\u003Ch4\u003E\u003Cspan class=\"fa-stack fa-lg faq-icon\"\u003E\u003Ci class=\"fa fa-circle fa-stack-2x\" style=\"color:{{faqRecentCat.bgColor}};\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"fa fa-stack-1x\" style=\"color:{{faqRecentCat.color}};\" ng-class=\"faqRecentCat.icon\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ca href=\"\u002Fcommunaute\u002Ftopic\u002F{{faqRecentCat.slug}}\" target=\"_self\"\u003E&nbsp;{{faqRecentCat.name}}\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003Cunergie-footer class=\"white-footer\"\u003E\u003C\u002Funergie-footer\u003E\u003Cnewsletter-modal ng-if=\"$root.dataFeature['newsletterModal']\"\u003E\u003C\u002Fnewsletter-modal\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"container\"\u003E\u003Csection\u003E\u003Ch1 class=\"text-center\"\u003EMentions légales\u003C\u002Fh1\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12\"\u003E\u003Carticle class=\"large-main-panel\"\u003E\u003Ch2\u003EPlüm énergie\u003C\u002Fh2\u003E\u003Cp\u003EPlüm énergie SAS, société par actions simplifiée au capital de {{providerInfo && providerInfo.capital}}, autorisée à exercer l'activité de fournisseur d'électricité par arrêté ministériel du 28 décembre 2015.\u003C\u002Fp\u003E\u003Cp\u003ESiège social : 30 rue Proudhon, 93210 St Denis\u003Cbr\u003EImmatriculée au RCS de Bobigny sous le numéro 803 248 467\n\u003Cbr\u003ENuméro de TVA intracommunautaire : FR 21 803 248 467\u003Cbr\u003ENuméro de déclaration CNIL : 1972743\u003C\u002Fp\u003E\u003Cp\u003EDirecteur de la publication : Vincent Maillard\u003C\u002Fp\u003E\u003Cp\u003ELe site plum.fr est un site destiné à informer les personnes qui le consultent sur l'activité de Plüm énergie ainsi que sur l'offre qu'elle propose aux particuliers.\u003C\u002Fp\u003E\u003Cp\u003ELe site est hébergé en Union Européenne (République d'Irlande) par la société Amazon Web Services LLC :\n\u003Cbr\u003EP.O. Box 81226\u003Cbr\u003ESeattle, WA 98108-1226\u003Cbr\u003E\u003Ca class=\"underlined\" href=\"http:\u002F\u002Faws.amazon.com\"\u003Ehttp:\u002F\u002Faws.amazon.com\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Ch2\u003EUtilisation du site plum.fr\u003C\u002Fh2\u003E\u003Cp\u003EL'utilisateur du présent site web reconnaît avoir pris connaissance des présentes conditions d'utilisation et s'engage à les respecter. Tout litige en relation avec l'utilisation du présent site web est soumis au droit français.\u003C\u002Fp\u003E\u003Cp\u003ELes informations se trouvant sur le site plum.fr le sont à titre informatif. Plüm énergie ne garantit pas l'exactitude, l'exhaustivité, l'actualité des informations qui y sont présentées. Ainsi, les offres proposées par Plüm énergie sur ce site ne constituent pas un engagement contractuel. Plüm énergie se réserve le droit de les modifier ou les supprimer à tout moment et sans préavis.\u003C\u002Fp\u003E\u003Cp\u003EEn tant qu'utilisateur vous reconnaissez et acceptez que votre utilisation du site plum.fr, y compris le téléchargement de tout matériel à partir du site s'effectue à vos risques et périls.\u003C\u002Fp\u003E\u003Cp\u003EPar ailleurs, vous vous engagez à ne pas utiliser ce site ou les forums de discussion qu’il contient pour notamment :\u003Cul\u003E\u003Cli\u003E\u003Cp\u003Eenvoyer, transmettre ou diffuser par tout moyen tout contenu illicite, préjudiciable ou attentatoire à la vie privée ;\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cp\u003Eafficher, transmettre ou diffuser par tout moyen tout contenu violant les droits d’un tiers tel qu’un brevet, logiciel, marque ou logo, secret de fabrication, droit de propriété intellectuelle ou tout autre droit de propriété ;\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003Cp\u003EA défaut, votre responsabilité civile et\u002Fou pénale pourrait être engagée.\u003C\u002Fp\u003E\u003Cp\u003EPlüm énergie ne pourra en aucun cas être responsable en cas de dommages directs et\u002Fou indirects résultant de l'utilisation de ce site ou de l'impossibilité d'accéder à ce site.\u003C\u002Fp\u003E\u003Cp\u003EAucune garantie n'est fournie par Plüm énergie concernant la continuité de son fonctionnement.\u003C\u002Fp\u003E\u003Ch2\u003EProtection des données\u003C\u002Fh2\u003E\u003Cp\u003EToutes les données informatiques sont traitées de manière strictement confidentielle, dans le plus strict respect des obligations de la loi 78-17 du 6 janvier 1978 modifiée dite \"informatique et libertés\".\u003C\u002Fp\u003E\u003Cp\u003EL'utilisateur est informé que lors de ses visites sur le site, un cookie peut s'installer automatiquement sur son logiciel de navigation. Un cookie est un petit fichier qui s’installe sur le disque dur de l’ordinateur en vue de faciliter la navigation sur le site Internet tout en garantissant l’anonymat de l’utilisateur.\u003C\u002Fp\u003E\u003Cp\u003ELe paramétrage de votre logiciel de navigation vous permet de vous opposer à l’utilisation de cookies et nous vous invitons à consulter les manuels à cet effet.\u003C\u002Fp\u003E\u003Cp\u003EL’utilisateur dispose d’un droit d’accès, de rectification et d’opposition pour motifs légitimes des données à caractère personnel le concernant. L’utilisateur peut en faire la demande par courrier électronique à donnees-personnelles@plum-energie.fr ou par courrier postal à \"Service des données personnelles - Plüm énergie, 30 rue Proudhon 93210 Saint Denis\".\u003C\u002Fp\u003E\u003Ch2\u003EPropriété intellectuelle\u003C\u002Fh2\u003E\u003Cp\u003ELe site plum.fr, son arborescence, les logiciels, sons, images, textes, logos, marques et les données ou bases de données qui y figurent sont la propriété de Plüm énergie et sont protégés par le code de la propriété intellectuelle ou toute autre disposition légale en vigueur. Ils sont destinés à un usage strictement personnel. Toute reproduction, modification, communication à des tiers, en tout ou partie et quelle qu'en soit la finalité est interdite.\u003C\u002Fp\u003E\u003Ch2\u003ELiens à partir et vers d’autres sites\u003C\u002Fh2\u003E\u003Cp\u003ELes liens hypertextes éventuellement mis en place dans le cadre du site web en direction d'autres sites Internet ne sauraient engager la responsabilité de Plüm énergie ni constituer un quelconque partenariat avec elle. Ces sites sont indépendants et Plüm énergie ne saurait en aucun cas être tenu pour responsable de leur contenu.\u003C\u002Fp\u003E\u003Cp\u003ELes utilisateurs et visiteurs du site plüm-energie.fr ne pourront mettre en place un hyperlien en direction du présent site web qui porterait atteinte à l’image ou la notoriété de Plüm énergie.\u003C\u002Fp\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"landscape-page row-fluid\" id=\"landscape-form\"\u003E\u003Cdiv class=\"col-xs-12 window-height\"\u003E\u003Clandscape-form questions=\"landscapeQuestions\" contract-selected=\"contract\" display-end-modal=\"false\"\u003E\u003C\u002Flandscape-form\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-10 col-xs-12 col-md-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EVOTRE COMMANDE EST PRESQUE TERMINÉE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cdiv class=\"text-center margin-top-20 darkish-pink\"\u003E\u003Ch4\u003ENous vous avons envoyé un email\n\u003Cspan ng-if=\"email\"\u003Eà l’adresse {{email}}\u003C\u002Fspan\u003E\u003Cbr\u003ECliquez sur le lien qui se trouve dans cet email pour terminer votre commande :\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"margin-top-20\"\u003E\u003Cli\u003E\u003Cstrong\u003ECréer un mot de passe\u003C\u002Fstrong\u003E pour accéder à votre espace client sur espace-client.plum.fr\u003C\u002Fli\u003E\u003Cli\u003ESaisir vos \u003Cstrong\u003Einformations de paiement\u003C\u002Fstrong\u003E (préparez la partie IBAN de votre RIB)\u003C\u002Fli\u003E\u003Cli\u003E\u003Cstrong\u003ESigner votre mandat de prélèvement\u003C\u002Fstrong\u003E par voie électronique\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"text-center margin-top-20\"\u003E\u003Cstrong\u003EEt après, on s’occupe de tout !\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center margin-top-20\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Frocket.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\" ng-class=\"{'background-marine': partner.mvsa}\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\" ng-if=\"partner.selectra\" style=\"text-align: right; margin-right: 10px;\"\u003E\u003Cspan\u003Een partenariat avec\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cimg alt=\"logo selectra\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fselectra.svg\" style=\"display: inline-block; height: 20px;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\" ng-if=\"partner.mvsa\" style=\"text-align: right; margin-right: 10px;\"\u003E\u003Cspan\u003Een partenariat avec\u003C\u002Fspan\u003E\u003Cimg alt=\"logo mieux vivre votre argent\" src=\"assets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Fmvsa.svg\" style=\"margin-left: 10px; display: inline-block; height: 50px;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\" ng-if=\"partner.sosSeniors\" style=\"text-align: right; margin-right: 10px;\"\u003E\u003Cspan\u003Een partenariat avec\u003C\u002Fspan\u003E\u003Cimg alt=\"logo groupe sos seniors\" src=\"assets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Fgroupe_sos_seniors.svg\" style=\"margin-left: 10px; display: inline-block; height: 60px; padding: 5px; background: white;\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\" ng-class=\"{'background-marine': partner.mvsa}\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-lg-10 col-md-8 col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navbar-brand navbar-right\" ng-if=\"partner.selectra\"\u003E\u003Cspan class=\"fw-500\"\u003Een partenariat avec\u003C\u002Fspan\u003E\u003Cimg alt=\"logo selectra\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fselectra.svg\" style=\"display: inline-block; margin-left: 10px; height: 150%; vertical-align: bottom;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navbar-brand navbar-right\" ng-if=\"partner.mvsa\"\u003E\u003Cspan class=\"fw-500\"\u003Een partenariat avec\u003C\u002Fspan\u003E\u003Cdiv style=\"display: inline-block; position: relative; margin-left: 10px; vertical-align: top;\"\u003E\u003Cdiv style=\"position: absolute;\"\u003E\u003Cimg alt=\"logo mieux vivre votre argent\" src=\"assets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Fmvsa.svg\" style=\"max-height: 84px;\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navbar-brand navbar-right\" ng-if=\"partner.sosSeniors\"\u003E\u003Cspan class=\"fw-500\"\u003Een partenariat avec\u003C\u002Fspan\u003E\u003Cdiv style=\"display: inline-block; position: relative; margin-left: 10px; vertical-align: top;\"\u003E\u003Cdiv style=\"position: absolute; background: white; height: 72px; margin-top: -26px; padding: 5px 10px;\"\u003E\u003Cimg alt=\"logo groupe sos seniors\" src=\"assets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Fgroupe_sos_seniors.svg\" style=\"max-height: 62px; margin-top: 0;\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"background-white\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum.svg\" style=\"width: 200px\"\u003E\u003Cdiv class=\"hidden-xs margin-top-30\" style=\"position: relative; background-color: #ffe5dc; border-radius: 5px; width: 90%\"\u003E\u003Cdiv style=\"position: absolute; right: 0; top: 50%; transform: translate(50%, -50%); width: 30%\"\u003E\u003Cvideo autoplay muted playsinline style=\"width: 100%\"\u003E\u003Csource src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.webm\" type=\"video\u002Fwebm\"\u003E\u003Csource src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.mp4\" type=\"video\u002Fmp4\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.gif\"\u003E\u003C\u002Fvideo\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"padding-20 fs-20 fw-600\" style=\"width: 80%; line-height: 35px; padding-left: 30px;\"\u003EGrâce à l’Achat Groupé Printemps 2018 avec Selectra\u003Cspan ng-if=\"partner.selectra\"\u003E,\u003C\u002Fspan\u003E\u003Cspan ng-if=\"partner.mvsa\"\u003E&nbsp;et Mieux Vivre Votre Argent,\u003C\u002Fspan\u003E\u003Cspan ng-if=\"partner.sosSeniors\"\u003E&nbsp;et GROUPE SOS Seniors,\u003C\u002Fspan\u003E\nbénéficiez d’une remise exceptionnelle !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row visible-xs-block margin-top-30\"\u003E\u003Cdiv class=\"col-md-8\"\u003E\u003Ch2\u003EGrâce à l’Achat Groupé Printemps 2018 avec Selectra\u003Cspan ng-if=\"partner.selectra\"\u003E,\u003C\u002Fspan\u003E\u003Cspan ng-if=\"partner.mvsa\"\u003E&nbsp;et Mieux Vivre Votre Argent,\u003C\u002Fspan\u003E\u003Cspan ng-if=\"partner.sosSeniors\"\u003E&nbsp;et GROUPE SOS Seniors,\u003C\u002Fspan\u003E\nbénéficiez d’une remise exceptionnelle !\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4\"\u003E\u003Cvideo autoplay loop muted playsinline style=\"width: 100%\"\u003E\u003Csource src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.webm\" type=\"video\u002Fwebm\"\u003E\u003Csource src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.mp4\" type=\"video\u002Fmp4\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.gif\"\u003E\u003C\u002Fvideo\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-justify fw-500 margin-top-60\" style=\"padding-left: 30px;\"\u003E\u003Cp class=\"fs-18 fw-600\"\u003EBienvenue {{params.givenname}} !\u003C\u002Fp\u003E\u003Cp class=\"fs-16 fw-400\" style=\"line-height: 22px;\"\u003ERéduisez votre facture d’électricité en souscrivant chez Plüm énergie : toute votre première année,\nvous bénéficiez d’une\n\u003Cspan class=\"fw-500\"\u003Eremise de 30% sur le prix de votre électricité en heures creuses et 10% en heures pleines.\u003C\u002Fspan\u003E\nÀ partir de la seconde année, et sans limite de durée, vous bénéficiez toujours d’une remise de 15% en heures creuses\net 5% en heures pleines !\u003Csup\u003E(1)\u003C\u002Fsup\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Chr class=\"margin-top-30\" style=\"max-width: 440px;\"\u003E\u003Cdiv class=\"text-center margin-top-50\"\u003E\u003Ca class=\"btn background-light-pink round fs-20\" ng-click=\"gaEventsService.newEvent('clic sur je souscris - ouverture du tunnel de souscription')\" ui-sref=\"subscriptionOffrePrintemps2018(params)\" style=\"max-width: 220px;\"\u003EJe souscris\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center margin-top-50\"\u003E\u003Cdiv class=\"fw-600 fs-20\" style=\"line-height: 22px;\"\u003EL’achat groupé c’est :\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-4 margin-top-50\"\u003E\u003Cdiv class=\"fw-600 fs-18\" style=\"line-height: 22px;\"\u003EUN FOURNISSEUR\u003Cbr\u003EDE QUALITÉ\u003C\u002Fdiv\u003E\u003Cimg class=\"margin-tb-20\" alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fprix-selectra.svg\" style=\"height: 120px;\"\u003E\u003Cp class=\"margin-top-1O\"\u003EPour la deuxième année consécutive, Plüm est lauréat du prix Selectra du\n\u003Ca class=\"blue-light-selectra\" href=\"https:\u002F\u002Fselectra.info\u002Fprix\" target=\"_blank\"\u003EMeilleur Petit Fournisseur\u003C\u002Fa\u003E\nd’électricité 2018 !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4 margin-top-50\"\u003E\u003Cdiv class=\"fw-600 fs-18\" style=\"line-height: 22px;\"\u003EUNE DOUBLE\u003Cbr\u003EREMISE EXCLUSIVE\u003C\u002Fdiv\u003E\u003Cimg class=\"margin-tb-20\" alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Ftarif.svg\" style=\"height: 120px;\"\u003E\u003Cp class=\"margin-top-1O margin-bottom-0\"\u003EDe l’électricité 100% renouvelable avec une double remise sur le prix du kWh \u003Csup\u003E(1)\u003C\u002Fsup\u003E\n:\u003Cbr\u003E\u003C\u002Fp\u003E\u003Cdiv style=\"display: inline-block; text-align: left;\"\u003E\u003Cspan class=\"blue-light-selectra\"\u003E- 30% en heures creuses\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"blue-light-selectra\"\u003E- 10% en heures pleines\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4 margin-top-50\"\u003E\u003Cdiv class=\"fw-600 fs-18\" style=\"line-height: 22px;\"\u003EUN SUIVI CONSO\u003Cbr\u003EPERSONNALISÉ\u003C\u002Fdiv\u003E\u003Cimg class=\"margin-tb-20\" alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Festime.svg\" style=\"height: 120px;\"\u003E\u003Cp class=\"margin-top-1O\"\u003EVotre espace personalisé, pour mieux comprendre votre consommation et\n\u003Cspan class=\"blue-light-selectra\"\u003Eapprendre à la déplacer un maximum\u003C\u002Fspan\u003E\nsur vos heures creuses !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center margin-top-60\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cdiv class=\"fs-30 fw-600 dark-pink margin-top-30\"\u003E\u003Cspan class=\"hidden-xs fs-60\"\u003EPROLONGATION !\u003C\u002Fspan\u003E\u003Cspan class=\"visible-xs-block fs-30\"\u003EPROLONGATION !\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-12 fw-400 margin-bottom-30\"\u003E(offre désormais valable jusqu’au {{ partnerOfferEnd | amDateFormat:'DD MMMM YYYY' }})\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center margin-top-60\"\u003E\u003Ch4 class=\"fw-600 margin-bottom-30\"\u003ECHANGEZ DE FOURNISSEUR EN TOUTE TRANQUILITÉ\u003C\u002Fh4\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 col-md-offset-1 margin-top-30\"\u003E\u003Ch5 style=\"height: 60px\"\u003ERAPIDE\u003C\u002Fh5\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Frapide.svg\" style=\"height: 100px;\"\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003ESouscrivez en ligne en 5 minutes chrono\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 margin-top-30\"\u003E\u003Ch5 style=\"height: 60px\"\u003ESIMPLE\u003C\u002Fh5\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fsimple.svg\" style=\"height: 100px;\"\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003EOn s’occupe de tout, même de  votre ancien contrat.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 margin-top-30\"\u003E\u003Ch5 style=\"height: 60px\"\u003ESANS FRAIS\u003C\u002Fh5\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fsans-frais.svg\" style=\"height: 100px;\"\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003EAucun frais de dossier, passer chez Plüm, c’est gratuit !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 margin-top-30\"\u003E\u003Ch5 style=\"height: 60px\"\u003ESANS ENGAGEMENT\u003C\u002Fh5\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fsans-engagement.svg\" style=\"height: 100px;\"\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003EVous pouvez résilier à tout moment, sans frais.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 margin-top-30\"\u003E\u003Ch5 style=\"height: 60px\"\u003EGARANTI SANS COUPURE\u003C\u002Fh5\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fsans-risques.svg\" style=\"height: 100px;\"\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003EEnedis continue d’assurer votre alimentation et garantit les mêmes services qu’aux clients EDF.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center margin-tb-50\"\u003E\u003Ca class=\"btn background-light-pink round fs-20\" ng-click=\"gaEventsService.newEvent('clic sur je participe - ouverture du tunnel de souscription')\" ui-sref=\"subscriptionOffrePrintemps2018(params)\" style=\"max-width: 220px;\"\u003EJe participe !\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-tb-60 fs-10\"\u003E\u003Cp\u003E(1) Valable pour un nouveau contrat. Offre réservée aux inscrits de l’Achat Groupé Printemps 2018 jusqu’au {{ partnerOfferEnd | amDateFormat:'DD\u002FMM\u002FYYYY' }} pour toute première souscription. 30% de remise sur le prix du kilowatt heure en heures creuses par rapport aux tarifs réglementés de ventes d’électricité, hors toutes taxes, 10% de remise sur le prix du kilowatt heure en heures pleines par rapport aux tarifs réglementés de ventes d’électricité, hors toutes taxes.\u003C\u002Fp\u003E\u003Cp\u003EOffre non cumulable. Il est impossible de bénéficier d’un crédit parrainage lors de la souscription à cette offre.\u003C\u002Fp\u003E\u003Cp\u003EA partir de la 2ème année, et ce sans limite de durée vous bénéficiez :\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli\u003Ed'une remise de 15% sur le prix du kilowatt heure en heures creuses, hors toutes taxes, par rapport aux TRV\u003C\u002Fli\u003E\u003Cli\u003Ed'une remise de 5% sur le prix du kilowatt heure en heures pleines, hors toutes taxes, par rapport aux TRV\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp\u003ELes données collectées ici sont traitées par Plüm énergie. En application de la loi du 6 Janvier 1978 modifiée, dite \"Informatique et Libertés\", nous vous rappelons que vous disposez d’un droit d’accès, de rectification, d’opposition et de suppression de vos données personnelles en écrivant à Plüm énergie via l’adresse e-mail donnees-personnelles@plum.fr.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-tb-50\"\u003E\u003Cdiv class=\"col-lg-4 col-md-5 col-lg-offset-1\"\u003E\u003Ca class=\"btn background-marine\" ng-click=\"gaEventsService.newEvent('clic sur le bouton Grille des tarifs - ouverture du .pdf la grille des tarifs')\" href=\"\u002Fdocumentation\u002Ffis_offre_printemps_2018.pdf\" target=\"_blank\" style=\"margin-top: 10px;\"\u003E\u003Cspan class=\"padding-tb-5\" style=\"display: inline-block;\"\u003EGrille des tarifs\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-4 col-md-5 col-lg-offset-2 col-md-offset-1\"\u003E\u003Ca class=\"btn background-marine\" ng-click=\"gaEventsService.newEvent('clic sur Conditions générales de Vente - ouverture des conditions générales de vente')\" href=\"\u002Fdocumentation\u002Fcgv.pdf\" target=\"_blank\" style=\"margin-top: 10px;\"\u003E\u003Cspan class=\"padding-tb-5\" style=\"display: inline-block;\"\u003EConditions Générales de Vente\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-tb-50 fs-20 text-center\"\u003EPlüm énergie est fournisseur français d’électricité dont le siège est situé au\u003Cbr\u003E30 rue Proudhon, 93210 La Plaine Saint Denis\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"background-light-pink padding-bottom-15\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Ch6\u003EBesoin d’un coup de pouce ? Nous sommes là pour vous aider !\u003C\u002Fh6\u003E\u003Cdiv class=\"margin-top-1O\"\u003E\u003Cdiv style=\"display: inline-block; width: 30px; vertical-align: middle; margin-right: 10px;\"\u003E\u003Cimg src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Ftelephone.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv style=\"display: inline-block; vertical-align: middle;\"\u003E\u003Cspan class=\"fw-500\"\u003E{{contactTelephone.offrePrintemps2018.label}}\u003C\u002Fspan\u003E\n(prix d’un appel local)\u003Cbr\u003Edu lundi au vendredi de 9h à 18h\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-1O\"\u003E\u003Cdiv style=\"display: inline-block; width: 30px; vertical-align: middle; margin-right: 10px;\"\u003E\u003Cimg src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fletter.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fw-500\" style=\"display: inline-block; vertical-align: middle;\"\u003Ebonjour@plum.fr\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Ch6\u003ELien utiles\u003C\u002Fh6\u003E\u003Cdiv class=\"margin-top-1O\"\u003E\u003Ca class=\"white underline\" ui-sref=\"terms\" target=\"_blank\"\u003EMentions légales du site\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title text-right\" style=\"margin-right: 10px;\"\u003E\u003Cspan\u003Een partenariat avec\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cimg alt=\"logo selectra\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fselectra.svg\" style=\"display: inline-block; height: 20px;\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-lg-10 col-md-8 col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navbar-brand navbar-right\"\u003E\u003Cspan class=\"fw-500\"\u003Een partenariat avec\u003C\u002Fspan\u003E\u003Cimg alt=\"logo selectra\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fselectra.svg\" style=\"display: inline-block; margin-left: 10px; height: 150%; vertical-align: bottom;\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"background-white\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum.svg\" style=\"width: 200px\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 text-right\"\u003E\u003Cdiv class=\"inline-block text-left fs-20 fw-600 padding-right-30\"\u003EBesoin d’aide pour souscrire ?\u003Cbr\u003E{{contactTelephone.offreRentree2018.label}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs row margin-top-30\" style=\"border: solid 2px #efefef; border-radius: 5px; padding: 15px 0;\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"padding-20 fs-20 fw-400\" style=\"width: 80%; line-height: 35px; padding-left: 30px;\"\u003E\u003Cdiv\u003EGrâce à\n\u003Cspan class=\"fw-600\" ng-if=\"!city\"\u003El’achat groupé Selectra,\u003C\u002Fspan\u003E\u003Cspan class=\"fw-600\" ng-if=\"city\"\u003El’achat groupé Selectra pour les habitants {{prep}}{{city}} et des environs,\u003C\u002Fspan\u003E\nprofitez de notre remise exclusive sur le prix de l’électricité !\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-15\"\u003E\u003Ca class=\"btn background-light-pink round fs-20\" ng-click=\"gaEventsService.newEvent('clic sur je participe 1 desktop - ouverture du tunnel de souscription')\" ui-sref=\"subscriptionOffreRentree2018(params)\" style=\"max-width: 220px;\"\u003EJe participe\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 text-right\"\u003E\u003Cimg class=\"padding-right-30\" ng-src=\"assets\u002Fimg\u002Fsubscription\u002FoffreRentree2018\u002F{{logo}}\" alt=\"offre rentree 2018\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row visible-xs-block\"\u003E\u003Cdiv class=\"col-md-8 margin-top-30\"\u003E\u003Ch2 class=\"fw-400\"\u003EGrâce à\n\u003Cspan class=\"fw-600\" ng-if=\"!city\"\u003El’achat groupé Selectra,\u003C\u002Fspan\u003E\u003Cspan class=\"fw-600\" ng-if=\"city\"\u003El’achat groupé Selectra pour la ville de {{city}},\u003C\u002Fspan\u003E\nprofitez de notre remise exclusive sur le prix de l’électricité !\u003C\u002Fh2\u003E\u003Cdiv class=\"margin-top-50\"\u003E\u003Ca class=\"btn background-light-pink round fs-20\" ng-click=\"gaEventsService.newEvent('clic sur je participe 1 mobile - ouverture du tunnel de souscription')\" ui-sref=\"subscriptionOffreRentree2018(params)\" style=\"max-width: 220px;\"\u003EJe participe\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4 margin-top-30\"\u003E\u003Cimg ng-src=\"assets\u002Fimg\u002Fsubscription\u002FoffreRentree2018\u002F{{logo}}\" alt=\"offre rentree 2018\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-justify fw-500 margin-top-60\" style=\"padding-left: 30px;\"\u003E\u003Cp class=\"fs-16 fw-400\" style=\"line-height: 22px;\"\u003ERéduisez votre facture d’électricité en souscrivant chez Plüm énergie, grâce à l’achat groupé Selectra.\nVous bénéficiez d’\u003Cspan class=\"fw-600\"\u003Eune remise de 30% sur le prix de votre élecricité\u003C\u002Fspan\u003E\nen heures creuses la première année, et 10% les années suivantes.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Chr class=\"margin-top-30\" style=\"max-width: 440px;\"\u003E\u003Cdiv class=\"text-center margin-top-50\"\u003E\u003Cdiv class=\"fw-600 fs-20\" style=\"line-height: 22px;\"\u003EPasser chez Plüm, c’est faire un choix éclairé\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-4 margin-top-50\"\u003E\u003Cdiv class=\"fw-600 fs-18\" style=\"line-height: 22px;\"\u003EUN FOURNISSEUR\u003Cbr\u003EDE QUALITÉ\u003C\u002Fdiv\u003E\u003Cimg class=\"margin-tb-20\" alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fprix-selectra.svg\" style=\"height: 120px;\"\u003E\u003Cp class=\"margin-top-1O\"\u003EPour la deuxième année consécutive, Plüm est lauréat du prix Selectra du\n\u003Ca class=\"blue-light-selectra\" href=\"https:\u002F\u002Fselectra.info\u002Fprix\" target=\"_blank\"\u003EMeilleur Petit Fournisseur\u003C\u002Fa\u003E\nd’électricité 2018 !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4 margin-top-50\"\u003E\u003Cdiv class=\"fw-600 fs-18\" style=\"line-height: 22px;\"\u003EUNE REMISE\u003Cbr\u003EEXCLUSIVE\u003C\u002Fdiv\u003E\u003Cimg class=\"margin-tb-20\" alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Ftarif.svg\" style=\"height: 120px;\"\u003E\u003Cp class=\"margin-top-1O margin-bottom-0\"\u003EDe l’électricité 100% renouvelable avec une remise de -30% sur le prix du kWh en heures creuses\u003Csup\u003E(1)\u003C\u002Fsup\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4 margin-top-50\"\u003E\u003Cdiv class=\"fw-600 fs-18\" style=\"line-height: 22px;\"\u003EUN SUIVI CONSO\u003Cbr\u003EPERSONNALISÉ\u003C\u002Fdiv\u003E\u003Cimg class=\"margin-tb-20\" alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Festime.svg\" style=\"height: 120px;\"\u003E\u003Cp class=\"margin-top-1O\"\u003EVotre espace personalisé, pour mieux comprendre votre consommation et\n\u003Cspan class=\"blue-light-selectra\"\u003Eapprendre à la déplacer un maximum\u003C\u002Fspan\u003E\nsur vos heures creuses !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center margin-top-60\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cdiv class=\"text-center fw-600\" ng-if=\"displayCountdown &gt;= countdownDetail.days &amp;&amp; countdownDetail.asSeconds &gt;= 0\"\u003E\u003Cdiv class=\"text-center\" style=\"display: inline-block; vertical-align: text-top; margin-left: 10px; margin-right: 60px;\"\u003E\u003Cdiv class=\"fs-45 padding-15\" style=\"background-color: #f9f9f9; border-radius: 5px;\"\u003E{{ countdownDetail.days }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-10 margin-top-1O\"\u003EJOURS\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" style=\"display: inline-block; vertical-align: text-top; margin-left: 10px; margin-right: 10px;\"\u003E\u003Cdiv class=\"fs-45 padding-15\" style=\"background-color: #f9f9f9; border-radius: 5px;\"\u003E{{ countdownDetail.hours }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-10 margin-top-1O\"\u003EHEURES\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" style=\"display: inline-block; vertical-align: text-top; margin-left: 10px; margin-right: 10px;\"\u003E\u003Cdiv class=\"fs-45 padding-15\" style=\"background-color: #f9f9f9; border-radius: 5px;\"\u003E{{ countdownDetail.minutes }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-10 margin-top-1O\"\u003EMINUTES\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" style=\"display: inline-block; vertical-align: text-top; margin-left: 10px; margin-right: 10px;\"\u003E\u003Cdiv class=\"fs-45 padding-15\" style=\"background-color: #f9f9f9; border-radius: 5px;\"\u003E{{ countdownDetail.seconds }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-10 margin-top-1O\"\u003ESECONDES\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-22 fw-600 margin-top-30\"\u003EDÉPÊCHEZ-VOUS DE PARTICIPER !\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-12 fw-400 margin-bottom-30\"\u003E(offre valable jusqu’au {{ partnerOfferEnd | amDateFormat:'DD MMMM YYYY' }})\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center margin-tb-50\"\u003E\u003Ca class=\"btn background-light-pink round fs-20\" ng-click=\"gaEventsService.newEvent('clic sur je participe 2 - ouverture du tunnel de souscription')\" ui-sref=\"subscriptionOffreRentree2018(params)\" style=\"max-width: 220px;\"\u003EJe participe\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv style=\"background: #f8f8f8;\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"text-center margin-top-60\"\u003E\u003Ch4 class=\"fs-26 fw-600 margin-bottom-30\" style=\"color: #9fabc0;\"\u003EREJOIGNEZ PLÜM ÉNERGIE\u003Cbr\u003EEN TOUTE TRANQUILITÉ\u003C\u002Fh4\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 col-md-offset-1 margin-top-30\"\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Frapide.svg\" style=\"height: 100px;\"\u003E\u003Ch5 class=\"fw-600\"\u003E&nbsp;\u003Cbr\u003ERAPIDE\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003ESouscrivez en ligne en 5 minutes chrono\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 margin-top-30\"\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fsimple.svg\" style=\"height: 100px;\"\u003E\u003Ch5 class=\"fw-600\"\u003E&nbsp;\u003Cbr\u003ESIMPLE\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003EOn s’occupe de tout, même de  votre ancien contrat.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 margin-top-30\"\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fsans-frais.svg\" style=\"height: 100px;\"\u003E\u003Ch5 class=\"fw-600\"\u003ESANS\u003Cbr\u003EFRAIS\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003EAucun frais de dossier, passer chez Plüm, c’est gratuit !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 margin-top-30\"\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fsans-engagement.svg\" style=\"height: 100px;\"\u003E\u003Ch5 class=\"fw-600\"\u003ESANS\u003Cbr\u003EENGAGEMENT\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003EVous pouvez résilier à tout moment, sans frais.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-2 col-sm-6 col-xs-12 margin-top-30\"\u003E\u003Cimg alt=\"logo unergie\" src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fsans-risques.svg\" style=\"height: 100px;\"\u003E\u003Ch5 class=\"fw-600\"\u003EGARANTI\u003Cbr\u003ESANS COUPURE\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-20 fs-12\"\u003EEnedis continue d’assurer votre alimentation et garantit les mêmes services qu’aux clients EDF.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"background-white\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"margin-tb-60 fs-10\"\u003E\u003Cp\u003E\u003Csup\u003E(1)\u003C\u002Fsup\u003E\nValable pour un nouveau contrat. Parrainage impossible lors de la souscription à cette offre.\nOffre réservée aux inscrits de l’opération Selectra jusqu’au {{ partnerOfferEnd | amDateFormat:'DD\u002FMM\u002FYYYY' }}\npour toute première souscription. 30% de remise sur le prix du kilowatt heure en heures creuses par rapport\naux tarifs réglementés de ventes d’électricité, hors toutes taxes. Offre non cumulable.\u003C\u002Fp\u003E\u003Cp\u003EÀ partir de la deuxième année, vous bénéficiez d’une remise de 10% sur vos heures creuses et ce, sans limite de durée !\u003C\u002Fp\u003E\u003Cp\u003ELes données collectées ici sont traitées par Plüm énergie.\nEn application de la loi du 6 Janvier 1978 modifiée, dite \"Informatique et Libertés\",\nnous vous rappelons que vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression\nde vos données personnelles en écrivant à Plüm énergie via l’adresse e-mail donnees-personnelles@plum.fr.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-tb-50\"\u003E\u003Cdiv class=\"col-lg-4 col-md-5 col-lg-offset-1\"\u003E\u003Ca class=\"btn background-marine round\" ng-click=\"gaEventsService.newEvent('clic sur le bouton Grille des tarifs - ouverture du .pdf la grille des tarifs')\" href=\"\u002Fdocumentation\u002Ffis_offre_rentree_2018.pdf\" target=\"_blank\" style=\"margin-top: 10px;\"\u003E\u003Cspan class=\"padding-tb-5\" style=\"display: inline-block;\"\u003EGrille des tarifs\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-lg-4 col-md-5 col-lg-offset-2 col-md-offset-1\"\u003E\u003Ca class=\"btn background-marine round\" ng-click=\"gaEventsService.newEvent('clic sur Conditions générales de Vente - ouverture des conditions générales de vente')\" href=\"\u002Fdocumentation\u002Fcgv.pdf\" target=\"_blank\" style=\"margin-top: 10px;\"\u003E\u003Cspan class=\"padding-tb-5\" style=\"display: inline-block;\"\u003EConditions Générales de Vente\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-tb-50 fs-20 text-center\"\u003EPlüm énergie est fournisseur français d’électricité dont le siège est situé au\u003Cbr\u003E30 rue Proudhon, 93210 La Plaine Saint Denis\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"background-light-pink padding-bottom-15\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Ch6\u003EBesoin d’un coup de pouce ? Nous sommes là pour vous aider !\u003C\u002Fh6\u003E\u003Cdiv class=\"margin-top-1O\"\u003E\u003Cdiv style=\"display: inline-block; width: 30px; vertical-align: middle; margin-right: 10px;\"\u003E\u003Cimg src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Ftelephone.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv style=\"display: inline-block; vertical-align: middle;\"\u003E\u003Cspan class=\"fw-500\"\u003E{{contactTelephone.offreRentree2018.label}}\u003C\u002Fspan\u003E\n(prix d’un appel local)\u003Cbr\u003E{{contactTelephone.offreRentree2018.openingHour}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-1O\"\u003E\u003Cdiv style=\"display: inline-block; width: 30px; vertical-align: middle; margin-right: 10px;\"\u003E\u003Cimg src=\"assets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fletter.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fw-500\" style=\"display: inline-block; vertical-align: middle;\"\u003Ebonjour@plum.fr\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Ch6\u003ELien utiles\u003C\u002Fh6\u003E\u003Cdiv class=\"margin-top-1O\"\u003E\u003Ca class=\"white underline\" ui-sref=\"terms\" target=\"_blank\"\u003EMentions légales du site\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"anonPaymentSummary\"\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003Cspan\u003ERégularisation du solde débiteur\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"navbar-text\"\u003ERégularisation du solde débiteur\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1 default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ERÉSUMÉ DU PAIEMENT\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" ng-submit=\"goToPayment()\"\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"error\"\u003E\u003Ci class=\"fa fa-warning hidden-xs\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp\u003E\u003Cstrong ng-if=\"!error.data.message\"\u003EUne erreur s'est produite.\u003C\u002Fstrong\u003E\u003Cstrong ng-if=\"error.data.message\"\u003E{{error.data.message}}\u003C\u002Fstrong\u003E\u003Cbr\u003E\u003Cbr\u003EVous avez la possibilité de contacter le service client au\n\u003Ca class=\"underline\" ng-href=\"{{contactTelephone.anonymous.link}}\" ng-bind=\"contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\nafin de résoudre le problème.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!token\"\u003E\u003Cp\u003ELe lien de paiement a expiré, merci de contacter le service client au\n\u003Ca class=\"underline\" ng-href=\"{{contactTelephone.anonymous.link}}\" ng-bind=\"contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\nafin de résoudre le problème.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-20\"\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ui-sref=\"landing\"\u003EREVENIR À LA PAGE D'ACCUEIL\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"token\"\u003E\u003Cp\u003EVoici les informations relatives à votre régularisation :\u003C\u002Fp\u003E\u003Cdiv class=\"row marginb15\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EIDENTIFIANT CONTRAT :\u003C\u002Fp\u003E{{ token.id_contract }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EPOINT DE LIVRAISON :\u003C\u002Fp\u003E{{ token.id_prm | prm }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EADRESSE :\u003C\u002Fp\u003E{{ token.addr_num_street }}\u003Cbr ng-if=\"contractDraft.addr_details\"\u003E{{ token.addr_details }}\u003Cbr ng-if=\"contractDraft.addr_bat\"\u003E{{ token.addr_bat }}\u003Cbr ng-if=\"contractDraft.addr_locality\"\u003E{{ token.addr_locality }}\u003Cbr\u003E{{ token.addr_post_code }} {{ token.addr_city_lbl }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EMONTANT :\u003C\u002Fp\u003E{{ token.amount | frAmount }} €\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EPour continuer vers notre partenaire de paiement par carte bancaire, cliquez sur RÉGLER.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': isLoading}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ui-sref=\"landing\"\u003EANNULER\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"isLoading\"\u003ERÉGLER {{ token.amount | frAmount }} €\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ccampaign-landing-template campaign=\"currentCampaign\" state-params=\"stateParams\"\u003E\u003C\u002Fcampaign-landing-template\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"fb-root\"\u003E\u003C\u002Fdiv\u003E\u003Cscript\u003E(function(d, s, id) {\n  var js, fjs = d.getElementsByTagName(s)[0];\n  if (d.getElementById(id)) return;\n  js = d.createElement(s); js.id = id;\n  js.src = \"\u002F\u002Fconnect.facebook.net\u002Ffr_FR\u002Fsdk.js#xfbml=1&version=v2.9\";\n  fjs.parentNode.insertBefore(js, fjs);\n}(document, 'script', 'facebook-jssdk'));\n\u003C\u002Fscript\u003E\u003Cdiv class=\"confirm-newsletter\"\u003E\u003Cheader\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 confirm-newsletter-header-title\"\u003E\u003Ch1\u003ELes éclairages\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 confirm-newsletter-header-img\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002FconfirmNewsletter\u002Flogo_plum_lighting.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Csection\u003E\u003Cp\u003EVotre avis a bien été pris en compte, merci !\u003C\u002Fp\u003E\u003Cimg class=\"mailbox\" src=\"\u002Fassets\u002Fimg\u002FconfirmNewsletter\u002Fmailbox.gif\"\u003E\u003Cp\u003EEnvie de nous donner un petit coup de pouce ?\u003C\u002Fp\u003E\u003Cp\u003ECliquez sur « J’aime cette Page » et suivez nos aventures sur facebook !\u003C\u002Fp\u003E\u003Cdiv class=\"facebook\"\u003E\u003Cdiv class=\"fb-page\" data-href=\"https:\u002F\u002Fwww.facebook.com\u002FPlumEnergie\u002F\" data-width=\"500\" data-tabs=\"timeline\" data-small-header=\"false\" data-adapt-container-width=\"true\" data-hide-cover=\"false\" data-show-facepile=\"true\"\u003E\u003Cblockquote class=\"fb-xfbml-parse-ignore\" cite=\"https:\u002F\u002Fwww.facebook.com\u002FPlumEnergie\u002F\"\u003E\u003Ca href=\"https:\u002F\u002Fwww.facebook.com\u002FPlumEnergie\u002F\"\u003EPlüm énergie\u003C\u002Fa\u003E\u003C\u002Fblockquote\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"endSubscription\"\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003Cspan\u003EMa commande Plüm énergie\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"navbar-text\"\u003EMa commande Plüm énergie\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\" ng-show=\"displayForm\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cend-subscription-initial class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\" ng-if=\"state === 'state-initial'\"\u003E\u003C\u002Fend-subscription-initial\u003E\u003Cend-subscription-error-no-contract class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\" ng-if=\"state === 'state-error-no-contract'\"\u003E\u003C\u002Fend-subscription-error-no-contract\u003E\u003Cend-subscription-error-other class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\" ng-if=\"state === 'state-error-other'\"\u003E\u003C\u002Fend-subscription-error-other\u003E\u003Cend-subscription-error-payment-refused class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\" ng-if=\"state === 'state-error-payment-refused'\" contract=\"contract\"\u003E\u003C\u002Fend-subscription-error-payment-refused\u003E\u003Cend-subscription-retraction-form class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\" ng-if=\"state === 'state-end-retraction-form'\" on-state-end=\"updateViewState('RETRACTION-FORM-FINISHED')\" contract=\"contract\"\u003E\u003C\u002Fend-subscription-retraction-form\u003E\u003Cend-subscription-goal-form class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\" ng-if=\"state === 'state-end-goal-form'\" on-state-end=\"updateViewState('GOAL-FORM-FINISHED')\" contract=\"contract\"\u003E\u003C\u002Fend-subscription-goal-form\u003E\u003Cend-subscription-finish class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\" ng-if=\"state === 'state-end-finish'\"\u003E\u003C\u002Fend-subscription-finish\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"endSubscription\"\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003Cspan\u003EMa commande Plüm énergie\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"navbar-text\"\u003EMa commande Plüm énergie\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cend-subscription-error-payment-refused class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\" contract=\"contract\"\u003E\u003C\u002Fend-subscription-error-payment-refused\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


statesRun.$inject = ["featuresService", "$rootScope"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = statesRun;

/** @ngInject */

function statesRun(featuresService, $rootScope) {
    return $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
        $rootScope.previousState = from.name;
        $rootScope.currentState = to.name;
    });
}

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


uiMaskRun.$inject = ["uiMaskConfig"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uiMaskRun;

/** @ngInject */

function uiMaskRun(uiMaskConfig) {
    uiMaskConfig.clearOnBlur = false;

    // Fix input bug on android device
    // https://github.com/angular-ui/ui-mask/pull/26
    var isAndroid = /(android)/i.test(navigator.userAgent);
    if (isAndroid) {
        var index = uiMaskConfig.eventsToHandle.indexOf('input');
        return uiMaskConfig.eventsToHandle.splice(index, 1);
    }
}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _numeral = __webpack_require__(132);

var _numeral2 = _interopRequireDefault(_numeral);

__webpack_require__(709);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = numeralConfig;

/** @ngInject */

function numeralConfig() {
    // switch between locales
    _numeral2.default.locale('fr');
}

/***/ }),
/* 709 */,
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = avatar;

/** @ngInject */

function avatar() {
    return {
        restrict: 'E',
        template: __webpack_require__(711)(),
        scope: {
            user: '='
        }
    };
}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{user.userslug}}\" target=\"_self\"\u003E\u003Cspan class=\"profile\" ng-if=\"!user.picture\" ng-style=\"{'background-color': user['icon:bgColor']}\"\u003E{{user[\"icon:text\"]}}\u003C\u002Fspan\u003E\u003Cspan class=\"profile\" ng-if=\"user.picture\" ng-style=\"{'background-image': 'url({{ user['picture'] }})'}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartInfo.$inject = ["Chart", "ApiService", "DeviceChecker"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = chartInfo;

/** @ngInject */

function chartInfo(Chart, ApiService, DeviceChecker) {
    return {
        restrict: 'E',
        template: __webpack_require__(713)(),
        scope: {
            hasPot: '=',
            userInfo: '=',
            data: '=info'
        },
        link: function link($scope) {
            $scope.isMobile = DeviceChecker.isMobile;

            $scope.$watch('userInfo', function () {
                if ($scope.userInfo.contractSelected) {
                    $scope.userIsBase = $scope.userInfo.contractSelected.plan === 'Base';
                    $scope.isLinkyCommunicating = $scope.userInfo.contractSelected.prm.communicating;
                    if ($scope.userInfo.contractSelected.nextPayment) {
                        $scope.paymentDay = (0, _moment2.default)($scope.userInfo.contractSelected.nextPayment.date).date();
                        $scope.paymentMoment = (0, _moment2.default)($scope.userInfo.contractSelected.nextPayment.date).format('DD MMMM YYYY');
                    }
                }
            });

            return Chart.watch.activeIndex(function (newIndex) {
                if ($scope.data) {
                    $scope.info = $scope.data[newIndex];
                    if (!$scope.$$phase) {
                        $scope.$digest();
                    }
                }
            });
        }
    };
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"tracking-info\" ng-class=\"{'text-center': isMobile()}\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-3\"\u003EMENSUALITÉ\u003Cdiv class=\"value\" ng-class=\"{marginb15: isMobile()}\"\u003E{{ info.mensuality }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003EDATE DE PRÉLÈVEMENT\u003Cdiv class=\"value\" ng-if=\"info.paymentMonth\" ng-class=\"{marginb15: isMobile()}\"\u003E{{ paymentDay }} {{ info.paymentMonth }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\" ng-if=\"!info.paymentMonth\" ng-class=\"{marginb15: isMobile()}\"\u003E-\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003EMONTANT\u003Cdiv ng-if=\"!info.amountWithModifs || info.amountWithModifs == info.amount\"\u003E\u003Cdiv class=\"value\" ng-class=\"{marginb15: isMobile()}\"\u003E{{ info.paid }}\u003Cspan ng-show=\"info.paid != 'En attente'\"\u003E€\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"(info.amountWithModifs &gt; 0 || info.amountWithModifs &lt; 0) &amp;&amp; info.amountWithModifs !== info.amount\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-offset-4 col-xs-8 col-sm-offset-0 col-sm-12\"\u003E\u003Cspan class=\"pull-left\"\u003ENon lissé\u003C\u002Fspan\u003E\u003Cdiv class=\"value buffer-left pull-left\" ng-class=\"{marginb15: isMobile()}\"\u003E{{ info.paid }}\u003Cspan ng-show=\"info.paid != 'En attente'\"\u003E€\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-offset-4 col-xs-8 col-sm-offset-0 col-sm-12\"\u003E\u003Cspan class=\"pull-left\"\u003ELissé\u003C\u002Fspan\u003E\u003Cdiv class=\"value buffer-left pull-left\" ng-class=\"{marginb15: isMobile()}\"\u003E{{ info.amountWithModifs | frAmount }}\u003Cspan ng-show=\"info.paid != 'En attente'\"\u003E€\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\" ng-if=\"hasPot\" ng-show=\"info.pot.type == 'earned' || isLinkyCommunicating\"\u003ECAGNOTTE\u003Cdiv class=\"value\" ng-class=\"{marginb15: isMobile()}\"\u003E{{ info.pot.value }}\u003Cspan ng-show=\"info.pot.value != 'En attente'\"\u003E€\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\" ng-if=\"hasPot\" ng-show=\"info.pot.type != 'earned' &amp;&amp; !isLinkyCommunicating\"\u003ECAGNOTTE ESTIMÉE\u003Cdiv class=\"value\" ng-class=\"{marginb15: isMobile()}\"\u003E{{ info.pot.value }}\u003Cspan ng-show=\"info.pot.value != 'En attente'\"\u003E€\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv uib-collapse=\"info.paid == 'En attente'\"\u003E\u003Cdiv class=\"separator\" ng-class=\"{'chart-separator': isMobile()}\"\u003E\u003C\u002Fdiv\u003E\u003Cp ng-show=\"!info.prediction\"\u003EComment ma mensualité est-elle calculée ?\u003C\u002Fp\u003E\u003Cp ng-show=\"info.prediction\"\u003ECette mensualité est donnée à titre indicatif, elle sera recalculée après la relève d'un technicien Enedis.\u003C\u002Fp\u003E\u003Ctable class=\"hidden-xs\"\u003E\u003Ctr\u003E\u003Ctd\u003EABONNEMENT&nbsp;\u003Cspan class=\"fa fa-question-circle\" uib-popover-template=\"'subscription'\" popover-trigger=\"mouseenter\"\u003E\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003ECONSOMMATION ESTIMÉE&nbsp;\u003Cspan class=\"fa fa-question-circle\" uib-popover-template=\"'estimatedCons'\" popover-trigger=\"mouseenter\"\u003E\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003ECONTRIBUTIONS PUBLIQUES&nbsp;\u003Cspan class=\"fa fa-question-circle\" uib-popover-template=\"'taxes'\" popover-trigger=\"mouseenter\"\u003E\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd class=\"large-amount\"\u003E{{ info.subscription }}€\u003C\u002Ftd\u003E\u003Ctd class=\"large-amount\"\u003E{{ info.consumption }}€\u003C\u002Ftd\u003E\u003Ctd class=\"large-amount\"\u003E{{ info.taxes }}€\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003Cdiv class=\"visible-xs\"\u003E\u003Cdiv\u003EABONNEMENT&nbsp;\u003Cspan class=\"fa fa-question-circle\" uib-popover-template=\"'subscription'\" popover-trigger=\"mouseenter\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"large-amount\"\u003E{{ info.subscription }}€\u003C\u002Fspan\u003E\u003Cdiv\u003ECONSOMMATION ESTIMÉE&nbsp;\u003Cspan class=\"fa fa-question-circle\" uib-popover-template=\"'estimatedCons'\" popover-trigger=\"mouseenter\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"large-amount\"\u003E{{ info.consumption }}€\u003C\u002Fspan\u003E\u003Cdiv\u003ECONTRIBUTIONS PUBLIQUES&nbsp;\u003Cspan class=\"fa fa-question-circle\" uib-popover-template=\"'taxes'\" popover-trigger=\"mouseenter\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"large-amount\"\u003E{{ info.taxes }}€\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"subscription\"\u003E\u003Cdiv\u003EPrix de l'abonnement pour une puissance de {{userInfo.contractSelected.max_power}} kVA avec l'option {{userInfo.contractSelected.plan}} :\n{{info.subscription}} € TTC\u002Fmois\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"estimatedCons\"\u003E\u003Cdiv\u003EPrix pour votre consommation {{ info.date|amDateFormat:'MMMM' | elision }} estimée à\n\u003Cspan ng-if=\"info.estimatedCons.base\"\u003E{{info.estimatedCons.base}} kWh\u003C\u002Fspan\u003E\n\u003Cspan ng-if=\"info.estimatedCons.base && info.estimatedCons.hp\"\u003E,\u003C\u002Fspan\u003E\n\u003Cspan ng-if=\"info.estimatedCons.hp\"\u003E{{info.estimatedCons.hp}} kWh en heures pleines\u003C\u002Fspan\u003E\n\u003Cspan ng-if=\"info.estimatedCons.hc\"\u003Eet {{info.estimatedCons.hc}} kWh en heures creuses\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"taxes\"\u003E\u003Cdiv\u003EVotre facture comprend 3 différentes contributions publiques :\u003Cul\u003E\n\u003Cli\u003Ela contribution aux charges de service public de l’électricité\u003C\u002Fli\u003E\n\u003Cli\u003Ela contribution tarifaire d’acheminement\u003C\u002Fli\u003E\n\u003Cli\u003Ela taxe sur la consommation finale de l’électricité\u003C\u002Fli\u003E\n\u003C\u002Ful\u003E\n\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartMonth.$inject = ["Chart"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = chartMonth;

/** @ngInject */

function chartMonth(Chart) {
    return {
        restrict: 'E',
        template: '<div ng-class="{active: active}"><p>{{month}}</p></div>',
        scope: {
            index: '=',
            month: '='
        },
        link: function link(scope) {
            scope.active = false;
            return Chart.watch.activeIndex(function (newIndex) {
                if (newIndex === scope.index) {
                    scope.active = true;
                } else {
                    scope.active = false;
                }
                if (!scope.$$phase) {
                    return scope.$digest();
                }
            });
        }
    };
}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartPotImage.$inject = ["Chart"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = chartPotImage;

/** @ngInject */

function chartPotImage(Chart) {
    return {
        restrict: 'E',
        template: __webpack_require__(716)(),
        scope: {
            pot: '='
        }
    };
}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"chart-pot-image\" ng-show=\"pot.value != 'En attente' &amp;&amp; pot.value != '0,00'\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcochon.png\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = circleRating;

/** @ngInject */

function circleRating() {
    return {
        restrict: 'E',
        template: __webpack_require__(718)(),
        scope: {
            grade: '='
        },
        link: function link(scope) {
            return scope.$watch('grade', function () {
                var rest = 3 - Number(scope.grade);
                if (scope.grade !== 0) {
                    scope.gradeRange = __range__(1, scope.grade, true);
                } else {
                    scope.gradeRange = [];
                }
                if (rest !== 0) {
                    scope.restRange = __range__(1, rest, true);
                } else {
                    scope.restRange = [];
                }
            });
        }
    };
}

function __range__(left, right, inclusive) {
    var range = [];
    var ascending = left < right;
    var end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for (var i = left; ascending ? i < end : i > end; ascending ? i += 1 : i -= 1) {
        range.push(i);
    }
    return range;
}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-circle full\" ng-repeat=\"i in gradeRange\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"fa fa-circle empty\" ng-repeat=\"i in restRange\"\u003E\u003C\u002Fi\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


clampDirective.$inject = ["$timeout"];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
exports.default = clampDirective;

/** @ngInject */

function clampDirective($timeout) {
  var clampDiv = void 0,
      clampCss = void 0;
  var directive = {
    restrict: 'A',
    link: linkDirective
  };

  return directive;

  function linkDirective(scope, element, attrs) {
    // Setup clamp div if not
    if ((0, _jquery2.default)('#clamp-directive').length) {
      clampDiv = (0, _jquery2.default)('#clamp-directive');
    } else {
      clampDiv = (0, _jquery2.default)('<div id="clamp-directive" />').css({
        position: 'fixed',
        bottom: 0,
        left: 0,
        color: 'transparent',
        padding: 0,
        margin: 0
      });
      (0, _jquery2.default)('body').append(clampDiv);
    }

    $timeout(function () {
      var lineCount = 1,
          lineMax = +attrs.clamp;
      var lineStart = 0,
          lineEnd = 0;
      var text = element.html().replace(/\n/g, ' ') + ' '; // add space at end, if not last word not detected
      // let maxWidth = element[0].offsetWidth;
      var maxWidth = element.width() || element.parent().width();
      var estimateTag = createElement();

      clampCss = getCssElement(element);

      // Add gutter padding
      maxWidth -= parseInt(clampCss['padding-left'], 10) + parseInt(clampCss['padding-right'], 10);

      // Add clamp-width="max width" to force width
      if (attrs.clampWidth) maxWidth = +attrs.clampWidth;

      estimateTag.css(clampCss);
      element.empty();
      clampDiv.append(estimateTag);

      text.replace(/ /g, function (m, pos) {
        estimateTag.html(text.slice(lineStart, pos));
        if (estimateTag.width() >= maxWidth && lineCount < lineMax) {
          var clampTag = createElement();
          resetElement(clampTag);
          clampTag.html(text.slice(lineStart, lineEnd));
          element.append(clampTag);

          lineCount++;
          lineStart = lineEnd + 1;
          estimateTag.css('text-indent', 'initial');
        }
        lineEnd = pos;

        if (pos + 1 >= text.length) {
          var _clampTag = createElement();
          resetElement(_clampTag, true);
          _clampTag.html(text.slice(lineStart));
          element.append(_clampTag);
          estimateTag.remove();
        }
      });
      estimateTag.html(text.slice(lineStart));
      resetElement(estimateTag, true);

      scope.$emit('clampCallback', element, attrs);
    });
  }
}

function getCssElement(element) {
  return {
    'font-family': getComputedStyle(element, 'font-family'),
    'font-size': getComputedStyle(element, 'font-size'),
    'font-weight': getComputedStyle(element, 'font-weight'),
    'text-indent': getComputedStyle(element, 'text-indent'),
    'letter-spacing': getComputedStyle(element, 'letter-spacing'),
    'word-spacing': getComputedStyle(element, 'word-spacing'),
    'padding-left': getComputedStyle(element, 'padding-left'),
    'padding-right': getComputedStyle(element, 'padding-right')
  };
}

function getComputedStyle(element, property) {
  var el = element[0];
  if (el.style[property]) return el.style[property];
  if (window.getComputedStyle) return document.defaultView.getComputedStyle(el).getPropertyValue(property);
}

function createElement() {
  var tagDiv = document.createElement('div');
  (function (s) {
    // s.position = 'absolute';
    s.whiteSpace = 'pre';
    s.visibility = 'hidden';
    s.display = 'inline-block';
  })(tagDiv.style);

  return _angular2.default.element(tagDiv);
}

function resetElement(element, type) {
  element.css({
    // position: 'inherit',
    overflow: 'hidden',
    display: 'block',
    textOverflow: type ? 'ellipsis' : 'clip',
    visibility: 'inherit',
    whiteSpace: 'nowrap',
    width: '100%'
  });
}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


cookiesBar.$inject = ["$rootScope", "CookiesService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cookiesBar;

/** @ngInject */

function cookiesBar($rootScope, CookiesService) {
    return {
        restrict: 'E',
        template: __webpack_require__(721)(),
        scope: true,
        link: function link(scope) {
            scope.cookiesAccepted = CookiesService.checkCookiesAcceptance();
            scope.acceptCookies = function () {
                return CookiesService.acceptCookies();
            };
            $rootScope.$on('cookiesAccepted', function () {
                scope.cookiesAccepted = true;
            });
        }
    };
}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"cookies-bar background-marine white\" ng-if=\"!cookiesAccepted\"\u003E\u003Cp\u003ENous utilisons des cookies pour améliorer votre expérience sur ce site. \u003Cbr\u003E\nEn cliquant sur n'importe quel lien de cette page, vous donnez votre consentement pour leur utilisation.\u003C\u002Fp\u003E\u003Ci class=\"fa fa-2x fa-remove\" ng-click=\"acceptCookies()\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cookies-bar cookies-bar-relative background-marine white\" ng-if=\"!cookiesAccepted\"\u003E\u003Cp\u003ENous utilisons des cookies pour améliorer votre expérience sur ce site. \u003Cbr\u003E\nEn cliquant sur n'importe quel lien de cette page, vous donnez votre consentement pour leur utilisation.\u003C\u002Fp\u003E\u003Ci class=\"fa fa-2x fa-remove\" ng-click=\"acceptCookies()\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = emailForm;

/** @ngInject */

function emailForm() {
    return {
        restrict: 'E',
        template: __webpack_require__(723)(),
        scope: {
            buttontext: '@',
            buttonbackgroundcolor: '@',
            buttontextcolor: '@',
            emailplaceholder: '@placeholder',
            right: '@',
            left: '@',
            bottom: '@',
            top: '@'
        },
        link: function link(scope) {
            scope.formStyle = {
                position: 'absolute',
                height: '34px',
                right: scope.right,
                left: scope.left,
                bottom: scope.bottom,
                top: scope.top,
                width: '400px',
                margin: 'auto'
            };
            scope.inputStyle = {
                'background-color': '#fff',
                'border': '1px solid #ccc',
                'border-radius': '4px',
                'color': '#555555',
                'font-size': '14px',
                'height': '34px',
                'padding': '6px 12px',
                'width': '250px'
            };
            scope.buttonStyle = {
                'display': 'inline-block',
                'color': scope.buttontextcolor,
                'background-color': scope.buttonbackgroundcolor
            };
        }
    };
}

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"form-inline\" ng-style=\"formStyle\" ng-submit=\"$parent.submit()\"\u003E\u003Cinput class=\"form-control\" id=\"email\" type=\"email\" required ng-model=\"$parent.email\" ng-style=\"inputStyle\" placeholder=\"{{emailplaceholder}}\"\u003E\u003Cbutton class=\"btn\" type=\"submit\" ng-style=\"buttonStyle\"\u003E{{buttontext}}\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _range2 = __webpack_require__(725);

var _range3 = _interopRequireDefault(_range2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = dateField;

/** @ngInject */

function dateField() {
    return {
        restrict: 'E',
        template: __webpack_require__(728)(),
        scope: {
            date: '=',
            min: '=',
            max: '='
        },
        link: function link($scope) {
            var now = (0, _moment2.default)($scope.date);
            $scope.dateObj = {
                day: now.date(),
                month: now.month() + 1,
                year: now.year()
            };
            $scope.days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
            $scope.months = [{ label: 'janvier', value: 1 }, { label: 'février', value: 2 }, { label: 'mars', value: 3 }, { label: 'avril', value: 4 }, { label: 'mai', value: 5 }, { label: 'juin', value: 6 }, { label: 'juillet', value: 7 }, { label: 'août', value: 8 }, { label: 'septembre', value: 9 }, { label: 'octobre', value: 10 }, { label: 'novembre', value: 11 }, { label: 'décembre', value: 12 }];
            var year = (0, _moment2.default)().year();
            var minYear = $scope.min ? (0, _moment2.default)($scope.min).year() : year;
            var maxYear = $scope.max ? (0, _moment2.default)($scope.max).year() : year + 1;
            $scope.years = (0, _range3.default)(minYear, maxYear + 1);

            $scope.checkDate = function () {
                if ($scope.dateObj.day && $scope.dateObj.month && $scope.dateObj.year) {
                    var date = (0, _moment2.default)($scope.dateObj.year + '-' + $scope.dateObj.month + '-' + $scope.dateObj.day, 'YYYY-M-D');
                    while (!date.isValid()) {
                        $scope.dateObj.day -= 1;
                        date = (0, _moment2.default)($scope.dateObj.year + '-' + $scope.dateObj.month + '-' + $scope.dateObj.day, 'YYYY-M-D');
                    }
                    $scope.date = date;
                    return true;
                }
                return false;
            };
        }
    };
}

/***/ }),
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cselect class=\"form-control inline\" type=\"select\" ng-model=\"dateObj.day\" ng-options=\"d as d for d in days\" ng-change=\"checkDate()\"\u003E\u003C\u002Fselect\u003E\u003Cspan\u003E&nbsp;\u002F&nbsp;\u003C\u002Fspan\u003E\u003Cselect class=\"form-control inline\" type=\"select\" ng-model=\"dateObj.month\" ng-options=\"m.value as m.label for m in months\" ng-change=\"checkDate()\"\u003E\u003C\u002Fselect\u003E\u003Cspan\u003E&nbsp;\u002F&nbsp;\u003C\u002Fspan\u003E\u003Cselect class=\"form-control inline\" type=\"select\" ng-model=\"dateObj.year\" ng-options=\"y as y for y in years\" ng-change=\"checkDate()\"\u003E\u003C\u002Fselect\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = forceUppercase;


function forceUppercase() {
    return {
        restrict: 'C',
        require: 'ngModel',
        link: function link(scope, element, attrs, modelCtrl) {
            var capitalize = function capitalize() {
                var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                var capitalized = inputValue.toUpperCase();
                if (capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                }
                return capitalized;
            };

            modelCtrl.$parsers.push(capitalize);
            return capitalize(scope[attrs.ngModel]);
        }
    };
}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


hint.$inject = ["ImplementationToText", "DeviceChecker", "Hint", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hint;

/** @ngInject */

function hint(ImplementationToText, DeviceChecker, Hint, ErrorCatcher) {
    return {
        restrict: 'E',
        template: __webpack_require__(731)(),
        scope: {
            hint: '=',
            state: '@',
            large: '=',
            hintClass: '='
        },
        link: function link(scope, element, attrs) {
            scope.max = 5;
            scope.rate = scope.hint.rating ? scope.hint.rating : 0;

            scope.implementationToText = function (implementation) {
                return ImplementationToText[implementation];
            };
            scope.columnSize = function (state) {
                return { flow: 'col-sm-3', hints: 'col-sm-4' }[state] || 'col-sm-4';
            };
            scope.isMobile = function () {
                return DeviceChecker.isMobile();
            };
            scope.saveRating = function (rating) {
                return Hint.saveComment({ id_hint: scope.hint._id, rating: rating }).$promise.catch(ErrorCatcher.catchError);
            };
        }
    };
}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"hint-image hidden-xs\" ng-if=\"large &amp;&amp; state == 'hints'\"\u003E\u003Cdiv\u003E{{hint.room[0] | uppercase}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hint-container\" ng-class=\"{'width-desktop': !isMobile(), 'width-mobile': isMobile()}\"\u003E\u003Cdiv class=\"hint-room\" ng-if=\"hint.room[0] &amp;&amp; !large\"\u003E\u003Cspan class=\"iconHintRoom\" ng-class=\"hintClass\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"nameHintRoom\"\u003E{{hint.room[0]}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Ch4 class=\"hint-title\" ng-class=\"{'col-xs-10': large}\"\u003E{{hint.title}}\u003C\u002Fh4\u003E\u003Cdiv class=\"hint-body\"\u003E\u003Cdiv class=\"hint-ratings\" ng-if=\"large\"\u003E\u003Cplum-feature feature-name=\"hintRating\"\u003E\u003Cdiv class=\"row\" ng-if=\"$root.dataFeature['hintRating']\"\u003E\u003Cdiv class=\"col-xs-12 star-rating\"\u003E\u003Cuib-rating ng-model=\"rate\" max=\"max\" ng-click=\"saveRating(rate)\"\u003E\u003C\u002Fuib-rating\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fplum-feature\u003E\u003Cdiv class=\"row circle-rating\"\u003E\u003Cp ng-class=\"columnSize(hint.state)\"\u003EÉconomie\u003C\u002Fp\u003E\u003Ccircle-rating class=\"col-sm-3\" grade=\"hint.saving\"\u003E\u003C\u002Fcircle-rating\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row circle-rating\"\u003E\u003Cp ng-class=\"columnSize(hint.state)\"\u003EInvestissement\u003C\u002Fp\u003E\u003Ccircle-rating class=\"col-sm-3\" grade=\"hint.investment\"\u003E\u003C\u002Fcircle-rating\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row text-rating\"\u003E\u003Cp ng-class=\"columnSize(hint.state)\"\u003EMise en œuvre\u003C\u002Fp\u003E\u003Cdiv class=\"col-sm-3\"\u003E{{implementationToText(hint.implementation)}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tip\" ng-if=\"large\"\u003E\u003Cp class=\"strong\"\u003E{{hint.summary}}\u003C\u002Fp\u003E\u003Cp ng-bind-html=\"hint.body | rawHtml\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-tip\" ng-if=\"!large\"\u003E\u003Cdiv\u003E\u003Cp clamp=\"5\" ng-bind=\"hint.summary\"\u003E\u003C\u002Fp\u003E\u003Cp\u003EVoir en grand\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!--.hint-footer(ng-class=\"{centered: large}\" ng-if=\"state == 'hints'\")--\u003E\u003C!--  button.btn.btn-try(ng-if=\"large\")--\u003E\u003C!--    i.fa.fa-plus--\u003E\u003C!--    | Je souhaite essayer ce conseil--\u003E\u003C!--  span {{large ? 'XXX MEMBRES ESSAYENT AUSSI CE CONSEIL' : 'ESSAYÉ PAR XX MEMBRES'}}--\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navbarWhiteBackground.$inject = ["$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navbarWhiteBackground;

/** @ngInject */

function navbarWhiteBackground($timeout) {
    return {
        restrict: 'C',
        link: {
            post: function post(scope, element) {
                var getHeaderHeight = function getHeaderHeight() {
                    var $navLanding = _angular2.default.element('header.nav-landing')[0];
                    if ($navLanding) {
                        return $navLanding.getBoundingClientRect().height;
                    }
                    return 0;
                };

                var updateOpacity = function updateOpacity() {
                    var headerHeight = getHeaderHeight();
                    var viewportTop = _angular2.default.element(window).scrollTop();
                    var displayBackground = viewportTop > headerHeight - 72;
                    if (displayBackground || element.has('.in').length > 0) {
                        return element.addClass('navbar-white-background-active');
                    }
                    return element.removeClass('navbar-white-background-active');
                };

                (0, _jquery2.default)(window).on('scroll.navbarWhiteBackground', updateOpacity);
                element.on('click.navbarWhiteBackground', function () {
                    return $timeout(updateOpacity, 10);
                });
                $timeout(updateOpacity);

                return scope.$on('$destroy', function () {
                    element.off('.navbarWhiteBackground');
                    return (0, _jquery2.default)(window).off('.navbarWhiteBackground');
                });
            }
        }
    };
}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navbarOpacity.$inject = ["$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navbarOpacity;

/** @ngInject */

function navbarOpacity($timeout) {
    return {
        restrict: 'C',
        link: {
            post: function post(scope, element) {
                var getHeaderHeight = function getHeaderHeight() {
                    var $navLanding = _angular2.default.element('header.nav-landing')[0];
                    if ($navLanding) {
                        return $navLanding.getBoundingClientRect().height;
                    }
                    return 0;
                };

                var updateOpacity = function updateOpacity() {
                    var headerHeight = getHeaderHeight();
                    var offsetBegin = headerHeight / 3;
                    var offsetEnd = headerHeight - 72;
                    var viewportTop = _angular2.default.element(window).scrollTop();
                    if (viewportTop < offsetBegin) {
                        element.css('opacity', 0);
                        return element.css('visibility', 'hidden');
                    } else if (viewportTop > offsetEnd) {
                        element.css('opacity', 100);
                        return element.css('visibility', 'visible');
                    }
                    element.css('opacity', (viewportTop - offsetBegin) / (offsetEnd - offsetBegin));
                    return element.css('visibility', 'visible');
                };

                (0, _jquery2.default)(window).on('scroll.navbarOpacity', updateOpacity);
                $timeout(updateOpacity);

                return scope.$on('$destroy', function () {
                    return (0, _jquery2.default)(window).off('.navbarOpacity');
                });
            }
        }
    };
}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


landscapeCanvas.$inject = ["$location", "$state", "$stateParams", "LandscapeElements"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = landscapeCanvas;

/** @ngInject */

function landscapeCanvas($location, $state, $stateParams, LandscapeElements) {
    return {
        restrict: 'E',
        replace: true,
        template: __webpack_require__(735)(),
        scope: {},
        link: function link(scope, element, attrs) {
            scope.LE = LandscapeElements;
            scope.$watchCollection('LE.LandscapeElements', function (landscapeElements) {
                scope.landscapeElements = landscapeElements;
            });
        }
    };
}

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"landscape-canvas\"\u003E\u003Cimg class=\"landscape-elem\" ng-repeat=\"element in landscapeElements | orderBy:element.id_question track by $index \" ng-if=\"element.img\" ng-src=\"{{element.img}}\"\u003E\u003Cimg id=\"buisson\" src=\"\u002Fassets\u002Fimg\u002Fbuisson.png\"\u003E\u003Cimg id=\"arbre-1\" src=\"\u002Fassets\u002Fimg\u002Farbre-2.png\"\u003E\u003Cimg id=\"arbre-2\" src=\"\u002Fassets\u002Fimg\u002Farbre-2.png\"\u003E\u003Cimg id=\"arbre-3\" src=\"\u002Fassets\u002Fimg\u002Farbre-1.png\"\u003E\u003Cimg id=\"cloud-1\" src=\"\u002Fassets\u002Fimg\u002Fcloud-1.png\"\u003E\u003Cimg id=\"cloud-2\" src=\"\u002Fassets\u002Fimg\u002Fcloud-2.png\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


landscapeForm.$inject = ["$rootScope", "$location", "$state", "$stateParams", "LandscapeQuestions", "$sce", "AlertManager", "$timeout", "$compile", "BubblesService", "LandscapeElements", "DeviceChecker", "ErrorCatcher", "$uibModal"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isBoolean2 = __webpack_require__(292);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _startsWith2 = __webpack_require__(293);

var _startsWith3 = _interopRequireDefault(_startsWith2);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable
                                                                                                                                                                                                                                                                               block-scoped-var,
                                                                                                                                                                                                                                                                               complexity,
                                                                                                                                                                                                                                                                               guard-for-in,
                                                                                                                                                                                                                                                                               max-depth,
                                                                                                                                                                                                                                                                               max-statements-per-line,
                                                                                                                                                                                                                                                                               no-eq-null,
                                                                                                                                                                                                                                                                               no-self-assign,
                                                                                                                                                                                                                                                                               no-sequences,
                                                                                                                                                                                                                                                                               no-template-curly-in-string,
                                                                                                                                                                                                                                                                               no-unused-expressions,
                                                                                                                                                                                                                                                                               no-use-before-define,
                                                                                                                                                                                                                                                                               no-var,
                                                                                                                                                                                                                                                                               one-var,
                                                                                                                                                                                                                                                                               radix,
                                                                                                                                                                                                                                                                               no-plusplus,
                                                                                                                                                                                                                                                                               no-return-assign,
                                                                                                                                                                                                                                                                               no-nested-ternary,
                                                                                                                                                                                                                                                                               no-unused-vars,
                                                                                                                                                                                                                                                                               vars-on-top,
                                                                                                                                                                                                                                                                               no-multi-assign,
                                                                                                                                                                                                                                                                               no-restricted-syntax,
                                                                                                                                                                                                                                                                               no-console,
                                                                                                                                                                                                                                                                               no-empty,
                                                                                                                                                                                                                                                                               */
// Should remove eslint after merging landscape between website & backoffice


var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = landscapeForm;

/** @ngInject */

function landscapeForm($rootScope, $location, $state, $stateParams, LandscapeQuestions, $sce, AlertManager, $timeout, $compile, BubblesService, LandscapeElements, DeviceChecker, ErrorCatcher, $uibModal) {
    return {
        restrict: 'E',
        replace: true,
        template: __webpack_require__(738)(),
        scope: {
            questions: '=',
            contractSelected: '=',
            displayEndModal: '=',
            onLandscapeDone: '&?'
        },
        link: {
            pre: function pre(scope, element, attrs) {
                scope.id_contract = scope.contractSelected.id;
                scope.isDraft = Boolean(scope.contractSelected.isDraft);
                scope.heating = null;
                scope.primary_residence = null;
                scope.img_path = '/assets/img/landscape_form';
                scope.questionsI = 0;
                scope.disableBack = false;
                scope.landscapeDone = false;
                scope.currentStep = parseInt($stateParams.step);
                scope.errors = [];
                BubblesService.displayed = false;
                BubblesService.flush();
                var tmpNextQuestion = null;

                scope.isSubscriptionState = function (currentState) {
                    return (0, _startsWith3.default)(currentState, 'subscription');
                };

                LandscapeElements.LandscapeElements = [];
                scope.landscapeElements = LandscapeElements.LandscapeElements;

                scope.temperatureList = [{
                    tooltip: 'Économe',
                    value: 17,
                    color: '#455469'
                }, {
                    tooltip: 'Normal',
                    value: 18,
                    color: '#455469'
                }, {
                    tooltip: 'Confortable',
                    value: 19,
                    color: '#c2395c'
                }, {
                    tooltip: 'Chaud',
                    value: 20,
                    color: '#c2395c'
                }, {
                    tooltip: 'Plus chaud',
                    value: 21,
                    color: '#c2395c'
                }];

                scope.answers = [];

                scope.steps = [{
                    label: 'C’est parti !',
                    category: 'c-est-parti',
                    active: false,
                    done: false,
                    notify: true,
                    navigation: false
                }, {
                    label: 'Mon logement',
                    category: 'logement',
                    active: false,
                    done: false,
                    notify: false,
                    show_progression: true,
                    navigation: true
                }, {
                    label: 'Ma situation',
                    category: 'situation',
                    active: false,
                    done: false,
                    notify: false,
                    show_progression: true,
                    navigation: true
                }, {
                    label: 'Mon énergie',
                    category: 'energie',
                    active: false,
                    done: false,
                    notify: false,
                    show_progression: true,
                    navigation: true
                }, {
                    label: 'Mes équipements',
                    category: 'equipement',
                    active: false,
                    done: false,
                    notify: false,
                    show_progression: true,
                    navigation: true
                }];

                scope.$on('landscapeNavigating', function () {
                    return scope.errors = [];
                });

                var watchStep = function watchStep(step) {
                    return function () {
                        var result = [];
                        for (var i = 0, end = scope.steps.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            var item = void 0;
                            scope.steps[i].done = i < step;
                            scope.steps[i].active = i === step;
                            if (i === step) {
                                scope.steps[step].done = false;
                                item = scope.steps[step].active = true;
                            }
                            result.push(item);
                        }
                        return result;
                    }();
                };

                scope.$watch('currentStep', watchStep, false);

                if ($stateParams.step && $stateParams.step < scope.steps.length && $stateParams.step > 0) {
                    scope.currentStep = parseInt($stateParams.step);
                } else if (!scope.questions || scope.questions.length === 1 && scope.questions[0][0].id === 1) {
                    scope.currentStep = 0;
                } else {
                    scope.currentStep = 1;
                }

                _angular2.default.forEach(scope.steps, function (value, index) {
                    if (scope.currentStep > parseInt(index)) {
                        value.done = true;
                    }

                    if (parseInt(index) === scope.currentStep) {
                        return value.active = true;
                    }
                });

                scope.toInt = function (value) {
                    return parseInt(value);
                };

                scope.printLabel = function (question, qBlock) {
                    // specific to question 6
                    var html = void 0,
                        label = void 0;
                    if (question.label.indexOf('{') > -1 && question.label.indexOf('}') > -1) {
                        label = question.label.slice(1);
                        label = label.slice(0, label.length - 1);
                        try {
                            var qJ = JSON.parse(label);
                            var prevQ = null;
                            for (var i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                                var block = scope.questions[i];
                                if (block === qBlock) {
                                    prevQ = scope.questions[i - 1];
                                }
                            }

                            var numberOfOccupiants = scope.answers[prevQ[1].id].value;
                            html = qJ.singular;
                            if (parseInt(numberOfOccupiants) > 1) {
                                html = qJ.plural;
                            }
                            html = html.replace('%d', numberOfOccupiants);
                            return $sce.trustAsHtml(html);
                        } catch (error) {
                            return label;
                        }
                    } else {
                        html = question.label;
                        return $sce.trustAsHtml(html);
                    }
                };

                scope.checkChangeNumber = function (answer, question) {
                    if (answer) {
                        if (parseInt(answer.value) > parseInt(question.max)) {
                            return answer.value = parseInt(question.max);
                        } else if (parseInt(answer.value) < parseInt(question.min)) {
                            return answer.value = parseInt(question.min);
                        }
                    }
                };

                scope.easterEgg = function () {
                    var elem = document.getElementById('hanger-right');
                    elem.style.display = 'none';

                    var hL = document.getElementById('hanger-left');
                    var formContainer = document.getElementById('form-container');

                    if (hL) {
                        hL.className += ' cut-it';

                        formContainer.style.transform = 'rotate(15deg)';
                        return formContainer.className += ' bounceRotate';
                    }
                };

                scope.getNextQuestion = function (question) {
                    if (question) {
                        if (question.next) {
                            return question.next;
                        } else if (question.answer_type === 'enum') {
                            for (var i = 0, end = question.enums.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                                if (question.answer === question.enums[i].value) {
                                    if (question.enums[i].next) {
                                        return question.enums[i].next;
                                    }
                                }
                            }
                        }
                    }

                    return null;
                };

                scope.isValid = function (answer, q) {
                    if (q.answer_type !== 'enum') {
                        answer.answer_func = answer.value;
                    }
                    var hasErr = false;
                    var qBlock = scope.getQuestionBlockById(q.id);
                    if (qBlock) {
                        var l = scope.getQlength(qBlock);
                        return function () {
                            var result = [];
                            for (var i = 0, end = l, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                                var item = void 0;
                                if (!hasErr) {
                                    if (qBlock[i].answer_type === 'number') {
                                        if (scope.answers[qBlock[i].id] && scope.answers[qBlock[i].id].value && scope.answers[qBlock[i].id].value !== '') {
                                            if (i === l - 1) {
                                                scope.errors = [];
                                            }
                                        } else {
                                            hasErr = true;
                                        }

                                        item = scope.checkChangeNumber(scope.answers[qBlock[i].id], q);
                                    } else if (scope.answers[qBlock[i].id] && scope.answers[qBlock[i].id].value && scope.answers[qBlock[i].id].value !== '') {
                                        if (i === l - 1) {
                                            item = scope.errors = [];
                                        }
                                    } else {
                                        item = hasErr = true;
                                    }
                                }
                                result.push(item);
                            }
                            return result;
                        }();
                    }
                };

                scope.getQuestionById = function (id_question) {
                    for (var i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        for (var it = 0, end1 = scope.getQlength(scope.questions[i]), asc1 = end1 >= 0; asc1 ? it < end1 : it > end1; asc1 ? it++ : it--) {
                            if (scope.questions[i][it].id === id_question) {
                                return scope.questions[i][it];
                            }
                        }
                    }
                };

                scope.getQuestionBlockById = function (id_question) {
                    for (var i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        for (var it = 0, end1 = scope.getQlength(scope.questions[i]), asc1 = end1 >= 0; asc1 ? it < end1 : it > end1; asc1 ? it++ : it--) {
                            if (scope.questions[i][it].id === id_question) {
                                return scope.questions[i];
                            }
                        }
                    }
                };

                var validateQuestion = function validateQuestion(question, l, source, index) {
                    var counter = 0;
                    var hasError = 0;

                    for (var i = 0, end = l, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        var it;
                        var id_question = question[i].id;
                        if (question[i].answer_type !== 'equipment' && question[i].answer_type !== 'multi') {
                            if (scope.answers[question[i].id] && scope.answers[question[i].id].value && !hasError) {
                                scope.errors = [];
                                counter++;
                            } else if (!scope.errors.length) {
                                if (source === 'keydown') {
                                    scope.$apply(function () {
                                        return scope.errors.push({ message: 'Vous devez répondre à cette question avant de passer à la suivante.' });
                                    });
                                } else {
                                    scope.errors.push({ message: 'Vous devez répondre à cette question avant de passer à la suivante.' });
                                }

                                hasError++;
                            }
                        } else if (question[i].answer_type === 'equipment' && question[i].exclusive) {
                            if (scope.answers[question[i].id] && (scope.answers[question[i].id].length > 0 || Object.keys(scope.answers[question[i].id]).length > 0)) {
                                scope.errors = [];
                                counter++;
                            } else {
                                if (source === 'keydown') {
                                    scope.$apply(function () {
                                        return scope.errors.push({ message: 'Vous devez répondre à cette question avant de passer à la suivante.' });
                                    });
                                } else {
                                    scope.errors.push({ message: 'Vous devez répondre à cette question avant de passer à la suivante.' });
                                }

                                hasError++;
                            }
                        } else if (question[i].answer_type === 'multi') {
                            var multiObj = {};
                            var prevQ = scope.questions[index - 1][1];
                            var totalP = 0;
                            for (it = 0, end1 = question[i].multi.length, asc1 = end1 >= 0; asc1 ? it < end1 : it > end1; asc1 ? it++ : it--) {
                                var asc1, end1;
                                if (question[i].multi[i] && question[i].multi[it].index) {
                                    if (question[i].multi[it].value) {
                                        totalP += parseInt(question[i].multi[it].value);
                                        multiObj[question[i].multi[it].index] = question[i].multi[it].value;
                                    }
                                }
                            }

                            if (totalP > parseInt(scope.answers[prevQ.id].value) || totalP < parseInt(scope.answers[prevQ.id].value)) {
                                scope.errors = [];
                                scope.errors.push({ message: 'Le total doit \xEAtre \xE9gal au nombre d\'occupants (' + scope.answers[prevQ.id].value + ').' });
                            } else {
                                scope.errors = [];
                                scope.answers[question[i].id] = scope.answers[question[i].id] || {};
                                scope.answers[question[i].id].value = JSON.stringify(multiObj);
                            }
                            return scope.errors.length < 1;
                        } else {
                            // is equipment
                            for (it = 0, end2 = question[i].enums.length, asc2 = end2 >= 0; asc2 ? it < end2 : it > end2; asc2 ? it++ : it--) {
                                var asc2, end2;
                                var idEquipment = question[i].enums[it].id_equipment;
                                scope.popupHasError(question[i].enums[it].popup, question[i], question[i].enums[it].id_equipment);
                                if (question[i].popup_error) {
                                    break;
                                }
                            }

                            if (question[i].popup_error) {
                                scope.errors = [];
                                scope.errors.push({ message: 'Veuillez corriger les erreurs.' });
                            } else {
                                scope.errors = [];
                                counter++;
                            }
                        }
                    }

                    if (counter === l) {
                        return true;
                    }
                    return false;
                };

                scope.getInfoBulleTemplate = function (question) {
                    var html = '<div>' + question.info_bulle + '</div>';
                    return html;
                };

                scope.nextStep = function (currentStep, cat, notify) {
                    var newStep = currentStep + 1;
                    if (newStep > scope.steps.length) {
                        newStep = scope.steps.length - 1;
                    }
                    scope.currentStep = newStep;
                    return scope.loaded = 1;
                };

                // move to previous step from step arg
                scope.previousStep = function (currentStep, cat) {
                    var previousStep = scope.steps[currentStep - 1];
                    if (currentStep > 0) {
                        if (previousStep.notify) {
                            return $state.go($state.current, { step: currentStep - 1, cat: cat }, {
                                notify: previousStep.notify,
                                resolve: true
                            });
                        }
                        if (previousStep.category === cat) {
                            scope.currentStep = currentStep - 1;
                            return $state.go($state.current, { step: currentStep - 1, cat: cat }, {
                                notify: previousStep.notify,
                                resolve: false
                            });
                        }
                    }
                };

                // move to specific step, arg = step number
                scope.goToStep = function (step, cat) {
                    if (step !== undefined) {
                        if (step !== 0 && scope.questions.length) {
                            scope.currentStep = step;
                            return $state.go($state.current, { step: step, cat: cat, resolve: false }, { notify: false });
                        }
                        scope.currentStep = step;
                        return $state.go($state.current, { step: step, cat: cat, resolve: false }, { notify: false });
                    }
                };

                scope.navToStep = function (step, cat) {
                    var index = 0;
                    if (scope.steps[step].navigation) {
                        var l = void 0;
                        return __range__(scope.questions.length - 1, 0, false).map(function (i) {
                            return l = scope.getQlength(scope.questions[i]), function () {
                                var result = [];
                                for (var it = 0, end = l, asc = end >= 0; asc ? it < end : it > end; asc ? it++ : it--) {
                                    var item = void 0;
                                    if (scope.questions[i][it].category === cat) {
                                        index = i;
                                        item = scope.goToQ(i);
                                    }
                                    result.push(item);
                                }
                                return result;
                            }();
                        });
                    }
                };

                // set progression bar
                scope.setProgression = function (currentStep) {
                    return { width: currentStep * 20 + '%' };
                };

                // set width for sliding effect
                scope.setQuestionsWidth = function () {
                    if (scope.questions) {
                        return { width: 435 * scope.questions.length + 'px' };
                    }
                };

                // submit Q
                scope.validateQ = function (index, source) {
                    scope.disableSave = true;
                    setTimeout;
                    var question = scope.questions[index];
                    var qDomId = 'step' + scope.currentStep + '-q' + index;
                    // object to pass by reference
                    var validatedQ = { v: 0 };
                    var l = scope.getQlength(question);
                    var iterations = 0;
                    var tmpStatus = void 0;
                    if (validateQuestion(question, l, source, index)) {
                        tmpNextQuestion = null;
                        var handleQuestion = function handleQuestion(questionIndex, callback) {
                            iterations++;
                            if (questionIndex < l) {
                                var q = question[questionIndex];
                                var nextQ = scope.questions[index + 1];
                                var status = scope.getAnswerStatus(q, scope.answers[q.id], nextQ);
                                if (tmpStatus !== 1 && tmpStatus !== undefined) {
                                    status = tmpStatus === 2 ? 2 : 3;
                                }

                                tmpStatus = status;
                                // if answer exists and not changed
                                if (status === 1) {
                                    // if next question exists
                                    if (scope.questions[index + 1] && validatedQ.v >= l) {
                                        return scope.nextQ(question, scope.questions[index + 1], index);
                                    } else if (scope.questions[index + 1] && scope.questions[index + 1].length > 0) {
                                        validatedQ.v++;
                                        if (validatedQ.v >= l && scope.questions[index + 1] !== undefined) {
                                            scope.disableSave = false;
                                            return scope.nextQ(question, scope.questions[index + 1], index);
                                        }
                                        scope.disableSave = false;
                                        return callback(questionIndex + 1, callback);
                                    }
                                    return scope.saveAnswer(q, question, index, validatedQ, l, function (nextQuestion) {
                                        if (validatedQ.v < l) {
                                            return callback(questionIndex + 1, callback);
                                        } else if (nextQuestion && nextQuestion.length > 0) {
                                            scope.disableSave = false;
                                            return scope.nextQ(question, nextQuestion, index);
                                        } else if (q.last) {
                                            scope.disableSave = false;
                                            return scope.setLandscapeDone();
                                        }
                                    });

                                    // if answer exists but different from original
                                } else if (status === 2) {
                                    // clean all answers after the current one
                                    if (index === 0) {
                                        return LandscapeQuestions.flush({ id_contract: scope.id_contract, draft: scope.isDraft }).$promise.then(function (data) {
                                            scope.flush();
                                            return scope.saveAnswer(q, question, index, validatedQ, l, function (nextQuestion) {
                                                if (validatedQ.v < l) {
                                                    callback(questionIndex + 1, callback);
                                                }
                                                if (nextQuestion && nextQuestion.length > 0) {
                                                    scope.disableSave = false;
                                                    return scope.nextQ(question, nextQuestion, index);
                                                } else if (q.last) {
                                                    scope.disableSave = false;
                                                    return scope.setLandscapeDone();
                                                }
                                            });
                                        }, function (response) {}).catch(function (error) {
                                            console.error('catchError', error);
                                            AlertManager.addAlert({
                                                type: 'danger',
                                                msg: 'Une erreur est survenue, veuillez réessayer plus tard.'
                                            });
                                            callback(questionIndex + 1, callback);
                                            return ErrorCatcher.catchError(error);
                                        });
                                    }
                                    if (q.flush_after) {
                                        return LandscapeQuestions.flushAfter({
                                            id_question: q.id,
                                            id_contract: scope.id_contract,
                                            draft: scope.isDraft
                                        }).$promise.then(function (data) {
                                            var cb = function cb() {
                                                return scope.saveAnswer(q, question, index, validatedQ, l, function (nextQuestion) {
                                                    if (validatedQ.v < l) {
                                                        return callback(questionIndex + 1, callback);
                                                    } else if (nextQuestion && nextQuestion.length > 0) {
                                                        scope.disableSave = false;
                                                        return scope.nextQ(question, nextQuestion, index);
                                                    } else if (q.last) {
                                                        var isSubscription = false;
                                                        scope.disableSave = false;
                                                        _angular2.default.element('#saveLandscape').dispatchEvent('landscapeDone');
                                                        return scope.setLandscapeDone();
                                                    }
                                                });
                                            };

                                            return scope.flushAfter(question[0].id, cb);
                                        }).catch(ErrorCatcher.catchError);
                                    }
                                    return scope.saveAnswer(q, question, index, validatedQ, l, function (nextQuestion) {
                                        if (validatedQ.v < l) {
                                            return callback(questionIndex + 1, callback);
                                        } else if (nextQuestion && nextQuestion.length > 0) {
                                            scope.disableSave = false;
                                            return scope.nextQ(question, nextQuestion, index);
                                        } else if (q.last) {
                                            scope.disableSave = false;
                                            return scope.setLandscapeDone();
                                        }
                                    });

                                    // if answer does not exists
                                } else if (status === 3) {
                                    return scope.saveAnswer(q, question, index, validatedQ, l, function (nextQuestion) {
                                        if (validatedQ.v < l) {
                                            return callback(questionIndex + 1, callback);
                                        } else if (nextQuestion && nextQuestion.length > 0) {
                                            scope.disableSave = false;
                                            return scope.nextQ(question, nextQuestion, index);
                                        } else if (q.last) {
                                            scope.disableSave = false;
                                            return scope.setLandscapeDone();
                                        }
                                    });
                                }
                            } else {}
                        };

                        return handleQuestion(0, handleQuestion);
                    }
                    return scope.disableSave = false;
                };

                scope.getAnswerStatus = function (q, a, nextQ) {
                    // if exists and not changed : 1
                    if (q) {
                        if (q.answer_type === 'equipment' && q.answer) {
                            var qA = void 0;
                            if (typeof q.answer === 'string') {
                                qA = q.answer.split(',');
                            } else {
                                qA = [q.answer];
                            }
                            // if exists and not changed : 1
                            if (scope.answers[q.id] != null && a && a.length > 0 && qA.length > 0 && qA === a && nextQ) {
                                return 1;
                                // if exists but diff : 2
                            } else if (qA.length > 0 && a && a.length > 0 && qA !== a) {
                                return 2;
                                // if not exists : 3
                            }
                            return 3;
                        }
                        if (a != null && a.value != null && q.answer != null && q.answer === a.value && nextQ) {
                            return 1;
                        } else if (q.answer != null && a != null && q.answer !== a.value) {
                            return 2;
                        }
                        return 3;
                    }
                };

                scope.editForm = function () {
                    return $timeout(function () {
                        var elem = document.getElementById('form-container');
                        var vis = document.getElementById('vis');
                        var landCanvas = document.getElementById('landscape-canvas');
                        if (elem && vis && landCanvas) {
                            elem.className = elem.className.replace('get-out', '');
                            landCanvas.className = landCanvas.className.replace(' get-in-middle', '');
                            vis.className = vis.className.replace('fade-out', '');
                        }
                        return scope.triggerLandscapeDoneAnimation(false);
                    });
                };

                scope.hasNextQuestion = function (question) {
                    var hasNext = true;
                    var qLength = scope.getQlength(question);
                    for (var i = 0, end = qLength, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        var q = question[i];
                        if (!scope.getNextQuestion(q) && q.last) {
                            hasNext = false;
                        }
                    }

                    return hasNext;
                };

                scope.saveAnswer = function (q, question, index, validatedQ, l, callback) {
                    var v = void 0;
                    scope.disableSave = true;
                    var answer = {
                        id_question: q.id
                        // answer is equipment
                    };if (scope.answers[q.id] && q.answer_type === 'equipment') {
                        var tempA = [];
                        var tempFuncA = [];
                        for (var key in scope.answers[q.id]) {
                            v = scope.answers[q.id][key];
                            if (scope.answers[q.id][key] && scope.answers[q.id][key].value) {
                                if (key !== 'popups') {
                                    tempA.push(key.toString());
                                    tempFuncA.push(scope.answers[q.id][key].answer_func);
                                }
                            }
                        }
                        answer.answer = tempA.join();
                        answer.answer_func = tempFuncA.join();
                    } else if (scope.answers[q.id]) {
                        answer.answer = scope.answers[q.id].value;
                        answer.answer_func = scope.answers[q.id].answer_func || null;
                    } else if (!scope.answers[q.id] && q.answer_type === 'equipment') {
                        answer.answer = '';
                    }

                    if (scope.answers[q.id] && scope.answers[q.id].popups) {
                        answer.popups = scope.answers[q.id].popups;
                    }

                    if (answer.answer || q.answer_type === 'equipment') {
                        return LandscapeQuestions.saveAnswer({
                            id_contract: scope.id_contract,
                            draft: scope.isDraft
                        }, answer).$promise.then(function (data) {
                            if (data) {
                                if (q.answer_type !== 'equipment') {
                                    scope.setQuestionAnswer(data, index);
                                }

                                validatedQ.v++;

                                if (data.heating) {
                                    scope.heating = data.heating;
                                    if (scope.contractSelected) {
                                        scope.contractSelected.heating = data.heating;
                                    }
                                }
                                if ((0, _isBoolean3.default)(data.primary_residence)) {
                                    scope.primary_residence = data.primary_residence;
                                    if (scope.contractSelected) {
                                        scope.contractSelected.primary_residence = data.primary_residence;
                                    }
                                }
                                if (data.next_question && data.next_question.length > 0) {
                                    tmpNextQuestion = data.next_question;
                                    if (!scope.getQuestionById(data.next_question[0].id)) {
                                        scope.questions.push(data.next_question);
                                    }

                                    return callback(data.next_question);
                                } else if (tmpNextQuestion) {
                                    if (!scope.getQuestionById(tmpNextQuestion[0].id)) {
                                        scope.questions.push(tmpNextQuestion);
                                    }

                                    return callback(tmpNextQuestion);
                                } else if (validatedQ.v === l) {
                                    // do form submitted
                                    return callback(null);
                                }
                            } else {
                                return AlertManager.addAlert({
                                    type: 'danger',
                                    msg: 'Une erreur est survenue, veuillez réessayer plus tard.'
                                });
                            }
                        }, function (response) {
                            if (response.statusCode < 200 || response.statusCode > 299) {
                                return AlertManager.addAlert({
                                    type: 'danger',
                                    msg: 'Une erreur est survenue, veuillez réessayer plus tard.'
                                });
                            }
                        }).catch(ErrorCatcher.catchError);
                    }
                    return AlertManager.addAlert({ type: 'danger', msg: 'Une erreur est survenue, veuillez réessayer plus tard.' });
                };

                scope.findLandscapeElement = function (id_question) {
                    for (var i = 0, end = scope.landscapeElements.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        if (scope.landscapeElements[i] && scope.landscapeElements[i].id_question === id_question) {
                            return { element: scope.landscapeElements[i], i: i };
                        }
                    }
                };

                scope.findLandscapeEquipments = function (elem) {
                    for (var i = 0, end = scope.landscapeEquipments.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        if (scope.landscapeEquipments[i].pictofont === elem.pictofont) {
                            scope.landscapeEquipments[i].i = i;
                            return scope.landscapeEquipments[i];
                        }
                    }

                    return null;
                };

                scope.setLandscapeElement = function (question, answer) {
                    if (question) {
                        var i = void 0,
                            img = void 0;
                        var lE = scope.findLandscapeElement(question.id);

                        if (answer && answer.answer_type !== 'equipment') {
                            if (question.answer_type === 'enum' && answer) {
                                return function () {
                                    var result = [];
                                    for (i = 0, end = question.enums.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                                        var asc, end;
                                        var item = void 0;
                                        if (question.enums[i].value === answer) {
                                            // should chek if not already in for update
                                            if (question.enums[i].landscape) {
                                                if (question.enums[i].replace && lE && scope.landscapeElements[lE.i - 1]) {
                                                    scope.landscapeElements[lE.i - 1].img = null;
                                                    item = scope.landscapeElements[lE.i] = {
                                                        img: '/assets/img/landscape/' + question.enums[i].landscape,
                                                        id_question: question.id
                                                    };
                                                } else if (lE) {
                                                    item = scope.landscapeElements[lE.i] = {
                                                        img: '/assets/img/landscape/' + question.enums[i].landscape,
                                                        id_question: question.id
                                                    };
                                                } else if (!lE) {
                                                    item = scope.landscapeElements.push({
                                                        img: '/assets/img/landscape/' + question.enums[i].landscape,
                                                        id_question: question.id
                                                    });
                                                }
                                            } else if (lE) {
                                                item = scope.landscapeElements[lE.i] = { img: null, id_question: question.id };
                                            }
                                        }
                                        result.push(item);
                                    }
                                    return result;
                                }();
                            } else if (question.landscape_it && question.landscape && question.landscape !== '0') {
                                img = '/assets/img/landscape/' + question.landscape.replace(/`/g, '').replace('${value}', answer);
                                if (answer === 0) {
                                    return scope.landscapeElements[lE.i] = { img: null, id_question: question.id };
                                } else if (lE) {
                                    return scope.landscapeElements[lE.i] = { img: img, id_question: question.id };
                                } else if (!lE) {
                                    return scope.landscapeElements.push({ img: img, id_question: question.id });
                                }
                            }
                        } else if (!answer && lE) {
                            return scope.landscapeElements[lE.i] = { img: null, id_question: question.id };
                        }
                    }
                };

                scope.findBubbleByName = function (bubbles, name) {
                    if (bubbles) {
                        for (var i = 0, end = bubbles.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            if (bubbles[i] && bubbles[i].name === name) {
                                return bubbles[i];
                            }
                        }
                    }
                };

                scope.setQuestionAnswer = function (answer, index) {
                    if (scope.questions[index]) {
                        var l = scope.getQlength(scope.questions[index]);
                        return function () {
                            var result = [];
                            for (var i = 0, end = l, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                                var item = void 0;
                                if (scope.questions[index][i].id === answer.id_question) {
                                    scope.questions[index][i].id_answer = answer.id;
                                    switch (scope.questions[index][i].answer_type) {
                                        case 'number':
                                            item = scope.questions[index][i].answer = parseInt(answer.answer);
                                            break;
                                        default:
                                            item = scope.questions[index][i].answer = answer.answer;
                                    }
                                }
                                result.push(item);
                            }
                            return result;
                        }();
                    }
                };

                scope.flush = function () {
                    // reverse loop because splice reorganises array
                    for (var start = scope.questions.length - 1, i = start, asc = start <= 0; asc ? i < 0 : i > 0; asc ? i++ : i--) {
                        if (scope.questions[i]) {
                            scope.questions.splice(i, 1);
                            scope.deleteQstyle(i);
                        }
                    }

                    return BubblesService.flush();
                };

                scope.flushAfter = function (idQuestion, callback) {
                    for (var start = scope.questions.length - 1, i = start, asc = start <= 0; asc ? i < 0 : i > 0; asc ? i++ : i--) {
                        for (var it = 0, end = scope.getQlength(scope.questions[i]), asc1 = end >= 0; asc1 ? it < end : it > end; asc1 ? it++ : it--) {
                            if (scope.questions[i] && scope.questions[i][it]) {
                                if (scope.questions[i][it].id === idQuestion) {
                                    return callback();
                                } else if (scope.questions[i][it].id > idQuestion) {
                                    scope.questions.splice(i, 1);
                                    scope.deleteQstyle(i);
                                }
                            }
                        }
                    }
                };

                scope.setMultiClass = function (q) {
                    if (q.multi.length <= 3) {
                        return 'col-xs-4';
                    }
                    return 'col-xs-' + Math.round(12 / q.multi.length);
                };

                scope.setMultiAnswer = function (q, multi, index) {
                    var multiObj = {};
                    var prevQ = scope.questions[index - 1][1];
                    var totalP = 0;
                    for (var i = 0, end = q.multi.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        if (q.multi[i] && q.multi[i].index) {
                            if (q.multi[i].value) {
                                totalP += parseInt(q.multi[i].value);
                                multiObj[q.multi[i].index] = q.multi[i].value;
                            }
                        }
                    }

                    if (totalP > parseInt(scope.answers[prevQ.id].value) || totalP < parseInt(scope.answers[prevQ.id].value)) {
                        return null;
                    }
                    scope.errors = [];
                    scope.answers[q.id] = scope.answers[q.id] || {};
                    return scope.answers[q.id].value = JSON.stringify(multiObj);
                };

                // move to previous Q in same category
                scope.previousQ = function (index) {
                    if (!scope.disableBack) {
                        $rootScope.$broadcast('landscapeNavigating');

                        if (scope.questionsI > 1) {
                            var question = scope.questions[index - 1];
                            if (question) {
                                var elem = void 0,
                                    qDomId = void 0;
                                if (question[0].category !== scope.steps[scope.currentStep].category) {
                                    qDomId = 'step1-q' + (index - 1);
                                    elem = document.getElementById(qDomId);
                                    elem.style.marginLeft = '0';
                                    scope.disableBack = true;
                                    $timeout(function () {
                                        scope.questionsI = index;
                                        return scope.disableBack = false;
                                    }, 300);
                                    return scope.previousStep(scope.currentStep, question[0].category);
                                }
                                qDomId = 'step1-q' + (index - 1);
                                elem = document.getElementById(qDomId);
                                elem.style.marginLeft = '0';
                                scope.disableBack = true;
                                return $timeout(function () {
                                    scope.questionsI = index;
                                    return scope.disableBack = false;
                                }, 300);
                            }
                        }
                    }
                };

                scope.getCurrentStep = function (question) {
                    var category = '';
                    if (question.category) {
                        category = question.category;
                    } else if (question && scope.getQlength(question) > 0) {
                        category = question[0].category;
                    }

                    for (var i = 0, end = scope.steps.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        var step = scope.steps[i];
                        if (step.category === category) {
                            return i;
                        }
                    }
                };

                scope.nextQ = function (question, next_question, index) {
                    var elem = void 0,
                        formEl = void 0,
                        formElStyle = void 0,
                        mLeft = void 0;
                    $rootScope.$broadcast('landscapeNavigating');
                    var qDomId = 'step1-q' + index;
                    var currentStep = scope.getCurrentStep(question);

                    if (next_question[0].category === question[0].category || next_question[0].category === question.category) {
                        elem = document.getElementById(qDomId);
                        formEl = document.getElementById('form-container');
                        formElStyle = window.getComputedStyle(formEl);
                        mLeft = formElStyle.width;
                        if (elem) {
                            elem.style.marginLeft = '-' + mLeft;
                            scope.disableBack = true;
                            return $timeout(function () {
                                scope.questionsI = index + 2;
                                return scope.disableBack = false;
                            }, 300);
                        }
                    } else if (currentStep < 4) {
                        elem = document.getElementById(qDomId);
                        formEl = document.getElementById('form-container');
                        formElStyle = window.getComputedStyle(formEl);
                        mLeft = formElStyle.width;
                        if (elem) {
                            elem.style.marginLeft = '-' + mLeft;
                            scope.disableBack = true;
                            $timeout(function () {
                                scope.questionsI = index + 2;
                                return scope.disableBack = false;
                            }, 300);
                            return scope.nextStep(scope.currentStep, next_question[0].category, { notify: false, resolve: false });
                        }
                    }
                };

                scope.getQlength = function (q) {
                    if (q) {
                        var l = void 0;
                        if (!q.length) {
                            l = Object.keys(q).length;
                        } else {
                            l = q.length;
                        }

                        return l;
                    }
                };

                return scope.getAnswerFormatRaw = function (answer_format) {
                    var res = answer_format.replace(/`/g, '').replace('${value}', '');
                    if (res) {
                        return $sce.trustAsHtml(res);
                    }
                    return '';
                };
            },
            post: function post(scope, element, attrs) {
                scope.qStyles = {};

                // go to Question (id_question)
                scope.goToQ = function (index) {
                    var i = void 0;
                    var cat = scope.questions[index][0].category;
                    for (i = 0, end = scope.steps.length, asc = end >= 0; asc ? i <= end : i >= end; asc ? i++ : i--) {
                        var asc, end;
                        if (scope.steps[i] && scope.steps[i].category === cat) {
                            scope.goToStep(i, cat);
                        }
                    }

                    scope.questionsI = index + 1;
                    return scope.$applyAsync(function () {
                        return function () {
                            var result = [];
                            for (i = 0, end1 = scope.questions.length, asc1 = end1 >= 0; asc1 ? i < end1 : i > end1; asc1 ? i++ : i--) {
                                var asc1, end1;
                                var domId, questionsDomElem, width;
                                if (i < index) {
                                    questionsDomElem = (0, _jquery2.default)('#questions');
                                    width = questionsDomElem.innerWidth() - 30;
                                    domId = 'step1-q' + i;
                                    result.push(scope.qStyles[domId] = {
                                        'margin-left': '-100%',
                                        'width': width + 'px'
                                    });
                                } else {
                                    questionsDomElem = (0, _jquery2.default)('#questions');
                                    width = questionsDomElem.innerWidth() - 30;
                                    domId = 'step1-q' + i;
                                    result.push(scope.qStyles[domId] = {
                                        'margin-left': '0',
                                        'width': width + 'px'
                                    });
                                }
                            }
                            return result;
                        }();
                    });
                };

                scope.setQstyle = function (domId) {
                    var max = DeviceChecker.isMobile() ? 239 : 434;
                    var adjustment = 30;

                    if (scope.qStyles[domId] && parseInt(scope.qStyles[domId].width.replace('px', '')) > max) {
                        return scope.qStyles[domId];
                    }

                    var questionsDomElem = (0, _jquery2.default)('#questions');
                    var width = Math.max(max + 1, questionsDomElem.innerWidth() - adjustment);
                    var style = { width: width + 'px' };
                    scope.qStyles[domId] = style;
                    return style;
                };

                scope.deleteQstyle = function (index) {
                    var domId = 'step1-q' + index;
                    return delete scope.qStyles[domId];
                };

                scope.setEnumClass = function (enums, first) {
                    var cssClass = void 0,
                        s = void 0;
                    var isMobile = DeviceChecker.isMobile();

                    if (enums.length > 4) {
                        if (enums.length === 6) {
                            var enumsClass = void 0;
                            if (isMobile) {
                                s = 4;
                                enumsClass = 'enums-long-mobile';
                            } else {
                                s = Math.floor(12 / enums.length);
                                enumsClass = 'enums-long';
                            }
                            cssClass = enumsClass + ' col-xs-' + s + ' col-md-' + s;
                        } else {
                            s = Math.floor(12 / (enums.length / 2));
                            cssClass = 'col-xs-' + s + ' col-md-' + s;
                        }
                    } else if (enums.length < 3) {
                        s = Math.floor(8 / enums.length);
                        var sM = 6;
                        cssClass = 'col-xs-' + sM + ' col-md-' + s;
                        if (enums[0].img) {
                            cssClass += ' col-md-offset-1';
                        }
                    } else {
                        s = Math.floor(12 / enums.length);
                        cssClass = 'col-xs-' + s + ' col-md-' + s;
                    }

                    if (enums[0].img) {
                        cssClass += ' img';
                    } else if (first && enums.length <= 4) {
                        cssClass += ' col-md-offset-2';
                    }

                    return cssClass;
                };

                scope.setEnumAnswer = function (answer, value, answer_func, question) {
                    if (scope.answers[question.id] && question.popup) {
                        scope.answers[question.id].value = value;
                        scope.answers[question.id].answer_func = answer_func;
                    } else {
                        scope.answers[question.id] = { value: value, answer_func: answer_func };
                    }

                    return scope.isValid(answer, question);
                };

                scope.setEquipmentAnswer = function (answer, equipment, question) {
                    var id_question = question.id;
                    if (scope.answers[id_question]) {
                        if (question.exclusive) {
                            scope.flushEquipmentsForQuestion(question);
                            scope.answers[id_question] = [];
                        }

                        if (!scope.answers[id_question][equipment.id_equipment]) {
                            scope.answers[id_question][equipment.id_equipment] = {
                                value: true,
                                id_question: id_question,
                                pictofont: equipment.pictofont,
                                id_equipment: equipment.id_equipment,
                                answer_func: equipment.answer_func
                            };
                            scope.setLandscapeEquipment(question, scope.answers[id_question][equipment.id_equipment]);
                        } else {
                            var val = !scope.answers[id_question][equipment.id_equipment].value;
                            scope.answers[id_question][equipment.id_equipment] = {
                                value: val,
                                id_question: id_question,
                                pictofont: equipment.pictofont,
                                id_equipment: equipment.id_equipment,
                                answer_func: equipment.answer_func
                            };
                            scope.setLandscapeEquipment(question, scope.answers[id_question][equipment.id_equipment]);
                        }
                    } else if (!scope.answers[id_question]) {
                        scope.answers[id_question] = [];
                        scope.answers[id_question][equipment.id_equipment] = {
                            value: true,
                            id_question: id_question,
                            pictofont: equipment.pictofont,
                            id_equipment: equipment.id_equipment,
                            answer_func: equipment.answer_func
                        };
                        scope.setLandscapeEquipment(question, scope.answers[id_question][equipment.id_equipment]);
                    }

                    if (equipment.popup.length > 0 && scope.answers[id_question][equipment.id_equipment] && scope.answers[id_question][equipment.id_equipment].value) {
                        scope.popUp(equipment.popup, id_question);
                    }

                    return scope.answers[id_question][equipment.id_equipment];
                };

                scope.flushEquipmentsForQuestion = function (question) {
                    return function () {
                        var result = [];
                        for (var i = 0, end = scope.answers[question.id].length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            var item = void 0;
                            if (scope.answers[question.id][i]) {
                                if (BubblesService) {
                                    item = BubblesService.remove(scope.answers[question.id][i].pictofont);
                                }
                            }
                            result.push(item);
                        }
                        return result;
                    }();
                };

                scope.popUp = function (id_question, id_trigger) {
                    if (!scope.popuping) {
                        scope.popQuestions = [];
                        scope.popuping = true;
                        scope.answers[id_trigger].popups = scope.answers[id_trigger].popups || [];
                        if ((typeof id_question === 'undefined' ? 'undefined' : _typeof(id_question)) === 'object') {
                            return __range__(0, id_question.length, false).map(function (i) {
                                return LandscapeQuestions.getPopupQuestion({ id_question: id_question[i] }).$promise.then(function (data) {
                                    if (data) {
                                        scope.popQuestions.push(data);
                                        scope.answers[data.id] = scope.answers[data.id] || {};
                                        scope.answers[id_trigger].popups[data.id] = scope.answers[data.id];
                                    }

                                    if (scope.popQuestions.length === id_question.length) {
                                        if (scope.popQuestions.length > 1) {
                                            scope.popupLarge = true;
                                        } else {
                                            scope.popupLarge = false;
                                        }
                                        scope.popup = true;
                                        return scope.popuping = false;
                                    }
                                }, function (response) {}).catch(ErrorCatcher.catchError);
                            });
                        }
                        return LandscapeQuestions.getPopupQuestion({ id_question: id_question }).$promise.then(function (data) {
                            if (data) {
                                scope.popQuestions.push(data);
                                scope.answers[data.id] = scope.answers[data.id] || {};
                                scope.answers[id_trigger].popups[data.id] = scope.answers[data.id];
                                if (scope.popQuestions.length > 1) {
                                    scope.popupLarge = true;
                                } else {
                                    scope.popupLarge = false;
                                }
                                scope.popup = true;
                                return scope.popuping = false;
                            }
                        }, function (response) {}).catch(ErrorCatcher.catchError);
                    }
                };

                scope.popupIsAnswered = function (id_question, q, id_equipment) {
                    var id_trigger = q.id;
                    if (scope.answers[id_trigger] && (scope.answers[id_trigger].value || scope.answers[id_trigger][id_equipment] && scope.answers[id_trigger][id_equipment].value)) {
                        for (var i = 0, end = id_question.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            if (scope.answers[id_question[i]] && scope.answers[id_question[i]].value) {
                                return true;
                            }
                        }
                    }
                };

                scope.popupHasError = function (id_question, q, id_equipment) {
                    var id_trigger = q.id;
                    if (scope.answers[id_trigger] && scope.answers[id_trigger][id_equipment] && scope.answers[id_trigger][id_equipment].value) {
                        for (var i = 0, end = id_question.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            if (!scope.answers[id_question[i]] || !scope.answers[id_question[i]] || !scope.answers[id_question[i]].value || scope.answers[id_question[i]].value === '') {
                                q.popup_error = true;
                                return true;
                            }
                        }
                        q.popup_error = false;
                        return false;
                    }
                    q.popup_error = false;
                    return false;
                };

                scope.setLandscapeEquipment = function (question, answer) {
                    if (answer.pictofont && question.answer_type === 'equipment') {
                        var a = _angular2.default.copy(answer);
                        var bubbles = BubblesService.getData();
                        var bubble = scope.findBubbleByName(bubbles, answer.pictofont);

                        if (!bubbles || !bubbles.length) {
                            return BubblesService.display({ selector: '#vis', data: [{ count: 18, name: answer.pictofont }] });
                        } else if (bubble) {
                            if (!answer.value) {
                                a.value = false;
                                if (BubblesService) {
                                    return BubblesService.remove(answer.pictofont);
                                }
                            }
                        } else if (bubbles && bubbles.length) {
                            if (BubblesService.isDisplayed() && answer.value) {
                                return BubblesService.add({ count: 18, name: answer.pictofont });
                            } else if (!BubblesService.isDisplayed() && answer.value) {
                                return BubblesService.display({ selector: '#vis', data: [{ count: 18, name: answer.pictofont }] });
                            }
                            return null;
                        }
                    }
                };

                scope.setTabIndex = function (q, questionsI) {
                    for (var i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        var qBlock = scope.questions[i];
                        for (var j = 0, end1 = qBlock.length, asc1 = end1 >= 0; asc1 ? j < end1 : j > end1; asc1 ? j++ : j--) {
                            var question = qBlock[j];
                            if (q.id === question.id) {
                                if (questionsI === i + 1) {
                                    return 1;
                                }
                            }
                        }
                    }
                    return -1;
                };

                scope.setLandscapeDone = function (subscription, onLoad) {
                    scope.nBubbles = BubblesService.getData().length;
                    var isSubscription = false;
                    scope.$evalAsync(function () {
                        return scope.loaded = false;
                    });

                    if (scope.isSubscriptionState($state.current.name)) {
                        isSubscription = true;
                    }

                    if (!isSubscription) {
                        return $timeout(function () {
                            var elem = document.getElementById('form-container');
                            var vis = document.getElementById('vis');
                            var landCanvas = document.getElementById('landscape-canvas');
                            if (elem && vis && landCanvas) {
                                elem.className += ' get-out';
                                landCanvas.className += ' get-in-middle';
                                vis.className += 'fade-out';
                            }
                            scope.triggerLandscapeDoneAnimation(true);

                            if (scope.displayEndModal && !onLoad) {
                                $uibModal.open({
                                    animation: true,
                                    size: 'xs',
                                    template: __webpack_require__(739)(),
                                    controller: ["$scope", "$uibModalInstance", function controller($scope, $uibModalInstance) {
                                        return $scope.close = $uibModalInstance.dismiss;
                                    }]
                                });
                            }
                        });
                    } else if (isSubscription && scope.$parent.popupInstance) {
                        return $timeout(function () {
                            var canvas = document.getElementById('landscape-canvas');
                            if (scope.$parent.isEdition !== true && scope.$parent.isNew !== true && scope.landscapeOpened === true && scope.landscapeIsDone !== true) {
                                scope.$parent.isEdition = false;
                                scope.$parent.isNew = false;
                                return scope.$parent.$close({
                                    answers: scope.answers,
                                    canvas: canvas,
                                    landscapeDone: true,
                                    LandscapeElements: LandscapeElements.LandscapeElements,
                                    heating: scope.heating,
                                    primary_residence: scope.primary_residence
                                });
                            } else if (scope.landscapeDonePassed === true && scope.landscapeIsDone === true) {
                                scope.$parent.isEdition = false;
                                scope.$parent.isNew = false;
                                return scope.$parent.$close({
                                    answers: scope.answers,
                                    canvas: canvas,
                                    landscapeDone: true,
                                    LandscapeElements: LandscapeElements.LandscapeElements,
                                    heating: scope.heating,
                                    primary_residence: scope.primary_residence
                                });
                            }
                            scope.landscapeDonePassed = true;
                            scope.$parent.isEdition = false;
                            scope.$parent.isNew = false;
                            scope.landscapeOpened = true;
                            scope.loaded = true;
                            return scope.editForm();
                        }, 1500);
                    }
                };

                scope.landscapeDonePassed = false;
                scope.landscapeOpened = false;

                // temperature
                scope.setTemperatureAnswer = function (temp, q) {
                    scope.answers[q.id] = scope.answers[q.id] || {};
                    scope.answers[q.id].answer_func = temp.value;
                    return scope.answers[q.id].value = temp.value;
                };

                // temperature
                scope.setTempStyle = function (temp, q) {
                    if (scope.answers[q.id] && scope.answers[q.id].value === temp.value) {
                        return { background: temp.color, color: 'white' };
                    }
                    return { background: 'white' };
                };

                // temp tooltip
                scope.setTempTooltipStyle = function (temp, q) {
                    if (scope.answers[q.id] && scope.answers[q.id].value === temp.value) {
                        return { color: temp.color };
                    }
                    return {};
                };

                scope.returnCanvas = function () {
                    var canvas = document.getElementById('landscape-canvas');
                    return scope.$parent.$close({
                        answers: scope.answers,
                        canvas: canvas
                    });
                };

                // key binding
                window.addEventListener('keydown', function (k) {
                    if (!scope.landscapeDone) {
                        if (!scope.popup && (0, _jquery2.default)('#landscape-popup').hasClass('ng-hide')) {
                            switch (k.keyCode) {
                                case 13:
                                    return scope.validateQ(scope.questionsI - 1, 'keydown');
                                default:
                                    return null;
                            }
                        } else {
                            switch (k.keyCode) {
                                case 13:
                                    return scope.$evalAsync(function () {
                                        return scope.popup = false;
                                    });
                                default:
                                    return null;
                            }
                        }
                    }
                });

                // drawing
                var watchAnswers = function watchAnswers(answers, oldAnswers) {
                    if (answers && answers.length) {
                        var reset = false;
                        return function () {
                            var result = [];
                            for (var i = 1, end = answers.length, asc = end >= 1; asc ? i <= end : i >= end; asc ? i++ : i--) {
                                // new answers
                                var nextQ, value;
                                var item = void 0;
                                var question = scope.getQuestionById(i);
                                if (question) {
                                    nextQ = scope.getNextQuestion(question);
                                }

                                // if nextQ is array
                                if (nextQ && (typeof nextQ === 'undefined' ? 'undefined' : _typeof(nextQ)) === 'object') {
                                    nextQ = nextQ[0];
                                }
                                // ...
                                if (answers[i]) {
                                    value = answers[i].value;

                                    if (question && question.answer_type === 'equipment') {
                                        value = answers[i];
                                        scope.setLandscapeEquipment(question, value);
                                    }
                                }

                                if (question && question.answer_type !== 'equipment') {
                                    if (answers[i] && !oldAnswers[i] && question && value) {
                                        item = scope.setLandscapeElement(question, value);

                                        // answer is set but different
                                    } else if (answers[i] && oldAnswers[i] && value !== oldAnswers[i].value) {
                                        if (i !== 1 || !answers[nextQ] && !reset) {
                                            item = scope.setLandscapeElement(question, value);
                                        } else if (!reset) {
                                            scope.setLandscapeElement(question, value);
                                            item = reset = true;
                                        } else if (reset) {
                                            item = scope.setLandscapeElement(question, null);
                                        }
                                    } else if (answers[i] && oldAnswers[i] && value === oldAnswers[i].value) {
                                        if (reset) {
                                            scope.setLandscapeElement(question, null);
                                            item = answers[i] = null;
                                        } else {
                                            // set from init
                                            item = scope.setLandscapeElement(question, value);
                                        }
                                    }
                                }
                                result.push(item);
                            }
                            return result;
                        }();
                    }
                };

                scope.$watch('answers', watchAnswers, true);

                // INIT FORM

                var init = function init() {
                    if (scope.questions) {
                        for (var i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            var l;
                            if (scope.questions[i][0]) {
                                scope.questionsI++;
                            }

                            if (!scope.questions[i].length) {
                                l = Object.keys(scope.questions[i]).length;
                            } else {
                                l = scope.questions[i].length;
                            }

                            for (var it = 0, end1 = l, asc1 = end1 >= 0; asc1 ? it < end1 : it > end1; asc1 ? it++ : it--) {
                                // first question check if it has answers, otherwise go to step 0
                                // preventing user to try to enter further step url
                                if (i === 0 && !scope.questions[i][it].answer && scope.currentStep !== 1) {
                                    scope.answers = [];
                                    LandscapeElements.LandscapeElements = [];
                                    scope.landscapeElements = LandscapeElements.LandscapeElements;
                                    scope.goToStep(0);
                                    break;
                                }

                                if (scope.questions[i][it] && scope.questions[i][it].answer) {
                                    var qId = scope.questions[i][it].id;
                                    if (scope.questions[i][it].answer_type === 'equipment') {
                                        var itt;
                                        if (typeof scope.questions[i][it].answer === 'string') {
                                            var qA = scope.questions[i][it].answer.split(',');
                                            scope.answers[qId] = {};
                                            for (itt = 0, end2 = qA.length, asc2 = end2 >= 0; asc2 ? itt < end2 : itt > end2; asc2 ? itt++ : itt--) {
                                                var asc2, end2;
                                                var enums = scope.questions[i][it].enums;

                                                for (var ittt = 0, end3 = enums.length, asc3 = end3 >= 0; asc3 ? ittt < end3 : ittt > end3; asc3 ? ittt++ : ittt--) {
                                                    if (parseInt(enums[ittt].id_equipment) === parseInt(qA[itt])) {
                                                        scope.answers[qId][parseInt(qA[itt])] = {
                                                            value: true,
                                                            pictofont: enums[ittt].pictofont,
                                                            answer_func: enums[ittt].answer_func
                                                        };
                                                        scope.setLandscapeEquipment(scope.questions[i][it], scope.answers[qId][parseInt(qA[itt])]);
                                                    }
                                                }
                                            }
                                        } else {
                                            scope.answers[qId][scope.questions[i][it].answer] = {
                                                value: true,
                                                pictofont: scope.questions[i][it].pictofont,
                                                answer_func: scope.questions[i][it].answer_func
                                            };
                                        }

                                        if (scope.questions[i][it].popups && scope.questions[i][it].popups.length > 0) {
                                            for (itt = 0, end4 = scope.questions[i][it].popups.length, asc4 = end4 >= 0; asc4 ? itt < end4 : itt > end4; asc4 ? itt++ : itt--) {
                                                var asc4, end4;
                                                var popup = scope.questions[i][it].popups[itt];
                                                scope.answers[popup.id] = scope.answers[popup.id] || {};
                                                scope.answers[popup.id].value = popup.answer;
                                                scope.answers[popup.id].answer_func = popup.answer_func;
                                                scope.answers[qId].popups = scope.answers[scope.questions[i][it].id].popups || [];
                                                scope.answers[qId].popups[popup.id] = scope.answers[popup.id];
                                            }
                                        }
                                    } else if (scope.questions[i][it].answer_type === 'multi') {
                                        scope.answers[scope.questions[i][it].id] = { value: scope.questions[i][it].answer };
                                        var tmpMulti = JSON.parse(scope.questions[i][it].answer);

                                        for (var multiI = 0, end5 = scope.questions[i][it].multi.length, asc5 = end5 >= 0; asc5 ? multiI < end5 : multiI > end5; asc5 ? multiI++ : multiI--) {
                                            scope.questions[i][it].multi[multiI].value = tmpMulti[scope.questions[i][it].multi[multiI].index];
                                        }
                                    } else {
                                        scope.answers[scope.questions[i][it].id] = {
                                            value: scope.questions[i][it].answer,
                                            answer_func: scope.questions[i][it].answer_func
                                        };
                                    }
                                }

                                if (i === scope.questions.length - 1) {
                                    if (scope.questions[i][it] && !scope.getNextQuestion(scope.questions[i][it]) && scope.questions[i][it].answer && scope.questions[i][it].last) {
                                        scope.setLandscapeDone(null, true);
                                    } else {
                                        var loader = document.getElementById('landscape-loader');
                                        loader.style.display = 'none';
                                    }

                                    if (!scope.questions[i][it].answer && scope.currentStep !== 1) {
                                        scope.answers = [];
                                        LandscapeElements.LandscapeElements = [];
                                        scope.landscapeElements = LandscapeElements.LandscapeElements;
                                        scope.goToStep(0);
                                    }
                                }
                            }
                        }

                        scope.loaded = true;
                        if (scope.questions.length > 1) {
                            var lastQ = scope.questions[scope.questions.length - 1];
                            var cat = scope.questions[scope.questions.length - 1][0].category;
                            scope.goToQ(scope.questions.length - 1);
                        }

                        // Set event listener for transition end
                        scope.isSubscription = false;
                        if (scope.isSubscriptionState($state.current.name)) {
                            scope.isSubscription = true;
                        }

                        if (scope.isSubscription) {
                            scope.landscapeIsDone = scope.questions[scope.questions.length - 1][0].last === true && scope.questions[scope.questions.length - 1][0].answer !== undefined;
                            return $timeout(function () {
                                if (scope.$parent.isEdition !== true && scope.$parent.isNew !== true) {
                                    return scope.returnCanvas();
                                }
                                scope.$parent.isNew = false;
                                scope.$parent.isEdition = false;
                                return scope.landscapeOpened = true;
                            }, 1000);
                        }
                    }
                };

                scope.triggerLandscapeDoneAnimation = function (setLandscapeDone) {
                    return $timeout(function () {
                        scope.landscapeDone = setLandscapeDone;
                        if (scope.onLandscapeDone) {
                            scope.onLandscapeDone({ $event: { landscapeDone: setLandscapeDone } });
                        }
                        var loader = document.getElementById('landscape-loader');
                        if (loader) {
                            return loader.style.display = 'none';
                        }
                    }, 500);
                };

                if (scope.isSubscriptionState($state.current.name) && (scope.$parent.isNew === true || scope.$parent.isEdition === true)) {
                    return $rootScope.$on('landscapeModalReady', function (event, data) {
                        return init();
                    });
                }
                return init();
            }
        }
    };
}

function __range__(left, right, inclusive) {
    var range = [];
    var ascending = left < right;
    var end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
    }
    return range;
}

/***/ }),
/* 737 */,
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"landscape-form-wrapper\"\u003E\u003Cdiv id=\"form-container\"\u003E\u003Cul class=\"steps\" ng-show=\"currentStep !== 0\"\u003E\u003Cdiv class=\"hanger col-md-offset-1\" id=\"hanger-left\" ng-class=\"{'hanger-subscription': isSubscription}\"\u003E\u003Cspan class=\"hanger-line\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"hanger-tick\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger col-md-offset-5\" id=\"hanger-right\" ng-class=\"{'hanger-subscription': isSubscription}\" ng-click=\"easterEgg()\"\u003E\u003Cspan class=\"hanger-line\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"hanger-tick\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"steps-ariane hidden-xs\"\u003E\u003Cspan class=\"ariane-string\"\u003E\u003C\u002Fspan\u003E\u003Cspan id=\"ariane-string-achievement\" ng-style=\"setProgression(currentStep)\"\u003E\u003C\u002Fspan\u003E\u003Cli class=\"step\" ng-repeat=\"step in ::steps track by $index\" ng-class=\"{'done' : step.done, 'active' : step.active, 'navigable': step.navigation}\"\u003E\u003Cspan class=\"tick\"\u003E\u003C\u002Fspan\u003E\u003Clabel class=\"step-label\"\u003E{{step.label}}\u003C\u002Flabel\u003E\u003C\u002Fli\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"steps-title visible-xs-block\"\u003E\u003Ch4 ng-repeat=\"step in ::steps track by $index\" ng-if=\"step.active\"\u003E{{step.label}}\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"questions-wrapper\" id=\"step-0\" ng-show=\"currentStep==0\"\u003E\u003Cdiv class=\"questions\"\u003E\u003Ch3\u003EDessinez avec nous votre paysage énergétique !\u003C\u002Fh3\u003E\u003Cp\u003EEn quelques minutes, décrivez-nous votre situation et vos usages.\nGrâce à vos réponses, nous pourrons calculer la répartition de votre consommation électrique, usage par usage.\u003C\u002Fp\u003E\u003Cp\u003ELes réponses à ces questions, comme toutes les informations que vous nous confiez, sont strictement confidentielles.\nElles ne seront jamais communiquées à des tiers.\u003C\u002Fp\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cbutton class=\"btn-ls-form\" ng-click=\"nextStep(currentStep)\"\u003EAllons-y\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"questions-wrapper\" id=\"step-1\" ng-show=\"currentStep !== 0\"\u003E\u003Cdiv class=\"row error\" ng-show=\"errors.length\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\u003Cspan ng-repeat=\"error in errors\"\u003E{{error.message}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"questions\" id=\"questions\" ng-class=\"{'has-error': errors.length}\"\u003E\u003Cform name=\"landscapeform\" no-validate ng-submit=\"false\"\u003E\u003Cul class=\"question-list\" ng-style=\"setQuestionsWidth()\"\u003E\u003Cli class=\"question\" ng-repeat=\"question in questions track by $index\" ng-init=\"blockIndex = $index\" ng-attr-id=\"{{'step1-q'+$index}}\" ng-style=\"setQstyle('step1-q'+$index)\" ng-class=\"{'has-error': errors.length}\"\u003E\u003Cspan class=\"prev-q\" ng-show=\"$index&gt;0\" ng-click=\"previousQ($index)\"\u003E\u003C Q {{questionsI-1}}\u003C\u002Fspan\u003E\u003Cp class=\"qi\"\u003EQUESTION {{questionsI}}\u003C\u002Fp\u003E\u003Cdiv class=\"question-wrapper\" ng-repeat=\"q in ::question track by $index\" ng-class=\"{'temp':q.is_temperature}\"\u003E\u003Cp class=\"ql\"\u003E\u003Cstrong ng-bind-html=\"printLabel(q, question)\"\u003E\u003C\u002Fstrong\u003E\u003Cspan class=\"fa fa-question-circle\" ng-if=\"q.info_bulle\" uib-popover-html=\"getInfoBulleTemplate(q)\" popover-trigger=\"outsideClick\" popover-placement=\"{{ $first ? 'bottom' : 'top' }}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cul class=\"answers\" ng-if=\"q.answer_type == 'enum'\"\u003E\u003Cli class=\"answer\" ng-repeat=\"answer in q.enums track by $index\" ng-class=\"setEnumClass(q.enums, $first)\"\u003E\u003Cimg class=\"a-img-select fadeIn\" ng-click=\"setEnumAnswer(answers[q.id], answer.value, answer.answer_func, q)\" ng-if=\"answer.img\" ng-src=\"{{img_path}}\u002F{{answer.img}}\"\u003E\u003Cspan class=\"answer-label\" ng-click=\"setEnumAnswer(answers[q.id], answer.value, answer.answer_func, q)\"\u003E{{answer.value}}\u003C\u002Fspan\u003E\u003Cspan class=\"custom-radio\" ng-click=\"setEnumAnswer(answers[q.id], answer.value, answer.answer_func, q)\"\u003E\u003Cspan name=\"{{ setFormElemName() }}\" ng-class=\"{'checked':answers[q.id].value == answer.value ? true : answers[q.id].value ? false : q.default == answer.value}\" ng-init=\"answers[q.id].value = ( answers[q.id].value ? answers[q.id].value : q.default )\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cul class=\"answers\" ng-if=\"q.answer_type == 'equipment'\"\u003E\u003Cli class=\"answer\" ng-repeat=\"answer in ::q.enums track by $index\" ng-class=\"setEnumClass(q.enums, $first)\"\u003E\u003Cimg class=\"a-img-select fadeIn\" ng-click=\"setEquipmentAnswer(answers[q.id], answer, q)\" ng-if=\"answer.img\" ng-src=\"{{img_path}}\u002F{{answer.img}}\"\u003E\u003Cspan class=\"answer-label\" ng-click=\"setEquipmentAnswer(answers[q.id], answer, q)\"\u003E{{answer.value}}\u003C\u002Fspan\u003E\u003Cspan ng-click=\"setEquipmentAnswer(answers[q.id], answer, q)\" ng-class=\"{'custom-check':!q.exclusive,'custom-radio':q.exclusive}\"\u003E\u003Cspan ng-class=\"{&quot;checked&quot;:answers[q.id][answer.id_equipment].value}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Ca class=\"popup-trigger\" ng-if=\"answers[q.id][answer.id_equipment].value &amp;&amp; q.enums[$index].popup.length &gt; 0\" alt=\"editer\"\u003E\u003Ci class=\"fa\" ng-click=\"popUp(answer.popup, q.id)\" ng-class=\"popupHasError(answer.popup, q, answer.id_equipment) ? 'fa-exclamation' : 'fa-pencil-square-o'\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cul class=\"multi-questions\" ng-if=\"q.answer_type == 'multi'\"\u003E\u003Cli class=\"multi-question\" ng-repeat=\"multi in q.multi\" ng-class=\"setMultiClass(q)\"\u003E\u003Cdiv ng-if=\"multi.img\"\u003E\u003Cimg ng-src=\"{{img_path}}\u002F{{multi.img}}\"\u003E\u003C\u002Fdiv\u003E\u003Clabel\u003E{{ multi.label }}\u003C\u002Flabel\u003E\u003Cdiv class=\"multi-questions-input\"\u003E\u003Cinput tabindex=\"{{setTabIndex(q, questionsI)}}\" type=\"{{ multi.type }}\" ng-class=\"{'input-number':multi.type=='number'}\" ng-model=\"multi.value\" ng-change=\"setMultiAnswer(q, multi, blockIndex)\" placeholder=\"{{ multi.placeholder }}\" pattern=\"{{multi.type === 'number' ? '[0-9]*' : ''}}\" min=\"{{multi.min}}\" max=\"{{multi.max}}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv ng-if=\"q.answer_type != 'enum' &amp;&amp; q.answer_type != 'equipment' &amp;&amp; q.answer_type != 'multi'\"\u003E\u003Cdiv class=\"input-single-container\" ng-if=\"!q.is_temperature\"\u003E\u003Cinput tabindex=\"{{setTabIndex(q, questionsI)}}\" type=\"{{q.answer_type}}\" ng-model=\"answers[q.id].value\" ng-class=\"{'input-number':q.answer_type=='number'}\" placeholder=\"{{q.placeholder ? q.placeholder : &quot;0&quot;}}\" pattern=\"{{q.answer_type === 'number' ? '[0-9]*' : ''}}\" ng-change=\"isValid(answers[q.id], q)\" ng-init=\"answers[q.id].value = ( answers[q.id].value ? answers[q.id].value : toInt(q.default) )\"\u003E\u003Cspan class=\"unity\" ng-show=\"q.answer_format &amp;&amp; q.answer_format != '0'\" ng-bind-html=\"getAnswerFormatRaw(q.answer_format)\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"temperature-container\" ng-if=\"q.is_temperature\"\u003E\u003Cul class=\"temp-list\"\u003E\u003Cspan class=\"temp-line\"\u003E\u003C\u002Fspan\u003E\u003Cli ng-repeat=\"temp in temperatureList\" ng-click=\"setTemperatureAnswer(temp,q)\"\u003E\u003Cspan class=\"temp-circle\" ng-style=\"setTempStyle(temp, q)\"\u003E{{temp.value}}°\u003C\u002Fspan\u003E\u003Cspan class=\"temp-tooltip\" ng-show=\"answers[q.id].value == temp.value\" ng-style=\"setTempTooltipStyle(temp, q)\"\u003E{{temp.tooltip}}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ci ng-class=\"{spinner: disableSave}\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"validate-q noselect\" ng-if=\"hasNextQuestion(question)\" ng-click=\"!scope.disableSave &amp;&amp; validateQ($index)\" ng-class=\"{'disabled': disableSave}\"\u003EContinuer\u003C\u002Fspan\u003E\u003Cspan class=\"validate-q noselect\" id=\"saveLandscape\" ng-if=\"!hasNextQuestion(question)\" ng-click=\"!scope.disableSave &amp;&amp; validateQ($index)\" ng-class=\"{'disabled': disableSave}\"\u003EEnregistrer\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5 col-md-5 col-lg-5 col-lg-offset-1\"\u003E\u003Ch2 id=\"init-title\" ng-show=\"!landscapeElements.length\"\u003EIci, se dessinera votre paysage énergetique.\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-12 col-lg-12 done-text\" ng-if=\"landscapeDone\"\u003E\u003Ch3\u003EILLUSTRATION INTERACTIVE\u003C\u002Fh3\u003E\u003Ch2\u003EMon paysage énergétique\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Chr id=\"bottom-line\"\u003E\u003Clandscape-canvas\u003E\u003C\u002Flandscape-canvas\u003E\u003Cspan id=\"equipments-counter\" ng-show=\"landscapeDone\"\u003E\u003Cspan class=\"counter\"\u003E{{ nBubbles }}\u003C\u002Fspan\u003E\u003Cspan class=\"counter-label\"\u003EÉQUIPEMENTS ÉLECTRIQUES\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cul class=\"equipments-list\"\u003E\u003Cdiv id=\"vis\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Ful\u003E\u003Cplum-feature feature-name=\"landscapeEdit\" ng-show=\"!isSubscription\"\u003E\u003Cbutton class=\"fadeIn\" id=\"edit-landscape-btn\" ng-if=\"$root.dataFeature['landscapeEdit']\" ng-show=\"landscapeDone\" ng-click=\"editForm()\"\u003E\u003Ci class=\"fa fa-pencil-square-o\"\u003E\u003C\u002Fi\u003EÉditer mes infos\u003C\u002Fbutton\u003E\u003C\u002Fplum-feature\u003E\u003Cdiv id=\"landscape-popup\" ng-show=\"popuping || popup\"\u003E\u003Cdiv id=\"popup-loader\" ng-show=\"!popup\"\u003E\u003Ci class=\"spinner\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 inner\" ng-class=\"{'popup-large': popupLarge}\" ng-show=\"popup\"\u003E\u003Cspan class=\"close\" ng-click=\"popup = false\"\u003E\u003Ci class=\"fa fa-times\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Cul class=\"popqlist\"\u003E\u003Cli class=\"popq\" ng-repeat=\"popQuestion in popQuestions\"\u003E\u003Clabel\u003E{{ popQuestion.label }}\u003C\u002Flabel\u003E\u003Cdiv class=\"form-group number\" ng-if=\"popQuestion.answer_type != 'enum' &amp;&amp; q.answer_type != 'equipment'\"\u003E\u003Cinput tabindex=\"-1\" type=\"{{popQuestion.answer_type}}\" ng-model=\"answers[popQuestion.id].value\" ng-class=\"{'input-number':popQuestion.answer_type=='number'}\" placeholder=\"{{popQuestion.placeholder ? popQuestion.placeholder : &quot;0&quot;}}\" ng-change=\"isValid(answers[popQuestion.id], popQuestion)\" ng-init=\"answers[q.id].value = ( answers[popQuestion.id].value ? answers[popQuestion.id].value : toInt(popQuestion.default) )\"\u003E\u003Cspan class=\"unity\" ng-show=\"popQuestion.answer_format &amp;&amp; popQuestion.answer_format != '0'\" ng-bind-html=\"getAnswerFormatRaw(popQuestion.answer_format)\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"enums\" ng-if=\"popQuestion.answer_type == 'enum'\"\u003E\u003Cli class=\"answer\" ng-repeat=\"answer in popQuestion.enums track by $index\" ng-class=\"setEnumClass(popQuestion.enums, $first)\" ng-click=\"setEnumAnswer(answers[popQuestion.id], answer.value, answer.answer_func, popQuestion)\"\u003E\u003Cspan class=\"answer-label\"\u003E{{answer.value}}\u003C\u002Fspan\u003E\u003Cspan class=\"custom-radio\" ng-click=\"setEnumAnswer(answers[popQuestion.id], answer.value, answer.answer_func, popQuestion)\"\u003E\u003Cspan name=\"{{ setFormElemName() }}\" ng-class=\"{'checked':answers[popQuestion.id].value == answer.value ? true : answers[popQuestion.id].value ? false : popQuestion.default == answer.value}\" ng-init=\"answers[popQuestion.id].value = ( answers[popQuestion.id].value ? answers[popQuestion.id].value : popQuestion.default )\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cspan class=\"validate-popup\" ng-click=\"popup = false\"\u003EValider\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"landscape-loader\" ng-show=\"currentStep !== 0 &amp;&amp; !loaded\"\u003E\u003Ci class=\"spinner\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"text-center modal-inner\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1 text-center\"\u003E\u003Ch1 class=\"light darkish-pink\"\u003EPaysage Énergétique\u003C\u002Fh1\u003E\u003Cp class=\"margin-top-20\"\u003EMerci d'avoir complété votre \"paysage énergétique\", celui-ci nous permettra d'évaluer encore mieux votre consommation.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-20\"\u003ENous préparons aussi de nouvelles fonctionnalités, qui exploitent vos réponses.\nPatience ! Nous vous tiendrons informé :)\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-20 text-center\"\u003E\u003Cbutton class=\"btn btn-lg btn-primary background-light-pink\" ng-click=\"close()\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


newsletterModal.$inject = ["$uibModal", "$timeout", "$cookies", "DeviceChecker"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty = __webpack_require__(14);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = newsletterModal;

/** @ngInject */

function newsletterModal($uibModal, $timeout, $cookies, DeviceChecker) {
    return {
        restrict: 'E',
        link: function link($scope) {
            var MOBILE_DISPLAY_DELAY = 7000;
            var LANDING_ID_CAMPAIGN = 'LANDING_NEWSLETTER';
            var COOKIE_LABEL_HAS_OPENED_NEWSLETTER = 'hasOpenedNewsletterOnce';
            var COOKIE_EXPIRE_DATE = (0, _moment2.default)().add(15, 'day').toDate();

            var hasOpenedOnce = false;
            var openNewsletterModal = function openNewsletterModal() {
                if (!hasOpenedOnce) {
                    hasOpenedOnce = true;
                    $cookies.put(COOKIE_LABEL_HAS_OPENED_NEWSLETTER, true, { expires: COOKIE_EXPIRE_DATE });
                    var referrer = (0, _isEmpty2.default)(document.referrer) ? undefined : document.referrer;
                    return $uibModal.open({
                        animation: true,
                        size: 'lg',
                        template: __webpack_require__(741)(),
                        backdrop: 'static',
                        windowClass: 'newsletter-modal modal-vertical-center',
                        controller: ["$scope", "$uibModalInstance", "CampaignLanding", "CampaignLandingType", function controller($scope, $uibModalInstance, CampaignLanding, CampaignLandingType) {
                            $scope.form = {
                                email: ''
                            };
                            $scope.isSubmitted = false;
                            $scope.submit = function () {
                                CampaignLanding.submitCampaignInformation({
                                    id_campaign: LANDING_ID_CAMPAIGN,
                                    type: CampaignLandingType.SUBSCRIBE,
                                    referrer: referrer,
                                    mail: $scope.form.email
                                });
                                $scope.isSubmitted = true;
                            };

                            $scope.close = function () {
                                return $uibModalInstance.dismiss();
                            };
                        }]
                    });
                }
            };

            var activate = function activate() {
                if (!$cookies.get(COOKIE_LABEL_HAS_OPENED_NEWSLETTER)) {
                    if (DeviceChecker.isMobile()) {
                        var delayedOpenNewsletterModal$ = $timeout(openNewsletterModal, MOBILE_DISPLAY_DELAY);

                        return $scope.$on('$destroy', function () {
                            return $timeout.cancel(delayedOpenNewsletterModal$);
                        });
                    }
                    (0, _jquery2.default)('body').on('mouseleave.landingNewsletterModal', openNewsletterModal);

                    return $scope.$on('$destroy', function () {
                        return (0, _jquery2.default)('body').off('mouseleave.landingNewsletterModal');
                    });
                }
            };

            activate();
        }
    };
}

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"newsletter-form\" ng-if=\"!isSubmitted\"\u003E\u003Cheader class=\"visible-xs-block\"\u003E\u003Ch3 class=\"title\"\u003EGardons le contact !\u003C\u002Fh3\u003E\u003C\u002Fheader\u003E\u003Cdiv class=\"container-fluid newsletter-information\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-3 col-md-4 newsletter-information-image\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fampoule.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-9 col-md-8 newsletter-information-detail\"\u003E\u003Ch3 class=\"title hidden-xs\"\u003EGardons le contact !\u003C\u002Fh3\u003E\u003Ch3 class=\"subtitle\"\u003EUne fois par semaine, recevez un éclairage de Plüm énergie\u003C\u002Fh3\u003E\u003Cp\u003ETous&nbsp;les&nbsp;vendredis, en&nbsp;30&nbsp;secondes&nbsp;de&nbsp;lecture, des&nbsp;clés&nbsp;pour&nbsp;consommer&nbsp;plus intelligemment&nbsp;son&nbsp;électricité\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"newsletter-actions\"\u003E\u003Cform ng-submit=\"submit()\"\u003E\u003Cinput type=\"email\" name=\"email\" ng-model=\"form.email\" required placeholder=\"Mon adresse e-mail\"\u003E\u003Cbutton class=\"btn btn-submit background-light-pink\" type=\"submit\"\u003ERecevoir les éclairages de Plüm\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-cancel background-bluegrey-pale\" type=\"button\" ng-click=\"close()\"\u003E\u003Cspan class=\"hidden-xs\"\u003ENon merci, je préfère rester dans le noir :)\u003C\u002Fspan\u003E\u003Cspan class=\"visible-xs-inline\"\u003ENon merci\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"newsletter-form-success-wrapper\" ng-if=\"isSubmitted\"\u003E\u003Cdiv class=\"newsletter-form-success hidden-xs\"\u003E\u003Cdiv class=\"container-fluid newsletter-information\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-3 col-md-4 newsletter-information-image\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fcheck-desktop.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-9 col-md-8 newsletter-information-detail\"\u003E\u003Ch3\u003EVotre adresse e-mail a bien été enregistrée.\u003C\u002Fh3\u003E\u003Ch3\u003EÀ bientôt !\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"newsletter-actions\"\u003E\u003Cbutton class=\"btn btn-cancel background-waterblue\" type=\"button\" ng-click=\"close()\"\u003EContinuer sur&nbsp;espace-client.plum.fr\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"newsletter-form-success newsletter-form-success-mobile\"\u003E\u003Cdiv class=\"newsletter-form-success-item\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fcheck-desktop.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"newsletter-form-success-item\"\u003E\u003Ch3\u003EVotre adresse e-mail a bien été enregistrée.\u003C\u002Fh3\u003E\u003Ch3\u003EÀ bientôt\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"newsletter-form-success-item newsletter-actions\"\u003E\u003Cbutton class=\"btn btn-cancel background-waterblue\" type=\"button\" ng-click=\"close()\"\u003EContinuer sur&nbsp;espace-client.plum.fr\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


noApplyClick.$inject = ["$parse"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = noApplyClick;

/** @ngInject */

function noApplyClick($parse) {
    return {
        compile: function compile($element, attr) {
            var fn = $parse(attr.noApplyClick);
            return function (scope, element, attr) {
                return element.on('click', function (event) {
                    return fn(scope, { $event: event, $element: element });
                });
            };
        }
    };
}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


plumFeature.$inject = ["featuresService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * @ngdoc directive
 * @name plumFeature
 * @restrict EA
 * @multiElement
 * @param {string} featureName is the name of the key you want to look
 * for in the JSON file returned from the API
 * @param {function} featureCallback is a callback that is called on the
 * data returned by the API
 * @example
 <plum-feature feature-name="subscription" feature-callback="">
   <div ng-if="dataFeature">
     Show me if subscription is true
   </div>
 </plum-feature>
*/
exports.default = plumFeature;

/** @ngInject */

function plumFeature(featuresService) {
    return {
        restrict: 'E',
        scope: {
            featureCallback: '=',
            featureName: '@'
        },
        template: '<span ng-transclude></span>',
        transclude: true,
        link: function link(scope, element, attrs, ctrl, transclude) {
            var callback = function callback(features) {
                scope.$parent.dataFeature = scope.$parent.dataFeature || [];
                scope.$parent.dataFeature[scope.featureName] = features[scope.featureName];
                if (scope.featureCallback !== undefined) {
                    return scope.featureCallback(scope.$parent, features[scope.featureName]);
                }
            };

            return featuresService.getFeatures(callback);
        }
    };
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


popin.$inject = ["$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isInteger = __webpack_require__(745);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = popin;

/** @ngInject */

function popin($timeout) {
    return {
        restrict: 'E',
        template: __webpack_require__(746)(),
        transclude: true,
        scope: {
            displayDelay: '=?',
            foldDelay: '=?'
        },
        link: function link(scope) {
            scope.displayDelay = (0, _isInteger2.default)(scope.displayDelay) ? scope.displayDelay : 0;
            scope.popin = { isDisplay: false, isFold: false };
            scope.popinClass = function () {
                return {
                    'popin-visible': scope.popin.isDisplay,
                    'popin-hidden': !scope.popin.isDisplay,
                    'popin-fold-open': scope.popin.isFold,
                    'popin-fold-close': !scope.popin.isFold
                };
            };

            var enablePopin = function enablePopin() {
                scope.popin.isDisplay = true;
            };

            var foldPopin = function foldPopin() {
                scope.popin.isFold = true;
            };

            $timeout(enablePopin, scope.displayDelay);

            if ((0, _isInteger2.default)(scope.displayDelay)) {
                $timeout(foldPopin, scope.foldDelay);
            }
        }
    };
}

/***/ }),
/* 745 */,
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"popin\" ng-class=\"popinClass()\"\u003E\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"popin.isDisplay = false\"\u003E\u003C\u002Fi\u003E\u003Cng-transclude\u003E\u003C\u002Fng-transclude\u003E\u003Cdiv class=\"popin-fold-button\" ng-click=\"popin.isFold = !popin.isFold\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


potBalance.$inject = ["PotManager"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = potBalance;

/** @ngInject */

function potBalance(PotManager) {
    return {
        restrict: 'E',
        template: '<span>{{pot.real | frAmount}}€</span>',
        link: function link(scope) {
            scope.pot = PotManager.getPotBalance();
            PotManager.watch(function (newPot) {
                scope.pot = newPot;
            });
        }
    };
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


potDivision.$inject = ["ReportManager"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _last = __webpack_require__(294);

var _last2 = _interopRequireDefault(_last);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable
    block-scoped-var,
    no-eq-null,
    no-use-before-define,
    no-var,
*/
exports.default = potDivision;

/** @ngInject */

function potDivision(ReportManager) {
    return {
        scope: {
            pot: '=',
            userInfo: '='
        },
        restrict: 'E',
        template: __webpack_require__(749)(),
        link: function link($scope) {
            $scope.realVisible = $scope.pot.real !== undefined;
            var contract = $scope.userInfo.contractSelected;

            var getLatestReadMonthIndex = function getLatestReadMonthIndex(dateMonths, lastReadings) {
                var date = lastReadings ? (0, _moment2.default)(lastReadings[0] != null ? lastReadings[0].end_date : undefined) : (0, _moment2.default)();
                for (var index = 0; index < dateMonths.length; index++) {
                    var month = dateMonths[index];
                    if (date.isSame(month, 'month')) {
                        return date.date() >= 25 ? index + 1 : index;
                    }
                }
                return date.isAfter((0, _last2.default)(dateMonths), 'month') ? dateMonths.length : 0;
            };

            // Compute visual elements from data
            $scope.computeFromColorIndex = function (interval, month, colorIndex) {
                // In case there is an inconsistency in the data returned by the API
                if (interval < 0) {
                    $scope.colored = [];
                    $scope.coloredWidth = 0;
                    $scope.coloredMonthWidth = 0;

                    $scope.uncolored = [];
                    $scope.uncoloredWidth = 0;
                    $scope.uncoloredMonthWidth = 0;
                    console.error('Inconsistent data : month interval is "' + interval + '" but should be positive');
                }
                $scope.colored = months.slice(0, colorIndex);
                $scope.coloredWidth = $scope.colored.length * $scope.monthWidth;
                $scope.coloredMonthWidth = 100 / $scope.colored.length;

                $scope.uncolored = months.slice(colorIndex);
                $scope.uncoloredWidth = $scope.uncolored.length * $scope.monthWidth;
                $scope.uncoloredMonthWidth = 100 / $scope.uncolored.length;
            };

            if (contract != null) {
                var nextReadingDate = (0, _moment2.default)(contract.prm.next_reading_date);
                var commissioningDate = contract.commissioning_date ? (0, _moment2.default)(contract.commissioning_date) : undefined;
                var lastReadingDate = contract.prm.last_real_reading_date ? (0, _moment2.default)(contract.prm.last_real_reading_date).add(1, 'month') : undefined;
                var startDate = lastReadingDate || commissioningDate || (0, _moment2.default)();
                var period = nextReadingDate.year() * 12 + nextReadingDate.month() - (startDate.year() * 12 + startDate.month());
                var interval = Math.min(period, 5);

                // Populates an array with the name of the months
                var months = [];
                var dateMonths = [];
                for (var i = 0, end = interval, asc = end >= 0; asc ? i <= end : i >= end; asc ? i += 1 : i -= 1) {
                    dateMonths[i] = startDate.clone().add(i, 'months');
                    months[i] = dateMonths[i].format('MMM');
                }

                $scope.startDate = startDate.clone();
                $scope.endDate = nextReadingDate;
                $scope.monthWidth = 100 / (1 + interval);

                var colorIndex = getLatestReadMonthIndex(dateMonths, ReportManager.values);
                $scope.computeFromColorIndex(interval, months, colorIndex);

                // Watch for values to change on report
                return ReportManager.watch(function (contract) {
                    colorIndex = getLatestReadMonthIndex(dateMonths, contract != null ? contract.lastReadings : undefined);
                    return $scope.computeFromColorIndex(interval, months, colorIndex);
                });
            }
        }
    };
}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"pot-division\"\u003E\u003Cdiv class=\"col-xs-6 col-sm-4\" ng-if=\"realVisible\"\u003E\u003Cdiv class=\"pot-real-label\"\u003EUtilisable\u003C\u002Fdiv\u003E\u003Cdiv class=\"pot-real\" ng-class=\"{'pot-real-mobile': isMobile()}\"\u003E{{pot.real | frAmount}}€\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-8\"\u003E\u003Cdiv class=\"total-period-month\"\u003E\u003Cdiv class=\"colored\" ng-style=\"{width: coloredWidth + '%'}\" uib-popover-template=\"'unveiled-period'\" popover-trigger=\"mouseenter\"\u003E\u003Cdiv class=\"month\" ng-repeat=\"month in colored\" ng-class=\"{'month-mobile': isMobile()}\" ng-style=\"{width: coloredMonthWidth + '%'}\"\u003E{{month}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"uncolored\" ng-style=\"{width: uncoloredWidth + '%'}\" uib-popover-template=\"'veiled-period'\" popover-trigger=\"mouseenter\"\u003E\u003Cdiv class=\"month\" ng-repeat=\"month in uncolored\" ng-class=\"{'month-mobile': isMobile()}\" ng-style=\"{width: uncoloredMonthWidth + '%'}\"\u003E{{month}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"colored\"\u003E\u003Cdiv class=\"pot-estimated\"\u003E+ {{pot.estimated | frAmount}}€\u003Cspan class=\"user-pot-value-label\" ng-if=\"pot.estimated &gt; 0\"\u003EEstimé\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"unveiled-period\"\u003E\u003Cdiv\u003EBonus estimé pour la période du {{ startDate | amDateFormat:'DD\u002FMM\u002FYYYY' }}\nau {{ endDate | amDateFormat:'DD\u002FMM\u002FYYYY' }} :\u003Cbr\u003E{{pot.estimated | frAmount}}€\u003Cbr\u003E\n\u003Cbr\u003ENB : ce bonus sera crédité sur votre cagnotte après le passage du technicien Enedis, pour la relève semestrielle.\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"veiled-period\"\u003E\u003Cdiv\u003EFaites votre auto-relève chaque fin de mois pour suivre vos économies d’énergie et voir votre cagnotte augmenter.\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


report.$inject = ["Contract", "ReportManager", "PotManager", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _castArray = __webpack_require__(295);

var _castArray2 = _interopRequireDefault(_castArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = report;

/** @ngInject */

function report(Contract, ReportManager, PotManager, ErrorCatcher) {
    return {
        restrict: 'E',
        template: __webpack_require__(751)(),
        scope: {
            userInfo: '='
        },
        link: function link($scope) {
            $scope.errors = {
                display: false
            };
            $scope.canForceWarning = false;
            $scope.errorMessages = null;
            $scope.newReport = {};
            $scope.report = ReportManager;

            var refreshReport = function refreshReport() {
                $scope.report.updateClass('read');
                return PotManager.update();
            };

            $scope.enableReport = function () {
                $scope.report.updateClass('input');
                ReportManager.message = null;
            };

            $scope.closeErrors = function () {
                $scope.errors.display = false;
            };

            $scope.updateReport = function (newReport) {
                var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                if ($scope.userInfo.contractSelected.plan === 'Base' && newReport.base || newReport.hp && newReport.hc) {
                    $scope.errors.display = false;
                    if ($scope.userInfo.contractSelected) {
                        return Contract.report({ id: $scope.userInfo.contractSelected.id, force: force }, newReport).$promise.then(function (response) {
                            if (response && response.status === 'SUCCESS') {
                                $scope.newReport = {};
                                return Contract.get({ id: $scope.userInfo.contractSelected.id }).$promise.then(function (contract) {
                                    ReportManager.updateContract(contract);
                                    return refreshReport();
                                }).then(function () {
                                    ReportManager.message = 'Votre relève a bien été enregistrée.';
                                });
                            } else if (response && response.status === 'WARNING') {
                                ReportManager.message = response.message;
                                $scope.errorMessages = [ReportManager.message];
                                $scope.errors.display = true;
                                $scope.canForceWarning = true;
                            } else {
                                if (response && response.type) {
                                    switch (response.type) {
                                        case 'LINKY':
                                            ReportManager.message = 'Les auto-relèves ne sont pas acceptées pour les compteurs Linky.';
                                            break;
                                        case 'ENEDIS':
                                            ReportManager.message = 'Une erreur technique est survenue lors de la transmission à Enedis.';
                                            break;
                                        case 'CONS_INF_0':
                                            ReportManager.message = 'La relève saisie est inférieure à la dernière relève réelle. Nous vous recontacterons pour vous indiquer la marche à suivre.';
                                            break;
                                        default:
                                            ReportManager.message = 'Une erreur technique est survenue.';
                                    }
                                } else {
                                    ReportManager.message = 'Une erreur technique est survenue.';
                                }
                                $scope.errorMessages = [ReportManager.message];
                                $scope.errors.display = true;
                                $scope.canForceWarning = false;
                            }
                        }).catch(function (error) {
                            if (error.data && error.data.error && error.data.error.message && error.data.error.canForce !== undefined) {
                                $scope.errors.display = true;
                                $scope.canForceWarning = error.data.error.canForce;
                                $scope.errorMessages = (0, _castArray2.default)(error.data.error.message);
                            } else {
                                var message = 'Une erreur s’est produite.  Votre relève n’a pas été enregistrée.';
                                if (error.data && error.data.error && error.data.error.message && error.data.error.display) {
                                    message = error.data.error.message;
                                }
                                ReportManager.message = message;
                                refreshReport();
                            }
                            return ErrorCatcher.catchError(error);
                        });
                    }
                } else {
                    return refreshReport();
                }
            };

            var activate = function activate() {
                return ReportManager.updateContract($scope.userInfo.contractSelected);
            };

            return activate();
        }
    };
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"form-body\" ng-submit=\"updateReport(newReport)\" uib-popover-template=\"'error-messages'\" popover-trigger=\"'none'\" popover-is-open=\"errors.display\" popover-placement=\"bottom\"\u003E\u003Cdiv class=\"report-input report-input-large\" ng-if=\"userInfo.contractSelected.plan == 'Base'\"\u003E\u003Clabel\u003ERelève\u003C\u002Flabel\u003E\u003Cinput name=\"base\" ng-show=\"report.class=='input'\" ng-model=\"newReport.base\" ng-focus=\"closeErrors()\" maxlength=\"6\" pattern=\"[0-9]*\" min=\"0\" max=\"999999\" title=\"1 à 6 chiffres\" placeholder=\"{{ report.contract.lastReadings[0].value }}\" type=\"number\"\u003E\u003Cdiv class=\"report-value\" ng-show=\"report.class=='read'\"\u003E{{ report.contract.lastReadings[0].value }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"report-input report-input-small\" ng-if=\"userInfo.contractSelected.plan == 'Heures creuses' &amp;&amp; userInfo.contractSelected.prm.metter_kind !== 'EMC'\"\u003E\u003Clabel\u003EHeures pleines\u003C\u002Flabel\u003E\u003Cinput name=\"heures_pleines\" ng-show=\"report.class=='input'\" ng-model=\"newReport.hp\" ng-focus=\"closeErrors()\" maxlength=\"6\" pattern=\"[0-9]*\" min=\"0\" max=\"999999\" title=\"1 à 6 chiffres\" placeholder=\"{{ report.contract.lastReadings[0].dial == 'Heures Pleines' ? report.contract.lastReadings[0].value : report.contract.lastReadings[1].value }}\" type=\"number\"\u003E\u003Cdiv class=\"report-value\" ng-show=\"report.class=='read'\"\u003E{{ report.contract.lastReadings[0].dial == 'Heures Pleines' ? report.contract.lastReadings[0].value : report.contract.lastReadings[1].value }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"report-input report-input-small\" ng-if=\"userInfo.contractSelected.plan == 'Heures creuses'\"\u003E\u003Clabel\u003EHeures creuses\u003C\u002Flabel\u003E\u003Cinput name=\"heures_creuses\" ng-show=\"report.class=='input'\" ng-model=\"newReport.hc\" ng-focus=\"closeErrors()\" maxlength=\"6\" pattern=\"[0-9]*\" min=\"0\" max=\"999999\" title=\"1 à 6 chiffres\" placeholder=\"{{ report.contract.lastReadings[0].dial == 'Heures Creuses' ? report.contract.lastReadings[0].value : report.contract.lastReadings[1].value }}\" type=\"number\"\u003E\u003Cdiv class=\"report-value\" ng-show=\"report.class=='read'\"\u003E{{ report.contract.lastReadings[0].dial == 'Heures Creuses' ? report.contract.lastReadings[0].value : report.contract.lastReadings[1].value }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"report-input report-input-small\" ng-if=\"userInfo.contractSelected.plan == 'Heures creuses' &amp;&amp; userInfo.contractSelected.prm.metter_kind === 'EMC'\"\u003E\u003Clabel\u003EHeures pleines\u003C\u002Flabel\u003E\u003Cinput name=\"heures_pleines\" ng-show=\"report.class=='input'\" ng-model=\"newReport.hp\" ng-focus=\"closeErrors()\" maxlength=\"6\" pattern=\"[0-9]*\" min=\"0\" max=\"999999\" title=\"1 à 6 chiffres\" placeholder=\"{{ report.contract.lastReadings[0].dial == 'Heures Pleines' ? report.contract.lastReadings[0].value : report.contract.lastReadings[1].value }}\" type=\"number\"\u003E\u003Cdiv class=\"report-value\" ng-show=\"report.class=='read'\"\u003E{{ report.contract.lastReadings[0].dial == 'Heures Pleines' ? report.contract.lastReadings[0].value : report.contract.lastReadings[1].value }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"report-button\" ng-switch on=\"report.class\"\u003E\u003Cbutton class=\"background-bluegrey btn\" type=\"submit\" ng-switch-when=\"input\"\u003EEnregistrer\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-gold\" ng-if=\"!userInfo.contractSelected.isLinkyCommunicating\" type=\"button\" ng-switch-when=\"read\" ng-click=\"enableReport()\" ng-disabled=\"!report.canEdit()\"\u003ERelever\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"report-message\" ng-if=\"userInfo.contractSelected.isLinkyCommunicating\"\u003E\u003Cp\u003EVous disposez d’un compteur nouvelle génération. Vous n’avez pas besoin de faire votre auto-relève. Nous mettons votre suivi conso à jour chaque mois.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"report-message\" ng-if=\"report.message\"\u003E\u003Cp\u003E{{ report.message }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"report-message\" ng-if=\"!report.message\"\u003E\u003Cp ng-if=\"!report.canEditStatus.isContractDefined\"\u003EAucun contrat n'est défini\u003C\u002Fp\u003E\u003Cp ng-if=\"report.canEditStatus.isContractDefined &amp;&amp; !report.canEditStatus.isNotReportedToday &amp;&amp; !userInfo.contractSelected.isLinkyCommunicating\"\u003EVous avez déjà effectué une auto-relève aujourd'hui, revenez demain !\u003C\u002Fp\u003E\u003Cp ng-if=\"report.canEditStatus.isContractDefined &amp;&amp; report.canEditStatus.isNotReportedToday &amp;&amp; !report.canEditStatus.isAllowedReportStatus\"\u003ELe status de votre contract ne vous permet pas de faire une relève.\nMerci de refaire votre relève dans 1 ou 2 jours le temps que votre contrat soit actif.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"error-messages\"\u003E\u003Cdiv\u003E\u003Cdiv ng-repeat=\"message in errorMessages\"\u003E\u003Ci class=\"fa fa-exclamation-triangle\"\u003E&nbsp;\u003C\u002Fi\u003E\u003Cspan\u003E{{message}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cp\u003E\u003Cdiv class=\"btn-toolbar btn-right\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-if=\"canForceWarning\" ng-click=\"closeErrors()\"\u003ECorriger\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-gold\" ng-if=\"canForceWarning\" ng-click=\"updateReport(newReport, true)\"\u003EJe suis sûr\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fp\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


scrollToNext.$inject = ["smoothScroll"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _last = __webpack_require__(294);

var _last2 = _interopRequireDefault(_last);

var _flow = __webpack_require__(133);

var _flow2 = _interopRequireDefault(_flow);

var _map = __webpack_require__(203);

var _map2 = _interopRequireDefault(_map);

var _filter = __webpack_require__(313);

var _filter2 = _interopRequireDefault(_filter);

var _first = __webpack_require__(314);

var _first2 = _interopRequireDefault(_first);

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable
    no-eq-null,
*/
exports.default = scrollToNext;

/** @ngInject */

function scrollToNext(smoothScroll) {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            var selectors = attr.scrollToNext.split(' ');
            var offset = 72;
            var threshold = 3;
            var scrollToNextElement = function scrollToNextElement() {
                var windowOffsetTop = (0, _jquery2.default)(window).scrollTop();
                var $nextElement = (0, _flow2.default)((0, _map2.default)(function (selector) {
                    return (0, _jquery2.default)(selector);
                }), (0, _filter2.default)(function ($element) {
                    return $element.offset() && windowOffsetTop < $element.offset().top - offset - threshold;
                }), _first2.default)(selectors);

                if ($nextElement != null) {
                    return smoothScroll($nextElement[0], { offset: offset });
                }
            };

            var toggleScrollElementVisibility = function toggleScrollElementVisibility() {
                var $window = (0, _jquery2.default)(window);
                var $lastElement = (0, _jquery2.default)((0, _last2.default)(selectors));
                if ($lastElement != null) {
                    var lastItemVisible = $window.scrollTop() + $window.height() > $lastElement.offset().top + $lastElement.height() / 2;
                    if (lastItemVisible) {
                        return element.hide();
                    }
                    return element.show();
                }
            };

            element.on('click.scrollToNext', scrollToNextElement);
            (0, _jquery2.default)(window).on('scroll.scrollToNext', toggleScrollElementVisibility);

            return scope.$on('$destroy', function () {
                element.off('.scrollToNext');
                return (0, _jquery2.default)(window).off('.scrollToNext');
            });
        }
    };
}

/***/ }),
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


subscriptionTimelineGraph.$inject = ["$filter"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaultTo = __webpack_require__(71);

var _defaultTo2 = _interopRequireDefault(_defaultTo);

var _map = __webpack_require__(53);

var _map2 = _interopRequireDefault(_map);

var _filter = __webpack_require__(82);

var _filter2 = _interopRequireDefault(_filter);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _d = __webpack_require__(96);

var _d2 = _interopRequireDefault(_d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = subscriptionTimelineGraph;

/** @ngInject */

function subscriptionTimelineGraph($filter) {
    return {
        restrict: 'E',
        scope: {
            data: '<',
            sleek_timetable: '<sleekTimetable',
            tutorial: '<?'
        },
        link: function link($scope, element) {
            var xlgGraphSize = { width: 860, height: 360 };

            var containerWidth = xlgGraphSize.width;
            var containerHeight = xlgGraphSize.height;
            var margin = { top: 50, right: 5, bottom: 5, left: 5 };
            var width = containerWidth - margin.left - margin.right;
            var height = containerHeight - margin.top - margin.bottom;
            var viewBox = '0 0 ' + containerWidth + ' ' + containerHeight;
            var transitionDuration = 750;

            var chart = {};
            $scope.tutorial = (0, _defaultTo2.default)($scope.tutorial, {});

            var extendPadding = function extendPadding(array, accessor, paddingPercent) {
                var extend = _d2.default.extent(array, accessor);
                var range = extend[1] - extend[0];
                return [extend[0] - range * paddingPercent, extend[1] + range * paddingPercent];
            };

            var seasonClass = function seasonClass(d) {
                var date = (0, _moment2.default)(d.date);
                var isWinter = [11, 0, 1].indexOf(date.month()) > -1;
                var isSummer = [5, 6, 7].indexOf(date.month()) > -1;

                if (isWinter) {
                    return 'month-info-winter';
                } else if (isSummer) {
                    return 'month-info-summer';
                }
                return '';
            };

            var generateGraph = function generateGraph() {
                if ($scope.sleek_timetable) {
                    element.addClass('averaged');
                } else {
                    element.removeClass('averaged');
                }

                var svg = _d2.default.select(element.get(0)).append('svg').attr('width', containerWidth).attr('height', containerHeight).attr('preserveAspectRatio', 'xMinYMin meet').attr('viewBox', viewBox);

                var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

                var x = _d2.default.scale.ordinal().domain((0, _map2.default)($scope.data, function (d) {
                    return d.date;
                })).rangeBands([0, width], 0, 0);

                var y = _d2.default.scale.linear().domain(extendPadding($scope.data, function (d) {
                    return d.amount;
                }, 0.5)).rangeRound([height, 0]);

                // Data positionning logic
                var amount = {
                    line: _d2.default.svg.line().x(function (d) {
                        return x(d.date) + x.rangeBand(d) / 2;
                    }).y(function (d) {
                        return y(d.amount);
                    }),
                    area: _d2.default.svg.area().x(function (d) {
                        return x(d.date) + x.rangeBand(d) / 2;
                    }).y0(height).y1(function (d) {
                        return y(d.amount);
                    }),
                    label: function label(d) {
                        return $filter('frAmount')(d.amount) + ' \u20AC';
                    }
                };
                var average = {
                    line: _d2.default.svg.line().x(function (d) {
                        return x(d.date) + x.rangeBand(d) / 2;
                    }).y(function (d) {
                        return y(d.sleeked);
                    }),
                    area: _d2.default.svg.area().x(function (d) {
                        return x(d.date) + x.rangeBand(d) / 2;
                    }).y0(height).y1(function (d) {
                        return y(d.sleeked);
                    }),
                    label: function label(d) {
                        return $filter('frAmount')(d.sleeked) + ' \u20AC';
                    }
                };

                var drawLogic = $scope.sleek_timetable ? average : amount;
                // Background area (background of date column)
                g.append('path').attr('class', 'graph-area').attr('d', drawLogic.area($scope.data));

                // Date column
                g.selectAll('.month-delimiter').data($scope.data).enter().append('rect').attr('class', function (d) {
                    var clazz = 'month-delimiter';
                    if (!d.amountDisplay) {
                        clazz += ' month-delimiter-no-amount';
                    }
                    if (d.nextReading) {
                        clazz += ' month-delimiter-reading';
                    }
                    return clazz;
                }).attr('x', function (d) {
                    return x(d.date);
                }).attr('y', function (d) {
                    if (d.nextReading) {
                        return -1 * margin.top;
                    }
                    return 0;
                }).attr('width', 1).attr('height', function (d) {
                    if (d.nextReading) {
                        return height + margin.top;
                    }
                    return height;
                });

                // Date label
                g.selectAll('.month-label').data($scope.data).enter().append('text').attr('class', function (d) {
                    return 'month-label ' + (d.amountDisplay ? '' : 'month-label-no-amount');
                }).attr('x', function (d) {
                    return x(d.date) + 10;
                }).attr('y', 13).text(function (d) {
                    return $filter('date')(d.date, 'MMM yy');
                });

                // Next Reading label
                g.selectAll('.month-reading-label-1').data((0, _filter2.default)($scope.data, function (d) {
                    return d.nextReading;
                })).enter().append('text').attr('class', 'month-reading-label month-reading-label-1').attr('x', function (d) {
                    return x(d.date) + 10;
                }).attr('y', -35).text('Relève de');
                g.selectAll('.month-reading-label-2').data((0, _filter2.default)($scope.data, function (d) {
                    return d.nextReading;
                })).enter().append('text').attr('class', 'month-reading-label month-reading-label-2').attr('x', function (d) {
                    return x(d.date) + 10;
                }).attr('y', -20).text('compteur Enedis');

                // Border left + bottom
                g.append('rect').attr('class', 'border-left').attr('x', 0).attr('y', 0).attr('width', 2).attr('height', height);
                g.append('rect').attr('class', 'border-bottom').attr('x', 0).attr('y', height).attr('width', width).attr('height', 2);

                // Line
                g.append('path').attr('class', 'graph-line').attr('d', drawLogic.line($scope.data));

                // Graph Dot
                g.selectAll('.graph-dot').data($scope.data).enter().append('circle').attr('class', 'graph-dot').attr('cx', drawLogic.line.x()).attr('cy', drawLogic.line.y()).attr('r', 8);

                // Amount
                g.selectAll('.graph-amount').data((0, _filter2.default)($scope.data, 'amountDisplay')).enter().append('text').attr('class', 'graph-amount').attr('x', drawLogic.line.x()).attr('y', function (d) {
                    return drawLogic.line.y()(d) - 30;
                }).text(drawLogic.label);

                // Info column
                g.selectAll('.month-info').data($scope.data).enter().append('rect').attr('class', function (d) {
                    return 'month-info ' + seasonClass(d);
                }).attr('x', function (d) {
                    return x(d.date);
                }).attr('y', 0).attr('width', x.rangeBand()).attr('height', height);

                return { svg: svg, x: x, y: y, amount: amount, average: average };
            };

            var resizeGraph = function resizeGraph() {
                var elementWidth = element.get(0).getBoundingClientRect().width > 1000 ? 1000 : element.get(0).getBoundingClientRect().width;
                var graphSize = xlgGraphSize;
                graphSize = { width: elementWidth, height: Math.round(elementWidth * (graphSize.height / graphSize.width)) };

                chart.svg.attr('width', graphSize.width);
                chart.svg.attr('height', graphSize.height);
            };

            var updateGraphOnDisplayAverage = function updateGraphOnDisplayAverage(sleek_timetable) {
                var svg = _d2.default.select(element.get(0)).transition();
                var drawLogic = sleek_timetable ? chart.average : chart.amount;

                if (sleek_timetable) {
                    element.addClass('averaged');
                } else {
                    element.removeClass('averaged');
                }

                svg.select('.graph-area').duration(transitionDuration).attr('d', drawLogic.area($scope.data));

                svg.select('.graph-line').duration(transitionDuration).attr('d', drawLogic.line($scope.data));

                // Graph Dot
                svg.selectAll('.graph-dot').duration(transitionDuration).attr('cx', drawLogic.line.x()).attr('cy', drawLogic.line.y());

                // Amount
                svg.selectAll('.graph-amount').duration(transitionDuration).attr('x', drawLogic.line.x()).attr('y', function (d) {
                    return drawLogic.line.y()(d) - 30;
                }).text(drawLogic.label);
            };

            var updateGraphOnTutorial = function updateGraphOnTutorial(tutorial) {
                updateGraphOnDisplayAverage(tutorial.display ? tutorial.sleek_timetable : $scope.sleek_timetable);
                element[tutorial.isSummer ? 'addClass' : 'removeClass']('summer');
                element[tutorial.isWinter ? 'addClass' : 'removeClass']('winter');
                element[tutorial.isNextReading ? 'addClass' : 'removeClass']('next-reading');
            };

            var activate = function activate() {
                chart = generateGraph();
                resizeGraph();
                _d2.default.select(window).on('resize', resizeGraph);

                $scope.$watch('sleek_timetable', updateGraphOnDisplayAverage);
                $scope.$watch('tutorial', updateGraphOnTutorial);
            };

            activate();
        }
    };
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


updateTitle.$inject = ["$rootScope", "$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = updateTitle;

/** @ngInject */

function updateTitle($rootScope, $timeout) {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            var listener = function listener(event, toState) {
                var defaultTitle = 'Plüm énergie : fournisseur d’électricité de nouvelle génération';
                var title = toState.data && toState.data.pageTitle ? toState.data.pageTitle + ' - ' + defaultTitle : defaultTitle;

                var updateText = function updateText() {
                    return element.text(title);
                };
                return $timeout(updateText, 0, false);
            };

            return $rootScope.$on('$stateChangeSuccess', listener);
        }
    };
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = birthdate;

/** @ngInject */

function birthdate() {
    return {
        require: 'ngModel',
        link: function link(scope, elm, attr, ctrl) {
            ctrl.$validators.isBirthdate = function (value) {
                return (0, _moment2.default)(value, 'DDMMYYYY').isValid();
            };
        }
    };
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = compareTo;

/** @ngInject */

function compareTo() {
    return {
        require: 'ngModel',
        scope: {
            otherModelValue: '=compareTo'
        },
        link: function link(scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function (modelValue) {
                return modelValue === scope.otherModelValue;
            };
            return scope.$watch('otherModelValue', function () {
                return ngModel.$validate();
            });
        }
    };
}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ReportManager.$inject = ["$rootScope", "ContractStatus"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = __webpack_require__(8);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(14);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ReportManager;

/** @ngInject */
/* eslint-disable
    no-eq-null,
*/

function ReportManager($rootScope, ContractStatus) {
    return {
        allowedReportStatus: [ContractStatus.enService, ContractStatus.enAttenteReleve],
        class: 'read',
        contract: null,
        values: [],
        message: null,
        canEditStatus: {
            isContractDefined: false,
            isNotReportedToday: false,
            isAllowedReportStatus: false
        },
        updateContract: function updateContract(contract) {
            this.contract = contract;
            this.values = contract != null ? contract.lastReadings : undefined;
            this.message = null;
            var lastReportDate = (0, _get2.default)(this.contract, 'lastReadings[0].end_date');
            this.canEditStatus = {
                isContractDefined: !(0, _isEmpty2.default)(contract),
                isNotReportedToday: (0, _isEmpty2.default)(lastReportDate) || !(0, _moment2.default)().isSame((0, _moment2.default)(lastReportDate), 'day'),
                isAllowedReportStatus: this.allowedReportStatus.indexOf(this.contract.status) > -1
            };
            return $rootScope.$emit('lastReadings updated');
        },
        canEdit: function canEdit() {
            return this.canEditStatus.isContractDefined && this.canEditStatus.isNotReportedToday && this.canEditStatus.isAllowedReportStatus;
        },
        updateClass: function updateClass(newClass) {
            if (newClass === 'input' && !this.canEdit()) {
                return;
            }
            this.class = newClass;
        },
        watch: function watch(callback) {
            var self = this;
            return $rootScope.$on('lastReadings updated', function () {
                return callback(self.contract);
            });
        }
    };
}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Contract.$inject = ["$resource"];
ContractDraft.$inject = ["$resource"];
User.$inject = ["$resource"];
Hint.$inject = ["$resource"];
Tokens.$inject = ["$resource"];
Community.$inject = ["$resource"];
BillingAddress.$inject = ["$resource"];
Features.$inject = ["$resource"];
ProviderInfo.$inject = ["$resource"];
LandscapeQuestions.$inject = ["$resource"];
DataAccessReferences.$inject = ["$resource"];
DataAccessVariables.$inject = ["$resource"];
CampaignLanding.$inject = ["$resource"];
RefGoals.$inject = ["$resource"];
Contact.$inject = ["$resource"];
LogNavigation.$inject = ["$resource"];
NavError.$inject = ["$resource"];
TariffResource.$inject = ["$q", "StaticTariff"];
SelfReport.$inject = ["$resource"];
AnonPayment.$inject = ["$resource"];
AnonTermination.$inject = ["$resource"];
SecurityDeposit.$inject = ["$resource"];
BillingAcc.$inject = ["$resource"];
Invoice.$inject = ["$resource"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    Contract: Contract,
    ContractDraft: ContractDraft,
    User: User,
    Hint: Hint,
    Community: Community,
    BillingAddress: BillingAddress,
    Features: Features,
    LandscapeQuestions: LandscapeQuestions,
    ProviderInfo: ProviderInfo,
    DataAccessReferences: DataAccessReferences,
    DataAccessVariables: DataAccessVariables,
    CampaignLanding: CampaignLanding,
    RefGoals: RefGoals,
    Contact: Contact,
    LogNavigation: LogNavigation,
    NavError: NavError,
    TariffResource: TariffResource,
    SelfReport: SelfReport,
    BillingAcc: BillingAcc,
    Invoice: Invoice,
    AnonPayment: AnonPayment,
    AnonTermination: AnonTermination,
    SecurityDeposit: SecurityDeposit,
    Tokens: Tokens

    /** @ngInject */
};
function Contract($resource) {
    return $resource('/api/my-contract/:id', { id: '@id' }, {
        report: {
            url: '/api-user/my-contract/:id/self-report',
            method: 'POST'
        },
        burnToBill: {
            url: '/api/my-contract/:id/burn-pot-to-bill',
            method: 'POST'
        },
        burnToInvestment: {
            url: '/api/investment',
            method: 'POST'
        },
        getInvoices: {
            url: '/api/my-contract/:id/invoices',
            method: 'GET'
        },
        myCons: {
            url: '/api/my-cons/:id',
            method: 'GET',
            isArray: true
        },
        myConsV2: {
            url: '/api-user/my-cons/:id',
            method: 'GET',
            isArray: true
        },
        bypassRetraction: {
            url: '/api-user/selfcare/contract/:id/bypass_retraction',
            method: 'POST'
        },
        retract: {
            url: '/api-user/selfcare/contract/:id/retract',
            method: 'POST'
        },
        refGoal: {
            url: '/api-user/selfcare/contract/:id/goal',
            method: 'PUT'
        },
        isDepositNeeded: {
            url: '/api/contracts/:id/deposit-needed',
            method: 'GET'
        },
        isDepositNeededByToken: {
            url: '/anon/contracts/deposit-needed',
            method: 'GET'
        },
        getRedirectToSecurityDeposit: {
            url: '/api-user/my-contract/:id/security-deposit-redirect',
            method: 'GET'
        },
        cancelContract: {
            url: '/api-user/my-contract/:id/cancel',
            method: 'PUT'
        },
        regularize: {
            url: '/api-user/my-contract/:id/regularize',
            method: 'GET'
        }
    });
}

/** @ngInject */
function ContractDraft($resource) {
    return $resource('/api/my-contract-draft', {}, {
        get: {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }
        },
        getByToken: {
            url: '/anon/my-contract-draft',
            method: 'GET'
        },
        update: {
            method: 'PUT'
        },
        updateByToken: {
            url: '/anon/my-contract-draft',
            method: 'PUT'
        },
        verify: {
            url: '/api-user/eligibility/prm/:id',
            method: 'GET'
        },
        checkPostCode: {
            url: '/api-user/eligibility/postcode/:id',
            method: 'GET'
        },
        getPaymentIframe: {
            url: '/api-user/generate-mandate/:id',
            method: 'GET'
        },
        getPaymentIframeByToken: {
            url: '/anon/generate-mandate/:id',
            method: 'GET'
        },
        checkSponsor: {
            url: '/api/my-contract-draft/sponsor/:sponsor_id'
        },
        checkPromo: {
            url: '/api-user/my-promo/:promo/check'
        },
        checkPromoOnDraft: {
            url: '/api-user/my-contract-draft/:id_draft/check-promo/:promo'
        },
        checkLandscapeRequired: {
            url: '/api-user/landscape/:id_contract/required?draft=true'
        },
        getTimetableV1: {
            url: '/api-user/my-contract-draft/timetable',
            method: 'POST',
            isArray: true
        },
        getTimetableV2: {
            url: '/api-user/my-contract-draft/timetable/simu',
            method: 'POST',
            isArray: true
        },
        getTimetableByToken: {
            url: '/anon/my-contract-draft/timetable',
            method: 'POST',
            isArray: true
        },
        getQuotation: {
            url: '/api-user/my-contract-draft/quotation',
            method: 'POST'
        },
        report: {
            url: '/api/my-contract-draft/self-report',
            method: 'POST',
            isArray: true
        },
        modifyDraftOffer: {
            url: '/api/my-contract-draft/offer/:provider_offer',
            method: 'PUT'
        },
        createJiraIssue: {
            method: 'POST',
            url: '/api-user/jira/issue/:idProject'
        },
        getOfferSelectable: {
            url: '/api/ref-provider-offers/:provider_offer/selectable',
            method: 'GET'
        },
        computeEnedisPrestations: {
            url: '/api-user/enedis-prestations/computation?draft=true',
            method: 'POST'
        }
    });
}

/** @ngInject */
function User($resource) {
    return $resource('anon', {}, {
        signUp: {
            url: '/anon/signup',
            method: 'POST'
        },
        setPassword: {
            url: '/anon/passwd/:token',
            method: 'POST'
        },
        getInfoByToken: {
            url: '/anon/process/:token',
            method: 'GET'
        },
        resetPassword: {
            url: '/anon/forgot-passwd',
            method: 'POST'
        },
        authenticate: {
            url: '/authenticate',
            method: 'POST'
        },
        logout: {
            url: '/api-user/logout',
            method: 'POST'
        },
        getInfo: {
            url: '/api/my-info',
            method: 'GET'
        },
        getPotBalance: {
            url: '/api/pot-balance',
            method: 'GET'
        },
        getBillingAddress: {
            url: '/api/my-billing-acc',
            method: 'GET'
        },
        getMyIban: {
            url: '/api-user/my-iban',
            method: 'GET'
        },
        getUa: {
            url: '/api/my-ua/',
            method: 'GET',
            isArray: true
        },
        getProofOfResidence: {
            url: '/api-user/documents/:id_contract/proofofresidence',
            method: 'POST',
            responseType: 'arraybuffer'
        },
        getContractCertificate: {
            url: '/api-user/documents/:id_contract/contractcertificate',
            method: 'GET',
            responseType: 'arraybuffer'
        },
        saveNewBillingAddress: {
            url: '/api-user/selfcare/addr-modif',
            method: 'POST'
        },
        saveNewPhoneNumber: {
            url: '/api-user/selfcare/phone-modif',
            method: 'POST'
        },
        confirmNewPhoneNumber: {
            url: '/api-user/selfcare/phone-modif/:id_confirmation',
            method: 'POST'
        },
        saveNewEmail: {
            url: '/api-user/selfcare/email-modif',
            method: 'POST'
        },
        confirmNewEmail: {
            url: '/api-user/selfcare/email-modif/:processId',
            method: 'POST'
        },
        saveNominativeInfo: {
            url: '/api-user/selfcare/my-info',
            method: 'PUT'
        },
        saveIban: {
            url: '/api-user/my-mandate',
            method: 'PUT'
        },
        signMandate: {
            url: '/api-user/my-account/sign-mandate',
            method: 'GET'
        },
        deleteMandate: {
            url: '/api/my-billing-acc/mandate',
            method: 'DELETE'
        },
        createAlias: {
            url: '/api-user/my-account/create-alias',
            method: 'GET'
        },
        deleteAlias: {
            url: '/api/my-billing-acc/card-alias',
            method: 'DELETE'
        },
        selectPaymentMethod: {
            url: '/api/my-billing-acc/recurrent-cb',
            method: 'PUT'
        }
    });
}

/** @ngInject */
function Hint($resource) {
    return $resource('api-content/hints', { id_hint: '@id_hint' }, {
        getAll: {
            url: '/api-content/hints/search',
            method: 'GET',
            isArray: true
        },
        saveComment: {
            url: '/api-content/hints/:id_hint/comments',
            method: 'POST'
        }
    });
}

/** @ngInject */
function Tokens($resource) {
    return $resource('', {}, {
        getToken: {
            url: '/tokens',
            method: 'POST'
        },
        getSignupToken: {
            url: '/anon/translate-subscription-token',
            method: 'POST'
        }
    });
}

/** @ngInject */
function Community($resource) {
    return $resource('/communaute/api/', {}, {
        getTrendingTopics: {
            url: '/communaute/api/recent'
        },
        getTopic: {
            url: '/communaute/api/topic/:id'
        },
        fetchUserInfo: {
            url: '/communaute/api/user/uid/:uid'
        },
        getUsers: {
            url: '/communaute/api/users'
        },
        getMostActiveUsers: {
            url: '/communaute/api/users/sort-posts'
        },
        getOnlineUsers: {
            url: '/communaute/api/users/online'
        },
        getChats: {
            url: '/communaute/api/chats'
        },
        getNotifications: {
            url: '/communaute/api/notifications'
        },
        getTrendingFaq: {
            url: '/communaute/api/category/8/faq'
        },
        getLastBlogPosts: {
            url: '/communaute/api/category/3/l-actu-plüm-énergie'
        }
    });
}

/** @ngInject */
function BillingAddress($resource) {
    return $resource('api-user/selfcare', {}, {
        showBillAddresses: {
            url: '/api-user/selfcare/lookup-addr',
            method: 'GET',
            isArray: true
        }
    });
}

/** @ngInject */
function Features($resource) {
    return $resource('/anon/features');
}

/** @ngInject */
function ProviderInfo($resource) {
    return $resource('/api/references/provider-info');
}

/** @ngInject */
function LandscapeQuestions($resource) {
    return $resource('/api-user/landscape', {
        category: '@category',
        id_contract: '@id_contract',
        id_answer: '@id_answer',
        id_question: '@id_question'
    }, {
        getAll: {
            url: '/api-user/landscape?',
            method: 'GET',
            isArray: true
        },
        getPopupQuestion: {
            url: '/api-user/landscape/popup/:id_question',
            method: 'GET'
        },
        search: {
            url: '/api-user/landscape/:id_contract/questions?category=:category',
            method: 'GET',
            isArray: true,
            category: '@cat'
        },
        saveAnswer: {
            url: '/api-user/landscape/:id_contract/answer',
            method: 'POST'
        },
        delAnswer: {
            url: '/api-user/landscape/:id_contract/answer/:id_answer',
            method: 'DELETE'
        },
        flush: {
            url: '/api-user/landscape/:id_contract/flush',
            method: 'DELETE'
        },
        flushAfter: {
            url: '/api-user/landscape/:id_contract/flush-after/:id_question',
            method: 'DELETE'
        }
    });
}

/** @ngInject */
function DataAccessReferences($resource) {
    return $resource('all', {}, {
        ref: {
            url: '/api/references/:id',
            method: 'GET'
        }
    });
}

/** @ngInject */
function DataAccessVariables($resource) {
    return $resource('all', {}, {
        get: {
            url: '/api/get/:variables',
            method: 'GET'
        }
    });
}

/** @ngInject */
function CampaignLanding($resource) {
    return $resource('/anon/campaigns', { id_campaign: '@id_campaign' }, {
        getCampaign: {
            url: '/anon/campaigns/:id_campaign',
            method: 'GET'
        },
        // type: 100 ==> visite: au loading de la page
        // type: 110 ==> subscribe: qd il rentre son email avec son email donc
        submitCampaignInformation: {
            url: '/anon/campaigns/:id_campaign',
            method: 'POST'
        }
    });
}

/** @ngInject */
function RefGoals($resource) {
    return $resource('/api/ref-goals', {}, {
        getGoals: {
            method: 'GET',
            isArray: true
        }
    });
}

/** @ngInject */
function Contact($resource) {
    return $resource('/anon/contact', {}, {
        sendMessage: {
            method: 'POST'
        }
    });
}

/** @ngInject */
function LogNavigation($resource) {
    return $resource('log', {}, {
        log: {
            url: '/api-content/nav',
            method: 'POST'
        }
    });
}

/** @ngInject */
function NavError($resource) {
    return $resource('/api-content/nav-error', {}, {
        sendError: {
            method: 'POST'
        }
    });
}

/** @ngInject */
function TariffResource($q, StaticTariff) {
    // static tariff while waiting for webservice with correct price
    var staticTariff$ = $q.resolve(StaticTariff);
    return {
        getTariff: function getTariff() {
            return { $promise: staticTariff$ };
        }
    };
}

/** @ngInject */
function SelfReport($resource) {
    return $resource('/anon/self-report/:token', { token: '@token' }, {
        get: {
            method: 'GET'
        },
        post: {
            method: 'POST'
        }
    });
}

/** @ngInject */
function AnonPayment($resource) {
    return $resource('', {}, {
        getToken: {
            url: '/api-user/payment-token/:tokenId',
            method: 'GET'
        },
        getRedirect: {
            url: '/api-user/regularization/:tokenId',
            method: 'GET'
        },
        getOrderReference: {
            url: '/api-user/slimpay-order/:order_reference/status',
            method: 'GET'
        }
    });
}

/** @ngInject */
function AnonTermination($resource) {
    return $resource('', {}, {
        createTerminationToken: {
            url: '/api-user/my-contract/:id_contract/termination-token',
            method: 'POST'
        },
        getTerminationToken: {
            url: '/api-user/anon/confirm-termination/:tokenId',
            method: 'GET'
        },
        confirmTermination: {
            url: '/api-user/anon/confirm-termination/:tokenId',
            method: 'POST'
        },
        cancelTermination: {
            url: '/api-user/anon/confirm-termination/:tokenId',
            method: 'DELETE'
        }
    });
}

/** @ngInject */
function SecurityDeposit($resource) {
    return $resource('', {}, {
        getToken: {
            url: '/api-user/security-deposit/:tokenId',
            method: 'GET'
        },
        getRedirect: {
            url: '/api-user/security-deposit-redirect/:tokenId',
            method: 'GET'
        },
        refuseDeposit: {
            url: '/api-user/refuse-deposit/:tokenId',
            method: 'POST'
        }
    });
}

/** @ngInject */
function BillingAcc($resource) {
    return $resource('/api/my-billing-acc', {}, {
        getPaymentDay: {
            url: '/api/my-billing-acc/payment-day',
            method: 'GET'
        },
        putPaymentDay: {
            url: '/api/my-billing-acc/payment-day',
            method: 'PUT'
        }
    });
}

/** @ngInject */
function Invoice($resource) {
    return $resource('/invoices', { id_payment: '@id_payment', id_invoice: '@id_invoice' }, {
        sendRegulateSituation: {
            url: '/api-user/payment/:id_payment/retry',
            method: 'POST'
        },
        sendPayNextPayment: {
            url: '/api-user/payment/:id_payment/next-timetable',
            method: 'POST'
        },
        sendInvoiceByMail: {
            url: '/api-user/invoices/:id_invoice/email',
            method: 'GET'
        },
        creditCardRedirect: {
            url: '/api-user/payment/:id_payment/credit-card-redirect',
            method: 'GET'
        },
        getPayment: {
            url: '/api/my-payments/:payment_id',
            method: 'GET'
        },
        getPayments: {
            url: '/api/my-payments',
            method: 'GET',
            isArray: true
        }
    });
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AdwordsService.$inject = ["$window", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(20);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = AdwordsService;

/** @ngInject */

function AdwordsService($window, ErrorCatcher) {
    var buildConversion = function buildConversion(label) {
        return function (orderId) {
            if ($window.google_trackConversion) {
                var orderIdData = orderId ? { google_conversion_order_id: orderId } : {};
                var trackValue = (0, _assign2.default)({}, {
                    google_conversion_id: 854892059,
                    google_conversion_label: label,
                    google_conversion_language: 'en',
                    google_conversion_format: '3',
                    google_conversion_color: 'ffffff',
                    google_remarketing_only: false
                }, orderIdData);
                return $window.google_trackConversion(trackValue);
            }
            return ErrorCatcher.catchErrorWithoutRedirect({
                message: '$window.google_trackConversion not loaded.',
                label: label,
                orderId: orderId
            });
        };
    };

    return {
        fireSlimpaySuccessRedirect: buildConversion('2BDTCNul2HAQm7zSlwM')
    };
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AlertManager;

/** @ngInject */

function AlertManager() {
    return {
        alerts: [],
        addAlert: function addAlert(alert) {
            return this.alerts.push(alert);
        },
        closeAlert: function closeAlert(index) {
            return this.alerts.splice(index, 1);
        },
        clearAlerts: function clearAlerts() {
            return this.alerts.splice(0, this.alerts.length);
        },
        success: function success(msg, timeout, detail) {
            return this.addAlert({ type: 'success', timeout: timeout, msg: msg, detail: detail });
        },
        error: function error(msg, timeout, detail) {
            return this.addAlert({ type: 'error', timeout: timeout, msg: msg, detail: detail });
        }
    };
}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ApiService.$inject = ["$q", "User", "Features", "ContractStatus", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _filter = __webpack_require__(82);

var _filter2 = _interopRequireDefault(_filter);

var _defaultTo = __webpack_require__(71);

var _defaultTo2 = _interopRequireDefault(_defaultTo);

var _assign = __webpack_require__(20);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ApiService;

/** @ngInject */

function ApiService($q, User, Features, ContractStatus, ErrorCatcher) {
    var CONTRACT_TO_HIDE = [ContractStatus.duplicat];
    var UNSELECTABLE_CONTRACT_STATUS = [ContractStatus.resilie, ContractStatus.retracte, ContractStatus.annule];

    var displayContract = function displayContract(c) {
        return CONTRACT_TO_HIDE.indexOf(c.status) === -1;
    };
    var selectableContract = function selectableContract(c) {
        return UNSELECTABLE_CONTRACT_STATUS.indexOf(c.status) === -1;
    };

    var promises = {
        userInfo: null,
        features: null
    };

    var resetPromise = function resetPromise(key) {
        promises[key] = null;
    };

    var fetchUserInfo = function fetchUserInfo() {
        if (!promises.userInfo) {
            promises.userInfo = User.getInfo().$promise.then(function (response) {
                return (0, _assign2.default)({}, response, {
                    contracts: response.contracts,
                    contractSelected: (0, _defaultTo2.default)((0, _filter2.default)(response.contracts, selectableContract)[0], response.contracts && response.contracts[0])
                });
            }).catch(function (error) {
                ErrorCatcher.catchError(error);
                return $q.reject(error);
            });
        }
        return promises.userInfo;
    };

    var fetchFeatures = function fetchFeatures() {
        if (!promises.features) {
            promises.features = Features.get().$promise;
        }
        return promises.features;
    };

    return {
        fetchFeatures: fetchFeatures,
        fetchUserInfo: fetchUserInfo,
        resetPromise: resetPromise
    };
}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LogoutService.$inject = ["User", "ApiService", "PotManager"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LogoutService;

/** @ngInject */

function LogoutService(User, ApiService, PotManager) {
    var logout = function logout() {
        ApiService.resetPromise('userInfo');
        ApiService.resetPromise('features');
        PotManager.resetPot();
        localStorage.removeItem('hideDashboard');
        return User.logout().$promise;
    };

    return {
        logout: logout
    };
}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _d = __webpack_require__(96);

var _d2 = _interopRequireDefault(_d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = BubblesService;

/** @ngInject */
/* eslint-disable
    no-use-before-define,
    no-var,
    radix,
*/

function BubblesService() {
    // init bubbles
    var Bubbles = function Bubbles(conf) {
        var width = conf.width || 300;
        var height = conf.height || 500;
        var bubbleStrokeColor = conf.bubbleStrokeColor || '455469';
        var bubbleStrokeWidth = conf.bubbleStrokeWidth || '2';
        var fontFamily = conf.fontFamily || 'equipements';
        var isPictofont = conf.pictofont || true;
        var type = conf.type || 'float';
        var jitter = conf.jitter || 0.013;
        var data = [];
        var node = null;
        var label = null;
        var margin = { top: 5, right: 0, bottom: 0, left: 0 };
        var maxRadius = conf.maxRadius || 30;
        var rScale = _d2.default.scale.sqrt().range([0, maxRadius]);
        var collisionPadding = 3;
        var minCollisionRadius = 12;

        // return radius value from data passed to d3
        var rValue = function rValue(d) {
            return parseInt(d.count);
        };

        // return id from data passed to d3
        var idValue = function idValue(d) {
            if (isPictofont) {
                return d.name.charCodeAt(0);
            }
            return d.name.charCodeAt(0);
        };

        // return text from data passed to d3
        var textValue = function textValue(d) {
            return d.name[0];
        };

        // transform data (random sort + parseInt count for safety as count is used to determine the radius)
        var transformData = function transformData(rawData) {
            if (rawData && rawData.length) {
                rawData.forEach(function (d) {
                    d.count = parseInt(d.count);
                    return rawData.sort(function () {
                        return 0.5 - Math.random();
                    });
                });

                return rawData;
            }
        };

        // tick function for force
        var tick = function tick(e) {
            var dampenedAlpha = e.alpha * 0.1;
            node = _d2.default.selectAll('.bubble-node');
            label = _d2.default.selectAll('.bubble-label');

            var transform = function transform(d) {
                return 'translate(' + d.x + ',' + d.y + ')';
            };

            if (node) {
                // loop in all nodes to update position applying gravity + collision
                node.each(gravity(dampenedAlpha)).each(collide(jitter)).attr('transform', transform);

                // place label according to circle position as labels
                // are separated from circle due to SVG specs (no text elem in circle)
                return label.style('left', function (d) {
                    return margin.left + d.x - d.dx / 2 + 'px';
                }).style('top', function (d) {
                    return margin.top + d.y - d.dy / 2 + 'px';
                });
            }
        };

        // create force
        // gravity 1 and charge 1 to float
        // change to make it fall along with Y position in gravity
        var force = _d2.default.layout.force().gravity(1).charge(1).size([width, height]).on('tick', tick);

        var self = this;
        self.data = null;

        // chart object return by bubbles
        // chart inits the drawing by being passed to d3.call
        var chart = function chart(selection) {
            this.data = null;
            var selfChart = this;
            return selection.each(function (rawData) {
                // transforming the data
                data = transformData(rawData);

                // binding transformed data to bubbles for accessibility (adding, removing...)
                self.data = data;

                // applying max radius size to all element
                var maxDomainValue = _d2.default.max(data, function (d) {
                    return rValue(d);
                });

                // scale bubbles according to count parameter
                rScale.domain([0, maxDomainValue]);

                // enter selector, create svg and bing data to svg
                var svg = _d2.default.select(this).selectAll('svg').data([data]);
                self.svg = svg;
                var svgEnter = svg.enter().append('svg');
                svg.attr('width', width + margin.left + margin.right);
                svg.attr('height', height + margin.top + margin.bottom);

                // create group svg to group bubbles
                node = svgEnter.append('g').attr('id', 'bubble-nodes').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

                // create rectangle for bubble background (if needed)
                node.append('rect').attr('id', 'bubble-background').attr('width', width).attr('height', height);

                // create lables which are html (not svg)
                label = _d2.default.select(this).selectAll('#bubble-labels').data([data]).enter().append('div').attr('id', 'bubble-labels');

                // draw
                return update();
            });
        };

        var update = function update() {
            if (data && data.length) {
                data.forEach(function (d, i) {
                    d.forceR = Math.max(minCollisionRadius, rScale(rValue(d)));
                });

                // May the force be with you
                force.nodes(data).start();

                updateNodes();
                return updateLabels();
            }
        };

        var updateNodes = function updateNodes() {
            // get Bubbles and delete if exist (we don't want double drawing)
            node = node.selectAll('.bubble-node').data(data, function (d) {
                return idValue(d);
            });
            node.exit().remove();

            // create bubbles in the svg and apply styles, force and connected events (drag&drop, tooltips in the future for rpu ?)
            return node.enter().append('a').attr('class', 'bubble-node').attr('id', function (d, i) {
                return 'nodes' + idValue(d);
            }).style('stroke', bubbleStrokeColor).style('stroke-width', bubbleStrokeWidth).call(force.drag).call(connectEvents).append('circle').attr('r', function (d) {
                return rScale(rValue(d));
            });
        };

        var updateLabels = function updateLabels() {
            // same as bubbles
            label = label.selectAll('.bubble-label').data(data, function (d) {
                return idValue(d);
            });
            label.exit().remove();

            var labelEnter = label.enter().append('a').attr('class', 'bubble-label').attr('id', function (d, i) {
                return 'labels' + idValue(d);
            }).call(force.drag).call(connectEvents);

            labelEnter.append('div').attr('class', 'bubble-label-name').style('font-family', fontFamily).text(function (d) {
                return textValue(d);
            });

            // scale font size according to bubble radius
            label.style('font-size', function (d) {
                return Math.max(8, rScale(rValue(d) / 1.6)) + 'px';
            }).style('width', function (d) {
                return 2.5 * rScale(rValue(d)) + 'px';
            });

            // trick to center label in bubble
            label.append('span').text(function (d) {
                return textValue(d);
            }).each(function (d) {
                d.dx = Math.max(2.5 * rScale(rValue(d)), this.getBoundingClientRect().width);
            }).remove();

            // reset the width of the label to the actual width
            label.style('width', function (d) {
                return d.dx + 'px';
            });

            return label.each(function (d) {
                d.dy = this.getBoundingClientRect().height;
            });
        };

        // add function for adding label after drawing is init
        var addLabel = function addLabel(data) {
            var s = _d2.default.select('#bubble-labels');

            var labelEnter = s.append('a').data(data).attr('class', 'bubble-label').attr('id', function (d, i) {
                return 'labels' + idValue(d);
            }).call(force.drag).call(connectEvents);

            labelEnter.append('div').attr('class', 'bubble-label-name').style('font-family', fontFamily).text(function (d) {
                return textValue(d);
            });

            labelEnter.style('font-size', function (d) {
                return Math.max(8, rScale(rValue(d) / 1.6)) + 'px';
            }).style('width', function (d) {
                return 2.5 * rScale(rValue(d)) + 'px';
            });

            labelEnter.append('span').text(function (d) {
                return textValue(d);
            }).each(function (d) {
                d.dx = Math.max(2.5 * rScale(rValue(d)), this.getBoundingClientRect().width);
            }).remove();

            return labelEnter.each(function (d) {
                d.dy = this.getBoundingClientRect().height;
            });
        };

        // add function for adding nodes after drawing is init
        var addNode = function addNode(data) {
            var nodeContainer = _d2.default.select('#bubble-nodes');

            return nodeContainer.append('a').data(data).attr('id', function (d, i) {
                return 'nodes' + idValue(d);
            }).attr('class', 'bubble-node').style('stroke', bubbleStrokeColor).style('stroke-width', bubbleStrokeWidth).call(force.drag).call(connectEvents).append('circle').attr('r', function (d) {
                return rScale(rValue(d));
            });
        };

        // gravity force
        var gravity = function gravity(alpha) {
            // if type is float let them stand at the top so y = 0 else means fall, make them go to the bottom and beyond (force will handle collision with svg borders)
            var cy = void 0;
            if (type === 'float') {
                cy = 0;
            } else {
                cy = height * 2;
            }

            // alpha to correct speed of movement (useless for float), higher => faster
            var ay = alpha / 12;

            // apply Y position to bubble (by tick)
            return function (d) {
                if (d.y + (cy - d.y + d.forceR * 3) * ay < height) {
                    d.y += (cy - d.y) * ay;
                }
            };
        };

        // collision force d3 spec
        var collide = function collide(jitter) {
            return (
                // returns the function below on each element
                function (d) {
                    return data.forEach(function (d2, index) {
                        // check if node and node in inner loop are not same
                        if (d !== d2) {
                            // distance between both dots
                            var x = d.x - d2.x;
                            var y = d.y - d2.y;
                            var distance = Math.sqrt(x * x + y * y);

                            // min distance that is supposed to be to avoid collision
                            // first bubble radius + second bubble radius + padding (set padding to 0 if you don't want any space at all between bubbles)
                            var minDistance = d.forceR + d2.forceR + collisionPadding;

                            if (distance < minDistance) {
                                // jitter is used to increase or decrease intensity of movement as it is done by tick
                                // higher jitter will make bubbles bounce further between each other
                                distance = (distance - minDistance) / distance * jitter;
                                var moveX = x * distance;
                                var moveY = y * distance;

                                // we will push the current node 'backwards and the other node forward'
                                // for true gravity should try pushing d2 only if y is lower so bubble higher in the chart

                                var newX = d.x - moveX;
                                if (newX < 0) {
                                    if (d.x + moveX < width && d.x + moveX > 0) {
                                        newX = d.x + moveX;
                                    } else {
                                        newX = rValue(d);
                                    }
                                } else if (newX > width) {
                                    if (d.x + moveX < width && d.x + moveX > 0) {
                                        newX = d.x + moveX;
                                    } else {
                                        newX = width - rValue(d);
                                    }
                                }

                                var newY = d.y - moveY;
                                if (newY < 0) {
                                    if (d.y + moveY < height && d.y + moveY > 0) {
                                        newY = d.y + moveY;
                                    } else {
                                        newY = rValue(d) / 2;
                                    }
                                } else if (newY > height) {
                                    if (d.y + moveY < height && d.y + moveY > 0) {
                                        newY = d.y + moveY;
                                    } else {
                                        newY = height - rValue(d) / 2;
                                    }
                                }

                                var newXd2 = d2.x + moveX;
                                if (newXd2 < 0) {
                                    if (d2.x - moveX < width && d2.x - moveX > 0) {
                                        newXd2 = d2.x - moveX;
                                    } else {
                                        newXd2 = rValue(d2);
                                    }
                                } else if (newXd2 > width) {
                                    if (d2.x - moveX < width && d2.x - moveX > 0) {
                                        newXd2 = d2.x - moveX;
                                    } else {
                                        newXd2 = width - rValue(d2) / 2;
                                    }
                                }

                                var newYd2 = d2.y + moveY;
                                if (newYd2 < 0) {
                                    newYd2 = rValue(d2);
                                } else if (newYd2 > height) {
                                    newYd2 = height - rValue(d2) / 2;
                                }

                                // apply new positions
                                d.x = newX;
                                d.y = newY;
                                d2.x = newXd2;
                                d2.y = newYd2;

                                // if is last node check if nodes are still colliding, if yes, trust the force !
                                if (index === self.data.length - 1) {
                                    var launched = 0;
                                    if (!launched) {
                                        return function () {
                                            var result = [];
                                            for (var i = 0, end = self.data.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                                                var item = void 0;
                                                if (self.data[index + 1]) {
                                                    var nX = d.x - self.data[index + 1].x;
                                                    var nY = d.y - self.data[index + 1].y;
                                                    if (Math.sqrt(nX * nX + nY * nY) > minDistance) {
                                                        launched = 1;
                                                        item = force.nodes(self.data).start();
                                                    }
                                                }
                                                result.push(item);
                                            }
                                            return result;
                                        }();
                                    }
                                }
                            }
                        }
                    });
                }
            );
        };

        // add function to add new node + label
        // public setter
        chart.add = function (data) {
            var index = findIndexByName(data.name);

            if (data && typeof index === 'undefined') {
                data = [data];
                self.data.push(data[0]);
                force = _d2.default.layout.force().gravity(0.1).charge(1).size([width, height]).on('tick', tick);
            }

            var toCall = function toCall(selection) {
                return selection.each(function (rA) {
                    rA = transformData(rA);
                    if (rA) {
                        rA.forEach(function (d, i) {
                            d.forceR = Math.max(minCollisionRadius, rScale(rValue(d)));
                        });
                        force.nodes(self.data).start();

                        addNode(rA);
                        return addLabel(rA);
                    }
                });
            };

            return _d2.default.select('#vis').datum(data).call(toCall);
        };

        // flush all bubbles
        chart.flush = function () {
            var svgsLabels = _d2.default.selectAll('.bubble-label');
            if (svgsLabels && svgsLabels.length > 0) {
                svgsLabels.remove();
            }

            var svgs = self.svg.selectAll('.bubble-node');
            if (svgs && svgs.length > 0) {
                svgs.remove();
            }
            self.data = [];
        };

        // remove an existing bubble. Bubbles are identified by their name
        chart.remove = function (name) {
            var index = findIndexByName(name);
            var obj = { name: name };
            if (typeof index !== 'undefined') {
                var svgs = self.svg.selectAll('#nodes' + idValue(obj));
                if (svgs && svgs.length > 0) {
                    svgs.remove();
                }
                var labels = _d2.default.selectAll('#bubble-labels');
                var svgsLabels = _d2.default.selectAll('#labels' + idValue(obj));
                if (svgsLabels && svgsLabels.length > 0) {
                    svgsLabels.remove();
                }
                self.data.splice(index, 1);
                return force.nodes(self.data).start();
            }
            return null;
        };

        // public getter to get current nodes displayed as data format
        chart.getData = function () {
            return self.data;
        };

        // public getter for displayed, true if chart is initiated
        chart.displayed = false;

        // find index of bubble by its name
        var findIndexByName = function findIndexByName(name) {
            if (self.data) {
                for (var i = 0, end = self.data.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                    if (self.data[i] && self.data[i].name === name) {
                        return i;
                    }
                }
            }
        };

        var connectEvents = function connectEvents(d) {
            d.on('mouseover', mouseover);
            return d.on('mouseout', mouseout);
        };

        var mouseover = function mouseover(d) {
            return node.classed('bubble-hover', function (p) {
                return p === d;
            });
        };

        var mouseout = function mouseout(d) {
            return node.classed('bubble-hover', false);
        };

        return chart;
    };

    var plot = null;

    var plotData = function plotData(selector, data, plot) {
        _d2.default.select(selector).datum(data).call(plot);

        plot.displayed = true;
    };

    var display = function display(conf) {
        plot = new Bubbles(conf);
        return plotData(conf.selector, conf.data, plot);
    };

    var add = function add(data) {
        return plot.add(data);
    };

    var remove = function remove(name) {
        if (plot) {
            return plot.remove(name);
        }
    };

    var getData = function getData() {
        if (plot) {
            return plot.getData();
        }
        return [];
    };

    var isDisplayed = function isDisplayed() {
        return plot.displayed;
    };

    var flush = function flush() {
        if (plot && plot.displayed) {
            return plot.flush();
        }
    };

    return {
        display: display,
        add: add,
        remove: remove,
        getData: getData,
        isDisplayed: isDisplayed,
        flush: flush
    };
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


userCommunityService.$inject = ["ApiService", "Community", "$q", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = userCommunityService;

/** @ngInject */

function userCommunityService(ApiService, Community, $q, ErrorCatcher) {
    var userCommunity = {};

    var fetchCommunityInfo = function fetchCommunityInfo() {
        return ApiService.fetchUserInfo().then(function (userInfoResult) {
            return $q.all({
                info: Community.fetchUserInfo({ uid: userInfoResult.forum_uid }).$promise,
                chats: Community.getChats().$promise,
                notifications: Community.getNotifications().$promise
            }).then(function (userCommunityResult) {
                userCommunity = userCommunityResult;
            });
        }).catch(function (error) {
            userCommunity = {};
            return ErrorCatcher.catchErrorWithoutRedirect(error);
        });
    };

    var getUserCommunityInfo = function getUserCommunityInfo() {
        return userCommunity.info;
    };

    var getChatsCount = function getChatsCount() {
        var unreadChats = userCommunity.chats != null ? userCommunity.chats.rooms.filter(function (room) {
            return room.unread;
        }) : undefined;
        return unreadChats ? unreadChats.length : 0;
    };

    var getNotificationsCount = function getNotificationsCount() {
        var unreadNotifications = userCommunity.notifications != null ? userCommunity.notifications.notifications.filter(function (notification) {
            return !notification.read;
        }) : undefined;
        return unreadNotifications ? unreadNotifications.length : 0;
    };

    return {
        fetchCommunityInfo: fetchCommunityInfo,
        getUserCommunityInfo: getUserCommunityInfo,
        getChatsCount: getChatsCount,
        getNotificationsCount: getNotificationsCount
    };
}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Chart.$inject = ["Contract", "$state", "$rootScope", "$filter"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _matches = __webpack_require__(815);

var _matches2 = _interopRequireDefault(_matches);

var _forEach = __webpack_require__(816);

var _forEach2 = _interopRequireDefault(_forEach);

var _cloneDeep = __webpack_require__(316);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _get = __webpack_require__(8);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(204);

var _set2 = _interopRequireDefault(_set);

var _map = __webpack_require__(53);

var _map2 = _interopRequireDefault(_map);

var _filter = __webpack_require__(82);

var _filter2 = _interopRequireDefault(_filter);

var _first = __webpack_require__(317);

var _first2 = _interopRequireDefault(_first);

var _minBy = __webpack_require__(819);

var _minBy2 = _interopRequireDefault(_minBy);

var _flow = __webpack_require__(133);

var _flow2 = _interopRequireDefault(_flow);

var _values = __webpack_require__(821);

var _values2 = _interopRequireDefault(_values);

var _flatten = __webpack_require__(823);

var _flatten2 = _interopRequireDefault(_flatten);

var _map3 = __webpack_require__(203);

var _map4 = _interopRequireDefault(_map3);

var _max = __webpack_require__(824);

var _max2 = _interopRequireDefault(_max);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _d = __webpack_require__(96);

var _d2 = _interopRequireDefault(_d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable
 radix,
 */
exports.default = Chart;

/** @ngInject */

function Chart(Contract, $state, $rootScope, $filter) {
    // For the colors of the charts you have to take into account the 75% of opacity
    // applied by nvd3. See http://stackoverflow.com/questions/12228548/finding-equivalent-color-with-opacity
    // for conversion formulas.
    //
    var info = [];

    var setScale = function setScale(data) {
        return [0, (0, _flow2.default)(_values2.default, _flatten2.default, (0, _map4.default)('values'), _flatten2.default, (0, _map4.default)('y'), _max2.default)(data)];
    };

    var watch = {
        data: function data(callback) {
            return $rootScope.$on('chart-updated', function (event, chart) {
                return callback(chart);
            });
        },
        activeIndex: function activeIndex(callback) {
            return $rootScope.$on('chart-active-index-updated', function (event, index) {
                return callback(index);
            });
        }
    };

    var retrieveFilteredData = function retrieveFilteredData(values, tempclass) {
        return values.filter((0, _matches2.default)({ temp_class: tempclass }));
    };

    var filterValues = function filterValues(values) {
        var filteredValues = {
            BASE: { key: 'Base', values: [], type: 'BASE' },
            HP: { key: 'Heures pleine', values: [], type: 'HP' },
            HC: { key: 'Heures creuse', values: [], type: 'HC' }
        };
        (0, _forEach2.default)(values, function (val) {
            if (val && val.cons_details) {
                // is hphc
                return (0, _forEach2.default)(Object.keys(val.cons_details), function (k) {
                    var tmpVal = (0, _cloneDeep2.default)(val);
                    tmpVal.id_p_calendar = k;
                    tmpVal.estimatedCons = val.cons_details[k].estimatedCons;
                    tmpVal.autoCons = val.cons_details[k].autoCons;
                    tmpVal.realCons = val.cons_details[k].realCons;
                    return filteredValues[k].values.push(tmpVal);
                });
            } else if (val) {
                // legacy
                if (val.temp_class === 'HP' || val.temp_class === 'HC' || val.temp_class === 'BASE') {
                    return filteredValues[val.temp_class].values.push(val);
                }
            }
        });

        return (0, _map2.default)(Object.keys(filteredValues), function (k) {
            return filteredValues[k];
        });
    };

    var getMinDateValue = function getMinDateValue(values) {
        return (0, _minBy2.default)(values, function (value) {
            return (0, _moment2.default)().year(value.year).month(value.month).toISOString();
        });
    };

    var generateDefaultValuesPerMonth = function generateDefaultValuesPerMonth(minDateValue, numberOfMonth) {
        return (0, _map2.default)(Array(numberOfMonth), function (value, index) {
            if (minDateValue.month + index > 12) {
                return { month: (minDateValue.month + index) % 12, year: minDateValue.year + 1 };
            }
            return { month: minDateValue.month + index, year: minDateValue.year };
        });
    };

    var fillWithExistingValueOrDefault = function fillWithExistingValueOrDefault(values, defaultDateValues) {
        return defaultDateValues.map(function (defaultValue) {
            var sameDateValue = (0, _filter2.default)(values, (0, _matches2.default)(defaultValue));
            return (0, _get2.default)(sameDateValue, 0, defaultValue);
        });
    };

    var getActiveIndex = function getActiveIndex() {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Array.from(info)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var value = _step.value;

                if (value.active) {
                    return info.indexOf(value);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };

    var paintActive = function paintActive() {
        var activeIndex = getActiveIndex();
        if (activeIndex !== undefined) {
            $rootScope.$emit('chart-active-index-updated', activeIndex);
            _d2.default.selectAll('.nv-bar.nv-bar-group-' + activeIndex).classed({ 'nv-bar-active': true });
            return _d2.default.selectAll('.nv-bar.nv-bar-group-' + activeIndex + '.prediction').style({ fill: 'url(#prediction-active)' });
        }
    };

    var makeActive = function makeActive(index) {
        if (info[index].clickable) {
            var activeIndex = getActiveIndex();
            if (activeIndex !== undefined) {
                info[activeIndex].active = false;
                _d2.default.selectAll('.nv-bar.nv-bar-group-' + activeIndex).classed({ 'nv-bar-active': false });
                _d2.default.selectAll('.nv-bar.nv-bar-group-' + activeIndex + '.prediction').style({ fill: 'url(#prediction)' });
            }

            info[index].active = true;
            return paintActive();
        }
    };

    var formatInfoData = function formatInfoData(values) {
        var tmpValues = filterValues(values);
        var isSameDate = function isSameDate(value1) {
            return function (value2) {
                return value1.month === value2.month && value1.year === value2.year;
            };
        };
        var getNumber = function getNumber(object, field) {
            return Number((0, _get2.default)(object, field, 0));
        };
        // flow is equivalent to the | in linux allowing to chain output in the next function
        var minDateValue = getMinDateValue(values);
        var toGraphValues = function toGraphValues(values, numberOfMonth) {
            var defaultDateValues = generateDefaultValuesPerMonth(minDateValue, numberOfMonth);
            return function (type) {
                return (0, _flow2.default)(function (values) {
                    return fillWithExistingValueOrDefault(values, defaultDateValues);
                })(values);
            };
        };

        var baseGraphValues = toGraphValues(tmpValues[0].values, 12)();
        var hpGraphValues = toGraphValues(tmpValues[1].values, 12)();
        var hcGraphValues = toGraphValues(tmpValues[2].values, 12)();

        info = baseGraphValues.map(function (baseValue) {
            var amountWithModif = void 0;
            var consumption = void 0;
            var paid = void 0;
            var taxes = void 0;
            var hpValue = (0, _first2.default)(hpGraphValues.filter(isSameDate(baseValue)));
            var hcValue = (0, _first2.default)(hcGraphValues.filter(isSameDate(baseValue)));
            var getFirst = function getFirst(path) {
                return (0, _get2.default)(baseValue, path, (0, _get2.default)(hpValue, path, (0, _get2.default)(hcValue, path)));
            };

            var hasConsDetail = hpValue.cons_details || hcValue.cons_details || baseValue.cons_details;

            var date = (0, _moment2.default)().year(Number(baseValue.year)).month(Number(baseValue.month) - 1);

            var pot = {};
            if (getFirst('earnedPot')) {
                pot.type = 'earned';
                pot.value = $filter('frAmount')(Number(getFirst('earnedPot')));
            } else if (getFirst('estimatedEarnedPot')) {
                pot.type = 'estimated';
                pot.value = $filter('frAmount')(Number(getFirst('estimatedEarnedPot')));
            } else if (date.isBefore((0, _moment2.default)())) {
                pot.type = 'unknown';
                pot.value = $filter('frAmount')(0);
            } else {
                pot.type = null;
                pot.value = 'En attente';
            }

            if (hasConsDetail === undefined) {
                consumption = Number((getNumber(baseValue, 'estimatedConsValued') + getNumber(hpValue, 'estimatedConsValued') + getNumber(hcValue, 'estimatedConsValued')).toPrecision(12));
                amountWithModif = Number((getNumber(baseValue, 'amountWithModif') + getNumber(hpValue, 'amountWithModif') + getNumber(hcValue, 'amountWithModif')).toPrecision(12));
                taxes = Number((getNumber(baseValue, 'taxes') + getNumber(hpValue, 'taxes') + getNumber(hcValue, 'taxes')).toPrecision(12));
            } else {
                consumption = Number((getNumber(baseValue, 'estimatedConsValued') + getNumber(hpValue, 'estimatedConsValued')).toPrecision(12));
                amountWithModif = Number((getNumber(baseValue, 'amountWithModif') + getNumber(hpValue, 'amountWithModif')).toPrecision(12));
                taxes = Number((getNumber(baseValue, 'taxes') + getNumber(hpValue, 'taxes')).toPrecision(12));
            }

            var estimatedCons = {
                base: getNumber(baseValue, 'estimatedCons'),
                hp: getNumber(hpValue, 'estimatedCons'),
                hc: getNumber(hcValue, 'estimatedCons')
            };

            var subscription = Number(getFirst('subscription'));

            if (consumption !== undefined || subscription !== undefined || taxes !== undefined) {
                paid = $filter('frAmount')(Number((taxes + subscription + consumption).toPrecision(12)));
            } else {
                paid = 'En attente';
            }

            var formattedDate = date.format('MMM YY');
            var clickable = estimatedCons.base > 0 || estimatedCons.hp > 0 || estimatedCons.hc > 0;

            /* Echu // 2018-07 // Echoir */
            var echuEchoirSwitchDate = (0, _moment2.default)('2018-07', 'YYYY-MM');
            var paymentMonth = void 0;
            if (date.isSame(echuEchoirSwitchDate, 'month')) {
                paymentMonth = undefined;
            } else if (date.isBefore(echuEchoirSwitchDate, 'month')) {
                paymentMonth = (0, _moment2.default)(date).add(1, 'months').format('MMMM YYYY');
            } else {
                paymentMonth = (0, _moment2.default)(date).format('MMMM YYYY');
            }

            return {
                active: (0, _moment2.default)().month() === Number(baseValue.month) - 1,
                consumption: $filter('frAmount')(consumption),
                date: date,
                mensuality: date.format('MMMM YYYY'),
                paymentMonth: paymentMonth,
                paid: paid,
                pot: pot,
                prediction: getFirst('prediction'),
                subscription: $filter('frAmount')(subscription),
                taxes: $filter('frAmount')(taxes),
                estimatedCons: estimatedCons,
                formattedDate: formattedDate,
                clickable: clickable,
                amountWithModifs: amountWithModif
            };
        });
        return info;
    };

    var formatData = function formatData(values) {
        var getEstimatedValue = function getEstimatedValue(value) {
            return (0, _get2.default)(value, 'correctedCons', (0, _get2.default)(value, 'estimatedCons', 0));
        };

        var getRealValue = function getRealValue(value) {
            return (0, _get2.default)(value, 'realCons', (0, _get2.default)(value, 'autoCons', 0));
        };
        var mapGraphData = function mapGraphData(values, type) {
            var toGraphData = function toGraphData(value, index) {
                var formattedDate = (0, _moment2.default)().year(Number(value.year)).month(Number(value.month) - 1).format('MMM YY');
                var numberedDate = value.year + '-' + value.month;
                var additionnalClass = value.prediction ? ' prediction' : '';
                return [{
                    index: index,
                    type: type,
                    x: formattedDate + ' Estim\xE9',
                    y: Number(getEstimatedValue(value)),
                    barColor: '#93a3b7',
                    classType: 'nv-bar-estimated' + additionnalClass,
                    classGroup: 'nv-bar-group-' + index,
                    numberedDate: numberedDate,
                    tempClass: value.temp_class
                }, {
                    index: index,
                    type: type,
                    x: formattedDate + ' Consomm\xE9',
                    y: Number(getRealValue(value)),
                    barColor: '#071B37',
                    classType: 'nv-bar-real' + additionnalClass,
                    classGroup: 'nv-bar-group-' + index,
                    numberedDate: numberedDate,
                    tempClass: value.temp_class
                }];
            };
            return (0, _flow2.default)(_map4.default.convert({ cap: false })(toGraphData), _flatten2.default)(values);
        };

        var prepareData = function prepareData(values) {
            var minDateValue = getMinDateValue(values);
            var defaultDateValues = generateDefaultValuesPerMonth(minDateValue, 12);
            var filteredValues = filterValues(values);
            (0, _forEach2.default)(filteredValues, function (val) {
                val.values = fillWithExistingValueOrDefault(val.values, defaultDateValues);
                val.values = mapGraphData(val.values, val.type);
            });

            return filteredValues;
        };

        return prepareData(values);
    };

    var getOptions = function getOptions(opts) {
        var chartHeight = 200;
        return {
            multiBarChart: {
                chart: {
                    type: 'multiBarChart',
                    height: chartHeight,
                    margin: {
                        top: 20,
                        right: 15,
                        bottom: 15,
                        left: 15
                    },
                    clipEdge: true,
                    groupSpacing: 0,
                    duration: 1, // Set to one to avoid
                    stacked: true,
                    showControls: false,
                    showYAxis: false,
                    showXAxis: false,
                    showLegend: false,
                    noData: 'Aucune donnée disponible.',
                    multibar: {
                        dispatch: {
                            renderEnd: function renderEnd(e) {
                                if ($state.current.name === 'tracking') {
                                    var nextReadingDate = opts && opts.nextReadingDate ? (0, _moment2.default)(opts.nextReadingDate).startOf('month').format('YYYY-M') : null;

                                    var defs = _d2.default.selectAll('svg').append('defs');
                                    defs.append('pattern').attr({
                                        id: 'prediction',
                                        width: '8',
                                        height: '10',
                                        patternUnits: 'userSpaceOnUse',
                                        patternTransform: 'rotate(45 50 50)'
                                    }).append('line').attr({ 'stroke': '#a6a6a6', 'stroke-width': '7px', 'y2': '10' });
                                    defs.append('pattern').attr({
                                        id: 'prediction-active',
                                        width: '8',
                                        height: '10',
                                        patternUnits: 'userSpaceOnUse',
                                        patternTransform: 'rotate(45 50 50)'
                                    }).append('line').attr({ 'stroke': '#E97C92', 'stroke-width': '7px', 'y2': '10' });

                                    // for after window resize
                                    _d2.default.selectAll('rect.nv-bar').style('stroke', 'white').attr('stroke-width', '1px').attr('rx', 0).style('fill', '').each(function (elementData) {
                                        return _d2.default.select(this).classed(elementData.classGroup, true).classed(elementData.classType, true);
                                    });

                                    _d2.default.selectAll('rect.nv-bar.prediction').style('stroke', 'white').attr('stroke-width', '1px').attr('rx', 2).style('fill', 'url(#prediction)').each(function (elementData) {
                                        return _d2.default.select(this).classed(elementData.classGroup, true).classed(elementData.classType, true);
                                    });

                                    paintActive();

                                    return _d2.default.selectAll('rect.nv-bar').each(function (elementData) {
                                        // check if set of data is reading month
                                        elementData.isReadingMonth = elementData.numberedDate === nextReadingDate;
                                        var el = _d2.default.select(this);
                                        var id = 'bar-' + elementData.numberedDate + '-' + elementData.type;
                                        el.attr('id', id);

                                        // add reading date marker
                                        var rDeL = _d2.default.select('#reading-date');
                                        var addMarker = function () {
                                            if (opts.plan === 'Heures creuses' && elementData.type === 'HC') {
                                                return true;
                                            } else if (opts.plan === 'Base') {
                                                return true;
                                            }
                                        }();
                                        if (elementData.isReadingMonth && addMarker) {
                                            var seriesNumber = 2;
                                            switch (elementData.type) {
                                                case 'BASE':
                                                    seriesNumber = 0;break;
                                                case 'HP':
                                                    seriesNumber = 1;break;
                                                case 'HC':
                                                    seriesNumber = 2;break;
                                                default:
                                                    seriesNumber = 2;
                                            }
                                            var series = '.nv-series-' + seriesNumber;
                                            if (rDeL.empty()) {
                                                var readingMarker = _d2.default.select(series).insert('line', '#' + id + ' + *');
                                                readingMarker.attr('id', 'reading-date').style('stroke', 'black').style('fill', 'black').attr('stroke-width', '1.5px').attr('y1', parseInt(chartHeight)).attr('y2', '-60').attr('transform', el.attr('transform'));

                                                var txt = _d2.default.select(series).insert('text', '#' + id + ' + *');
                                                txt.attr('x', 10).attr('y', -20).attr('transform', el.attr('transform')).attr('stroke-width', '0').attr('fill', '#455469').attr('class', 'reading-label');

                                                txt.insert('tspan').html('Prochaine relève').attr({ x: 10, dy: '2.4em' });
                                                txt.insert('tspan').html('Enedis').attr({ x: 10, dy: '1.2em' });

                                                _d2.default.select(series).insert('rect', '#' + id + ' + *').attr('y', -17).attr('stroke-width', '0').attr('fill', 'rgba(255,255,255,0.5)').attr('transform', el.attr('transform')).attr({ width: '135' }).attr({ height: '2.4em' });
                                            }
                                        }

                                        if (rDeL.empty() === false) {
                                            el.append('pattern').attr({
                                                id: 'prediction',
                                                width: '8',
                                                height: '10',
                                                patternUnits: 'userSpaceOnUse',
                                                patternTransform: 'rotate(45 50 50)'
                                            }).append('line').attr({ 'stroke': '#a6a6a6', 'stroke-width': '7px', 'y2': '10' });
                                            el.append('pattern').attr({
                                                id: 'prediction-active',
                                                width: '8',
                                                height: '10',
                                                patternUnits: 'userSpaceOnUse',
                                                patternTransform: 'rotate(45 50 50)'
                                            }).append('line').attr({ 'stroke': '#E97C92', 'stroke-width': '7px', 'y2': '10' });
                                        }

                                        var width = el.attr('width');
                                        var reducedWidth = width * 0.7;
                                        var marginLeft = (elementData.classType != null ? elementData.classType.indexOf('nv-bar-estimated') : undefined) > -1 ? width - reducedWidth : 0;

                                        return el.attr('width', reducedWidth).attr('x', marginLeft);
                                    });
                                }
                            },
                            elementClick: function elementClick(element) {
                                return makeActive(element.data.index);
                            }
                        }
                    },
                    useInteractiveGuideline: false,
                    tooltip: {
                        contentGenerator: function contentGenerator(data) {
                            var content = '<div class=\'tooltip-header\'>' + data.value + '</div>';
                            data.series.forEach(function (serie) {
                                if (serie.value) {
                                    content += '<i class=\'fa fa-circle\' style=\'color: ';
                                    content += serie.color + '\'></i> ' + serie.key + ' : ';
                                    content += serie.value + ' kWh';
                                }
                            });
                            return content;
                        },

                        distance: 30,
                        gravity: 's'
                    },
                    callback: function callback() {
                        _d2.default.selectAll('rect.nv-bar').style('stroke', 'white').attr('stroke-width', '1px').attr('rx', 2).style('fill', '');

                        _d2.default.selectAll('rect.nv-bar.prediction').style('stroke', 'white').attr('stroke-width', '1px').attr('rx', 2).style('fill', 'url(#prediction)');

                        return paintActive();
                    }
                }
            }
        };
    };

    var generateGraphData = function generateGraphData(contractCons, opts) {
        var data = formatData(contractCons);
        var overrideOptions = (0, _set2.default)(getOptions(opts), 'multiBarChart.chart.forceY', setScale(data));
        return {
            data: data,
            options: overrideOptions,
            info: formatInfoData(contractCons),
            makeActive: makeActive
        };
    };

    return {
        options: getOptions(),
        watch: watch,
        setScale: setScale,
        utils: {
            generateGraphData: generateGraphData,
            makeActive: makeActive,
            retrieveFilteredData: retrieveFilteredData,
            formatData: formatData,
            formatInfoData: formatInfoData
        }
    };
}

/***/ }),
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CookiesService.$inject = ["$cookies", "$rootScope"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = CookiesService;

/** @ngInject */

function CookiesService($cookies, $rootScope) {
    var checkCookiesAcceptance = function checkCookiesAcceptance() {
        return $cookies.get('plumAuthorizeCookies');
    };

    var acceptCookies = function acceptCookies() {
        $cookies.put('plumAuthorizeCookies', true, { expires: _moment2.default.utc((0, _moment2.default)().add(5, 'years'))._d });
        return $rootScope.$emit('cookiesAccepted');
    };

    $rootScope.$on('$stateChangeStart', function () {
        if (!checkCookiesAcceptance()) {
            return acceptCookies();
        }
    });

    return {
        checkCookiesAcceptance: checkCookiesAcceptance,
        acceptCookies: acceptCookies
    };
}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DeviceChecker;

/** @ngInject */

function DeviceChecker() {
    // Currying
    var minWidth = function minWidth(width) {
        return function () {
            return window.innerWidth > width;
        };
    };
    var maxWidth = function maxWidth(width) {
        return function () {
            return window.innerWidth < width;
        };
    };

    return {
        isMobile: maxWidth(768),
        isTab: maxWidth(992),
        isDesktop: maxWidth(1200),
        isLargeDesktop: minWidth(1200)
    };
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ErrorCatcher.$inject = ["$state", "$stateParams", "$timeout", "$cookies", "NavError"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _noop2 = __webpack_require__(197);

var _noop3 = _interopRequireDefault(_noop2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _has = __webpack_require__(101);

var _has2 = _interopRequireDefault(_has);

var _set = __webpack_require__(204);

var _set2 = _interopRequireDefault(_set);

var _reduce = __webpack_require__(832);

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable
 max-statements-per-line,
 no-eq-null,
 */
exports.default = ErrorCatcher;

/** @ngInject */

function ErrorCatcher($state, $stateParams, $timeout, $cookies, NavError) {
    var removeField = function removeField(obj, path) {
        if ((0, _has2.default)(obj, path)) {
            return (0, _set2.default)(obj, path, undefined);
        }
        return obj;
    };
    var removeFields = function removeFields(paths) {
        return function (obj) {
            return (0, _reduce2.default)(paths, removeField, obj);
        };
    };
    var removeErrorFields = removeFields(['config.transformRequest', 'config.transformResponse', 'config.headers', 'config.data.password', 'config.data.passwordCheck']);

    var catchError = function catchError(bypassRedirectToLogin) {
        return function (errorResult) {
            // Remove $promise and $resolved from angular promise object
            var error = JSON.parse(_angular2.default.toJson(errorResult));

            // Print error in browser console
            console.error('ErrorCatcher', error);

            // Send error to the server
            NavError.sendError({
                state: window.location.pathname,
                url: error.config != null ? error.config.url : 'no url',
                returnCode: error.status,
                error: (0, _assign3.default)({}, { idRequest: (0, _get3.default)((0, _get3.default)(errorResult, 'headers', _noop3.default)(), 'x-urg-id-req') }, removeErrorFields(error))
            }).$promise.catch(function (error) {
                return console.error('Cannot send error logging to the server', error);
            });

            // Redirect to login in case of not authenticated
            if (!bypassRedirectToLogin && error.status === 401) {
                $cookies.remove('ssoStatus', { path: '/' });
                return $timeout(function () {
                    return $state.go('login', { redirectTo: $state.current.name, bulk_purchase: $stateParams.bulk_purchase }, { reload: true });
                });
            }
        };
    };

    return {
        WEBSITE_ERROR_STATUS: 0,
        catchError: catchError(false),
        catchErrorWithoutRedirect: catchError(true)
    };
}

/***/ }),
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


featuresService.$inject = ["ApiService", "$q", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = featuresService;

/** @ngInject */

function featuresService(ApiService, $q, ErrorCatcher) {
    var features$ = null;
    var features = [];

    var getFeaturesPromise = function getFeaturesPromise() {
        if (features$ === null) {
            features$ = ApiService.fetchFeatures().catch(function (error) {
                ErrorCatcher.catchError(error);
                return $q.reject(error);
            });
        }

        return features$;
    };

    var getFeatures = function getFeatures(callback) {
        if (features.length < 1) {
            var dfd = $q.defer();
            return getFeaturesPromise().then(function (response) {
                features = response;
                if (typeof callback === 'function') {
                    dfd.resolve(features);
                    return callback(features);
                }
                dfd.resolve(features);
                return dfd.promise;
            });
        }
        if (typeof callback === 'function') {
            return callback(features);
        }
        return features;
    };

    var reset = function reset() {
        features$ = null;
        features = [];
    };

    return {
        getFeatures: getFeatures,
        getFeaturesPromise: getFeaturesPromise,
        reset: reset
    };
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable
    max-statements-per-line,
*/
exports.default = capitalize;

/** @ngInject */

function capitalize() {
    return function (input) {
        if (input) {
            return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase();
        }
        return '';
    };
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNumber2 = __webpack_require__(139);

var _isNumber3 = _interopRequireDefault(_isNumber2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ceil;


function ceil() {
    return function (val) {
        return (0, _isNumber3.default)(val) ? Math.ceil(val) : val;
    };
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = clientId;

/** @ngInject */

function clientId() {
    return function (val) {
        if (val && val.length === 9) {
            return val.slice(0, 2) + " " + val.slice(2, 5) + " " + val.slice(5, 7) + " " + val.slice(7, 9);
        } else if (val) {
            return val;
        }
    };
}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


contractStatus.$inject = ["ReferencesService", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = __webpack_require__(8);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = contractStatus;

/** @ngInject */

function contractStatus(ReferencesService, ErrorCatcher) {
    var data = null;
    var serviceInvoked = false;
    var UNKNOWN_STATUS_MSG = 'Notre système n’a pas retrouvé le statut de votre contrat. Contactez-nous pour que nous résolvions ce problème.';

    var realFilter = function realFilter(value) {
        return (0, _get2.default)(data, [value, 0, 'label_fr'], UNKNOWN_STATUS_MSG);
    };

    var filterStub = function filterStub(value) {
        if (data === null) {
            if (!serviceInvoked) {
                serviceInvoked = true;
                ReferencesService.getRefPromise('contractStatus').then(function (contractStatusMapping) {
                    data = contractStatusMapping;
                }).catch(ErrorCatcher.catchError);
            }
            return 'loading ...';
        }
        return realFilter(value);
    };

    filterStub.$stateful = true;
    return filterStub;
}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty = __webpack_require__(14);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = elision;

/** @ngInject */

function elision() {
    var VOWEL = ['a', 'e', 'i', 'o', 'u'];
    return function (val) {
        if ((0, _isEmpty2.default)(val)) {
            return val;
        }
        return VOWEL.indexOf(val[0]) > -1 ? 'd\'' + val : 'de ' + val;
    };
}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(20);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = frAmount;

/** @ngInject */
/* eslint-disable
 no-eq-null,
 */

function frAmount() {
    return function (val, options) {
        var floatVal = parseFloat(val);
        var defaultOptions = { minimumFractionDigits: 2 };
        options = options != null ? (0, _assign2.default)({}, defaultOptions, options) : defaultOptions;
        if (!isNaN(floatVal)) {
            return floatVal.toLocaleString('fr-FR', options);
        }
        return '- ';
    };
}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isString2 = __webpack_require__(205);

var _isString3 = _interopRequireDefault(_isString2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = iban;


function iban() {
    var EVERY_FOUR_CHARS = /(.{4})(?!$)/g;

    return function (value) {
        return (0, _isString3.default)(value) ? value.replace(EVERY_FOUR_CHARS, '$1 ') : value;
    };
}

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = phone;

/** @ngInject */

function phone() {
    return function (val) {
        if (val && val.length === 10) {
            return val.slice(0, 2) + " " + val.slice(2, 4) + " " + val.slice(4, 6) + " " + val.slice(6, 8) + " " + val.slice(8, 10);
        } else if (val && val.length === 12) {
            return val.slice(0, 3) + " " + val.slice(3, 4) + " " + val.slice(4, 6) + " " + val.slice(6, 8) + " " + val.slice(8, 10) + " " + val.slice(10, 12);
        } else if (val && val.length === 13) {
            return val.slice(0, 4) + " " + val.slice(4, 5) + " " + val.slice(5, 7) + " " + val.slice(7, 9) + " " + val.slice(9, 11) + " " + val.slice(11, 13);
        }
        return val;
    };
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = prm;

/** @ngInject */

function prm() {
    return function (val) {
        if (val) {
            return val.slice(0, 2) + " " + val.slice(2, 5) + " " + val.slice(5, 8) + " " + val.slice(8, 11) + " " + val.slice(11);
        }
    };
}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _numeral = __webpack_require__(132);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = integer;

/** @ngInject */

function integer() {
    return function (value) {
        return (0, _numeral2.default)(value).format('0');
    };
}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _numeral = __webpack_require__(132);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = decimals;

/** @ngInject */

function decimals() {
    return function (value) {
        return (0, _numeral2.default)(value).format('.00$');
    };
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gaEventsService.$inject = ["$window"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = gaEventsService;

/** @ngInject */

function gaEventsService($window) {
    var newEvent = function newEvent(eventAction, eventLabel) {
        eventLabel = eventLabel || eventAction;
        // GA EVENT
        // initial GA event Start subscription
        var campainId = localStorage.id_campaign || 'default';
        $window.ga('send', {
            hitType: 'event',
            eventCategory: campainId,
            eventAction: eventAction,
            eventLabel: campainId + '-' + eventLabel,
            transport: 'beacon'
        });
        return true;
    };

    return {
        newEvent: newEvent
    };
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LandscapeElements;

/** @ngInject */

function LandscapeElements() {
    var LandscapeElements = [];

    return {
        LandscapeElements: LandscapeElements
    };
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MobilePhone.$inject = ["CommonRegex"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _replace2 = __webpack_require__(850);

var _replace3 = _interopRequireDefault(_replace2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = MobilePhone;

/** @ngInject */

function MobilePhone(CommonRegex) {
    var phoneRegex = CommonRegex.phone;

    var formatPhoneToPlus33 = function formatPhoneToPlus33(phone) {
        if (phoneRegex.plus33.test(phone)) {
            return phone;
        } else if (phoneRegex['0033'].test(phone)) {
            return '+' + phone.slice(2);
        } else if (phoneRegex['06or07'].test(phone)) {
            return '+33' + phone.slice(1);
        }
        return phone;
    };

    var formatPhoneTo0607 = function formatPhoneTo0607(phone) {
        if (phoneRegex.plus33.test(phone)) {
            return (0, _replace3.default)(phone, /\+33(.*)/g, '0$1');
        } else if (phoneRegex['0033'].test(phone)) {
            return (0, _replace3.default)(phone, /0033(.*)/g, '0$1');
        } else if (phoneRegex['06or07'].test(phone)) {
            return phone;
        }
        return phone;
    };

    var formatPhoneToSpacePhone = function formatPhoneToSpacePhone(v) {
        return (0, _replace3.default)(v, /(.{2})(?=.)/g, '$1 ');
    };

    return {
        phoneRegex: phoneRegex,
        formatPhoneToPlus33: formatPhoneToPlus33,
        formatPhoneTo0607: formatPhoneTo0607,
        formatPhoneToSpacePhone: formatPhoneToSpacePhone
    };
}

/***/ }),
/* 850 */,
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


PotManager.$inject = ["$rootScope", "User", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNumber = __webpack_require__(139);

var _isNumber2 = _interopRequireDefault(_isNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = PotManager;

/** @ngInject */

function PotManager($rootScope, User, ErrorCatcher) {
    var pot = {
        total: null,
        real: null,
        estimated: null
    };

    var update = function update() {
        return User.getPotBalance().$promise.then(function (response) {
            pot.total = Number(response.real) + Number(response.estimated);
            pot.real = Number(response.real);
            pot.estimated = Number(response.estimated);
            $rootScope.$emit('pot-updated', pot);
        }).catch(ErrorCatcher.catchError);
    };

    var getPotBalance = function getPotBalance() {
        if (!(0, _isNumber2.default)(pot.total) || !(0, _isNumber2.default)(pot.real) || !(0, _isNumber2.default)(pot.estimated)) {
            update();
        }
        return pot;
    };

    var resetPot = function resetPot() {
        pot = {
            total: null,
            real: null,
            estimated: null
        };
    };

    var watch = function watch(callback) {
        return $rootScope.$on('pot-updated', function (event, updatedPot) {
            return callback(updatedPot);
        });
    };

    return {
        getPotBalance: getPotBalance,
        resetPot: resetPot,
        watch: watch,
        update: update
    };
}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PrmUtilsService;

/** @ngInject */

function PrmUtilsService() {
    var isCBE = function isCBE(metter_kind) {
        return ['CBE', 'CEB'].indexOf(metter_kind) > -1;
    };

    var isEMC = function isEMC(metter_kind) {
        return ['EMC', 'CFB'].indexOf(metter_kind) > -1;
    };

    var isLinky = function isLinky(metter_kind) {
        switch (metter_kind) {
            case 'AMM':
                return true;
            case 'CCB':
                return true;
            case 'LINKY':
                return true;
            case 'CBE':
                return false;
            case 'EMC':
                return false;
            default:
                return false;
        }
    };

    var isMigratedLinky = function isMigratedLinky(prm) {
        if (!isLinky(prm.metter_kind)) {
            return false;
        }
        switch (prm.distributor_it) {
            case 'GINKO':
                return true;
            case 'QETGC':
                return false;
            default:
                return false;
        }
    };

    return {
        isCBE: isCBE,
        isEMC: isEMC,
        isMigratedLinky: isMigratedLinky,
        isLinky: isLinky
    };
}

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


rawHtml.$inject = ["$sce"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rawHtml;

/** @ngInject */

function rawHtml($sce) {
    return function (val) {
        return $sce.trustAsHtml(val);
    };
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ReferencesService.$inject = ["$rootScope", "DataAccessReferences"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _has = __webpack_require__(101);

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ReferencesService;

/** @ngInject */

function ReferencesService($rootScope, DataAccessReferences) {
    var refsPromise = {};

    var getRefPromise = function getRefPromise(ref) {
        if (!(0, _has2.default)(refsPromise, ref)) {
            refsPromise[ref] = DataAccessReferences.ref({ id: ref }).$promise;
        }
        return refsPromise[ref];
    };

    return {
        getRefPromise: getRefPromise
    };
}

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


campaignLandingCtrl.$inject = ["$scope", "$stateParams", "currentCampaign"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = campaignLandingCtrl;

/** @ngInject */

function campaignLandingCtrl($scope, $stateParams, currentCampaign) {
    $scope.stateParams = $stateParams;
    $scope.currentCampaign = currentCampaign;
}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


campaignLandingTemplate.$inject = ["$compile", "$state", "CampaignLanding", "CampaignLandingType"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty = __webpack_require__(14);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = campaignLandingTemplate;

/** @ngInject */

function campaignLandingTemplate($compile, $state, CampaignLanding, CampaignLandingType) {
    return {
        restrict: 'E',
        scope: {
            stateParams: '=',
            campaign: '='
        },
        link: function link(scope, element) {
            var isNotPreviewMode = (0, _isEmpty2.default)(scope.stateParams.tokenId);
            if (isNotPreviewMode) {
                var referrer = (0, _isEmpty2.default)(document.referrer) ? undefined : document.referrer;
                scope.email = '';
                scope.submit = function () {
                    CampaignLanding.submitCampaignInformation({
                        id_campaign: scope.campaign.id,
                        type: CampaignLandingType.SUBSCRIBE,
                        referrer: referrer,
                        mail: scope.email
                    });
                    return $state.go(scope.campaign.redirect_state);
                };

                localStorage.id_campaign = scope.campaign.id;
                CampaignLanding.submitCampaignInformation({
                    id_campaign: scope.campaign.id,
                    type: CampaignLandingType.VISITE,
                    referrer: referrer
                });
            }

            element.html(scope.campaign.html);
            return $compile(element.contents())(scope);
        }
    };
}

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


communityCtrl.$inject = ["$scope", "$rootScope", "$state", "$window", "$uibModal", "$stateParams", "PermPermissionStore", "DeviceChecker", "ApiService", "Community", "gaEventsService", "ContractService", "ErrorCatcher", "userCommunityService", "LandingPageLink"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable
 no-eq-null,
 no-loop-func,
 */
exports.default = communityCtrl;

/** @ngInject */

function communityCtrl($scope, $rootScope, $state, $window, $uibModal, $stateParams, PermPermissionStore, DeviceChecker, ApiService, Community, gaEventsService, ContractService, ErrorCatcher, userCommunityService, LandingPageLink) {
    $scope.questionIsFocused = false;
    $scope.userCommunityInfo = {};
    $scope.mostActiveUsers = {};
    $scope.topicMessages = {};
    $scope.userChatsCount = 0;
    $scope.userNotificationsCount = 0;
    $scope.isMobile = DeviceChecker.isMobile;
    $scope.isClient = false;
    $scope.self = $scope;
    $scope.state = $state;
    $scope.gaEventsService = gaEventsService;
    $scope.openContactForm = !(0, _isEmpty3.default)($stateParams.contact);
    $scope.offerPageLink = LandingPageLink[$window.location.hostname] + '/offre-cagnotte-renouvelable/';

    // This is a callback called in the feature directive to add the state name in the state
    // object returned by Plüm's API
    // First let's create an object whose keys are the URLs of the app and whose values are
    // the corresponding state name
    var stateURLs = $state.get().reduce(function (result, item) {
        var key = '/#' + item.url;
        result[key] = item.name;
        return result;
    }, {});

    $scope.logout = function () {
        return $state.go('logout', {}, { reload: true });
    };

    $scope.isActive = function (state) {
        return $state.is(state);
    };

    $scope.hasParentState = function (parent) {
        return $state.current.parent != null ? $state.current.parent.includes(parent) : undefined;
    };

    $scope.search = function (searchValue) {
        var param = window.encodeURIComponent(searchValue);
        $window.location.href = '/communaute/search/' + param + '?in=titlesposts';
    };

    $scope.focusQuestionInput = function (bool) {
        $scope.questionIsFocused = bool;
        return $scope.$evalAsync();
    };

    $scope.addStateName = function (scope, states) {
        // Next let's get the state name from the URL. If the URL is not found, redirect to landing page
        scope.activeBurgerMenu = states.map(function (state) {
            state.stateName = stateURLs[state.url];
            if (state.stateName === undefined) {
                console.error('No state found for URL ' + state.url);
                state.stateName = 'landing';
            }
            return state;
        });
    };

    $scope.getHeaderHeight = function () {
        var headerHeight = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Array.from(_angular2.default.element('.stickBelow'))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var header = _step.value;

                headerHeight += header.getBoundingClientRect().height;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return headerHeight;
    };

    $scope.getCurrentStateInfo = function (scope, states) {
        var findCurrentStateLabel = function findCurrentStateLabel(currentStateUrl) {
            var stateLabel = states.filter(function (state) {
                return state.url === '/#' + currentStateUrl;
            });
            if (stateLabel.length === 0) {
                return states[0].label;
            }
            return stateLabel[0].label;
        };
        scope.activeBurgerMenu = findCurrentStateLabel($state.current.url);

        return $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            scope.activeBurgerMenu = findCurrentStateLabel(toState.url);
        });
    };

    $scope.openContactModal = function () {
        var openContactModal = $uibModal.open({
            animation: true,
            controller: 'contactModalCtrl',
            template: __webpack_require__(140)(),
            resolve: {
                contractSelected: ["ApiService", "PermPermissionStore", function contractSelected(ApiService, PermPermissionStore) {
                    return __guard__(PermPermissionStore.getStore().client, function (x) {
                        return x.validatePermission().then(function () {
                            return ApiService.fetchUserInfo().then(function (response) {
                                if (response.contractSelected) {
                                    return response.contractSelected;
                                }
                                if (response.contracts.length > 0) {
                                    return response.contracts[0];
                                }
                            });
                        });
                    }).catch(function () {
                        return {};
                    });
                }],
                userInfo: ["ApiService", function userInfo(ApiService) {
                    return __guard__(PermPermissionStore.getStore().client, function (x) {
                        return x.validatePermission().then(function () {
                            return ApiService.fetchUserInfo();
                        }).catch(function () {
                            return {};
                        });
                    });
                }]
            }
        });
        return openContactModal.closed.then(function () {
            return $state.go($state.$current.self.name, { contact: undefined }, { notify: false });
        });
    };

    $scope.openSubscriptionModal = function () {
        $uibModal.open({ animation: true, component: 'subscriptionModal' });
    };

    $scope.redirectOnClick = function () {
        ApiService.fetchUserInfo().then(function (userInfo) {
            $state.go(ContractService.getMyAccountStatusFromContract((0, _get3.default)(userInfo, 'contractSelected')));
        }).catch(function (error) {
            if (error.message !== 'transition prevented') {
                ErrorCatcher.catchError(error);
            }
        });
    };

    $rootScope.$on('$stateChangeStart', function () {
        __guard__(PermPermissionStore.getStore().client, function (x) {
            return x.validatePermission().then(function () {
                $scope.isClient = true;
            });
        });
    });

    var activate = function activate() {
        __guard__(PermPermissionStore.getStore().client, function (x) {
            return x.validatePermission().then(function () {
                $scope.isClient = true;
            });
        });

        __guard__(PermPermissionStore.getStore().user, function (x) {
            return x.validatePermission().then(function () {
                return userCommunityService.fetchCommunityInfo();
            });
        }).then(function () {
            $scope.userCommunityInfo = userCommunityService.getUserCommunityInfo();
            $scope.userChatsCount = userCommunityService.getChatsCount();
            $scope.userNotificationsCount = userCommunityService.getNotificationsCount();
        });

        Community.getMostActiveUsers().$promise.then(function (response) {
            if (response.users) {
                $scope.mostActiveUsers = response.users;
            }
        }).catch(ErrorCatcher.catchErrorWithoutRedirect);

        Community.getOnlineUsers().$promise.then(function (response) {
            if (response.users) {
                $scope.onlineUsers = response.users;
            }
        }).catch(ErrorCatcher.catchErrorWithoutRedirect);

        Community.getUsers().$promise.then(function (response) {
            if (response.users) {
                $scope.recentlyJoinedUsers = response.users;
            }
        }).catch(ErrorCatcher.catchErrorWithoutRedirect);

        Community.getTrendingTopics().$promise.then(function (response) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Array.from(response.topics)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var topic = _step2.value;

                    if (!topic.teaser) {
                        Community.getTopic({ id: topic.tid }).$promise.then(function (post) {
                            $scope.topicMessages[post.tid] = post.posts[0].content;
                        }).catch(ErrorCatcher.catchErrorWithoutRedirect);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            $scope.topics = response.topics;
        }).catch(ErrorCatcher.catchErrorWithoutRedirect);

        Community.getTrendingFaq().$promise.then(function (response) {
            var faqCategories = response.children;
            var hasPosts = function hasPosts(element) {
                return element.posts.length > 0;
            };
            var newFaqCat = faqCategories.filter(hasPosts);
            newFaqCat.sort(function (x, y) {
                return y.posts[0].timestamp - x.posts[0].timestamp;
            });
            var postCount = {};
            for (var i = 0, end = newFaqCat.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                postCount[newFaqCat[i].cid] = {};
                newFaqCat[i].messageCount = postCount[newFaqCat[i].cid];
                var postId = newFaqCat[i].posts[0].topic.slug.split('/');
                Community.getTopic({ id: postId[0] }).$promise.then(function (response) {
                    postCount[response.cid].msgCount = response.postcount;
                }).catch(ErrorCatcher.catchErrorWithoutRedirect);
            }

            $scope.faqRecentCats = newFaqCat;
        }).catch(ErrorCatcher.catchErrorWithoutRedirect);

        Community.getLastBlogPosts().$promise.then(function (response) {
            var blogTopics = response.topics;
            var retrieveId = function retrieveId(element) {
                return element.tid;
            };
            var blogTopicsId = blogTopics.map(retrieveId);
            var blogPosts = [];
            for (var i = 0, end = blogTopicsId.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                Community.getTopic({ id: blogTopicsId[i] }).$promise.then(function (response) {
                    var postContent = response.posts[0].content;

                    var dom = document.implementation.createHTMLDocument('temp');
                    dom.documentElement.innerHTML = postContent;

                    var postImg = (0, _jquery2.default)('img', dom).get(0);
                    var postImgUrl = (0, _jquery2.default)(postImg).attr('src');
                    response.posts[0].imgUrl = postImgUrl;

                    var text = (0, _jquery2.default)(dom).text();
                    if (text && text.length > 160) {
                        var textProv = text.substr(0, 159);
                        var indexTextDef = textProv.lastIndexOf(' ');
                        text = textProv.substr(0, indexTextDef);
                    }

                    postContent = { text: text };
                    response.posts[0].postText = postContent;

                    return blogPosts.push(response);
                }).catch(ErrorCatcher.catchErrorWithoutRedirect);
            }
            $scope.actuPosts = blogPosts;
        }).catch(ErrorCatcher.catchErrorWithoutRedirect);

        if ($scope.openContactForm) {
            $scope.openContactModal();
        }
    };

    return activate();
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


termsCtrl.$inject = ["$scope", "providerInfo"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = termsCtrl;

/** @ngInject */

function termsCtrl($scope, providerInfo) {
    $scope.providerInfo = providerInfo;
}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


confirmCtrl.$inject = ["$scope", "$state", "$stateParams", "$q", "User", "DeviceChecker", "ContactTelephone", "ErrorCatcher", "userInfo", "ContractDraft", "ContractService", "ApiService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = confirmCtrl;

/** @ngInject */

function confirmCtrl($scope, $state, $stateParams, $q, User, DeviceChecker, ContactTelephone, ErrorCatcher, userInfo, ContractDraft, ContractService, ApiService) {
    $scope.password = '';
    $scope.passwordCheck = '';
    $scope.passwordStrengh = undefined;
    $scope.hasUserInfo = userInfo.hasUserInfo;
    $scope.currentInput = 'password';
    $scope.passwordType = 'password';
    $scope.isMobile = DeviceChecker.isMobile;
    $scope.contactTelephone = ContactTelephone;
    $scope.isSubmitting = false;
    $scope.error = {
        confirm: false
    };
    $scope.confirmForm = {
        form1: {
            $invalid: false
        } // Need to do it due to weird behavior
    };
    $scope.minStrength = 2;
    $scope.scoreMeaning = ['Trop simple', 'Encore un petit effort', 'Acceptable', 'Très bien', 'Top !'];

    $scope.togglePasswordVisibility = function () {
        $scope.passwordType = $scope.passwordType === 'password' ? 'text' : 'password';
    };

    $scope.focus = function (input) {
        $scope.currentInput = input;
        if (input !== 'password') {
            $scope.error.confirm = false;
        }
        if (input !== '') {
            return $scope.confirmForm.form1.$setPristine();
        }
    };

    $scope.passwordStrengh = undefined;

    $scope.setPassword = function (password, passwordCheck) {
        $scope.error.confirm = false;
        $scope.confirmForm.form1.$setSubmitted();
        if ($scope.confirmForm.form1.$invalid) {
            return;
        }

        $scope.isSubmitting = true;
        var setPassword$ = User.setPassword({ token: $state.params.token }, { password: password, passwordCheck: passwordCheck }).$promise;
        setPassword$.then(function (user) {
            var userInfoData = ApiService.fetchUserInfo();
            var contractDraft = ContractDraft.get({ create: false, silent: true }).$promise;
            return $q.all({ userInfo: userInfoData, contractDraft: contractDraft });
        }).then(function (values) {
            // Get redirectTo + source
            var _localStorage = localStorage,
                redirectTo = _localStorage.redirectTo,
                source = _localStorage.source;


            localStorage.removeItem('subscriptionToken');
            localStorage.removeItem('redirectTo');
            localStorage.removeItem('source');

            // Redirect rules
            if (!(0, _isEmpty3.default)(ContractService.findFirstGoalNotDefinedContract(values.userInfo.contracts))) {
                return $state.go('endSubscription');
            } else if ($stateParams.redirectTo === 'endSubscription') {
                return $state.go($stateParams.redirectTo, $stateParams);
            } else if (values.contractDraft.ready_to_checkout) {
                return $state.go('subscriptionSummary');
            } else if (source === 'communaute') {
                if (redirectTo !== undefined && redirectTo !== 'undefined') {
                    window.location.href = '/communaute' + redirectTo;
                }
                return $state.go('community');
            } else if (redirectTo !== undefined && redirectTo !== 'undefined') {
                return $state.go(redirectTo);
            }
            var unpaidContract = ContractService.findFirstUnpaidContract(values.userInfo.contracts);
            if (!(0, _isEmpty3.default)(unpaidContract)) {
                return $state.go('invoice', { contractId: unpaidContract.id });
            }
            var selectedContract = ContractService.findFirstNotFinishedContract(values.userInfo.contracts);
            if (!(0, _isEmpty3.default)(selectedContract)) {
                return $state.go('account', { contractId: selectedContract.id });
            }
            if ((0, _isEmpty3.default)(values.userInfo.contracts)) {
                return $state.go('subscription', { bulk_purchase: $stateParams.bulk_purchase });
            }
            return $state.go('account');
        }).catch(function (error) {
            if (!error.message === 'transition prevented') {
                return ErrorCatcher.catchError(error);
            }
        });

        return setPassword$.catch(function (error) {
            $scope.isSubmitting = false;
            $scope.error.confirm = true;
            return ErrorCatcher.catchError(error);
        });
    };

    var activate = function activate() {
        __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1193)]; ((function (zxcvbn) {
            $scope.updatePasswordStrength = function (password) {
                console.log('updatePasswordStrength was triggered');
                $scope.passwordStrengh = password ? zxcvbn(password).score : undefined;
            };
            $scope.$watch('password', function (newValue, oldValue) {
                console.log('password change was triggered');
                $scope.passwordStrengh = newValue ? zxcvbn(newValue).score : undefined;
            });
        }).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);

        if (localStorage.source !== undefined) {
            $scope.fromCommunity = true;
        }
    };

    return activate();
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


confirmChangeMailCtrl.$inject = ["$scope", "ContactTelephone", "isChangeMailSuccess"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = confirmChangeMailCtrl;

/** @ngInject */

function confirmChangeMailCtrl($scope, ContactTelephone, isChangeMailSuccess) {
    $scope.contactTelephone = ContactTelephone;
    $scope.isChangeMailSuccess = isChangeMailSuccess;
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


contactModalCtrl.$inject = ["$scope", "$uibModalInstance", "contractSelected", "DeviceChecker", "RecaptchaKey", "$location", "MailAdresses", "Contact", "userInfo", "ContactTelephone", "PermPermissionStore", "ContactSubjects", "gaEventsService", "FileUploader", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = __webpack_require__(8);

var _get2 = _interopRequireDefault(_get);

var _has = __webpack_require__(101);

var _has2 = _interopRequireDefault(_has);

var _assign = __webpack_require__(20);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = contactModalCtrl;

/** @ngInject */

function contactModalCtrl($scope, $uibModalInstance, contractSelected, DeviceChecker, RecaptchaKey, $location, MailAdresses, Contact, userInfo, ContactTelephone, PermPermissionStore, ContactSubjects, gaEventsService, FileUploader, ErrorCatcher) {
    $scope.gaEventsService = gaEventsService;
    $scope.urgentPhone = (0, _get2.default)(contractSelected, 'prm.help_phone');
    $scope.availableCategories = ContactSubjects.anonymous;
    $scope.mailAdresse = MailAdresses;
    $scope.contactTelephone = ContactTelephone;
    $scope.displayForm = false;
    $scope.captcha = { key: RecaptchaKey[$location.host()] };
    $scope.form = {
        api: {},
        isCustomerIdDefined: (0, _has2.default)(userInfo, 'customer_id'),
        isContactSending: false,
        isContactSent: false,
        error: {
            hasError: false,
            message: ''
        },
        model: {
            firstName: userInfo.givenname,
            lastName: userInfo.sn,
            email: userInfo.mail,
            selectedSubject: {},
            subject: undefined,
            type: undefined,
            body: undefined,
            captcha: undefined,
            attachmentToken: undefined
        }
    };
    $scope.fileUploaderStatus = 'INITIAL';
    $scope.fileUploaderMessage = '';
    $scope.uploader = new FileUploader({
        url: '/anon/contact/attachment',
        method: 'POST',
        alias: 'attachment',
        autoUpload: true,
        onAfterAddingFile: function onAfterAddingFile(item) {
            $scope.fileUploaderStatus = 'SENDING';
        },
        onSuccessItem: function onSuccessItem(item, response, status, headers) {
            $scope.form.model.attachmentToken = response.token;
            $scope.fileUploaderStatus = 'SUCCESS';
        },
        onErrorItem: function onErrorItem(item, response, status, headers) {
            ErrorCatcher.catchError(response);
            $scope.fileUploaderStatus = 'FAIL';
            $scope.fileUploaderMessage = response.message;
        }
    });

    $scope.close = function () {
        return $uibModalInstance.dismiss();
    };

    $scope.isMobile = DeviceChecker.isMobile;

    $scope.switchToForm = function () {
        $scope.displayForm = true;
    };

    $scope.sendMessage = function (form) {
        form.api.$setSubmitted();
        if (form.api.$invalid) {
            return;
        }

        form.isContactSending = true;
        var messageToSend = (0, _assign2.default)({}, form.model, {
            selectedSubject: undefined,
            subject: form.model.selectedSubject.subject,
            type: form.model.selectedSubject.type
        });
        return Contact.sendMessage({}, messageToSend).$promise.then(function () {
            form.isContactSending = false;
            form.isContactSent = true;
        }).catch(function (error) {
            form.error.hasError = true;
            form.isContactSending = false;
            form.isContactSent = false;
            form.error.message = error.data.message;
            return ErrorCatcher.catchError(error);
        });
    };

    var activate = function activate() {
        __guard__(PermPermissionStore.getStore().client, function (x) {
            return x.validatePermission().then(function () {
                $scope.availableCategories = ContactSubjects.client;
            });
        });

        return gaEventsService.newEvent('open modal - Nous Contacter');
    };

    return activate();
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


flowCtrl.$inject = ["$scope"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = flowCtrl;

/** @ngInject */

function flowCtrl($scope) {
    $scope.hint = {
        body: 'Et jusqu\u2019\xE0 20% de moins avec un thermostat programmable ou thermostat \xE0 horloge (r\xE9duction de la temp\xE9rature la nuit ou en cas d\u2019absence).',
        implementation: 1,
        investment: 1,
        large: true,
        room: 'kitchen',
        saving: 2,
        summary: 'Vous consommerez jusqu\u2019\xE0 10 % de moins avec un thermostat simple (le chauffage se d\xE9clenche en fonction d\u2019une temp\xE9rature choisie)',
        title: '10% de moins grâce à un thermostat'
    };
}

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


unergieFooter.$inject = ["$q", "$uibModal", "$stateParams", "$timeout", "ReferencesService", "TariffResource", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mapKeys2 = __webpack_require__(321);

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

var _mapValues2 = __webpack_require__(322);

var _mapValues3 = _interopRequireDefault(_mapValues2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = unergieFooter;

/** @ngInject */

function unergieFooter($q, $uibModal, $stateParams, $timeout, ReferencesService, TariffResource, ErrorCatcher) {
    return {
        restrict: 'E',
        template: __webpack_require__(864)(),
        link: function link($scope) {
            var tariffInfoPromise = $q.resolve({});
            var availablePowersPromise = $q.resolve({});

            $scope.openPriceModal = function () {
                $uibModal.open({
                    animation: true,
                    size: 'lg',
                    component: 'priceModal',
                    resolve: {
                        availablePowers: availablePowersPromise,
                        tariffInfo: tariffInfoPromise
                    }
                });
            };

            var activate = function activate() {
                availablePowersPromise = ReferencesService.getRefPromise('ot-ps').catch(function (error) {
                    ErrorCatcher.catchError(error);
                    $q.reject(error);
                });

                tariffInfoPromise = TariffResource.getTariff().$promise.then(function (result) {
                    var toUpperCaseKey = function toUpperCaseKey(val, key) {
                        return key.toUpperCase();
                    };
                    return (0, _mapValues3.default)(result, function (val) {
                        return (0, _mapKeys3.default)(val, toUpperCaseKey);
                    });
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    $q.reject(error);
                });

                $timeout(function () {
                    if ($stateParams.shouldOpenPriceForm) {
                        $scope.openPriceModal();
                    }
                });
            };
            activate();
        }
    };
}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cfooter class=\"nav nav-plum\"\u003E\u003Cdiv class=\"container-fluid dashboard\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-8 col-sm-offset-2\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ca class=\"squared-link white\" ng-click=\"openContactModal() &amp;&amp; gaEventsService.newEvent('click - Nous Contacter')\"\u003ENous contacter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ca class=\"squared-link white\" href=\"https:\u002F\u002Fassistance.plum.fr\" target=\"_self\"\u003EFAQ\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ca class=\"squared-link white\" href=\"\u002Fcommunaute\u002Fcategory\u002F3\u002Fl-actu-plüm-énergie\" target=\"_self\"\u003EActualités PLÜM\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-2\"\u003E\u003Ca class=\"social-link white\" href=\"https:\u002F\u002Fwww.facebook.com\u002FPlumEnergie\u002F\" target=\"blank\"\u003E\u003Ci class=\"fa fa-facebook-official\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca class=\"social-link white\" href=\"https:\u002F\u002Ftwitter.com\u002FPlumEnergie\" target=\"blank\"\u003E\u003Ci class=\"fa fa-twitter-square\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 text-center white footer-small-link\"\u003E\u003Ca class=\"white\" ui-sref=\"terms\"\u003EMentions légales\u003C\u002Fa\u003E&nbsp;-&nbsp;\u003Ca class=\"white\" href=\"\u002Fdocumentation\u002Fcgv.pdf\" target=\"blank\"\u003EConditions générales de vente\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffooter\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


forgotPasswordCtrl.$inject = ["$scope", "$state", "$stateParams", "User", "ApiService", "ContactTelephone", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = forgotPasswordCtrl;

/** @ngInject */

function forgotPasswordCtrl($scope, $state, $stateParams, User, ApiService, ContactTelephone, ErrorCatcher) {
    $scope.contactTelephone = ContactTelephone;
    $scope.user = {};
    $scope.fromCommunity = $stateParams.source === 'communaute';
    $scope.source = $stateParams.source;
    $scope.redirectTo = $stateParams.redirectTo;
    ApiService.resetPromise('userInfo');
    $scope.sendResetPasswd = false;
    $scope.sendResetPasswdSuccess = false;
    $scope.incorrectEmail = false;
    $scope.unknownError = false;
    $scope.isForgotPassword = false;
    $scope.page = $state.current.name;

    $scope.sendResetPassword = function (user) {
        $scope.isForgotPassword = true;
        return User.resetPassword({ email: user.username }).$promise.then(function () {
            $scope.loginError = false;
            $scope.sendResetPasswd = true;
            $scope.sendResetPasswdSuccess = true;
        }, function (error) {
            $scope.loginError = false;
            $scope.sendResetPasswd = true;
            if (error.status === 400) {
                $scope.incorrectEmail = true;
            } else {
                $scope.unknownError = true;
            }
            return ErrorCatcher.catchError(error);
        }).finally(function () {
            $scope.isForgotPassword = false;
        });
    };
}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


hintsCtrl.$inject = ["Hint", "RoomName", "$scope", "smoothScroll", "DeviceChecker", "$timeout", "hints", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable
    guard-for-in,
    no-use-before-define,
    no-var,
*/
exports.default = hintsCtrl;

/** @ngInject */

function hintsCtrl(Hint, RoomName, $scope, smoothScroll, DeviceChecker, $timeout, hints, ErrorCatcher) {
    $scope.isMobile = function () {
        return DeviceChecker.isMobile();
    };
    $scope.hintCategories = {
        'Se chauffer': {
            title: 'Se chauffer',
            hints: [],
            id: 'se-chauffer'
        },
        'Chauffer l’eau': {
            title: 'Chauffer l’eau',
            hints: [],
            id: 'chauffer-l-eau'
        },
        'Cuisiner': {
            title: 'Cuisiner',
            hints: [],
            id: 'cuisiner'
        },
        'Laver': {
            title: 'Laver',
            hints: [],
            id: 'laver'
        },
        'Refroidir': {
            title: 'Refroidir',
            hints: [],
            id: 'refroidir'
        },
        'Se divertir': {
            title: 'Se divertir',
            hints: [],
            id: 'se-divertir'
        },
        'S’éclairer': {
            title: 'S’éclairer',
            hints: [],
            id: 's-eclairer'
        },
        'Autres': {
            title: 'Autres',
            hints: [],
            id: 'autres'
        }
    };

    var flushHints = function flushHints() {
        return function () {
            var result = [];
            for (var k in $scope.hintCategories) {
                var v = $scope.hintCategories[k];
                result.push(v.hints = []);
            }
            return result;
        }();
    };

    $scope.searchString = '';
    var timeOutPromise = null;

    $scope.searchHint = function () {
        if (timeOutPromise) {
            $timeout.cancel(timeOutPromise);
        }
        timeOutPromise = $timeout(searchIt, 300);
    };

    var refreshHints = function refreshHints(hints) {
        flushHints();
        return function () {
            var result = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Array.from(hints)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var hint = _step.value;

                    var item = void 0;
                    if ($scope.hintCategories[hint.category]) {
                        item = $scope.hintCategories[hint.category].hints.push(hint);
                    }
                    result.push(item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return result;
        }();
    };

    var searchIt = function searchIt() {
        return Hint.getAll({ q: $scope.searchString }).$promise.then(function (response) {
            return refreshHints(response);
        }).catch(ErrorCatcher.catchError);
    };

    refreshHints(hints);

    $scope.getHintClass = function (room) {
        return RoomName[room] || 'default';
    };

    $scope.getHintClassDirective = function (room) {
        return RoomName[room] + 'Icon' || 'default';
    };

    $scope.isLeft = function (parentIndex) {
        return parentIndex % 2 === 0;
    };

    $scope.isRight = function (parentIndex) {
        return parentIndex % 2 === 1;
    };

    $scope.readHint = function (hint, hintIndex, category) {
        var temp = category.hints[hintIndex];
        category.hints[hintIndex] = category.hints[0];
        category.hints[0] = temp;
        return smoothScroll(document.getElementById(category.id), { offset: 30 });
    };
}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


homeCtrl.$inject = ["AlertManager", "$scope", "$stateParams", "$window"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty = __webpack_require__(14);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = homeCtrl;

/** @ngInject */

function homeCtrl(AlertManager, $scope, $stateParams, $window) {
    if (!(0, _isEmpty2.default)($stateParams.utm_source)) {
        localStorage.utm_source = $stateParams.utm_source;
    }
    if (!(0, _isEmpty2.default)($stateParams.utm_medium)) {
        localStorage.utm_medium = $stateParams.utm_medium;
    }
    if (!(0, _isEmpty2.default)($stateParams.utm_campaign)) {
        localStorage.utm_campaign = $stateParams.utm_campaign;
    }

    $scope.alerts = AlertManager.alerts;
    $scope.closeAlert = function (index) {
        return AlertManager.closeAlert(index);
    };

    $scope.openSelfcareV2 = function () {
        if ($window.location.host.indexOf('local') !== -1) {
            $window.location.href = 'https://local.unergie.com:3010';
        } else {
            $window.location.href = 'https://' + $window.location.host + '/v2';
        }
    };
}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


animatedOnVisible.$inject = ["$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = animatedOnVisible;

/** @ngInject */

function animatedOnVisible($timeout) {
    return {
        restrict: 'A',
        link: {
            post: function post(scope, element, attr) {
                var animate = function animate() {
                    var $window = (0, _jquery2.default)(window);
                    var elementOffsetBottom = element.offset().top + element.height() / 1.8;
                    var viewportBottom = $window.scrollTop() + $window.height();
                    if (viewportBottom >= elementOffsetBottom && !element.hasClass('animated')) {
                        element.removeClass('visibility-hidden');
                        return element.addClass(attr.animatedOnVisible + ' animated');
                    }
                };

                (0, _jquery2.default)(window).on('scroll.animatedOnVisible', function () {
                    return animate();
                });

                element.addClass('visibility-hidden');
                $timeout(animate);

                return scope.$on('$destroy', function () {
                    return (0, _jquery2.default)(window).off('.animatedOnVisible');
                });
            }
        }
    };
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


landingCtrl.$inject = ["$scope", "$uibModal", "$timeout", "$state", "$stateParams", "$q", "DeviceChecker", "PermPermissionStore", "gaEventsService", "TariffResource", "ReferencesService", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mapKeys = __webpack_require__(321);

var _mapKeys2 = _interopRequireDefault(_mapKeys);

var _mapValues = __webpack_require__(322);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = landingCtrl;

/** @ngInject */

function landingCtrl($scope, $uibModal, $timeout, $state, $stateParams, $q, DeviceChecker, PermPermissionStore, gaEventsService, TariffResource, ReferencesService, ErrorCatcher) {
    $scope.gaEventsService = gaEventsService;
    $scope.active = 0;
    $scope.isMobile = DeviceChecker.isMobile;
    $scope.navCollapsed = true;
    $scope.navbarOffsetBegin = 100;
    $scope.navbarOffsetEnd = 100;
    $scope.specialOffer = {
        isSponsor: localStorage.sponsorId,
        isPromo: localStorage.promoId
    };
    var tariffInfoPromise = $q.resolve({});
    var availablePowersPromise = $q.resolve({});

    $scope.toogleNavCollapsed = function () {
        if (DeviceChecker.isMobile()) {
            $scope.navCollapsed = !$scope.navCollapsed;
        }
        return true;
    };

    $scope.openContactModal = function () {
        $uibModal.open({
            animation: true,
            controller: 'contactModalCtrl',
            template: __webpack_require__(140)(),
            resolve: {
                contractSelected: function contractSelected() {
                    return undefined;
                },
                userInfo: ["ApiService", function userInfo(ApiService) {
                    return __guard__(PermPermissionStore.getStore().client, function (x) {
                        return x.validatePermission().then(function () {
                            return ApiService.fetchUserInfo();
                        }).catch(function () {
                            return {};
                        });
                    });
                }]
            }
        });
    };

    $scope.openFonctionnementCagnotteModal = function () {
        $uibModal.open({
            animation: true,
            size: 'lg',
            template: __webpack_require__(870)(),
            controller: ["$scope", "$uibModalInstance", "gaEventsService", function controller($scope, $uibModalInstance, gaEventsService) {
                $scope.close = $uibModalInstance.dismiss;
                var activate = function activate() {
                    return gaEventsService.newEvent('open modal - Fonctionnement Cagnotte');
                };
                activate();
            }]
        });
    };

    $scope.openTransitionEnergetiqueModal = function () {
        $uibModal.open({
            animation: true,
            size: 'lg',
            template: __webpack_require__(871)(),
            controller: ["$scope", "$uibModalInstance", "gaEventsService", function controller($scope, $uibModalInstance, gaEventsService) {
                $scope.close = $uibModalInstance.dismiss;
                var activate = function activate() {
                    return gaEventsService.newEvent('open modal - Transition Energetique');
                };
                activate();
            }]
        });
    };

    $scope.openPriceModal = function () {
        $uibModal.open({
            animation: true,
            size: 'lg',
            component: 'priceModal',
            resolve: {
                tariffInfo: tariffInfoPromise,
                availablePowers: availablePowersPromise
            }
        });
    };

    $scope.openSubscriptionModal = function () {
        $uibModal.open({ animation: true, component: 'subscriptionModal' });
    };

    $scope.openQuotation = function () {
        $state.go('quotationDefault');
    };

    var activate = function activate() {
        availablePowersPromise = ReferencesService.getRefPromise('ot-ps').catch(function (error) {
            ErrorCatcher.catchError(error);
            $q.reject(error);
        });

        tariffInfoPromise = TariffResource.getTariff().$promise.then(function (result) {
            var toUpperCaseKey = function toUpperCaseKey(val, key) {
                return key.toUpperCase();
            };
            return (0, _mapValues2.default)(result, function (val) {
                return (0, _mapKeys2.default)(val, toUpperCaseKey);
            });
        }).catch(function (error) {
            ErrorCatcher.catchError(error);
            $q.reject(error);
        });

        $timeout(function () {
            if ($stateParams.shouldOpenPriceForm) {
                $scope.openPriceModal();
            }
        });
    };

    activate();
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"fonctionnement-cagnotte-modal\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"detail col-xs-12 col-sm-4\"\u003E\u003Ch2\u003E1\u003C\u002Fh2\u003E\u003Cdiv class=\"detail-icon\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002Fgears.svg\"\u003E\u003C\u002Fdiv\u003E\u003Ch4 class=\"light\"\u003EESTIMATION\u003C\u002Fh4\u003E\u003Cp class=\"detail-description\"\u003ENous estimons votre consommation de référence grâce à notre diagnostic en ligne personnalisé et évolutif\u003C\u002Fp\u003E\u003Cp class=\"detail-description-sub\"\u003EUn nouveau-né rejoint votre foyer ? Nous nous adaptons !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail col-xs-12 col-sm-4\"\u003E\u003Ch2\u003E2\u003C\u002Fh2\u003E\u003Cdiv class=\"detail-icon\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002Fgraphique.svg\"\u003E\u003C\u002Fdiv\u003E\u003Ch4 class=\"light\"\u003EMESURE\u003C\u002Fh4\u003E\u003Cp class=\"detail-description\"\u003ENotre algorithme exclusif permet d’affiner votre consommation réelle de manière plus juste\u003C\u002Fp\u003E\u003Cp class=\"detail-description-sub\"\u003EIl fait très froid ce mois-ci ? Nous le prenons en compte !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail col-xs-12 col-sm-4\"\u003E\u003Ch2\u003E3\u003C\u002Fh2\u003E\u003Cdiv class=\"detail-icon\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002Fcagnotte-plm_3.svg\"\u003E\u003C\u002Fdiv\u003E\u003Ch4 class=\"light\"\u003ERÉCOMPENSE\u003C\u002Fh4\u003E\u003Cp class=\"detail-description\"\u003EDès que votre consommation réelle est inférieure à la référence, nous créditons votre cagnotte\u003C\u002Fp\u003E\u003Cp class=\"detail-description-sub\"\u003EVous regardez votre cagnotte grandir mois après mois !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"transition-energetique-modal\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch2 class=\"marine\"\u003ELa transition énergétique,\u003Cbr\u003E qu’est-ce que c’est ?\u003C\u002Fh2\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002Frenouvelable.svg\"\u003E\u003Cp\u003EC’est d’une part accroître la production d’énergie renouvelable, mais surtout apprendre à consommer moins.\nParce que finalement, la meilleure énergie reste celle qu’on ne consomme pas.\u003C\u002Fp\u003E\u003Cp\u003EEn choisissant Plüm, vous prenez activement part à la transition énergétique.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


scrollSendEvent.$inject = ["$timeout", "gaEventsService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = scrollSendEvent;

/** @ngInject */

function scrollSendEvent($timeout, gaEventsService) {
    return {
        restrict: 'A',
        link: {
            post: function post(scope, element, attr) {
                var animate = function animate() {
                    var $window = (0, _jquery2.default)(window);
                    var elementOffsetBottom = element.offset().top + element.height() / 1.8;
                    var viewportBottom = $window.scrollTop() + $window.height();
                    if (viewportBottom >= elementOffsetBottom && !element.hasClass('event-sent')) {
                        element.addClass('event-sent');
                        return gaEventsService.newEvent(attr.scrollSendEvent);
                    }
                };

                (0, _jquery2.default)(window).on('scroll.scrollSendEvent', function () {
                    return animate();
                });

                $timeout(animate);

                return scope.$on('$destroy', function () {
                    return (0, _jquery2.default)(window).off('.scrollSendEvent');
                });
            }
        }
    };
}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


linkyModalCtrl.$inject = ["$scope", "$uibModalInstance"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = linkyModalCtrl;

/** @ngInject */

function linkyModalCtrl($scope, $uibModalInstance) {
    $scope.close = $uibModalInstance.dismiss;
}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


loginCtrl.$inject = ["$scope", "$q", "$uibModal", "$state", "$stateParams", "$window", "User", "ApiService", "AlertManager", "PotManager", "ContractService", "ContractDraft", "gaEventsService", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = loginCtrl;

/** @ngInject */

function loginCtrl($scope, $q, $uibModal, $state, $stateParams, $window, User, ApiService, AlertManager, PotManager, ContractService, ContractDraft, gaEventsService, ErrorCatcher) {
    $scope.gaEventsService = gaEventsService;
    $scope.user = {};
    $scope.fromCommunity = $stateParams.source === 'communaute';
    $scope.source = $stateParams.source;
    $scope.redirectTo = $stateParams.redirectTo;
    ApiService.resetPromise('userInfo');
    $scope.dataFeature = false;
    $scope.loginError = false;
    $scope.sendResetPasswd = false;
    $scope.sendResetPasswdSuccess = false;
    $scope.incorrectEmail = false;
    $scope.unknownError = false;
    $scope.isLogin = false;

    $scope.openSubscriptionModal = function () {
        gaEventsService.newEvent('click - Je souscris');
        $uibModal.open({
            animation: true,
            component: 'subscriptionModal',
            resolve: {
                stateParams: function stateParams() {
                    return {
                        source: $stateParams.source,
                        redirectTo: $stateParams.redirectTo
                    };
                }
            }
        });
    };

    $scope.sendResetPassword = function (user) {
        User.resetPassword({ email: user.username }).$promise.then(function () {
            $scope.sendResetPasswdSuccess = true;
        }).catch(function (error) {
            if (error.status === 400) {
                $scope.incorrectEmail = true;
            } else {
                $scope.unknownError = true;
            }
            ErrorCatcher.catchErrorWithoutRedirect(error);
        }).finally(function () {
            $scope.loginError = false;
            $scope.sendResetPasswd = true;
        });
    };

    $scope.login = function (user) {
        $scope.isLogin = true;
        $scope.loginError = false;
        var authenticate$ = User.authenticate(user).$promise;
        authenticate$.catch(function (error) {
            var message = error.data ? error.data.message : 'Erreur inconnue';
            $scope.loginError = true;
            $scope.isLogin = false;
            ErrorCatcher.catchErrorWithoutRedirect(error);
        });
        return authenticate$.then(function () {
            gaEventsService.newEvent('click - Login - success');

            // Clear data
            AlertManager.clearAlerts();
            ApiService.resetPromise('userInfo');
            ApiService.resetPromise('features');
            PotManager.resetPot();
            localStorage.removeItem('hideDashboard');
            localStorage.removeItem('subscriptionToken');

            var userInfo = ApiService.fetchUserInfo().catch(function (error) {
                ErrorCatcher.catchError(error);
                return {};
            });
            var contractDraft = ContractDraft.get({ create: false, silent: true }).$promise.catch(function (error) {
                ErrorCatcher.catchError(error);
                return {};
            });
            return $q.all({ userInfo: userInfo, contractDraft: contractDraft });
        }).then(function (values) {
            // Redirect rules
            if ($scope.redirectTo && $scope.redirectTo.startsWith('/')) {
                $window.location.href = $scope.redirectTo;
                return;
            } else if ($scope.redirectTo === 'endSubscription') {
                return $state.go($scope.redirectTo, $stateParams);
            } else if (values.contractDraft.ready_to_checkout) {
                return $state.go('subscriptionSummary');
            } else if (!(0, _isEmpty3.default)(ContractService.findFirstGoalNotDefinedContract(values.userInfo.contracts))) {
                return $state.go('endSubscription');
            } else if ($scope.fromCommunity) {
                if ($scope.redirectTo !== undefined && $scope.redirectTo !== 'undefined') {
                    $window.location.href = '/communaute' + $scope.redirectTo;
                    return;
                }
                return $state.go('community');
            } else if ($scope.redirectTo !== undefined) {
                return $state.go($scope.redirectTo, $stateParams);
            }
            var unpaidContract = ContractService.findFirstUnpaidContract(values.userInfo.contracts);
            if (!(0, _isEmpty3.default)(unpaidContract)) {
                return $state.go('invoice', { contractId: unpaidContract.id });
            }
            var selectedContract = ContractService.findFirstNotFinishedContract(values.userInfo.contracts);
            if (!(0, _isEmpty3.default)(selectedContract)) {
                return $state.go('account', { contractId: selectedContract.id });
            }
            if ((0, _isEmpty3.default)(values.userInfo.contracts)) {
                return $state.go('subscription', { bulk_purchase: $stateParams.bulk_purchase });
            }
            return $state.go('account');
        }).catch(function (error) {
            if (!error.message === 'transition prevented') {
                ErrorCatcher.catchErrorWithoutRedirect(error);
            }
        });
    };
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


landscapeCtrl.$inject = ["$scope", "$rootScope", "$q", "$uibModal", "$state", "$stateParams", "$window", "User", "ApiService", "AlertManager", "PotManager", "ContractService", "ContractDraft", "gaEventsService", "ErrorCatcher", "LandscapeQuestions"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = landscapeCtrl;

/** @ngInject */

function landscapeCtrl($scope, $rootScope, $q, $uibModal, $state, $stateParams, $window, User, ApiService, AlertManager, PotManager, ContractService, ContractDraft, gaEventsService, ErrorCatcher, LandscapeQuestions) {
    $scope.idContract = $stateParams.id;
    $scope.contract = { id: $scope.idContract, isDraft: true };
    return LandscapeQuestions.search({
        category: 'c-est-parti',
        id_contract: $stateParams.id,
        draft: true
    }).$promise.then(function (landscapeQuestions) {
        var isNew = false;
        if (landscapeQuestions && landscapeQuestions.length === 1) {
            if (landscapeQuestions[0][0].answer === undefined || landscapeQuestions[0][0].answer === '' || landscapeQuestions[0][0].answer === false) {
                isNew = true;
            }
        }
        var edit = $stateParams.edit;
        $scope.landscapeQuestions = landscapeQuestions;

        $scope.isEdition = { edition: edit, new: isNew };
        $scope.isEdition = edit;
        $scope.isNew = isNew;
        if (landscapeQuestions[0][0] && edit !== true) {
            var lastBlock = landscapeQuestions[landscapeQuestions.length - 1];
            if (lastBlock[Object.keys(lastBlock).length - 1] && lastBlock[Object.keys(lastBlock).length - 1].last) {
                window.dispatchEvent('landscapeDone');
                $scope.landscapeDone = true;
            }
        }
    });
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


logoutCtrl.$inject = ["LogoutService", "LogNavigation", "PermPermissionStore", "$window", "$state"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = logoutCtrl;

/** @ngInject */

function logoutCtrl(LogoutService, LogNavigation, PermPermissionStore, $window, $state) {
    return PermPermissionStore.getStore().user.validatePermission().then(function () {
        return LogNavigation.log({ url: $state.current.url }).$promise;
    }).then(function () {
        return LogoutService.logout();
    }).finally(function (err) {
        $window.location.href = "https://" + $window.location.host;
    });
}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


myMeterCtrl.$inject = ["$scope", "$state"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = myMeterCtrl;

/** @ngInject */

function myMeterCtrl($scope, $state) {
    $scope.isActive = function (state) {
        return state === $state.current.name;
    };
}

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navbarAccountCtrl.$inject = ["$scope", "$state"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navbarAccountCtrl;

/** @ngInject */

function navbarAccountCtrl($scope, $state) {
    $scope.navAccountCollapsed = true;

    $scope.isActive = function (state) {
        return $state.is(state);
    };

    $scope.getHeaderHeight = function () {
        var headerHeight = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Array.from(_angular2.default.element('.stickBelow'))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var header = _step.value;

                headerHeight += header.getBoundingClientRect().height;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return headerHeight;
    };

    $scope.toogleNavAccountCollapsed = function () {
        $scope.navAccountCollapsed = !$scope.navAccountCollapsed;
    };
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


offerCtrl.$inject = ["AlertManager", "$scope", "$state", "$uibModal"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
// This should be replaced by offer as soon as the client can access This
exports.default = offerCtrl;

/** @ngInject */

function offerCtrl(AlertManager, $scope, $state, $uibModal) {
    $scope.openLinkyModal = function () {
        return $uibModal.open({
            animation: true,
            size: 'lg',
            controller: 'linkyModalCtrl',
            template: __webpack_require__(288)()
        });
    };
}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


promoCtrl.$inject = ["$scope", "$state", "ContractDraft", "$stateParams"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = promoCtrl;

/** @ngInject */

function promoCtrl($scope, $state, ContractDraft, $stateParams) {
    localStorage.promoId = $stateParams.promoId.toUpperCase();

    return $state.go('landing');
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


proofOfResModalCtrl.$inject = ["$scope", "$state", "$uibModalInstance", "User", "contractId", "$http", "AlertManager"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = proofOfResModalCtrl;

/** @ngInject */

function proofOfResModalCtrl($scope, $state, $uibModalInstance, User, contractId, $http, AlertManager) {
    $scope.close = $uibModalInstance.close;
    $scope.people = null;
    $scope.civs = [];
    $scope.fns = [];
    $scope.lns = [];
    $scope.queryParams = '';
    $scope.contractId = contractId;

    $scope.addPerson = function () {
        $scope.people = $scope.people || [];

        if ($scope.people.length < 5) {
            return $scope.people.push({ fn: '', ln: '' });
        }
        return AlertManager.addAlert({ type: 'danger', msg: 'Vous ne pouvez pas ajouter plus de 5 personnes.' });
    };

    $scope.removePeople = function (index) {
        return $scope.people.splice(index, 1);
    };

    return $scope.$watch('people', function (people) {
        if (people && people.length > 0) {
            for (var i = 0, end = people.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                $scope.lns[i] = people[i].ln;
                $scope.civs[i] = people[i].civ;
                $scope.fns[i] = people[i].fn;
            }

            var fnsString = 'firstnames=' + $scope.fns.join(',');
            var lnsString = 'lastnames=' + $scope.lns.join(',');
            var civsString = 'civs=' + $scope.civs.join(',');
            return $scope.$evalAsync(function () {
                $scope.queryParams = '?' + fnsString + '&' + lnsString + '&' + civsString;
            });
        }
    }, true);
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


selfReportCtrl.$inject = ["$scope", "$state", "$stateParams", "SelfReport", "DeviceChecker", "ApiService", "PrmUtilsService", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set2 = __webpack_require__(204);

var _set3 = _interopRequireDefault(_set2);

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _castArray2 = __webpack_require__(295);

var _castArray3 = _interopRequireDefault(_castArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = selfReportCtrl;

/** @ngInject */

function selfReportCtrl($scope, $state, $stateParams, SelfReport, DeviceChecker, ApiService, PrmUtilsService, ErrorCatcher) {
    window.currentScope = $scope;
    $scope.isMobile = DeviceChecker.isMobile;
    $scope.currentStep = 'state-initial';
    $scope.viewState = {
        displayLocateCounter: false,
        housingType: '',
        counterType: '',
        counterNumber: 0,
        communicating: false,
        planType: '',
        error: null,
        errorMessages: null,
        releve: {
            base: undefined,
            hp: undefined,
            hc: undefined
        }
    };

    var planTypeReference = {
        BASE: 10,
        HPHC: 20
    };
    var arianeSteps = {
        cestParti: {
            current: 1,
            achievementStyle: { width: '0%' }
        },
        localiserLeCompteur: {
            current: 2,
            achievementStyle: { width: '27%' }
        },
        identifierLeCompteur: {
            current: 3,
            achievementStyle: { width: '52%' }
        },
        envoyerLaReleve: {
            current: 4,
            achievementStyle: { width: '77%' }
        },
        fin: {
            current: 5,
            achievementStyle: { width: '77%' }
        }
    };

    $scope.step = {
        'state-initial': {
            title: '',
            arianeStep: arianeSteps.cestParti,
            next: function next() {
                $scope.viewState.error = null;
                $scope.viewState.errorMessages = null;
                if ($scope.viewState.displayLocateCounter) {
                    if ($scope.viewState.housingType === 'house') {
                        // Premiere autoreleve OUI -Paysage energetique maison
                        $scope.currentStep = 'state-1-maison';
                    } else if ($scope.viewState.housingType === 'apartment') {
                        // Premiere autoreleve OUI -Paysage energetique immeuble
                        $scope.currentStep = 'state-1-immeuble';
                    }
                    // Premiere autoreleve OUI -Paysage energetique aucun
                    $scope.currentStep = 'state-1-unknown';
                } else if (PrmUtilsService.isEMC($scope.viewState.counterType) && $scope.viewState.planType === planTypeReference.BASE) {
                    $scope.currentStep = 'state-3-emc-base';
                } else if (PrmUtilsService.isEMC($scope.viewState.counterType) && $scope.viewState.planType === planTypeReference.HPHC) {
                    $scope.currentStep = 'state-3-emc-hc';
                } else if (PrmUtilsService.isCBE($scope.viewState.counterType) && $scope.viewState.planType === planTypeReference.BASE) {
                    $scope.currentStep = 'state-3-cbe-base';
                } else if (PrmUtilsService.isCBE($scope.viewState.counterType) && $scope.viewState.planType === planTypeReference.HPHC) {
                    $scope.currentStep = 'state-3-cbe-hp';
                } else if (PrmUtilsService.isLinky($scope.viewState.counterType) && !$scope.viewState.communicating && $scope.viewState.planType === planTypeReference.HPHC) {
                    $scope.currentStep = 'state-3-cbe-hp';
                } else if (PrmUtilsService.isLinky($scope.viewState.counterType) && !$scope.viewState.communicating && $scope.viewState.planType === planTypeReference.BASE) {
                    $scope.currentStep = 'state-3-cbe-base';
                } else if ($scope.viewState.communicating) {
                    $scope.currentStep = 'state-6-linky';
                } else {
                    $scope.step['state-initial'].nextError({ message: 'Impossible de déterminer le type de compteur' });
                }
            },
            nextError: function nextError(error) {
                $scope.viewState.error = error;
                $scope.viewState.errorMessages = (0, _castArray3.default)(error.data ? error.data.message : undefined);
                if ((error.data ? error.data.message : undefined) === 'Token non défini dans l’url') {
                    $scope.currentStep = 'state-error-token-invalid';
                } else if (__guard__(error.data ? error.data.message : undefined, function (x) {
                    return x.indexOf('"token" length must be 40 characters long');
                }) > -1) {
                    $scope.currentStep = 'state-error-token-invalid';
                } else if ((error.data ? error.data.message : undefined) === 'Le token a expiré.') {
                    $scope.currentStep = 'state-error-token-invalid';
                } else {
                    $scope.currentStep = 'state-error';
                    ErrorCatcher.catchError(error);
                }
            }
        },
        'state-1-maison': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.localiserLeCompteur,
            next: function next() {
                if (PrmUtilsService.isCBE($scope.viewState.counterType)) {
                    $scope.currentStep = 'state-2-cbe-find-counter';
                } else {
                    $scope.currentStep = 'state-2-emc-find-counter';
                }
            }
        },
        'state-1-immeuble': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.localiserLeCompteur,
            next: function next() {
                if (PrmUtilsService.isCBE($scope.viewState.counterType)) {
                    $scope.currentStep = 'state-2-cbe-find-counter';
                } else {
                    $scope.currentStep = 'state-2-emc-find-counter';
                }
            }
        },
        'state-1-unknown': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.localiserLeCompteur,
            next: function next() {
                if (PrmUtilsService.isCBE($scope.viewState.counterType)) {
                    $scope.currentStep = 'state-2-cbe-find-counter';
                } else {
                    $scope.currentStep = 'state-2-emc-find-counter';
                }
            }
        },
        'state-2-cbe-find-counter': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.identifierLeCompteur,
            imgValues: {
                illus_CBE_serial_1: function illus_CBE_serial_1() {
                    return $scope.viewState.counterNumber;
                },
                illus_CBE_serial_2: function illus_CBE_serial_2() {
                    return $scope.viewState.counterNumber;
                }
            },
            previous: function previous() {
                if ($scope.viewState.housingType === 'house') {
                    $scope.currentStep = 'state-1-maison';
                } else if ($scope.viewState.housingType === 'apartment') {
                    $scope.currentStep = 'state-1-immeuble';
                } else {
                    $scope.currentStep = 'state-1-unknown';
                }
            },
            next: function next() {
                $scope.viewState.displayLocateCounter = false;
                $scope.currentStep = 'state-initial';
                $scope.step['state-initial'].next();
            }
        },
        'state-2-emc-find-counter': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.identifierLeCompteur,
            imgValues: {
                illus_EMC_serial: function illus_EMC_serial() {
                    return $scope.viewState.counterNumber;
                }
            },
            previous: function previous() {
                if ($scope.viewState.housingType === 'house') {
                    $scope.currentStep = 'state-1-maison';
                } else if ($scope.viewState.housingType === 'apartment') {
                    $scope.currentStep = 'state-1-immeuble';
                } else {
                    $scope.currentStep = 'state-1-unknown';
                }
            },
            next: function next() {
                $scope.viewState.displayLocateCounter = false;
                $scope.currentStep = 'state-initial';
                $scope.step['state-initial'].next();
            }
        },
        'state-3-emc-base': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                EMC_base_reading: function EMC_base_reading() {
                    return $scope.viewState.releve.base;
                }
            },
            isValid: function isValid() {
                return $scope.viewState.releve.base > 0;
            },
            next: function next() {
                $scope.step['state-5-submitting'].next();
            }
        },
        'state-3-emc-hc': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                EMC_HC_reading: function EMC_HC_reading() {
                    return $scope.viewState.releve.hc;
                },
                EMC_HP_reading: function EMC_HP_reading() {
                    return $scope.viewState.releve.hp;
                }
            },
            isValid: function isValid() {
                return $scope.viewState.releve.hc > 0;
            },
            next: function next() {
                $scope.currentStep = 'state-4-emc-hp';
            }
        },
        'state-3-cbe-base': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                CBE_base_reading: function CBE_base_reading() {
                    return $scope.viewState.releve.base;
                }
            },
            isValid: function isValid() {
                return $scope.viewState.releve.base > 0;
            },
            next: function next() {
                $scope.step['state-5-submitting'].next();
            }
        },
        'state-3-cbe-hp': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                CBE_HC_reading: function CBE_HC_reading() {
                    return $scope.viewState.releve.hc;
                },
                CBE_HP_reading: function CBE_HP_reading() {
                    return $scope.viewState.releve.hp;
                }
            },
            isValid: function isValid() {
                return $scope.viewState.releve.hp > 0;
            },
            next: function next() {
                $scope.currentStep = 'state-4-cbe-hc';
            }
        },
        'state-4-emc-hp': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                EMC_HC_reading: function EMC_HC_reading() {
                    return $scope.viewState.releve.hc;
                },
                EMC_HP_reading: function EMC_HP_reading() {
                    return $scope.viewState.releve.hp;
                }
            },
            isValid: function isValid() {
                return $scope.viewState.releve.hp > 0;
            },
            previous: function previous() {
                $scope.currentStep = 'state-3-emc-hc';
            },
            next: function next() {
                $scope.step['state-5-submitting'].next();
            }
        },
        'state-4-cbe-hc': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                CBE_HC_reading: function CBE_HC_reading() {
                    return $scope.viewState.releve.hc;
                },
                CBE_HP_reading: function CBE_HP_reading() {
                    return $scope.viewState.releve.hp;
                }
            },
            isValid: function isValid() {
                return $scope.viewState.releve.hc > 0;
            },
            previous: function previous() {
                $scope.currentStep = 'state-3-cbe-hp';
            },
            next: function next() {
                $scope.step['state-5-submitting'].next();
            }
        },
        'state-5-submitting': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            next: function next(params) {
                $scope.currentStep = 'state-5-submitting';
                SelfReport.post({
                    token: $stateParams.token,
                    force: (0, _get3.default)(params, 'force', false)
                }, $scope.viewState.releve).$promise.then(function (response) {
                    if (response && response.status === 'SUCCESS') {
                        ApiService.resetPromise('userInfo');
                        $scope.currentStep = 'state-6-success';
                    } else if (response && response.status === 'WARNING') {
                        $scope.step['state-5-submitting'].nextError({
                            data: {
                                display: true,
                                message: response.message,
                                canForce: true
                            }
                        });
                    } else {
                        var message = void 0;
                        if (response && response.type) {
                            switch (response.type) {
                                case 'LINKY':
                                    message = 'Les auto-relèves ne sont pas acceptées pour les compteurs Linky.';
                                    break;
                                case 'ENEDIS':
                                    message = 'Une erreur technique est survenue lors de la transmission à Enedis.';
                                    break;
                                case 'CONS_INF_0':
                                    message = 'La relève saisie est inférieure à la dernière relève réelle. Nous vous recontacterons pour vous indiquer la marche à suivre.';
                                    break;
                                default:
                                    message = 'Une erreur technique est survenue.';
                            }
                        } else {
                            message = 'Une erreur technique est survenue.';
                        }
                        $scope.step['state-5-submitting'].nextError({
                            data: {
                                display: true,
                                message: message,
                                canForce: false
                            }
                        });
                    }
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    $scope.step['state-5-submitting'].nextError(error);
                });
            },
            nextError: function nextError(error) {
                $scope.viewState.error = error;
                $scope.viewState.errorMessages = (0, _castArray3.default)(error.data ? error.data.message : undefined);
                $scope.currentStep = (0, _get3.default)(error, 'data.canForce', false) ? 'state-warning-submit' : 'state-error-submit';
                ErrorCatcher.catchError(error);
            }
        },
        'state-6-success': {
            title: 'Auto relève',
            arianeStep: arianeSteps.fin,
            next: function next() {
                // Nothing to do
                $state.go('landing');
            }
        },
        'state-6-linky': {
            title: 'Auto relève',
            arianeStep: arianeSteps.fin,
            next: function next() {
                // Nothing to do
                $state.go('landing');
            }
        },
        'state-error': {
            title: 'Erreur au chargement',
            arianeStep: arianeSteps.cestParti
        },
        'state-error-token-invalid': {
            title: 'Lien invalide',
            arianeStep: arianeSteps.cestParti
        },
        'state-warning-submit': {
            title: 'Attention',
            arianeStep: arianeSteps.envoyerLaReleve,
            next: function next(params) {
                $scope.step['state-5-submitting'].next(params);
            }
        },
        'state-error-submit': {
            title: 'Echec',
            arianeStep: arianeSteps.envoyerLaReleve
        }
    };

    $scope.skipLocateCounter = {
        isVisible: function isVisible() {
            var visibleOnStep = ['state-1-maison', 'state-1-immeuble', 'state-1-unknown', 'state-2-cbe-find-counter', 'state-2-emc-find-counter'];
            return visibleOnStep.indexOf($scope.currentStep) > -1;
        },
        skip: function skip() {
            $scope.viewState.displayLocateCounter = false;
            $scope.currentStep = 'state-initial';
            $scope.step['state-initial'].next();
        }
    };

    $scope.localizeCounter = {
        isVisible: function isVisible() {
            var visibleOnStep = ['state-3-emc-base', 'state-3-emc-hc', 'state-3-cbe-base', 'state-3-cbe-hp'];
            return visibleOnStep.indexOf($scope.currentStep) > -1;
        },
        localize: function localize() {
            $scope.viewState.displayLocateCounter = true;
            $scope.currentStep = 'state-initial';
            $scope.step['state-initial'].next();
        }
    };

    var activate = function activate() {
        if ((0, _isEmpty3.default)($stateParams.token)) {
            var error = (0, _set3.default)({}, 'data.message', 'Token non défini dans l’url');
            $scope.step['state-initial'].nextError(error);
            ErrorCatcher.catchError(error);
        } else {
            SelfReport.get({ token: $stateParams.token }).$promise.then(function (result) {
                $scope.viewState.housingType = result.housing_king;
                $scope.viewState.displayLocateCounter = result.first;
                $scope.viewState.counterType = result.metter_kind;
                $scope.viewState.counterNumber = result.metter_number;
                $scope.viewState.communicating = result.communicating;
                $scope.viewState.planType = result.plan_id;
                $scope.step['state-initial'].next();
            }).catch(function (error) {
                $scope.step['state-initial'].nextError(error);
                ErrorCatcher.catchError(error);
            });
        }
    };

    activate();
}
function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map2 = __webpack_require__(53);

var _map3 = _interopRequireDefault(_map2);

var _isNumber2 = __webpack_require__(139);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _d = __webpack_require__(96);

var _d2 = _interopRequireDefault(_d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = selfReportImgValue;

/** @ngInject */

function selfReportImgValue() {
    return {
        restrict: 'A',
        scope: {
            ref: '@imgRef',
            values: '=?imgValues'
        },
        link: {
            post: function post(scope, element) {
                var INITIAL_COUNTER = '00000000';

                var watchValues = function watchValues(key) {
                    return function () {
                        return scope.values[key]();
                    };
                };

                var updateDisplayedValueFromObject = function updateDisplayedValueFromObject(key) {
                    return function (value) {
                        if (key === 'illus_CBE_serial_1') {
                            return element.find('#illus_CBE_serial_1').html('n\xB000 00 00 000 <tspan font-weight=\'bold\' fill=\'#2DC7C5\'>' + value + '</tspan> 00');
                        } else if (key === 'illus_CBE_serial_2') {
                            return element.find('#illus_CBE_serial_2').html('n\xB0X 000 <tspan font-weight=\'bold\' fill=\'#2DC7C5\'>' + value + '</tspan>');
                        } else if (key === 'illus_EMC_serial') {
                            return element.find('#illus_EMC_serial').html('n\xB0X 000 <tspan font-weight=\'bold\' fill=\'#2DC7C5\'>' + value + '</tspan>');
                        } else if ((0, _isNumber3.default)(value)) {
                            var emptyValue = INITIAL_COUNTER.slice(0, INITIAL_COUNTER.length - ('' + value).length);
                            var displayedValue = '<tspan font-weight=\'bold\' fill=\'#2DC7C5\'>' + value + '</tspan>';
                            return element.find('#' + key).html(emptyValue + displayedValue);
                        }
                        return element.find('#' + key).html('00000XXX');
                    };
                };

                // Cannot edit <img src='*.svg'>, need to load svg dynamically to edit it
                return _d2.default.xml(scope.ref, 'image/svg+xml', function (xml) {
                    element.html(xml.documentElement);
                    return function () {
                        (0, _map3.default)(scope.values, function (value, key) {
                            updateDisplayedValueFromObject(key)(value());
                            return scope.$watch(watchValues(key), updateDisplayedValueFromObject(key));
                        });
                    }();
                });
            }
        }
    };
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = selfReportStep;

/** @ngInject */

function selfReportStep() {
    return {
        restrict: 'E',
        template: __webpack_require__(885)()
    };
}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"state state-initial\" ng-if=\"currentStep === 'state-initial'\"\u003E\u003Ci class=\"spinner spinner-form\" ng-if=\"isMobile()\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-1-maison\" ng-if=\"currentStep === 'state-1-maison'\"\u003E\u003Ch3\u003E1. Localisez-le\u003C\u002Fh3\u003E\u003Cp\u003EVotre compteur peut être rangé dans un coffret ou un placard.\nPeut-être dans votre garage ou à l’entrée de votre maison ?\nSi vous ne le trouvez pas dans votre maison,\nil est peut-être à l’extérieur, encastré dans un muret.\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"step['state-1-maison'].next()\"\u003ESuivant\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"roundSide\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-1-immeuble\" ng-if=\"currentStep === 'state-1-immeuble'\"\u003E\u003Ch3\u003E1. Localisez-le\u003C\u002Fh3\u003E\u003Cp\u003EVotre compteur peut se cacher dans différentes pièces de votre logement.\nIl peut être rangé dans un coffret sur un de vos murs ou un placard, dans votre entrée ou votre cuisine ?\nAvez-vous vérifié sur votre palier ou dans le local technique en bas de votre immeuble ?\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"step['state-1-immeuble'].next()\"\u003ESuivant\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-1-unknown\" ng-if=\"currentStep === 'state-1-unknown'\"\u003E\u003Ch3\u003E1. Localisez-le\u003C\u002Fh3\u003E\u003Cp\u003EVotre compteur peut se cacher dans différentes pièces de votre habitation.\nIl peut être rangé dans un coffret sur un de vos murs ou un placard,\ndans votre entrée, sur votre palier ou dans le local technique ?\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"step['state-1-unknown'].next()\"\u003ESuivant\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-2-cbe-find-counter\" ng-if=\"currentStep === 'state-2-cbe-find-counter'\"\u003E\u003Cdiv class=\"find-counter-detail\"\u003E\u003Ch3\u003E2. Identifiez-le\u003C\u002Fh3\u003E\u003Cp\u003ELe « matricule » de votre compteur est le \u003Cspan class=\"counter-number\" ng-bind=\"viewState.counterNumber\"\u003E\u003C\u002Fspan\u003E.\nIl correspond aux trois derniers chiffres du numéro de série inscrit dessus.\nAttention, sur certains modèles, on trouve derrière le matricule deux chiffres qu’il faut ignorer.\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-if=\"!isMobile()\" ng-click=\"step[currentStep].previous()\"\u003ERetour\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"step[currentStep].next()\"\u003EJ'ai trouvé\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"find-counter-image\"\u003E\u003Cdiv ng-if=\"isMobile()\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002F2-billus-c-b-e.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-2-emc-find-counter\" ng-if=\"currentStep === 'state-2-emc-find-counter'\"\u003E\u003Cdiv class=\"find-counter-detail\"\u003E\u003Ch3\u003E2. Identifiez-le\u003C\u002Fh3\u003E\u003Cp\u003ELe « matricule » de votre compteur est le \u003Cspan class=\"counter-number\" ng-bind=\"viewState.counterNumber\"\u003E\u003C\u002Fspan\u003E.\nIl correspond aux trois derniers chiffres du numéro de série inscrit dessus.\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-if=\"!isMobile()\" ng-click=\"step[currentStep].previous()\"\u003ERetour\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"step[currentStep].next()\"\u003EJ'ai trouvé\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"find-counter-image\"\u003E\u003Cdiv ng-if=\"isMobile()\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002F2-aillus-e-m-c.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-3-emc-base\" ng-if=\"currentStep === 'state-3-emc-base'\"\u003E\u003Cdiv class=\"state-top\"\u003E\u003Ch3\u003EEnvoyer la relève\u003C\u002Fh3\u003E\u003Cp\u003ERelevez les 5 derniers chiffres du compteur.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-middle\" ng-if=\"isMobile()\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fe-m-c-base.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-bottom text-center\"\u003E\u003Cform class=\"text-center\"\u003E\u003Cdiv class=\"form-body\"\u003E\u003Clabel\u003Econsommation\u003C\u002Flabel\u003E\u003Cinput type=\"number\" pattern=\"[0-9]*\" required min=\"0\" max=\"999999\" maxlength=\"6\" ng-model=\"viewState.releve.base\" placeholder=\"XXX\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-disabled=\"!step['state-3-emc-base'].isValid()\" ng-click=\"step['state-3-emc-base'].next()\"\u003EJ’envoie\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-3-emc-hc\" ng-if=\"currentStep === 'state-3-emc-hc'\"\u003E\u003Cdiv class=\"state-top\"\u003E\u003Ch3\u003E1. Heures creuses\u003C\u002Fh3\u003E\u003Cp\u003ERelevez les 5 derniers chiffres du cadran supérieur correspondant aux heures creuses (HC).\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-middle\" ng-if=\"isMobile()\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fe-m-c-h-c.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-bottom text-center\"\u003E\u003Cform class=\"text-center\"\u003E\u003Cdiv class=\"form-body\"\u003E\u003Clabel\u003Eheures creuses\u003C\u002Flabel\u003E\u003Cinput type=\"number\" pattern=\"[0-9]*\" required min=\"0\" max=\"999999\" maxlength=\"6\" ng-model=\"viewState.releve.hc\" placeholder=\"XXX\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-disabled=\"!step['state-3-emc-hc'].isValid()\" ng-click=\"step['state-3-emc-hc'].next()\"\u003ESuivant\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-3-cbe-base\" ng-if=\"currentStep === 'state-3-cbe-base'\"\u003E\u003Cdiv class=\"state-top\"\u003E\u003Ch3\u003EEnvoyer la relève\u003C\u002Fh3\u003E\u003Cp\u003EAppuyez sur le bouton défilement (D) pour afficher le relevé.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-middle\" ng-if=\"isMobile()\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-base.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-bottom text-center\"\u003E\u003Cform class=\"text-center\"\u003E\u003Cdiv class=\"form-body\"\u003E\u003Clabel\u003Econsommation\u003C\u002Flabel\u003E\u003Cinput type=\"number\" pattern=\"[0-9]*\" required min=\"0\" max=\"999999\" maxlength=\"6\" ng-model=\"viewState.releve.base\" placeholder=\"XXX\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-disabled=\"!step['state-3-cbe-base'].isValid()\" ng-click=\"step['state-3-cbe-base'].next()\"\u003ESuivant\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-3-cbe-hp\" ng-if=\"currentStep === 'state-3-cbe-hp'\"\u003E\u003Cdiv class=\"state-top\"\u003E\u003Ch3\u003E1. Heures pleines\u003C\u002Fh3\u003E\u003Cp\u003EAppuyez une fois sur le bouton défilement (D) pour afficher le relevé, le mot \u003Cspan class=\"plan-type-pleine\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-h-p-text.svg\"\u003E\u003C\u002Fspan\u003E doit être affiché.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-middle\" ng-if=\"isMobile()\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-h-p.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-bottom text-center\"\u003E\u003Cform class=\"text-center\"\u003E\u003Cdiv class=\"form-body\"\u003E\u003Clabel\u003EHEURE \u003Cspan class=\"plan-type-pleine\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-h-p-text.svg\"\u003E\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003Cinput type=\"number\" pattern=\"[0-9]*\" required min=\"0\" max=\"999999\" maxlength=\"6\" ng-model=\"viewState.releve.hp\" placeholder=\"XXX\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-disabled=\"!step['state-3-cbe-hp'].isValid()\" ng-click=\"step['state-3-cbe-hp'].next()\"\u003ESuivant\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-4-emc-hp\" ng-if=\"currentStep === 'state-4-emc-hp'\"\u003E\u003Cdiv class=\"state-top\"\u003E\u003Ch3\u003E2. Heures pleines\u003C\u002Fh3\u003E\u003Cp\u003ERelevez les 5 derniers chiffres du cadran inférieur correspondant aux heures pleines (HP).\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-middle\" ng-if=\"isMobile()\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fe-m-c-h-p.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-bottom text-center\"\u003E\u003Cform class=\"text-center\"\u003E\u003Cdiv class=\"form-body\"\u003E\u003Clabel\u003Eheures pleines\u003C\u002Flabel\u003E\u003Cinput type=\"number\" pattern=\"[0-9]*\" required min=\"0\" max=\"999999\" maxlength=\"6\" ng-model=\"viewState.releve.hp\" placeholder=\"XXX\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn btn-same-width background-bluegrey\" ng-if=\"!isMobile()\" ng-click=\"step['state-4-emc-hp'].previous()\"\u003ERetour\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-waterblue\" ng-disabled=\"!step['state-4-emc-hp'].isValid()\" ng-click=\"step['state-4-emc-hp'].next()\"\u003EJ'envoie\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-4-cbe-hc\" ng-if=\"currentStep === 'state-4-cbe-hc'\"\u003E\u003Cdiv class=\"state-top\"\u003E\u003Ch3\u003E2. Heures creuses\u003C\u002Fh3\u003E\u003Cp\u003EAppuyez une fois sur le bouton défilement (D) pour afficher le relevé, le mot \u003Cspan class=\"plan-type-creuse\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-h-c-text.svg\"\u003E\u003C\u002Fspan\u003E doit être affiché.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-middle\" ng-if=\"isMobile()\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-h-c.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state-bottom text-center\"\u003E\u003Cform class=\"text-center\"\u003E\u003Cdiv class=\"form-body\"\u003E\u003Clabel\u003EHEURE \u003Cspan class=\"plan-type-creuse\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-h-c-text.svg\"\u003E\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003Cinput type=\"number\" pattern=\"[0-9]*\" required min=\"0\" max=\"999999\" maxlength=\"6\" ng-model=\"viewState.releve.hc\" placeholder=\"XXX\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn btn-same-width background-bluegrey\" ng-if=\"!isMobile()\" ng-click=\"step['state-4-cbe-hc'].previous()\"\u003ERetour\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-waterblue\" ng-disabled=\"!step['state-4-cbe-hc'].isValid()\" ng-click=\"step['state-4-cbe-hc'].next()\"\u003EJ'envoie\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-5-submitting\" ng-if=\"currentStep === 'state-5-submitting'\"\u003E\u003Ci class=\"spinner spinner-form\" ng-if=\"isMobile()\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-6-success\" ng-if=\"currentStep === 'state-6-success'\"\u003E\u003Cimg ng-if=\"isMobile()\" src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fdone.svg\"\u003E\u003Cp\u003EMerci.\u003Cbr\u003E Votre auto relève a bien été prise en compte.\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"step['state-6-success'].next()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-6-linky\" ng-if=\"currentStep === 'state-6-linky'\"\u003E\u003Cimg ng-if=\"isMobile()\" src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fdone.svg\"\u003E\u003Cp\u003EVous possédez un compteur linky communicant, vous n'avez pas besoin de relever votre compteur, la relève sera faite automatiquement.\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"step['state-6-success'].next()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-error\" ng-if=\"currentStep === 'state-error'\"\u003E\u003Cimg ng-if=\"isMobile()\" src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fclose.svg\"\u003E\u003Cp\u003EUne erreur s'est produite lors de la récupération des informations de relève.\u003C\u002Fp\u003E\u003Cp ng-if=\"viewState.error.data.display\" ng-bind=\"viewState.error.data.message\"\u003E\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez cependant continuer votre relève en accédant à votre espace client.\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink\" ui-sref=\"login\"\u003EAccédez à mon espace client\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-waterblue\" ng-click=\"step['state-6-success'].next()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-error-token-invalid\" ng-if=\"currentStep === 'state-error-token-invalid'\"\u003E\u003Cimg ng-if=\"isMobile()\" src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fclose.svg\"\u003E\u003Cp\u003ELe lien utilisé est invalide.\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez cependant continuer votre relève en accédant à votre espace client.\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink\" ui-sref=\"login\"\u003EAccédez à mon espace client\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-waterblue\" ng-click=\"step['state-6-success'].next()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-error-submit\" ng-if=\"currentStep === 'state-error-submit'\"\u003E\u003Cimg ng-if=\"isMobile()\" src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fclose.svg\"\u003E\u003Cp\u003EUne erreur s'est produite lors de l'envoi des informations\u003C\u002Fp\u003E\u003Cp ng-if=\"viewState.error.data.display\" ng-bind=\"viewState.error.data.message\"\u003E\u003C\u002Fp\u003E\u003Cp\u003EN'hésitez pas à accéder à votre espace client.\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink\" ui-sref=\"login\"\u003EEspace client\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-bluegrey\" ng-click=\"step['state-initial'].next()\"\u003ERectifier\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-waterblue\" ng-click=\"step['state-6-success'].next()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-warning-submit\" ng-if=\"currentStep === 'state-warning-submit'\"\u003E\u003Cimg ng-if=\"isMobile()\" src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fwarning.svg\"\u003E\u003Cp ng-if=\"viewState.error.data.display\" ng-repeat=\"msg in viewState.errorMessages\" ng-bind=\"msg\"\u003E\u003C\u002Fp\u003E\u003Cdiv class=\"action\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink\" ng-if=\"viewState.error.data.canForce\" ng-click=\"step['state-warning-submit'].next({force: true})\"\u003EJe suis sûr\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-bluegrey\" ng-click=\"step['state-initial'].next()\"\u003ECorriger\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-waterblue\" ng-click=\"step['state-6-success'].next()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = selfReportStepImage;

/** @ngInject */

function selfReportStepImage() {
    return {
        restrict: 'E',
        template: __webpack_require__(887)()
    };
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"state state-initial\" ng-if=\"currentStep === 'state-initial'\"\u003E\u003Ci class=\"spinner spinner-form\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-2-cbe-find-counter\" ng-if=\"currentStep === 'state-2-cbe-find-counter'\"\u003E\u003Cdiv class=\"self-report-img-value\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002F2-billus-c-b-e-desktop.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-2-emc-find-counter\" ng-if=\"currentStep === 'state-2-emc-find-counter'\"\u003E\u003Cdiv class=\"self-report-img-value\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002F2-aillus-e-m-c.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-3-emc-base\" ng-if=\"currentStep === 'state-3-emc-base'\"\u003E\u003Cdiv class=\"self-report-img-value\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fe-m-c-base.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-3-emc-hc\" ng-if=\"currentStep === 'state-3-emc-hc'\"\u003E\u003Cdiv class=\"self-report-img-value\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fe-m-c-h-c.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-3-cbe-base\" ng-if=\"currentStep === 'state-3-cbe-base'\"\u003E\u003Cdiv class=\"self-report-img-value\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-base.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-3-cbe-hp\" ng-if=\"currentStep === 'state-3-cbe-hp'\"\u003E\u003Cdiv class=\"self-report-img-value\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-h-p.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-4-emc-hp\" ng-if=\"currentStep === 'state-4-emc-hp'\"\u003E\u003Cdiv class=\"self-report-img-value\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fe-m-c-h-p.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-4-cbe-hc\" ng-if=\"currentStep === 'state-4-cbe-hc'\"\u003E\u003Cdiv class=\"self-report-img-value\" self-report-img-value img-ref=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fc-b-e-h-c.svg\" img-values=\"step[currentStep].imgValues\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-5-submitting\" ng-if=\"currentStep === 'state-5-submitting'\"\u003E\u003Ci class=\"spinner spinner-form\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-6-success\" ng-if=\"currentStep === 'state-6-success'\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fdone.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-6-linky\" ng-if=\"currentStep === 'state-6-linky'\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fdone.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-error\" ng-if=\"currentStep === 'state-error'\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fclose.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-error-token-invalid\" ng-if=\"currentStep === 'state-error-token-invalid'\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fclose.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-error-submit\" ng-if=\"currentStep === 'state-error-submit'\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fclose.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"state state-warning-submit\" ng-if=\"currentStep === 'state-warning-submit'\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002FselfReport\u002Fwarning.svg\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


signupCtrl.$inject = ["AlertManager", "$scope", "$location", "User", "$stateParams", "DeviceChecker", "RecaptchaKey", "MobilePhone", "gaEventsService", "CommonRegex", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty = __webpack_require__(14);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _assign = __webpack_require__(20);

var _assign2 = _interopRequireDefault(_assign);

var _noop = __webpack_require__(197);

var _noop2 = _interopRequireDefault(_noop);

var _get = __webpack_require__(8);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable
 */
exports.default = signupCtrl;

/** @ngInject */

function signupCtrl(AlertManager, $scope, $location, User, $stateParams, DeviceChecker, RecaptchaKey, MobilePhone, gaEventsService, CommonRegex, ErrorCatcher) {
  $scope.newUser = {};
  $scope.captcha = {
    key: RecaptchaKey[$location.host()]
  };
  $scope.signupForm = {
    form1: {
      $invalid: false,
      $setSubmitted: _noop2.default // Need to do it due to weird behavior
    } };
  $scope.isSignup = false;
  $scope.signedUp = false;
  $scope.signupError = { isError: false, code: '' };
  $scope.gaEventsService = gaEventsService;

  $scope.source = $stateParams.source;
  $scope.redirectTo = $stateParams.redirectTo;
  $scope.fromCommunity = $stateParams.source === 'communaute';

  $scope.isMobile = DeviceChecker.isMobile;
  $scope.phoneRegex = MobilePhone.phoneRegex.all;
  $scope.nameRegex = CommonRegex.fullname;

  if ($stateParams.parrainage) {
    localStorage.sponsorId = $stateParams.parrainage;
  }
  if ($stateParams.promo) {
    localStorage.promoId = $stateParams.promo.toUpperCase();
  }

  $scope.updateMobilePhone = function (phoneNumber) {
    $scope.newUser.phone = !(0, _isEmpty2.default)(phoneNumber) ? MobilePhone.formatPhoneToPlus33(phoneNumber) : undefined;
  };

  $scope.signUp = function (newUser) {
    var userForm = (0, _assign2.default)({}, newUser, {
      utm_source: localStorage.utm_source,
      utm_medium: localStorage.utm_medium,
      utm_campaign: localStorage.utm_campaign
    });
    $scope.signupError = { isError: false, code: '' };
    $scope.signupForm.form1.$setSubmitted();
    if ($scope.signupForm.form1.$invalid) {
      return;
    }

    $scope.isSignup = true;
    var signUp$ = User.signUp(userForm).$promise;
    return signUp$.then(function () {
      localStorage.removeItem('utm_source');
      localStorage.removeItem('utm_medium');
      localStorage.removeItem('utm_campaign');
      if ($scope.fromCommunity === true || $scope.redirectTo !== undefined) {
        localStorage.source = $stateParams.source;
        localStorage.redirectTo = $stateParams.redirectTo;
      }
      return $scope.signedUp = true;
    }).catch(function (error) {
      if (error.status === 409) {
        $scope.signupError = { isError: true, code: 'DUPLICATE_EMAIL' };
      } else if (!(0, _isEmpty2.default)((0, _get2.default)(error, 'data.message'))) {
        $scope.signupError = { isError: true, code: 'SERVICE_MSG', message: error.data.message };
      } else {
        $scope.signupError = { isError: true, code: 'DEFAULT_MSG' };
      }
      return ErrorCatcher.catchErrorWithoutRedirect(error);
    }).finally(function () {
      return $scope.isSignup = false;
    });
  };

  return $scope.newSignUp = function () {
    $scope.newUser = {};
    return $scope.signedUp = false;
  };
}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


sponsorCtrl.$inject = ["$scope", "$state", "ContractDraft", "$stateParams"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sponsorCtrl;

/** @ngInject */

function sponsorCtrl($scope, $state, ContractDraft, $stateParams) {
    localStorage.sponsorId = $stateParams.sponsorId;

    return $state.go('landing');
}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


subscriptionEndCtrl.$inject = ["$scope", "$stateParams"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subscriptionEndCtrl;

/** @ngInject */

function subscriptionEndCtrl($scope, $stateParams) {
    $scope.email = $stateParams.email;
}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


subscriptionSummaryCtrl.$inject = ["$scope", "$state", "ContractDraft", "MobilePhone", "ContactTelephone", "ErrorCatcher", "contractDraft", "timeline", "subscriptionToken"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _flow2 = __webpack_require__(312);

var _flow3 = _interopRequireDefault(_flow2);

var _startsWith2 = __webpack_require__(293);

var _startsWith3 = _interopRequireDefault(_startsWith2);

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = subscriptionSummaryCtrl;

/** @ngInject */

function subscriptionSummaryCtrl($scope, $state, ContractDraft, MobilePhone, ContactTelephone, ErrorCatcher, contractDraft, timeline, subscriptionToken) {
    $scope.isLoading = false;
    $scope.isDisplayedExtendedLegalNotice = false;
    $scope.contactTelephone = ContactTelephone;
    $scope.contractDraft = contractDraft;
    $scope.timeline = timeline;
    $scope.retractEndDate = (0, _moment2.default)().add(14, 'days');
    $scope.enablePayment = false;
    $scope.form = {
        hasConsentCurves: false,
        hasConsentIndex: false
    };

    $scope.goToPayment = function () {
        var _this = this;

        if ($scope.enablePayment !== true) {
            return;
        }
        var consentPayload = { consent_curves: $scope.form.hasConsentCurves, consent_index: $scope.form.hasConsentIndex };
        var updatePromise = (0, _isEmpty3.default)(subscriptionToken) ? ContractDraft.update({}, consentPayload).$promise : ContractDraft.updateByToken({ token: subscriptionToken }, consentPayload).$promise;
        $scope.isLoading = true;
        updatePromise.then(function () {
            var getPaymentIframePromise = (0, _isEmpty3.default)(subscriptionToken) ? ContractDraft.getPaymentIframe({ id: contractDraft.id }).$promise : ContractDraft.getPaymentIframeByToken({ id: contractDraft.id, token: subscriptionToken }).$promise;
            getPaymentIframePromise.then(function (response) {
                window.location = response.redirectUrl;
            }).catch(function (error) {
                ErrorCatcher.catchError(error);
            });
        }).catch(ErrorCatcher.catchError).finally(function () {
            _this.isLoading = false;
        });
    };

    $scope.getSleekSentence = function () {
        if (contractDraft.sleek_timetable) {
            return 'Liss\xE9, par p\xE9riodes de ' + (contractDraft.billing_modality === '12month' ? 12 : 6) + ' mois';
        }
        return 'Réel';
    };

    $scope.isShowroom = function () {
        return (0, _startsWith3.default)($scope.contractDraft.id_ref_promo, 'SRP');
    };

    $scope.formatTo0607 = (0, _flow3.default)(MobilePhone.formatPhoneTo0607, MobilePhone.formatPhoneToSpacePhone);

    $scope.formatCalendar = function (calendar) {
        return (0, _get3.default)({ BASE: 'Base', HPHC: 'Heures Pleines / Heures Creuses' }, calendar, calendar);
    };

    $scope.getAmountFromTimeline = function (timelineMonth) {
        return (0, _get3.default)(timelineMonth, contractDraft.sleek_timetable ? 'sleeked' : 'amount');
    };

    $scope.showExtendedLegalNotice = function () {
        $scope.isDisplayedExtendedLegalNotice = true;
    };

    // Get next Billing date (enedis reading date + 1 month)
    var getNextBillingDate = function getNextBillingDate() {
        return (0, _moment2.default)(contractDraft.nextBillableDate).add(15, 'day');
    };

    var computeEnedisPrestations = function computeEnedisPrestations() {
        return ContractDraft.computeEnedisPrestations(null, {
            id_contract: contractDraft.id,
            prestationType: contractDraft.subscription_type,
            specialReport: contractDraft.force_intervention,
            choosen_mes_type: contractDraft.choosen_mes_type || 'NORMAL',
            choosen_max_power: contractDraft.choosen_max_power || contractDraft.max_power,
            choosen_id_p_calendar: contractDraft.choosen_id_p_calendar || contractDraft.id_p_calendar
        }).$promise.then(function (prestation) {
            $scope.enedisPrestations = prestation;
        }).catch(function (error) {
            ErrorCatcher.catchError(error);
        });
    };

    var checkPromo = function checkPromo() {
        if ((0, _get3.default)($scope, 'contractDraft.id_ref_promo.length') > 0) {
            $scope.errorPromo = false;
            return ContractDraft.checkPromoOnDraft({ id_draft: contractDraft.id, promo: contractDraft.id_ref_promo, soft: true }).$promise.then(function () {
                return $scope.errorPromo;
            }).catch(function (error) {
                $scope.errorPromo = error;
            });
        }
    };

    var activate = function activate() {
        $scope.form.hasConsentIndex = !!(0, _get3.default)($scope.contractDraft, 'consent_index', null);
        $scope.form.hasConsentCurves = !!(0, _get3.default)($scope.contractDraft, 'consent_curves', null);
        $scope.currentMonthTimeline = (0, _get3.default)(timeline, 0);
        $scope.nextMonthTimeline = (0, _get3.default)(timeline, 1);
        $scope.nextBillingDate = getNextBillingDate();
        checkPromo();
        computeEnedisPrestations();
    };

    activate();
}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


anonPaymentSummaryCtrl.$inject = ["$scope", "$window", "$stateParams", "AnonPayment", "ContactTelephone", "ErrorCatcher", "paymentToken"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = anonPaymentSummaryCtrl;

/** @ngInject */

function anonPaymentSummaryCtrl($scope, $window, $stateParams, AnonPayment, ContactTelephone, ErrorCatcher, paymentToken) {
    $scope.contactTelephone = ContactTelephone;
    $scope.token = paymentToken;
    $scope.isLoading = false;
    $scope.error = null;

    $scope.goToPayment = function () {
        $scope.isLoading = true;
        $scope.error = null;
        AnonPayment.getRedirect({ tokenId: $stateParams.tokenId }).$promise.then(function (redirectResult) {
            $window.location = redirectResult.redirectUrl;
        }).catch(function (error) {
            ErrorCatcher.catchError(error);
            $scope.isLoading = false;
            $scope.error = error;
        });
    };
}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


anonTerminationSummaryCtrl.$inject = ["$state", "$scope", "$window", "$stateParams", "$uibModal", "AnonTermination", "ContactTelephone", "ErrorCatcher", "terminationToken", "cancel"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cloneDeep2 = __webpack_require__(316);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = anonTerminationSummaryCtrl;

/** @ngInject */

function anonTerminationSummaryCtrl($state, $scope, $window, $stateParams, $uibModal, AnonTermination, ContactTelephone, ErrorCatcher, terminationToken, cancel) {
    $scope.contactTelephone = ContactTelephone;
    $scope.token = terminationToken;
    $scope.isLoading = false;
    $scope.error = null;
    $scope.confirmed = false;
    $scope.cancelConfirmed = false;
    $scope.cancelMode = cancel;
    $scope.reason = {
        choice: null,
        text: ''
    };

    $scope.payload = {
        effectiveDate: (0, _moment2.default)(),
        enedisEstimation: false,
        reading: {}
    };

    $scope.effectiveDateMin = (0, _moment2.default)();
    $scope.effectiveDateMax = (0, _moment2.default)().add(42, 'day');
    $scope.maxLength = 6;

    var openErrorModal = function openErrorModal(error) {
        $uibModal.open({
            animation: true,
            size: 'lg',
            template: __webpack_require__(894)(),
            controller: ["$scope", "$uibModalInstance", function controller($scope, $uibModalInstance) {
                $scope.contactTelephone = ContactTelephone;
                $scope.error = error;

                switch (error.sgeCode) {
                    case 'SGT4B5':
                        $scope.errorCase = 'INDEX';
                        break;
                    case 'SGE500':
                    case 'SGT500':
                        $scope.errorCase = 'UNAVAILABLE';
                        break;
                    default:
                        $scope.errorCase = 'OTHER';
                }

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };
            }]
        });
    };

    var confirmation = function confirmation() {
        $scope.isLoading = true;
        $scope.error = null;
        var payload = (0, _cloneDeep3.default)($scope.payload);
        payload.effectiveDate = payload.effectiveDate.format('YYYY-MM-DD');
        if (payload.enedisEstimation) {
            delete payload.reading.hp;
            delete payload.reading.hc;
            delete payload.reading.base;
        }
        payload.reason = $scope.reason;
        AnonTermination.confirmTermination({ tokenId: $stateParams.tokenId }, payload).$promise.then(function (terminationResult) {
            var result = terminationResult.toJSON();
            if (result.success) {
                $scope.confirmed = true;
            } else if (result.sgeCode) {
                openErrorModal(result);
            } else {
                $scope.error = { data: result };
            }
        }).catch(function (error) {
            ErrorCatcher.catchError(error);
            $scope.error = error;
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    var uncheckEsti = function uncheckEsti() {
        $scope.payload.enedisEstimation = false;
    };

    var openConfirmModal = function openConfirmModal() {
        $uibModal.open({
            animation: true,
            size: 'lg',
            template: __webpack_require__(895)(),
            controller: ["$scope", "$uibModalInstance", function controller($scope, $uibModalInstance) {
                $scope.close = function () {
                    uncheckEsti();
                    $uibModalInstance.dismiss();
                };
                $scope.confirm = function () {
                    $uibModalInstance.dismiss();
                    confirmation();
                };
            }]
        });
    };

    $scope.confirmTermination = function () {
        if ($scope.payload.enedisEstimation && !terminationToken.migratedLinky) {
            openConfirmModal();
        } else {
            confirmation();
        }
    };

    $scope.cancelTermination = function () {
        $scope.error = null;
        AnonTermination.cancelTermination({ tokenId: $stateParams.tokenId }).$promise.then(function (redirectResult) {
            $scope.cancelConfirmed = true;
        }).catch(function (error) {
            ErrorCatcher.catchError(error);
            $scope.error = error;
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.isEffectiveDateValid = function () {
        return !$scope.token.migratedLinky || (0, _moment2.default)($scope.payload.effectiveDate).isBetween($scope.effectiveDateMin, $scope.effectiveDateMax, 'day', '[]');
    };

    $scope.canShoot = function () {
        return (terminationToken.migratedLinky || $scope.payload.enedisEstimation || terminationToken.id_p_calendar === 'BASE' && $scope.payload.reading.base || terminationToken.id_p_calendar === 'HPHC' && $scope.payload.reading.hp && $scope.payload.reading.hc) && $scope.reason.choice && ($scope.reason.choice !== 'OTHER' || $scope.reason.text) && $scope.isEffectiveDateValid();
    };
}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"subscription-form-modal\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\" ng-if=\"errorCase == 'UNAVAILABLE'\"\u003E\u003Ch4 class=\"marine\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E&nbsp;LE SERVEUR INFORMATIQUE D'ENEDIS NE RÉPOND PAS\u003C\u002Fh4\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cp\u003EL'outil informatique du gestionnaire public du réseau (ENEDIS) ne semble pas fonctionner en ce moment. Nous ne pouvons donc pas enregistrer votre résiliation.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cp\u003ERelancez votre demande dans quelques minutes.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ca class=\"btn background-light-pink\" ng-click=\"close()\"\u003EOK\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\" ng-if=\"errorCase == 'INDEX'\"\u003E\u003Ch4 class=\"marine\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E&nbsp;RELÈVE DU COMPTEUR REJETÉE PAR ENEDIS\u003C\u002Fh4\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cp\u003EEnedis a rejeté votre demande de résiliation à cause de la relève.\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez :\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli\u003ENous transmettre par email à&nbsp;\u003Ca class=\"underline\" ng-href=\"mailto:bonjour@plum.fr\"\u003Ebonjour@plum.fr\u003C\u002Fa\u003E&nbsp;une photo de votre compteur faisant bien apparaître la relève\u003C\u002Fli\u003E\u003Cli\u003EEnregistrer votre résiliation tout de suite sans fournir de relève\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ca class=\"btn background-light-pink\" ng-click=\"close()\"\u003ECORRIGER MA RELÈVE\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\" ng-if=\"errorCase == 'OTHER'\"\u003E\u003Ch4 class=\"marine\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E&nbsp;VOTRE DEMANDE DE RÉSILIATION N'A PU ABOUTIR\u003C\u002Fh4\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cp\u003EEnedis a rejeté votre demande de résiliation pour une raison inexpliquée. Celle-ci n'a donc pas été enregistrée.\u003C\u002Fp\u003E\u003Cp\u003ERelancez votre demande dans quelques minutes.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cp\u003ESi l'erreur se reproduit, merci de contacter le service client par mail&nbsp;\u003Ca class=\"underline\" ng-href=\"mailto:bonjour@plum.fr\"\u003Ebonjour@plum.fr\u003C\u002Fa\u003E&nbsp;ou par téléphone au&nbsp;\u003Ca class=\"underline\" ng-href=\"{{contactTelephone.anonymous.link}}\" ng-bind=\"contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ca class=\"btn background-light-pink\" ng-click=\"close()\"\u003ERETOUR FORMULAIRE\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"subscription-form-modal\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1 text-center\"\u003E\u003Ch4 class=\"marine\"\u003ECOMFIRMER\u003C\u002Fh4\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cp\u003ESi vous ne fournissez pas de relève, votre facture de clôture sera basée sur une estimation fournie par ENEDIS.\u003C\u002Fp\u003E\u003Cp\u003EJe confirme ne pas pouvoir indiquer la relève de mon compteur\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row margin-top-20\"\u003E\u003Cdiv class=\"col-xs-12 text-center\"\u003E\u003Ca class=\"btn background-marine\" ng-click=\"close()\"\u003EModifier mon choix\u003C\u002Fa\u003E\u003Ca class=\"btn background-light-pink\" ng-click=\"confirm()\"\u003EConfirmer\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _accountStatus = __webpack_require__(897);

var _accountStatus2 = _interopRequireDefault(_accountStatus);

var _accountStatusTimeline = __webpack_require__(899);

var _accountStatusTimeline2 = _interopRequireDefault(_accountStatusTimeline);

var _retractModal = __webpack_require__(901);

var _retractModal2 = _interopRequireDefault(_retractModal);

var _skipRetractModal = __webpack_require__(902);

var _skipRetractModal2 = _interopRequireDefault(_skipRetractModal);

var _account = __webpack_require__(903);

var _account2 = _interopRequireDefault(_account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.account', []).directive('accountStatus', _accountStatus2.default).directive('accountStatusTimeline', _accountStatusTimeline2.default).controller('retractModalCtrl', _retractModal2.default).controller('skipRetractModalCtrl', _skipRetractModal2.default).controller('accountCtrl', _account2.default).name;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


accountStatus.$inject = ["$compile", "$uibModal", "PermPermissionStore", "ContractStatusLabel", "ContactTelephone"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _has = __webpack_require__(101);

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = accountStatus;

/** @ngInject */

function accountStatus($compile, $uibModal, PermPermissionStore, ContractStatusLabel, ContactTelephone) {
    return {
        restrict: 'E',
        scope: {
            userContract: '=',
            isRetractable: '='
        },
        template: __webpack_require__(898)(),
        link: function link($scope) {
            $scope.isUnknownStatus = false;
            $scope.contactTelephone = ContactTelephone;
            var activate = function activate() {
                $scope.isUnknownStatus = !(0, _has2.default)(ContractStatusLabel, $scope.userContract.status);
            };

            $scope.openContactModal = function () {
                return $uibModal.open({
                    animation: true,
                    controller: 'contactModalCtrl',
                    template: __webpack_require__(140)(),
                    resolve: {
                        contractSelected: function contractSelected() {
                            return $scope.contractSelected;
                        },
                        userInfo: ["ApiService", function userInfo(ApiService) {
                            return __guard__(PermPermissionStore.getStore().client, function (x) {
                                return x.validatePermission().then(function () {
                                    return ApiService.fetchUserInfo();
                                }).catch(function () {
                                    return {};
                                });
                            });
                        }]
                    }
                });
            };

            return $scope.$watch('userContract', activate);
        }
    };
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 0 &amp;&amp; isRetractable\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ENous attendons la fin votre délai de rétractation pour transmettre votre commande à Enedis.\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 0 &amp;&amp; !isRetractable\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ECommande en cours de préparation par Plüm énergie\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 1\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EDemande transmise à Enedis.\u003Cbr\u003EVotre contrat sera actif d'ici 48h en moyenne\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 2\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EActif\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 3\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EUne de vos mensualités n'a pas été payée\u003Cbr\u003E\u003Ca ng-if=\"$root.dataFeature['invoice']\" ui-sref=\"invoice\"\u003EPlus de détails ici\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 4\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EContrat résilié\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 5\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EVotre compteur a été coupé suite à un incident de paiement\u003Cbr\u003E\u003Ca ng-if=\"$root.dataFeature['invoice']\" ui-sref=\"invoice\"\u003EPlus de détails ici\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 6\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ENotre système n'a pas retrouvé le statut de votre contrat\u003Cbr\u003E\u003Ca ng-click=\"openContactModal()\"\u003EContactez-nous pour que nous résolvions ce problème\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 9\"\u003E\u003Cp\u003ESTATUS DU CONTRACT :\u003C\u002Fp\u003EL'activation de votre contrat requiert une action de votre part.\nMerci de nous contacter \u003Ca ng-click=\"openContactModal()\"\u003Een cliquant ici\u003C\u002Fa\u003E.\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 10\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ECommande en cours de préparation par Plüm énergie\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 14\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EUne résiliation est en cours\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 15\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EUne coupure ou de limitation de votre compteur est en cours\u003Cbr\u003EAppelez notre service client pour trouver une solution, au\n\u003Ca ng-href=\"{{contactTelephone.client.link}}\"\u003E{{contactTelephone.client.label}}\u003C\u002Fa\u003E ({{contactTelephone.client.openingHour}}).\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 80 &amp;&amp; isRetractable\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ENous attendons la fin votre délai de rétractation pour transmettre votre commande à Enedis.\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 80 &amp;&amp; !isRetractable\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ECommande en cours de préparation par Plüm énergie\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 81\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EUne relève de votre compteur est nécessaire\nVous pouvez la saisir dans le tableau de bord en haut de l'espace client\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 82\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EL'activation de votre compteur nécessite l'intervention d'un technicien Enedis.\u003Cp\u003EPour prendre rendez-vous et activer rapidement votre contrat, suivez les instructions indiquées dans le mail ou le sms que vous avez reçu.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 83\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EL'activation de votre compteur nécessite l'intervention d'un technicien Enedis.\u003Cp\u003EPour prendre rendez-vous et activer rapidement votre contrat, suivez les instructions indiquées dans le mail ou le sms que vous avez reçu.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 90\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ECommande annulée le {{userContract.retraction_end_date | date: 'dd\u002FMM\u002Fyyyy'}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 91\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ECommande annulée le {{userContract.retraction_end_date | date: 'dd\u002FMM\u002Fyyyy'}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"userContract.status === 92\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003EVotre commande est bloquée en attente d'une action de votre part.\nSi vous souhaitez la débloquer, appelez notre service client au\n\u003Ca ng-href=\"{{contactTelephone.client.link}}\"\u003E{{contactTelephone.client.label}}\u003C\u002Fa\u003E ({{contactTelephone.client.openingHour}}).\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"isUnknownStatus\"\u003E\u003Cp\u003ESTATUT DU CONTRAT :\u003C\u002Fp\u003ECommande en cours de traitement par Plüm énergie\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


accountStatusTimeline.$inject = ["DeviceChecker", "ContractStatusLabel"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = __webpack_require__(8);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = accountStatusTimeline;

/** @ngInject */

function accountStatusTimeline(DeviceChecker, ContractStatusLabel) {
    return {
        restrict: 'E',
        scope: {
            userContract: '<',
            displayTitle: '<'
        },
        template: __webpack_require__(900)(),
        link: function link($scope) {
            var TIMELINE_STEP = {
                DISABLED: 0,
                PRISE_DE_COMMANDE: 1,
                VALIDATION_DE_LA_COMMANDE: 2,
                ACTIVATION_DE_LA_COMMANDE: 3,
                CONTRAT_ACTIF: 4
            };

            $scope.isTimelineVisible = false;
            $scope.statusColor2 = false;
            $scope.status2 = false;
            $scope.statusColor3 = false;
            $scope.status3 = false;
            $scope.status4 = false;

            $scope.isTab = DeviceChecker.isTab;

            var activate = function activate() {
                var contractStatus = (0, _get2.default)(ContractStatusLabel, [$scope.userContract.status], ContractStatusLabel.unknown);
                $scope.currentTimelineStep = contractStatus.timelineStep;
                $scope.stepName1 = contractStatus.isWaitingAction ? 'EN ATTENTE' : 'EN PREPARATION';

                switch ($scope.currentTimelineStep) {
                    case TIMELINE_STEP.DISABLED:
                        $scope.isTimelineVisible = false;
                        $scope.status2 = false;
                        $scope.statusColor2 = false;
                        $scope.status3 = false;
                        $scope.statusColor3 = false;
                        $scope.status4 = false;
                        break;
                    case TIMELINE_STEP.PRISE_DE_COMMANDE:
                        $scope.isTimelineVisible = true;
                        $scope.status2 = false;
                        $scope.statusColor2 = false;
                        $scope.status3 = false;
                        $scope.statusColor3 = false;
                        $scope.status4 = false;
                        break;
                    case TIMELINE_STEP.VALIDATION_DE_LA_COMMANDE:
                        $scope.isTimelineVisible = true;
                        $scope.status2 = true;
                        $scope.statusColor2 = true;
                        $scope.status3 = false;
                        $scope.statusColor3 = false;
                        $scope.status4 = false;
                        break;
                    case TIMELINE_STEP.ACTIVATION_DE_LA_COMMANDE:
                        $scope.isTimelineVisible = true;
                        $scope.status2 = true;
                        $scope.statusColor2 = true;
                        $scope.status3 = true;
                        $scope.statusColor3 = true;
                        $scope.status4 = false;
                        break;
                    case TIMELINE_STEP.CONTRAT_ACTIF:
                        $scope.isTimelineVisible = true;
                        $scope.status2 = true;
                        $scope.statusColor2 = true;
                        $scope.status3 = true;
                        $scope.statusColor3 = true;
                        $scope.status4 = true;
                        break;
                    default:
                        $scope.isTimelineVisible = false;
                        $scope.status2 = false;
                        $scope.statusColor2 = false;
                        $scope.status3 = false;
                        $scope.statusColor3 = false;
                        $scope.status4 = false;
                        break;
                }
            };

            activate();
            $scope.$watch('userContract', activate);
        }
    };
}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cspan ng-if=\"$root.dataFeature['accountStatus'] &amp;&amp; isTimelineVisible\"\u003E\u003Cdiv ng-if=\"!status4\"\u003E\u003Cdiv class=\"text-center\" ng-if=\"displayTitle\"\u003E\u003Ch3 class=\"paddingl20 marginb30\"\u003ESuivi de ma commande\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Cdiv class=\"account-status-timeline margin-top-30\"\u003E\u003Cul class=\"ariane-steps ariane-white\"\u003E\u003Cspan class=\"ariane-string\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"ariane-string-achievement\" step-value=\"{{currentTimelineStep}}\"\u003E\u003C\u002Fspan\u003E\u003Cli class=\"ariane-step\" ng-class=\"{'ariane-step-done' : currentTimelineStep &gt; 0, 'ariane-step-active' : currentTimelineStep === 0}\"\u003E\u003Cspan class=\"ariane-tick\"\u003E\u003C\u002Fspan\u003E\u003Clabel class=\"ariane-step-label\"\u003E{{stepName1}}\u003C\u002Flabel\u003E\u003C\u002Fli\u003E\u003Cli class=\"ariane-step\" ng-class=\"{'ariane-step-done' : currentTimelineStep &gt; 1, 'ariane-step-active' : currentTimelineStep === 1}\"\u003E\u003Cspan class=\"ariane-tick\"\u003E\u003C\u002Fspan\u003E\u003Clabel class=\"ariane-step-label\"\u003EEN TRAITEMENT\u003C\u002Flabel\u003E\u003C\u002Fli\u003E\u003Cli class=\"ariane-step\" ng-class=\"{'ariane-step-done' : currentTimelineStep &gt; 2, 'ariane-step-active' : currentTimelineStep === 2}\"\u003E\u003Cspan class=\"ariane-tick\"\u003E\u003C\u002Fspan\u003E\u003Clabel class=\"ariane-step-label\"\u003ECONTRAT ACTIF\u003C\u002Flabel\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row text-center marginb15 visible-xs-block visible-sm-block\"\u003E\u003Cdiv class=\"status-steps-mob\" ng-class=\"{'': isTab()}\"\u003E\u003Cdiv class=\"col-md-1 col-md-offset-1 col-xs-2 col-xs-offset-1 col-sm-2 col-sm-offset-0 no-padding z-index\"\u003E\u003Cimg class=\"bg-white\" alt=\"checked status\" src=\"\u002Fassets\u002Fimg\u002Fcheck-status.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-3 col-xs-9 col-sm-10 text-left bidule-green hidden-md hidden-lg\"\u003E\u003Cp\u003EPRISE DE COMMANDE\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"status-steps-mob\" ng-class=\"{'status-steps-mob': isTab()}\"\u003E\u003Cdiv class=\"col-md-2 no-padding hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"bidule-line no-padding\" ng-class=\"{'bidule-bg-green': statusColor2, 'bidule-bg-grey': !statusColor2}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-1 col-md-offset-0 col-xs-2 col-xs-offset-1 col-sm-2 col-sm-offset-0 no-padding z-index\" ng-if=\"status2\"\u003E\u003Cimg class=\"bg-white\" alt=\"checked status\" src=\"\u002Fassets\u002Fimg\u002Fcheck-status.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-1 col-md-offset-0 col-xs-2 col-xs-offset-1 col-sm-2 col-sm-offset-0\" ng-if=\"!status2\"\u003E\u003Cimg class=\"padding-endpoint1 hidden-xs hidden-sm\" alt=\"unchecked status\" src=\"\u002Fassets\u002Fimg\u002Fendpoint2.png\"\u003E\u003Cimg class=\"hidden-md hidden-lg\" alt=\"unchecked status\" src=\"\u002Fassets\u002Fimg\u002Fendpoint-mob.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-3 col-xs-9 col-sm-10 text-left hidden-md hidden-lg\" ng-class=\"{'bidule-green': statusColor2, 'bidule-grey': !statusColor2}\"\u003E\u003Cp\u003EVALIDATION DE LA COMMANDE\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"status-steps-mob\" ng-class=\"{'status-steps-mob': isTab()}\"\u003E\u003Cdiv class=\"col-md-2 no-padding hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"bidule-line no-padding\" ng-class=\"{'bidule-bg-green': statusColor3, 'bidule-bg-grey': !statusColor3}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-1 col-md-offset-0 col-xs-2 col-xs-offset-1 col-sm-2 col-sm-offset-0 no-padding z-index\" ng-if=\"status3\"\u003E\u003Cimg class=\"bg-white\" alt=\"checked status\" src=\"\u002Fassets\u002Fimg\u002Fcheck-status.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-1 col-md-offset-0 col-xs-2 col-xs-offset-1 col-sm-2 col-sm-offset-0\" ng-if=\"!status3\"\u003E\u003Cimg class=\"padding-endpoint1 hidden-xs hidden-sm\" alt=\"unchecked status\" src=\"\u002Fassets\u002Fimg\u002Fendpoint2.png\"\u003E\u003Cimg class=\"hidden-md hidden-lg\" alt=\"unchecked status\" src=\"\u002Fassets\u002Fimg\u002Fendpoint-mob.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-3 col-xs-9 col-sm-10 text-left hidden-md hidden-lg\" ng-class=\"{'bidule-green': statusColor3, 'bidule-grey': !statusColor3}\"\u003E\u003Cp\u003EACTIVATION DE LA COMMANDE\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"status-steps-mob\" ng-class=\"{'status-steps-mob': isTab()}\"\u003E\u003Cdiv class=\"col-md-2 no-padding hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"bidule-line no-padding bidule-bg-grey\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-1 col-md-offset-0 col-xs-2 col-xs-offset-1 col-sm-2 col-sm-offset-0\"\u003E\u003Cimg class=\"padding-endpoint1 hidden-xs hidden-sm\" alt=\"checked status\" src=\"\u002Fassets\u002Fimg\u002Fendpoint3.png\"\u003E\u003Cimg class=\"hidden-md hidden-lg\" alt=\"unchecked status\" src=\"\u002Fassets\u002Fimg\u002Fendpoint-mob.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-3 col-xs-9 col-sm-10 text-left hidden-md hidden-lg bidule-grey\"\u003E\u003Cp\u003ECOMPTE ACTIF\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row text-center\" ng-if=\"status4\"\u003E\u003Cdiv class=\"col-md-6 col-md-offset-3 marginb15\"\u003E\u003Cimg alt=\"check status\" src=\"\u002Fassets\u002Fimg\u002Fcheck-status.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-4 col-md-offset-4 margin-bottom-30 bidule-green\"\u003E\u003Cp\u003ECONTRAT ACTIF\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


retractModalCtrl.$inject = ["$scope", "$rootScope", "$state", "$uibModalInstance", "Contract", "contractId", "AlertManager", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = retractModalCtrl;

/** @ngInject */

function retractModalCtrl($scope, $rootScope, $state, $uibModalInstance, Contract, contractId, AlertManager, ErrorCatcher) {
    $scope.close = $uibModalInstance.dismiss;

    $scope.confirmRetractation = function () {
        return Contract.retract({ id: contractId }).$promise.then(function (response) {
            window.location.reload();
            $scope.close();
        }).catch(function (error) {
            AlertManager.addAlert({
                type: 'error',
                msg: 'Une erreur s\'est produite. Essayer de recharger la page. ' + error.data.message,
                timeout: 30000
            });
            return ErrorCatcher.catchError(error);
        });
    };
}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


skipRetractModalCtrl.$inject = ["$scope", "$rootScope", "$state", "$uibModalInstance", "Contract", "contractId", "AlertManager", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = skipRetractModalCtrl;

/** @ngInject */

function skipRetractModalCtrl($scope, $rootScope, $state, $uibModalInstance, Contract, contractId, AlertManager, ErrorCatcher) {
    $scope.close = $uibModalInstance.dismiss;

    $scope.confirmSkipRetractation = function () {
        return Contract.bypassRetraction({ id: contractId }).$promise.then(function (response) {
            window.location.reload();
            $scope.close();
        }).catch(function (error) {
            console.error(error);
            AlertManager.addAlert({
                type: 'error',
                msg: 'Une erreur s\'est produite. Essayer de recharger la page. ' + error.data.message,
                timeout: 30000
            });
            return ErrorCatcher.catchError(error);
        });
    };
}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


accountCtrl.$inject = ["ApiService", "User", "$scope", "userInfo", "DeviceChecker", "$uibModal", "billingAddress", "$state", "featuresService", "BillingAddress", "$rootScope", "$window", "DataAccessVariables", "ContractStatus", "AnonTermination", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = accountCtrl;

/** @ngInject */

function accountCtrl(ApiService, User, $scope, userInfo, DeviceChecker, $uibModal, billingAddress, $state, featuresService, BillingAddress, $rootScope, $window, DataAccessVariables, ContractStatus, AnonTermination, ErrorCatcher) {
    $scope.modifyBillAdd = false;
    $scope.selectorBillAdd = false;
    $scope.enableBtnSaveBillAdd = false;
    $scope.showNewBillAddUnsave = false;
    $scope.newBillAdd = '';
    $scope.sponsorFee = null;
    $scope.sponsoredFee = null;

    $scope.isTab = DeviceChecker.isTab;
    $scope.isDesktop = DeviceChecker.isDesktop;

    $scope.userBillingAddress = billingAddress;
    $scope.userContract = userInfo.contractSelected;

    $scope.startContractDate = userInfo.contractSelected.commissioning_date ? userInfo.contractSelected.commissioning_date : userInfo.contractSelected.retraction_end_date;
    $scope.isRetractable = _moment2.default.utc().isBefore(userInfo.contractSelected.retraction_end_date);

    $scope.sponsorUrl = $window.location.origin + '/parrainage/' + userInfo.customer_id;

    $scope.openRetractModal = function () {
        $uibModal.open({
            animation: true,
            size: 'md',
            controller: 'retractModalCtrl',
            template: __webpack_require__(904)(),
            resolve: {
                contractId: function contractId() {
                    return $scope.userContract.id;
                }
            }
        });
    };

    $scope.openSkipRetractModal = function () {
        $uibModal.open({
            animation: true,
            size: 'md',
            controller: 'skipRetractModalCtrl',
            template: __webpack_require__(905)(),
            resolve: {
                contractId: function contractId() {
                    return $scope.userContract.id;
                }
            }
        });
    };

    $scope.openProofOfResModal = function () {
        $uibModal.open({
            animation: true,
            size: 'md',
            controller: 'proofOfResModalCtrl',
            template: __webpack_require__(323)(),
            resolve: {
                contractId: function contractId() {
                    return $scope.userContract.id;
                }
            }
        });
    };

    $scope.isUserContractCanRetract = function () {
        return [ContractStatus.initial, ContractStatus.enAttenteEcheancier].indexOf(userInfo.contractSelected.status) > -1 && $scope.isRetractable;
    };

    $scope.isUserContractActive = function () {
        return userInfo.contractSelected.status === ContractStatus.enService;
    };

    $scope.canTerminate = function () {
        return [ContractStatus.enService, ContractStatus.coupe, ContractStatus.coupureDemande].indexOf($scope.userContract.status) > -1;
    };

    $scope.canDownloadContractCertificate = function () {
        return [ContractStatus.resilie, ContractStatus.duplicat, ContractStatus.retracte, ContractStatus.annule].indexOf($scope.userContract.status) === -1;
    };

    $scope.showInputBillAdd = function () {
        $scope.modifyBillAdd = !$scope.modifyBillAdd;
    };

    $scope.refreshAddresses = function (search) {
        if (search !== '') {
            BillingAddress.showBillAddresses({ q: search }).$promise.then(function (response) {
                $scope.billAddresses = response;
            }).catch(ErrorCatcher.catchError);
        }
        if (search === '') {
            $scope.billAddresses = [];
        }
    };

    $scope.selectLabel = function (element) {
        $scope.enableBtnSaveBillAdd = true;
        $scope.showNewBillAddUnsave = true;
        $scope.newBillAddSelected = element;
    };

    $scope.cancelModifyBillAdd = function () {
        $scope.newBillAddSelected = '';
        $scope.billAddresses = '';
        $scope.showNewBillAddUnsave = false;
        $scope.enableBtnSaveBillAdd = false;
        $scope.modifyBillAdd = !$scope.modifyBillAdd;
    };

    $scope.saveBillAdd = function (element) {
        var newBillAdd = {
            addr_city_code: element.addr_city_code,
            addr_city_lbl: element.addr_city_lbl,
            addr_num_street: element.addr_num_street,
            addr_post_code: element.addr_post_code,
            addr_details: element.addr_details,
            addr_locality: element.addr_locality,
            addr_bat: element.addr_bat
        };
        return User.saveNewBillingAddress(newBillAdd).$promise.then(function (response) {
            $scope.showNewBillAddUnsave = false;
            return window.location.reload();
        }).catch(ErrorCatcher.catchError);
    };

    $scope.redirectToTerminate = function () {
        AnonTermination.createTerminationToken({ id_contract: $scope.userContract.id }, {}).$promise.then(function (tokenResult) {
            $state.go('anonTerminationSummary', { tokenId: tokenResult.tokenId });
        }).catch(function (error) {
            if (!error.message === 'transition prevented') {
                ErrorCatcher.catchErrorWithoutRedirect(error);
            }
        });
    };

    $scope.billingModalityMapper = {
        '2month': 'Bimestrielle',
        '6month': 'Semestrielle',
        '12month': 'Annuelle'
    };

    var activate = function activate() {
        DataAccessVariables.get({ variables: 'SPONSOR_FEE,SPONSORED_FEE' }).$promise.then(function (response) {
            $scope.sponsorFee = response.SPONSOR_FEE;
            $scope.sponsoredFee = response.SPONSORED_FEE;
        });
    };

    activate();
}

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cimg class=\"close-modal\" src=\"\u002Fassets\u002Fimg\u002Fp-l-u-m-bouton-close.png\" ng-click=\"close()\"\u003E\u003Cdiv class=\"text-center offer-bloc\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1 text-center\"\u003E\u003Ch1 class=\"light darkish-pink\"\u003EConfirmer l'annulation de ma commande\u003C\u002Fh1\u003E\u003Cp class=\"margin-top-20\"\u003ESi je clique sur le bouton \"Confirmer\", ma commande sera annulée.\nMon contrat d'électricité continuera d'être géré par mon ancien fournisseur.\u003C\u002Fp\u003E\u003Cdiv class=\"col-xs-3 col-xs-offset-2 text-center\"\u003E\u003Cbutton class=\"btn btn-lg background-bluegrey\" ng-click=\"close()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3 col-xs-offset-2 text-center\"\u003E\u003Cbutton class=\"btn btn-lg background-waterblue\" ng-click=\"confirmRetractation()\"\u003EConfirmer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cimg class=\"close-modal\" src=\"\u002Fassets\u002Fimg\u002Fp-l-u-m-bouton-close.png\" ng-click=\"close()\"\u003E\u003Cdiv class=\"text-center offer-bloc\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1 text-center\"\u003E\u003Ch1 class=\"light darkish-pink\"\u003ELancer ma commande tout de suite\u003C\u002Fh1\u003E\u003Cp class=\"margin-top-20\"\u003EJe souhaite renoncer à ma période de rétractation.\nL'activation de mon compteur se fera dans les prochaines 48 heures.\u003C\u002Fp\u003E\u003Cdiv class=\"col-xs-3 col-xs-offset-2 text-center\"\u003E\u003Cbutton class=\"btn btn-lg background-bluegrey\" ng-click=\"close()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3 col-xs-offset-2 text-center\"\u003E\u003Cbutton class=\"btn btn-lg background-waterblue\" ng-click=\"confirmSkipRetractation()\"\u003EConfirmer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _endSubscriptionErrorNoContract = __webpack_require__(907);

var _endSubscriptionErrorNoContract2 = _interopRequireDefault(_endSubscriptionErrorNoContract);

var _endSubscriptionErrorOther = __webpack_require__(909);

var _endSubscriptionErrorOther2 = _interopRequireDefault(_endSubscriptionErrorOther);

var _endSubscriptionErrorPaymentRefused = __webpack_require__(911);

var _endSubscriptionErrorPaymentRefused2 = _interopRequireDefault(_endSubscriptionErrorPaymentRefused);

var _endSubscriptionGoalForm = __webpack_require__(913);

var _endSubscriptionGoalForm2 = _interopRequireDefault(_endSubscriptionGoalForm);

var _endSubscriptionInitial = __webpack_require__(915);

var _endSubscriptionInitial2 = _interopRequireDefault(_endSubscriptionInitial);

var _endSubscriptionRetractionForm = __webpack_require__(917);

var _endSubscriptionRetractionForm2 = _interopRequireDefault(_endSubscriptionRetractionForm);

var _endSubscriptionFinish = __webpack_require__(919);

var _endSubscriptionFinish2 = _interopRequireDefault(_endSubscriptionFinish);

var _endSubscription = __webpack_require__(921);

var _endSubscription2 = _interopRequireDefault(_endSubscription);

var _endSubscriptionSlimpayError = __webpack_require__(922);

var _endSubscriptionSlimpayError2 = _interopRequireDefault(_endSubscriptionSlimpayError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.endSubscription', []).component('endSubscriptionErrorNoContract', _endSubscriptionErrorNoContract2.default).component('endSubscriptionErrorOther', _endSubscriptionErrorOther2.default).component('endSubscriptionErrorPaymentRefused', _endSubscriptionErrorPaymentRefused2.default).component('endSubscriptionGoalForm', _endSubscriptionGoalForm2.default).component('endSubscriptionInitial', _endSubscriptionInitial2.default).component('endSubscriptionRetractionForm', _endSubscriptionRetractionForm2.default).component('endSubscriptionFinish', _endSubscriptionFinish2.default).controller('endSubscriptionCtrl', _endSubscription2.default).controller('endSubscriptionSlimpayErrorCtrl', _endSubscriptionSlimpayError2.default).name;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endSubscriptionErrorNoContract = {
    bindings: {},
    template: __webpack_require__(908)(),
    /** @ngInject */controller: ["MailAdresses", "ContactTelephone", function controller(MailAdresses, ContactTelephone) {
        var ctrl = this;
        ctrl.MailAdresses = MailAdresses;
        ctrl.contactTelephone = ContactTelephone.anonymous;
    }]
};

exports.default = endSubscriptionErrorNoContract;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EOUPS !\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cp\u003EAucun contrat à finaliser n'a été trouvé. Vous pouvez reprendre votre commande ou revenir sur la page d'accueil.\u003C\u002Fp\u003E\u003Cp\u003ESi cette erreur persiste contactez-nous par téléphone au&nbsp;\u003Ca class=\"underlined\" ng-href=\"{{$ctrl.contactTelephone.link}}\"\u003E{{$ctrl.contactTelephone.label}}\u003C\u002Fa\u003E&nbsp;ou par email à&nbsp;\u003Ca class=\"underlined\" ng-href=\"mailto:{{ $ctrl.MailAdresses.commande }}\"\u003E{{ $ctrl.MailAdresses.commande }}\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"subscription\"\u003EREPRENDRE MA COMMANDE\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"landing\"\u003EREVENIR À LA PAGE D'ACCUEIL\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endSubscriptionErrorOther = {
    bindings: {},
    template: __webpack_require__(910)(),
    /** @ngInject */controller: ["MailAdresses", "ContactTelephone", function controller(MailAdresses, ContactTelephone) {
        var ctrl = this;
        ctrl.MailAdresses = MailAdresses;
        ctrl.contactTelephone = ContactTelephone.anonymous;
    }]
};

exports.default = endSubscriptionErrorOther;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EOUPS !\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cp\u003EUne erreur inconnu s'est produite pendant la souscription. Vous pouvez reprendre votre commande ou ou accéder a votre compte.\u003C\u002Fp\u003E\u003Cp\u003ESi cette erreur persiste contactez-nous par téléphone au&nbsp;\u003Ca class=\"underlined\" ng-href=\"{{$ctrl.contactTelephone.link}}\"\u003E{{$ctrl.contactTelephone.label}}\u003C\u002Fa\u003E&nbsp;ou par email à&nbsp;\u003Ca class=\"underlined\" ng-href=\"mailto:{{ $ctrl.MailAdresses.commande }}\"\u003E{{ $ctrl.MailAdresses.commande }}\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"subscription\"\u003EREPRENDRE MA COMMANDE\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"landing\"\u003EREVENIR À LA PAGE D'ACCUEIL\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var endSubscriptionErrorPaymentRefused = {
    bindings: {
        contract: '<'
    },
    template: __webpack_require__(912)(),
    /** @ngInject */controller: ["MailAdresses", "ContactTelephone", "ContractDraft", "ErrorCatcher", function controller(MailAdresses, ContactTelephone, ContractDraft, ErrorCatcher) {
        var ctrl = this;
        ctrl.MailAdresses = MailAdresses;
        ctrl.contactTelephone = ContactTelephone.anonymous;

        ctrl.goToPayment = function () {
            var getPaymentIframePromise = void 0;
            if ((0, _isEmpty3.default)(localStorage.subscriptionToken)) {
                getPaymentIframePromise = ContractDraft.getPaymentIframe({ id: ctrl.contract.id }).$promise;
            } else {
                getPaymentIframePromise = ContractDraft.getPaymentIframeByToken({ id: ctrl.contract.id, token: localStorage.subscriptionToken }).$promise;
            }
            getPaymentIframePromise.then(function (response) {
                window.location = response.redirectUrl;
            }).catch(function (error) {
                ErrorCatcher.catchError(error);
            });
        };
    }]
};

exports.default = endSubscriptionErrorPaymentRefused;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EOUPS !\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cp\u003ESuite à une erreur, votre moyen de paiement a été rejeté.\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez retenter de saisir votre IBAN auprès de notre partenaire.\u003C\u002Fp\u003E\u003Cp\u003ESi cette erreur persiste contactez-nous par téléphone au&nbsp;\u003Ca class=\"underlined\" ng-href=\"{{$ctrl.contactTelephone.link}}\"\u003E{{$ctrl.contactTelephone.label}}\u003C\u002Fa\u003E&nbsp;ou par email à&nbsp;\u003Ca class=\"underlined\" ng-href=\"mailto:{{ $ctrl.MailAdresses.commande }}\"\u003E{{ $ctrl.MailAdresses.commande }}\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.goToPayment()\"\u003EVALIDER MON RIB\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"landing\"\u003EREVENIR À LA PAGE D'ACCUEIL\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNil = __webpack_require__(206);

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var endSubscriptionGoalForm = {
    bindings: {
        contract: '<',
        onStateEnd: '&'
    },
    template: __webpack_require__(914)(),
    /** @ngInject */controller: ["Contract", "ApiService", "ErrorCatcher", function controller(Contract, ApiService, ErrorCatcher) {
        var ctrl = this;
        ctrl.form = {
            refGoal: null
        };

        ctrl.isFormValid = function () {
            return !(0, _isNil2.default)(ctrl.form.refGoal);
        };

        ctrl.submitForm = function () {
            return Contract.refGoal({ id: ctrl.contract.id }, { id_ref_goal: ctrl.form.refGoal }).$promise.then(function (result) {
                ApiService.resetPromise('userInfo');
                ctrl.onStateEnd();
            }).catch(function (error) {
                console.error('Cannot submit refgoal', error);
                ErrorCatcher.catchError(error);
            });
        };

        ctrl.$onInit = function () {
            ctrl.form.refGoal = ctrl.contract.id_ref_goal;
        };
    }]
};

exports.default = endSubscriptionGoalForm;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ETERMINER MA COMMANDE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" ng-submit=\"$ctrl.submitForm()\"\u003E\u003Cp\u003EEt si vous nous disiez pour quelle raison principale vous avez choisi Plüm énergie ?\u003C\u002Fp\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"goal-item col-md-3 col-sm-6 col-xs-12\" id=\"energy-transition\" ng-click=\"$ctrl.form.refGoal = 'ECOLO'\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-renouvelable.svg\"\u003E\u003Cp\u003EPour agir pour la transition énergétique\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.refGoal === 'ECOLO'}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"goal-item col-md-3 col-sm-6 col-xs-12\" id=\"manage-conso\" ng-click=\"$ctrl.form.refGoal = 'MAITRISE'\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-graph.svg\"\u003E\u003Cp\u003EPour mieux maîtriser votre conso\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.refGoal === 'MAITRISE'}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"goal-item col-md-3 col-sm-6 col-xs-12\" id=\"reduce-facture\" ng-click=\"$ctrl.form.refGoal = 'ECONOMIE'\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-pricecut.svg\"\u003E\u003Cp\u003EPour réduire votre facture d’électricité\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.refGoal === 'ECONOMIE'}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"goal-item col-md-3 col-sm-6 col-xs-12\" id=\"innovation\" ng-click=\"$ctrl.form.refGoal = 'INNOVATION'\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-robot.svg\"\u003E\u003Cp\u003EPar attrait pour l’innovation\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.refGoal === 'INNOVATION'}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"!$ctrl.isFormValid()\" id=\"btnFinishOrderGoal\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endSubscriptionInitial = {
    bindings: {},
    template: __webpack_require__(916)()
};

exports.default = endSubscriptionInitial;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ELOADING...\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Ci class=\"spinner\"\u003E\u003C\u002Fi\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNil = __webpack_require__(206);

var _isNil2 = _interopRequireDefault(_isNil);

var _defaultTo = __webpack_require__(71);

var _defaultTo2 = _interopRequireDefault(_defaultTo);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var endSubscriptionRetractionForm = {
    bindings: {
        contract: '<',
        onStateEnd: '&'
    },
    template: __webpack_require__(918)(),
    /** @ngInject */controller: ["ApiService", "Contract", "ContractStatus", "ContactTelephone", "ErrorCatcher", function controller(ApiService, Contract, ContractStatus, ContactTelephone, ErrorCatcher) {
        var ctrl = this;
        ctrl.contactTelephone = ContactTelephone;
        ctrl.contractStatus = ContractStatus;
        ctrl.actionTypes = {
            bypassTrue: 'bypassTrue',
            bypassFalse: 'bypassFalse',
            selectEmmenagementDate: 'selectEmmenagementDate'
        };

        ctrl.state = 'state-initial';
        ctrl.hasAlreadyBypassed = false;
        ctrl.activationDate = (0, _moment2.default)().add(14, 'days').format('D MMMM YYYY');
        ctrl.isEmmenagement = false;
        ctrl.form = {
            isSubmit: false,
            action: ctrl.actionTypes.bypassTrue,
            emmenagementDate: null
        };

        ctrl.isFormValid = function () {
            var isActionDefined = !(0, _isNil2.default)(ctrl.form.action);
            var isEmmenagementDateAfterToday = (0, _moment2.default)().isBefore((0, _moment2.default)(ctrl.form.emmenagementDate, 'DDMMYYYY'), 'day');

            if (ctrl.form.action === ctrl.actionTypes.selectEmmenagementDate) {
                return isEmmenagementDateAfterToday;
            }
            return isActionDefined;
        };

        ctrl.submitForm = function () {
            ctrl.form.isSubmit = true;
            if (ctrl.form.action === ctrl.actionTypes.bypassTrue) {
                Contract.bypassRetraction({ id: ctrl.contract.id }, {}).$promise.then(function () {
                    ApiService.resetPromise('userInfo');
                    ctrl.onStateEnd();
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    ctrl.form.isSubmit = false;
                });
            } else if (ctrl.form.action === ctrl.actionTypes.selectEmmenagementDate) {
                Contract.bypassRetraction({
                    id: ctrl.contract.id,
                    withDate: (0, _moment2.default)(ctrl.form.emmenagementDate, 'DDMMYYYY').format('YYYY-MM-DD')
                }, {}).$promise.then(function () {
                    ApiService.resetPromise('userInfo');
                    ctrl.onStateEnd();
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    ctrl.form.isSubmit = false;
                });
            } else {
                ApiService.resetPromise('userInfo');
                ctrl.onStateEnd();
            }
        };

        ctrl.$onInit = function () {
            var retractionEndDate = (0, _moment2.default)((0, _defaultTo2.default)(ctrl.contract.retraction_end_date, (0, _moment2.default)().add(14, 'days')));
            ctrl.activationDate = retractionEndDate.format('D MMMM YYYY');
            ctrl.isEmmenagement = ctrl.contract.is_a_move;
            if (retractionEndDate.isSameOrBefore((0, _moment2.default)(), 'day')) {
                ctrl.hasAlreadyBypassed = true;
                ctrl.form.action = ctrl.actionTypes.bypassFalse;
            }

            if (ctrl.contract.channel === 'WEB' && ctrl.contract.subscription_type === 'CDF') {
                ctrl.state = 'state-web-cdf';
            } else if (ctrl.contract.channel === 'WEB' && ctrl.contract.subscription_type === 'MES') {
                ctrl.state = 'state-web-mes';
            } else if (ctrl.contract.channel === 'WEB' && ['CDF_INTER', 'MES_INTER', 'FIRST_MES'].includes(ctrl.contract.subscription_type)) {
                ctrl.state = 'state-web-mes-inter';
            } else if (ctrl.contract.channel === 'TLV' && ctrl.contract.subscription_type === 'CDF') {
                ctrl.state = 'state-televente-cdf';
            } else if (ctrl.contract.channel === 'TLV' && ctrl.contract.subscription_type === 'MES') {
                ctrl.state = 'state-televente-mes';
            } else if (ctrl.contract.channel === 'TLV' && ['CDF_INTER', 'MES_INTER', 'FIRST_MES'].includes(ctrl.contract.subscription_type)) {
                ctrl.state = 'state-televente-mes-inter';
            } else {
                ctrl.state = 'state-unknown';
            }
        };
    }]
};

exports.default = endSubscriptionRetractionForm;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ETERMINER MA COMMANDE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" ng-if=\"$ctrl.state === 'state-web-cdf'\" ng-submit=\"$ctrl.submitForm()\"\u003E\u003Cdiv class=\"retractation\" ng-if=\"!$ctrl.hasAlreadyBypassed\"\u003E\u003Cp\u003EVotre moyen de paiement est enregistré. Vous pouvez maintenant choisir votre délai d'activation.\u003C\u002Fp\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cdiv class=\"radio-custom-container\" id=\"trigger-order-now\" ng-click=\"$ctrl.form.action = $ctrl.actionTypes.bypassTrue\"\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.action === $ctrl.actionTypes.bypassTrue}\"\u003E\u003C\u002Fspan\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-fast.svg\"\u003E\u003Cspan\u003EJe souhaite \u003Cb\u003Edéclencher ma commande tout de suite,\u003C\u002Fb\u003E sans attendre la fin du délai de rétractation.\nMon passage chez Plüm se fera d’ici 48h.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"radio-custom-container\" id=\"trigger-order-later\" ng-click=\"$ctrl.form.action = $ctrl.actionTypes.bypassFalse\"\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.action === $ctrl.actionTypes.bypassFalse}\"\u003E\u003C\u002Fspan\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-sablier.svg\"\u003E\u003Cspan\u003EJe souhaite \u003Cb\u003Eutiliser ma période de réfléxion de 14 jours,\u003C\u002Fb\u003E prévue par le code de la consommation.\nJe pourrai donc, jusqu’au {{$ctrl.activationDate}}, changer d’avis et annuler ma commande.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cdiv class=\"radio-custom-container\" id=\"trigger-order-now\" ng-click=\"$ctrl.form.action = $ctrl.actionTypes.bypassTrue\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-fast.svg\"\u003E\u003Cp\u003EJe souhaite \u003Cb\u003Edéclencher ma commande tout de suite,\u003C\u002Fb\u003E sans attendre la fin du délai de rétractation.\nMon passage chez Plüm se fera d’ici 48h.\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.action === $ctrl.actionTypes.bypassTrue}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"radio-custom-container\" id=\"trigger-order-later\" ng-click=\"$ctrl.form.action = $ctrl.actionTypes.bypassFalse\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-sablier.svg\"\u003E\u003Cp\u003EJe souhaite \u003Cb\u003Eutiliser ma période de réfléxion de 14 jours,\u003C\u002Fb\u003E prévue par le code de la consommation.\nJe pourrai donc, jusqu’au {{$ctrl.activationDate}}, changer d’avis et annuler ma commande.\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.action === $ctrl.actionTypes.bypassFalse}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.hasAlreadyBypassed\"\u003E\u003Cp\u003EVotre moyen de paiement est enregistré.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" type=\"submit\" ng-class=\"{'btn-spinner-loading': $ctrl.form.isSubmit}\" ng-disabled=\"!$ctrl.isFormValid() || $ctrl.form.isSubmit\" id=\"btnFinisheOrderConfirmation\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cform class=\"form-container form-body\" ng-if=\"$ctrl.state === 'state-web-mes'\" ng-submit=\"$ctrl.submitForm()\"\u003E\u003Cdiv class=\"retractation\" ng-if=\"!$ctrl.hasAlreadyBypassed\"\u003E\u003Cp\u003EVotre moyen de paiement est enregistré. Vous pouvez maintenant choisir votre délai d'activation.\u003Cdiv class=\"hidden-xs\"\u003E\u003Cdiv class=\"radio-custom-container\" id=\"trigger-order-now\" ng-click=\"$ctrl.form.action = $ctrl.actionTypes.bypassTrue\"\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.action === $ctrl.actionTypes.bypassTrue}\"\u003E\u003C\u002Fspan\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-fast.svg\"\u003E\u003Cspan\u003EJe souhaite \u003Cb\u003Edéclencher ma commande tout de suite,\u003C\u002Fb\u003E sans attendre la fin du délai de rétractation.\nMon passage chez Plüm se fera d’ici 48h.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"radio-custom-container\" id=\"trigger-order-later\" ng-if=\"$ctrl.isEmmenagement\" ng-click=\"$ctrl.form.action = $ctrl.actionTypes.selectEmmenagementDate\"\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.action === $ctrl.actionTypes.selectEmmenagementDate}\"\u003E\u003C\u002Fspan\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-move-in.svg\"\u003E\u003Cdiv class=\"emmenagement-date\"\u003E\u003Cdiv class=\"information\"\u003EJe souhaite \u003Cb\u003Esélectionner ma date d'emménagement\u003C\u002Fb\u003E.\nJe renonce à mon délai de rétractation et ma commande sera active à la date saisie.\u003C\u002Fdiv\u003E\u003Clabel\u003EDate d'emménagement :\u003Cinput name=\"emmenagementDate\" type=\"text\" ng-required=\"true\" ng-model=\"$ctrl.form.emmenagementDate\" birthdate ng-disabled=\"$ctrl.form.action !== $ctrl.actionTypes.selectEmmenagementDate\" placeholder=\"JJ   MM   AAAA\" ui-mask=\"99   99   9999\"\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cdiv class=\"radio-custom-container\" id=\"trigger-order-now\" ng-click=\"$ctrl.form.action = $ctrl.actionTypes.bypassTrue\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-fast.svg\"\u003E\u003Cp\u003EJe souhaite \u003Cb\u003Edéclencher ma commande tout de suite,\u003C\u002Fb\u003E sans attendre la fin du délai de rétractation.\nMon passage chez Plüm se fera d’ici 48h.\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.action === $ctrl.actionTypes.bypassTrue}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"radio-custom-container\" id=\"trigger-order-later\" ng-if=\"$ctrl.isEmmenagement\" ng-click=\"$ctrl.form.action = $ctrl.actionTypes.selectEmmenagementDate\"\u003E\u003Cimg class=\"vector-icon\" src=\"\u002Fassets\u002Fimg\u002FendSubscription\u002Fendcmd-move-in.svg\"\u003E\u003Cdiv class=\"emmenagement-date\"\u003E\u003Cdiv class=\"information\"\u003EJe souhaite \u003Cb\u003Esélectionner ma date d'emménagement\u003C\u002Fb\u003E.\nJe renonce à mon délai de rétractation et ma commande sera active à la date saisie.\u003C\u002Fdiv\u003E\u003Clabel\u003EDate d'emménagement :\u003Cinput name=\"emmenagementDate\" type=\"text\" ng-required=\"true\" ng-model=\"$ctrl.form.emmenagementDate\" birthdate ng-disabled=\"$ctrl.form.action !== $ctrl.actionTypes.selectEmmenagementDate\" placeholder=\"JJ   MM   AAAA\" ui-mask=\"99   99   9999\"\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.form.action === $ctrl.actionTypes.selectEmmenagementDate}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fp\u003E\u003Cdiv ng-if=\"$ctrl.hasAlreadyBypassed\"\u003E\u003Cp\u003EVotre moyen de paiement est enregistré.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.hasAlreadyBypassed\"\u003E\u003Cp\u003EVotre moyen de paiement est enregistré.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" type=\"submit\" ng-class=\"{'btn-spinner-loading': $ctrl.form.isSubmit}\" ng-disabled=\"!$ctrl.isFormValid() || $ctrl.form.isSubmit\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cform class=\"form-container form-body\" ng-if=\"['state-televente-cdf', 'state-televente-mes'].indexOf($ctrl.state) &gt; -1\" ng-submit=\"$ctrl.onStateEnd()\"\u003E\u003Cdiv ng-if=\"!$ctrl.hasAlreadyBypassed\"\u003E\u003Cp\u003EVous avez souhaité utiliser votre période de réflexion de 14 jours, prévue par le code de la consommation.\u003C\u002Fp\u003E\u003Cp\u003EVotre commande va donc être mise en attente et sera lancée le {{$ctrl.activationDate}}.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.hasAlreadyBypassed\"\u003E\u003Cp\u003EVous avez souhaité déclencher votre commande tout de suite. Votre contrat sera actif chez Plüm d'ici 3 jours ouvrés environ.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cform class=\"form-container form-body\" ng-if=\"['state-web-mes-inter', 'state-televente-mes-inter'].indexOf($ctrl.state) &gt; -1\" ng-submit=\"$ctrl.onStateEnd()\"\u003E\u003Cp\u003EL'activation de votre compteur nécessite l'intervention d'un technicien Enedis.\u003C\u002Fp\u003E\u003Cp\u003EPour prendre rendez-vous et activer rapidement votre contrat, suivez les instructions indiquées dans le mail ou le sms que vous avez reçu.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cform class=\"form-container form-body\" ng-if=\"$ctrl.state === 'state-unknown'\" ng-submit=\"$ctrl.onStateEnd()\"\u003E\u003Cp\u003EVotre moyen de paiement est enregistré.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\"\u003ETERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: __webpack_require__(920)(),
    bindings: {}
};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-10\"\u003E\u003Ch4\u003EVOTRE COMMANDE EST TERMINÉE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-2 text-right\"\u003E\u003Ca class=\"no-padding\" title=\"Retourner au contrat\" ui-sref=\"account({contractId: $ctrl.contract.id})\" ui-sref-opts=\"{reload: true}\"\u003E\u003Ci class=\"fa fa-close fa-2x\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body text-center\"\u003E\u003Cp class=\"fs-18\"\u003ENous allons maintenant transférer votre dossier au service public ENEDIS pour activer votre contrat.\nNous vous tiendrons informé par e-mail des prochaines étapes.\u003C\u002Fp\u003E\u003Cp class=\"fs-18 light-pink\"\u003EÀ bientôt !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


endSubscriptionCtrl.$inject = ["$scope", "$state", "$stateParams", "$q", "Contract", "ContractService", "ContractStatus", "AdwordsService", "gaEventsService", "ErrorCatcher", "userInfo", "contractDraft", "isDepositNeeded"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaultTo = __webpack_require__(71);

var _defaultTo2 = _interopRequireDefault(_defaultTo);

var _isEmpty = __webpack_require__(14);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = endSubscriptionCtrl;

/** @ngInject */

function endSubscriptionCtrl($scope, $state, $stateParams, $q, Contract, ContractService, ContractStatus, AdwordsService, gaEventsService, ErrorCatcher, userInfo, contractDraft, isDepositNeeded) {
    // Selected Contract State
    $scope.contract = null;
    $scope.paymentAccepted = false;
    $scope.transaction = {
        transactionStatus: $stateParams.transactionStatus,
        transactionErrorCode: $stateParams.transactionErrorCode,
        signatureOperationResult: $stateParams.signatureOperationResult,
        transactionId: (0, _defaultTo2.default)($stateParams.transactionId, $stateParams.order_reference)

        // View state
    };$scope.displayForm = false;
    $scope.state = 'state-initial';
    $scope.hasRetractationBypassed = false;
    $scope.hasRefGoalBypassed = false;
    $scope.userInfo = userInfo;

    $scope.updateViewState = function (action) {
        if (action === 'RETRACTION-FORM-FINISHED') {
            $scope.hasRetractationBypassed = true;
        } else if (action === 'GOAL-FORM-FINISHED') {
            $scope.hasRefGoalBypassed = true;
        }

        if ((0, _isEmpty2.default)($scope.contract.id)) {
            $scope.state = 'state-error-no-contract';
        } else if (!$scope.paymentAccepted) {
            $scope.state = 'state-error-payment-refused';
        } else if (!$scope.hasRetractationBypassed) {
            $scope.state = 'state-end-retraction-form';
        } else if (!$scope.hasRefGoalBypassed) {
            $scope.state = 'state-end-goal-form';
        } else {
            $scope.state = 'state-end-finish';
        }
    };

    var activate = function activate() {
        var transactionContractId = (0, _defaultTo2.default)($scope.transaction.transactionId, '').split('-')[0];
        var transactionContract = ContractService.findContract(userInfo.contracts, transactionContractId);
        var initialContract = ContractService.findFirstGoalNotDefinedContract(userInfo.contracts);

        // Update status on found contract
        if (!(0, _isEmpty2.default)(transactionContract)) {
            $scope.contract = transactionContract;
            $scope.paymentAccepted = true;
            gaEventsService.newEvent('page - Confirmation Souscription Success - Slimplay + Initial Contract');
        } else if ($scope.transaction.transactionStatus === 'success') {
            $scope.contract = { id: transactionContractId };
            $scope.paymentAccepted = true;
            $scope.hasRetractationBypassed = true;
            $scope.hasRefGoalBypassed = true;
            gaEventsService.newEvent('page - Confirmation Souscription Success - Slimplay + No Initial Contract');
        } else if ($scope.transaction.transactionStatus === 'failure' || contractDraft.id === transactionContractId && contractDraft.ready_to_checkout) {
            $scope.contract = { id: transactionContractId };
            $scope.paymentAccepted = false;
            gaEventsService.newEvent('page - Confirmation Souscription Fail - Payment Refused');
        } else if ((0, _isEmpty2.default)(transactionContractId) && !(0, _isEmpty2.default)(initialContract)) {
            $scope.contract = initialContract;
            $scope.paymentAccepted = true;
            gaEventsService.newEvent('page - Confirmation Souscription Success - No Slimpay + Initial Contract');
        } else {
            $scope.contract = {};
            $scope.paymentAccepted = false;
            gaEventsService.newEvent('page - Confirmation Souscription None - No Slimpay + No Initial Contract');
        }

        // Fire tracking
        if (!(0, _isEmpty2.default)($scope.contract.id)) {
            AdwordsService.fireSlimpaySuccessRedirect($scope.contract.id);
            if (window.fbq) {
                window.fbq('track', 'CompleteRegistration');
            }
            if (window.uetq) {
                window.uetq.push({
                    ec: 'Souscription', // Event category
                    ea: 'Fin de souscription', // Event action
                    el: $scope.contract.id // Event label
                });
            }
        }

        // If transactionContractId undefined,
        // check security deposit for the first selected contract
        var isDepositNeededPromise = void 0;
        if (!(0, _isEmpty2.default)(isDepositNeeded.contractId) || (0, _isEmpty2.default)($scope.contract.id)) {
            isDepositNeededPromise = $q.resolve({ depositNeeded: false });
        } else {
            isDepositNeededPromise = Contract.isDepositNeeded({ id: $scope.contract.id }).$promise;
        }
        isDepositNeededPromise.then(function (result) {
            if (result.depositNeeded) {
                $state.go('securityDepositAuthenticated', { contractId: $scope.contract.id });
            } else {
                // Update which state to display
                $scope.updateViewState();
                $scope.displayForm = true;
            }
        }).catch(function (error) {
            ErrorCatcher.catchError(error);
        });
    };

    // Controller Activation Promises
    // https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#controller-activation-promises
    activate();
}

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


endSubscriptionSlimpayErrorCtrl.$inject = ["$scope", "$stateParams"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = endSubscriptionSlimpayErrorCtrl;

/** @ngInject */

function endSubscriptionSlimpayErrorCtrl($scope, $stateParams) {
    var transactionContractId = (0, _get3.default)($stateParams, 'transactionId', (0, _get3.default)($stateParams, 'order_reference', '')).split('-')[0];
    $scope.contract = { id: transactionContractId };
}

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _invoiceBiduleProofOfResidence = __webpack_require__(924);

var _invoiceBiduleProofOfResidence2 = _interopRequireDefault(_invoiceBiduleProofOfResidence);

var _invoiceBiduleSleek = __webpack_require__(926);

var _invoiceBiduleSleek2 = _interopRequireDefault(_invoiceBiduleSleek);

var _invoiceDetail = __webpack_require__(928);

var _invoiceDetail2 = _interopRequireDefault(_invoiceDetail);

var _invoiceDetails = __webpack_require__(930);

var _invoiceDetails2 = _interopRequireDefault(_invoiceDetails);

var _invoiceSituation = __webpack_require__(932);

var _invoiceSituation2 = _interopRequireDefault(_invoiceSituation);

var _invoiceSituationTimeline = __webpack_require__(937);

var _invoiceSituationTimeline2 = _interopRequireDefault(_invoiceSituationTimeline);

var _invoice = __webpack_require__(939);

var _invoice2 = _interopRequireDefault(_invoice);

var _invoicePaymentTable = __webpack_require__(941);

var _invoicePaymentTable2 = _interopRequireDefault(_invoicePaymentTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.invoice', []).directive('invoiceBiduleProofOfResidence', _invoiceBiduleProofOfResidence2.default).component('invoiceBiduleSleek', _invoiceBiduleSleek2.default).directive('invoiceDetail', _invoiceDetail2.default).directive('invoiceDetails', _invoiceDetails2.default).directive('invoiceSituation', _invoiceSituation2.default).directive('invoiceSituationTimeline', _invoiceSituationTimeline2.default).controller('invoiceCtrl', _invoice2.default).component('invoicePaymentTable', _invoicePaymentTable2.default).name;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


invoiceBiduleProofOfResidence.$inject = ["$uibModal"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = invoiceBiduleProofOfResidence;

/** @ngInject */

function invoiceBiduleProofOfResidence($uibModal) {
    return {
        restrict: 'E',
        template: __webpack_require__(925)(),
        link: function link($scope) {
            $scope.openProofOfResModal = function () {
                return $uibModal.open({
                    animation: true,
                    size: 'md',
                    controller: 'proofOfResModalCtrl',
                    template: __webpack_require__(323)(),
                    resolve: {
                        contractId: ["ApiService", "PermPermissionStore", function contractId(ApiService, PermPermissionStore) {
                            return __guard__(PermPermissionStore.getStore().client, function (x) {
                                return x.validatePermission().then(function () {
                                    return ApiService.fetchUserInfo().then(function (userInfo) {
                                        return userInfo.contractSelected.id;
                                    });
                                });
                            });
                        }]
                    }
                });
            };
        }
    };
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"bidule-panel bidule-panel-proof-of-residence\"\u003E\u003Cdiv class=\"btn-proofofresidence text-center\" ng-click=\"openProofOfResModal()\"\u003E\u003Ca\u003E\u003Cp\u003EJUSTIFICATIF DE DOMICILE\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003Cbutton class=\"btn background-bluegrey\"\u003ETélécharger\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: __webpack_require__(927)(),
    bindings: {
        sleek: '<'
    }
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"bidule-panel bidule-panel-sleek\" ng-if=\"!$ctrl.sleek\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Ffactu_reel.svg\"\u003E\u003Ch4\u003EMode de prélèvement «&nbsp;saisonnier&nbsp;»\u003C\u002Fh4\u003E\u003Cp\u003EVos mensualités sont actuellement calculées en mode «&nbsp;saisonnier&nbsp;», où chaque mensualité varie en fonction\nd’une estimation mois par mois de votre consommation.\u003Cbr\u003EVous pouvez, sur simple demande, passer en mode «&nbsp;lissé&nbsp;», dans lequel vos mensualités sont identiques pendant\nles 6 mois de chaque période de facturation.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


invoiceDetail.$inject = ["Invoice", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = invoiceDetail;

/** @ngInject */

function invoiceDetail(Invoice, ErrorCatcher) {
    return {
        restrict: 'E',
        scope: {
            invoice: '='
        },
        template: __webpack_require__(929)(),
        link: function link(scope) {
            scope.actions = {
                payStatus: { SUCCESS: 'SUCCESS', FAIL: 'FAIL', PENDING: 'PENDING', POD: 'POD' },
                isDetailOpen: false
            };

            scope.getInvoiceLabel = function (type) {
                var INVOICE_LABEl_MAPPING = {
                    REG: 'Facture de régularisation',
                    REG_FINAL: 'Facture de clôture',
                    MISC: 'Facture de frais',
                    REG_REVERSAL: 'Annulation de la facture de régularisation',
                    REG_FINAL_REVERSAL: 'Annulation de la facture de clôture',
                    MISC_REVERSAL: 'Annulation de la facture de frais'
                };
                return (0, _get3.default)(INVOICE_LABEl_MAPPING, type, 'Facture');
            };

            scope.sendInvoiceByMail = function (id) {
                Invoice.sendInvoiceByMail({ id_invoice: id }).$promise.catch(ErrorCatcher.catchError);
            };
        }
    };
}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"large-main-panel invoice-detail\"\u003E\u003Cdiv class=\"top-detail\"\u003E\u003Cdiv class=\"top-detail-period\" ng-if=\"['MISC', 'MISC_REVERSAL'].indexOf(invoice.type) === -1\"\u003E{{invoice.periodFrom | date: 'MMM yyyy' | capitalize}} à {{invoice.periodTo | date: 'MMM yyyy'}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-detail-period\" ng-if=\"['MISC', 'MISC_REVERSAL'].indexOf(invoice.type) &gt; -1\"\u003E{{invoice.withdrawDate | date: 'dd MMM yyyy'}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-detail-invoice\"\u003E{{getInvoiceLabel(invoice.type)}} n°{{invoice.invoiceNumber}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"status success\"\u003E\u003Cp class=\"fw-500\" ng-if=\"invoice.payStatus === actions.payStatus.SUCCESS\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Fsuccess.svg\"\u003E\npayée\u003C\u002Fp\u003E\u003Cp class=\"fw-500\" ng-if=\"invoice.payStatus === actions.payStatus.FAIL\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Ffail.svg\"\u003E\nnon payée\u003C\u002Fp\u003E\u003Cp class=\"fw-500\" ng-if=\"invoice.payStatus === actions.payStatus.PENDING\"\u003Een cours\u003C\u002Fp\u003E\u003Cp class=\"fw-500\" ng-if=\"invoice.payStatus === actions.payStatus.POD\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"amount-block\"\u003E\u003Cdiv class=\"amount-block-label\"\u003E\u003Cspan class=\"amount\"\u003E{{invoice.amount | frAmount}}&euro;\u003C\u002Fspan\u003E\u003Cspan class=\"per-month\" ng-if=\"['MISC', 'MISC_REVERSAL'].indexOf(invoice.type) === -1\"\u003E&nbsp;\u002F mois\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"amount-block-average\" ng-if=\"['MISC', 'MISC_REVERSAL'].indexOf(invoice.type) === -1\"\u003E\u003Cspan\u003Een moyenne\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"amount-block-sublabel\" ng-repeat=\"label in invoice.label\"\u003E\u003Cspan\u003E{{ label.label }}\u003C\u002Fspan\u003E\u003Cspan class=\"buffer-left\"\u003E{{ label.amount | frAmount }}&euro;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"regularisation\" ng-if=\"invoice.regul\"\u003E\u003Ctable\u003E\u003Ctbody\u003E\u003Ctr\u003E\u003Ctd\u003ERÉGULARISATION\u003Cbr\u003E\u003Cspan class=\"fs-12 fw-400\"\u003EPrélèvement demandé le {{invoice.regul.withdrawDate | date: 'dd MMM yyyy'}}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E{{invoice.regul.amount | frAmount }}&euro;\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-if=\"invoice.downloadLink\" ng-click=\"sendInvoiceByMail(invoice.id)\" uib-popover=\"Votre facture a été bien envoyée par mail.\" popover-trigger=\"outsideClick\"\u003EEnvoyer par mail\u003C\u002Fbutton\u003E\u003Ca class=\"btn background-bluegrey\" ng-if=\"invoice.downloadLink\" ng-href=\"\u002Fapi-user{{invoice.downloadLink}}\" target=\"_blank\"\u003ETélécharger\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = invoiceDetails;

/** @ngInject */

function invoiceDetails() {
    return {
        restrict: 'E',
        scope: {
            invoices: '='
        },
        template: __webpack_require__(931)()
    };
}

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"text-center margin-top-40 margin-bottom-50\"\u003E\u003Ch1 class=\"margin-top-15 bold\"\u003EToutes mes factures\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-panel\" ng-if=\"!invoices.length\"\u003E\u003Cdiv class=\"large-main-panel\"\u003E\u003Cp\u003EVous n'avez pas de facture pour le moment.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"invoices.length\"\u003E\u003Cdiv class=\"col-sm-6\" ng-repeat=\"i in invoices\"\u003E\u003Cinvoice-detail invoice=\"i\"\u003E\u003C\u002Finvoice-detail\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


invoiceSituation.$inject = ["$uibModal"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _toNumber2 = __webpack_require__(131);

var _toNumber3 = _interopRequireDefault(_toNumber2);

var _first2 = __webpack_require__(317);

var _first3 = _interopRequireDefault(_first2);

var _defaultTo2 = __webpack_require__(71);

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

var _filter2 = __webpack_require__(82);

var _filter3 = _interopRequireDefault(_filter2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = invoiceSituation;

/** @ngInject */

function invoiceSituation($uibModal) {
    return {
        restrict: 'E',
        scope: {
            situation: '<',
            userInfo: '<',
            onSituationUpdated: '&'
        },
        template: __webpack_require__(933)(),
        link: function link($scope) {
            var $controllerScope = $scope;
            $scope.payStatus = { SUCCESS: 'SUCCESS', FAIL: 'FAIL', PENDING: 'PENDING' };
            $scope.situationDetails = [];
            $scope.situationSelected = {};
            $scope.sleek = undefined;

            var getCurrentOrFirst = function getCurrentOrFirst(dateLabel, selectedPeriod, details) {
                var isSameMonth = function isSameMonth(selectedPeriod) {
                    return function (detail) {
                        return (0, _moment2.default)(selectedPeriod).isSame(detail[dateLabel], 'month');
                    };
                };
                var getCurrentDetail = function getCurrentDetail(selectedPeriod, details) {
                    return (0, _filter3.default)(details, isSameMonth(selectedPeriod))[0];
                };
                return (0, _defaultTo3.default)(getCurrentDetail(selectedPeriod, details), (0, _first3.default)(details));
            };

            var updateSituation = function updateSituation(situation) {
                $scope.sleek = situation.sleek;
                $scope.situationDetails = situation.details;
                $scope.situationSelected = getCurrentOrFirst('withdrawDate', (0, _moment2.default)(), situation.details);
            };

            $scope.selectSituation = function (situation) {
                $scope.situationSelected = situation;
            };

            $scope.shouldDisplayRegulateBtn = function () {
                var BALANCE_THRESHOLD = -1;
                return (0, _toNumber3.default)($scope.userInfo.contractSelected.contractBalance.balance) < BALANCE_THRESHOLD;
            };

            $scope.openChangeSamplingDateModal = function () {
                $uibModal.open({
                    animation: true,
                    size: 'lg',
                    template: __webpack_require__(934)(),
                    resolve: {
                        paymentDayInfo: ["BillingAcc", "ErrorCatcher", function paymentDayInfo(BillingAcc, ErrorCatcher) {
                            return BillingAcc.getPaymentDay().$promise.catch(ErrorCatcher.catchError);
                        }]
                    },
                    controller: ["$scope", "$uibModalInstance", "ErrorCatcher", "BillingAcc", "paymentDayInfo", function controller($scope, $uibModalInstance, ErrorCatcher, BillingAcc, paymentDayInfo) {
                        $scope.form = paymentDayInfo;
                        $scope.submit = function () {
                            BillingAcc.putPaymentDay({ preferredPaymentDay: $scope.form.preferredPaymentDay }).$promise.catch(ErrorCatcher.catchError);
                            $uibModalInstance.dismiss();
                        };
                        $scope.close = function () {
                            $uibModalInstance.dismiss();
                        };
                    }]
                });
            };

            $scope.openRegulateSituationPopup = function (_situationSelected) {
                $uibModal.open({
                    animation: true,
                    template: __webpack_require__(935)(),
                    resolve: {
                        situationSelected: function situationSelected() {
                            return _situationSelected;
                        }
                    },
                    controller: ["$scope", "$uibModalInstance", "ErrorCatcher", "Invoice", "situationSelected", function controller($scope, $uibModalInstance, ErrorCatcher, Invoice, situationSelected) {
                        var PAYMENT_STATUS_ABORDED_BY_CLIENT_ERROR = 90;
                        var PAYMENT_STATUS_RTRANSAC_ERROR = 95;
                        var generatePaymentStatus = [PAYMENT_STATUS_ABORDED_BY_CLIENT_ERROR, PAYMENT_STATUS_RTRANSAC_ERROR];
                        $scope.situationSelected = situationSelected;
                        $scope.isSubmitted = false;
                        $scope.errorMessage = null;
                        $scope.regulateByCreditCard = function () {
                            $scope.errorMessage = null;
                            return Invoice.getPayment({ payment_id: situationSelected.idPayment }).$promise.then(function (result) {
                                if (generatePaymentStatus.indexOf(result.status) > -1) {
                                    return Invoice.sendRegulateSituation({ id_payment: result.id }).$promise;
                                }
                                return result;
                            }).then(function (result) {
                                return Invoice.creditCardRedirect({ id_payment: result.id }).$promise;
                            }).then(function (result) {
                                window.location = result.redirectUrl;
                            }).catch(function (error) {
                                $scope.errorMessage = (0, _get3.default)(error, 'data.details.message', error.data.message);
                                return ErrorCatcher.catchError(error);
                            });
                        };
                        $scope.submit = function () {
                            Invoice.sendRegulateSituation({ id_payment: situationSelected.idPayment }).$promise.then(function () {
                                $scope.isSubmitted = true;
                                $controllerScope.onSituationUpdated();
                            }).catch(ErrorCatcher.catchError);
                        };
                        $scope.close = function () {
                            $uibModalInstance.dismiss();
                        };
                    }]
                });
            };

            $scope.openPayNextPaymentPopup = function (situationSelected) {
                $uibModal.open({
                    animation: true,
                    template: __webpack_require__(936)(),
                    controller: ["$scope", "$uibModalInstance", "ErrorCatcher", "Invoice", function controller($scope, $uibModalInstance, ErrorCatcher, Invoice) {
                        $scope.situationSelected = situationSelected;
                        $scope.isSubmitted = false;
                        $scope.submit = function () {
                            Invoice.sendPayNextPayment({ id_payment: situationSelected.idPayment }).$promise.then(function () {
                                $scope.isSubmitted = true;
                                $controllerScope.onSituationUpdated();
                            }).catch(ErrorCatcher.catchError);
                        };
                        $scope.close = function () {
                            $uibModalInstance.dismiss();
                        };
                    }]
                });
            };

            updateSituation($scope.situation);
            $scope.$watch('situation', updateSituation);
        }
    };
}

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"text-center margin-top-40 margin-bottom-50\"\u003E\u003Ch1 class=\"margin-top-15 bold\"\u003EMa situation\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-panel\"\u003E\u003Cdiv class=\"large-main-panel\" ng-if=\"!situationSelected.payStatus\"\u003E\u003Cp\u003EVous n'avez pas de situation en cours.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"large-main-panel timeline-panel\" ng-if=\"situationSelected.payStatus\"\u003E\u003Cdiv class=\"top-detail\" ng-if=\"situationSelected.payStatus === payStatus.SUCCESS\"\u003E\u003Cdiv class=\"amount success\"\u003E{{situationSelected.estimatedAmount | frAmount}}&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"summary\"\u003E\u003Cdiv class=\"status success\"\u003EÀ JOUR\u003C\u002Fdiv\u003E\u003Cp\u003EL’échéance {{ situationSelected.consPeriod | date: 'MMMM' | elision}} a été réglée le \u003Cstrong\u003E{{ situationSelected.withdrawDate | date: 'dd MMM yyyy' }}\u003C\u002Fstrong\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-detail\" ng-if=\"situationSelected.payStatus === payStatus.FAIL\"\u003E\u003Cdiv class=\"amount fail\"\u003E{{situationSelected.estimatedAmount | frAmount}}&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"summary\"\u003E\u003Cdiv class=\"status fail\"\u003EPRÉLÈVEMENT REJETÉ\u003C\u002Fdiv\u003E\u003Cp\u003ELe prélèvement du \u003Cstrong\u003E{{ situationSelected.withdrawDate | date: 'dd MMM yyyy' }}\u003C\u002Fstrong\u003E a été rejeté par votre banque.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-detail\" ng-if=\"situationSelected.payStatus === payStatus.PENDING\"\u003E\u003Cdiv class=\"amount pending\"\u003E{{situationSelected.estimatedAmount | frAmount}}&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"summary\"\u003E\u003Cdiv class=\"status pending\"\u003EPROCHAIN PRÉLÈVEMENT\u003C\u002Fdiv\u003E\u003Cp\u003E{{ situationSelected.withdrawDate | date: 'dd MMM yyyy' }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cinvoice-situation-timeline situations=\"situationDetails\" selected-situation=\"situationSelected\" on-situation-selected=\"selectSituation(situation)\"\u003E\u003C\u002Finvoice-situation-timeline\u003E\u003Cdiv class=\"actions text-right\"\u003E\u003Cbutton class=\"btn background-bluegrey hidden-xs\" ng-if=\"$root.dataFeature['invoiceChangeSamplingDate']\" ng-click=\"openChangeSamplingDateModal()\"\u003EChanger la date de mes prélèvements\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-bluegrey visible-xs-inline\" ng-if=\"$root.dataFeature['invoiceChangeSamplingDate']\" ng-click=\"openChangeSamplingDateModal()\"\u003EChanger date de prélèvements\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-waterblue\" ng-if=\"shouldDisplayRegulateBtn() &amp;&amp; situationSelected.payStatus === payStatus.FAIL\" ng-click=\"openRegulateSituationPopup(situationSelected)\"\u003ERégulariser la situation\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-waterblue\" ng-if=\"false &amp;&amp; situationSelected.payStatus === payStatus.PENDING\"\u003EPayer la prochaine échéance\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"lissage\" ng-if=\"sleek\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Ffactu_lisse.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-9\"\u003E\u003Ch4\u003EMode de prélèvement «&nbsp;lissé&nbsp;»\u003C\u002Fh4\u003E\u003Cp\u003EVous payez actuellement des mensualités identiques chaque mois,\njusqu’à la prochaine réévaluation de votre échéancier.\u003Cbr\u003EVous avez la possibilité d’utiliser un mode de prélèvement «&nbsp;saisonnier&nbsp;», où chaque mensualité varie\nen fonction d’une estimation mois par mois de votre consommation.\nEn faisant des auto-relèves régulières, ce mode de prélèvement permet de mieux percevoir\nle niveau de consommation réelle chaque mois.\u003Cbr\u003EContactez-nous pour activer ce mode.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"lissage\" ng-if=\"!sleek\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Ffactu_reel.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-9\"\u003E\u003Ch4\u003EMode de prélèvement «&nbsp;saisonnier&nbsp;»\u003C\u002Fh4\u003E\u003Cp\u003EVos mensualités sont actuellement calculées en mode «&nbsp;saisonnier&nbsp;», où chaque mensualité varie en fonction\nd’une estimation mois par mois de votre consommation.\u003Cbr\u003EVous pouvez, sur simple demande, passer en mode «&nbsp;lissé&nbsp;», dans lequel vos mensualités sont identiques pendant\nles 6 mois de chaque période de facturation.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-sampling-date-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003EChoisissez la date de prélèvement\u003Cbr\u003E qui vous convient le mieux.\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"select-date-wrapper\"\u003E\u003Cdiv class=\"select-date\"\u003E\u003Cdiv class=\"select-date-item-wrapper\" ng-repeat=\"d in form.availableDays\" ng-click=\"form.preferredPaymentDay = d\"\u003E\u003Cdiv class=\"select-date-item\" ng-class=\"{'active': form.preferredPaymentDay === d}\" ng-bind=\"d\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn background-marine\" ng-click=\"submit()\"\u003EAppliquer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"regulate-situation-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003ERégularisation d’une mensualité impayée\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!isSubmitted\"\u003E\u003Cp class=\"error\" ng-if=\"errorMessage\" ng-bind=\"errorMessage\"\u003E\u003C\u002Fp\u003E\u003Cp\u003ELe prélèvement de {{situationSelected.estimatedAmount | frAmount}}&euro;\ncorrespondant au mois {{ situationSelected.withdrawDate | date: 'MMMM yyyy' | elision}} a été rejeté par votre banque.\u003Cp\u003EPour régulariser la situation, vous avez la possibilité de relancer une fois votre prélèvement.\u003C\u002Fp\u003E\u003Cp\u003EAvant cela, assurez vous que votre compte dispose du montant nécessaire.\u003C\u002Fp\u003E\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"close()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-waterblue\" ng-if=\"$root.dataFeature['invoiceRegulateByCreditCard']\" ng-click=\"regulateByCreditCard()\"\u003EPayer par CB\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"submit()\"\u003ERelancer le prélèvement\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"isSubmitted\"\u003E\u003Cp\u003ENous allons donc représenter à votre banque le prélèvement de {{situationSelected.estimatedAmount | frAmount}}&euro;.\nIl sera effectivement prélevé sur votre compte d'ici 3 à 4 jours.\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"close()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"pay-next-payment-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003EPayer la prochaine échéance\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!isSubmitted\"\u003E\u003Cp\u003EVous pouvez payer la prochaine échéange dès maintenant.\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"close()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"submit()\"\u003EPayer la prochaine échéance\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"isSubmitted\"\u003E\u003Cp\u003ENous allons donc présenter à votre banque le prélèvement de la prochaine échéance.\nIl sera effectivement prélevé sur votre compte d'ici 3 à 4 jours.\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"close()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


invoiceSituationTimeline.$inject = ["$timeout", "DeviceChecker"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = invoiceSituationTimeline;

/** @ngInject */

function invoiceSituationTimeline($timeout, DeviceChecker) {
    return {
        restrict: 'E',
        scope: {
            situations: '=',
            selectedSituation: '=',
            onSituationSelected: '&'
        },
        template: __webpack_require__(938)(),
        link: function link($scope, element) {
            $scope.payStatus = { SUCCESS: 'SUCCESS', FAIL: 'FAIL', PENDING: 'PENDING' };
            $scope.position = $scope.situations.indexOf($scope.selectedSituation);
            $scope.selectSituation = function (situation) {
                return $scope.onSituationSelected({ situation: situation });
            };

            var scrollTimeline = function scrollTimeline(position) {
                var $timeline = element.find('.timeline');
                var $timelineOld = element.find('.timeline-item.timeline-item-timetable.timeline-item-timetable-old');
                var movePosition = $timelineOld.outerWidth() * position;
                return $timeline.animate({ scrollLeft: movePosition }, 200, 'linear');
            };

            $scope.canMoveToLeft = function () {
                return $scope.position > 0;
            };

            $scope.canMoveToRight = function () {
                return $scope.position < $scope.situations.length - 1;
            };

            $scope.scroll = function (direction) {
                if (!DeviceChecker.isMobile()) {
                    var canMoveToLeft = direction === 'LEFT' && $scope.canMoveToLeft();
                    var canMoveToRight = direction === 'RIGHT' && $scope.canMoveToRight();
                    if (canMoveToLeft || canMoveToRight) {
                        $scope.position = direction === 'LEFT' ? $scope.position - 1 : $scope.position + 1;
                        scrollTimeline($scope.position);
                    }
                }

                return true;
            };

            $scope.scrollToActive = function () {
                if (!DeviceChecker.isMobile()) {
                    $scope.position = $scope.situations.indexOf($scope.selectedSituation);
                    scrollTimeline($scope.position);
                }
                return true;
            };

            return $scope.$watch('selectedSituation', function () {
                return $timeout($scope.scrollToActive);
            });
        }
    };
}

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"timeline-wrapper\"\u003E\u003Cdiv class=\"timeline-scroll timeline-scroll-left hidden-xs\" ng-click=\"scroll('LEFT')\" ng-class=\"{'timeline-scroll-hidden': !canMoveToLeft()}\"\u003E\u003Ci class=\"fa fa-3x fa-angle-double-left\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"timeline\"\u003E\u003Cdiv class=\"timeline-item timeline-item-timetable timeline-item-timetable-old hidden-xs\"\u003E\u003Cdiv class=\"info text-center\"\u003E\u003Cimg class=\"text-center\" src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Ficonbill.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bar\"\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"date\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"timeline-item timeline-item-current\" ng-repeat=\"d in situations\" ng-click=\"onSituationSelected({situation: d})\" ng-class=\"{      'timeline-item-success': d.payStatus === payStatus.SUCCESS,      'timeline-item-fail': d.payStatus === payStatus.FAIL,      'timeline-item-pending': d.payStatus === payStatus.PENDING,      'active': d === selectedSituation    }\"\u003E\u003Cdiv class=\"info text-center\"\u003E\u003Cspan class=\"info-amount visible-xs-inline\"\u003E{{d.estimatedAmount | frAmount}}&euro;\u003C\u002Fspan\u003E\u003Cimg class=\"text-center\" ng-if=\"d.payStatus === payStatus.SUCCESS\" src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Fsuccess.svg\"\u003E\u003Cimg class=\"text-center\" ng-if=\"d.payStatus === payStatus.FAIL\" src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Ffail.svg\"\u003E\u003Cspan class=\"info-amount hidden-xs\"\u003E{{d.estimatedAmount | frAmount}}&euro;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bar\"\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"date\"\u003E{{ d.consPeriod | date: 'MMM yyyy' }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"timeline-item timeline-item-timetable timeline-item-timetable-new hidden-xs\"\u003E\u003Cdiv class=\"info text-center\"\u003E\u003Cimg class=\"text-center\" src=\"\u002Fassets\u002Fimg\u002Finvoice\u002Ficonbill.svg\"\u003E\u003Cspan class=\"info-amount\"\u003ENouvel échéancier\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bar\"\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"date\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"timeline-scroll timeline-scroll-right hidden-xs\" ng-click=\"scroll('RIGHT')\" ng-class=\"{'timeline-scroll-hidden': !canMoveToRight()}\"\u003E\u003Ci class=\"fa fa-3x fa-angle-double-right\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


invoiceCtrl.$inject = ["$scope", "$q", "$uibModal", "$rootScope", "ErrorCatcher", "Contract", "ContractStatus", "invoices", "userInfo", "userAction", "transaction"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isString2 = __webpack_require__(205);

var _isString3 = _interopRequireDefault(_isString2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = invoiceCtrl;

/** @ngInject */

function invoiceCtrl($scope, $q, $uibModal, $rootScope, ErrorCatcher, Contract, ContractStatus, invoices, userInfo, userAction, transaction) {
    $scope.data = invoices;
    $scope.userInfo = userInfo;
    $scope.userAction = userAction;
    $scope.transation = transaction;

    $scope.isSelectedContractActive = function () {
        return userInfo.contractSelected.status !== ContractStatus.resilie;
    };
    $scope.isUserContractActive = function () {
        return userInfo.contractSelected.status === ContractStatus.enService;
    };
    $scope.isSelectedContractHasPot = function () {
        return userInfo.contractSelected.providerOffer.has_pot;
    };

    $scope.updateInvoices = function () {
        return Contract.getInvoices({ id: userInfo.contractSelected.id }).$promise.catch(function (error) {
            ErrorCatcher.catchError(error);
            return $q.resolve({ currentSituation: {}, invoices: [] });
        }).then(function (invoicesData) {
            $scope.data = invoicesData;
        });
    };

    var openTransactionStatusPopup = function openTransactionStatusPopup() {
        if ($rootScope.dataFeature.invoiceRegulateByCreditCard && (0, _isString3.default)(transaction.transactionStatus)) {
            $uibModal.open({
                animation: true,
                template: __webpack_require__(940)(),
                resolve: {
                    transaction: function transaction() {
                        return $scope.transation;
                    }
                },
                controller: ["$scope", "$uibModalInstance", "transaction", function controller($scope, $uibModalInstance, transaction) {
                    $scope.transaction = transaction;
                    $scope.isTransationSuccess = transaction.transactionStatus === 'success';
                    $scope.close = function () {
                        return $uibModalInstance.dismiss();
                    };
                }]
            });
        }
    };

    var activate = function activate() {
        return openTransactionStatusPopup();
    };

    activate();
}

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"transaction-status-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\" ng-if=\"isTransationSuccess\"\u003EPaiement confirmé\u003C\u002Fh4\u003E\u003Ch4 class=\"marine\" ng-if=\"!isTransationSuccess\"\u003EPaiement rejeté\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"isTransationSuccess\"\u003E\u003Cp\u003EVotre paiement\u003Cspan ng-if=\"transaction.payment.amount\"\u003E de {{transaction.payment.amount | frAmount}}€\u003C\u002Fspan\u003E par carte bancaire a bien été effectué.\u003C\u002Fp\u003E\u003Cp\u003EMerci !\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"close()\"\u003ERetourner sur espace-client.plum.fr\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!isTransationSuccess\"\u003E\u003Cp\u003EVotre paiement\u003Cspan ng-if=\"transaction.payment.amount\"\u003E de {{transaction.payment.amount | frAmount}}€\u003C\u002Fspan\u003E par carte bancaire a été refusé par votre banque.\u003C\u002Fp\u003E\u003Cp\u003EAssurez-vous auprès d’elle que vous disposez des fonds nécessaires.\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"close()\"\u003ERetourner sur espace-client.plum.fr\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map3 = __webpack_require__(203);

var _map4 = _interopRequireDefault(_map3);

var _toPairs2 = __webpack_require__(942);

var _toPairs3 = _interopRequireDefault(_toPairs2);

var _groupBy2 = __webpack_require__(947);

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _flow2 = __webpack_require__(133);

var _flow3 = _interopRequireDefault(_flow2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _sumBy2 = __webpack_require__(951);

var _sumBy3 = _interopRequireDefault(_sumBy2);

var _compact2 = __webpack_require__(324);

var _compact3 = _interopRequireDefault(_compact2);

var _capitalize2 = __webpack_require__(953);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _orderBy2 = __webpack_require__(959);

var _orderBy3 = _interopRequireDefault(_orderBy2);

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

var _map5 = __webpack_require__(53);

var _map6 = _interopRequireDefault(_map5);

var _keyBy2 = __webpack_require__(964);

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _partition2 = __webpack_require__(965);

var _partition3 = _interopRequireDefault(_partition2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // https://github.com/lodash/lodash/wiki/FP-Guide


var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InvoicePaymentTableCtrl = function () {
    /** @ngInject */
    InvoicePaymentTableCtrl.$inject = ["$filter", "$window", "PaymentStatus", "PaymentModes", "Invoice", "Contract", "ContractService", "ErrorCatcher", "ApiService"];
    function InvoicePaymentTableCtrl($filter, $window, PaymentStatus, PaymentModes, Invoice, Contract, ContractService, ErrorCatcher, ApiService) {
        _classCallCheck(this, InvoicePaymentTableCtrl);

        this.$filter = $filter;
        this.$window = $window;
        this.PaymentModes = PaymentModes;
        this.Invoice = Invoice;
        this.Contract = Contract;
        this.ContractService = ContractService;
        this.PaymentStatus = PaymentStatus;
        this.ErrorCatcher = ErrorCatcher;
        this.ApiService = ApiService;
        this.currentDate = new Date();
        this.paymentsData = [];
        this.isRegularizing = false;
    }

    _createClass(InvoicePaymentTableCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.ApiService.fetchUserInfo().then(function (userInfo) {
                _this.computedPaymentMode = userInfo.billingaccount.recurrent_cb_payment ? 'CB' : 'SEPA';
            });
            this.Invoice.getPayments({ id_contract: this.contract.id }).$promise.then(function (result) {
                _this.paymentsData = InvoicePaymentTableCtrl.transformPaymentsData(result);
            }).catch(this.ErrorCatcher.catchError);
        }
    }, {
        key: 'sumBy',


        // sumBy('1.23', '1.23') => 2.46
        value: function sumBy() {
            var encodeToCents = function encodeToCents(number) {
                return Number(number) * 100;
            };
            var decodeFromCents = function decodeFromCents(number) {
                return Number(number) / 100;
            };

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return decodeFromCents((0, _sumBy3.default)(args, encodeToCents));
        }
    }, {
        key: 'getPaymentTypeLabel',
        value: function getPaymentTypeLabel(payment) {
            var formattedValueDate = this.$filter('elision')((0, _moment2.default)(payment.value_date).format('MMMM YYYY'));
            switch (payment.type) {
                case 'TT':
                    return '\xC9ch\xE9ance ' + formattedValueDate;
                case 'REC':
                    return 'R\xE9gularisation ' + formattedValueDate;
                case 'REG':
                    return 'Facture de r\xE9gularisation ' + formattedValueDate;
                case 'MISC':
                    return 'Frais';
                case 'BURN':
                    return 'Utilisation de la cagnotte';
                default:
                    return 'Inconnu';
            }
        }
    }, {
        key: 'getPaymentStatusLabel',
        value: function getPaymentStatusLabel(payment) {
            if (payment.status <= 50 && payment.status <= 55) {
                var paymentDateDelay = payment.mode === 'CB' ? (0, _moment2.default)().add(-9, 'hours') : (0, _moment2.default)().add(-5, 'days');
                var paymentValidated = (0, _moment2.default)(payment.payment_date).isBefore(paymentDateDelay);
                return paymentValidated ? 'Payé' : 'En cours de traitement';
            }
            return (0, _get3.default)(this.PaymentStatus, payment.status, 'Inconnu');
        }
    }, {
        key: 'getPaymentModeLabel',
        value: function getPaymentModeLabel(paymentMode) {
            return (0, _get3.default)(this.PaymentModes, paymentMode, 'Inconnu');
        }
    }, {
        key: 'displayNegativeBalance',
        value: function displayNegativeBalance() {
            return this.ContractService.isContractNegativeBalance(this.ContractService.NEGATIVE_BALANCE_THRESHOLD)(this.contract);
        }
    }, {
        key: 'displayRegulateBtn',
        value: function displayRegulateBtn() {
            return this.ContractService.isContractNegativeBalance(this.ContractService.REGULATE_BTN_THRESHOLD)(this.contract);
        }
    }, {
        key: 'regulateByCreditCard',
        value: function regulateByCreditCard() {
            this.$uibModal.open({
                animation: true,
                resolve: { unpaidContract: this.contract },
                component: 'unpaidBalanceModal'
            });
        }
    }, {
        key: 'regularizeByCreditCard',
        value: function regularizeByCreditCard() {
            var _this2 = this;

            this.isRegularizing = true;
            this.Contract.regularize({ id: this.contract.id }).$promise.then(function (result) {
                _this2.$window.location = result.redirectUrl;
            }).catch(function (error) {
                _this2.isRegularizing = false;
                _this2.ErrorCatcher.catchError(error);
                _this2.error = error;
            });
        }
    }], [{
        key: 'transformPaymentsData',
        value: function transformPaymentsData(data) {
            var plannedAndOtherPayments = (0, _partition3.default)(data, { status: 0 });
            var burnAndOtherPayments = (0, _partition3.default)(plannedAndOtherPayments[1], { type: 'BURN' });

            // Group burn payment with TT payment
            var burnPaymentByValueDate = (0, _keyBy3.default)(burnAndOtherPayments[0], function (p) {
                return (0, _moment2.default)(p.value_date).format('MM-YYYY');
            });
            var otherPaymentsWithBurnPayment = (0, _map6.default)(burnAndOtherPayments[1], function (p) {
                return (0, _assign3.default)({}, p, { burnPayment: p.type === 'TT' ? burnPaymentByValueDate[(0, _moment2.default)(p.value_date).format('MM-YYYY')] : undefined });
            });

            // Create datastructure for mobile view
            var burnMobilePayments = (0, _isEmpty3.default)(plannedAndOtherPayments[0]) ? null : ['Paiement programmé', plannedAndOtherPayments[0]];
            var otherMobilePayments = (0, _flow3.default)((0, _groupBy3.default)(function (p) {
                return (0, _moment2.default)(p.payment_date).startOf('month').toISOString();
            }), _toPairs3.default, function (payments) {
                return (0, _orderBy3.default)(payments, [function (p) {
                    return p[0];
                }], ['desc']);
            }, (0, _map4.default)(function (p) {
                return [(0, _capitalize3.default)((0, _moment2.default)(p[0]).format('DD MMMM YYYY')), (0, _orderBy3.default)(p[1], ['payment_date'], ['desc'])];
            }))(otherPaymentsWithBurnPayment);

            return {
                desktopPayments: [plannedAndOtherPayments[0], otherPaymentsWithBurnPayment],
                mobilePayments: (0, _compact3.default)([burnMobilePayments].concat(otherMobilePayments))
            };
        }
    }]);

    return InvoicePaymentTableCtrl;
}();

exports.default = {
    template: __webpack_require__(966)(),
    controller: InvoicePaymentTableCtrl,
    bindings: {
        contract: '<'
    }
};

/***/ }),
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"hidden-xs\"\u003E\u003Cdiv class=\"text-center margin-top-40 margin-bottom-50\"\u003E\u003Ch1 class=\"margin-top-15 bold\"\u003EMes paiements\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row top-info\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-9\"\u003E\u003Cdiv class=\"top-info-status\" ng-if=\"$ctrl.displayNegativeBalance()\"\u003E\u003Cspan\u003EMon solde Plüm :&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"light-pink\"\u003E{{$ctrl.contract.contractBalance.balance}}€\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$root.dataFeature['invoiceRegulateByCreditCard'] &amp;&amp; $ctrl.displayRegulateBtn()\"\u003E\u003Cspan\u003E&nbsp;|&nbsp;\u003C\u002Fspan\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" ng-class=\"{'btn-spinner-loading': $ctrl.isRegularizing}\" ng-disabled=\"$ctrl.isRegularizing\" ng-click=\"$ctrl.regularizeByCreditCard()\"\u003ERégler par carte\u003C\u002Fbutton\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-info-status\" ng-if=\"!$ctrl.displayNegativeBalance()\"\u003E\u003Cspan\u003ETous vos paiements sont&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"waterblue\"\u003Eà jour !\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-3 text-right\"\u003E\u003Cspan\u003EÀ jour au {{ $ctrl.currentDate | amDateFormat:'DD MMMM YYYY - HH:mm' }}\u003C\u002Fspan\u003E\u003Cdiv class=\"inline-block\"\u003E\u003Ca class=\"btn background-waterblue\" href=\"\u002Fapi-user\u002Fdocuments\u002F{{$ctrl.contract.id}}\u002Ftimetable?fs=stream\" target=\"_blank\"\u003ETélécharger mon échéancier\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-panel\" ng-if=\"!$ctrl.paymentsData.desktopPayments[0].length &amp;&amp; !$ctrl.paymentsData.desktopPayments[1].length\"\u003E\u003Cdiv class=\"large-main-panel\"\u003E\u003Cp\u003EVous n'avez pas de paiement pour le moment.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"payments in $ctrl.paymentsData.desktopPayments\" ng-if=\"payments.length &gt; 0\"\u003E\u003Ch4 ng-if=\"$index === 0\"\u003EPaiements à venir\u003C\u002Fh4\u003E\u003Ch4 ng-if=\"$index === 1\"\u003EPaiements déjà réalisés\u003C\u002Fh4\u003E\u003Ctable class=\"table margin-bottom-50\"\u003E\u003Cthead class=\"background-marine\"\u003E\u003Ctr\u003E\u003Cth class=\"text-right\"\u003EMontant\u003C\u002Fth\u003E\u003Cth\u003EPrévu le\u003C\u002Fth\u003E\u003Cth\u003EMotif\u003C\u002Fth\u003E\u003Cth\u003EÉtat du paiement\u003C\u002Fth\u003E\u003Cth\u003EMoyen de paiement\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody class=\"background-white\" ng-repeat=\"p in payments\"\u003E\u003Ctr\u003E\u003Ctd class=\"text-right\"\u003E\u003Cspan ng-if=\"!p.burnPayment\"\u003E{{ p.amount | frAmount }}€\u003C\u002Fspan\u003E\u003Cspan ng-if=\"p.burnPayment\"\u003E\u003Cdel\u003E{{ $ctrl.sumBy(p.amount, p.burnPayment.amount) | frAmount }}€\u003C\u002Fdel\u003E\u003Cbr\u003E{{ p.amount | frAmount }}€\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E{{ p.payment_date | amDateFormat:'DD MMMM YYYY' }}\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan ng-if=\"!p.burnPayment\"\u003E{{ $ctrl.getPaymentTypeLabel(p) }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"p.burnPayment\"\u003E{{ $ctrl.getPaymentTypeLabel(p) }}\u003Cbr\u003E({{ p.burnPayment.amount | frAmount }}€ de {{ $ctrl.getPaymentModeLabel(p.burnPayment.mode) }} utilisée)\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"payment-status payment-status-{{p.status}}\"\u003E{{ $ctrl.getPaymentStatusLabel(p) }}\u003C\u002Ftd\u003E\u003Ctd\u003E{{ $ctrl.getPaymentModeLabel(p.status === 0 ? $ctrl.computedPaymentMode : p.mode) }} {{p.status === 0 ? $ctrl.computedPaymentMode : p.mode}}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch1 class=\"margin-top-15 bold\"\u003EMes paiements\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-info text-center\"\u003E\u003Cdiv class=\"top-info-status\" ng-if=\"$ctrl.displayNegativeBalance()\"\u003E\u003Cdiv\u003EMon solde Plüm\u003C\u002Fdiv\u003E\u003Cdiv class=\"light-pink\"\u003E{{$ctrl.contract.contractBalance.balance}}€\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" ng-if=\"$root.dataFeature['invoiceRegulateByCreditCard'] &amp;&amp; $ctrl.displayRegulateBtn()\" ng-class=\"{'btn-spinner-loading': $ctrl.isRegularizing}\" ng-disabled=\"$ctrl.isRegularizing\" ng-click=\"$ctrl.regularizeByCreditCard()\"\u003ERégler par carte\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-info-status\" ng-if=\"!$ctrl.displayNegativeBalance()\"\u003E\u003Cspan\u003ETous vos paiements sont&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"waterblue\"\u003Eà jour !\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"top-panel\" ng-if=\"!$ctrl.paymentsData.mobilePayments.length\"\u003E\u003Cdiv class=\"large-main-panel\"\u003E\u003Cp\u003EVous n'avez pas de paiement pour le moment.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"payments in $ctrl.paymentsData.mobilePayments\" ng-if=\"payments\"\u003E\u003Ch4\u003E{{payments[0]}}\u003C\u002Fh4\u003E\u003Cdiv class=\"main-panel flex flex-align-items flex-space-between\" ng-repeat=\"p in payments[1]\"\u003E\u003Cdiv\u003E\u003Cdiv class=\"fw-500\"\u003E{{ $ctrl.getPaymentTypeLabel(p) }}\u003C\u002Fdiv\u003E\u003Cdiv\u003E({{ $ctrl.getPaymentModeLabel(p.mode) }})\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cspan class=\"payment-status payment-status-{{p.status}}\"\u003E{{ $ctrl.getPaymentStatusLabel(p) }}\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;\u003C\u002Fspan\u003E\u003Cspan\u003Ele {{ p.payment_date | amDateFormat:'DD MMMM YYYY' }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"amount text-right\"\u003E\u003Cdiv ng-if=\"!p.burnPayment\"\u003E\u003Cdiv class=\"fw-500 fs-20\"\u003E{{ p.amount | frAmount }}€\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"p.burnPayment\"\u003E\u003Cdiv class=\"line-through fw-500 fs-16\"\u003E{{ $ctrl.sumBy(p.amount, p.burnPayment.amount) | frAmount }}€\u003C\u002Fdiv\u003E\u003Cdiv class=\"gold fw-500 fs-16\"\u003E{{ p.burnPayment.amount | frAmount }}€\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cdiv class=\"fw-500 fs-20\"\u003E{{ p.amount | frAmount }}€\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _mandateConfirmation = __webpack_require__(968);

var _mandateConfirmation2 = _interopRequireDefault(_mandateConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.mandateConfirmation', []).component('mandateConfirmation', _mandateConfirmation2.default).name;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MandateConfirmationController = function () {
    function MandateConfirmationController() {
        _classCallCheck(this, MandateConfirmationController);
    }

    _createClass(MandateConfirmationController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.transaction.transactionStatus === 'success') {
                this.viewState = 'state-mandate-success';
            } else if (this.transaction.transactionStatus === 'failure') {
                this.viewState = 'state-mandate-failure';
            } else {
                this.viewState = 'state-mandate-default';
            }
        }
    }]);

    return MandateConfirmationController;
}();

exports.default = {
    template: __webpack_require__(969)(),
    controller: MandateConfirmationController,
    bindings: {
        transaction: '<'
    }
};

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-mandate-success'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EMOYEN DE PAIEMENT ENREGISTRÉ\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Faccepted.svg\"\u003E\u003Cspan\u003EMoyen de paiement enregistré\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003EVotre autorisation de prélèvement est signée.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-30\"\u003EMerci de votre confiance en Plüm énergie.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"invoice\"\u003EMON ESPACE CLIENT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-mandate-failure'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EMOYEN DE PAIEMENT NON ENREGISTRÉ\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Frejected.svg\"\u003E\u003Cspan\u003EMoyen de paiement non enregistré\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003EVotre autorisation de prélèvement n'a pas été signée.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-30\"\u003EVous pouvez contacter le service client via le formulaire de contact se trouvant sur votre espace personnel.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-marine\" ui-sref=\"invoice\"\u003EMON ESPACE CLIENT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-mandate-default'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EMOYEN DE PAIEMENT EN COURS DE TRAITEMENT\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Fpending.svg\"\u003E\u003Cspan\u003ELa transaction est en cours\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003ESi vous venez de modifier votre moyen de paiement, il est en cours de traitement.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"invoice\"\u003EMON ESPACE CLIENT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _priceModal = __webpack_require__(971);

var _priceModal2 = _interopRequireDefault(_priceModal);

var _subscriptionModal = __webpack_require__(973);

var _subscriptionModal2 = _interopRequireDefault(_subscriptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
/**
 * Transversal modals over all states
 */
exports.default = _angular2.default.module('unergie.commonModal', []).component('priceModal', _priceModal2.default).component('subscriptionModal', _subscriptionModal2.default).name;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PriceModalCtrl = function () {
    /** @ngInject */
    PriceModalCtrl.$inject = ["gaEventsService"];
    function PriceModalCtrl(gaEventsService) {
        _classCallCheck(this, PriceModalCtrl);

        this.gaEventsService = gaEventsService;
    }

    _createClass(PriceModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.gaEventsService.newEvent('open modal - Tarifs');
            this.filter = {
                offerType: 'BASE',
                power: 6,
                availablePowers: this.resolve.availablePowers
            };
        }
    }]);

    return PriceModalCtrl;
}();

exports.default = {
    template: __webpack_require__(972)(),
    controller: PriceModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"price-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch2 class=\"marine\"\u003ETarifs Plüm énergie\u003C\u002Fh2\u003E\u003Cform class=\"form-horizontal price-filter\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-6 control-label\"\u003EQuelle est votre offre tarifaire ?\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cspan class=\"offer-radio visible-xs-block\" ng-click=\"$ctrl.filter.offerType = 'BASE'\"\u003E\u003Cp\u003Ebase \u003Csup\u003E(1)\u003C\u002Fsup\u003E\u003C\u002Fp\u003E\u003Cdiv class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.filter.offerType === 'BASE'}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"offer-radio hidden-xs\" ng-click=\"$ctrl.filter.offerType = 'BASE'\"\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.filter.offerType === 'BASE'}\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003Ebase\u003C\u002Fspan\u003E\u003Csup\u003E(1)\u003C\u002Fsup\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cspan class=\"offer-radio visible-xs-block\" ng-click=\"$ctrl.filter.offerType = 'HPHC'\"\u003E\u003Cp\u003Eheures&nbsp;pleines \u002F heures&nbsp;creuses\u003C\u002Fp\u003E\u003Cdiv class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.filter.offerType === 'HPHC'}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"offer-radio hidden-xs\" ng-click=\"$ctrl.filter.offerType = 'HPHC'\"\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.filter.offerType === 'HPHC'}\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003Eheures&nbsp;pleines \u002F heures&nbsp;creuses\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-6 control-label\"\u003EQuelle est la puissance de votre compteur ?\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cselect class=\"form-control\" ng-model=\"$ctrl.filter.power\" ng-options=\"item as item + ' kVA' for item in $ctrl.filter.availablePowers[$ctrl.filter.offerType].availablePowers\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cdiv class=\"price-comparison text-center container visible-xs-block\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-4 col-xs-offset-1 logo\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fedf-logo.svg\"\u003E\u003Csup\u003E(2)\u003C\u002Fsup\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-4 logo\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Flogo.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row head mobile-title\"\u003E\u003Cdiv class=\"col-xs-12\"\u003EType d’énergie\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row head\"\u003E\u003Cdiv class=\"col-xs-4 col-xs-offset-1\"\u003Eclassique\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-4\"\u003Everte\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row mobile-title\"\u003E\u003Cdiv class=\"col-xs-12\"\u003EAbonnement mensuel\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-4 col-xs-offset-1\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.edf[$ctrl.filter.offerType][$ctrl.filter.power].abo | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-4\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.plum[$ctrl.filter.offerType][$ctrl.filter.power].abo | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row mobile-title\" ng-if=\"$ctrl.filter.offerType === 'BASE'\"\u003E\u003Cdiv class=\"col-xs-12\"\u003EkWh\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.filter.offerType === 'BASE'\"\u003E\u003Cdiv class=\"col-xs-4 col-xs-offset-1\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.edf[$ctrl.filter.offerType][$ctrl.filter.power].base | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-4\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.plum[$ctrl.filter.offerType][$ctrl.filter.power].base | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3 cell-price-difference\"\u003E-4% \u003Csup\u003E(3)\u003C\u002Fsup\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row mobile-title\" ng-if=\"$ctrl.filter.offerType === 'HPHC'\"\u003E\u003Cdiv class=\"col-xs-12\"\u003EkWh heures pleines\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.filter.offerType === 'HPHC'\"\u003E\u003Cdiv class=\"col-xs-4 col-xs-offset-1\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.edf[$ctrl.filter.offerType][$ctrl.filter.power].hp | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-4\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.plum[$ctrl.filter.offerType][$ctrl.filter.power].hp | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3 cell-price-difference\"\u003E-4% \u003Csup\u003E(3)\u003C\u002Fsup\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row mobile-title\" ng-if=\"$ctrl.filter.offerType === 'HPHC'\"\u003E\u003Cdiv class=\"col-xs-12\"\u003EkWh heures creuses\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.filter.offerType === 'HPHC'\"\u003E\u003Cdiv class=\"col-xs-4 col-xs-offset-1\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.edf[$ctrl.filter.offerType][$ctrl.filter.power].hc | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-4\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.plum[$ctrl.filter.offerType][$ctrl.filter.power].hc | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3 cell-price-difference\"\u003E-4% \u003Csup\u003E(3)\u003C\u002Fsup\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"price-comparison text-center container hidden-xs\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3 logo\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fedf-logo.svg\"\u003E\u003Csup\u003E(2)\u003C\u002Fsup\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3 logo\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Flogo.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-2 cell-price-difference\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row head\"\u003E\u003Cdiv class=\"col-sm-4\"\u003EType d’énergie\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003Eclassique\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003Everte\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-2 cell-price-difference\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003EAbonnement mensuel\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.edf[$ctrl.filter.offerType][$ctrl.filter.power].abo | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.plum[$ctrl.filter.offerType][$ctrl.filter.power].abo | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-2 cell-price-difference\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.filter.offerType === 'BASE'\"\u003E\u003Cdiv class=\"col-sm-4\"\u003EkWh\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.edf[$ctrl.filter.offerType][$ctrl.filter.power].base | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.plum[$ctrl.filter.offerType][$ctrl.filter.power].base | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-2 cell-price-difference\"\u003E-4% \u003Csup\u003E(3)\u003C\u002Fsup\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.filter.offerType === 'HPHC'\"\u003E\u003Cdiv class=\"col-sm-4\"\u003EkWh heures pleines\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.edf[$ctrl.filter.offerType][$ctrl.filter.power].hp | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.plum[$ctrl.filter.offerType][$ctrl.filter.power].hp | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-2 cell-price-difference\"\u003E-4% \u003Csup\u003E(3)\u003C\u002Fsup\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.filter.offerType === 'HPHC'\"\u003E\u003Cdiv class=\"col-sm-4\"\u003EkWh heures creuses\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.edf[$ctrl.filter.offerType][$ctrl.filter.power].hc | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Cspan ng-bind=\"$ctrl.resolve.tariffInfo.plum[$ctrl.filter.offerType][$ctrl.filter.power].hc | frAmount: {maximumFractionDigits: 4}\"\u003E\u003C\u002Fspan\u003E&nbsp;&euro;\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-2 cell-price-difference\"\u003E-4% \u003Csup\u003E(3)\u003C\u002Fsup\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"price-action text-center\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Ca class=\"btn btn-price-tarif btn-same-width background-light-pink round\" href=\"\u002Fdocumentation\u002Ffis.pdf\" target=\"blank\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fbouton-grille-tarif.svg\"\u003E\u003Cspan\u003EGrille des tarifs\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Ca class=\"btn btn-price-close btn-same-width background-light-pink outline round\" ng-click=\"$ctrl.close()\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcross.svg\"\u003E\u003Cspan\u003EFermer la fenêtre\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"detail\"\u003E(1) Base = sans heures creuses (2) Offre « tarif bleu », tarifs réglementés par l’état (3) Réductions sur le prix HT du kWh.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SubscriptionModalCtrl = function () {
    /** @ngInject */
    SubscriptionModalCtrl.$inject = ["$state", "gaEventsService"];
    function SubscriptionModalCtrl($state, gaEventsService) {
        _classCallCheck(this, SubscriptionModalCtrl);

        this.$state = $state;
        this.gaEventsService = gaEventsService;
    }

    _createClass(SubscriptionModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.redirectTo = null;
            this.gaEventsService.newEvent('open modal - Modal Souscription ChangementFournisseur/Emmenagement');
        }
    }, {
        key: 'redirect',
        value: function redirect(redirectTo) {
            if (redirectTo === 'subscriptionChangementFournisseur') {
                this.gaEventsService.newEvent('click - Je change de fournisseur dans mon logement actuel');
            } else if (redirectTo === 'subscriptionEmmenagement') {
                this.gaEventsService.newEvent('click - J’emménage dans un nouveau logement');
            }
            this.$state.go(redirectTo, this.stateParams || {});
            this.close();
        }
    }]);

    return SubscriptionModalCtrl;
}();

exports.default = {
    template: __webpack_require__(974)(),
    controller: SubscriptionModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"subscription-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cdiv class=\"details\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 text-center\" ng-click=\"$ctrl.redirectTo = 'subscriptionChangementFournisseur'\"\u003E\u003Cdiv class=\"detail\" ng-class=\"{'detail-active': $ctrl.redirectTo === 'subscriptionChangementFournisseur'}\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fswitch.svg\"\u003E\u003Cp\u003EJe change de fournisseur dans mon logement actuel\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.redirectTo === 'subscriptionChangementFournisseur'}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 text-center\" ng-click=\"$ctrl.redirectTo = 'subscriptionEmmenagement'\"\u003E\u003Cdiv class=\"detail\" ng-class=\"{'detail-active': $ctrl.redirectTo === 'subscriptionEmmenagement'}\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Fmove-in.svg\"\u003E\u003Cp\u003EJ’emménage dans un nouveau logement\u003C\u002Fp\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{checked: $ctrl.redirectTo === 'subscriptionEmmenagement'}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.redirect($ctrl.redirectTo)\" ng-disabled=\"!$ctrl.redirectTo\"\u003ECONTINUER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _navbar = __webpack_require__(976);

var _navbar2 = _interopRequireDefault(_navbar);

var _navbarDashboard = __webpack_require__(977);

var _navbarDashboard2 = _interopRequireDefault(_navbarDashboard);

var _navbarMenu = __webpack_require__(979);

var _navbarMenu2 = _interopRequireDefault(_navbarMenu);

var _navbarMenuDesktopFixed = __webpack_require__(981);

var _navbarMenuDesktopFixed2 = _interopRequireDefault(_navbarMenuDesktopFixed);

var _navPlumScrollable = __webpack_require__(982);

var _navPlumScrollable2 = _interopRequireDefault(_navPlumScrollable);

var _unpaidBalanceModal = __webpack_require__(983);

var _unpaidBalanceModal2 = _interopRequireDefault(_unpaidBalanceModal);

var _changePaymentDayModal = __webpack_require__(985);

var _changePaymentDayModal2 = _interopRequireDefault(_changePaymentDayModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.navbar', []).controller('navbarCtrl', _navbar2.default).directive('navbarDashboard', _navbarDashboard2.default).directive('navbarMenu', _navbarMenu2.default).directive('navbarMenuDesktopFixed', _navbarMenuDesktopFixed2.default).directive('navPlumScrollable', _navPlumScrollable2.default).component('unpaidBalanceModal', _unpaidBalanceModal2.default).component('changePaymentDayModal', _changePaymentDayModal2.default).name;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navbarCtrl.$inject = ["$rootScope", "$scope", "$state", "$uibModal", "$window", "$anchorScroll", "$location", "$cookies", "AlertManager", "smoothScroll", "ReportManager", "PermPermissionStore", "DeviceChecker", "PotManager", "gaEventsService", "userCommunityService", "ContractService", "ContractStatus", "PrmUtilsService", "DataAccessVariables", "ErrorCatcher", "features", "userInfo"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _first2 = __webpack_require__(314);

var _first3 = _interopRequireDefault(_first2);

var _filter2 = __webpack_require__(313);

var _filter3 = _interopRequireDefault(_filter2);

var _flow2 = __webpack_require__(133);

var _flow3 = _interopRequireDefault(_flow2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _contract = __webpack_require__(320);

var _contract2 = _interopRequireDefault(_contract);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navbarCtrl;

/** @ngInject */
/* eslint-disable
 no-eq-null,
 */

function navbarCtrl($rootScope, $scope, $state, $uibModal, $window, $anchorScroll, $location, $cookies, AlertManager, smoothScroll, ReportManager, PermPermissionStore, DeviceChecker, PotManager, gaEventsService, userCommunityService, ContractService, ContractStatus, PrmUtilsService, DataAccessVariables, ErrorCatcher, features, userInfo) {
    var lastId = null;
    $scope.gaEventsService = gaEventsService;
    $scope.navCollapsed = DeviceChecker.isMobile();
    $scope.userCommunityInfo = {};
    $scope.userCommunityCount = 0;
    $scope.showNavOnMobile = $state.current.data.showNavOnMobile;
    $scope.state = $state;
    $scope.self = $scope;
    $scope.isMobile = DeviceChecker.isMobile;
    $scope.isTab = DeviceChecker.isTab;

    if (userInfo) {
        $scope.userInfo = userInfo;
        $scope.userInfo.hasContracts = $scope.userInfo.contracts.length > 0;
        $scope.report = ReportManager;
        $scope.newReport = {};
        $scope.latestReport = {};
        $scope.pot = PotManager.getPotBalance();
        PotManager.watch(function (newPot) {
            $scope.pot = newPot;
        });

        $scope.activeContracts = $scope.userInfo.contracts;

        $scope.changeContract = function (newContract) {
            if (!newContract) {
                userInfo.contractSelected = (0, _flow3.default)((0, _filter3.default)(function (c) {
                    return c.status !== ContractStatus.resilie;
                }), _first3.default)(userInfo.contracts);
            } else {
                userInfo.contractSelected = newContract;
            }
            $scope.contractSelected = userInfo.contractSelected;
            if (lastId && lastId !== userInfo.contractSelected.id) {
                return $state.go($state.current, { contractId: userInfo.contractSelected.id }, { reload: true });
            }
            return lastId = userInfo.contractSelected.id;
        };

        var check525Date = function check525Date(date) {
            var targetDate = void 0;
            if ((0, _moment2.default)().date() < 6) {
                targetDate = (0, _moment2.default)().subtract(1, 'months').date(25).startOf('day').toISOString();
                if ((0, _moment2.default)(date).isBefore(targetDate)) {
                    return true;
                }
            }

            if ((0, _moment2.default)().date() > 24) {
                targetDate = (0, _moment2.default)().date(25).startOf('day').toISOString();
                if ((0, _moment2.default)(date).isBefore(targetDate)) {
                    return true;
                }
            }
            return false;
        };

        if (userInfo.contractSelected) {
            userInfo.contractSelected.isLinky = PrmUtilsService.isLinky(userInfo.contractSelected.prm.metter_kind);
            userInfo.contractSelected.isLinkyCommunicating = userInfo.contractSelected.prm && userInfo.contractSelected.prm.communicating;
            if (!userInfo.contractSelected.isLinkyCommunicating) {
                ReportManager.updateContract(userInfo.contractSelected);
                if (check525Date(userInfo.contractSelected.lastReadings != null ? userInfo.contractSelected.lastReadings[0].end_date : undefined)) {
                    ReportManager.updateClass('input');
                }
            }
        }
    }

    $scope.logout = function () {
        AlertManager.clearAlerts();
        return $state.go('logout', {}, { reload: true });
    };

    $scope.isActive = function (state) {
        return $state.is(state) || $state.includes(state);
    };

    $scope.hasParentState = function (parent) {
        return $state.current.parent != null ? $state.current.parent.includes(parent) : undefined;
    };

    $scope.isSelectedContractActive = function () {
        return userInfo.contractSelected.status !== ContractStatus.resilie;
    };

    $scope.scrollDownIfAnonymous = function () {
        if (!$scope.isClient && $state.is('landing')) {
            return smoothScroll(document.getElementById('menu'));
        }
    };

    __guard__(PermPermissionStore.getStore().client, function (x) {
        return x.validatePermission().then(function () {
            $scope.isClient = true;
        });
    });

    $rootScope.$on('$stateChangeStart', function () {
        return __guard__(PermPermissionStore.getStore().client, function (x1) {
            return x1.validatePermission().then(function () {
                $scope.isClient = true;
            });
        });
    });

    $scope.openContactModal = function () {
        return $uibModal.open({
            animation: true,
            controller: 'contactModalCtrl',
            template: __webpack_require__(140)(),
            resolve: {
                contractSelected: function contractSelected() {
                    return $scope.contractSelected;
                },
                userInfo: function userInfo() {
                    return $scope.userInfo;
                }
            }
        });
    };

    $scope.scrollDecouvrir = function () {
        $location.hash('decouvrir');
        return $anchorScroll();
    };

    $scope.toogleNavCollapsed = function () {
        if (DeviceChecker.isMobile()) {
            $scope.navCollapsed = !$scope.navCollapsed;
        }
        return true;
    };

    $scope.getHeaderHeight = function () {
        var headerHeight = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Array.from(_angular2.default.element('.stickBelow'))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var header = _step.value;

                headerHeight += header.getBoundingClientRect().height;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return headerHeight;
    };

    $scope.getFooterHeight = function () {
        var footerHeight = 0;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = Array.from(_angular2.default.element('footer'))[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var footer = _step2.value;

                footerHeight += footer.getBoundingClientRect().height;
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = Array.from(_angular2.default.element('#fold-bottom'))[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var foldBlock = _step3.value;

                footerHeight += foldBlock.getBoundingClientRect().height;
            }
            // Super dirty : only works with footerHeight + 2px ?!
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        return footerHeight + 2;
    };

    var openUnpaidBalance = function openUnpaidBalance() {
        return DataAccessVariables.get({ variables: 'OVERDUE_THRESHOLD_POPUP' }).$promise.then(function (variables) {
            return ContractService.findFirstUnpaidContract(userInfo.contracts, variables.OVERDUE_THRESHOLD_POPUP);
        }).then(function (unpaidContract) {
            if (features.unpaidBalancePopup && !$cookies.get('hasDisplayedUnpaidBalancePopup') && unpaidContract) {
                $cookies.put('hasDisplayedUnpaidBalancePopup', true);
                $uibModal.open({
                    animation: true,
                    resolve: { unpaidContract: unpaidContract },
                    component: 'unpaidBalanceModal'
                });
            }
        }).catch(ErrorCatcher.catchError);
    };

    _angular2.default.element($window).bind('resize', function () {
        if (!$scope.$$phase) {
            return $scope.$digest();
        }
    });

    $scope.$watch(function () {
        return (0, _get3.default)($state, 'current.data.showNavOnMobile');
    }, function (showNavOnMobile) {
        $scope.showNavOnMobile = showNavOnMobile;
    });

    var fetchCommunityInfo = function fetchCommunityInfo() {
        __guard__(PermPermissionStore.getStore().client, function (x) {
            return x.validatePermission().then(function () {
                return userCommunityService.fetchCommunityInfo();
            }).then(function () {
                $scope.userCommunityInfo = userCommunityService.getUserCommunityInfo();
                $scope.userCommunityCount = userCommunityService.getChatsCount() + userCommunityService.getNotificationsCount();
            }).catch(function () {
                return false;
            });
        });
    };

    var activate = function activate() {
        openUnpaidBalance();
        fetchCommunityInfo();
    };

    activate();
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navbarDashboard.$inject = ["$state", "$uibModal", "ApiService", "ContractStatusLabel"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navbarDashboard;

/** @ngInject */

function navbarDashboard($state, $uibModal, ApiService, ContractStatusLabel) {
    return {
        restrict: 'E',
        template: __webpack_require__(978)(),
        link: function link($scope) {
            $scope.termsViewState = (0, _get3.default)(ContractStatusLabel, [$scope.userInfo.contractSelected.status, 'termsView'], ContractStatusLabel.unknown.termsView);
            $scope.canDisplayPotBurn = function () {
                var potBurnConfirmed = JSON.parse(sessionStorage.getItem('potBurnConfirmed'));
                return $scope.pot.real > 0 || potBurnConfirmed && (0, _moment2.default)().isBefore(potBurnConfirmed.expire);
            };

            $scope.openChangePaymentDayModal = function () {
                $uibModal.open({
                    animation: true,
                    size: 'lg',
                    component: 'changePaymentDayModal',
                    resolve: {
                        paymentDayInfo: ["BillingAcc", "ErrorCatcher", function paymentDayInfo(BillingAcc, ErrorCatcher) {
                            return BillingAcc.getPaymentDay().$promise.catch(ErrorCatcher.catchError);
                        }]
                    }
                }).result.then(function (result) {
                    if (result.isSubmitted) {
                        // Reload userInfo instead of reloading page (currently break transition & page animation)
                        ApiService.resetPromise('userInfo');
                        $state.go($state.current, { contractId: $scope.userInfo.contractSelected.id }, { reload: true });
                    }
                });
            };
        }
    };
}

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"dashboard container stickBelow\" ng-if=\"isClient\" permission permission-only=\"'client'\"\u003E\u003Cdiv class=\"user-infos\"\u003E\u003Cdiv class=\"user-name\"\u003EBonjour {{userInfo.givenname}}\u003Ca class=\"btn btn-contact-us background-waterblue\" ng-click=\"openContactModal()\"\u003ENous contacter\u003Cdiv class=\"bidule bidule-white bidule-button\"\u003E\u003Cdiv class=\"bidule-bot\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bidule-top\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-client-number\"\u003ERÉF. CLIENT :\u003Cspan class=\"number\"\u003E&nbsp;{{userInfo.customer_id | clientId}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator-large\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-contracts\" ng-if=\"activeContracts\"\u003E\u003Cdiv class=\"address\"\u003EADRESSE\u003Cselect class=\"form-control small user-address adress-selector\" ng-init=\"changeContract(userInfo.contractSelected)\" ng-model=\"userInfo.contractSelected\" ng-options=\"contract.prm.addr_num_street + ' - ' + contract.prm.addr_post_code + ' ' + contract.prm.addr_city_lbl for contract in activeContracts\" ng-change=\"changeContract(userInfo.contractSelected)\" ng-show=\"activeContracts.length &gt; 1\"\u003E\u003C\u002Fselect\u003E\u003Cdiv class=\"small user-address\" ng-if=\"activeContracts.length == 1\" ng-init=\"changeContract(userInfo.contractSelected)\"\u003E{{userInfo.contractSelected.prm.addr_num_street}} - {{userInfo.contractSelected.prm.addr_post_code}} {{userInfo.contractSelected.prm.addr_city_lbl}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-offer\" ng-class=\"{'marginb15 margin-top-15': isTab()}\"\u003E\u003Cdiv class=\"contract col-xs-12 no-padding\"\u003E\u003Cdiv class=\"contract-number\"\u003EN° CONTRAT : {{userInfo.contractSelected.id}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv class=\"offer col-xs-12 no-padding\"\u003E\u003Cdiv class=\"offer-type\"\u003EVOTRE OFFRE : {{userInfo.contractSelected.providerOffer.label}}\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"userInfo.contractSelected.plan\"\u003EOPTION : {{userInfo.contractSelected.plan}}\u003Cbr\u003E\u003Cspan ng-if=\"userInfo.contractSelected.off_peak_label &amp;&amp; userInfo.contractSelected.id_p_calendar !== 'BASE'\"\u003E&nbsp;({{userInfo.contractSelected.off_peak_label}})\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-terms\"\u003E\u003Cdiv ng-if=\"termsViewState === 'STATE-CONTRACT-INITIAL'\"\u003E\u003Cdiv class=\"user-next-bill\"\u003E\u003Ch3\u003EAvancement de ma commande\u003C\u002Fh3\u003E\u003Cdiv class=\"separator-large separator-marine\"\u003E\u003C\u002Fdiv\u003E\u003Caccount-status-timeline user-contract=\"userInfo.contractSelected\" display-title=\"false\"\u003E\u003C\u002Faccount-status-timeline\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"termsViewState === 'STATE-CONTRACT-ACTIVE'\"\u003E\u003Cdiv class=\"user-next-bill\"\u003E\u003Ch3\u003EMon échéancier\u003C\u002Fh3\u003E\u003Cdiv class=\"separator-large separator-marine\"\u003E\u003C\u002Fdiv\u003E\u003Ch4\u003EProchaine mensualité\u003C\u002Fh4\u003E\u003Cdiv class=\"user-next-bill-date\"\u003E{{ userInfo.contractSelected.nextPayment.date | amDateFormat:'DD MMMM YYYY' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-next-bill-amount large-amount\"\u003E{{ userInfo.contractSelected.nextPayment.amount | frAmount }}€\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-next-bill-modify-date\"\u003E\u003Cbutton class=\"btn background-marine clickable\" ng-click=\"openChangePaymentDayModal()\"\u003E\u003Cspan class=\"hidden-xs\"\u003EModifier ma date de prélèvement\u003C\u002Fspan\u003E\u003Cspan class=\"visible-xs-inline\"\u003EModifier prélèvement\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-next-report\" ng-if=\"userInfo.contractSelected &amp;&amp; !userInfo.contractSelected.isLinkyCommunicating\"\u003E\u003Ch4 class=\"next-report-title\"\u003EProchain passage Enedis\u003C\u002Fh4\u003E\u003Cdiv class=\"next-report-text\"\u003EVotre relève semestrielle est prévue aux alentours du&nbsp;\u003Cstrong\u003E{{ userInfo.contractSelected.prm.next_reading_date | amDateFormat:'DD MMMM YYYY'}}\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"termsViewState === 'STATE-CONTRACT-TERMINATED'\"\u003E\u003Cdiv class=\"user-next-bill\"\u003E\u003Ch3\u003EContrat résilié\u003C\u002Fh3\u003E\u003Cdiv class=\"separator-large separator-marine\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003ELe contrat \u003Cstrong\u003E{{ userInfo.contractSelected.id }}\u003C\u002Fstrong\u003E a été résilié.\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez créer un nouveau contrat en cliquant sur le bouton ci dessous.\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cbutton class=\"btn btn-new-contract background-waterblue\" ui-sref=\"subscription\"\u003ENouveau contrat\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"termsViewState === 'STATE-CONTRACT-CANCELED'\"\u003E\u003Cdiv class=\"user-next-bill\"\u003E\u003Ch3\u003ECommande annulée\u003C\u002Fh3\u003E\u003Cdiv class=\"separator-large separator-marine\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EVotre commande a été annulée.\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez créer un nouveau contrat en cliquant sur le bouton ci dessous.\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cbutton class=\"btn btn-new-contract background-waterblue\" ui-sref=\"subscription\"\u003ENouveau contrat\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-pot\" ng-if=\"termsViewState === 'STATE-CONTRACT-ACTIVE'\"\u003E\u003Cdiv class=\"pot\"\u003E\u003Ch3\u003EMa cagnotte\u003C\u002Fh3\u003E\u003Cdiv class=\"main-panel-value user-pot-value large-amount\"\u003E\u003Cpot-balance\u003E\u003C\u002Fpot-balance\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sub-panel no-top-radius background-gold medium\" ng-if=\"canDisplayPotBurn()\"\u003E\u003Cpot-burn user-info=\"userInfo\"\u003E\u003C\u002Fpot-burn\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$root.dataFeature['reports'] &amp;&amp; userInfo.contractSelected\"\u003E\u003Cdiv class=\"report\" ng-class=\"report.class\"\u003E\u003Ch4 ng-if=\"report.class == 'input'\"\u003EJe fais mon auto-relève pour contrôler ma consommation\u003C\u002Fh4\u003E\u003Ch4 ng-if=\"report.class != 'input'\"\u003EMa dernière relève : {{( report.contract.lastReadings[0].end_date | amDateFormat:'DD MMMM YYYY')}}&nbsp;\u003Cspan ng-if=\"report.contract.lastReadings[0].index_nature == 'AUTO-RELEVE'\"\u003E(auto-relevée)\u003C\u002Fspan\u003E\u003Cspan ng-if=\"report.contract.lastReadings[0].index_nature == 'REEL'\"\u003E(relève ENEDIS)\u003C\u002Fspan\u003E\u003Cspan ng-if=\"report.contract.lastReadings[0].index_nature == 'ESTIME'\"\u003E(estimé ENEDIS)\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003Creport class=\"dark-report\" ng-if=\"userInfo.contractSelected\" user-info=\"userInfo\"\u003E\u003C\u002Freport\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-pot\" ng-if=\"userInfo.contractSelected.status === 81 &amp;&amp; !userInfo.contractSelected.isLinkyCommunicating\"\u003E\u003Cdiv class=\"pot\"\u003E\u003Ch3\u003ERelève de compteur\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$root.dataFeature['reports'] &amp;&amp; userInfo.contractSelected\"\u003E\u003Cdiv class=\"report\" ng-class=\"report.class\"\u003E\u003Ch4 ng-if=\"report.class == 'input'\"\u003EJe fais mon auto-relève pour finaliser mon contrat\u003C\u002Fh4\u003E\u003Ch4 ng-if=\"report.class != 'input'\"\u003EMa dernière relève : {{( report.contract.lastReadings[0].end_date | amDateFormat:'DD MMMM YYYY')}}&nbsp;\u003Cspan ng-if=\"report.contract.lastReadings[0].index_nature == 'AUTO-RELEVE'\"\u003E(auto-relevée)\u003C\u002Fspan\u003E\u003Cspan ng-if=\"report.contract.lastReadings[0].index_nature == 'REEL'\"\u003E(relève ENEDIS)\u003C\u002Fspan\u003E\u003Cspan ng-if=\"report.contract.lastReadings[0].index_nature == 'ESTIME'\"\u003E(estimé ENEDIS)\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003Creport class=\"dark-report\" ng-if=\"userInfo.contractSelected\" user-info=\"userInfo\"\u003E\u003C\u002Freport\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navbarMenu.$inject = ["$state", "ApiService", "ContractService", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navbarMenu;

/** @ngInject */

function navbarMenu($state, ApiService, ContractService, ErrorCatcher) {
    return {
        restrict: 'E',
        template: __webpack_require__(980)(),
        link: function link($scope) {
            $scope.redirectOnClick = function () {
                ApiService.fetchUserInfo().then(function (userInfo) {
                    $state.go(ContractService.getMyAccountStatusFromContract((0, _get3.default)(userInfo, 'contractSelected')));
                }).catch(function (error) {
                    if (error.message !== 'transition prevented') {
                        ErrorCatcher.catchError(error);
                    }
                });
            };
        }
    };
}

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"navigation-wrapper\"\u003E\u003Cnav class=\"navbar navbar-default\" ng-class=\"{'navbar-transparent': isClient}\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"nav navbar-header\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"desktop-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"nav navbar-nav mobile-nav\"\u003E\u003Cli ng-if=\"isClient\"\u003E\u003Ca class=\"active visible-xs\" ng-if=\"isActive('dashboard')\"\u003EMon tableau de bord\u003C\u002Fa\u003E\u003Ca class=\"active visible-xs\" ng-if=\"isActive('hints')\"\u003ELes conseils\u003C\u002Fa\u003E\u003Ca class=\"active visible-xs\" ng-if=\"isActive('tracking')\"\u003EMon suivi conso\u003C\u002Fa\u003E\u003Ca class=\"active visible-xs\" ng-if=\"isActive('navbarAccount')\"\u003EMon compte\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli ng-if=\"!isClient\"\u003E\u003Ca class=\"active visible-xs stick-menu-mob\"\u003EL'offre Plüm énergie\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cbutton class=\"navbar-toggle\" type=\"button\" ng-click=\"toogleNavCollapsed()\"\u003E\u003Cspan class=\"sr-only\"\u003EMenu\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-bar\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse\" uib-collapse=\"navCollapsed\"\u003E\u003Cul class=\"nav navbar-nav\"\u003E\u003Cli class=\"visible-xs-block\"\u003E\u003Ca ui-sref=\"dashboard\" ng-class=\"{active: isActive('dashboard')}\" ng-click=\"toogleNavCollapsed()\" permission permission-only=\"'client'\"\u003EMon tableau de bord\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ui-sref=\"hints\" ng-class=\"{active: isActive('hints')}\" ng-click=\"toogleNavCollapsed()\" permission permission-only=\"'client'\"\u003ELes conseils\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli ng-if=\"!$root.dataFeature['communityCounter']\"\u003E\u003Ca ui-sref=\"community\"\u003ELa communauté\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli ng-if=\"$root.dataFeature['communityCounter']\"\u003E\u003Ca ui-sref=\"community\" data-content=\"{{userCommunityCount}}\" ng-class=\"{'user-community-count': userCommunityCount}\"\u003ELa communauté\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca ui-sref=\"tracking\" ng-class=\"{active: isActive('tracking')}\" ng-click=\"toogleNavCollapsed()\" ng-if=\"isSelectedContractActive()\" permission permission-only=\"'client'\"\u003EMon suivi conso\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cul class=\"nav navbar-nav navbar-right\"\u003E\u003Cli permission permission-only=\"'client'\"\u003E\u003Cdiv class=\"btn-group-my-account btn-group\" ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Cbutton class=\"btn btn-my-account background-white dark-pink\" ng-click=\"toogleNavCollapsed() &amp;&amp; redirectOnClick()\"\u003E\u003Cspan\u003EMon compte\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-logoff\" ng-click=\"logout()\"\u003E\u003Ci class=\"fa fa-power-off\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'user'\" permission-except=\"'client'\"\u003E\u003Cdiv ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Ca class=\"btn btn-subscribe dark-pink background-white\" ui-sref=\"subscription\" ng-click=\"gaEventsService.newEvent('click - Souscription')\"\u003E\u003Cspan\u003EPasser chez Plüm\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"\" ng-click=\"logout()\"\u003E\u003Ci class=\"fa fa-power-off\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli permission permission-only=\"'anonymous'\"\u003E\u003Ca class=\"inverted\" ng-if=\"!$root.dataFeature['newSubscribeNavbar']\" ui-sref=\"login\" ng-click=\"gaEventsService.newEvent('click - Login')\"\u003EDéjà client ?\u003C\u002Fa\u003E\u003Cdiv class=\"btn-group\" ng-if=\"$root.dataFeature['newSubscribeNavbar']\" ng-class=\"{'button-text-icon': isClient, 'button-icon': !isClient}\"\u003E\u003Ca class=\"btn btn-login background-waterblue\" ui-sref=\"login\" ng-click=\"gaEventsService.newEvent('click - Login')\"\u003EDéjà client ?\u003C\u002Fa\u003E\u003Ca class=\"btn btn-subscribe dark-pink background-white\" ui-sref=\"subscription\" ng-click=\"gaEventsService.newEvent('click - Souscription')\"\u003EPasser chez Plüm\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navbarMenuDesktopFixed.$inject = ["$timeout", "DeviceChecker"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navbarMenuDesktopFixed;

/** @ngInject */

function navbarMenuDesktopFixed($timeout, DeviceChecker) {
    return {
        restrict: 'C',
        scope: {
            isCollapsed: '='
        },
        link: function link(scope, element) {
            return $timeout(function () {
                var $window = (0, _jquery2.default)(window);
                var $navbarDashboard = (0, _jquery2.default)('.navbar-dashboard');
                $window.on('scroll.navPlumScrollable', function () {
                    if (!DeviceChecker.isMobile()) {
                        var windowOffetTop = (0, _jquery2.default)(window).scrollTop();
                        var navbarDashboardOffsetBottom = $navbarDashboard.offset().top + $navbarDashboard.height();
                        if (windowOffetTop >= navbarDashboardOffsetBottom) {
                            return element.addClass('navbar-menu-desktop-fixed-visible');
                        }
                        return element.removeClass('navbar-menu-desktop-fixed-visible');
                    }
                });

                return scope.$on('$destroy', function () {
                    return $window.off('.navPlumScrollable');
                });
            });
        }
    };
}

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


navPlumScrollable.$inject = ["$timeout", "$rootScope", "DeviceChecker"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = navPlumScrollable;

/** @ngInject */

function navPlumScrollable($timeout, $rootScope, DeviceChecker) {
    return {
        restrict: 'A',
        scope: {
            isCollapsed: '='
        },
        link: function link(scope, element) {
            return $timeout(function () {
                var $window = (0, _jquery2.default)(window);
                var $navbarDashboard = element.find('.navbar-dashboard');

                var activate = function activate() {
                    // Execute on directive load
                    var hasChangedState = $rootScope.previousState !== $rootScope.currentState;
                    if (hasChangedState && !DeviceChecker.isMobile()) {
                        $timeout(function () {
                            var navbarDashboardOffsetBottom = $navbarDashboard.offset().top + $navbarDashboard.height();
                            return (0, _jquery2.default)('html, body').animate({ scrollTop: navbarDashboardOffsetBottom }, '500', 'swing');
                        }, 1000);
                    }

                    // Execute on state transition
                    return scope.$on('$stateChangeSuccess', function (event, to, toParams, from) {
                        hasChangedState = from.url !== to.url;
                        if (hasChangedState && !DeviceChecker.isMobile()) {
                            var navbarDashboardOffsetBottom = $navbarDashboard.offset().top + $navbarDashboard.height();
                            return $window.scrollTop(navbarDashboardOffsetBottom);
                        }
                    });
                };

                return activate();
            });
        }
    };
}

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toNumber2 = __webpack_require__(131);

var _toNumber3 = _interopRequireDefault(_toNumber2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnpaidBalanceModalCtrl = function () {
    /** @ngInject */
    UnpaidBalanceModalCtrl.$inject = ["$window", "$timeout", "$q", "Contract", "ContactTelephone", "ErrorCatcher"];
    function UnpaidBalanceModalCtrl($window, $timeout, $q, Contract, ContactTelephone, ErrorCatcher) {
        _classCallCheck(this, UnpaidBalanceModalCtrl);

        this.$window = $window;
        this.$timeout = $timeout;
        this.$q = $q;
        this.Contract = Contract;
        this.ContactTelephone = ContactTelephone;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(UnpaidBalanceModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.error = null;
            this.isRegularizing = false;
        }
    }, {
        key: 'regularize',
        value: function regularize() {
            var _this = this;

            this.isRegularizing = true;
            this.Contract.regularize({ id: this.resolve.unpaidContract.id }).$promise.then(function (result) {
                _this.$window.location = result.redirectUrl;
            }).catch(function (error) {
                _this.isRegularizing = false;
                _this.ErrorCatcher.catchError(error);
                _this.error = error;
            });
        }
    }, {
        key: 'toAbsolute',
        value: function toAbsolute(amount) {
            return Math.abs((0, _toNumber3.default)(amount));
        }
    }]);

    return UnpaidBalanceModalCtrl;
}();

exports.default = {
    template: __webpack_require__(984)(),
    controller: UnpaidBalanceModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"modal-body\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch2\u003ENous constatons un solde impayé  d’un montant de {{$ctrl.toAbsolute($ctrl.resolve.unpaidContract.contractBalance.balance) | frAmount}}€\u003C\u002Fh2\u003E\u003Ch3\u003EQue souhaitez-vous faire ?\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 text-center margin-top-20 margin-bottom-20 flex flex-column flex-space-between\" style=\"height: 180px;\"\u003E\u003Cdiv\u003E\u003Ch5\u003ERégler votre solde par carte bancaire\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex flex-space-around\"\u003E\u003Cimg style=\"height: 30px;\" src=\"assets\u002Fimg\u002Fpayment\u002Flogo-cb.png\"\u003E\u003Cimg style=\"height: 30px;\" src=\"assets\u002Fimg\u002Fpayment\u002Flogo-mastercard.png\"\u003E\u003Cimg style=\"height: 30px;\" src=\"assets\u002Fimg\u002Fpayment\u002Flogo-visa.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" ng-click=\"$ctrl.regularize()\" ng-disabled=\"$ctrl.isRegularizing\" ng-class=\"{'btn-spinner-loading': $ctrl.isRegularizing}\"\u003EPAYER PAR CB\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 text-center margin-top-20 margin-bottom-20 flex flex-column flex-space-between\" style=\"height: 180px;\"\u003E\u003Cdiv\u003E\u003Ch5\u003ENous appeler pour trouver une solution de paiement\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Ftel_plum.png\" style=\"height: 50px;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cstrong class=\"fs-20\"\u003E{{$ctrl.ContactTelephone.client.label}}\u003C\u002Fstrong\u003E\u003Cbr\u003E\u003Cstrong class=\"fs-14\"\u003Echoix n°3\u003C\u002Fstrong\u003E\u003Cbr\u003E\u003Cstrong class=\"fs-14\"\u003Edu lundi au vendredi, de 9h à 18h\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangePaymentDayModalCtrl = function () {
    /** @ngInject */
    ChangePaymentDayModalCtrl.$inject = ["BillingAcc", "ErrorCatcher"];
    function ChangePaymentDayModalCtrl(BillingAcc, ErrorCatcher) {
        _classCallCheck(this, ChangePaymentDayModalCtrl);

        this.BillingAcc = BillingAcc;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(ChangePaymentDayModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.form = this.resolve.paymentDayInfo;
            this.isSubmitting = false;
            this.isSubmitted = false;
            this.hasError = false;
        }
    }, {
        key: 'submitPaymentDay',
        value: function submitPaymentDay() {
            var _this = this;

            this.isSubmitting = true;
            this.hasError = false;
            this.BillingAcc.putPaymentDay({ preferredPaymentDay: this.form.preferredPaymentDay }).$promise.then(function () {
                _this.isSubmitting = false;
                _this.isSubmitted = true;
                _this.closeModal();
            }).catch(function (error) {
                _this.isSubmitting = false;
                _this.hasError = true;
                _this.ErrorCatcher.catchError(error);
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close({ $value: { isSubmitted: this.isSubmitted } });
        }
    }]);

    return ChangePaymentDayModalCtrl;
}();

exports.default = {
    template: __webpack_require__(986)(),
    controller: ChangePaymentDayModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.closeModal()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-sampling-date-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003EChoisissez la date de prélèvement\u003Cbr\u003E qui vous convient le mieux.\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row error\" ng-if=\"$ctrl.hasError\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\" subscriptionSummaryForm.$submitted &amp;&amp; enablePayment !== true\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cp\u003EUne erreur s'est produite lors de l'enregistrement de la date.\u003C\u002Fp\u003E\u003Cp\u003EVous avez la possibilité de contacter le service client via le bouton \"Nous Contacter\"\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"select-date-wrapper\"\u003E\u003Cdiv class=\"select-date\"\u003E\u003Cdiv class=\"select-date-item-wrapper\" ng-repeat=\"day in $ctrl.form.availableDays\" ng-click=\"$ctrl.form.preferredPaymentDay = day\"\u003E\u003Cdiv class=\"select-date-item\" ng-class=\"{'active': $ctrl.form.preferredPaymentDay === day}\" ng-bind=\"day\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" ng-click=\"$ctrl.submitPaymentDay()\" ng-class=\"{'btn-spinner-loading': $ctrl.isSubmitting}\" ng-disabled=\"$ctrl.isSubmitting\"\u003EAppliquer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _paymentConfirmation = __webpack_require__(988);

var _paymentConfirmation2 = _interopRequireDefault(_paymentConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.paymentConfirmation', []).component('paymentConfirmation', _paymentConfirmation2.default).name;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _paymentConfirmation = __webpack_require__(989);

var _paymentConfirmation2 = _interopRequireDefault(_paymentConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentConfirmationController = function () {
    /** @ngInject */
    PaymentConfirmationController.$inject = ["ErrorCatcher"];
    function PaymentConfirmationController(ErrorCatcher) {
        _classCallCheck(this, PaymentConfirmationController);

        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(PaymentConfirmationController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.transaction.transactionStatus === 'success' && this.transaction.transactionId.split('_')[0] === 'DEPOSIT') {
                this.viewState = 'state-payment-security-deposit-success';
            } else if (this.transaction.transactionStatus === 'success') {
                this.viewState = 'state-payment-success';
            } else if (this.transaction.transactionStatus === 'failure') {
                this.viewState = 'state-payment-failure';
                this.errorMsg = this.getErrorMsgFromCode(this.transaction);
                this.ErrorCatcher.catchErrorWithoutRedirect({
                    status: this.ErrorCatcher.WEBSITE_ERROR_STATUS,
                    transaction: this.transaction,
                    errorMsg: this.errorMsg
                });
            } else {
                this.viewState = 'state-payment-default';
            }
        }
    }, {
        key: 'getErrorMsgFromCode',
        value: function getErrorMsgFromCode(transaction) {
            var result = _paymentConfirmation2.default.defaultErrorMsg;
            if (transaction.cardOperationResult) {
                result = (0, _get3.default)(_paymentConfirmation2.default.cardOperationResultMapping, transaction.cardOperationResult, _paymentConfirmation2.default.defaultErrorMsg);
            } else if (transaction.transactionErrorCode) {
                result = (0, _get3.default)(_paymentConfirmation2.default.transactionErrorCodeMapping, transaction.transactionErrorCode, _paymentConfirmation2.default.defaultErrorMsg);
            }
            // Assign default label if undefined in result
            return (0, _assign3.default)({}, _paymentConfirmation2.default.defaultErrorMsg, result);
        }
    }]);

    return PaymentConfirmationController;
}();

exports.default = {
    template: __webpack_require__(990)(),
    controller: PaymentConfirmationController,
    bindings: {
        transaction: '<'
    }
};

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    defaultErrorMsg: { code: 'Undefined slimpay error', label: 'Le paiement a été refusé.' },
    cardOperationResultMapping: {
        400: {
            code: 'Card Operator Refusal',
            label: 'Le paiement a été refusé par votre banque'
        },
        401: {
            code: 'Card bank refusal',
            label: 'Le paiement a été refusé par votre banque'
        },
        402: {
            code: 'Card access failure',
            label: 'Votre banque a rencontré une erreur technique qui a bloqué le paiement'
        },
        403: {
            code: 'Card number is invalid',
            label: 'Votre banque a refusé le paiement car le numéro de carte est incorrect'
        },
        404: {
            code: 'Card CVV is invalid',
            label: 'Votre banque a refusé le paiement car le code de vérification (CVV ou CVC) est incorrect'
        },
        405: {
            code: 'Card expiration date is invalid',
            label: 'Votre banque a refusé le paiement car la date d’expiration de la carte incorrecte'
        },
        406: {
            code: 'Card birth date is invalid',
            label: 'Votre banque a refusé le paiement suite à une erreur de saisie des informations de la carte'
        },
        407: {
            code: 'Card transaction reference is invalid',
            label: 'Le paiement a été refusé suite à une erreur de communication avec votre banque'
        },
        408: {
            code: 'Card is declared as lost',
            label: 'Votre banque a refusé le paiement car la carte a été déclarée comme perdue'
        },
        409: {
            code: 'Card is declared as stolen',
            label: 'Votre banque a refusé le paiement car la carte a été déclarée comme volée'
        }
    },
    transactionErrorCodeMapping: {
        100: { code: 'SlimPay internal error' },
        101: { code: 'Request data is missing' },
        102: { code: 'Request type is missing' },
        103: { code: 'Authentification data is missing' },
        104: { code: 'Site ID is not found' },
        105: { code: 'Incoherent is timestamp' },
        106: { code: 'Initialization code is missing' },
        107: { code: 'Initialization data is missing' },
        108: { code: 'Customer data is missing' },
        109: { code: 'Login failed' },
        111: { code: 'Payment type is invalid' },
        113: { code: 'Blob decoding failed' },
        118: { code: 'Payment type is missing' },
        119: { code: 'Transaction has been canceled by user', label: 'Vous avez annulé la transaction' },
        120: { code: 'Session timed out', label: 'Vous n’avez pas complété la transaction à temps' },
        121: { code: 'Entity type is invalid' },
        122: { code: 'Honorific prefix is invalid' },
        123: { code: 'First name is invalid' },
        124: { code: 'Last name is invalid' },
        125: { code: 'Email is invalid' },
        127: { code: 'Phone is invalid' },
        128: { code: 'Postal code is invalid' },
        129: { code: 'City is invalid' },
        133: { code: 'BIC is invalid', label: 'IBAN/BIC invalide' },
        134: { code: 'IBAN is invalid', label: 'IBAN/BIC invalide' },
        135: { code: 'Mandate reference is invalid' },
        136: { code: 'Debit amount is invalid' },
        137: { code: 'Debit execution date is invalid' },
        138: { code: 'Debit label is invalid' },
        139: { code: 'Card amount is invalid' },
        140: { code: 'Card operation type is invalid' },
        141: { code: 'Client reference is invalid' },
        142: { code: 'Company name is invalid' },
        143: { code: 'Organization id is invalid' },
        144: { code: 'Street1 is invalid' },
        145: { code: 'Street2 is invalid' },
        146: { code: 'Country is invalid' },
        147: { code: 'Transaction id is invalid' },
        148: { code: 'Not a SEPA account' },
        149: { code: 'Duplicate request' },
        150: { code: 'Receive payment amount is invalid' },
        151: { code: 'Receive payment deadline is invalid' },
        152: { code: 'Receive payment ID is invalid' },
        153: { code: 'Receive payment ID has already been used before' },
        154: { code: 'No mandate found with this reference' },
        156: { code: 'Invalid OTP key' },
        157: { code: 'Expired OTP key' },
        158: { code: 'Max OTP key tries' },
        159: { code: 'Incoherent mandate reference' },
        160: { code: 'Max OTP key sent' },
        161: { code: 'CSI is invalid' },
        162: { code: 'OTP channel type is invalid' },
        163: { code: 'Sequence type is invalid' },
        164: { code: 'DD ISTR type is invalid' },
        165: { code: 'Mandate transfer is invalid' },
        167: { code: 'Mandate sign date is invalid' },
        168: { code: 'Mandate source is invalid' },
        169: { code: 'Mandate file name is invalid' },
        170: { code: 'Mandate file content is invalid' },
        171: { code: 'Mandate sign status is invalid' },
        172: { code: 'Unauthorized operation', label: 'Opération refusée par votre banque' },
        173: { code: 'Mandate status is invalid' },
        174: { code: 'Address line 3 is invalid' },
        175: { code: 'Address line 4 is invalid' },
        176: { code: 'SEPA COM PACIFIC' },
        177: { code: 'Unreachable SEPA' },
        178: { code: 'Profile is invalid' },
        179: { code: 'Creditor is invalid' },
        180: { code: 'Mandate reference already exists' },
        181: { code: 'No documents to sign' },
        182: { code: 'Multiple entries found' },
        183: { code: 'Document already treated' },
        184: { code: 'Branch invalid' },
        185: { code: 'Frequency missing' },
        186: { code: 'Forbidden IBAN', label: 'IBAN interdit par la banque' },
        187: { code: 'Document template not found' },
        188: { code: 'Incorrect bank account owner', label: 'Propriétaire du compte invalide' }
    }
};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-payment-success'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EPAIEMENT ACCEPTÉ\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Faccepted.svg\"\u003E\u003Cspan\u003ETransaction validée\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003EVotre paiement par carte bancaire\u003Cspan\u003E&nbsp;\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.transaction.payment.amount\"\u003Ed’un montant de \u003Cstrong\u003E{{$ctrl.transaction.payment.amount | frAmount}}€\u003C\u002Fstrong\u003E&nbsp;\u003C\u002Fspan\u003Ea bien été effectué.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-30\"\u003EVous pouvez consulter la liste de vos paiements depuis l’onglet « Factures et paiements » de votre espace client.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"invoice\"\u003EMON ESPACE CLIENT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-payment-security-deposit-success'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EPAIEMENT ACCEPTÉ\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Faccepted.svg\"\u003E\u003Cspan\u003ELe paiement de votre dépôt de garantie a bien été enregistré sur votre compte.\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003EPour terminer votre commande, il vous reste encore à choisir la date à laquelle nous allons transmettre\nà Enedis votre demande.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"endSubscription\" id=\"btnFinishOrderDG\"\u003ETERMINER MA COMMANDE\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-payment-failure'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EPAIEMENT REFUSÉ\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Frejected.svg\"\u003E\u003Cspan\u003E{{$ctrl.errorMsg.label}}\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003EVotre paiement par carte bancaire\u003Cspan\u003E&nbsp;\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.transaction.payment.amount\"\u003Ed’un montant de \u003Cstrong\u003E{{$ctrl.transaction.payment.amount | frAmount}}€\u003C\u002Fstrong\u003E&nbsp;\u003C\u002Fspan\u003Ea été refusé.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-30\"\u003EAssurez-vous auprès de votre banque que vos moyens de paiement soient à jour et que vous disposiez\ndes fonds nécessaires, puis réessayez depuis votre espace client sur espace-client.plum.fr.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-marine\" ui-sref=\"invoice\"\u003EMON ESPACE CLIENT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-payment-default'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EPAIEMENT EN COURS DE TRAITEMENT\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Fpending.svg\"\u003E\u003Cspan\u003ELa transaction est en cours\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003EVotre paiement par carte bancaire est en cours de traitement. Cela peut prendre jusqu’à 48h.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-30\"\u003EVous pouvez consulter la liste de vos paiements depuis l’onglet « Factures et paiements » de votre espace client.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-light-pink\" ui-sref=\"invoice\"\u003EMON ESPACE CLIENT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _vendorSignatureConfirmation = __webpack_require__(992);

var _vendorSignatureConfirmation2 = _interopRequireDefault(_vendorSignatureConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.vendorSignatureConfirmation', []).component('vendorSignatureConfirmation', _vendorSignatureConfirmation2.default).name;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VendorSignatureConfirmationController = function () {
    function VendorSignatureConfirmationController() {
        _classCallCheck(this, VendorSignatureConfirmationController);
    }

    _createClass(VendorSignatureConfirmationController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.transaction.transactionStatus === 'success') {
                this.viewState = 'state-mandate-success';
            } else if (this.transaction.transactionStatus === 'failure') {
                this.viewState = 'state-mandate-failure';
            } else {
                this.viewState = 'state-mandate-default';
            }
        }
    }]);

    return VendorSignatureConfirmationController;
}();

exports.default = {
    template: __webpack_require__(993)(),
    controller: VendorSignatureConfirmationController,
    bindings: {
        transaction: '<'
    }
};

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-mandate-success'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ECONTRAT SIGNÉ\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Faccepted.svg\"\u003E\u003Cspan\u003EMoyen de paiement enregistré\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003E\u003Cspan class=\"fw-500\"\u003EImportant :\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;Il faut rappeler au client de créer le mot de passe de son compte client en cliquant sur « mot de passe oublié ».\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-mandate-failure'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EMOYEN DE PAIEMENT NON ENREGISTRÉ\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Frejected.svg\"\u003E\u003Cspan\u003EMoyen de paiement non enregistré\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003EL'autorisation de prélèvement n'a pas été signée.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.viewState === 'state-mandate-default'\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EMOYEN DE PAIEMENT EN COURS DE TRAITEMENT\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Ch5\u003E\u003Cimg class=\"buffer-right\" src=\"\u002Fassets\u002Fimg\u002FpaymentConfirmation\u002Fpending.svg\"\u003E\u003Cspan\u003ELa transaction est en cours\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003Cp class=\"margin-top-15\"\u003ESi vous venez de modifier le moyen de paiement, il est en cours de traitement.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _changeBillingAddressModal = __webpack_require__(995);

var _changeBillingAddressModal2 = _interopRequireDefault(_changeBillingAddressModal);

var _changeEmailModal = __webpack_require__(997);

var _changeEmailModal2 = _interopRequireDefault(_changeEmailModal);

var _changeSelectedPaymentMethodModal = __webpack_require__(999);

var _changeSelectedPaymentMethodModal2 = _interopRequireDefault(_changeSelectedPaymentMethodModal);

var _changeMobileModal = __webpack_require__(1001);

var _changeMobileModal2 = _interopRequireDefault(_changeMobileModal);

var _changePasswordModal = __webpack_require__(1003);

var _changePasswordModal2 = _interopRequireDefault(_changePasswordModal);

var _deleteCreditCardModal = __webpack_require__(1005);

var _deleteCreditCardModal2 = _interopRequireDefault(_deleteCreditCardModal);

var _deleteMandateModal = __webpack_require__(1007);

var _deleteMandateModal2 = _interopRequireDefault(_deleteMandateModal);

var _personalInformationDetail = __webpack_require__(1009);

var _personalInformationDetail2 = _interopRequireDefault(_personalInformationDetail);

var _personalInfoSponsorLink = __webpack_require__(1011);

var _personalInfoSponsorLink2 = _interopRequireDefault(_personalInfoSponsorLink);

var _personalInformation = __webpack_require__(1013);

var _personalInformation2 = _interopRequireDefault(_personalInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.personalInformation', []).component('changeBillingAddressModal', _changeBillingAddressModal2.default).component('changeEmailModal', _changeEmailModal2.default).component('changeSelectedPaymentMethodModal', _changeSelectedPaymentMethodModal2.default).component('changeMobileModal', _changeMobileModal2.default).component('changePasswordModal', _changePasswordModal2.default).component('deleteCreditCardModal', _deleteCreditCardModal2.default).component('deleteMandateModal', _deleteMandateModal2.default).directive('personalInformationDetail', _personalInformationDetail2.default).directive('personalInfoSponsorLink', _personalInfoSponsorLink2.default).controller('personalInformationCtrl', _personalInformation2.default).name;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangeBillingAddressModalCtrl = function () {
    /** @ngInject */
    ChangeBillingAddressModalCtrl.$inject = ["BillingAddress", "User", "ErrorCatcher"];
    function ChangeBillingAddressModalCtrl(BillingAddress, User, ErrorCatcher) {
        _classCallCheck(this, ChangeBillingAddressModalCtrl);

        this.BillingAddress = BillingAddress;
        this.User = User;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(ChangeBillingAddressModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = false;
            this.isSubmitting = false;
            this.isSubmitted = false;
            this.form = {
                selectedAddress: null,
                details: {
                    addr_details: undefined,
                    addr_locality: undefined,
                    addr_bat: undefined
                }
            };
        }
    }, {
        key: 'lookupAddress',
        value: function lookupAddress(addr) {
            var _this = this;

            var address$ = this.BillingAddress.showBillAddresses({ q: addr }).$promise;
            address$.finally(function () {
                _this.loading = false;
            });
            return address$;
        }
    }, {
        key: 'submitAddress',
        value: function submitAddress(data) {
            var _this2 = this;

            var newBillAdd = (0, _assign3.default)({}, this.form.selectedAddress, this.form.details);
            this.isSubmitting = true;
            this.User.saveNewBillingAddress(newBillAdd).$promise.then(function (response) {
                _this2.isSubmitted = true;
            }).catch(this.ErrorCatcher.catchError).finally(function () {
                _this2.isSubmitting = false;
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close({ $value: { isSubmitted: this.isSubmitted } });
        }
    }]);

    return ChangeBillingAddressModalCtrl;
}();

exports.default = {
    template: __webpack_require__(996)(),
    controller: ChangeBillingAddressModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.closeModal()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-billing-address-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003ECHANGER VOTRE ADRESSE DE FACTURATION\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail\" ng-if=\"!$ctrl.isSubmitted\"\u003E\u003Cdiv class=\"billing-address-search\"\u003E\u003Cdiv class=\"default-form\"\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cp\u003ERechercher votre adresse de facturation dans notre base de données.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EAdresse\u003C\u002Flabel\u003E\u003Cinput class=\"form-control inline\" type=\"text\" size=\"80\" ng-model=\"$ctrl.form.selectedAddress\" ng-model-options=\"{ debounce: 650 }\" uib-typeahead=\"res as res.label for res in $ctrl.lookupAddress($viewValue) | limitTo:5\" typeahead-on-select=\"$ctrl.updateAddr($item)\" placeholder=\"Recherche ...\" ng-disabled=\"$ctrl.isSubmitting\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 margin-top-15 text-right\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-if=\"!$ctrl.isSubmitted\" ng-click=\"$ctrl.closeModal()\" ng-disabled=\"$ctrl.isSubmitting\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default-form\" ng-if=\"$ctrl.form.selectedAddress.label\"\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EVOIE\u003C\u002Flabel\u003E\u003Cp\u003E{{$ctrl.form.selectedAddress.addr_num_street}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003ECODE POSTAL\u003C\u002Flabel\u003E\u003Cp\u003E{{$ctrl.form.selectedAddress.addr_post_code}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EVILLE\u003C\u002Flabel\u003E\u003Cp\u003E{{$ctrl.form.selectedAddress.addr_city_lbl}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003ECOMPLÉMENTS D'ADRESSE\u003C\u002Flabel\u003E\u003Cinput ng-model=\"$ctrl.form.details.addr_details\" type=\"text\" placeholder=\"Indications complémentaires, ...\" ng-disabled=\"$ctrl.isSubmitting\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EN° DE BÂTIMENT\u003C\u002Flabel\u003E\u003Cinput ng-model=\"$ctrl.form.details.addr_bat\" type=\"text\" placeholder=\"A, ...\" ng-disabled=\"$ctrl.isSubmitting\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003ELOCALITÉ\u003C\u002Flabel\u003E\u003Cinput ng-model=\"$ctrl.form.details.addr_locality\" type=\"text\" placeholder=\"Lieu-dit, ...\" ng-disabled=\"$ctrl.isSubmitting\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 margin-top-15 text-right\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-disabled=\"$ctrl.isSubmitting\" ng-click=\"$ctrl.closeModal()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" ng-disabled=\"$ctrl.isSubmitting\" ng-click=\"$ctrl.submitAddress()\" ng-class=\"{'btn-spinner-loading': $ctrl.isSubmitting}\"\u003EEnvoyer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail\" ng-if=\"$ctrl.isSubmitted\"\u003E\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-container form-body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cp\u003EL'adresse de facturation a été bien mis à jour.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 margin-top-15 text-right\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangeEmailModalCtrl = function () {
    /** @ngInject */
    ChangeEmailModalCtrl.$inject = ["$state", "User", "ErrorCatcher"];
    function ChangeEmailModalCtrl($state, User, ErrorCatcher) {
        _classCallCheck(this, ChangeEmailModalCtrl);

        this.$state = $state;
        this.User = User;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(ChangeEmailModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.currentState = 'state-email-form';
            this.isSending = false;
            this.isSubmitted = false;
            this.errorMessage = null;
            this.form = {
                new_email: null,
                password: null
            };
        }
    }, {
        key: 'submitEmail',
        value: function submitEmail() {
            var _this = this;

            this.isSending = true;
            this.User.saveNewEmail(this.form).$promise.then(function (result) {
                _this.isSubmitted = true;
                _this.currentState = 'state-finish';
            }).catch(function (error) {
                _this.ErrorCatcher.catchError(error);
                _this.errorMessage = error.data.message;
                _this.currentState = 'state-error';
            }).finally(function () {
                _this.isSending = false;
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close({ $value: { isSubmitted: this.isSubmitted } });
        }
    }]);

    return ChangeEmailModalCtrl;
}();

exports.default = {
    template: __webpack_require__(998)(),
    controller: ChangeEmailModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.closeModal()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-email-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003ECHANGER D'EMAIL\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-email-form\" ng-if=\"$ctrl.currentState === 'state-email-form'\"\u003E\u003Cform ng-submit=\"$ctrl.submitEmail()\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003ESaisissez votre nouvelle adresse email.\u003C\u002Fp\u003E\u003Cp\u003EUn email de validation vous sera envoyé afin de confirmer le changement.\u003C\u002Fp\u003E\u003Cinput type=\"email\" name=\"email\" placeholder=\"votre@email.com\" ng-model=\"$ctrl.form.new_email\" required ng-disabled=\"$ctrl.isSending\"\u003E\u003Cp\u003EPar mesure de sécurité, veillez également saisir votre mot de passe.\u003C\u002Fp\u003E\u003Cinput type=\"password\" name=\"password\" placeholder=\"Mot de passe\" ng-model=\"$ctrl.form.password\" required ng-disabled=\"$ctrl.isSending\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-if=\"!$ctrl.isSubmitted\" ng-click=\"$ctrl.closeModal()\" ng-disabled=\"$ctrl.isSending\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine hidden-xs\" type=\"submit\" ng-disabled=\"$ctrl.isSending\" ng-class=\"{'btn-spinner-loading': $ctrl.isSending}\"\u003EChanger mon adresse email\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine visible-xs-inline-block\" type=\"submit\" ng-disabled=\"$ctrl.isSending\" ng-class=\"{'btn-spinner-loading': $ctrl.isSending}\"\u003EChanger\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-finish\" ng-if=\"$ctrl.currentState === 'state-finish'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EUn email de validation vous a été envoyé.\u003C\u002Fp\u003E\u003Cp\u003EMerci de vérifier la boite mail de votre nouvelle adresse email et de cliquer sur le lien afin de confirmer le changement de mail.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-error\" ng-if=\"$ctrl.currentState === 'state-error'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EUne erreur est survenu lors du changement de votre adresse email.\u003C\u002Fp\u003E\u003Cp class=\"error\"\u003E{{$ctrl.errorMessage}}\u003C\u002Fp\u003E\u003Cp\u003EMerci de rééssayer ou de contacter le service client.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangeSelectedPaymentMethodModalCtrl = function () {
    /** @ngInject */
    ChangeSelectedPaymentMethodModalCtrl.$inject = ["$state", "User", "ErrorCatcher"];
    function ChangeSelectedPaymentMethodModalCtrl($state, User, ErrorCatcher) {
        _classCallCheck(this, ChangeSelectedPaymentMethodModalCtrl);

        this.$state = $state;
        this.User = User;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(ChangeSelectedPaymentMethodModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.currentState = 'state-form';
            this.hasSubmitted = false;
            this.isSubmitted = false;
            this.isSending = false;
            this.errorMessage = null;
            this.form = {
                recurrentCbPayment: this.resolve.recurrentCbPayment
            };
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            this.hasSubmitted = true;
            this.isSending = true;
            this.User.selectPaymentMethod({ recurrent_cb_payment: this.form.recurrentCbPayment }).$promise.then(function (result) {
                _this.isSubmitted = true;
                _this.currentState = 'state-finish';
            }).catch(function (error) {
                _this.ErrorCatcher.catchError(error);
                _this.errorMessage = error.data.message;
                _this.currentState = 'state-error';
            }).finally(function () {
                _this.isSending = false;
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close({ $value: { isSubmitted: this.isSubmitted } });
        }
    }]);

    return ChangeSelectedPaymentMethodModalCtrl;
}();

exports.default = {
    template: __webpack_require__(1000)(),
    controller: ChangeSelectedPaymentMethodModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.closeModal()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-iban-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003ECHANGER DE MOYEN DE PAIEMENT\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-email-form\" ng-if=\"$ctrl.currentState === 'state-form'\"\u003E\u003Cform ng-submit=\"$ctrl.submit()\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EChoisissez le moyen de paiement que vous préférez :\u003C\u002Fp\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-xs-12 form-group\"\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput class=\"clickable\" type=\"radio\" name=\"selectedPaymentMethod\" ng-model=\"$ctrl.form.recurrentCbPayment\" ng-value=\"false\"\u003EPrélèvement SEPA\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput class=\"clickable\" type=\"radio\" name=\"selectedPaymentMethod\" ng-model=\"$ctrl.form.recurrentCbPayment\" ng-value=\"true\"\u003ECarte bancaire\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-if=\"!$ctrl.isSubmitted\" ng-disabled=\"$ctrl.isSending\" ng-click=\"$ctrl.closeModal()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" type=\"submit\" ng-click=\"$ctrl.submit()\" ng-class=\"{'btn-spinner-loading': $ctrl.isSending}\"\u003EValider\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-finish\" ng-if=\"$ctrl.currentState === 'state-finish'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003ELe moyen de paiement a été modifié.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-error\" ng-if=\"$ctrl.currentState === 'state-error'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EUne erreur est survenue lors du changement de votre moyen de paiement.\u003C\u002Fp\u003E\u003Cp class=\"error\"\u003E{{$ctrl.errorMessage}}\u003C\u002Fp\u003E\u003Cp\u003EMerci de rééssayer ou de contacter le service client.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangeMobileModalCtrl = function () {
    /** @ngInject */
    ChangeMobileModalCtrl.$inject = ["User", "MobilePhone", "ErrorCatcher"];
    function ChangeMobileModalCtrl(User, MobilePhone, ErrorCatcher) {
        _classCallCheck(this, ChangeMobileModalCtrl);

        this.User = User;
        this.MobilePhone = MobilePhone;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(ChangeMobileModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.phoneRegex = this.MobilePhone.phoneRegex.all;
            this.isSending = false;
            this.isSubmitted = false;
            this.currentState = 'state-phone-form';
            this.errorMessage = null;
            this.form = {
                phoneNumber: null,
                phoneNumberIsSame: null,
                confirmId: null,
                confirmCode: null,
                confirmCodeInError: null
            };
        }
    }, {
        key: 'isSameFromCurrentNumber',
        value: function isSameFromCurrentNumber() {
            return this.MobilePhone.formatPhoneToPlus33(this.resolve.currentPhoneNumber) === this.MobilePhone.formatPhoneToPlus33(this.form.phoneNumber);
        }
    }, {
        key: 'submitNewPhoneNumber',
        value: function submitNewPhoneNumber() {
            var _this = this;

            this.isSending = true;
            return this.User.saveNewPhoneNumber({ phone: this.MobilePhone.formatPhoneToPlus33(this.form.phoneNumber) }).$promise.then(function (response) {
                _this.currentState = 'state-confirm-form';
                _this.form.confirmId = response.processId;
            }).catch(function (error) {
                _this.ErrorCatcher.catchError(error);
                _this.errorMessage = error.data.message;
                _this.currentState = 'state-error';
            }).finally(function () {
                _this.isSending = false;
            });
        }
    }, {
        key: 'confirmNewPhoneNumber',
        value: function confirmNewPhoneNumber() {
            var _this2 = this;

            this.form.confirmCodeInError = null;
            this.isSending = true;
            return this.User.confirmNewPhoneNumber({ id_confirmation: this.form.confirmId }, { code: this.form.confirmCode }).$promise.then(function (response) {
                _this2.isSubmitted = true;
                _this2.currentState = 'state-finish';
            }).catch(function (error) {
                _this2.ErrorCatcher.catchError(error);
                _this2.errorMessage = error.data.message;
                if (error.data.message === 'Code invalide') {
                    _this2.form.confirmCodeInError = _this2.form.confirmCode;
                }
                _this2.currentState = 'state-error';
            }).finally(function () {
                _this2.isSending = false;
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close({ $value: { isSubmitted: this.isSubmitted } });
        }
    }]);

    return ChangeMobileModalCtrl;
}();

exports.default = {
    template: __webpack_require__(1002)(),
    controller: ChangeMobileModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.closeModal()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-mobile-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003ECHANGER DE NUMÉRO DE TÉLÉPHONE PORTABLE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-phone-form\" ng-if=\"$ctrl.currentState === 'state-phone-form'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003ESaisissez votre nouveau numéro de téléphone portable.\u003Cbr\u003E\u003Cspan class=\"subdetail\"\u003E(Un code vous sera transmis pour valider le numéro)\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp class=\"error\" ng-if=\"$ctrl.isSameFromCurrentNumber()\"\u003ELe numéro de téléphone correspond à celui actuellement défini.\u003Cbr\u003EVous pouvez fermer le formulaire ou saisir un autre numéro.\u003C\u002Fp\u003E\u003Cinput type=\"tel\" name=\"phoneNumber\" ng-pattern=\"phoneRegex\" maxlength=\"13\" placeholder=\"Ex: +33..., 06...\" ng-model=\"$ctrl.form.phoneNumber\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.closeModal()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" ng-click=\"$ctrl.submitNewPhoneNumber()\" ng-class=\"{'btn-spinner-loading': $ctrl.isSending}\" ng-disabled=\"!$ctrl.form.phoneNumber || $ctrl.isSameFromCurrentNumber()\"\u003EChanger\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-confirm-form\" ng-if=\"$ctrl.currentState === 'state-confirm-form'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003ESaisissez le code de confirmation reçu par sms\u003Cbr\u003E\u003Cspan class=\"subdetail\"\u003ELe code sms peut prendre quelques minutes pour être reçu\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp class=\"error\" ng-if=\"$ctrl.form.confirmCodeInError\"\u003ELe code {{$ctrl.form.confirmCodeInError}} semble invalide.\u003Cbr\u003E\nMerci de réessayer avec un autre code ou contacter le service client.\u003C\u002Fp\u003E\u003Cinput type=\"text\" pattern=\"[0-9]*\" maxlength=\"4\" placeholder=\"Ex: 1234\" name=\"confirmCode\" ng-model=\"$ctrl.form.confirmCode\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.closeModal()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" ng-click=\"$ctrl.confirmNewPhoneNumber()\" ng-class=\"{'btn-spinner-loading': $ctrl.isSending}\" ng-disabled=\"$ctrl.form.confirmCode.length !== 4\"\u003EConfirmer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-finish\" ng-if=\"$ctrl.currentState === 'state-finish'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003ELe numéro de téléphone a été bien changé !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-error\" ng-if=\"$ctrl.currentState === 'state-error'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EUne erreur est survenu lors du changement de votre numéro de téléphone.\u003C\u002Fp\u003E\u003Cp\u003EMerci de rééssayer ou de contacter le service client.\u003C\u002Fp\u003E\u003Cp class=\"error\"\u003E{{$ctrl.errorMessage}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangePasswordModalCtrl = function () {
    /** @ngInject */
    ChangePasswordModalCtrl.$inject = ["User", "ErrorCatcher"];
    function ChangePasswordModalCtrl(User, ErrorCatcher) {
        _classCallCheck(this, ChangePasswordModalCtrl);

        this.User = User;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(ChangePasswordModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.isSubmitted = false;
            this.isSubmitting = false;
        }
    }, {
        key: 'submitEmail',
        value: function submitEmail() {
            var _this = this;

            this.isSubmitting = true;
            this.User.resetPassword({ email: this.resolve.email }).$promise.then(function () {
                _this.isSubmitting = false;
                _this.isSubmitted = true;
            }).catch(this.ErrorCatcher.catchError).finally(function () {
                _this.isSubmitting = false;
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close({ $value: { isSubmitted: this.isSubmitted } });
        }
    }]);

    return ChangePasswordModalCtrl;
}();

exports.default = {
    template: __webpack_require__(1004)(),
    controller: ChangePasswordModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.closeModal()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-password-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003ERÉINITIALISEZ VOTRE MOT DE PASSE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp ng-if=\"!$ctrl.isSubmitted\"\u003EVoulez-vous réinitialisez votre mot de passe ?\u003C\u002Fp\u003E\u003Cp ng-if=\"$ctrl.isSubmitted\"\u003EUn e-mail a été envoyé. Il vous permettra de redéfinir votre mot de passe.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\" ng-if=\"!$ctrl.isSubmitted\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.closeModal()\" ng-disabled=\"$ctrl.isSubmitting\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" ng-click=\"$ctrl.submitEmail()\" ng-disabled=\"$ctrl.isSubmitting\" ng-class=\"{'btn-spinner-loading': $ctrl.isSubmitting}\"\u003EEnvoyer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\" ng-if=\"$ctrl.isSubmitted\"\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-if=\"$ctrl.isSubmitted\" ng-click=\"$ctrl.closeModal()\" ng-disabled=\"$ctrl.isSubmitting\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeleteCreditCardModalCtrl = function () {
    /** @ngInject */
    DeleteCreditCardModalCtrl.$inject = ["$state", "User", "ErrorCatcher"];
    function DeleteCreditCardModalCtrl($state, User, ErrorCatcher) {
        _classCallCheck(this, DeleteCreditCardModalCtrl);

        this.$state = $state;
        this.User = User;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(DeleteCreditCardModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.currentState = 'state-form';
            this.hasSubmitted = false;
            this.isSubmitted = false;
            this.isSending = false;
            this.errorMessage = null;
        }
    }, {
        key: 'deleteCreditCard',
        value: function deleteCreditCard() {
            var _this = this;

            this.hasSubmitted = true;
            this.isSending = true;
            this.User.deleteAlias().$promise.then(function (result) {
                _this.isSubmitted = true;
                _this.currentState = 'state-finish';
                window.location = result.redirectUrl;
            }).catch(function (error) {
                _this.ErrorCatcher.catchError(error);
                _this.errorMessage = error.data.message;
                _this.currentState = 'state-error';
            }).finally(function () {
                _this.isSending = false;
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close({ $value: { isSubmitted: this.isSubmitted } });
        }
    }]);

    return DeleteCreditCardModalCtrl;
}();

exports.default = {
    template: __webpack_require__(1006)(),
    controller: DeleteCreditCardModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.closeModal()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-credit-card-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003ESUPPRIMER VOTRE CARTE BANCAIRE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-email-form\" ng-if=\"$ctrl.currentState === 'state-form'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EÊtes-vous sûr de vouloir supprimer votre carte bancaire ?\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-if=\"!$ctrl.isSubmitted\" ng-disabled=\"$ctrl.isSending\" ng-click=\"$ctrl.closeModal()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" type=\"submit\" ng-disabled=\"$ctrl.isSending\" ng-class=\"{'btn-spinner-loading': $ctrl.isSending}\" ng-click=\"$ctrl.deleteCreditCard()\"\u003ESupprimer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-finish\" ng-if=\"$ctrl.currentState === 'state-finish'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003ELa carte de crédit a été supprimée.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-error\" ng-if=\"$ctrl.currentState === 'state-error'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EUne erreur est survenue lors de la suppression de votre carte de crédit.\u003C\u002Fp\u003E\u003Cp class=\"error\"\u003E{{$ctrl.errorMessage}}\u003C\u002Fp\u003E\u003Cp\u003EMerci de rééssayer ou de contacter le service client.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeleteMandateModalCtrl = function () {
    /** @ngInject */
    DeleteMandateModalCtrl.$inject = ["$state", "User", "ErrorCatcher"];
    function DeleteMandateModalCtrl($state, User, ErrorCatcher) {
        _classCallCheck(this, DeleteMandateModalCtrl);

        this.$state = $state;
        this.User = User;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(DeleteMandateModalCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.currentState = 'state-form';
            this.hasSubmitted = false;
            this.isSubmitted = false;
            this.isSending = false;
            this.errorMessage = null;
        }
    }, {
        key: 'deleteMandate',
        value: function deleteMandate() {
            var _this = this;

            this.hasSubmitted = true;
            this.isSending = true;
            this.User.deleteMandate().$promise.then(function (result) {
                _this.isSubmitted = true;
                _this.currentState = 'state-finish';
                window.location = result.redirectUrl;
            }).catch(function (error) {
                _this.ErrorCatcher.catchError(error);
                _this.errorMessage = error.data.message;
                _this.currentState = 'state-error';
            }).finally(function () {
                _this.isSending = false;
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close({ $value: { isSubmitted: this.isSubmitted } });
        }
    }]);

    return DeleteMandateModalCtrl;
}();

exports.default = {
    template: __webpack_require__(1008)(),
    controller: DeleteMandateModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.closeModal()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"change-credit-card-modal\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4 class=\"marine\"\u003ERÉVOQUER VOTRE MANDAT\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-email-form\" ng-if=\"$ctrl.currentState === 'state-form'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EÊtes-vous sûr de vouloir révoquer votre mandat de prélèvement SEPA ?\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-if=\"!$ctrl.isSubmitted\" ng-disabled=\"$ctrl.isSending\" ng-click=\"$ctrl.closeModal()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" type=\"submit\" ng-disabled=\"$ctrl.isSending\" ng-class=\"{'btn-spinner-loading': $ctrl.isSending}\" ng-click=\"$ctrl.deleteMandate()\"\u003ERévoquer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-finish\" ng-if=\"$ctrl.currentState === 'state-finish'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003ELe mandat a été révoqué.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"block block-state-error\" ng-if=\"$ctrl.currentState === 'state-error'\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cp\u003EUne erreur est survenue lors de la révocation de votre mandat.\u003C\u002Fp\u003E\u003Cp class=\"error\"\u003E{{$ctrl.errorMessage}}\u003C\u002Fp\u003E\u003Cp\u003EMerci de rééssayer ou de contacter le service client.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-bluegrey\" type=\"button\" ng-click=\"$ctrl.closeModal()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


personalInformationDetail.$inject = ["$uibModal", "$timeout", "$state", "ApiService", "User", "ContactTelephone", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = personalInformationDetail;

/** @ngInject */

function personalInformationDetail($uibModal, $timeout, $state, ApiService, User, ContactTelephone, ErrorCatcher) {
    return {
        restrict: 'E',
        scope: {
            userInfo: '<'
        },
        template: __webpack_require__(1010)(),
        link: function link($scope) {
            var _this = this;

            $scope.contactTelephone = ContactTelephone;
            $scope.billingAddress = {
                value: null,
                isLoading: false
            };
            $scope.myIban = {
                value: null,
                isLoading: false
            };
            $scope.isEditing = false;
            $scope.isSubmitting = false;
            $scope.addSecondNominal = false;
            $scope.error = null;
            $scope.nominalForm = {
                identity: {}
            };
            $scope.form = {
                givenname: null,
                sn: null,
                civ: null,
                birth_date: null,
                givenname2: null,
                sn2: null,
                civ2: null,
                accept_contacts: null
            };

            $scope.editForm = function () {
                $scope.isEditing = true;
                $scope.isSubmitting = false;
                $scope.addSecondNominal = !(0, _isEmpty3.default)($scope.userInfo.civ2);
                $scope.form = {
                    givenname: $scope.userInfo.givenname,
                    sn: $scope.userInfo.sn,
                    civ: $scope.userInfo.civ,
                    birth_date: $scope.userInfo.birth_date,
                    givenname2: $scope.userInfo.givenname2,
                    sn2: $scope.userInfo.sn2,
                    civ2: $scope.userInfo.civ2,
                    accept_contacts: $scope.userInfo.accept_contacts
                };
            };

            $scope.closeForm = function () {
                $scope.isEditing = false;
                $scope.isSubmitting = false;
            };

            $scope.toggleAddSecondNominal = function () {
                $scope.addSecondNominal = !$scope.addSecondNominal;
                if ($scope.addSecondNominal === false) {
                    $scope.form.givenname2 = null;
                    $scope.form.sn2 = null;
                    $scope.form.civ2 = null;
                }
            };

            $scope.reloadData = function () {
                // Reload userInfo instead of reloading page (currently break transition & page animation)
                ApiService.resetPromise('userInfo');
                $state.go($state.current, { contractId: $scope.userInfo.contractSelected.id }, { reload: true });
            };

            $scope.submit = function () {
                $scope.nominalForm.identity.$setSubmitted();
                if ($scope.nominalForm.identity.$invalid || !(0, _moment2.default)($scope.form.birth_date).isValid()) {
                    return;
                }

                $scope.isSubmitting = true;
                User.saveNominativeInfo((0, _assign3.default)({}, $scope.form, { birth_date: (0, _moment2.default)($scope.form.birth_date).format('YYYY-MM-DD') })).$promise.then(function () {
                    $scope.closeForm();
                    $scope.reloadData();
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    $scope.isSubmitting = false;
                    $scope.error = error;
                });
            };

            $scope.openChangePasswordModal = function () {
                $uibModal.open({
                    animation: true,
                    component: 'changePasswordModal',
                    resolve: {
                        email: function email() {
                            return $scope.userInfo.mail;
                        }
                    }
                }).result.then(function (result) {
                    if (result.isSubmitted) {
                        $scope.reloadData();
                    }
                });
            };

            $scope.openChangeEmailModal = function () {
                $uibModal.open({
                    animation: true,
                    component: 'changeEmailModal'
                }).result.then(function (result) {
                    if (result.isSubmitted) {
                        $scope.reloadData();
                    }
                });
            };

            $scope.openChangeMobileModal = function (_currentPhoneNumber) {
                $uibModal.open({
                    animation: true,
                    component: 'changeMobileModal',
                    resolve: {
                        currentPhoneNumber: function currentPhoneNumber() {
                            return _currentPhoneNumber;
                        }
                    }
                }).result.then(function (result) {
                    if (result.isSubmitted) {
                        $scope.reloadData();
                    }
                });
            };

            $scope.openChangeBillingAddress = function () {
                $uibModal.open({
                    animation: true,
                    component: 'changeBillingAddressModal',
                    size: 'lg'
                }).result.then(function (result) {
                    if (result.isSubmitted) {
                        $scope.reloadData();
                    }
                });
            };

            $scope.openChangeSelectedPaymentMethodModal = function (_recurrentCbPayment) {
                $uibModal.open({
                    animation: true,
                    component: 'changeSelectedPaymentMethodModal',
                    resolve: {
                        recurrentCbPayment: function recurrentCbPayment() {
                            return _recurrentCbPayment;
                        }
                    },
                    size: 'lg'
                }).result.then(function (result) {
                    if (result.isSubmitted) {
                        $scope.reloadData();
                    }
                });
            };

            $scope.openDeleteCreditCardModal = function () {
                $uibModal.open({
                    animation: true,
                    component: 'deleteCreditCardModal',
                    size: 'lg'
                }).result.then(function (result) {
                    if (result.isSubmitted) {
                        $scope.reloadData();
                    }
                });
            };

            $scope.openDeleteMandateModal = function () {
                $uibModal.open({
                    animation: true,
                    component: 'deleteMandateModal',
                    size: 'lg'
                }).result.then(function (result) {
                    if (result.isSubmitted) {
                        $scope.reloadData();
                    }
                });
            };

            $scope.signMandate = function () {
                return User.signMandate().$promise.then(function (result) {
                    window.open(result.redirectUrl, '_newtab');
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    _this.errorMessage = error.data.message;
                });
            };

            $scope.addCreditCard = function () {
                return User.createAlias().$promise.then(function (result) {
                    window.open(result.redirectUrl, '_newtab');
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    _this.errorMessage = error.data.message;
                });
            };

            $scope.getBillingAddress = function () {
                $scope.billingAddress.isLoading = true;
                return User.getBillingAddress().$promise.then(function (billingAddressResult) {
                    $scope.billingAddress.value = billingAddressResult;
                }).catch(ErrorCatcher.catchError).finally(function () {
                    $scope.billingAddress.isLoading = false;
                });
            };

            $scope.hasCreditCardExpired = function () {
                return (0, _moment2.default)().isAfter((0, _moment2.default)($scope.billingAddress.value.alias_expiration));
            };

            $scope.getIban = function () {
                User.getMyIban().$promise.then(function (myIbanResult) {
                    $scope.myIban.value = myIbanResult;
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                    _this.errorMessage = error.data.message;
                });
            };

            var activate = function activate() {
                $scope.getBillingAddress();
                $scope.getIban();
            };
            activate();
        }
    };
}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"text-center margin-top-40 margin-bottom-50 hidden-xs\"\u003E\u003Ch1 class=\"margin-top-15 bold\"\u003EMes informations personnelles\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"large-main-panel my-personal-information\"\u003E\u003Cdiv class=\"block-personal-information\"\u003E\u003Cdiv class=\"header row\"\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Ch3\u003EMes données personnelles\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cdiv class=\"action-right\"\u003E\u003Ci ng-class=\"{'spinner spinner-form': isSubmitting}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-show=\"!isEditing\" ng-click=\"editForm()\"\u003EModifier mes données personnelles\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-show=\"isEditing\" ng-disabled=\"isSubmitting\" ng-click=\"closeForm()\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-waterblue\" ng-show=\"isEditing\" ng-disabled=\"isSubmitting\" ng-click=\"submit()\" ng-class=\"{'btn-spinner-loading': click}\"\u003EMettre à jour\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!isEditing\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003ECIVILITÉ :\u003C\u002Fp\u003E\u003Cspan\u003E{{{'M.': 'Monsieur', 'Mme': 'Madame'}[userInfo.civ]}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-12 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003ENOM :\u003C\u002Fp\u003E{{userInfo.sn}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-12 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EPRÉNOM :\u003C\u002Fp\u003E{{userInfo.givenname}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-12 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EDATE DE NAISSANCE :\u003C\u002Fp\u003E{{userInfo.birth_date | date: 'dd MMMM yyyy' }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\" ng-if=\"userInfo.civ2\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003ECIVILITÉ :\u003C\u002Fp\u003E\u003Cspan\u003E{{{'M.': 'Monsieur', 'Mme': 'Madame'}[userInfo.civ2]}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-12 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003ENOM :\u003C\u002Fp\u003E{{userInfo.sn2}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-12 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EPRÉNOM :\u003C\u002Fp\u003E{{userInfo.givenname2}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003ERECEVOIR LA NEWSLETTER\u003C\u002Fp\u003E{{userInfo.accept_contacts ? 'Oui' : 'Non'}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"isEditing\"\u003E\u003Cform name=\"nominalForm.identity\"\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"error\"\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp\u003E\u003Cstrong ng-if=\"!error.data.message\"\u003EUne erreur s'est produite.\u003C\u002Fstrong\u003E\u003Cstrong ng-if=\"error.data.message\"\u003E{{error.data.message}}\u003C\u002Fstrong\u003E\u003Cbr\u003E\u003Cbr\u003EVous avez la possibilité de contacter le service client au\n\u003Ca class=\"underline\" ng-href=\"{{contactTelephone.anonymous.link}}\" ng-bind=\"contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\nafin de résoudre le problème.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: nominalForm.identity.$submitted &amp;&amp; nominalForm.identity.civ.$invalid}\"\u003E\u003Cdiv class=\"col-md-12 form-field\"\u003E\u003Clabel\u003ECIVILITÉ :\u003C\u002Flabel\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 col-md-3\"\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput type=\"radio\" name=\"civ\" value=\"Mme\" ng-model=\"form.civ\" ng-disabled=\"isSubmitting\" required\u003EMadame\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 col-md-3\"\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput type=\"radio\" name=\"civ\" value=\"M.\" ng-model=\"form.civ\" ng-disabled=\"isSubmitting\" required\u003EMonsieur\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: nominalForm.identity.$submitted &amp;&amp; nominalForm.identity.sn.$invalid}\"\u003E\u003Cdiv class=\"col-md-12 form-field\"\u003E\u003Clabel for=\"sn\"\u003ENOM :\u003C\u002Flabel\u003E\u003Cinput class=\"force-uppercase\" type=\"text\" id=\"sn\" name=\"sn\" ng-model=\"form.sn\" ng-disabled=\"isSubmitting\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: nominalForm.identity.$submitted &amp;&amp; nominalForm.identity.givenname.$invalid}\"\u003E\u003Cdiv class=\"col-md-12 form-field\"\u003E\u003Clabel for=\"givenname\"\u003EPRÉNOM :\u003C\u002Flabel\u003E\u003Cinput type=\"text\" id=\"givenname\" name=\"givenname\" ng-model=\"form.givenname\" ng-disabled=\"isSubmitting\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-md-12 form-field\"\u003E\u003Clabel\u003EDATE DE NAISSANCE * :\u003C\u002Flabel\u003E\u003Cdate-field class=\"form-inline\" date=\"form.birth_date\" min=\"'1900-01-01'\"\u003E\u003C\u002Fdate-field\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 form-message\" ng-class=\"{formmessage: !isMobile(), formmessagemob: isMobile()}\"\u003E\u003Cp ng-if=\"nominalForm.identity.$submitted &amp;&amp; !birthDate.isValid()\"\u003ELe format de votre date de naissance semble incorrect. Respectez le format : JJ MM AAAA.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cdiv class=\"row form-group\" ng-if=\"addSecondNominal\" ng-class=\"{error: nominalForm.identity.$submitted &amp;&amp; nominalForm.identity.civ2.$invalid}\"\u003E\u003Cdiv class=\"col-md-12 form-field\"\u003E\u003Clabel\u003ECIVILITÉ :\u003C\u002Flabel\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 col-md-3\"\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput type=\"radio\" name=\"civ2\" value=\"Mme\" ng-model=\"form.civ2\" ng-disabled=\"isSubmitting\" required\u003EMadame\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 col-md-3\"\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput type=\"radio\" name=\"civ2\" value=\"M.\" ng-model=\"form.civ2\" ng-disabled=\"isSubmitting\" required\u003EMonsieur\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-if=\"addSecondNominal\" ng-class=\"{error: nominalForm.identity.$submitted &amp;&amp; nominalForm.identity.sn2.$invalid}\"\u003E\u003Cdiv class=\"col-md-12 form-field\"\u003E\u003Clabel for=\"sn2\"\u003ENOM :\u003C\u002Flabel\u003E\u003Cinput class=\"force-uppercase\" type=\"text\" id=\"sn2\" name=\"sn2\" ng-model=\"form.sn2\" ng-disabled=\"isSubmitting\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-if=\"addSecondNominal\" ng-class=\"{error: nominalForm.identity.$submitted &amp;&amp; nominalForm.identity.givenname2.$invalid}\"\u003E\u003Cdiv class=\"col-md-12 form-field\"\u003E\u003Clabel for=\"givenname2\"\u003EPRÉNOM :\u003C\u002Flabel\u003E\u003Cinput type=\"text\" id=\"givenname2\" name=\"givenname2\" ng-model=\"form.givenname2\" ng-disabled=\"isSubmitting\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12\"\u003E\u003Cbutton class=\"btn background-waterblue\" type=\"button\" ng-if=\"!addSecondNominal\" ng-click=\"toggleAddSecondNominal()\" ng-disabled=\"isSubmitting\"\u003EAjouter une personne\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"button\" ng-if=\"addSecondNominal\" ng-click=\"toggleAddSecondNominal()\" ng-disabled=\"isSubmitting\"\u003ESupprimer la personne\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: nominalForm.identity.$submitted &amp;&amp; nominalForm.identity.accept_contacts.$invalid}\"\u003E\u003Cdiv class=\"col-sm-6 form-field\"\u003E\u003Clabel\u003ERECEVOIR LA NEWSLETTER\u003C\u002Flabel\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 col-md-3\"\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput type=\"radio\" name=\"accept_contacts\" ng-value=\"true\" ng-model=\"form.accept_contacts\" ng-disabled=\"isSubmitting\" required\u003EOui\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 col-md-3\"\u003E\u003Cdiv class=\"radio-inline\"\u003E\u003Clabel\u003E\u003Cinput type=\"radio\" name=\"accept_contacts\" ng-value=\"false\" ng-model=\"form.accept_contacts\" ng-disabled=\"isSubmitting\" required\u003ENon\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"large-main-panel my-personal-information margin-top-30\"\u003E\u003Cdiv class=\"block-personal-information\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ch3\u003EMes coordonnées de contact\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EE-MAIL :&nbsp;\u003C\u002Fp\u003E{{userInfo.mail}}\u003Cdiv class=\"margin-top-15\"\u003E\u003Cbutton class=\"inline-block btn background-bluegrey clickable\" ng-if=\"$root.dataFeature['personalInformationEdit'] &amp;&amp; !isEditing\" ng-click=\"openChangeEmailModal()\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nModifier\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003ETÉLÉPHONE :&nbsp;\u003C\u002Fp\u003E{{userInfo.phone}}\u003Cdiv class=\"margin-top-15\"\u003E\u003Cbutton class=\"inline-block btn background-bluegrey clickable\" ng-if=\"$root.dataFeature['personalInformationEdit'] &amp;&amp; !isEditing\" ng-click=\"openChangeMobileModal(userInfo.phone)\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nModifier\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"large-main-panel my-personal-information margin-top-30\"\u003E\u003Cdiv class=\"block-banking-information\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ch3\u003EMes informations bancaires\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 marginb15\"\u003E\u003Cdiv class=\"contract-field\" ng-if=\"billingAddress.isLoading\"\u003E\u003Ci class=\"spinner spinner-form\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"!billingAddress.isLoading\"\u003E\u003Cp\u003EADRESSE DE FACTURATION :&nbsp;\u003C\u002Fp\u003E{{billingAddress.value.addr_num_street}}\u003Cbr\u003E{{billingAddress.value.addr_post_code}} {{billingAddress.value.addr_city_lbl}}\u003Cdiv class=\"margin-top-15\"\u003E\u003Cbutton class=\"inline-block btn background-bluegrey clickable\" ng-if=\"$root.dataFeature['personalInformationEdit'] &amp;&amp; !isEditing\" ng-click=\"openChangeBillingAddress()\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nModifier\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 marginb15\" ng-if=\"billingAddress.value.hasMandate &amp;&amp; billingAddress.value.hasCardAlias\"\u003E\u003Cdiv class=\"contract-field\"\u003E\u003Cp\u003EMoyen de paiement sélectionné pour la facturation :\u003C\u002Fp\u003E{{ billingAddress.value.recurrent_cb_payment ? 'Carte bancaire' : 'Prélèvement SEPA' }}\u003Cdiv class=\"margin-top-15\"\u003E\u003Cbutton class=\"inline-block btn background-bluegrey clickable\" ng-if=\"!billingAddress.value.revoked &amp;&amp; !hasCreditCardExpired()\" ng-click=\"openChangeSelectedPaymentMethodModal(billingAddress.value.recurrent_cb_payment)\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nModifier\u003C\u002Fbutton\u003E\u003Cp ng-if=\"billingAddress.value.revoked || hasCreditCardExpired()\"\u003EVous devez avoir deux moyens de paiement valides pour en changer\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 marginb15\" ng-if=\"$root.dataFeature['personalInformationIban'] &amp;&amp; billingAddress.value.hasMandate\"\u003E\u003Cdiv class=\"contract-field\" ng-if=\"myIban.isLoading\"\u003E\u003Ci class=\"spinner spinner-form\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contract-field\" ng-if=\"!myIban.isLoading\"\u003E\u003Cp\u003EMandat de prélèvement SEPA\u003C\u002Fp\u003EIBAN : {{myIban.value.iban | iban}}\u003Cp\u003EStatut : {{ billingAddress.value.revoked ? 'révoqué' : 'valide' }}\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-15\"\u003E\u003Cbutton class=\"inline-block btn background-bluegrey clickable\" ng-if=\"$root.dataFeature['personalInformationEdit'] &amp;&amp; !isEditing\" ng-click=\"signMandate()\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nSigner un nouveau mandat\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-15\" ng-if=\"billingAddress.value.hasCardAlias &amp;&amp; !hasCreditCardExpired()\"\u003E\u003Cbutton class=\"inline-block btn background-dark-pink clickable\" ng-if=\"$root.dataFeature['personalInformationEdit'] &amp;&amp; !isEditing\" ng-click=\"openDeleteMandateModal()\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nSupprimer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 marginb15\" ng-if=\"billingAddress.value.hasCardAlias\"\u003E\u003Cdiv class=\"contract-field\" ng-if=\"!myCreditCard.isLoading\"\u003E\u003Cp\u003ECarte bancaire\u003C\u002Fp\u003EDate d'expiration : {{ billingAddress.value.alias_expiration }}\u003Cp\u003EStatut : {{ hasCreditCardExpired() ? 'expirée' : 'valide' }}\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-15\"\u003E\u003Cbutton class=\"inline-block btn background-bluegrey clickable\" ng-if=\"$root.dataFeature['personalInformationEdit'] &amp;&amp; !isEditing\" ng-click=\"addCreditCard()\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nModifier\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-15\" ng-if=\"billingAddress.value.hasMandate &amp;&amp; !billingAddress.value.revoked\"\u003E\u003Cbutton class=\"inline-block btn background-dark-pink clickable\" ng-if=\"$root.dataFeature['personalInformationEdit'] &amp;&amp; !isEditing\" ng-click=\"openDeleteCreditCardModal()\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nSupprimer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 marginb15\" ng-if=\"!billingAddress.value.hasCardAlias\"\u003E\u003Cdiv class=\"margin-top-15\"\u003E\u003Cbutton class=\"inline-block btn background-bluegrey clickable\" ng-if=\"$root.dataFeature['personalInformationEdit'] &amp;&amp; !isEditing\" ng-click=\"addCreditCard()\"\u003E\u003Ci class=\"open-modal fa fa-pencil-square-o\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\nAjouter une carte bancaire\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


personalInfoSponsorLink.$inject = ["$window"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = personalInfoSponsorLink;

/** @ngInject */

function personalInfoSponsorLink($window) {
    return {
        restrict: 'E',
        scope: {
            customerId: '<'
        },
        template: __webpack_require__(1012)(),
        link: function link($scope) {
            $scope.sponsorUrl = $window.location.origin + '/parrainage/' + $scope.customerId;
            $scope.displayedSponsorUrl = $window.location.hostname + '/parrainage/' + $scope.customerId;
        }
    };
}

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"bidule-panel bidule-panel-sponsor-link\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4\u003ELIENS DE&nbsp;PARRAINAGE\u003C\u002Fh4\u003E\u003Cp ng-bind=\"displayedSponsorUrl\"\u003E\u003C\u002Fp\u003E\u003Cbutton class=\"btn background-waterblue\" clipboard text=\"sponsorUrl\" uib-popover=\"Le lien a été copié dans le presse-papier\" popover-placement=\"bottom\" popover-trigger=\"'outsideClick'\" popover-class=\"popover-sponsor\" type=\"button\"\u003Ecopier\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


personalInformationCtrl.$inject = ["$scope", "$window", "userInfo"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = personalInformationCtrl;

/** @ngInject */

function personalInformationCtrl($scope, $window, userInfo) {
    $scope.userInfo = userInfo;
}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _angularjsSlider = __webpack_require__(1015);

var _angularjsSlider2 = _interopRequireDefault(_angularjsSlider);

var _ngRedux = __webpack_require__(1016);

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _redux = __webpack_require__(338);

var _reduxThunk = __webpack_require__(1085);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__(1086);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reduxPersist = __webpack_require__(1087);

var _reduxBeacon = __webpack_require__(1093);

var _logger = __webpack_require__(1096);

var _googleAnalytics = __webpack_require__(1098);

__webpack_require__(1103);

var _quotation = __webpack_require__(1104);

var _quotation2 = _interopRequireDefault(_quotation);

var _quotation3 = __webpack_require__(1105);

var _quotation4 = _interopRequireDefault(_quotation3);

var _quotationMiddleware = __webpack_require__(1106);

var _quotationMiddleware2 = _interopRequireDefault(_quotationMiddleware);

var _quotation5 = __webpack_require__(1107);

var _quotation6 = _interopRequireDefault(_quotation5);

var _quotationFormInitial = __webpack_require__(1109);

var _quotationFormInitial2 = _interopRequireDefault(_quotationFormInitial);

var _quotationFormLandscape = __webpack_require__(1111);

var _quotationFormLandscape2 = _interopRequireDefault(_quotationFormLandscape);

var _quotationFormConsumption = __webpack_require__(1113);

var _quotationFormConsumption2 = _interopRequireDefault(_quotationFormConsumption);

var _quotationModalIneligibility = __webpack_require__(1116);

var _quotationModalIneligibility2 = _interopRequireDefault(_quotationModalIneligibility);

var _quotationResultActions = __webpack_require__(1118);

var _quotationResultActions2 = _interopRequireDefault(_quotationResultActions);

var _quotationResultAnnualConsumption = __webpack_require__(1120);

var _quotationResultAnnualConsumption2 = _interopRequireDefault(_quotationResultAnnualConsumption);

var _quotationResultLandscape = __webpack_require__(1122);

var _quotationResultLandscape2 = _interopRequireDefault(_quotationResultLandscape);

var _quotationResultPot = __webpack_require__(1124);

var _quotationResultPot2 = _interopRequireDefault(_quotationResultPot);

var _quotationResultError = __webpack_require__(1126);

var _quotationResultError2 = _interopRequireDefault(_quotationResultError);

var _quotationTimetable = __webpack_require__(1128);

var _quotationTimetable2 = _interopRequireDefault(_quotationTimetable);

var _quotationMobileIntro = __webpack_require__(1130);

var _quotationMobileIntro2 = _interopRequireDefault(_quotationMobileIntro);

var _quotationVisitorMain = __webpack_require__(1132);

var _quotationVisitorMain2 = _interopRequireDefault(_quotationVisitorMain);

var _quotationVisitorNewsletter = __webpack_require__(1134);

var _quotationVisitorNewsletter2 = _interopRequireDefault(_quotationVisitorNewsletter);

var _quotationVisitorFacebook = __webpack_require__(1136);

var _quotationVisitorFacebook2 = _interopRequireDefault(_quotationVisitorFacebook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Used redux library:
 * ng-redux: Allow to use redux paradigm in angularjs 1 to ease state management
 * redux: state management
 * redux-logger: middleware logger to see action + previous/next state
 * redux-thunk: simple middleware to transform async actions to sync actions as redux require sync actions
 * redux-persist: middleware to save current state in local storage & reload the page with user data
 * Redux DevTools - Chrome extension (window.__REDUX_DEVTOOLS_EXTENSION__()): used to debug state & action with Chrome tools
 */
exports.default = _angular2.default.module('unergie.quotation', [_ngRedux2.default, _angularjsSlider2.default]).config( /** @ngInject */["$ngReduxProvider", function ($ngReduxProvider) {
    /* look on https://github.com/angular-redux/ng-redux for specific angularjs redux implementation */
    var reducers = (0, _redux.combineReducers)({
        quotation: _quotation2.default
    });

    /* Redux DevTools extension allow watching action using chrome extention */
    /* https://github.com/zalmoxisus/redux-devtools-extension */
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        $ngReduxProvider.createStoreWith(reducers, [_reduxThunk2.default, 'quotationMiddleware', (0, _reduxBeacon.createMiddleware)(_quotation4.default, _googleAnalytics.GoogleAnalytics, { logger: _logger.logger }), _reduxLogger2.default], [(0, _reduxPersist.autoRehydrate)(), window.__REDUX_DEVTOOLS_EXTENSION__()]);
    } else {
        $ngReduxProvider.createStoreWith(reducers, [_reduxThunk2.default, 'quotationMiddleware', (0, _reduxBeacon.createMiddleware)(_quotation4.default, _googleAnalytics.GoogleAnalytics)], [(0, _reduxPersist.autoRehydrate)()]);
    }
}]).run( /** @ngInject */["$ngRedux", function ($ngRedux) {
    // Persist each state change into local storage
    (0, _reduxPersist.persistStore)($ngRedux, { blacklist: ['@@INIT'] });
}]).factory('quotationMiddleware', _quotationMiddleware2.default).component('quotation', _quotation6.default).component('quotationFormInitial', _quotationFormInitial2.default).component('quotationFormLandscape', _quotationFormLandscape2.default).component('quotationFormConsumption', _quotationFormConsumption2.default).component('quotationModalIneligibility', _quotationModalIneligibility2.default).component('quotationResultActions', _quotationResultActions2.default).component('quotationResultAnnualConsumption', _quotationResultAnnualConsumption2.default).component('quotationResultLandscape', _quotationResultLandscape2.default).component('quotationResultPot', _quotationResultPot2.default).component('quotationResultError', _quotationResultError2.default).component('quotationTimetable', _quotationTimetable2.default).component('quotationMobileIntro', _quotationMobileIntro2.default).component('quotationVisitorMain', _quotationVisitorMain2.default).component('quotationVisitorNewsletter', _quotationVisitorNewsletter2.default).component('quotationVisitorFacebook', _quotationVisitorFacebook2.default).name;

/***/ }),
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _constants = __webpack_require__(89);

var _timeline = __webpack_require__(191);

var _timeline2 = _interopRequireDefault(_timeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = quotationReducer;


var INITIAL_STATE = {
    viewState: 'state-form-initial',
    contractDraft: {},
    landscapeContractDraft: {},
    landscapeQuestions: {},
    tariffOptions: {},
    isLandscapeDone: false,
    isMobileIntroVisible: true,
    consumptionView: {
        isPostCodeIneligible: false,
        postCodeValidation: {},
        consumptionForm: {
            declaredAnnualCons: {},
            factorCons: 0,
            power: 6,
            calendar: 'BASE',
            postcode: null,
            citycode: null
        }
    },
    quotationView: {
        quotationResult: null,
        quotationError: null,
        graphTimetable: [],
        potResult: {
            reduction: null,
            pot: null,
            total: null
        }
    },
    timetableView: {
        sleek_timetable: false,
        tutorial: {
            display: false,
            state: 'state-1',
            sleek_timetable: false,
            isSummer: false,
            isWinter: false,
            isNextReading: false
        }
    },
    potView: {
        viewState: 'state-form',
        isUpdating: false,
        error: null
    },
    resultPotView: {
        viewState: 'state-initial'
    },
    visitorView: {
        viewState: 'state-initial'
    }
};

function viewStateReducer(state, action) {
    switch (action.type) {
        case 'GO_TO_INITIAL':
            return 'state-form-initial';
        case 'GO_TO_FORM_LANDSCAPE':
            return 'state-form-landscape';
        case 'GO_TO_FORM_CONSUMPTION':
            return 'state-form-consumption';
        case 'GO_TO_STATE_RESULT':
            return 'state-result';
        case 'GO_TO_STATE_TIMETABLE':
            return 'state-timetable';
        case 'GO_TO_STATE_POT':
            return 'state-pot';
        case 'GO_TO_STATE_VISITOR':
            return 'state-visitor';
        case 'GET_QUOTATION':
            return 'state-result-loading';
        case 'GET_QUOTATION_DONE':
            return 'state-result';
        case 'GET_QUOTATION_ERROR':
            return 'state-result-error';
        case 'INIT_VIEW_STATE':
            return action.viewState;
        default:
            return state;
    }
}

function consumptionViewReducer(state, action) {
    switch (action.type) {
        case 'VALIDATE_POST_CODE':
            return (0, _assign3.default)({}, state, {
                postCodeValidation: { state: 'PENDING', choosen_post_code: action.choosen_post_code }
            });
        case 'VALIDATE_POST_CODE_DONE':
            return (0, _assign3.default)({}, state, {
                isPostCodeIneligible: action.postCodeResult.exist && !action.postCodeResult.eligible,
                postCodeValidation: (0, _assign3.default)({}, action.postCodeResult, {
                    state: 'DONE',
                    choosen_post_code: action.choosen_post_code
                })
            });
        case 'VALIDATE_POST_CODE_FAIL':
            return (0, _assign3.default)({}, state, {
                postCodeValidation: {
                    state: 'FAIL',
                    choosen_post_code: action.choosen_post_code,
                    error: action.error
                }
            });
        case 'VALIDATE_POST_CODE_INITIAL':
            return (0, _assign3.default)({}, state, {
                isPostCodeIneligible: false,
                postCodeValidation: {}
            });
        case 'UPDATE_FORM_CONSUMPTION':
            return (0, _assign3.default)({}, state, {
                consumptionForm: (0, _assign3.default)({}, action.consumptionForm, { factorCons: 0 })
            });
        case 'UPDATE_QUOTATION_POT':
            return (0, _assign3.default)({}, state, {
                consumptionForm: (0, _assign3.default)({}, state.consumptionForm, { factorCons: action.factorCons })
            });
        default:
            return state;
    }
}

function quotationViewReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_FORM_CONSUMPTION':
        case 'GET_QUOTATION':
            return (0, _assign3.default)({}, state, {
                quotationResult: null,
                quotationError: null,
                graphTimetable: [],
                potResult: {
                    reduction: null,
                    pot: null,
                    total: null
                }
            });
        case 'GET_QUOTATION_DONE':
            return (0, _assign3.default)({}, state, {
                quotationResult: (0, _assign3.default)({}, action.quotationResult),
                graphTimetable: (0, _timeline2.default)(action.quotationResult.timetable)
            });
        case 'GET_QUOTATION_ERROR':
            return (0, _assign3.default)({}, state, {
                quotationError: action.error
            });
        case 'UPDATE_QUOTATION_POT':
            return (0, _assign3.default)({}, state, {
                potResult: {
                    reduction: null,
                    pot: null,
                    total: null
                }
            });
        case 'UPDATE_QUOTATION_POT_DONE':
            return (0, _assign3.default)({}, state, {
                quotationResult: (0, _assign3.default)({}, state.quotationResult, { pot: action.pot }),
                potResult: {
                    reduction: action.pot.total.normal - action.pot.total.factored,
                    pot: action.pot.pot,
                    total: action.pot.total.normal - action.pot.total.factored + action.pot.pot
                }
            });
        default:
            return state;
    }
}

function timetableViewReducer(state, action) {
    switch (action.type) {
        case 'GO_TO_STATE_TIMETABLE':
            return (0, _assign3.default)({}, state, {
                tutorial: {
                    display: false,
                    state: 'state-1',
                    sleek_timetable: false,
                    isSummer: false,
                    isWinter: false,
                    isNextReading: false
                }
            });
        case 'UPDATE_SLEEK_TIMETABLE':
            return (0, _assign3.default)({}, state, {
                sleek_timetable: action.sleek_timetable
            });
        case 'TIMETABLE_VIEW_TUTORIAL_CLOSE':
            return (0, _assign3.default)({}, state, {
                tutorial: (0, _assign3.default)({}, state.tutorial, {
                    display: false,
                    state: 'state-1',
                    sleek_timetable: false,
                    isSummer: false,
                    isWinter: false,
                    isNextReading: false
                })
            });
        case 'TIMETABLE_VIEW_TUTORIAL_NEXT':
            {
                var tutorial = void 0;
                if (state.tutorial.display === false) {
                    tutorial = {
                        display: true,
                        state: 'state-1',
                        sleek_timetable: false,
                        seasonClass: 'summer',
                        isSummer: true,
                        isWinter: false,
                        isNextReading: false
                    };
                } else if (state.tutorial.state === 'state-1') {
                    tutorial = {
                        display: true,
                        state: 'state-2',
                        sleek_timetable: false,
                        seasonClass: 'winter',
                        isSummer: false,
                        isWinter: true,
                        isNextReading: false
                    };
                } else if (state.tutorial.state === 'state-2') {
                    tutorial = {
                        display: true,
                        state: 'state-3',
                        sleek_timetable: true,
                        isSummer: false,
                        isWinter: false,
                        isNextReading: false
                    };
                } else if (state.tutorial.state === 'state-3') {
                    tutorial = {
                        display: false,
                        state: 'state-1',
                        sleek_timetable: false,
                        isSummer: false,
                        isWinter: false,
                        isNextReading: false
                    };
                } else {
                    tutorial = {
                        display: false,
                        state: 'state-1',
                        sleek_timetable: false,
                        isSummer: false,
                        isWinter: false,
                        isNextReading: false
                    };
                }
                return (0, _assign3.default)({}, state, {
                    tutorial: (0, _assign3.default)({}, state.tutorial, tutorial)
                });
            }
        default:
            return state;
    }
}

function potViewReducer(state, action) {
    switch (action.type) {
        case 'GO_TO_STATE_POT':
            return (0, _assign3.default)({}, state, {
                viewState: 'state-form'
            });
        case 'UPDATE_FORM_CONSUMPTION':
            return (0, _assign3.default)({}, state, {
                viewState: 'state-form',
                isUpdating: false,
                error: null
            });
        case 'UPDATE_QUOTATION_POT':
            return (0, _assign3.default)({}, state, {
                isUpdating: true
            });
        case 'UPDATE_QUOTATION_POT_DONE':
            return (0, _assign3.default)({}, state, {
                viewState: 'state-result',
                isUpdating: false
            });
        case 'UPDATE_QUOTATION_POT_ERROR':
            return (0, _assign3.default)({}, state, {
                isUpdating: false,
                error: action.error
            });
        default:
            return state;
    }
}

function resultPotViewReducer(state, action) {
    switch (action.type) {
        case 'OPEN_RESULT_POT_DETAIL':
            return (0, _assign3.default)({}, state, { viewState: 'state-detail' });
        default:
            return state;
    }
}

function visitorViewReducer(state, action) {
    switch (action.type) {
        case 'GO_TO_STATE_VISITOR':
            return (0, _assign3.default)({}, state, { viewState: 'state-initial' });
        case 'DISPLAY_NEWSLETTER_FORM':
            return (0, _assign3.default)({}, state, { viewState: 'state-form', isSubmitting: false });
        case 'SUBMIT_NEWSLETTER_FORM':
            return (0, _assign3.default)({}, state, { viewState: 'state-form', isSubmitting: true });
        case 'SUBMIT_NEWSLETTER_FORM_DONE':
            return (0, _assign3.default)({}, state, { viewState: 'state-success', isSubmitting: false });
        case 'SUBMIT_NEWSLETTER_FORM_ERROR':
            return (0, _assign3.default)({}, state, { viewState: 'state-form', isSubmitting: false });
        case 'DISPLAY_FIRST_ADVICE':
            return (0, _assign3.default)({}, state, { viewState: 'state-first-advice' });
        default:
            return state;
    }
}

function commonReducer(state, action) {
    switch (action.type) {
        case 'HIDE_MOBILE_INTRO':
            return (0, _assign3.default)({}, state, { isMobileIntroVisible: false });
        case 'ON_CHANGES_CONTRACT_DRAFT':
            return (0, _assign3.default)({}, state, {
                contractDraft: _angular2.default.copy(action.contractDraft.currentValue),
                landscapeContractDraft: { id: (0, _get3.default)(action, 'contractDraft.currentValue.id'), isDraft: true }
            });
        case 'ON_CHANGES_LANDSCAPE_QUESTIONS':
            return (0, _assign3.default)({}, state, { landscapeQuestions: _angular2.default.copy(action.landscapeQuestions.currentValue) });
        case 'ON_CHANGES_TARIFF_OPTIONS':
            return (0, _assign3.default)({}, state, { tariffOptions: _angular2.default.copy(action.tariffOptions.currentValue) });
        case 'LANDSCAPE_DONE':
            return (0, _assign3.default)({}, state, { isLandscapeDone: action.isLandscapeDone });
        default:
            return state;
    }
}

function quotationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    if (action.type === 'RESET_QUOTATION') {
        return (0, _assign3.default)({}, state, INITIAL_STATE);
    }
    if (action.type === _constants.REHYDRATE) {
        // Reload state from localstorage using redux-persist
        // Avoid to erase rehydrate state
        return state;
    }
    return (0, _assign3.default)({}, commonReducer(state, action), {
        viewState: viewStateReducer(state.viewState, action),
        quotationView: quotationViewReducer(state.quotationView, action),
        consumptionView: consumptionViewReducer(state.consumptionView, action),
        timetableView: timetableViewReducer(state.timetableView, action),
        potView: potViewReducer(state.potView, action),
        resultPotView: resultPotViewReducer(state.resultPotView, action),
        visitorView: visitorViewReducer(state.visitorView, action)
    });
}

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map2 = __webpack_require__(53);

var _map3 = _interopRequireDefault(_map2);

var _flatten2 = __webpack_require__(202);

var _flatten3 = _interopRequireDefault(_flatten2);

var _compact2 = __webpack_require__(324);

var _compact3 = _interopRequireDefault(_compact2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var combine = function combine() {
    for (var _len = arguments.length, actionFns = Array(_len), _key = 0; _key < _len; _key++) {
        actionFns[_key] = arguments[_key];
    }

    return function (action, prevState, nextState) {
        return (0, _compact3.default)((0, _flatten3.default)((0, _map3.default)(actionFns, function (fn) {
            return fn(action, prevState, nextState);
        })));
    };
};

var pageView = function pageView(action, prevState, nextState) {
    return {
        hitType: 'pageview',
        page: nextState.quotation.viewState
    };
};

var clickOnBtnStartQuotation = function clickOnBtnStartQuotation(action) {
    if (action.origin === 'FORM_INITIAL_BTN_DEMARRER') {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-button-start-landscape',
            eventLabel: 'Clic sur le bouton "Démarrer"'
        };
    }
    return null;
};

var clickOnBtnBypassConsumption = function clickOnBtnBypassConsumption(action) {
    if (action.origin === 'FORM_INITIAL_BTN_BYPASS') {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-link-bypass-consumption',
            eventLabel: 'Clic sur le lien "Cliquez ici pour passer cette étape"'
        };
    }
    return null;
};

var clickOnIconQuestionMarkLandscape = function clickOnIconQuestionMarkLandscape() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-questionmark-landscape',
        eventLabel: 'Clic sur le "Questionmark - Paysage"'
    };
};

var onLandscapeSuccess = function onLandscapeSuccess(action) {
    if (action.isLandscapeDone) {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'landscape-success',
            eventLabel: 'Paysage = success'
        };
    }
    return null;
};

var onIneligibilityPostcode = function onIneligibilityPostcode(action, prevState, nextState) {
    if (nextState.quotation.consumptionView.isPostCodeIneligible) {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'ineligibility-postcode',
            eventLabel: 'In\xE9ligibilit\xE9 Code Postale ' + nextState.quotation.consumptionView.consumptionForm.postcode
        };
    }
    return null;
};

var clickOnIconQuestionMarkWhereToFind = function clickOnIconQuestionMarkWhereToFind() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-questionmark-wheretofind',
        eventLabel: 'Clic sur le "Questionmark - Où trouver ces informations ?"'
    };
};

var onChoosePowerSelected = function onChoosePowerSelected(action, prevState, nextState) {
    var power = {
        previous: prevState.quotation.consumptionView.consumptionForm.power,
        current: nextState.quotation.consumptionView.consumptionForm.power
    };
    if (power.previous !== power.current) {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'choosen-power',
            eventLabel: 'Puissance choisie ' + power.current,
            eventValue: power.current
        };
    }
    return null;
};

var clickOnEstimate = function clickOnEstimate(action) {
    if (action.origin === 'FORM_INITIAL_BTN_ESTIMATE_QUOTATION') {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-button-estimate',
            eventLabel: 'Clic sur le bouton "Estimer mon devis"'
        };
    }
    return null;
};

var clickOnTimetable = function clickOnTimetable(action) {
    if (action.origin === 'RESULT_ANNUAL_CONSUMPTION_BTN_TIMETABLE') {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-button-see-timetable',
            eventLabel: 'Clic sur le bouton "Voir le détail"'
        };
    }
    return null;
};

var clickOnTimetableExplanation = function clickOnTimetableExplanation(action, prevState, nextState) {
    var tutorial = nextState.quotation.timetableView.tutorial;
    var tutorialState = tutorial.display ? tutorial.state : 'initial';
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-button-explanation-' + tutorialState,
        eventLabel: 'Clic sur le bouton tutorial ' + tutorialState
    };
};

var clickOnTimetableUnderstood = function clickOnTimetableUnderstood(action) {
    if (action.origin === 'TIMETABLE_BTN_UNDERSTOOD') {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-button-understood',
            eventLabel: 'Clic sur le bouton "J’AI COMPRIS"'
        };
    }
    return null;
};

var clickOnTimetableSleek = function clickOnTimetableSleek(action, prevState, nextState) {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'choosen-timetable-sleek',
        eventLabel: 'Choix  "lisser" ' + action.sleek_timetable,
        eventValue: action.sleek_timetable ? 1 : 0
    };
};

var clickOnPotChoosenSaving = function clickOnPotChoosenSaving(action, prevState, nextState) {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'choosen-savings',
        eventLabel: 'Choix ' + action.factorCons,
        eventValue: action.factorCons
    };
};

var hoverOnPotCardBill = function hoverOnPotCardBill() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'hover-card-bill',
        eventLabel: 'Hover card "Ma facture annuelle baisse"'
    };
};

var hoverOnPotCardPot = function hoverOnPotCardPot() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'hover-card-bill',
        eventLabel: 'Hover card "Ma facture annuelle baisse"'
    };
};

var clickOnButtonModifyInfo = function clickOnButtonModifyInfo(action) {
    if (action.origin === 'RESULT_LANDSCAPE_BTN_MODIFY') {
        return {
            hitType: 'event',
            eventCategory: 'quotation',
            eventAction: 'clic-button-modify-info',
            eventLabel: 'Clic sur le bouton "Modifier"'
        };
    }
    return null;
};

var clickOnWhatIsIt = function clickOnWhatIsIt() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-button-whatisit',
        eventLabel: 'Clic sur le bouton "Qu’est-ce que c’est"'
    };
};

var clickOnVisitor = function clickOnVisitor() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-button-visitor',
        eventLabel: 'Clic sur le bouton "En simple visite ?"'
    };
};

var clickOnSubscribePlum = function clickOnSubscribePlum() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-button-goplum',
        eventLabel: 'Clic sur le bouton "Je passe chez Plüm"'
    };
};

var clickOnDisplayNewsletterForm = function clickOnDisplayNewsletterForm() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-visitor-newsletter-display-form',
        eventLabel: 'Clic sur le bouton pour afficher le formulaire de newsletter'
    };
};

var clickOnSubmitNewsletterForm = function clickOnSubmitNewsletterForm() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-visitor-newsletter-submit-form',
        eventLabel: 'Clic sur le bouton pour soumettre le formulaire de newsletter'
    };
};

var clickOnDisplayFirstAdvice = function clickOnDisplayFirstAdvice() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-visitor-newsletter-display-first-advise',
        eventLabel: 'Clic sur le bouton pour afficher premier conseil'
    };
};

var clickOnVisitorFacebook = function clickOnVisitorFacebook() {
    return {
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: 'clic-link-facebook',
        eventLabel: 'Clic sur le lien "Facebook"'
    };
};

var eventsMap = {
    GO_TO_INITIAL: pageView,
    GO_TO_FORM_LANDSCAPE: combine(pageView, clickOnBtnStartQuotation),
    GO_TO_FORM_CONSUMPTION: combine(pageView, clickOnBtnBypassConsumption, clickOnButtonModifyInfo),
    GO_TO_STATE_RESULT: combine(pageView, clickOnTimetableUnderstood),
    GO_TO_STATE_TIMETABLE: combine(pageView, clickOnTimetable),
    GO_TO_STATE_VISITOR: clickOnVisitor,
    GO_TO_STATE_POT: pageView,
    INIT_VIEW_STATE: pageView,
    VALIDATE_POST_CODE_DONE: onIneligibilityPostcode,
    UPDATE_FORM_CONSUMPTION: onChoosePowerSelected,
    GET_QUOTATION: combine(pageView, clickOnEstimate),
    GET_QUOTATION_DONE: pageView,
    GET_QUOTATION_ERROR: pageView,
    UPDATE_QUOTATION_POT: clickOnPotChoosenSaving,
    UPDATE_SLEEK_TIMETABLE: clickOnTimetableSleek,
    TIMETABLE_VIEW_TUTORIAL_CLOSE: clickOnTimetableExplanation,
    TIMETABLE_VIEW_TUTORIAL_NEXT: clickOnTimetableExplanation,
    LANDSCAPE_DONE: onLandscapeSuccess,
    DISPLAY_NEWSLETTER_FORM: clickOnDisplayNewsletterForm,
    SUBMIT_NEWSLETTER_FORM: clickOnSubmitNewsletterForm,
    DISPLAY_FIRST_ADVICE: clickOnDisplayFirstAdvice,
    CLICK_ON_QUESTION_MARK_FORM_INITIAL: clickOnIconQuestionMarkLandscape,
    CLICK_ON_QUESTION_MARK_FORM_CONSUMPTION: clickOnIconQuestionMarkWhereToFind,
    CLICK_ON_QUESTION_MARK_WHAT_IS_IT: clickOnWhatIsIt,
    CLICK_ON_SUBSCRIBE_PLUM: clickOnSubscribePlum,
    CLICK_ON_VISITOR_FACEBOOK: clickOnVisitorFacebook,
    HOVER_ON_CARD_BILL: hoverOnPotCardBill,
    HOVER_ON_CARD_POT: hoverOnPotCardPot
};

exports.default = eventsMap;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


quotationMiddleware.$inject = ["$state"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quotationMiddleware;

/** @ngInject */

function quotationMiddleware($state) {
    var ALLOWED_VIEW_STATE = ['state-form-initial', 'state-form-landscape', 'state-form-consumption', 'state-result', 'state-result-error', 'state-timetable', 'state-pot', 'state-visitor'];

    return function (store) {
        return function (next) {
            return function (action) {
                var previousState = store.getState();
                next(action);
                var nextState = store.getState();

                // On initialization, check if $state.current is defined, otherwise do nothing
                if ($state.current) {
                    var isNotInitViewStateAction = action.type !== 'INIT_VIEW_STATE';
                    var isCurrentStateQuotation = $state.current.name === 'quotation';
                    var isViewStateDirty = previousState.quotation.viewState !== nextState.quotation.viewState;
                    var isAllowedViewState = ALLOWED_VIEW_STATE.indexOf(nextState.quotation.viewState) > -1;
                    if (isNotInitViewStateAction && isCurrentStateQuotation && isViewStateDirty && isAllowedViewState) {
                        $state.go('quotation', { viewState: nextState.quotation.viewState }, { notify: false, location: true });
                    }
                }

                return nextState;
            };
        };
    };
}

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationController = function () {
    /** @ngInject */
    QuotationController.$inject = ["$ngRedux", "$scope", "$window", "DeviceChecker", "ContractDraft", "LandingPageLink"];
    function QuotationController($ngRedux, $scope, $window, DeviceChecker, ContractDraft, LandingPageLink) {
        _classCallCheck(this, QuotationController);

        this.isMobile = DeviceChecker.isMobile;
        this.contractDraftService = ContractDraft;

        /* ngRedux will merge the requested state's slice and actions onto this,
          you don't need to redefine them in your controller */
        var unsubscribe = $ngRedux.connect(this.mapStateToThis)(this);
        $scope.landingPageLink = LandingPageLink[$window.location.hostname] + '/';
        $scope.$on('$destroy', unsubscribe);
    }

    _createClass(QuotationController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.contractDraft) {
                this.onDispatch({ type: 'ON_CHANGES_CONTRACT_DRAFT', contractDraft: changes.contractDraft });
            }
            if (changes.landscapeQuestions) {
                this.onDispatch({ type: 'ON_CHANGES_LANDSCAPE_QUESTIONS', landscapeQuestions: changes.landscapeQuestions });
            }
            if (changes.tariffOptions) {
                this.onDispatch({ type: 'ON_CHANGES_TARIFF_OPTIONS', tariffOptions: changes.tariffOptions });
            }
            if (changes.viewState) {
                var viewState = changes.viewState.currentValue;
                if (!(0, _isEmpty3.default)(viewState)) {
                    this.onDispatch({ type: 'INIT_VIEW_STATE', viewState: viewState });
                }
            }
        }
    }, {
        key: 'onDispatch',
        value: function onDispatch(event) {
            // dispatch instantiated from $ngRedux.connect
            this.dispatch(event);
        }

        // Which part of the Redux global state does our component want to receive?

    }, {
        key: 'mapStateToThis',
        value: function mapStateToThis(state) {
            return {
                store: state.quotation
            };
        }
    }]);

    return QuotationController;
}();

exports.default = {
    template: __webpack_require__(1108)(),
    controller: QuotationController,
    bindings: {
        contractDraft: '<',
        landscapeQuestions: '<',
        tariffOptions: '<',
        viewState: '<'
    }
};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-flex quotation-mobile\" ng-if=\"$ctrl.isMobile()\"\u003E\u003Cheader\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003Cspan\u003EMon devis\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-action\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Cdiv class=\"quotation-mobile-body\"\u003E\u003Cquotation-mobile-intro ng-if=\"$ctrl.store.viewState === 'state-form-initial' &amp;&amp; $ctrl.store.isMobileIntroVisible\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-mobile-intro\u003E\u003Cquotation-form-initial ng-if=\"$ctrl.store.viewState === 'state-form-initial' &amp;&amp; !$ctrl.store.isMobileIntroVisible\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-form-initial\u003E\u003Cquotation-form-landscape ng-show=\"$ctrl.store.viewState === 'state-form-landscape'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-form-landscape\u003E\u003Cquotation-form-consumption class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-form-consumption'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-form-consumption\u003E\u003Cquotation-result-error class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-result-error'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-error\u003E\u003Cquotation-result-annual-consumption class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-result'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-annual-consumption\u003E\u003Cquotation-result-pot class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-result'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-pot\u003E\u003Cquotation-result-landscape class=\"animate-fade-out\" ng-if=\"['state-form-consumption', 'state-result-loading', 'state-result', 'state-result-error'].indexOf($ctrl.store.viewState) &gt; -1\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-landscape\u003E\u003Cquotation-timetable class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-timetable'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-timetable\u003E\u003Cquotation-pot class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-pot'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-pot\u003E\u003Cquotation-visitor-main class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-visitor'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-visitor-main\u003E\u003Cquotation-result-actions class=\"animate-fade-out\" ng-if=\"['state-result', 'state-visitor'].indexOf($ctrl.store.viewState) &gt; -1\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-actions\u003E\u003C\u002Fdiv\u003E\u003Cfooter\u003E\u003C\u002Ffooter\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs quotation-desktop\" ng-if=\"!$ctrl.isMobile()\"\u003E\u003Cnav class=\"navbar navbar-white\"\u003E\u003Cdiv class=\"navbar-header\"\u003E\u003Ca class=\"navbar-brand\" ui-sref=\"landing\"\u003E\u003Cimg alt=\"Plüm Energie\" src=\"\u002Fassets\u002Fimg\u002Flanding\u002Fdesktop\u002Flogo.svg\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse\"\u003E\u003Cul class=\"nav navbar-nav navbar-right\"\u003E\u003Cli\u003E\u003Ca class=\"btn btn-same-width background-white dark-pink hover-marine\" ng-href=\"{{landingPageLink}}\"\u003ERevenir sur plum.fr\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"container container-body\"\u003E\u003Cquotation-form-landscape ng-show=\"$ctrl.store.viewState === 'state-form-landscape'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-form-landscape\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"quotation-result-container\"\u003E\u003Cquotation-form-initial ng-if=\"$ctrl.store.viewState === 'state-form-initial'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-form-initial\u003E\u003Cquotation-result-landscape class=\"animate-fade-out\" ng-if=\"['state-form-consumption', 'state-result-loading', 'state-result', 'state-result-error'].indexOf($ctrl.store.viewState) &gt; -1\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-landscape\u003E\u003Cquotation-form-consumption class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-form-consumption'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-form-consumption\u003E\u003Cquotation-result-annual-consumption class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-result'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-annual-consumption\u003E\u003Cquotation-result-pot class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-result'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-pot\u003E\u003Cquotation-result-error class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-result-error'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-error\u003E\u003Cquotation-timetable class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-timetable'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-timetable\u003E\u003Cquotation-pot class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-pot'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-pot\u003E\u003Cquotation-visitor-main class=\"animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-visitor'\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-visitor-main\u003E\u003Cquotation-result-actions class=\"animate-fade-out\" ng-if=\"['state-result', 'state-visitor'].indexOf($ctrl.store.viewState) &gt; -1\" ng-class=\"{'state-visitor': $ctrl.store.viewState === 'state-visitor'}\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch($event)\"\u003E\u003C\u002Fquotation-result-actions\u003E\u003Cdiv class=\"quotation-result-loading animate-fade-out\" ng-if=\"$ctrl.store.viewState === 'state-result-loading'\"\u003E\u003Ci class=\"spinner-form spinner\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationFormInitialController = function () {
    /** @ngInject */
    QuotationFormInitialController.$inject = ["$timeout", "DeviceChecker"];
    function QuotationFormInitialController($timeout, DeviceChecker) {
        _classCallCheck(this, QuotationFormInitialController);

        this.$timeout = $timeout;
        this.isMobile = DeviceChecker.isMobile;
        this.popoverIsOpen = false;
    }

    _createClass(QuotationFormInitialController, [{
        key: 'goToStepLandscape',
        value: function goToStepLandscape() {
            this.onDispatch({ $event: { type: 'GO_TO_FORM_LANDSCAPE', origin: 'FORM_INITIAL_BTN_DEMARRER' } });
        }
    }, {
        key: 'goToStepConsumption',
        value: function goToStepConsumption() {
            this.onDispatch({ $event: { type: 'GO_TO_FORM_CONSUMPTION', origin: 'FORM_INITIAL_BTN_BYPASS' } });
        }
    }, {
        key: 'onIconQuestionMarkClick',
        value: function onIconQuestionMarkClick() {
            var that = this;
            this.$timeout(function () {
                if (that.popoverIsOpen) {
                    that.onDispatch({ $event: { type: 'CLICK_ON_QUESTION_MARK_FORM_INITIAL' } });
                }
            });
        }
    }]);

    return QuotationFormInitialController;
}();

exports.default = {
    template: __webpack_require__(1110)(),
    controller: QuotationFormInitialController,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-form-initial hidden-xs\"\u003E\u003Cdiv class=\"hanger hanger-left\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-right\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-header background-marine hidden-xs\"\u003E\u003Ch2\u003EMon paysage énergetique\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Ch3\u003EDessinez avec nous votre paysage énergétique !\u003C\u002Fh3\u003E\u003Cp\u003EEn quelques minutes, décrivez-nous votre situation et vos usages.\nRenseignez les caractéristiques de votre logement à l'aide de ce court questionnaire.&nbsp;\u003Cspan class=\"fa fa-question-circle\" ng-click=\"$ctrl.onIconQuestionMarkClick(popover)\" uib-popover-template=\"'quotation-initial-explanation'\" popover-is-open=\"$ctrl.popoverIsOpen\" popover-trigger=\"'outsideClick'\" popover-placement=\"right\" popover-append-to-body=\"true\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cdiv class=\"picto-paysage margin-top-30\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fpictos-paysage.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.goToStepLandscape()\"\u003EDémarrer\u003C\u002Fbutton\u003E\u003Cdiv class=\"bypass-landscape margin-top-30\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fbill.svg\"\u003E\u003Cdiv style=\"display: inline-block; vertical-align: middle\"\u003E\u003Cstrong\u003EVous avez une facture d’électricité à portée de main ?\u003C\u002Fstrong\u003E\u003Cbr\u003E\u003Ca class=\"bypass\" ng-click=\"$ctrl.goToStepConsumption()\"\u003ECliquez ici pour passer cette étape.\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block margin-top-15\"\u003E\u003Ch3\u003EDessinez votre paysage énergétique\u003C\u002Fh3\u003E\u003Cdiv class=\"landscape-panel\"\u003E\u003Cp\u003EPour obtenir votre devis en quelques secondes, décrivez votre logement et vos usages.\u003C\u002Fp\u003E\u003Cdiv class=\"picto-paysage margin-top-30\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fpictos-paysage.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.goToStepLandscape()\"\u003EDémarrer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bypass-landscape margin-top-30 text-center\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fbill.svg\"\u003E\u003Cdiv class=\"margin-top-15\"\u003E\u003Cstrong\u003EVous avez une facture d’électricité à portée de main ?\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-15\"\u003E\u003Ca class=\"bypass\" ng-click=\"$ctrl.goToStepConsumption()\"\u003ECliquez ici pour passer cette étape.\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"quotation-initial-explanation\"\u003E\u003Cdiv\u003E\u003Cp\u003ELes réponses à ces questions, comme toutes les informations que vous nous confiez, sont strictement confidentielles.\u003C\u002Fp\u003E\u003Cp\u003EElles ne seront jamais communiquées à des tiers.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationFormLandscapeComponent = function () {
    /** @ngInject */
    QuotationFormLandscapeComponent.$inject = ["DeviceChecker"];
    function QuotationFormLandscapeComponent(DeviceChecker) {
        _classCallCheck(this, QuotationFormLandscapeComponent);

        this.isMobile = DeviceChecker.isMobile;
    }

    _createClass(QuotationFormLandscapeComponent, [{
        key: 'onLandscapeDone',
        value: function onLandscapeDone($event) {
            this.onDispatch({ $event: { type: 'LANDSCAPE_DONE', isLandscapeDone: $event.landscapeDone } });
            if ($event.landscapeDone === true) {
                this.goToStepConsumption();
            }
        }
    }, {
        key: 'goToStepConsumption',
        value: function goToStepConsumption() {
            this.onDispatch({ $event: { type: 'GO_TO_FORM_CONSUMPTION' } });
        }
    }]);

    return QuotationFormLandscapeComponent;
}();

exports.default = {
    template: __webpack_require__(1112)(),
    controller: QuotationFormLandscapeComponent,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"row-fluid\" id=\"landscape-form\"\u003E\u003Cdiv class=\"col-md-12 row window-height\"\u003E\u003Clandscape-form questions=\"$ctrl.store.landscapeQuestions\" contract-selected=\"$ctrl.store.landscapeContractDraft\" display-end-modal=\"false\" on-landscape-done=\"$ctrl.onLandscapeDone($event)\"\u003E\u003C\u002Flandscape-form\u003E\u003Cdiv class=\"landscape-finished\" ng-if=\"$ctrl.store.isLandscapeDone\"\u003E\u003Cbutton class=\"btn background-waterblue\" ng-click=\"$ctrl.goToStepConsumption()\"\u003EObtenir mon estimation\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _some2 = __webpack_require__(349);

var _some3 = _interopRequireDefault(_some2);

var _isNumber2 = __webpack_require__(139);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _keys2 = __webpack_require__(41);

var _keys3 = _interopRequireDefault(_keys2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationFormConsumptionController = function () {
    /** @ngInject */
    QuotationFormConsumptionController.$inject = ["$uibModal", "$timeout", "DeviceChecker", "ContractDraft", "ErrorCatcher"];
    function QuotationFormConsumptionController($uibModal, $timeout, DeviceChecker, ContractDraft, ErrorCatcher) {
        _classCallCheck(this, QuotationFormConsumptionController);

        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.isMobile = DeviceChecker.isMobile;
        this.contractDraftService = ContractDraft;
        this.errorCatcher = ErrorCatcher;
        this.inseeCodes = [];
        this.popoverIsOpen = false;
    }

    _createClass(QuotationFormConsumptionController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if ((0, _isEmpty3.default)(this.consumptionForm)) {
                this.consumptionForm = _angular2.default.copy(this.store.consumptionView.consumptionForm);
            }
            var isOpenCurrentValue = (0, _get3.default)(changes, 'store.currentValue.consumptionView.isPostCodeIneligible');
            var isOpenPreviousValue = (0, _get3.default)(changes, 'store.previousValue.consumptionView.isPostCodeIneligible');
            var samePreviousValue = isOpenCurrentValue && isOpenPreviousValue;
            if (isOpenCurrentValue && !samePreviousValue) {
                this.$uibModal.open({ component: 'quotationModalIneligibility' });
            }
            if ((0, _get3.default)(changes, 'store.currentValue.consumptionView.postCodeValidation.inseecode') !== (0, _get3.default)(changes, 'store.previousValue.consumptionView.postCodeValidation.inseecode')) {
                this.inseeCodes = (0, _keys3.default)((0, _get3.default)(changes, 'store.currentValue.consumptionView.postCodeValidation.inseecode', []));
                if (this.inseeCodes.length === 1) {
                    this.consumptionForm.citycode = this.inseeCodes[0];
                }
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.validatePostCode(this.store.consumptionView.consumptionForm.postcode);
        }
    }, {
        key: 'validatePostCode',
        value: function validatePostCode(choosen_post_code) {
            var _this = this;

            this.updateForm();
            var POST_CODE_LENGTH = 5;
            if (choosen_post_code && choosen_post_code.length === POST_CODE_LENGTH) {
                this.onDispatch({
                    $event: function $event(dispatch) {
                        dispatch({ type: 'VALIDATE_POST_CODE', choosen_post_code: choosen_post_code });
                        _this.contractDraftService.checkPostCode({ id: choosen_post_code, return: 'inseecode' }).$promise.then(function (postCodeResult) {
                            dispatch({ type: 'VALIDATE_POST_CODE_DONE', choosen_post_code: choosen_post_code, postCodeResult: postCodeResult });
                        }).catch(function (error) {
                            _this.errorCatcher.catchError(error);
                            dispatch({ type: 'VALIDATE_POST_CODE_FAIL', choosen_post_code: choosen_post_code, error: error });
                        });
                    }
                });
            } else {
                this.onDispatch({ $event: { type: 'VALIDATE_POST_CODE_INITIAL' } });
            }
        }
    }, {
        key: 'checkIdProviderCalendar',
        value: function checkIdProviderCalendar(id) {
            if ((0, _get3.default)(this.store, 'consumptionView.postCodeValidation.eligible', false)) {
                this.consumptionForm.calendar = id;
                this.consumptionForm.declaredAnnualCons = {};
                this.updateForm();
            }
        }
    }, {
        key: 'isSubmitEnabled',
        value: function isSubmitEnabled() {
            var _this2 = this;

            if (!(0, _get3.default)(this.store, 'consumptionView.postCodeValidation.eligible', false)) {
                return false;
            }
            if ((0, _isEmpty3.default)(this.consumptionForm.calendar)) {
                return false;
            }
            if (!(0, _isNumber3.default)(this.consumptionForm.power)) {
                return false;
            }
            if (this.store.isLandscapeDone === false) {
                var consNotDefined = (0, _some3.default)((0, _get3.default)(this.store, ['tariffOptions', this.consumptionForm.calendar, 'tempClass']), function (value, key) {
                    return !(0, _isNumber3.default)(_this2.consumptionForm.declaredAnnualCons[key]);
                });
                if (consNotDefined) {
                    return false;
                }
            }
            return true;
        }
    }, {
        key: 'updateForm',
        value: function updateForm() {
            this.onDispatch({ $event: { type: 'UPDATE_FORM_CONSUMPTION', consumptionForm: this.consumptionForm } });
        }
    }, {
        key: 'submitFormConsumption',
        value: function submitFormConsumption() {
            var _this3 = this;

            if (this.store.isLandscapeDone) {
                this.consumptionForm.declaredAnnualCons = undefined;
            }
            this.onDispatch({ $event: { type: 'UPDATE_FORM_CONSUMPTION', consumptionForm: this.consumptionForm } });
            this.onDispatch({ $event: { type: 'GET_QUOTATION', origin: 'FORM_INITIAL_BTN_ESTIMATE_QUOTATION' } });
            this.contractDraftService.getQuotation({ return: 'offer,timetable' }, this.consumptionForm).$promise.then(function (quotationResult) {
                _this3.onDispatch({ $event: { type: 'GET_QUOTATION_DONE', quotationResult: quotationResult } });
            }).catch(function (error) {
                _this3.errorCatcher.catchError(error);
                _this3.onDispatch({ $event: { type: 'GET_QUOTATION_ERROR', error: error } });
            });
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            this.onDispatch({ $event: { type: 'GO_TO_INITIAL' } });
        }
    }, {
        key: 'onIconQuestionMarkClick',
        value: function onIconQuestionMarkClick() {
            var that = this;
            this.$timeout(function () {
                if (that.popoverIsOpen) {
                    that.onDispatch({ $event: { type: 'CLICK_ON_QUESTION_MARK_FORM_CONSUMPTION' } });
                }
            });
        }
    }, {
        key: 'objectLength',
        value: function objectLength(obj) {
            return (0, _keys3.default)(obj).length;
        }
    }]);

    return QuotationFormConsumptionController;
}();

exports.default = {
    template: __webpack_require__(1115)(),
    controller: QuotationFormConsumptionController,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1114 */,
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-form-consumption\"\u003E\u003Cdiv class=\"hanger hanger-left\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-right\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-header background-darkish-pink\"\u003E\u003Ch2\u003EMa consommation\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cstrong class=\"margin-top-20 hidden-xs\"\u003EPour une estimation complète, veuillez renseigner les caractéristiques de votre abonnement.\u003C\u002Fstrong\u003E\u003Cstrong class=\"margin-top-20 visible-xs-inline\"\u003ECaractéristiques de mon abonnement électricité\u003C\u002Fstrong\u003E\u003Cp class=\"consumption-help margin-top-20 hidden-xs\"\u003E\u003Cspan\u003EOù trouver ces informations ?&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-question-circle\" ng-if=\"!$ctrl.store.isLandscapeDone\" ng-click=\"$ctrl.onIconQuestionMarkClick()\" uib-popover-template=\"'quotation-consumption-help-initial'\" popover-is-open=\"$ctrl.popoverIsOpen\" popover-class=\"max-width-400\" popover-title=\"Où trouver ces informations ?\" popover-trigger=\"'outsideClick'\" popover-placement=\"right-top\" popover-append-to-body=\"true\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-question-circle\" ng-if=\"$ctrl.store.isLandscapeDone\" ng-click=\"$ctrl.onIconQuestionMarkClick()\" uib-popover-template=\"'quotation-consumption-help-landscape'\" popover-is-open=\"$ctrl.popoverIsOpen\" popover-class=\"max-width-400\" popover-title=\"Où trouver ces informations ?\" popover-trigger=\"'outsideClick'\" popover-placement=\"right-top\" popover-append-to-body=\"true\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"default-form form-horizontal margin-top-20\" ng-submit=\"$ctrl.submitFormConsumption()\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003ECode postal\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8 postal-code\"\u003E\u003Cinput type=\"text\" ng-model=\"$ctrl.consumptionForm.postcode\" ng-change=\"$ctrl.validatePostCode($ctrl.consumptionForm.postcode)\" ng-readonly=\"$ctrl.store.consumptionView.postCodeValidation.state === 'PENDING'\" pattern=\"[0-9]*\" inputmode=\"numeric\" maxlength=\"5\"\u003E\u003Cspan class=\"postal-code-state\" ng-if=\"$ctrl.store.consumptionView.postCodeValidation.state === 'PENDING'\"\u003E\u003Ci class=\"spinner spinner-form\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"postal-code-state\" ng-if=\"$ctrl.store.consumptionView.postCodeValidation.eligible\"\u003E\u003Ci class=\"fa fa-2x fa-check light-green\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"postal-code-state\" ng-if=\"$ctrl.store.consumptionView.postCodeValidation.state === 'FAIL' || $ctrl.store.consumptionView.postCodeValidation.exist === false || $ctrl.store.consumptionView.postCodeValidation.eligible === false\"\u003E\u003Ci class=\"fa fa-2x fa-times dark-pink\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"error\" ng-if=\"$ctrl.store.consumptionView.postCodeValidation.state === 'FAIL'\"\u003EUne erreur réseau c'est produite au moment de la vérification du code postal.\u003C\u002Fdiv\u003E\u003Cdiv class=\"error\" ng-if=\"$ctrl.store.consumptionView.postCodeValidation.exist === false\"\u003ECe code postal ne semble pas être attribué.\u003C\u002Fdiv\u003E\u003Cdiv class=\"error\" ng-if=\"$ctrl.store.consumptionView.postCodeValidation.exist === true &amp;&amp; $ctrl.store.consumptionView.postCodeValidation.eligible === false\"\u003ENous sommes désolés mais votre compteur n'est pas compatible avec notre offre.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003ELocalité\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\" ng-show=\"$ctrl.store.consumptionView.postCodeValidation.eligible &amp;&amp; $ctrl.inseeCodes.length &gt;= 1\"\u003E\u003Cp class=\"form-control-static\" ng-if=\"$ctrl.inseeCodes.length === 1\"\u003E{{$ctrl.store.consumptionView.postCodeValidation.inseecode[$ctrl.consumptionForm.citycode]}}\u003C\u002Fp\u003E\u003Cselect class=\"form-control\" ng-if=\"$ctrl.inseeCodes.length &gt; 1\" ng-model=\"$ctrl.consumptionForm.citycode\" ng-change=\"$ctrl.updateForm()\" ng-disabled=\"!$ctrl.store.consumptionView.postCodeValidation.eligible\" ng-options=\"key as value for (key, value) in $ctrl.store.consumptionView.postCodeValidation.inseecode\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003EFormule tarifaire\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"radio-dark-pink-block\" ng-repeat=\"(key, value) in $ctrl.store.tariffOptions\" ng-click=\"$ctrl.checkIdProviderCalendar(key)\" ng-class=\"{'disabled': !$ctrl.store.consumptionView.postCodeValidation.eligible}\"\u003E\u003Cspan class=\"radio-dark-pink\" ng-class=\"{                'disabled': !$ctrl.store.consumptionView.postCodeValidation.eligible,                'checked': $ctrl.consumptionForm.calendar === key              }\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"radio-dark-pink-label\"\u003E{{value.label}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003EPuissance souscrite\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cselect class=\"form-control consumption-input-power\" ng-model=\"$ctrl.consumptionForm.power\" ng-change=\"$ctrl.updateForm()\" ng-disabled=\"!$ctrl.store.consumptionView.postCodeValidation.eligible\" ng-options=\"item for item in $ctrl.store.tariffOptions[$ctrl.consumptionForm.calendar].availablePowers\"\u003E\u003C\u002Fselect\u003E\nkVA\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!-- With one tempClass --\u003E\u003Cdiv class=\"form-group margin-top-60\" ng-if=\"$ctrl.store.isLandscapeDone === false &amp;&amp; $ctrl.consumptionForm.calendar &amp;&amp; $ctrl.objectLength($ctrl.store.tariffOptions[$ctrl.consumptionForm.calendar].tempClass) === 1\" ng-repeat=\"(planTypeKey, planTypeValue) in $ctrl.store.tariffOptions[$ctrl.consumptionForm.calendar].tempClass\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003EConsommation annuelle\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"consumption-input-temp-class\" type=\"number\" ng-model=\"$ctrl.consumptionForm.declaredAnnualCons[planTypeKey]\" ng-change=\"$ctrl.updateForm()\" ng-disabled=\"!$ctrl.store.consumptionView.postCodeValidation.eligible\" ng-required maxlength=\"6\" pattern=\"[0-9]*\" min=\"0\" max=\"999999\"\u003E\nkWh\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!-- With multiple tempClass --\u003E\u003Cdiv class=\"form-group margin-top-60\" ng-if=\"$ctrl.store.isLandscapeDone === false &amp;&amp; $ctrl.consumptionForm.calendar &amp;&amp; $ctrl.objectLength($ctrl.store.tariffOptions[$ctrl.consumptionForm.calendar].tempClass) &gt; 1\"\u003E\u003Clabel class=\"col-sm-12\"\u003EConsommation annuelle\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-if=\"$ctrl.store.isLandscapeDone === false &amp;&amp; $ctrl.consumptionForm.calendar &amp;&amp; $ctrl.objectLength($ctrl.store.tariffOptions[$ctrl.consumptionForm.calendar].tempClass) &gt; 1\" ng-repeat=\"(planTypeKey, planTypeValue) in $ctrl.store.tariffOptions[$ctrl.consumptionForm.calendar].tempClass\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003E{{planTypeValue}}\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"consumption-input-temp-class\" type=\"number\" ng-model=\"$ctrl.consumptionForm.declaredAnnualCons[planTypeKey]\" ng-change=\"$ctrl.updateForm()\" ng-disabled=\"!$ctrl.store.consumptionView.postCodeValidation.eligible\" ng-required maxlength=\"6\" pattern=\"[0-9]*\" min=\"0\" max=\"999999\"\u003E\nkWh\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions margin-top-60\"\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ng-click=\"$ctrl.goBack()\"\u003ERetour\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-light-pink\" type=\"submit\" ng-disabled=\"!$ctrl.isSubmitEnabled()\"\u003EEstimer mon devis\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"quotation-consumption-help-initial\"\u003E\u003Cdiv\u003E\u003Cstrong\u003EVous trouverez les informations concernant votre abonnement sur vos dernières factures d’électricité.\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cul class=\"bullet-light-pink\"\u003E\u003Cli\u003E\u003Cstrong\u003ELa formule\u003C\u002Fstrong\u003E : Base où Heures Pleines \u002F Heures Creuses est aussi visible sur votre compteur d’électricité.\u003C\u002Fli\u003E\u003Cli\u003E\u003Cstrong\u003ELa puissance souscrite\u003C\u002Fstrong\u003E va de 3 à 36 kVA.\u003C\u002Fli\u003E\u003Cli\u003E\u003Cstrong\u003ELa consommation\u003C\u002Fstrong\u003E est indiquée en kWh sur votre facture annuelle\net correspond à la différence entre le nouvel index (relevé ou estimé) et l’ancien.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Chr\u003E\u003Cdiv\u003E\u003Cstrong\u003EExemple consommation annuelle 2016 :\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"bullet-light-pink\"\u003E\u003Cli\u003Eindex électricité au 25\u002F09\u002F2016 : 7 000 kWh\u003C\u002Fli\u003E\u003Cli\u003Eindex électricité au 25\u002F09\u002F2017 : 8 500 kWh\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cbr\u003E\u003Cdiv\u003EConsommation d’énergie facturée sur la période\u003C\u002Fdiv\u003E\u003Cdiv\u003E8 500 – 7 000 = 1.500 kWh\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"quotation-consumption-help-landscape\"\u003E\u003Cul class=\"bullet-light-pink\"\u003E\u003Cli\u003E\u003Cstrong\u003ELe code postal\u003C\u002Fstrong\u003E de votre logement sert à calculer le montant des taxes locales d’électricité.\u003C\u002Fli\u003E\u003Cli\u003E\u003Cstrong\u003ELa formule tarifaire\u003C\u002Fstrong\u003E Base où Heures Pleines \u002F Heures Creuses est visible sur  vos factures d’électricité\nainsi que sur votre compteur d’électricité.\u003C\u002Fli\u003E\u003Cli\u003E\u003Cstrong\u003ELa puissance souscrite\u003C\u002Fstrong\u003E va de 3 à 36 kVA.\u003Cbr\u003ELa plupart des Français ont une puissance souscrite de 6 kVA\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fscript\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationModalIneligibilityController =
/** @ngInject */
["DeviceChecker", function QuotationModalIneligibilityController(DeviceChecker) {
    _classCallCheck(this, QuotationModalIneligibilityController);

    this.isMobile = DeviceChecker.isMobile;
}];

exports.default = {
    template: __webpack_require__(1117)(),
    controller: QuotationModalIneligibilityController,
    bindings: {
        close: '&'
    }
};

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"modal-content-header\"\u003E\u003Ch3\u003EPROBLÈME D’ÉLIGIBILITÉ\u003C\u002Fh3\u003E\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-marine\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-content-body\"\u003E\u003Cdiv class=\"inegibility-picto\"\u003E\u003Cimg src=\"assets\u002Fimg\u002Fquotation\u002Fineligibility.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"strong\"\u003EMalheureusement, la commune que vous avez renseignée n’est pas éligible au changement de fournisseur.\u003C\u002Fp\u003E\u003Cp\u003ENous ne sommes pas en mesure de satisfaire votre demande, car la zone dans laquelle vous vous situez\ndépend d’une Entreprise Locale de Distribution.\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.close()\"\u003ERéessayer\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-marine\" ui-sref=\"landing\"\u003ERevenir à l’accueil\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationResultActionsComponent = function () {
    /** @ngInject */
    QuotationResultActionsComponent.$inject = ["$state", "DeviceChecker"];
    function QuotationResultActionsComponent($state, DeviceChecker) {
        _classCallCheck(this, QuotationResultActionsComponent);

        this.$state = $state;
        this.isMobile = DeviceChecker.isMobile;
    }

    _createClass(QuotationResultActionsComponent, [{
        key: 'goToVisitor',
        value: function goToVisitor() {
            this.onDispatch({ $event: { type: 'GO_TO_STATE_VISITOR' } });
        }
    }, {
        key: 'goToResult',
        value: function goToResult() {
            this.onDispatch({ $event: { type: 'GO_TO_STATE_RESULT' } });
        }
    }, {
        key: 'clickOnSubscribePlum',
        value: function clickOnSubscribePlum() {
            this.onDispatch({ $event: { type: 'CLICK_ON_SUBSCRIBE_PLUM' } });
            this.$state.go('subscription');
        }
    }]);

    return QuotationResultActionsComponent;
}();

exports.default = {
    template: __webpack_require__(1119)(),
    controller: QuotationResultActionsComponent,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn btn-same-width background-marine round\" ng-if=\"$ctrl.store.viewState === 'state-visitor'\" ng-click=\"$ctrl.goToResult()\"\u003ERetour au devis\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink round\" ng-click=\"$ctrl.clickOnSubscribePlum()\"\u003EJe passe chez Plüm\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationResultAnnualConsumptionComponent = function () {
    /** @ngInject */
    QuotationResultAnnualConsumptionComponent.$inject = ["DeviceChecker"];
    function QuotationResultAnnualConsumptionComponent(DeviceChecker) {
        _classCallCheck(this, QuotationResultAnnualConsumptionComponent);

        this.isMobile = DeviceChecker.isMobile;
    }

    _createClass(QuotationResultAnnualConsumptionComponent, [{
        key: 'getAmountPerMonth',
        value: function getAmountPerMonth(amount) {
            return Math.floor(Math.floor(amount * 100) / 12) / 100;
        }
    }, {
        key: 'openTimeline',
        value: function openTimeline() {
            this.onDispatch({ $event: { type: 'GO_TO_STATE_TIMETABLE', origin: 'RESULT_ANNUAL_CONSUMPTION_BTN_TIMETABLE' } });
        }
    }]);

    return QuotationResultAnnualConsumptionComponent;
}();

exports.default = {
    template: __webpack_require__(1121)(),
    controller: QuotationResultAnnualConsumptionComponent,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-result-annual-consumption\"\u003E\u003Cdiv class=\"hanger hanger-middle hidden-xs\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-left visible-xs-block\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-right visible-xs-block\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Ch4 class=\"hidden-xs\"\u003EMA CONSOMMATION ANNUELLE\u003C\u002Fh4\u003E\u003Ch4 class=\"visible-xs-block\"\u003EMA CONSOMMATION\u003C\u002Fh4\u003E\u003Cdiv class=\"amount-annual margin-top-40\"\u003E\u003Cdiv class=\"amount\"\u003E~{{$ctrl.getAmountPerMonth($ctrl.store.quotationView.quotationResult.offer.total.normal) | ceil | frAmount:{minimumFractionDigits: 0} }}€\u003C\u002Fdiv\u003E\u003Cdiv class=\"taxes\"\u003ETTC\u002Fmois\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"amount-detailed margin-top-30\"\u003E\u003Cdiv\u003EPour une facture annuelle\u003C\u002Fdiv\u003E\u003Cdiv\u003Ede {{$ctrl.store.quotationView.quotationResult.offer.total.normal | ceil | frAmount:{minimumFractionDigits: 0} }}€ TTC\u002Fan\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationResultLandscapeComponent = function () {
    /** @ngInject */
    QuotationResultLandscapeComponent.$inject = ["$timeout", "DeviceChecker"];
    function QuotationResultLandscapeComponent($timeout, DeviceChecker) {
        _classCallCheck(this, QuotationResultLandscapeComponent);

        this.$timeout = $timeout;
        this.isMobile = DeviceChecker.isMobile;
        this.popoverIsOpen = false;
    }

    _createClass(QuotationResultLandscapeComponent, [{
        key: 'goToStepLandscape',
        value: function goToStepLandscape() {
            this.onDispatch({ $event: { type: 'GO_TO_FORM_LANDSCAPE' } });
        }
    }, {
        key: 'goToStepConsumption',
        value: function goToStepConsumption() {
            this.onDispatch({ $event: { type: 'GO_TO_FORM_CONSUMPTION', origin: 'RESULT_LANDSCAPE_BTN_MODIFY' } });
        }
    }, {
        key: 'onIconQuestionMarkClick',
        value: function onIconQuestionMarkClick() {
            var that = this;
            this.$timeout(function () {
                if (that.popoverIsOpen) {
                    that.onDispatch({ $event: { type: 'CLICK_ON_QUESTION_MARK_WHAT_IS_IT' } });
                }
            });
        }
    }]);

    return QuotationResultLandscapeComponent;
}();

exports.default = {
    template: __webpack_require__(1123)(),
    controller: QuotationResultLandscapeComponent,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-result-landscape-form\"\u003E\u003Cdiv class=\"hanger hanger-middle hidden-xs\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-left visible-xs-block\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-right visible-xs-block\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Ch4\u003EMES CARACTÉRISTIQUES\u003C\u002Fh4\u003E\u003Cdiv class=\"subscription-canvas\" ng-if=\"$ctrl.store.isLandscapeDone\"\u003E\u003Clandscape-canvas\u003E\u003C\u002Flandscape-canvas\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-edit\" ng-if=\"!$ctrl.store.isLandscapeDone\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fpencil.svg\"\u003E\u003Cp class=\"hidden-xs\"\u003E\u003Cspan\u003EQu’est-ce que c’est&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"fa fa-question-circle\" uib-popover=\"Au travers de quelques questions, vous décrivez les caractéristiques de votre logement           et vos habitudes de consommation afin que notre estimation soit plus précise. \" ng-click=\"$ctrl.onIconQuestionMarkClick()\" popover-trigger=\"'outsideClick'\" popover-is-open=\"$ctrl.popoverIsOpen\" popover-placement=\"bottom\" popover-append-to-body=\"true\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-if=\"$ctrl.store.viewState === 'state-form-consumption'\" ng-click=\"$ctrl.goToStepLandscape()\"\u003EÉditer mon paysage\u003C\u002Fbutton\u003E\u003Cdiv ng-if=\"['state-result', 'state-result-error'].indexOf($ctrl.store.viewState) &gt; -1\"\u003E\u003Cdiv class=\"offer-detailed bluegrey margin-top-20\"\u003E\u003Cp\u003EFormule {{$ctrl.store.consumptionView.consumptionForm.calendar}}\u003C\u002Fp\u003E\u003Cp\u003EPuissance {{$ctrl.store.consumptionView.consumptionForm.power}} kVA\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn background-bluegrey\" ng-click=\"$ctrl.goToStepConsumption()\"\u003EModifier\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationResultPotComponent = function () {
    /** @ngInject */
    QuotationResultPotComponent.$inject = ["DeviceChecker", "ContractDraft", "ErrorCatcher"];
    function QuotationResultPotComponent(DeviceChecker, ContractDraft, ErrorCatcher) {
        _classCallCheck(this, QuotationResultPotComponent);

        this.isMobile = DeviceChecker.isMobile;
        this.contractDraftService = ContractDraft;
        this.errorCatcher = ErrorCatcher;
        this.potSlider = {
            options: {
                floor: -15,
                ceil: 0,
                step: 5,
                rightToLeft: true,
                showTicks: true,
                showTicksValues: true,
                disabled: false,
                onEnd: this.estimate.bind(this),
                translate: function translate(value) {
                    return value + '%';
                }
            }
        };
    }

    _createClass(QuotationResultPotComponent, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.store) {
                this.factorCons = changes.store.currentValue.consumptionView.consumptionForm.factorCons;
                this.potSlider.disabled = changes.store.currentValue.potView.isUpdating;
            }
        }
    }, {
        key: 'openPotDetail',
        value: function openPotDetail() {
            this.onDispatch({ $event: { type: 'OPEN_RESULT_POT_DETAIL' } });
        }
    }, {
        key: 'hoverOnCardBill',
        value: function hoverOnCardBill() {
            this.onDispatch({ $event: { type: 'HOVER_ON_CARD_BILL' } });
        }
    }, {
        key: 'hoverOnCardPot',
        value: function hoverOnCardPot() {
            this.onDispatch({ $event: { type: 'HOVER_ON_CARD_POT' } });
        }
    }, {
        key: 'estimate',
        value: function estimate() {
            var _this = this;

            this.onDispatch({
                $event: function $event(dispatch, getState) {
                    dispatch({ type: 'UPDATE_QUOTATION_POT', factorCons: _this.factorCons });
                    _this.contractDraftService.getQuotation({ return: 'pot' }, _angular2.default.copy(getState().quotation.consumptionView.consumptionForm)).$promise.then(function (quotationResult) {
                        dispatch({ type: 'UPDATE_QUOTATION_POT_DONE', pot: quotationResult.pot });
                    }).catch(function (error) {
                        _this.errorCatcher.catchError(error);
                        dispatch({ type: 'UPDATE_QUOTATION_POT_ERROR', error: error });
                    });
                }
            });
        }
    }]);

    return QuotationResultPotComponent;
}();

exports.default = {
    template: __webpack_require__(1125)(),
    controller: QuotationResultPotComponent,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-result-pot\"\u003E\u003Cdiv class=\"hanger hanger-middle hidden-xs\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-left visible-xs-block\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-right visible-xs-block\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Ch4\u003EMON BONUS PLÜM !\u003C\u002Fh4\u003E\u003Cdiv class=\"animate-fade-in-100\" ng-if=\"$ctrl.store.resultPotView.viewState === 'state-initial'\"\u003E\u003Cdiv\u003EÉconomisez jusqu’à\u003C\u002Fdiv\u003E\u003Cdiv class=\"percent\"\u003E-25%\u003C\u002Fdiv\u003E\u003Cp class=\"explanation\"\u003EPlüm récompense vos économies d’énergie.\u003C\u002Fp\u003E\u003Cbutton class=\"btn background-gold-dark\" ng-if=\"!$ctrl.store.quotationView.quotationResult.pot\" ng-click=\"$ctrl.openPotDetail()\"\u003EComment ça marche ?\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"animate-fade-in-100\" ng-if=\"$ctrl.store.resultPotView.viewState === 'state-detail' &amp;&amp; $ctrl.factorCons === 0\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fbonus.gif\" style=\"width: 100%; max-width: 350px;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"animate-fade-in-100\" ng-if=\"$ctrl.store.resultPotView.viewState === 'state-detail' &amp;&amp; $ctrl.factorCons !== 0\"\u003E\u003Cdiv class=\"amount-total\"\u003E\u003Cspan class=\"animate-fade-in-100 animate-fade-out-100\" ng-if=\"$ctrl.store.quotationView.potResult.reduction !== null\"\u003E{{($ctrl.store.quotationView.potResult.reduction | ceil) + ($ctrl.store.quotationView.potResult.pot | ceil) | frAmount:{minimumFractionDigits: 0} }}€\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"amount-detail\"\u003E\u003Cdiv class=\"flip-container\" ontouchstart=\"this.classList.toggle('hover');\" ng-mouseenter=\"$ctrl.hoverOnCardBill()\"\u003E\u003Cdiv class=\"flipper\"\u003E\u003Cdiv class=\"flip-front\"\u003E\u003Cimg class=\"amount-logo amount-logo-left hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fresult-reduction.svg\"\u003E\u003Cimg class=\"amount-logo amount-logo-left-middle visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fresult-reduction.svg\"\u003E\u003Cp class=\"amount-label\"\u003EMa facture\u003Cbr\u003Eannuelle baisse\u003C\u002Fp\u003E\u003Cp class=\"amount\"\u003E\u003Cspan class=\"animate-fade-in-100 animate-fade-out-100\" ng-if=\"$ctrl.store.quotationView.potResult.pot !== null\"\u003E{{$ctrl.store.quotationView.potResult.reduction | ceil | frAmount:{minimumFractionDigits: 0} }}€\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flip-back\"\u003E\u003Cimg class=\"amount-logo amount-logo-right hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fresult-reduction.svg\"\u003E\u003Cimg class=\"amount-logo amount-logo-left-middle visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fresult-reduction.svg\"\u003E\u003Cp class=\"amount-label\"\u003EVotre facture diminue de {{$ctrl.store.quotationView.potResult.reduction | ceil | frAmount:{minimumFractionDigits: 0} }}€,\nau moment de la régularisation\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flip-container\" ontouchstart=\"this.classList.toggle('hover');\" ng-mouseenter=\"$ctrl.hoverOnCardPot()\"\u003E\u003Cdiv class=\"flipper\"\u003E\u003Cdiv class=\"flip-front\"\u003E\u003Cimg class=\"amount-logo amount-logo-right hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fresult-pot.svg\"\u003E\u003Cimg class=\"amount-logo amount-logo-left-middle visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fresult-pot.svg\"\u003E\u003Cp class=\"amount-label\"\u003EMa cagnotte\u003Cbr\u003EPlüm augmente\u003C\u002Fp\u003E\u003Cp class=\"amount\"\u003E\u003Cspan class=\"animate-fade-in-100 animate-fade-out-100\" ng-if=\"$ctrl.store.quotationView.potResult.total !== null\"\u003E{{$ctrl.store.quotationView.potResult.pot | ceil | frAmount:{minimumFractionDigits: 0} }}€\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flip-back\"\u003E\u003Cimg class=\"amount-logo amount-logo-left hidden-xs\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fresult-pot.svg\"\u003E\u003Cimg class=\"amount-logo amount-logo-left-middle visible-xs-inline\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fresult-pot.svg\"\u003E\u003Cp class=\"amount-label\"\u003EPlüm vous offre {{$ctrl.store.quotationView.potResult.pot | ceil | frAmount:{minimumFractionDigits: 0} }}€,\nsoit vos économies au prix du kilowattheure HT\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slider-container margin-top-30\" ng-if=\"$ctrl.store.resultPotView.viewState === 'state-detail'\"\u003E\u003Crzslider rz-slider-model=\"$ctrl.factorCons\" rz-slider-options=\"$ctrl.potSlider.options\"\u003E\u003C\u002Frzslider\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationResultErrorComponent = function () {
    /** @ngInject */
    QuotationResultErrorComponent.$inject = ["DeviceChecker", "ContractDraft", "ErrorCatcher"];
    function QuotationResultErrorComponent(DeviceChecker, ContractDraft, ErrorCatcher) {
        _classCallCheck(this, QuotationResultErrorComponent);

        this.isMobile = DeviceChecker.isMobile;
        this.contractDraftService = ContractDraft;
        this.errorCatcher = ErrorCatcher;
    }

    _createClass(QuotationResultErrorComponent, [{
        key: 'retryGetQuotation',
        value: function retryGetQuotation() {
            var _this = this;

            this.onDispatch({
                $event: function $event(dispatch, getState) {
                    dispatch({ type: 'GET_QUOTATION' });
                    _this.contractDraftService.getQuotation({ return: 'offer,timetable' }, getState().quotation.consumptionView.consumptionForm).$promise.then(function (quotationResult) {
                        dispatch({ type: 'GET_QUOTATION_DONE', quotationResult: quotationResult });
                    }).catch(function (error) {
                        _this.errorCatcher.catchError(error);
                        dispatch({ type: 'GET_QUOTATION_ERROR', error: error });
                    });
                }
            });
        }
    }]);

    return QuotationResultErrorComponent;
}();

exports.default = {
    template: __webpack_require__(1127)(),
    controller: QuotationResultErrorComponent,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-result-error\"\u003E\u003Cdiv class=\"hanger hanger-middle hidden-xs\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-left visible-xs-block\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-right visible-xs-block\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Ch4\u003EERREUR PENDANT LA RECUPERATION DES DONNÉES\u003C\u002Fh4\u003E\u003Cdiv\u003E\u003Cp\u003ENous sommes désolé mais une erreur s'est produite au moment de la récupération des données de simulation\u003C\u002Fp\u003E\u003Cp\u003EVous pouvez nous contacter pour finaliser votre simulation et avoir un aperçu de nos tarif.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-marine\" ng-click=\"$ctrl.retryGetQuotation()\"\u003ERéessayer\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-marine\" ui-sref=\"landing\"\u003ERevenir à l’accueil\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationTimetableComponent = function () {
    /** @ngInject */
    QuotationTimetableComponent.$inject = ["DeviceChecker"];
    function QuotationTimetableComponent(DeviceChecker) {
        _classCallCheck(this, QuotationTimetableComponent);

        this.isMobile = DeviceChecker.isMobile;
    }

    _createClass(QuotationTimetableComponent, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.store) {
                this.sleek_timetable = changes.store.currentValue.timetableView.sleek_timetable;
            }
        }
    }, {
        key: 'close',
        value: function close() {
            this.onDispatch({ $event: { type: 'GO_TO_STATE_RESULT', origin: 'TIMETABLE_BTN_UNDERSTOOD' } });
        }
    }, {
        key: 'updateSleek',
        value: function updateSleek() {
            this.onDispatch({ $event: { type: 'UPDATE_SLEEK_TIMETABLE', sleek_timetable: this.sleek_timetable } });
        }
    }, {
        key: 'goToNextTutorialStep',
        value: function goToNextTutorialStep() {
            this.onDispatch({ $event: { type: 'TIMETABLE_VIEW_TUTORIAL_NEXT' } });
        }
    }, {
        key: 'closeTutorial',
        value: function closeTutorial() {
            this.onDispatch({ $event: { type: 'TIMETABLE_VIEW_TUTORIAL_CLOSE' } });
        }
    }]);

    return QuotationTimetableComponent;
}();

exports.default = {
    template: __webpack_require__(1129)(),
    controller: QuotationTimetableComponent,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-timetable\"\u003E\u003Cdiv class=\"hanger hanger-left\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hanger hanger-right\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-header\"\u003E\u003Ch3\u003EMON ÉCHÉANCIER COMPLET\u003C\u002Fh3\u003E\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-waterblue\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Cdiv class=\"form-body\"\u003E\u003Csubscription-timeline-graph data=\"$ctrl.store.quotationView.graphTimetable\" sleek-timetable=\"$ctrl.store.timetableView.sleek_timetable\" tutorial=\"$ctrl.store.timetableView.tutorial\"\u003E\u003C\u002Fsubscription-timeline-graph\u003E\u003Cdiv class=\"hidden-xs\" ng-if=\"!$ctrl.store.timetableView.tutorial.display\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput type=\"checkbox\" ng-model=\"$ctrl.sleek_timetable\" ng-change=\"$ctrl.updateSleek($ctrl.sleek_timetable)\"\u003EJe souhaite lisser mes échéances\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cp\u003ECes mensualités sont calculées à partir des prévisions de votre consommation annuelle.\nPour mieux refléter votre consommation réelle, elles sont re-calculées tous les 6 mois,\nsuite à la relève de votre compteur par un technicien du service public d’Enedis.\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Ci ng-if=\"!$ctrl.isMobile()\" ng-class=\"{'spinner spinner-form': $ctrl.isUpdating}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-marine outline\" type=\"button\" ng-click=\"$ctrl.goToNextTutorialStep()\"\u003EEXPLICATION\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.close()\"\u003EFERMER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\" ng-if=\"$ctrl.store.timetableView.tutorial.display\"\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-xs-12\" ng-if=\"$ctrl.store.timetableView.tutorial.state === 'state-1'\"\u003E\u003Cp\u003EEn été, votre consommation d’électricité diminue,\nc’est la raison pour laquelle vos mensualités sont plus basses.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12\" ng-if=\"$ctrl.store.timetableView.tutorial.state === 'state-2'\"\u003E\u003Cp\u003EEn hiver, votre consommation d’électricité augmente,\nc’est la raison pour laquelle vos mensualités sont plus hautes.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12\" ng-if=\"$ctrl.store.timetableView.tutorial.state === 'state-3'\"\u003E\u003Cp\u003EVous pouvez aussi choisir de lisser vos échéances sur 6 mois,\nvous paierez alors un montant identique pendant chaque période de facturation.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ng-click=\"$ctrl.goToNextTutorialStep()\"\u003E\u003Cspan ng-if=\"$ctrl.store.timetableView.tutorial.state === 'state-1'\"\u003ESUIVANT (2\u002F4)\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.store.timetableView.tutorial.state === 'state-2'\"\u003ESUIVANT (3\u002F4)\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.store.timetableView.tutorial.state === 'state-3'\"\u003ETERMINER (4\u002F4)\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-marine\" ng-click=\"$ctrl.close()\"\u003EFERMER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput type=\"checkbox\" ng-model=\"$ctrl.sleek_timetable\" ng-change=\"$ctrl.updateSleek($ctrl.sleek_timetable)\"\u003EJe souhaite lisser mes échéances\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EVotre échéancier, c'est un découpage de votre facture annuelle d'électricité en mensualités.\nCelles-ci sont calculées à partir des prévisions de votre consommation future, par périodes de 6 mois.\nVous pouvez choisir de les lisser où de les faire refléter votre consommation réelle, mois par mois.\u003C\u002Fp\u003E\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.close()\"\u003EFERMER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationMobileIntro = function () {
    /** @ngInject */
    QuotationMobileIntro.$inject = ["DeviceChecker"];
    function QuotationMobileIntro(DeviceChecker) {
        _classCallCheck(this, QuotationMobileIntro);

        this.isMobile = DeviceChecker.isMobile;
        this.currentSlide = 0;
    }

    _createClass(QuotationMobileIntro, [{
        key: 'nextSlide',
        value: function nextSlide() {
            this.currentSlide = this.currentSlide + 1;
        }
    }, {
        key: 'hideMobileIntro',
        value: function hideMobileIntro() {
            this.onDispatch({ $event: { type: 'HIDE_MOBILE_INTRO' } });
        }
    }]);

    return QuotationMobileIntro;
}();

exports.default = {
    template: __webpack_require__(1131)(),
    controller: QuotationMobileIntro,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"flex flex-column\"\u003E\u003Cdiv uib-carousel active=\"$ctrl.currentSlide\" no-wrap=\"true\"\u003E\u003Cdiv uib-slide index=\"0\"\u003E\u003Cdiv class=\"intro-panel\"\u003E\u003Ch2\u003EEstimez votre facture annuelle avec Plüm\u003C\u002Fh2\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fimg-mobile-bill.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv uib-slide index=\"1\"\u003E\u003Cdiv class=\"intro-panel\"\u003E\u003Ch2\u003EDécouvrez votre bonus économies d’énergie\u003C\u002Fh2\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fimg-mobile-cagnotte.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv uib-slide index=\"2\"\u003E\u003Cdiv class=\"intro-panel\"\u003E\u003Ch2\u003EEn 2 minutes, votre échéancier détaillé\u003C\u002Fh2\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fimg-mobile-echeancier.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-if=\"$ctrl.currentSlide !== 2\" ng-click=\"$ctrl.nextSlide()\"\u003ESuivant\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink outline round\" ng-if=\"$ctrl.currentSlide === 2\" ng-click=\"$ctrl.hideMobileIntro()\"\u003ECalculer mon devis\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationVisitorMain =
/** @ngInject */
["DeviceChecker", "ContractDraft", "ErrorCatcher", function QuotationVisitorMain(DeviceChecker, ContractDraft, ErrorCatcher) {
    _classCallCheck(this, QuotationVisitorMain);

    this.isMobile = DeviceChecker.isMobile;
    this.contractDraftService = ContractDraft;
    this.errorCatcher = ErrorCatcher;
}];

exports.default = {
    template: __webpack_require__(1133)(),
    controller: QuotationVisitorMain,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-visitor-main\"\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Ch4\u003EEN SIMPLE VISITE ?\u003C\u002Fh4\u003E\u003Cdiv\u003E\u003Cp\u003EVous êtes arrivé jusqu’ici par \u003Cstrong\u003Esimple curiosité\u003C\u002Fstrong\u003E ou vous avez  besoin \u003Cstrong\u003Ed’un peu de temps\u003C\u002Fstrong\u003E avant de passer chez Plüm ?\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cp\u003ED’ici là, vous pouvez déjà faire \u003Cstrong\u003Evos premier pas avec Plüm.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EApprenez avec nous à consommer plus intelligement !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cquotation-visitor-newsletter class=\"animate-fade-out\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch({$event: $event})\"\u003E\u003C\u002Fquotation-visitor-newsletter\u003E\u003Cquotation-visitor-facebook class=\"animate-fade-out\" store=\"$ctrl.store\" on-dispatch=\"$ctrl.onDispatch({$event: $event})\"\u003E\u003C\u002Fquotation-visitor-facebook\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationVisitorNewsletter = function () {
    /** @ngInject */
    QuotationVisitorNewsletter.$inject = ["DeviceChecker", "ContractDraft", "CampaignLanding", "CampaignLandingType", "ErrorCatcher"];
    function QuotationVisitorNewsletter(DeviceChecker, ContractDraft, CampaignLanding, CampaignLandingType, ErrorCatcher) {
        _classCallCheck(this, QuotationVisitorNewsletter);

        this.isMobile = DeviceChecker.isMobile;
        this.contractDraftService = ContractDraft;
        this.CampaignLanding = CampaignLanding;
        this.CampaignLandingType = CampaignLandingType;
        this.ErrorCatcher = ErrorCatcher;
        this.newsletterForm = { email: null };
    }

    _createClass(QuotationVisitorNewsletter, [{
        key: 'displayForm',
        value: function displayForm() {
            this.onDispatch({ $event: { type: 'DISPLAY_NEWSLETTER_FORM' } });
        }
    }, {
        key: 'submitFormNewsletter',
        value: function submitFormNewsletter() {
            var _this = this;

            this.onDispatch({ $event: { type: 'SUBMIT_NEWSLETTER_FORM' } });
            this.CampaignLanding.submitCampaignInformation({
                id_campaign: 'LANDING_NEWSLETTER',
                type: this.CampaignLandingType.SUBSCRIBE,
                referrer: (0, _isEmpty3.default)(document.referrer) ? undefined : document.referrer,
                mail: this.newsletterForm.email
            }).$promise.then(function () {
                _this.onDispatch({ $event: { type: 'SUBMIT_NEWSLETTER_FORM_DONE' } });
            }).catch(function (error) {
                _this.ErrorCatcher.catchError(error);
                _this.onDispatch({ $event: { type: 'SUBMIT_NEWSLETTER_FORM_ERROR' } });
            });
        }
    }, {
        key: 'displayFirstAdvice',
        value: function displayFirstAdvice() {
            this.onDispatch({ $event: { type: 'DISPLAY_FIRST_ADVICE' } });
        }
    }]);

    return QuotationVisitorNewsletter;
}();

exports.default = {
    template: __webpack_require__(1135)(),
    controller: QuotationVisitorNewsletter,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-visitor-newsletter\"\u003E\u003Cdiv class=\"hanger hanger-middle\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-header\"\u003E\u003Ch4\u003ELES ÉCLAIRAGES DE PLÜM\u003C\u002Fh4\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Flampe.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Cdiv ng-if=\"$ctrl.store.visitorView.viewState === 'state-initial'\"\u003E\u003Ch4\u003ELa Newsletter pour apprendre à mieux consommer\u003C\u002Fh4\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cp\u003E2 fois par mois, un éclairage sur la consommation d’énergie à lire en moins d’une minute\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-marine\" ng-click=\"$ctrl.displayForm()\"\u003ERecevoir les éclairages\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.store.visitorView.viewState === 'state-form'\"\u003E\u003Ch4\u003EConfiez-nous votre adresse, on en prendra soin\u003C\u002Fh4\u003E\u003Cform class=\"default-form form-horizontal margin-top-20\" ng-submit=\"$ctrl.submitFormNewsletter()\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003EAdresse e-mail\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput type=\"email\" name=\"email\" required ng-model=\"$ctrl.newsletterForm.email\" ng-disabled=\"$ctrl.store.visitorView.isSubmitting\" style=\"width: 100%;\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions margin-top-60\"\u003E\u003Cspan style=\"display: inline-block;\"\u003EPas de spam, c’est promis !\u003C\u002Fspan\u003E\u003Cbutton class=\"btn btn-spinner background-marine\" type=\"submit\" ng-class=\"{'btn-spinner-loading': $ctrl.store.visitorView.isSubmitting}\" ng-disabled=\"$ctrl.store.visitorView.isSubmitting\"\u003EEnvoyer !\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.store.visitorView.viewState === 'state-success'\"\u003E\u003Ch4\u003EMerci !\u003C\u002Fh4\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cp\u003EVous recevrez bientôt votre premier éclairage !\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cp\u003EEn attendant, voici un premier conseil \u003Cbr\u003E (juste entre nous, parce qu’on est vraiment sympa)\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions margin-top-30\"\u003E\u003Cbutton class=\"btn background-marine\" ng-click=\"$ctrl.displayFirstAdvice()\"\u003EDites, pour voir ?\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.store.visitorView.viewState === 'state-first-advice'\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-8 text-justify\"\u003E\u003Cstrong\u003EDépoussiérez vos ampoules pour gagner en luminosité !\u003C\u002Fstrong\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cp\u003ELa poussière qui s’accumule sur vos ampoules  et abat-jours peut vous faire perdre jusqu’à 40% de luminosité.\nUne ampoule de 100W n’éclairerait qu’à hauteur de 60W.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cstrong\u003EAvec ce petit brin de ménage, vous y verrez déjà plus clair ;).\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 no-padding\"\u003E\u003Cdiv class=\"ampoules-advice-wrapper\"\u003E\u003Cimg class=\"ampoules-advice\" src=\"\u002Fassets\u002Fimg\u002Fquotation\u002Fampoules-advice.png\" style=\"width: 174px;\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotationVisitorFacebook = function () {
    /** @ngInject */
    QuotationVisitorFacebook.$inject = ["DeviceChecker"];
    function QuotationVisitorFacebook(DeviceChecker) {
        _classCallCheck(this, QuotationVisitorFacebook);

        this.isMobile = DeviceChecker.isMobile;
    }

    _createClass(QuotationVisitorFacebook, [{
        key: 'clickOnIframeFacebook',
        value: function clickOnIframeFacebook() {
            this.onDispatch({ $event: { type: 'CLICK_ON_VISITOR_FACEBOOK' } });
        }
    }]);

    return QuotationVisitorFacebook;
}();

exports.default = {
    template: __webpack_require__(1137)(),
    controller: QuotationVisitorFacebook,
    bindings: {
        store: '<',
        onDispatch: '&'
    }
};

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"suspended-sign suspended-sign-quotation-visitor-facebook\"\u003E\u003Cdiv class=\"hanger hanger-middle\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-header\"\u003E\u003Ch4\u003EDÉCOUVREZ NOS CONSEILS\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body\"\u003E\u003Cp\u003ESuivez nos conseils hebdomadaires en likant notre page Facebook\u003C\u002Fp\u003E\u003Cdiv class=\"fb-page\" data-href=\"https:\u002F\u002Fwww.facebook.com\u002FPlumEnergie\" data-tabs=\"timeline\" data-width=\"320\" data-height=\"130\" data-small-header=\"false\" data-adapt-container-width=\"true\" data-hide-cover=\"false\" data-show-facepile=\"false\"\u003E\u003Cblockquote class=\"fb-xfbml-parse-ignore\" cite=\"https:\u002F\u002Fwww.facebook.com\u002FPlumEnergie\"\u003E\u003Ca href=\"https:\u002F\u002Fwww.facebook.com\u002FPlumEnergie\"\u003EPlüm énergie\u003C\u002Fa\u003E\u003C\u002Fblockquote\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _securityDepositSummary = __webpack_require__(1139);

var _securityDepositSummary2 = _interopRequireDefault(_securityDepositSummary);

var _securityDepositCancelModal = __webpack_require__(1141);

var _securityDepositCancelModal2 = _interopRequireDefault(_securityDepositCancelModal);

var _securityDepositFAQModal = __webpack_require__(1143);

var _securityDepositFAQModal2 = _interopRequireDefault(_securityDepositFAQModal);

var _securityDepositPostponeModal = __webpack_require__(1145);

var _securityDepositPostponeModal2 = _interopRequireDefault(_securityDepositPostponeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide Modularity - https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#modularity */
exports.default = _angular2.default.module('unergie.securityDepositSummary', []).component('securityDepositSummary', _securityDepositSummary2.default).component('securityDepositCancelModal', _securityDepositCancelModal2.default).component('securityDepositFAQModal', _securityDepositFAQModal2.default).component('securityDepositPostponeModal', _securityDepositPostponeModal2.default).name;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SecurityDepositSummary = function () {
    /** @ngInject */
    SecurityDepositSummary.$inject = ["$window", "$uibModal", "Contract", "SecurityDeposit", "DataAccessVariables", "ContactTelephone", "ErrorCatcher"];
    function SecurityDepositSummary($window, $uibModal, Contract, SecurityDeposit, DataAccessVariables, ContactTelephone, ErrorCatcher) {
        _classCallCheck(this, SecurityDepositSummary);

        this.$window = $window;
        this.$uibModal = $uibModal;
        this.Contract = Contract;
        this.SecurityDeposit = SecurityDeposit;
        this.DataAccessVariables = DataAccessVariables;
        this.ContactTelephone = ContactTelephone;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(SecurityDepositSummary, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.depositAmount = 0;
            this.isLoading = false;
            this.error = null;

            this.DataAccessVariables.get({ variables: 'DEPOSIT_AMOUNT' }).$promise.then(function (response) {
                _this.depositAmount = response.DEPOSIT_AMOUNT;
            });
        }
    }, {
        key: 'openFAQ',
        value: function openFAQ() {
            var _this2 = this;

            this.$uibModal.open({
                animation: true,
                component: 'securityDepositFAQModal',
                resolve: {
                    depositAmount: function depositAmount() {
                        return _this2.depositAmount;
                    }
                }
            });
        }
    }, {
        key: 'cancelPayment',
        value: function cancelPayment() {
            var _this3 = this;

            this.$uibModal.open({
                animation: true,
                component: 'securityDepositCancelModal',
                resolve: {
                    tokenId: function tokenId() {
                        return _this3.tokenId;
                    },
                    contractId: function contractId() {
                        return _this3.contractId;
                    }
                }
            });
        }
    }, {
        key: 'postponePayment',
        value: function postponePayment() {
            this.$uibModal.open({
                animation: true,
                component: 'securityDepositPostponeModal'
            });
        }
    }, {
        key: 'goToPayment',
        value: function goToPayment() {
            var _this4 = this;

            this.isLoading = true;
            this.error = null;
            var getRedirectPromise = void 0;
            if (this.tokenId) {
                getRedirectPromise = this.SecurityDeposit.getRedirect({ tokenId: this.tokenId }).$promise;
            } else {
                getRedirectPromise = this.Contract.getRedirectToSecurityDeposit({ id: this.contractId }).$promise;
            }
            getRedirectPromise.then(function (redirectResult) {
                _this4.$window.location = redirectResult.redirectUrl;
            }).catch(function (error) {
                _this4.ErrorCatcher.catchError(error);
                _this4.isLoading = false;
                _this4.error = error;
            });
        }
    }]);

    return SecurityDepositSummary;
}();

exports.default = {
    template: __webpack_require__(1140)(),
    controller: SecurityDepositSummary,
    bindings: {
        depositInfo: '<',
        tokenId: '<',
        contractId: '<'
    }
};

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"securityDepositSummary\"\u003E\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003Cspan\u003EMa commande Plüm énergie\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"navbar-text\"\u003EMa commande Plüm énergie\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1 default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003EDÉPÔT DE GARANTIE REQUIS\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" ng-submit=\"$ctrl.goToPayment()\"\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"$ctrl.error\"\u003E\u003Ci class=\"fa fa-warning hidden-xs\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp\u003E\u003Cstrong ng-if=\"!$ctrl.error.data.message\"\u003EUne erreur s'est produite.\u003C\u002Fstrong\u003E\u003Cstrong ng-if=\"$ctrl.error.data.message\"\u003E{{$ctrl.error.data.message}}\u003C\u002Fstrong\u003E\u003Cbr\u003E\u003Cbr\u003EVous avez la possibilité de contacter le service client au\n\u003Ca class=\"underline\" ng-href=\"{{$ctrl.ContactTelephone.anonymous.link}}\" ng-bind=\"$ctrl.ContactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\nafin de résoudre le problème.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-15\" ng-if=\"!$ctrl.depositInfo\"\u003E\u003Cp\u003ELe lien de paiement pour le dépôt de garantie a expiré, merci de contacter le service client au\n\u003Ca class=\"underline\" ng-href=\"{{$ctrl.ContactTelephone.anonymous.link}}\" ng-bind=\"$ctrl.ContactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\nafin de résoudre le problème.\u003C\u002Fp\u003E\u003Cdiv class=\"form-actions margin-top-20\"\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ui-sref=\"landing\"\u003EREVENIR À LA PAGE D'ACCUEIL\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-15\" ng-if=\"$ctrl.depositInfo.isDepositNeeded === true\"\u003E\u003Cp\u003EVotre moyen de paiement est enregistré.\u003C\u002Fp\u003E\u003Cp\u003EUn \u003Cstrong\u003Edépôt de garantie d’un montant de {{$ctrl.depositAmount | frAmount}}€ est nécessaire\u003C\u002Fstrong\u003E pour terminer\nla souscription de votre contrat d’électricité.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-30\"\u003E\u003Ca class=\"underline\" ng-click=\"$ctrl.openFAQ()\"\u003EEn savoir plus sur le dépôt de garantie\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-30 text-center\"\u003E\u003Cimg class=\"padding-20\" src=\"assets\u002Fimg\u002Fpayment\u002Flogo-cb.png\"\u003E\u003Cimg class=\"padding-20\" src=\"assets\u002Fimg\u002Fpayment\u002Flogo-mastercard.png\"\u003E\u003Cimg class=\"padding-20\" src=\"assets\u002Fimg\u002Fpayment\u002Flogo-visa.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions margin-top-20 flex-sm flex-space-around\"\u003E\u003Cbutton class=\"btn background-marine\" type=\"button\" ng-click=\"$ctrl.cancelPayment()\"\u003EANNULER LA COMMANDE\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn background-white border-marine\" type=\"button\" ng-click=\"$ctrl.postponePayment()\"\u003E\u003Cspan class=\"hidden-xs\"\u003ETERMINER MA COMMANDE PLUS TARD\u003C\u002Fspan\u003E\u003Cspan class=\"visible-xs-inline\"\u003ETERMINER PLUS TARD\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" type=\"submit\" ng-disabled=\"$ctrl.isLoading\" ng-class=\"{'btn-spinner-loading': $ctrl.isLoading}\"\u003EPAYER ET TERMINER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SecurityDepositCancelModal = function () {
    /** @ngInject */
    SecurityDepositCancelModal.$inject = ["$state", "ContactTelephone", "Contract", "SecurityDeposit", "ErrorCatcher"];
    function SecurityDepositCancelModal($state, ContactTelephone, Contract, SecurityDeposit, ErrorCatcher) {
        _classCallCheck(this, SecurityDepositCancelModal);

        this.$state = $state;
        this.ContactTelephone = ContactTelephone;
        this.Contract = Contract;
        this.SecurityDeposit = SecurityDeposit;
        this.ErrorCatcher = ErrorCatcher;
    }

    _createClass(SecurityDepositCancelModal, [{
        key: '$onInit',
        value: function $onInit() {
            this.state = 'STATE-CANCEL-FORM';
        }
    }, {
        key: 'confirmCancelContract',
        value: function confirmCancelContract() {
            var _this = this;

            this.state = 'STATE-CANCEL-PROGRESS';
            var cancelContractPromise = void 0;
            if (this.resolve.tokenId) {
                cancelContractPromise = this.SecurityDeposit.refuseDeposit({ tokenId: this.resolve.tokenId }, {}).$promise;
            } else {
                cancelContractPromise = this.Contract.cancelContract({ id: this.resolve.contractId }, {}).$promise;
            }
            cancelContractPromise.then(function () {
                _this.$state.go('landing');
                _this.state = 'STATE-CANCEL-DONE';
            }).catch(function (error) {
                _this.state = 'STATE-CANCEL-ERROR';
                _this.ErrorCatcher.catchError(error);
            });
        }
    }]);

    return SecurityDepositCancelModal;
}();

exports.default = {
    template: __webpack_require__(1142)(),
    controller: SecurityDepositCancelModal,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"modal-body text-center margin-top-20\"\u003E\u003Cdiv ng-if=\"$ctrl.state === 'STATE-CANCEL-FORM'\"\u003E\u003Ch3\u003EConfirmer l’annulation de votre commande\u003C\u002Fh3\u003E\u003Cp class=\"margin-top-20\"\u003EEn cliquant sur le bouton ci-dessous, votre commande sera annulée.\nBien sûr, aucune somme ne sera prélevée sur votre compte.\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-20\"\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.confirmCancelContract()\"\u003EANNULER MA COMMANDE\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'STATE-CANCEL-PROGRESS'\"\u003E\u003Ch3\u003EAnnulation en cours...\u003C\u002Fh3\u003E\u003Ci class=\"spinner spinner-form\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'STATE-CANCEL-DONE'\"\u003E\u003Ch3 class=\"text-center\"\u003ENous avons bien pris en compte l’annulation de votre commande\u003C\u002Fh3\u003E\u003Cp class=\"margin-top-20\"\u003EVos informations de paiement ne seront pas conservées.\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-20\"\u003E\u003Cbutton class=\"btn background-marine\" ng-click=\"$ctrl.close()\"\u003EFERMER\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'STATE-CANCEL-ERROR'\"\u003E\u003Ch3\u003EOups, une erreur s'est produite\u003C\u002Fh3\u003E\u003Cp class=\"margin-top-20\"\u003EUne erreur s'est produite au moment de l'annulation de votre commande.\nVous pouvez contacter le service client au\n\u003Ca class=\"underline\" ng-href=\"{{$ctrl.ContactTelephone.anonymous.link}}\" ng-bind=\"$ctrl.ContactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-20\"\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.confirmCancelContract()\"\u003EANNULER MA COMMANDE\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: __webpack_require__(1144)(),
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"modal-body\"\u003E\u003Ch3 class=\"text-center\"\u003ELe dépôt de garantie\u003C\u002Fh3\u003E\u003Cp class=\"margin-top-15\"\u003E\u003Cstrong\u003EQuel est son montant ?\u003C\u002Fstrong\u003E\u003Cbr\u003ELe montant du dépôt de garantie est de {{$ctrl.resolve.depositAmount | frAmount}}€.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-15\"\u003E\u003Cstrong\u003EComment est-il versé ?\u003C\u002Fstrong\u003E\u003Cbr\u003ELe dépôt de garantie est à régler par carte bancaire.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-15\"\u003E\u003Cstrong\u003EÀ quoi ça sert ?\u003C\u002Fstrong\u003E\u003Cbr\u003ELe dépôt de garantie, qui est une somme qui sert à couvrir les risques de défauts de paiement,\nest une pratique assez courante chez les fournisseurs d’énergie.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-15\"\u003E\u003Cstrong\u003EDans quels cas est-il demandé ?\u003C\u002Fstrong\u003E\u003Cbr\u003EIl est demandé, par exemple, si vous utilisez un moyen de paiement prépayé ou lorsque des impayés ont été constatés\ndans le passé pour le compteur de votre logement.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-15\"\u003E\u003Cstrong\u003EDans quelles conditions est-il restitué ?\u003C\u002Fstrong\u003E\u003Cbr\u003ELe dépôt de garantie est restitué dans deux cas de figure :\u003Cul\u003E\u003Cli\u003Esoit sur simple demande auprès du service client Plüm énergie, passés 12 mois sans aucun incident de paiement.\u003C\u002Fli\u003E\u003Cli\u003Esoit une fois la résiliation effective, avec la facture de clôture.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003Cp class=\"margin-top-15\"\u003E\u003Cstrong\u003EQue se passe-t-il si je ne souhaite pas le verser ?\u003C\u002Fstrong\u003E\u003Cbr\u003ESi vous ne souhaitez pas verser ce dépôt de garantie, nous n'activerons pas votre contrat et, bien entendu,\naucune somme ne sera prélevée sur votre compte.\u003Cbr\u003ESans action de votre part, votre commande sera automatiquement annulée au bout de 30 jours,\nmais vous pouvez l'annuler tout de suite en cliquant sur le bouton « ANNULER LA COMMANDE ».\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SecurityDepositPostponeModal = function () {
    /** @ngInject */
    SecurityDepositPostponeModal.$inject = ["$timeout", "$state"];
    function SecurityDepositPostponeModal($timeout, $state) {
        _classCallCheck(this, SecurityDepositPostponeModal);

        this.$timeout = $timeout;
        this.$state = $state;
    }

    _createClass(SecurityDepositPostponeModal, [{
        key: 'doLogout',
        value: function doLogout() {
            var _this = this;

            this.dismiss();
            this.$timeout(function () {
                return _this.$state.go('logout', {}, { reload: true });
            });
        }
    }]);

    return SecurityDepositPostponeModal;
}();

exports.default = {
    template: __webpack_require__(1146)(),
    controller: SecurityDepositPostponeModal,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"modal-body\"\u003E\u003Ch3 class=\"text-center\"\u003ECommande sauvegardée\u003C\u002Fh3\u003E\u003Cp class=\"margin-top-20\"\u003ELes informations de votre commande ont été sauvegardées.\nIl suffit de vous reconnecter sur espace-client.plum.fr pour la finaliser.\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-20\"\u003E\u003Cbutton class=\"btn background-white border-marine\" ng-click=\"$ctrl.doLogout()\"\u003EOK\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _subscriptionPay = __webpack_require__(1148);

var _subscriptionPay2 = _interopRequireDefault(_subscriptionPay);

var _subscriptionPartnerCreateAccount = __webpack_require__(1150);

var _subscriptionPartnerCreateAccount2 = _interopRequireDefault(_subscriptionPartnerCreateAccount);

var _subscriptionTimeline = __webpack_require__(1152);

var _subscriptionTimeline2 = _interopRequireDefault(_subscriptionTimeline);

var _subscriptionHelp = __webpack_require__(1154);

var _subscriptionHelp2 = _interopRequireDefault(_subscriptionHelp);

var _subscriptionHelpOffrePrintemps = __webpack_require__(1156);

var _subscriptionHelpOffrePrintemps2 = _interopRequireDefault(_subscriptionHelpOffrePrintemps);

var _subscriptionHelpOffreEte = __webpack_require__(1158);

var _subscriptionHelpOffreEte2 = _interopRequireDefault(_subscriptionHelpOffreEte);

var _subscriptionHelpOffreRentree = __webpack_require__(1160);

var _subscriptionHelpOffreRentree2 = _interopRequireDefault(_subscriptionHelpOffreRentree);

var _subscriptionHelpOffreAutomne = __webpack_require__(1162);

var _subscriptionHelpOffreAutomne2 = _interopRequireDefault(_subscriptionHelpOffreAutomne);

var _findPdlHelper = __webpack_require__(1164);

var _findPdlHelper2 = _interopRequireDefault(_findPdlHelper);

var _bypassReadingsAlert = __webpack_require__(1166);

var _bypassReadingsAlert2 = _interopRequireDefault(_bypassReadingsAlert);

var _subscriptionSwitchStandardOffer = __webpack_require__(1168);

var _subscriptionSwitchStandardOffer2 = _interopRequireDefault(_subscriptionSwitchStandardOffer);

var _landscapeConfirmModalCtrl = __webpack_require__(1170);

var _landscapeConfirmModalCtrl2 = _interopRequireDefault(_landscapeConfirmModalCtrl);

var _landscapeModalCtrl = __webpack_require__(1171);

var _landscapeModalCtrl2 = _interopRequireDefault(_landscapeModalCtrl);

var _subscriptionContactUnknownPRM = __webpack_require__(1172);

var _subscriptionContactUnknownPRM2 = _interopRequireDefault(_subscriptionContactUnknownPRM);

var _subscription = __webpack_require__(1173);

var _subscription2 = _interopRequireDefault(_subscription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.subscription', []).component('subscriptionPay', _subscriptionPay2.default).component('subscriptionPartnerCreateAccount', _subscriptionPartnerCreateAccount2.default).component('subscriptionTimeline', _subscriptionTimeline2.default).component('subscriptionHelp', _subscriptionHelp2.default).component('subscriptionHelpOffrePrintemps2018', _subscriptionHelpOffrePrintemps2.default).component('subscriptionHelpOffreEte2018', _subscriptionHelpOffreEte2.default).component('subscriptionHelpOffreRentree2018', _subscriptionHelpOffreRentree2.default).component('subscriptionHelpOffreAutomne2018', _subscriptionHelpOffreAutomne2.default).component('findPdlHelper', _findPdlHelper2.default).component('bypassReadingsAlert', _bypassReadingsAlert2.default).component('subscriptionSwitchStandardOffer', _subscriptionSwitchStandardOffer2.default).controller('landscapeConfirmModalCtrl', _landscapeConfirmModalCtrl2.default).controller('landscapeModalCtrl', _landscapeModalCtrl2.default).controller('subscriptionContactUnknownPRMCtrl', _subscriptionContactUnknownPRM2.default).controller('subscriptionCtrl', _subscription2.default).name;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _has2 = __webpack_require__(101);

var _has3 = _interopRequireDefault(_has2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var subscriptionPay = {
    restrict: 'E',
    bindings: {
        contractDraft: '<',
        sponsorValidation: '<',
        sponsorOkMessage: '<',
        promoValidation: '<',
        subscriptionType: '<',
        choosenMESTariff: '<choosenMesTariff',
        isUpdating: '<',
        onGoToPayment: '&',
        onContractDraftUpdate: '&'
    },
    template: __webpack_require__(1149)(),
    /** @ngInject */controller: ["$element", "DeviceChecker", function controller($element, DeviceChecker) {
        var ctrl = this;
        ctrl.enablePayment = false;
        ctrl.isMobile = DeviceChecker.isMobile;
        ctrl.form = {
            hasConsent: null
        };

        ctrl.isPromoValid = function () {
            return ctrl.promoValidation.isValid;
        };

        ctrl.updateConsent = function (hasConsent) {
            ctrl.onContractDraftUpdate({
                value: {
                    consent_curves: hasConsent,
                    consent_index: hasConsent
                }
            });
        };

        ctrl.$onChanges = function (changes) {
            if ((0, _has3.default)(changes, 'contractDraft.currentValue.consent_curves')) {
                ctrl.form.hasConsent = changes.contractDraft.currentValue.consent_curves;
            }
        };
    }]
};

exports.default = subscriptionPay;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"form-body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cstrong ng-if=\"$ctrl.contractDraft.sponsor_id &amp;&amp; $ctrl.sponsorValidation.isValid\"\u003E{{$ctrl.sponsorOkMessage}}\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cstrong ng-if=\"$ctrl.contractDraft.id_ref_promo &amp;&amp; $ctrl.promoValidation.isValid\"\u003EEn finalisant votre commande, vous bénéficierez du code promo {{$ctrl.contractDraft.id_ref_promo}}\u003Cspan ng-show=\"$ctrl.isPromoMessageDefault()\"\u003E.\u003C\u002Fspan\u003E\u003Cspan ng-show=\"!$ctrl.isPromoMessageDefault()\"\u003E&nbsp;:\u003Cbr\u003E\u003Cb\u003E&#171; {{$ctrl.promoValidation.message}} &#187;\u003C\u002Fb\u003E\u003C\u002Fspan\u003E\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.subscriptionType === 'emmenagement'\"\u003E\u003Cdiv class=\"col-sm-10\"\u003E\u003Cstrong\u003EPour votre emménagement, des frais de mise en service de {{$ctrl.choosenMESTariff.price}}€ seront appliqués.\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"form-group col-sm-10\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput id=\"accept-cgv\" type=\"checkbox\" ng-model=\"$ctrl.enablePayment\"\u003EJ'accepte sans réserve les&nbsp;\u003Ca class=\"underlined\" href=\"\u002Fdocumentation\u002Fcgv.pdf\" target=\"_blank\"\u003Econditions générales de vente de Plüm énergie\u003C\u002Fa\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"form-group col-sm-10\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput id=\"authorize-plum\" type=\"checkbox\" ng-model=\"$ctrl.form.hasConsent\" ng-change=\"$ctrl.updateConsent($ctrl.form.hasConsent)\"\u003EJ’autorise Plüm énergie à collecter auprès d’Enedis ma consommation d'électricité\n(courbe de consommation par demi-heure, puissance maximum utilisée)\net à l’analyser pour m’aider à mieux consommer.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 text-right\"\u003E\u003Ci ng-if=\"!$ctrl.isMobile()\" ng-class=\"{'spinner spinner-form': $ctrl.isUpdating}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.onGoToPayment()\" ng-disabled=\"$ctrl.isUpdating || !$ctrl.enablePayment || !$ctrl.isPromoValid()\"\u003ESAISIR MON RIB\u003C\u002Fbutton\u003E\u003Ci ng-if=\"$ctrl.isMobile()\" ng-class=\"{'spinner spinner-form': $ctrl.isUpdating}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var subscriptionPartnerCreateAccount = {
    restrict: 'E',
    bindings: {
        contractDraft: '<',
        sponsorValidation: '<',
        sponsorOkMessage: '<',
        promoValidation: '<',
        subscriptionType: '<',
        signupError: '<',
        choosenMESTariff: '<choosenMesTariff',
        isUpdating: '<',
        powerMax: '<',
        partnerOffer: '<',
        onCreateAccount: '&'
    },
    template: __webpack_require__(1151)(),
    /** @ngInject */controller: ["$element", "$location", "DeviceChecker", "MobilePhone", "RecaptchaKey", "ContactTelephone", function controller($element, $location, DeviceChecker, MobilePhone, RecaptchaKey, ContactTelephone) {
        var ctrl = this;
        ctrl.isMobile = DeviceChecker.isMobile;
        ctrl.contactTelephone = ContactTelephone;
        ctrl.phoneRegex = MobilePhone.phoneRegex.all;
        ctrl.newUser = {
            captcha: undefined
        };
        ctrl.captcha = {
            key: RecaptchaKey[$location.host()]
        };

        ctrl.isPromoValid = function () {
            return ctrl.promoValidation.isValid;
        };
    }]
};

exports.default = subscriptionPartnerCreateAccount;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"form-body\" name=\"$ctrl.signupForm\" ng-submit=\"$ctrl.signupForm.$valid &amp;&amp; $ctrl.onCreateAccount({newUser: $ctrl.newUser})\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 text-center subscription-item\"\u003E\u003Cdiv class=\"subscription-icon\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Fsaved.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"margin-top-20\"\u003EVos informations ont été sauvegardées\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 text-center subscription-item\" ng-if=\"$ctrl.partnerOffer === 'showroom'\"\u003E\u003Cdiv class=\"subscription-icon\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Fpresent.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-20\"\u003E\u003Cp\u003E\u003Cstrong class=\"fs-30\" ng-if=\"$ctrl.powerMax &lt;= 6\"\u003E25€\u003C\u002Fstrong\u003E\u003Cstrong class=\"fs-30\" ng-if=\"$ctrl.powerMax &gt; 6 &amp;&amp; $ctrl.powerMax &lt;= 12\"\u003E50€\u003C\u002Fstrong\u003E\u003Cstrong class=\"fs-30\" ng-if=\"$ctrl.powerMax &gt; 12\"\u003E75€\u003C\u002Fstrong\u003E&nbsp;\u003Cstrong\u003Eofferts\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003E\u003Cspan\u003EVous pourrez les utiliser depuis votre espace client pour diminuer vos factures\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 text-center subscription-item\" ng-if=\"$ctrl.partnerOffer === 'offreCinqVingtCinq'\"\u003E\u003Cdiv class=\"subscription-icon\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Fpresent.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-20\"\u003E\u003Cp class=\"padding-20 fw-500 blue-dark-selectra text-justify\"\u003EVous bénéficiez d’une remise de 5% sur le prix de votre élecricité en heures pleines\net 25% en heures creuses, durant toute la première année.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 text-center subscription-item\" ng-if=\"$ctrl.partnerOffer === 'offreFlashTrente'\"\u003E\u003Cdiv class=\"subscription-icon\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Fpresent.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-20\"\u003E\u003Cp class=\"padding-20 fw-500 blue-dark-selectra text-justify\"\u003EVous bénéficiez d’une remise de 30% en heures creuses, durant toute la première année.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-4 text-center subscription-item\"\u003E\u003Cdiv class=\"subscription-icon\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Fmailtosend.svg\"\u003E\u003Cp class=\"margin-top-20\"\u003EIl ne vous reste plus qu’à \u003Cstrong\u003Efinaliser votre souscription depuis votre boîte mail\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row error margin-top-20\" ng-if=\"$ctrl.signupError.isError\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error\"\u003E\u003Cp\u003E\u003Cspan ng-if=\"$ctrl.signupError.code === 'DUPLICATE_EMAIL'\"\u003EL'email renseigné est déjà associé à un compte existant.\n\u003Ca ui-sref=\"login\"\u003ECliquez ici pour vous connecter et finaliser votre commande.\u003C\u002Fa\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.signupError.code === 'SERVICE_MSG'\"\u003E\u003Cspan ng-bind=\"signupError.message\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.signupError.code === 'DEFAULT_MSG'\"\u003EUne erreur inattendue s'est produite. Votre demande d'inscription n'a pas été prise en compte.\u003C\u002Fspan\u003E\u003Cbr\u003ESi besoin, vous pouvez également contacter notre support client au\n\u003Ca class=\"underline\" ng-href=\"{{$ctrl.contactTelephone.anonymous.link}}\" ng-bind=\"$ctrl.contactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\nafin de résoudre et de finaliser votre commande.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\" ng-class=\"{error: $ctrl.signupForm.$submitted &amp;&amp; $ctrl.signupForm.recaptcha.$error.required}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\"$ctrl.signupForm.$submitted &amp;&amp; $ctrl.signupForm.recaptcha.$error.required\"\u003E\u003C\u002Fi\u003E\u003Cdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 no-margin-top\" vc-recaptcha name=\"recaptcha\" required key=\"$ctrl.captcha.key\" size=\"$ctrl.isMobile() ? 'compact' : 'normal'\" ng-model=\"$ctrl.newUser.captcha\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 form-message\" ng-class=\"{formmessage: !$ctrl.isMobile(), formmessagemob: $ctrl.isMobile()}\"\u003E\u003Cp ng-if=\"$ctrl.signupForm.$submitted &amp;&amp; $ctrl.signupForm.recaptcha.$error.required\"\u003ECette étape est conçue pour que nous nous assurions que c'est bien une personne\net non un ordinateur qui essaie de remplir le formulaire.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 text-right\"\u003E\u003Ci ng-if=\"!$ctrl.isMobile()\" ng-class=\"{'spinner spinner-form': $ctrl.isUpdating}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink button-round\" type=\"submit\" ng-disabled=\"$ctrl.isUpdating || !$ctrl.isPromoValid()\"\u003ECONTINUER \u003E\u003C\u002Fbutton\u003E\u003Ci ng-if=\"$ctrl.isMobile()\" ng-class=\"{'spinner spinner-form': $ctrl.isUpdating}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


subscriptionTimelineCtrl.$inject = ["DeviceChecker", "ContractDraft", "ErrorCatcher"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _timeline = __webpack_require__(191);

var _timeline2 = _interopRequireDefault(_timeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @ngInject */
function subscriptionTimelineCtrl(DeviceChecker, ContractDraft, ErrorCatcher) {
    var ctrl = this;
    ctrl.isMobile = DeviceChecker.isMobile;
    ctrl.view = {
        name: 'timetable',
        isLoadingTimetable: false,
        timeline: [],
        error: false,
        errorMessage: undefined
    };

    ctrl.update = function () {
        return ctrl.onUpdate();
    };

    ctrl.updateContractDraft = function () {
        return ctrl.onContractDraftUpdate({ value: ctrl.form });
    };

    ctrl.$onChanges = function (changes) {
        var isActive = (0, _get3.default)(changes, 'isActive.currentValue', false) || false;
        if (ctrl.contractDraft.nextBillableDate) {
            ctrl.view.nextBillableDate = (0, _moment2.default)(ctrl.contractDraft.nextBillableDate).add(15, 'day').format('MMMM YYYY').toLowerCase();
        }
        if (isActive) {
            ctrl.view.timeline = [];
            ctrl.view.isLoadingTimetable = true;
            ctrl.view.error = false;
            ctrl.view.errorMessage = undefined;
            var fnGetTimetable = ctrl.contractDraft.estimated_v !== 0 ? 'getTimetableV2' : 'getTimetableV1';

            ContractDraft[fnGetTimetable]().$promise.then(function (values) {
                if ((0, _isEmpty3.default)(values)) {
                    // Continue to next step as there isn't any data to display
                    ctrl.update();
                    ErrorCatcher.catchError({
                        message: 'no timeline data was found for current contract draft',
                        contractDraft: ctrl.contractDraft.id
                    });
                } else {
                    ctrl.view.timeline = (0, _timeline2.default)(values);
                    ctrl.view.isLoadingTimetable = false;
                }
            }).catch(function (error) {
                ErrorCatcher.catchError(error);
                ctrl.view.error = true;
                ctrl.view.errorMessage = error.data.message;
                ctrl.view.isLoadingTimetable = false;
            });
        }
    };
}

exports.default = {
    restrict: 'E',
    bindings: {
        contractDraft: '<',
        isActive: '<',
        isUpdating: '<',
        onUpdate: '&',
        onContractDraftUpdate: '&'
    },
    template: __webpack_require__(1153)(),
    controller: subscriptionTimelineCtrl
};

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"form-body text-center\" ng-if=\"$ctrl.view.isLoadingTimetable\"\u003E\u003Ci class=\"spinner spinner-form\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-body\" ng-if=\"!$ctrl.view.isLoadingTimetable\" ng-submit=\"$ctrl.update()\"\u003E\u003Ch4 class=\"text-left\"\u003EVoici vos mensualités, estimées à partir de l'historique de consommation de votre compteur\u003Cdiv class=\"data-cards text-center\"\u003E\u003Cdiv class=\"cards d-flex justify-content-center align-items-center\"\u003E\u003Cdiv class=\"card\"\u003E\u003Cdiv class=\"price d-flex flex-column justify-content-top align-items-center\"\u003E\u003Cdiv class=\"amount d-flex flex-column justify-content-top align-items-center\"\u003E\u003Ch4 class=\"fw-600\"\u003EMONTANT DES MENSUALITÉS\u003C\u002Fh4\u003E\u003Cdiv class=\"fw-600 d-flex flex-column justify-content-center align-items-center fs-18\"\u003E\u003Cp class=\"centerPrice\"\u003E\u003Cspan\u003E{{ $ctrl.view.timeline[1].sleeked | integer }}\u003C\u002Fspan\u003E\u003Cspan\u003E{{ $ctrl.view.timeline[1].sleeked | decimals }}\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp class=\"recurrencePrice\"\u003Epar mois\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cspan\u003E&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fh4\u003E\u003Ch4 class=\"fw-500\" ng-if=\"$ctrl.view.nextBillableDate\"\u003ELors de votre première facture de\u003Cspan class=\"darkish-pink\"\u003E&nbsp;{{$ctrl.view.nextBillableDate}}\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp;vous serez régularisé pour ne payer que ce que vous avez réellement consommé.\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Ci ng-if=\"!$ctrl.isMobile()\" ng-class=\"{'spinner spinner-form': $ctrl.isUpdating}\"\u003E\u003C\u002Fi\u003E\u003Cbutton class=\"btn background-light-pink button-round\" type=\"submit\" ng-disabled=\"!$ctrl.isActive || $ctrl.isUpdating\"\u003ECONTINUER \u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SubscriptionHelpCtrl =
/** @ngInject */
["ContactTelephone", function SubscriptionHelpCtrl(ContactTelephone) {
    _classCallCheck(this, SubscriptionHelpCtrl);

    this.ContactTelephone = ContactTelephone;
}];

exports.default = {
    template: __webpack_require__(1155)(),
    controller: SubscriptionHelpCtrl,
    bindings: {}
};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"suspended-sign suspended-sign-subscription-help\"\u003E\u003Cdiv class=\"sign-header background-marine\"\u003E\u003Ch5\u003EBesoin d’un\u003Cbr\u003Ecoup de pouce ?\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body text-center\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ca class=\"btn background-none fs-16\" ng-href=\"{{$ctrl.ContactTelephone.anonymous.link}}\" ng-bind=\"$ctrl.ContactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Ftel-plm.svg\" style=\"width: 30%\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center padding-20\"\u003Edu lundi au vendredi, de 09h à 18h\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block visible-sm-block\"\u003E\u003Cdiv class=\"flex flex-space-around flex-align-items background-white\"\u003E\u003Cdiv\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Ftel-plm.svg\" style=\"height: 30px;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch5\u003EBesoin d’un\u003Cbr\u003Ecoup de pouce ?\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv\u003E\u003Ca class=\"btn background-none fs-16\" ng-href=\"{{$ctrl.ContactTelephone.anonymous.link}}\" ng-bind=\"$ctrl.ContactTelephone.anonymous.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-8\"\u003Edu lundi au vendredi, de 09h à 18h\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var subscriptionHelpOffrePrintemps2018Ctrl =
/** @ngInject */
["ContactTelephone", function subscriptionHelpOffrePrintemps2018Ctrl(ContactTelephone) {
    _classCallCheck(this, subscriptionHelpOffrePrintemps2018Ctrl);

    this.ContactTelephone = ContactTelephone;
}];

exports.default = {
    template: __webpack_require__(1157)(),
    controller: subscriptionHelpOffrePrintemps2018Ctrl,
    bindings: {
        contractDraft: '<'
    }
};

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"suspended-sign suspended-sign-subscription-help\"\u003E\u003Cdiv class=\"sign-header background-marine\"\u003E\u003Ch5\u003EOFFRE EXCLUSIVE\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body text-center\"\u003E\u003Cdiv class=\"text-center padding-15\"\u003E\u003Cvideo autoplay loop muted playsinline style=\"width: 100%\"\u003E\u003Csource src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.webm\" type=\"video\u002Fwebm\"\u003E\u003Csource src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.mp4\" type=\"video\u002Fmp4\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.gif\"\u003E\u003C\u002Fvideo\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cspan class=\"fw-500 fs-8 bluegrey\"\u003EEn partenariat avec\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.contractDraft.id_ref_promo === 'PRINTEMPS_2018_SELECTRA'\"\u003E\u003Cobject class=\"padding-15\" data=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FcinqVingtCinq\u002Fselectra-blue.svg\" type=\"image\u002Fsvg+xml\" style=\"width: 100%;\"\u003E\u003C\u002Fobject\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center padding-15\" ng-if=\"$ctrl.contractDraft.id_ref_promo === 'PRINTEMPS_2018_SELECTRA_MVSA'\"\u003E\u003Cimg alt=\"logo mieux vivre votre argent\" src=\"assets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Fmvsa.svg\" style=\"width: 100%;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center padding-15\" ng-if=\"$ctrl.contractDraft.id_ref_promo === 'PRINTEMPS_2018_SELECTRA_SOS_SENIORS'\"\u003E\u003Cimg alt=\"logo groupe sos seniors\" src=\"assets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Fgroupe_sos_seniors.svg\" style=\"width: 100%;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center marg\"\u003E\u003Cp\u003EBesoin d’un coup de pouce ?\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cspan\u003EAppelez-nous au\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Ca class=\"btn background-none fs-16\" target=\"_blank\" ng-href=\"{{$ctrl.ContactTelephone.offrePrintemps2018.link}}\" ng-bind=\"$ctrl.ContactTelephone.offrePrintemps2018.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center padding-20\"\u003Edu lundi au vendredi de 9h à 18h\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block visible-sm-block\"\u003E\u003Cdiv class=\"flex flex-space-around flex-align-items background-white\"\u003E\u003Cdiv\u003E\u003Cvideo autoplay loop muted playsinline style=\"height: 30px;\"\u003E\u003Csource src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.webm\" type=\"video\u002Fwebm\"\u003E\u003Csource src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.mp4\" type=\"video\u002Fmp4\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FachatGroupePrintemps2018\u002Flogo-printemps-2018.gif\"\u003E\u003C\u002Fvideo\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch5\u003EOFFRE EXCLUSIVE\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv\u003E\u003Ca class=\"btn background-none fs-16\" target=\"_blank\" ng-href=\"{{$ctrl.ContactTelephone.offrePrintemps2018.link}}\" ng-bind=\"$ctrl.ContactTelephone.offrePrintemps2018.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-8\"\u003Edu lundi au vendredi de 9h à 18h\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var subscriptionHelpOffreEte2018Ctrl = function () {
    /** @ngInject */
    subscriptionHelpOffreEte2018Ctrl.$inject = ["ContactTelephone"];
    function subscriptionHelpOffreEte2018Ctrl(ContactTelephone) {
        _classCallCheck(this, subscriptionHelpOffreEte2018Ctrl);

        this.ContactTelephone = ContactTelephone;
    }

    _createClass(subscriptionHelpOffreEte2018Ctrl, [{
        key: 'offerContactTelephone',
        value: function offerContactTelephone() {
            var offer = this.contractDraft.utm_campaign === 'offre-ete-selectra' ? 'offreEte2018Selectra' : 'offreEte2018Plum';
            return this.ContactTelephone[offer];
        }
    }]);

    return subscriptionHelpOffreEte2018Ctrl;
}();

exports.default = {
    template: __webpack_require__(1159)(),
    controller: subscriptionHelpOffreEte2018Ctrl,
    bindings: {
        contractDraft: '<'
    }
};

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"suspended-sign suspended-sign-subscription-help\"\u003E\u003Cdiv class=\"sign-header background-marine\"\u003E\u003Ch5\u003EOFFRE EXCLUSIVE\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body text-center\"\u003E\u003Cdiv class=\"text-center padding-15\"\u003E\u003Cimg alt=\"logo offre été 2018\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FoffreEte2018\u002Flogo.png\" style=\"width: 100%;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center marg\"\u003E\u003Cp\u003EBesoin d’un coup de pouce ?\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cspan\u003EAppelez-nous au\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Ca class=\"btn background-none fs-16\" target=\"_blank\" ng-href=\"{{$ctrl.offerContactTelephone().link}}\" ng-bind=\"$ctrl.offerContactTelephone().label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center padding-20\"\u003E{{$ctrl.offerContactTelephone().openingHour}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block visible-sm-block\"\u003E\u003Cdiv class=\"flex flex-space-around flex-align-items background-white\"\u003E\u003Cdiv\u003E\u003Cimg alt=\"logo offre été 2018\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FoffreEte2018\u002Flogo.png\" style=\"height: 30px;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch5\u003EOFFRE EXCLUSIVE\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv\u003E\u003Ca class=\"btn background-none fs-16\" target=\"_blank\" ng-href=\"{{$ctrl.offerContactTelephone().link}}\" ng-bind=\"$ctrl.offerContactTelephone().label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-8\"\u003E{{$ctrl.offerContactTelephone().openingHour}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toLower2 = __webpack_require__(221);

var _toLower3 = _interopRequireDefault(_toLower2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var subscriptionHelpOffreRentree2018Ctrl = function () {
    /** @ngInject */
    subscriptionHelpOffreRentree2018Ctrl.$inject = ["$stateParams", "ContactTelephone"];
    function subscriptionHelpOffreRentree2018Ctrl($stateParams, ContactTelephone) {
        _classCallCheck(this, subscriptionHelpOffreRentree2018Ctrl);

        this.$stateParams = $stateParams;
        this.ContactTelephone = ContactTelephone;
        this.logoMapping = {
            'aix': 'logo-aix.svg',
            'le mans': 'logo-le-mans.svg',
            'montpellier': 'logo-montpellier.svg',
            'nancy': 'logo-nancy.svg',
            'nantes': 'logo-nantes.svg',
            'nice': 'logo-nice.svg',
            'nimes': 'logo-nimes.svg',
            'nîmes': 'logo-nimes.svg',
            'perpignan': 'logo-perpignan.svg',
            'toulon': 'logo-toulon.svg',
            'toulouse': 'logo-toulouse.svg'
        };
    }

    _createClass(subscriptionHelpOffreRentree2018Ctrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.logo = (0, _get3.default)(this.logoMapping, (0, _toLower3.default)(this.$stateParams.ville), 'logo-ag-hcplus.svg');
        }
    }]);

    return subscriptionHelpOffreRentree2018Ctrl;
}();

exports.default = {
    template: __webpack_require__(1161)(),
    controller: subscriptionHelpOffreRentree2018Ctrl,
    bindings: {
        contractDraft: '<'
    }
};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"suspended-sign suspended-sign-subscription-help\"\u003E\u003Cdiv class=\"sign-header background-marine\"\u003E\u003Ch5\u003EOFFRE EXCLUSIVE\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body text-center\"\u003E\u003Cdiv class=\"text-center padding-15\"\u003E\u003Cimg alt=\"logo offre rentrée 2018\" ng-src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FoffreRentree2018\u002F{{$ctrl.logo}}\" style=\"width: 100%;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center marg\"\u003E\u003Cp\u003EBesoin d’un coup de pouce ?\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cspan\u003EAppelez-nous au\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Ca class=\"btn background-none fs-16\" target=\"_blank\" ng-href=\"{{$ctrl.ContactTelephone.offreRentree2018.link}}\" ng-bind=\"$ctrl.ContactTelephone.offreRentree2018.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center padding-lr-20 padding-bottom-20\"\u003E{{$ctrl.ContactTelephone.offreRentree2018.openingHour}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block visible-sm-block\"\u003E\u003Cdiv class=\"flex flex-space-around flex-align-items background-white\"\u003E\u003Cdiv\u003E\u003Cimg alt=\"logo offre rentrée 2018\" ng-src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FoffreRentree2018\u002F{{$ctrl.logo}}\" style=\"height: 30px;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch5\u003EOFFRE EXCLUSIVE\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv\u003E\u003Ca class=\"btn background-none fs-16\" target=\"_blank\" ng-href=\"{{$ctrl.ContactTelephone.offreRentree2018.link}}\" ng-bind=\"$ctrl.ContactTelephone.offreRentree2018.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-8\"\u003E{{$ctrl.ContactTelephone.offreRentree2018.openingHour}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toLower2 = __webpack_require__(221);

var _toLower3 = _interopRequireDefault(_toLower2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var subscriptionHelpOffreAutomne2018Ctrl = function () {
    /** @ngInject */
    subscriptionHelpOffreAutomne2018Ctrl.$inject = ["$stateParams", "ContactTelephone"];
    function subscriptionHelpOffreAutomne2018Ctrl($stateParams, ContactTelephone) {
        _classCallCheck(this, subscriptionHelpOffreAutomne2018Ctrl);

        this.$stateParams = $stateParams;
        this.ContactTelephone = ContactTelephone;
        this.logoMapping = {
            famille: 'famille.png',
            selectra: 'selectra.png'
        };
    }

    _createClass(subscriptionHelpOffreAutomne2018Ctrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.logo = (0, _get3.default)(this.logoMapping, (0, _toLower3.default)(this.$stateParams.id_presta), 'selectra.png');
        }
    }]);

    return subscriptionHelpOffreAutomne2018Ctrl;
}();

exports.default = {
    template: __webpack_require__(1163)(),
    controller: subscriptionHelpOffreAutomne2018Ctrl,
    bindings: {
        contractDraft: '<'
    }
};

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"suspended-sign suspended-sign-subscription-help\"\u003E\u003Cdiv class=\"sign-header background-marine\"\u003E\u003Ch5\u003EOFFRE EXCLUSIVE\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sign-body-wrapper\"\u003E\u003Cdiv class=\"sign-body text-center\"\u003E\u003Cdiv class=\"text-center padding-15\"\u003E\u003Cimg alt=\"logo offre rentrée 2018\" ng-src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FoffreAutomne2018\u002F{{$ctrl.logo}}\" style=\"width: 100%;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center marg\"\u003E\u003Cp\u003EBesoin d’un coup de pouce ?\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Cspan\u003EAppelez-nous au\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Ca class=\"btn background-none fs-16\" target=\"_blank\" ng-href=\"{{$ctrl.ContactTelephone.offreAutomne2018.link}}\" ng-bind=\"$ctrl.ContactTelephone.offreAutomne2018.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center padding-lr-20 padding-bottom-20\"\u003E{{$ctrl.ContactTelephone.offreAutomne2018.openingHour}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visible-xs-block visible-sm-block\"\u003E\u003Cdiv class=\"flex flex-space-around flex-align-items background-white\"\u003E\u003Cdiv\u003E\u003Cimg alt=\"logo offre rentrée 2018\" ng-src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FoffreAutomne2018\u002F{{$ctrl.logo}}\" style=\"height: 30px;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch5\u003EOFFRE EXCLUSIVE\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv\u003E\u003Ca class=\"btn background-none fs-16\" target=\"_blank\" ng-href=\"{{$ctrl.ContactTelephone.offreAutomne2018.link}}\" ng-bind=\"$ctrl.ContactTelephone.offreAutomne2018.label\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fs-8\"\u003E{{$ctrl.ContactTelephone.offreAutomne2018.openingHour}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FindPdlHelperCtrl = function () {
    /** @ngInject */
    FindPdlHelperCtrl.$inject = ["gaEventsService", "ContactTelephone"];
    function FindPdlHelperCtrl(gaEventsService, ContactTelephone) {
        _classCallCheck(this, FindPdlHelperCtrl);

        this.gaEventsService = gaEventsService;
        this.ContactTelephone = ContactTelephone;
        this.detailState = 'EDF';
        this.displayDetailEDF = false;
        this.displayDetailDirectEnergie = false;
    }

    _createClass(FindPdlHelperCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.gaEventsService.newEvent('open modal - Comment trouver mon point de livraison ?');
            this.filter = {
                offerType: 'BASE',
                power: 6,
                availablePowers: this.resolve.partnerOffer
            };
        }
    }, {
        key: 'toggleDetailEDF',
        value: function toggleDetailEDF() {
            this.displayDetailEDF = !this.displayDetailEDF;
        }
    }, {
        key: 'toggleDetailDirectEnergie',
        value: function toggleDetailDirectEnergie() {
            this.displayDetailDirectEnergie = !this.displayDetailDirectEnergie;
        }
    }]);

    return FindPdlHelperCtrl;
}();

exports.default = {
    template: __webpack_require__(1165)(),
    controller: FindPdlHelperCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-whitegrey\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"flex-row\"\u003E\u003Cdiv class=\"flex-col-sm-7 background-white border-left-radius-3\"\u003E\u003Cdiv class=\"padding-20 padding-top-40\"\u003E\u003Cp class=\"margin-bottom-20 fs-22 fw-600 marine\"\u003EComment trouver mon point de livraison ?\u003C\u002Fp\u003E\u003Cp class=\"no-margin fw-600\"\u003ECe numéro à 14 chiffres est présent sur toutes vos anciennes facture d’électricité.\u003C\u002Fp\u003E\u003Cp class=\"margin-bottom-20 fs-12\"\u003EParfois nommé « Point de comptage, PRM, PDL... », il sert à identifier précisément votre compteur d’électricité.\u003C\u002Fp\u003E\u003Clabel class=\"clickable\"\u003E\u003Cinput type=\"radio\" name=\"provider\" value=\"Linky\" ng-model=\"$ctrl.detailState\"\u003E\nJ’ai déjà un compteur Linky !\u003C\u002Flabel\u003E\u003Cp class=\"margin-tb-20 fw-600\"\u003ESinon, quel est votre fournisseur d’électricité actuel ?\u003C\u002Fp\u003E\u003Cdiv class=\"flex-sm flex-space-around\"\u003E\u003Cdiv\u003E\u003Clabel class=\"text-center clickable\"\u003E\u003Cspan class=\"hidden-xs\"\u003EEDF\u003Cbr\u003E\u003C\u002Fspan\u003E\u003Cinput type=\"radio\" name=\"provider\" value=\"EDF\" ng-model=\"$ctrl.detailState\"\u003E\u003Cspan class=\"visible-xs-inline\"\u003E\nEDF\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel class=\"text-center clickable\"\u003E\u003Cspan class=\"hidden-xs\"\u003EEngie\u003Cbr\u003E\u003C\u002Fspan\u003E\u003Cinput type=\"radio\" name=\"provider\" value=\"Engie\" ng-model=\"$ctrl.detailState\"\u003E\u003Cspan class=\"visible-xs-inline\"\u003E\nEngie\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel class=\"text-center clickable\"\u003E\u003Cspan class=\"hidden-xs\"\u003EDirect Energie\u003Cbr\u003E\u003C\u002Fspan\u003E\u003Cinput type=\"radio\" name=\"provider\" value=\"Direct Energie\" ng-model=\"$ctrl.detailState\"\u003E\u003Cspan class=\"visible-xs-inline\"\u003E\nDirect Energie\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel class=\"text-center clickable\"\u003E\u003Cspan class=\"hidden-xs\"\u003EAutre\u003Cbr\u003E\u003C\u002Fspan\u003E\u003Cinput type=\"radio\" name=\"provider\" value=\"Autre\" ng-model=\"$ctrl.detailState\"\u003E\u003Cspan class=\"visible-xs-inline\"\u003E\nAutre\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel class=\"text-center clickable\"\u003E\u003Cspan class=\"hidden-xs\"\u003EAucun, j’emménage\u003Cbr\u003E\u003C\u002Fspan\u003E\u003Cinput type=\"radio\" name=\"provider\" value=\"Aucun, j’emménage\" ng-model=\"$ctrl.detailState\"\u003E\u003Cspan class=\"visible-xs-inline\"\u003E\nAucun, j’emménage\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-col-sm-5 marine background-whitegrey border-right-radius-3\"\u003E\u003Cdiv class=\"padding-20 padding-top-40 fw-400\"\u003E\u003Cdiv class=\"text-center\" ng-if=\"!$ctrl.detailState\"\u003E\u003Cp\u003ESelectionner une offre pour voir comment trouver votre numéro de Point de Livraison\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.detailState === 'Linky'\"\u003E\u003Cp class=\"margin-bottom-20 fs-22 fw-600 marine\"\u003EAvec Linky, le point de livraison est accessible directement !\u003C\u002Fp\u003E\u003Cp class=\"margin-bottom-20\"\u003EFaites défiler les écrans de votre compteur grâce à la touche « + »\u003C\u002Fp\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FfindPdlHelper\u002Fnumprmlinky.png\" alt=\"Compteur Linky\"\u003E\u003Cp\u003E(écran « Numéro de PRM »)\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.detailState === 'EDF'\"\u003E\u003Cp\u003ESur une facture EDF,\u003Cbr\u003Eil est situé en bas de la colonne de gauche,\u003Cbr\u003Erubrique « Votre Contrat »\u003C\u002Fp\u003E\u003Cdiv class=\"clickable\" ng-click=\"$ctrl.toggleDetailEDF()\"\u003E\u003Cimg ng-show=\"!$ctrl.displayDetailEDF\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FfindPdlHelper\u002Fedf-initial.gif\" alt=\"Example Facture EDF\"\u003E\u003Cimg ng-show=\"$ctrl.displayDetailEDF\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FfindPdlHelper\u002Fedf-zoom-in.gif\" alt=\"Example Facture EDF détaillé\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.detailState === 'Engie'\"\u003E\u003Cp\u003ESur une facture Engie\u003C\u002Fp\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FfindPdlHelper\u002Fengie-initial.gif\" alt=\"Compteur Linky\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.detailState === 'Direct Energie'\"\u003E\u003Cp\u003ESur une facture Direct Energie\u003C\u002Fp\u003E\u003Cdiv class=\"clickable\" ng-click=\"$ctrl.toggleDetailDirectEnergie()\"\u003E\u003Cimg ng-show=\"!$ctrl.displayDetailDirectEnergie\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FfindPdlHelper\u002Fdirect-energie-initial.gif\" alt=\"Example facture Direct Energie\"\u003E\u003Cimg ng-show=\"$ctrl.displayDetailDirectEnergie\" src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FfindPdlHelper\u002Fdirect-energie-zoom-in.gif\" alt=\"Example facture Direct Energie détaillé\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.detailState === 'Autre'\"\u003E\u003Cp\u003ESur une facture d’un autre fournisseur\u003C\u002Fp\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002FfindPdlHelper\u002Fautre-fournisseur.gif\" alt=\"Example Autre Fournisseur\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.detailState === 'Aucun, j’emménage'\"\u003E\u003Cp class=\"margin-tb-20 fs-22 fw-600 marine\"\u003ECherchons ensemble votre point de livraison !\u003C\u002Fp\u003E\u003Cp class=\"fw-600\"\u003EIl suffit de nous contacter au\u003C\u002Fp\u003E\u003Cp class=\"margin-bottom-20 fs-30 fw-600 dark-pink\"\u003E{{$ctrl.ContactTelephone.client.label}}\u003C\u002Fp\u003E\u003Cp class=\"margin-bottom-20\"\u003Edu lundi au vendredi, de 9h à 18h\u003Cbr\u003Eprix d’un appel local\u003C\u002Fp\u003E\u003Cp class=\"margin-tb-20 fs-22 fw-600 marine\"\u003EPenser à préparer\u003C\u002Fp\u003E\u003Cdiv class=\"text-left\"\u003E\u003Cul class=\"fa-ul\"\u003E\u003Cli\u003E\u003Ci class=\"fa-li fa fa-check dark-green\"\u003E\u003C\u002Fi\u003EL’adresse précise du logement\u003C\u002Fli\u003E\u003Cli\u003E\u003Ci class=\"fa-li fa fa-check dark-green\"\u003E\u003C\u002Fi\u003ELe nom et prénom de l’ancien occupant du logement, ou le numéro de série du compteur\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: __webpack_require__(1167)(),
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal\" ng-click=\"$ctrl.close({$value: {bypassReadings: false}})\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"text-center padding-tb-20\"\u003E\u003Ch3 class=\"light-pink\"\u003EAttention\u003C\u002Fh3\u003E\u003Cp\u003EPensez à nous transmettre votre relève de compteur.\u003C\u002Fp\u003E\u003Cp\u003ESans elle, votre contrat restera inactif.\u003C\u002Fp\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.close({$value: {bypassReadings: true}})\"\u003EJ’AI COMPRIS\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: __webpack_require__(1169)(),
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&' // {$value: myRejectedResult}
    }
};

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal\" ng-click=\"$ctrl.close({$value: {switchToStandardOffer: false}})\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"text-center padding-20\"\u003E\u003Ch3 class=\"light-pink\"\u003EOups\u003C\u002Fh3\u003E\u003Cp\u003ECette offre est réservée aux clients avec l’option tarifaire heures pleines \u002F heures creuses !\u003C\u002Fp\u003E\u003Cp\u003EPas de panique, on vous propose de profiter de notre offre cagnotte,\u003Cbr\u003Etoujours moins chère que les tarifs réglementés de vente.\u003C\u002Fp\u003E\u003Cp\u003EÉconomie garantie !\u003C\u002Fp\u003E\u003Cbutton class=\"hidden-xs btn background-light-pink\" ng-click=\"$ctrl.close({$value: {switchToStandardOffer: true}})\"\u003EJE PROFITE DE L’OFFRE CAGNOTTE PLUM\u003C\u002Fbutton\u003E\u003Cbutton class=\"visible-xs-block btn background-light-pink\" ng-click=\"$ctrl.close({$value: {switchToStandardOffer: true}})\"\u003EJE PROFITE\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


landscapeConfirmModalCtrl.$inject = ["$scope", "$uibModalInstance"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = landscapeConfirmModalCtrl;

/** @ngInject */

function landscapeConfirmModalCtrl($scope, $uibModalInstance) {
    $scope.close = $uibModalInstance.close;
    $scope.dismiss = $uibModalInstance.dismiss;
}

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


landscapeModalCtrl.$inject = ["$scope", "$uibModalInstance", "landscapeQuestions", "idContract", "isEdition"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = landscapeModalCtrl;

/** @ngInject */

function landscapeModalCtrl($scope, $uibModalInstance, landscapeQuestions, idContract, isEdition) {
    $scope.contract = { id: idContract, isDraft: true };
    $scope.landscapeQuestions = landscapeQuestions;
    $scope.popupInstance = $uibModalInstance;
    $scope.isEdition = isEdition.edition;
    $scope.isNew = isEdition.new;

    $scope.close = function () {
        var landCanvas = document.getElementById('landscape-canvas');
        $uibModalInstance.close({ canvas: landCanvas });
    };
}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


subscriptionContactUnknownPRMCtrl.$inject = ["$scope", "$uibModalInstance", "DeviceChecker", "Contact", "gaEventsService", "ErrorCatcher", "MailAdresses", "email", "phone"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = subscriptionContactUnknownPRMCtrl;

/** @ngInject */

function subscriptionContactUnknownPRMCtrl($scope, $uibModalInstance, DeviceChecker, Contact, gaEventsService, ErrorCatcher, MailAdresses, email, phone) {
    var RECONTACT_MSG = '\n\n[AUTOMATIQUE] Je souhaite être rappelé afin de terminer ma souscription par téléphone.';
    $scope.gaEventsService = gaEventsService;
    $scope.mailAdresse = MailAdresses;
    $scope.form = {
        api: {},
        isSending: false,
        isContactSent: false,
        canRecontact: false,
        minDate: new Date(),
        error: {
            hasError: false,
            message: ''
        },
        model: {
            type: 'task',
            subject: 'Numéro de point de livraison inconnu',
            dueDate: new Date().toISOString(),
            email: email,
            phone: phone,
            postalAddress: undefined,
            previousOccupant: undefined,
            serial: undefined,
            body: undefined
        }
    };

    $scope.close = function (evnt) {
        return $uibModalInstance.dismiss();
    };

    $scope.isMobile = DeviceChecker.isMobile;

    $scope.sendMessage = function (form) {
        form.api.$setSubmitted();
        if (form.api.$invalid) {
            return;
        }

        form.isSending = true;
        Contact.sendMessage({}, (0, _assign3.default)({}, form.model, { body: form.model.body + RECONTACT_MSG })).$promise.then(function () {
            form.isContactSent = true;
        }).catch(function (error) {
            form.error.hasError = true;
            form.error.message = error.data.message;
            return ErrorCatcher.catchError(error);
        }).finally(function () {
            form.isSending = false;
        });
    };
}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


subscriptionCtrl.$inject = ["$scope", "$state", "$window", "$rootScope", "$uibModal", "$timeout", "$stateParams", "ContractDraft", "Contract", "MetterKind", "MailAdresses", "DeviceChecker", "ReferencesService", "User", "Contact", "MobilePhone", "CommonRegex", "contractDraft", "DataAccessVariables", "ContactTelephone", "featuresService", "LandscapeQuestions", "ErrorCatcher", "PrmUtilsService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign2 = __webpack_require__(20);

var _assign3 = _interopRequireDefault(_assign2);

var _defaultTo2 = __webpack_require__(71);

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

var _find2 = __webpack_require__(192);

var _find3 = _interopRequireDefault(_find2);

var _isBoolean2 = __webpack_require__(292);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _isEmpty2 = __webpack_require__(14);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _map2 = __webpack_require__(53);

var _map3 = _interopRequireDefault(_map2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = subscriptionCtrl;

/** @ngInject */

function subscriptionCtrl($scope, $state, $window, $rootScope, $uibModal, $timeout, $stateParams, ContractDraft, Contract, MetterKind, MailAdresses, DeviceChecker, ReferencesService, User, Contact, MobilePhone, CommonRegex, contractDraft, DataAccessVariables, ContactTelephone, featuresService, LandscapeQuestions, ErrorCatcher, PrmUtilsService) {
    var DEFAULT_PROMO_OK_MSG = 'Code promotionnel valide.';
    var SUBSCRIPTION_TYPE = {
        emmenagement: 'emmenagement',
        changementFournisseur: 'changementfournisseur',
        subscriptionEmmenagement: 'subscriptionEmmenagement',
        subscriptionChangementFournisseur: 'subscriptionChangementFournisseur'
    };
    var PDL_SUBSCRIPTION_TYPE = {
        CDF: 'CDF', // changement de fournisseur
        CDF_INTER: 'CDF_INTER', // changement de fournisseur avec intervention
        MES: 'MES', // mise en service sans intervention
        MES_INTER: 'MES_INTER', // mise en service intervention
        FIRST_MES: 'FIRST_MES' // premiere mise en service
    };
    var commonMESTarifs = function commonMESTarifs(meter_kind) {
        var MESPrices = [{ label: 'Normale', id: 'NORMAL', delay: 5, price: '21,23' }, { label: 'Express', id: 'EXPRESS', delay: 2, price: '58,57' }];
        if (PrmUtilsService.isLinky(meter_kind)) {
            MESPrices.push({ label: 'Jour même', id: 'TODAY', delay: 1, price: '72,90' });
        } else {
            MESPrices.push({ label: 'Jour même', id: 'TODAY', delay: 1, price: '150,39' });
        }
        return MESPrices;
    };
    var MESWithoutInterTariff = function MESWithoutInterTariff() {
        return [{ label: 'Normale', id: 'NORMAL', delay: 5, price: '21,23' }];
    };
    var firstMESTariff = function firstMESTariff(meter_kind) {
        var MESPrices = [{ label: 'Normale', id: 'NORMAL', delay: 10, price: '49,31' }, { label: 'Express', id: 'EXPRESS', delay: 5, price: '86.65' }];
        if (PrmUtilsService.isLinky(meter_kind)) {
            MESPrices.push({ label: 'Jour même', id: 'TODAY', delay: 1, price: '100,98' });
        } else {
            MESPrices.push({ label: 'Jour même', id: 'TODAY', delay: 1, price: '178,47' });
        }
        return MESPrices;
    };
    var MESTariffs = {
        CDF: commonMESTarifs,
        CDF_INTER: commonMESTarifs,
        MES: MESWithoutInterTariff,
        MES_INTER: commonMESTarifs,
        FIRST_MES: firstMESTariff
    };

    $scope.subscriptionType = SUBSCRIPTION_TYPE.changementFournisseur;

    var $controllerScope = $scope;
    $scope.$stateParams = $stateParams;
    $scope.nameRegex = CommonRegex.fullname;
    $scope.phoneRegex = MobilePhone.phoneRegex.all;
    $scope.isPartnerSubscription = $state.$current.data.isPartnerSubscription;
    $scope.partnerOffer = $state.$current.data.partnerOffer;
    $scope.currentInput = null;
    $scope.contractDraft = {};
    $scope.reading = {};
    $scope.pdlResponse = null;
    $scope.showSpinner = false;
    $scope.isUpdating = false;
    $scope.isPRMEligible = false;
    $scope.displaySubscriptionHelp = false;
    $scope.MetterKind = MetterKind;
    $scope.MailAdresses = MailAdresses;
    $scope.sponsorValidation = {
        errorMessage: null,
        isValid: true,
        isChecking: false
    };
    $scope.promoValidation = {
        errorMessage: null,
        isValid: true,
        isChecking: false
    };
    $scope.isMobile = DeviceChecker.isMobile;
    $scope.showSponsor = !contractDraft.already_has_sponsor && localStorage.sponsorId !== undefined && localStorage.sponsorId !== '';
    $scope.birth_date_day = (0, _moment2.default)(contractDraft.birth_date).isValid() ? (0, _moment2.default)(contractDraft.birth_date).format('DD') : undefined;
    $scope.birth_date_month = (0, _moment2.default)(contractDraft.birth_date).isValid() ? (0, _moment2.default)(contractDraft.birth_date).format('MM') : undefined;
    $scope.birth_date_year = (0, _moment2.default)(contractDraft.birth_date).isValid() ? (0, _moment2.default)(contractDraft.birth_date).format('YYYY') : undefined;
    $scope.phone = contractDraft.phone;
    $scope.contactTelephone = ContactTelephone.anonymous;
    $scope.allContactTelephone = ContactTelephone;
    $scope.enableVerify = true;

    // MES + FIRST_MES
    $scope.calendarIds = undefined;
    $scope.powers = undefined;
    var availablePowers = void 0;

    var setContractDraft = function setContractDraft(contractDraft) {
        $scope.contractDraft = {
            id: contractDraft.id,
            id_prm: contractDraft.id_prm,
            civ: contractDraft.civ,
            sn: contractDraft.sn,
            givenname: contractDraft.givenname,
            mail: contractDraft.mail,
            accept_contacts: contractDraft.accept_contacts,
            heating: contractDraft.heating,
            birth_date: (0, _moment2.default)(contractDraft.birth_date).isValid() ? (0, _moment2.default)(contractDraft.birth_date).format('YYYY-MM-DD') : undefined,
            sponsor_id: contractDraft.sponsor_id || localStorage.sponsorId,
            id_ref_promo: contractDraft.id_ref_promo || localStorage.promoId,
            is_a_move: SUBSCRIPTION_TYPE.emmenagement === $scope.subscriptionType,
            choosen_mes_type: contractDraft.choosen_mes_type,
            consuel: contractDraft.consuel,
            ready_to_checkout: contractDraft.ready_to_checkout,
            sleek_timetable: contractDraft.sleek_timetable,
            primary_residence: contractDraft.primary_residence,
            phone: contractDraft.phone,
            utm_source: contractDraft.utm_source,
            utm_medium: contractDraft.utm_medium,
            utm_campaign: contractDraft.utm_campaign,
            estimated_v: contractDraft.estimated_v,
            nextBillableDate: contractDraft.nextBillableDate,
            switchReadings: {
                base: __guard__(contractDraft.switchReadings.filter(function (reading) {
                    return reading.dial === 'Base';
                })[0], function (x) {
                    return x.value;
                }),
                hp: __guard__(contractDraft.switchReadings.filter(function (reading) {
                    return reading.dial === 'Heures Pleines';
                })[0], function (x1) {
                    return x1.value;
                }),
                hc: __guard__(contractDraft.switchReadings.filter(function (reading) {
                    return reading.dial === 'Heures Creuses';
                })[0], function (x2) {
                    return x2.value;
                })
            }
        };
    };

    setContractDraft(contractDraft);

    $scope.cards = [{
        id: 1,
        image: 'img-changer-fournisseur',
        description: 'Je change de fournisseur pour mon logement actuel',
        type: SUBSCRIPTION_TYPE.changementFournisseur
    }, {
        id: 2,
        image: 'img-contrat-nouveau-logement',
        description: 'J’ouvre un contrat pour mon nouveau logement',
        type: SUBSCRIPTION_TYPE.emmenagement
    }];
    $scope.items = {};
    $scope.items[SUBSCRIPTION_TYPE.changementFournisseur] = {
        title: 'Changer de fournisseur d’énergie, c’est simple et gratuit !',
        description: 'Une fois votre commande terminée, nous nous occuperons de résilier votre contrat chez votre ancien fournisseur.'
    };
    $scope.items[SUBSCRIPTION_TYPE.emmenagement] = {
        title: 'Merci d’avoir choisi Plüm énergie !',
        description: 'Nous allons créer ensemble le dossier pour ouvrir votre contrat d’électricité.'
    };

    $scope.process = [{
        name: 'situation',
        isActive: true,
        isUpdating: false,
        error: false,
        errorMessage: undefined,
        changeType: function changeType(type) {
            $scope.subscriptionType = type;
        },
        getSituationClass: function getSituationClass(type) {
            return $scope.subscriptionType === type ? 'active' : 'inactive';
        },
        validate: function validate() {
            $scope.contractDraft.is_a_move = SUBSCRIPTION_TYPE.emmenagement === $scope.subscriptionType;
            $scope.goToNextProcess(this);
        }
    }, {
        name: 'identity',
        isActive: false,
        isUpdating: false,
        error: false,
        errorMessage: undefined,
        initSponsorFee: function initSponsorFee() {
            return DataAccessVariables.get({ variables: 'SPONSOR_FEE,SPONSORED_FEE' }).$promise.then(function (variables) {
                if (variables.SPONSOR_FEE === variables.SPONSORED_FEE) {
                    $scope.sponsorOkMessage = 'Une fois votre commande termin\xE9e et votre compteur activ\xE9, vous et votre parrain serez cr\xE9dit\xE9s de ' + variables.SPONSORED_FEE + '\u20AC.';
                }
                $scope.sponsorOkMessage = 'Une fois votre commande termin\xE9e et votre compteur activ\xE9, vous et votre parrain serez cr\xE9dit\xE9s respectivement de ' + variables.SPONSOR_FEE + '\u20AC et ' + variables.SPONSORED_FEE + '\u20AC.';
            }).catch(function (error) {
                $scope.sponsorOkMessage = 'Vous et votre parrain serez crédités une fois votre commande terminée et votre compteur activé.';
                return ErrorCatcher.catchError(error);
            });
        },
        initAvailablePower: function initAvailablePower() {
            return ReferencesService.getRefPromise('ot-ps').then(function (result) {
                availablePowers = result.toJSON();
                $scope.calendarIds = [{
                    id: null,
                    label: '-- Choisissez --'
                }].concat((0, _map3.default)(availablePowers, function (v, k) {
                    return { id: k, label: v.label };
                }));
            }).catch(ErrorCatcher.catchError);
        },
        checkSponsor: function checkSponsor() {
            if ((0, _get3.default)($scope, 'contractDraft.sponsor_id.length') === 9) {
                $scope.sponsorValidation = { errorMessage: null, isValid: false, isChecking: true };
                return ContractDraft.checkSponsor({ sponsor_id: $scope.contractDraft.sponsor_id }).$promise.then(function () {
                    $scope.sponsorValidation = { errorMessage: null, isValid: true, isChecking: false };
                }).catch(function (error) {
                    var DEFAULT_ERROR_MSG = 'Une erreur est survenue, merci de vérifier le numéro client de votre parrain';
                    var errorMessage = error.status === 400 ? error.data.message : DEFAULT_ERROR_MSG;
                    $scope.sponsorValidation = { errorMessage: errorMessage, isValid: false, isChecking: false };
                    return ErrorCatcher.catchError(error);
                });
            } else if ((0, _isEmpty3.default)($scope.contractDraft.sponsor_id) || $scope.contractDraft.sponsor_id.length === 0) {
                $scope.sponsorValidation = { errorMessage: null, isValid: true, isChecking: false };
            } else {
                $scope.sponsorValidation = {
                    errorMessage: 'Format : CLxxxxxxx (CL et 7 caractères)',
                    isValid: false,
                    isChecking: false
                };
            }
        },
        checkPromo: function checkPromo(softCheck) {
            if ((0, _get3.default)($scope, 'contractDraft.id_ref_promo.length', 0) > 0) {
                $scope.promoValidation = { message: null, errorMessage: null, isValid: false, isChecking: true };
                return ContractDraft.checkPromo({ promo: $scope.contractDraft.id_ref_promo, soft: softCheck }).$promise.then(function (result) {
                    var message = result.label_fr || DEFAULT_PROMO_OK_MSG;
                    return $scope.promoValidation = { message: message, errorMessage: null, isValid: true, isChecking: false };
                }).catch(function (error) {
                    var DEFAULT_ERROR_MSG = 'Une erreur est survenue, merci de vérifier votre code promotionnel';
                    var errorMessage = error.status === 400 ? error.data.message : DEFAULT_ERROR_MSG;
                    $scope.promoValidation = { message: null, errorMessage: errorMessage, isValid: false, isChecking: false };
                    return ErrorCatcher.catchError(error);
                });
            }
            $scope.promoValidation = { message: null, errorMessage: null, isValid: true, isChecking: false };
        },
        isSponsorValid: function isSponsorValid() {
            return $scope.sponsorValidation.isValid;
        },
        isPromoValid: function isPromoValid() {
            return $scope.promoValidation.isValid;
        },
        updateBirthDate: function updateBirthDate() {
            var birthdate = (0, _moment2.default)({ years: $scope.birth_date_year, months: $scope.birth_date_month - 1, day: $scope.birth_date_day });
            $scope.contractDraft.birth_date = birthdate.isValid() ? birthdate.format('YYYY-MM-DD') : undefined;
            $scope.birthDateError = (0, _isEmpty3.default)($scope.birth_date_year) || (0, _isEmpty3.default)($scope.birth_date_month) || (0, _isEmpty3.default)($scope.birth_date_day) || !birthdate.isValid();
        },
        updateMobilePhone: function updateMobilePhone() {
            $scope.contractDraft.phone = !(0, _isEmpty3.default)($scope.phone) ? MobilePhone.formatPhoneToPlus33($scope.phone) : undefined;
        }
    }, {
        name: 'pdl',
        isActive: false,
        isUpdating: false,
        isVerifying: false,
        error: false,
        errorMessage: undefined,
        authorizationToVerify: false,
        onStateActive: function onStateActive() {
            var DISPLAY_HELP_DELAY = 15000;
            $timeout(function () {
                if ($scope.pdlResponse === null) {
                    $scope.displaySubscriptionHelp = true;
                }
            }, DISPLAY_HELP_DELAY);
        },
        verify: function verify(currentStep) {
            var updateMESTariff = function updateMESTariff(pdlResponse) {
                $scope.MESTariff = MESTariffs[pdlResponse.subscriptionType](pdlResponse.metter.kind);
                $scope.contractDraft.choosen_mes_type = $scope.MESTariff[0].id;
                $scope.choosenMESTariff = $scope.MESTariff[0];
            };

            var openPDLDisabledModal = function openPDLDisabledModal() {
                $uibModal.open({
                    animation: true,
                    size: 'lg',
                    template: __webpack_require__(1174)(),
                    controller: ["$scope", "$uibModalInstance", "ContactTelephone", function controller($scope, $uibModalInstance, ContactTelephone) {
                        $scope.close = $uibModalInstance.dismiss;
                        $scope.contactTelephone = ContactTelephone.anonymous;
                        $scope.resetPDL = function () {
                            $scope.close();
                            $controllerScope.isPRMEligible = false;
                            $controllerScope.pdlResponse = null;
                        };
                        $scope.confirmToEmmenagement = function () {
                            $scope.close();
                            if (!$controllerScope.isPartnerSubscription) {
                                $state.transitionTo('subscriptionEmmenagement', { notify: false });
                            }
                            $controllerScope.contractDraft.is_a_move = true;
                            $controllerScope.subscriptionType = SUBSCRIPTION_TYPE.emmenagement;
                        };
                    }]
                });
            };

            var openSubscriptionSwitchStandardOffer = function openSubscriptionSwitchStandardOffer() {
                $uibModal.open({
                    animation: true,
                    size: 'lg',
                    component: 'subscriptionSwitchStandardOffer'
                }).result.then(function (result) {
                    if (result.switchToStandardOffer) {
                        ContractDraft.modifyDraftOffer({ provider_offer: 'STANDARD' }, {}).$promise.then(function () {
                            $state.go('subscription');
                        }).catch(function (error) {
                            if (!error.message === 'transition prevented') {
                                ErrorCatcher.catchErrorWithoutRedirect(error);
                            }
                        });
                    }
                });
            };

            $scope.isPRMEligible = false;
            $scope.pdlResponse = null;
            $scope.contractDraft.choosen_max_power = null;
            $scope.contractDraft.choosen_id_p_calendar = null;
            var currentStepIndex = $scope.getCurrentProcessIndex();
            $scope.process[currentStepIndex].error = false;
            var formatErrorMessage = 'Le numéro de point de livraison que vous avez renseigné ne semble pas correct. Vérifiez bien les 14 chiffres sur votre facture d’électricité.';
            if ($scope.contractDraft.id_prm) {
                if (!currentStep.authorizationToVerify) {
                    $scope.enableVerify = false;
                    return;
                }
                $scope.enableVerify = true;
                currentStep.isVerifying = true;
                return ContractDraft.verify({
                    id: $scope.contractDraft.id_prm,
                    id_contract: $scope.contractDraft.id,
                    consent: true
                }).$promise.then(function (PDLResponse) {
                    if (PDLResponse.eligible) {
                        $scope.isPRMEligible = true;
                        $scope.pdlResponse = PDLResponse;
                        updateMESTariff(PDLResponse);
                        $scope.updateChoosenCalendarId();
                        if ($scope.subscriptionType === SUBSCRIPTION_TYPE.changementFournisseur && $scope.pdlResponse.terminated) {
                            return openPDLDisabledModal();
                        }
                        if (['offreRentree2018', 'offreAutomne2018'].indexOf($scope.partnerOffer) > -1 && (0, _get3.default)($scope.pdlResponse, 'plan.id_p_calendar') === 'BASE') {
                            return openSubscriptionSwitchStandardOffer();
                        }
                    } else {
                        $scope.process[currentStepIndex].error = true;
                        $scope.process[currentStepIndex].errorMessage = PDLResponse.message;
                    }
                }).catch(function (error) {
                    var errorMessage = error.status !== 400 ? undefined : formatErrorMessage;
                    $scope.process[currentStepIndex].error = true;
                    $scope.process[currentStepIndex].errorMessage = errorMessage;
                    $scope.sendEnedisDownMessage();
                    return ErrorCatcher.catchError(error);
                }).finally(function () {
                    currentStep.isVerifying = false;
                });
            }
            $scope.process[currentStepIndex].error = true;
            $scope.process[currentStepIndex].errorMessage = formatErrorMessage;
        },
        validate: function validate() {
            var currentStep = this;
            contractDraft = $scope.contractDraft;

            var updateCurrentStep = function updateCurrentStep() {
                return $scope.update(currentStep);
            };
            var openAreYouSureModal = function openAreYouSureModal() {
                return $uibModal.open({
                    animation: true,
                    size: 'lg',
                    template: __webpack_require__(1175)(),
                    controller: ["$scope", "$uibModalInstance", "ContactTelephone", function controller($scope, $uibModalInstance, ContactTelephone) {
                        $scope.close = $uibModalInstance.dismiss;
                        $scope.contactTelephone = ContactTelephone.anonymous;
                        $scope.confirm = function () {
                            $scope.close();
                            return updateCurrentStep();
                        };
                    }]
                });
            };
            if ($scope.subscriptionType === SUBSCRIPTION_TYPE.emmenagement && !$scope.pdlResponse.terminated) {
                return openAreYouSureModal();
            }
            return updateCurrentStep();
        },
        canGoOnPRM: function canGoOnPRM() {
            var isMaxPower = Boolean($scope.pdlResponse.power.max || $scope.contractDraft.choosen_max_power);
            var hasPlan = Boolean($scope.pdlResponse.plan || $scope.contractDraft.choosen_id_p_calendar);
            if ($scope.pdlResponse.subscriptionType === 'FIRST_MES') {
                var isConsuelDefinedOnFirstMES = (0, _isBoolean3.default)($scope.contractDraft.consuel);
                return isMaxPower && hasPlan && isConsuelDefinedOnFirstMES;
            }
            return isMaxPower && hasPlan;
        },
        updateChoosenMESTariff: function updateChoosenMESTariff() {
            $scope.choosenMESTariff = (0, _find3.default)($scope.MESTariff, { id: $scope.contractDraft.choosen_mes_type });
        },
        openContactFormUnknownPDL: function openContactFormUnknownPDL() {
            return $uibModal.open({
                animation: true,
                size: 'lg',
                template: __webpack_require__(1176)(),
                controller: 'subscriptionContactUnknownPRMCtrl',
                resolve: {
                    email: function email() {
                        return $scope.contractDraft.mail;
                    },
                    phone: function phone() {
                        return $scope.contractDraft.phone;
                    }
                }
            });
        }
    }, {
        name: 'report',
        isActive: false,
        isUpdating: false,
        error: false,
        errorMessage: undefined,
        overrideNotTerminatedPDL: false,
        bypassReadings: function bypassReadings(currentStep) {
            $uibModal.open({
                animation: true,
                component: 'bypassReadingsAlert',
                resolve: {}
            }).result.then(function (result) {
                if (result.bypassReadings) {
                    $scope.goToNextProcess(currentStep);
                }
            });
        },
        report: function report(currentStep, reading) {
            $scope.isUpdating = true;
            currentStep.isUpdating = true;
            var currentStepIndex = $scope.getCurrentProcessIndex();
            return ContractDraft.report({}, reading).$promise.then(function (response) {
                $scope.process[currentStepIndex].error = false;
                return $scope.goToNextProcess(currentStep);
            }).catch(function (error) {
                $scope.process[currentStepIndex].error = true;
                $scope.process[currentStepIndex].errorMessage = 'Nous n’avons pas pu enregistrer votre relève. Si le problème persiste, vous pouvez passer cette étape.';
                $scope.isUpdating = false;
                currentStep.isUpdating = false;
                return ErrorCatcher.catchError(error);
            });
        },
        isLinky: function isLinky() {
            return PrmUtilsService.isLinky((0, _get3.default)($scope, 'pdlResponse.metter.kind'));
        },
        isFirstMES: function isFirstMES() {
            var isFirstMes = (0, _get3.default)($scope, 'pdlResponse.subscriptionType') === PDL_SUBSCRIPTION_TYPE.FIRST_MES;
            var hasNotPlan = !(0, _get3.default)($scope, 'pdlResponse.plan');
            return isFirstMes || hasNotPlan;
        }
    }, {
        name: 'heating',
        isActive: false,
        isUpdating: false,
        error: false,
        errorMessage: undefined
    }, {
        name: 'timetable',
        isActive: false,
        isUpdating: false
    }, {
        name: 'pay',
        isActive: false,
        isUpdating: false,
        error: false,
        errorMessage: undefined,
        goToPayment: function goToPayment(currentStep) {
            $scope.isUpdating = true;
            currentStep.isUpdating = true;
            $scope.contractDraft.ready_to_checkout = true;
            ContractDraft.update({}, { ready_to_checkout: true }).$promise.then(function () {
                return ContractDraft.getPaymentIframe({ id: $scope.contractDraft.id }).$promise;
            }).then(function (response) {
                window.location = response.redirectUrl;
            }).catch(function (error) {
                $scope.isUpdating = false;
                currentStep.isUpdating = false;
                ErrorCatcher.catchError(error);
            });
        },
        goToShowroomCreateAccount: function goToShowroomCreateAccount(currentStep, newUser) {
            $scope.isUpdating = true;
            currentStep.isUpdating = true;
            $scope.contractDraft.ready_to_checkout = true;
            var contractDraftPayload = { ready_to_checkout: true };
            if ($scope.partnerOffer === 'offrePrintemps2018') {
                contractDraftPayload = { ready_to_checkout: true, id_ref_promo: (0, _defaultTo3.default)($state.params.id_ref_promo, 'PRINTEMPS_2018_SELECTRA') };
            }

            ContractDraft.update({}, contractDraftPayload).$promise.then(function () {
                return User.signUp((0, _assign3.default)({}, newUser, {
                    civ: $scope.contractDraft.civ,
                    givenName: $scope.contractDraft.givenname,
                    sn: $scope.contractDraft.sn,
                    email: $scope.contractDraft.mail,
                    phone: $scope.contractDraft.phone,
                    birth_date: $scope.contractDraft.birth_date,
                    utm_source: localStorage.utm_source,
                    utm_medium: localStorage.utm_medium,
                    utm_campaign: localStorage.utm_campaign
                })).$promise;
            }).then(function () {
                localStorage.removeItem('utm_source');
                localStorage.removeItem('utm_medium');
                localStorage.removeItem('utm_campaign');
                return $state.go('subscriptionEnd', { email: $scope.contractDraft.mail });
            }).catch(function (error) {
                $scope.isUpdating = false;
                currentStep.isUpdating = false;
                ErrorCatcher.catchError(error);
                if (error.status === 409) {
                    $state.go('subscriptionSummary');
                } else if (!(0, _isEmpty3.default)((0, _get3.default)(error, 'data.message'))) {
                    currentStep.error = { isError: true, code: 'SERVICE_MSG', message: error.data.message };
                } else {
                    currentStep.error = { isError: true, code: 'DEFAULT_MSG' };
                }
            });
        }
    }, {
        name: 'landscape',
        isActive: false,
        isUpdating: false,
        error: false,
        errorMessage: undefined
    }];

    $scope.updateChoosenCalendarId = function () {
        $scope.powers = [{ id: null, label: '-- Choisissez --' }];
        var calendar = availablePowers[(0, _get3.default)($scope, 'pdlResponse.plan.id_p_calendar')] || availablePowers[$scope.contractDraft.choosen_id_p_calendar];
        if (calendar) {
            $scope.powers = $scope.powers.concat(calendar.availablePowers.map(function (p) {
                return { id: p, label: p + 'kVA' };
            }));
        }
    };

    $scope.isPromoMessageDefault = function () {
        return $scope.promoValidation.message === DEFAULT_PROMO_OK_MSG;
    };

    $scope.focus = function (input) {
        $scope.currentInput = input;
    };

    $scope.active = function (activeStep) {
        if (activeStep === 'pdl') {
            $scope.process[2].onStateActive();
        }
        Array.from($scope.process).forEach(function (step) {
            step.isActive = step.name === activeStep;
        });
    };

    $scope.getCurrentProcessIndex = function (forceIndex) {
        if (forceIndex) {
            return forceIndex;
        }
        var currentStepIndex = null;
        var index = 0;
        while (index < Math.max($scope.process.length, 0)) {
            if ($scope.process[index].isActive) {
                currentStepIndex = index;
            }
            index += 1;
        }
        return currentStepIndex;
    };

    $scope.goToNextProcess = function (currentStep, forceIndex) {
        $scope.isUpdating = true;
        currentStep.isUpdating = true;
        var currentStepIndex = $scope.getCurrentProcessIndex(forceIndex);
        if (currentStepIndex !== undefined && currentStepIndex !== $scope.process.length - 1) {
            if ($scope.process[currentStepIndex].name === 'report') {
                var subscriptionTypeForRequiredLandscape = [PDL_SUBSCRIPTION_TYPE.FIRST_MES, PDL_SUBSCRIPTION_TYPE.MES, PDL_SUBSCRIPTION_TYPE.MES_INTER];
                if (subscriptionTypeForRequiredLandscape.indexOf((0, _get3.default)($scope, 'pdlResponse.subscriptionType')) > -1) {
                    $scope.landscapeRequired = true;
                    $scope.getLandscapeQuestions().result.then(function () {
                        $timeout(function () {
                            $scope.isUpdating = false;
                            currentStep.isUpdating = false;
                        });
                    }).catch(function () {
                        $scope.isUpdating = false;
                        currentStep.isUpdating = false;
                    });
                } else {
                    featuresService.getFeatures(function (features) {
                        if (features.landscapeSubscription) {
                            $scope.showSpinner = true;
                            $scope.checkLandscapeRequired(function (response) {
                                if ($scope.landscapeRequired) {
                                    $scope.getLandscapeQuestions().result.then(function () {
                                        $timeout(function () {
                                            $scope.isUpdating = false;
                                            currentStep.isUpdating = false;
                                        });
                                    }).catch(function () {
                                        $scope.isUpdating = false;
                                        currentStep.isUpdating = false;
                                    });
                                } else {
                                    $scope.active($scope.process[4].name);
                                    $scope.isUpdating = false;
                                    currentStep.isUpdating = false;
                                }
                            });
                        } else {
                            $scope.active($scope.process[currentStepIndex + 1].name);
                            $scope.isUpdating = false;
                            currentStep.isUpdating = false;
                        }
                    });
                }
            } else if ($scope.process[currentStepIndex].name === 'heating' || $scope.process[currentStepIndex].name === 'landscape') {
                ContractDraft.get({ create: true, withRelated: 'nextBillableDate' }).$promise.then(function (data) {
                    setContractDraft(data);
                    $scope.active($scope.process[currentStepIndex + 1].name);
                    $scope.isUpdating = false;
                    currentStep.isUpdating = false;
                }).catch(function (error) {
                    ErrorCatcher.catchError(error);
                });
            } else {
                $scope.active($scope.process[currentStepIndex + 1].name);
                $scope.isUpdating = false;
                currentStep.isUpdating = false;
            }
        } else {
            $scope.isUpdating = false;
            currentStep.isUpdating = false;
        }
    };

    $scope.getLandscapeQuestions = function () {
        var uibModalOptions = {
            size: 'xs',
            template: __webpack_require__(1177)(),
            backdrop: 'TRUE',
            controller: 'landscapeConfirmModalCtrl'
        };

        var modal = $uibModal.open(uibModalOptions);
        modal.result.then(function () {
            return $scope.openLandscapeModal();
        });
        return modal;
    };

    $scope.openLandscapeModal = function (edit) {
        $scope.doingLandscape = true;
        $scope.active($scope.process[7].name);
        return LandscapeQuestions.search({
            category: 'c-est-parti',
            id_contract: $scope.contractDraft.id,
            draft: true
        }).$promise.then(function (_landscapeQuestions) {
            var isNew = false;
            if (_landscapeQuestions && _landscapeQuestions.length === 1) {
                if (_landscapeQuestions[0][0].answer === undefined || _landscapeQuestions[0][0].answer === '' || _landscapeQuestions[0][0].answer === false) {
                    isNew = true;
                }
            }

            var uiModalOptions = {
                animation: true,
                size: 'xlg',
                template: __webpack_require__(1178)(),
                backdrop: 'static',
                resolve: {
                    landscapeQuestions: function landscapeQuestions() {
                        return _landscapeQuestions;
                    },
                    idContract: function idContract() {
                        $scope.showSpinner = true;
                        return contractDraft.id;
                    },
                    isEdition: function isEdition() {
                        return { edition: edit, new: isNew };
                    }
                },

                controller: 'landscapeModalCtrl'
            };

            if (_landscapeQuestions[0][0] && edit !== true) {
                if (_landscapeQuestions[0][0].answer && _landscapeQuestions[0][0].answer !== '') {
                    uiModalOptions.size = 'hidden';
                    uiModalOptions.backdrop = false;
                }

                var lastBlock = _landscapeQuestions[_landscapeQuestions.length - 1];
                if (lastBlock[Object.keys(lastBlock).length - 1] && lastBlock[Object.keys(lastBlock).length - 1].last) {
                    $scope.landscapeDone = true;
                }
            }

            var landscapeModal = $uibModal.open(uiModalOptions);
            landscapeModal.result.then(function (result) {
                if (result && result.canvas) {
                    var landscapeCanvasSub = document.getElementById('landscape-canvas-sub');
                    while (landscapeCanvasSub.firstChild) {
                        landscapeCanvasSub.removeChild(landscapeCanvasSub.firstChild);
                    }
                    landscapeCanvasSub.appendChild(result.canvas);
                }
                if (result.heating) {
                    $scope.contractDraft.heating = result.heating;
                }
                if ((0, _isBoolean3.default)(result.primary_residence)) {
                    $scope.contractDraft.primary_residence = result.primary_residence;
                }
                if (result.landscapeDone) {
                    $scope.landscapeDone = true;
                }
                $scope.landscapeLoaded = true;
            });
            return landscapeModal.rendered.then(function () {
                return $rootScope.$broadcast('landscapeModalReady', {});
            }).catch(ErrorCatcher.catchError);
        });
    };

    $scope.editLandscape = function () {
        return $scope.openLandscapeModal(true);
    };

    $scope.checkLandscapeRequired = function (callback) {
        return ContractDraft.checkLandscapeRequired({
            id_contract: $scope.contractDraft.id
        }).$promise.then(function (result) {
            $scope.landscapeRequired = $scope.contractDraft.is_a_move || result.required;
            return callback(result);
        }).catch(ErrorCatcher.catchError);
    };

    $scope.trackEvent = function (eventName) {
        var campainId = localStorage.id_campaign || 'default';
        // GA EVENT
        $window.ga('send', {
            hitType: 'event',
            eventCategory: campainId,
            eventAction: 'update - Souscription - ' + eventName,
            eventLabel: campainId + ' Campaign Subscription Step',
            transport: 'beacon'
        });

        return true;
    };

    $scope.update = function (currentStep) {
        $scope.isUpdating = true;
        currentStep.isUpdating = true;

        if ($scope.contractDraft.sponsor_id !== null && $scope.contractDraft.sponsor_id !== undefined && $scope.contractDraft.sponsor_id.length === 0) {
            $scope.contractDraft.sponsor_id = null;
        }
        if ($scope.contractDraft.id_ref_promo !== null && $scope.contractDraft.id_ref_promo !== undefined && $scope.contractDraft.id_ref_promo.length === 0) {
            $scope.contractDraft.id_ref_promo = null;
        }
        return ContractDraft.update({}, $scope.contractDraft).$promise.then(function (response) {
            //     when the draft is updated, we can flush the sponsorId from the localStorage
            localStorage.removeItem('sponsorId');
            localStorage.removeItem('promoId');
            return $scope.goToNextProcess(currentStep);
        }).catch(function (error) {
            $scope.isUpdating = false;
            currentStep.isUpdating = false;
            return ErrorCatcher.catchError(error);
        });
    };

    $scope.updateContractDraft = function (value) {
        $scope.contractDraft = (0, _assign3.default)({}, $scope.contractDraft, value);
        return ContractDraft.update({}, value).$promise.catch(function (error) {
            return ErrorCatcher.catchError(error);
        });
    };

    $scope.getPowerMax = function () {
        return (0, _defaultTo3.default)((0, _get3.default)($scope.pdlResponse, 'power.max'), $scope.contractDraft.choosen_max_power);
    };

    $scope.sendEnedisDownMessage = function () {
        var jiraIssue = {
            summary: $scope.contractDraft.civ + ' ' + $scope.contractDraft.sn + ' ' + $scope.contractDraft.givenname + ' : Rappel finalisation de commande',
            description: $scope.contractDraft.civ + ' ' + $scope.contractDraft.sn + ' ' + $scope.contractDraft.givenname + ' n\u2019a pas pu terminer sa commande en raison d\u2019une indisponibilit\xE9 Enedis.',
            type: 'Task',
            epicLink: 'SN2-934',
            idContract: $scope.contractDraft.id,
            idPrm: $scope.contractDraft.id_prm,
            enrichSummary: false
        };
        if (localStorage.prm !== $scope.contractDraft.id_prm) {
            localStorage.prm = $scope.contractDraft.id_prm;
            ContractDraft.createJiraIssue({ idProject: 'support' }, jiraIssue).$promise.catch(ErrorCatcher.catchError);
        }
    };

    $scope.$watch('contractDraft.id_prm', function () {
        $scope.isPRMEligible = false;
        $scope.pdlResponse = null;
    });

    $scope.openFindPdlHelperModal = function () {
        $uibModal.open({
            animation: true,
            size: 'lg',
            component: 'findPdlHelper',
            resolve: {
                partnerOffer: function partnerOffer() {
                    return $scope.partnerOffer;
                }
            }
        });
    };

    var activate = function activate() {
        // GA EVENT
        // initial GA event Start subscription
        var campainId = localStorage.id_campaign || 'default';
        $window.ga('send', {
            hitType: 'event',
            eventCategory: campainId,
            eventAction: 'page - Souscription - ' + $scope.subscriptionType,
            eventLabel: campainId + ' Campaign Subscription Step',
            transport: 'beacon'
        });

        $scope.process[1].initSponsorFee();
        $scope.process[1].initAvailablePower();
        $scope.process[1].updateBirthDate();
        if (!$scope.isPartnerSubscription) {
            $scope.process[1].checkSponsor();
            $scope.process[1].checkPromo(true);
        }

        // Disable zendesk btn
        if (window.zE) {
            window.zE(function () {
                window.zE.hide();
            });
        }
    };

    activate();
}

function __guard__(value, transform) {
    return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"subscription-form-modal pdl-disabled-modal\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1 text-center\"\u003E\u003Ch3 class=\"marine\"\u003EVotre compteur n’est pas actif\u003C\u002Fh3\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-4 detail-item\"\u003E\u003Ch4\u003EJ’ai fait une erreur, on recommence\u003C\u002Fh4\u003E\u003Cdiv class=\"detail-item-image\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Fcome-in.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail-item detail\"\u003ECliquez sur corriger pour resaisir votre numéro de point de livraison\u003C\u002Fdiv\u003E\u003Ca class=\"btn white background-marine\" ng-click=\"resetPDL()\"\u003ECORRIGER\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-4 detail-item\"\u003E\u003Ch4\u003EC’est normal, j’emménage dans un nouveau logement !\u003C\u002Fh4\u003E\u003Cdiv class=\"detail-item-image\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Ferase.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail-item detail\"\u003ECliquez sur continuer si vous souhaitez activer le compteur de votre nouveau logement\u003C\u002Fdiv\u003E\u003Ca class=\"btn white background-light-pink\" ng-click=\"confirmToEmmenagement()\"\u003ECONTINUER\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-4 detail-item\"\u003E\u003Ch4\u003EJe ne comprends pas, j’ai besoin d’aide…\u003C\u002Fh4\u003E\u003Cdiv class=\"detail-item-image\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Fquestion.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail-item detail\"\u003EAppelez nous afin d’obtenir l’aide de la part d’un conseiller Plüm énergie\u003C\u002Fdiv\u003E\u003Ca class=\"btn white background-bluegrey\" ng-href=\"{{contactTelephone.link}}\"\u003E{{contactTelephone.label}}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"subscription-form-modal are-you-sure-modal\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1 text-center\"\u003E\u003Ch2 class=\"marine\"\u003ECOMPTEUR ACTIF\u003C\u002Fh2\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cp\u003EIl y a un contrat encore actif sur le compteur de votre nouveau domicile. Si vous continuez, vous résilierez le contrat de l'ancien occupant.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 text-center\"\u003E\u003Ca class=\"btn background-marine continue white\" ng-click=\"confirm()\"\u003EContinuer\u003C\u002Fa\u003E\u003Ca class=\"btn background-marine\" ng-href=\"{{contactTelephone.link}}\"\u003ENous appeler pour vérifier au\u003Cbr\u003E {{contactTelephone.label}}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"subscription-contact-modal\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1\"\u003E\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-10\"\u003E\u003Ch4\u003ERETROUVER MON POINT DE LIVRAISON\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-2 text-right\"\u003E\u003Ci class=\"fa fa-close fa-2x\" ng-click=\"close()\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container form-body\" ng-if=\"form.isContactSent\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cp\u003EVotre message a été envoyé. Vous serez contacté prochainement.\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-warning\" ng-click=\"close()\"\u003EFermer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\" name=\"form.api\" ng-if=\"!form.isContactSent\" ng-submit=\"gaEventsService.newEvent('click - Send Subscription Contact - Unknown PRM Form') &amp;&amp; sendMessage(form)\"\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cp\u003ENous pouvons vous aider à retrouver votre point de livraison. Pour ce faire, nous avons besoin des informations suivantes\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row error top-error\" ng-if=\"form.error.hasError\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-12 form-error text-center\"\u003E\u003Cp\u003EOups, il y eu un problème, votre message n'a pas été envoyé.\u003Cbr\u003E\u003Cbr\u003E\u003Cspan ng-bind=\"form.error.message\"\u003E\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003ELe plus simple est que vous nous écriviez à l'adresse\n\u003Ca class=\"underlined\" ng-href=\"mailto:{{mailAdresse.bonjour}}?subject={{form.model.selectedSubject.subject}}\"\u003E{{mailAdresse.bonjour}}\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Clabel\u003EAdresse postale du logement\u003Ctextarea name=\"postalAddress\" ng-model=\"form.model.postalAddress\" style=\"min-height: 90px;\" required\u003E\u003C\u002Ftextarea\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Clabel\u003ENom\u002Fprénom de l'ancien occupant (dans le cas d'un emménagement)\u003Cinput type=\"text\" name=\"previousOccupant\" ng-model=\"form.model.previousOccupant\"\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Clabel\u003ENuméro de série du compteur&nbsp;\u003Cspan class=\"fa fa-question-circle\" uib-popover-template=\"'serial-help'\" popover-trigger=\"mouseenter\" popover-placement=\"right\"\u003E\u003C\u002Fspan\u003E\u003Cinput type=\"text\" name=\"serial\" ng-model=\"form.model.serial\"\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Clabel\u003ECommentaire\u003Ctextarea name=\"body\" ng-model=\"form.model.body\" placeholder=\"Taper votre message ici...\" required\u003E\u003C\u002Ftextarea\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Clabel\u003E\u003Cinput type=\"checkbox\" ng-model=\"form.canRecontact\"\u003E&nbsp;Je souhaite être rappelé afin de terminer ma souscription par téléphone.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12 form-footer\"\u003E\u003Cbutton class=\"btn btn-spinner background-light-pink\" type=\"submit\" ng-disabled=\"form.isSending\" ng-class=\"{'btn-spinner-loading': form.isSending}\"\u003EEnvoyer le message\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cscript type=\"text\u002Fng-template\" id=\"serial-help\"\u003E\u003Cdiv\u003E\u003Cp\u003EC’est un numéro présent sur votre compteur d’électricité\n(souvent gravé au-dessus du cadran pour les compteurs électroniques, et en dessous de la roue pour les compteurs mécaniques).\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fscript\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"text-center modal-inner\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-10 col-md-offset-1 text-center\"\u003E\u003Ch1 class=\"light darkish-pink\"\u003EEstimation de votre consommation\u003C\u002Fh1\u003E\u003Cp class=\"margin-top-20\"\u003EPour estimer votre consommation, nous avons besoin de quelques informations sur votre logement et vos usages électriques.\u003C\u002Fp\u003E\u003Cp class=\"margin-top-20\"\u003ELes réponses à nos questions, comme toutes les informations que vous nous confiez, sont strictement confidentielles. Elles ne seront\njamais communiquées à des tiers sans votre accord.\u003C\u002Fp\u003E\u003Cdiv class=\"margin-top-20 text-center\"\u003E\u003Cbutton class=\"btn btn-lg btn-primary background-light-pink button-round\" ng-click=\"close()\"\u003ECONTINUER \u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"row landscape-modal\"\u003E\u003Cdiv class=\"close-landscape-modal fa fa-times\" ng-click=\"close()\"\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"row-fluid\" id=\"landscape-form\"\u003E\u003Cdiv class=\"col-xs-12 window-height\"\u003E\u003Clandscape-form questions=\"landscapeQuestions\" contract-selected=\"contract\" display-end-modal=\"false\"\u003E\u003C\u002Flandscape-form\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _landingOffrePrintemps = __webpack_require__(1180);

var _landingOffrePrintemps2 = _interopRequireDefault(_landingOffrePrintemps);

var _landingOffreRentree = __webpack_require__(1185);

var _landingOffreRentree2 = _interopRequireDefault(_landingOffreRentree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.subscriptionLanding', []).controller('landingOffrePrintemps2018Ctrl', _landingOffrePrintemps2.default).controller('landingOffreRentree2018Ctrl', _landingOffreRentree2.default).name;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


landingOffrePrintemps2018Ctrl.$inject = ["$state", "$scope", "$interval", "ContactTelephone", "gaEventsService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _padStart2 = __webpack_require__(350);

var _padStart3 = _interopRequireDefault(_padStart2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = landingOffrePrintemps2018Ctrl;

/** @ngInject */

function landingOffrePrintemps2018Ctrl($state, $scope, $interval, ContactTelephone, gaEventsService) {
    $scope.contactTelephone = ContactTelephone;
    $scope.gaEventsService = gaEventsService;
    $scope.params = $state.params;
    $scope.partner = {
        selectra: ['PRINTEMPS_2018_SELECTRA_MVSA', 'PRINTEMPS_2018_SELECTRA_SOS_SENIORS'].indexOf($state.params.id_ref_promo) === -1,
        mvsa: $state.params.id_ref_promo === 'PRINTEMPS_2018_SELECTRA_MVSA',
        sosSeniors: $state.params.id_ref_promo === 'PRINTEMPS_2018_SELECTRA_SOS_SENIORS'
    };
    $scope.partnerOfferEnd = (0, _moment2.default)('2018-07-10');
    $scope.displayCountdown = 0;

    $scope.countdownDetail = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };

    $interval(function () {
        var countdown = _moment2.default.duration($scope.partnerOfferEnd.diff());
        $scope.countdownDetail = {
            days: Math.trunc(countdown.asDays()),
            hours: (0, _padStart3.default)(countdown.hours(), 2, '0'),
            minutes: (0, _padStart3.default)(countdown.minutes(), 2, '0'),
            seconds: (0, _padStart3.default)(countdown.seconds(), 2, '0')
        };
    }, 1000, 0);
}

/***/ }),
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


landingOffreRentree2018Ctrl.$inject = ["$state", "$stateParams", "$scope", "$interval", "ContactTelephone", "gaEventsService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _padStart2 = __webpack_require__(350);

var _padStart3 = _interopRequireDefault(_padStart2);

var _toLower2 = __webpack_require__(221);

var _toLower3 = _interopRequireDefault(_toLower2);

var _get2 = __webpack_require__(8);

var _get3 = _interopRequireDefault(_get2);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = landingOffreRentree2018Ctrl;

/** @ngInject */

function landingOffreRentree2018Ctrl($state, $stateParams, $scope, $interval, ContactTelephone, gaEventsService) {
    $scope.contactTelephone = ContactTelephone;
    $scope.gaEventsService = gaEventsService;
    $scope.params = $state.params;
    $scope.partnerOfferEnd = (0, _moment2.default)('2018-10-15');
    $scope.displayCountdown = 10;
    $scope.city = $stateParams.ville;
    $scope.prep = ['d\'', 'd’'].indexOf($stateParams.prep) > -1 ? $stateParams.prep : $stateParams.prep + ' ';

    var logoMapping = {
        'aix': 'logo-aix.svg',
        'le mans': 'logo-le-mans.svg',
        'montpellier': 'logo-montpellier.svg',
        'nancy': 'logo-nancy.svg',
        'nantes': 'logo-nantes.svg',
        'nice': 'logo-nice.svg',
        'nimes': 'logo-nimes.svg',
        'nîmes': 'logo-nimes.svg',
        'perpignan': 'logo-perpignan.svg',
        'toulon': 'logo-toulon.svg',
        'toulouse': 'logo-toulouse.svg'
    };

    $scope.logo = (0, _get3.default)(logoMapping, (0, _toLower3.default)($stateParams.ville), 'logo-ag-hcplus.svg');

    $scope.countdownDetail = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };

    $interval(function () {
        var countdown = _moment2.default.duration((0, _moment2.default)($scope.partnerOfferEnd).add(1, 'days').diff());
        $scope.countdownDetail = {
            days: Math.trunc(countdown.asDays()),
            hours: (0, _padStart3.default)(countdown.hours(), 2, '0'),
            minutes: (0, _padStart3.default)(countdown.minutes(), 2, '0'),
            seconds: (0, _padStart3.default)(countdown.seconds(), 2, '0'),
            asSeconds: Math.trunc(countdown.asSeconds())
        };
    }, 1000, 0);
}

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _potBurn = __webpack_require__(1187);

var _potBurn2 = _interopRequireDefault(_potBurn);

var _tracking = __webpack_require__(1189);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.tracking', []).component('potBurn', _potBurn2.default).controller('trackingCtrl', _tracking2.default).name;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _some2 = __webpack_require__(349);

var _some3 = _interopRequireDefault(_some2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PotBurnCtrl = function () {
    /** @ngInject */
    PotBurnCtrl.$inject = ["$state", "$q", "$filter", "User", "Contract", "PotManager", "ErrorCatcher"];
    function PotBurnCtrl($state, $q, $filter, User, Contract, PotManager, ErrorCatcher) {
        _classCallCheck(this, PotBurnCtrl);

        this.$state = $state;
        this.$q = $q;
        this.$filter = $filter;
        this.User = User;
        this.Contract = Contract;
        this.PotManager = PotManager;
        this.ErrorCatcher = ErrorCatcher;
    }

    // INIT COMPONENT


    _createClass(PotBurnCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.dispatch({ type: 'ON_INIT', pot: this.PotManager.getPotBalance() });

            // Fetch old potBurnConfirmed after state reload
            var potBurnConfirmed = JSON.parse(sessionStorage.getItem('potBurnConfirmed'));
            if (potBurnConfirmed && (0, _moment2.default)().isBefore(potBurnConfirmed.expire)) {
                this.dispatch(potBurnConfirmed);
            } else {
                this.User.getUa().$promise.then(function (userAction) {
                    return (0, _some3.default)(userAction, function (action) {
                        return Number(action.type) === 100 && action.status === 0 && action.id_contract === _this.userInfo.contractSelected.id;
                    });
                }).then(function (isBurned) {
                    _this.dispatch({ type: 'UPDATE_IS_BURNED', isBurned: isBurned });
                    _this.dispatch({ type: 'DISPLAY_INITIAL_VIEW' });
                });
            }

            this.PotManager.watch(function (pot) {
                _this.dispatch({ type: 'UPDATE_POT', pot: pot });

                // Reload view only on initial states - not the final state
                if (['state_initial_burnable', 'state_initial_not_burnable', 'state_initial'].indexOf(_this.state) > -1) {
                    _this.dispatch({ type: 'DISPLAY_INITIAL_VIEW' });
                }
            });
        }

        // ACTIONS

    }, {
        key: 'displayInitialView',
        value: function displayInitialView() {
            this.dispatch({ type: 'DISPLAY_INITIAL_VIEW' });
        }
    }, {
        key: 'displaySelectBurnType',
        value: function displaySelectBurnType() {
            this.dispatch({ type: this.canBurnInvestment ? 'SELECT_BURN_TYPE' : 'BURN_TO_BILL_CONFIRM' });
        }
    }, {
        key: 'displayConfirmBurnToBill',
        value: function displayConfirmBurnToBill() {
            this.dispatch({ type: 'BURN_TO_BILL_CONFIRM' });
        }
    }, {
        key: 'burnToBill',
        value: function burnToBill() {
            var _this2 = this;

            this.dispatch({ type: 'BURN_TO_BILL_IN_PROGRESS' });
            var burnToBill$ = this.Contract.burnToBill({ id: this.userInfo.contractSelected.id }).$promise;
            burnToBill$.then(function (response) {
                // Save to sessionStorage before $state reload
                sessionStorage.setItem('potBurnConfirmed', JSON.stringify({
                    type: 'BURN_TO_BILL_CONFIRMED',
                    expire: (0, _moment2.default)().add(1, 'minutes').toISOString()
                }));
                _this2.PotManager.update();
                _this2.$state.go(_this2.$state.current, {}, { reload: true });
            });
            burnToBill$.catch(function (error) {
                _this2.ErrorCatcher.catchError(error);
                _this2.dispatch({ type: 'BURN_TO_BILL_ERROR', error: error });
            });
        }
    }, {
        key: 'displayConfirmBurnInvestment',
        value: function displayConfirmBurnInvestment() {
            this.dispatch({ type: 'BURN_INVESTMENT_CONFIRM' });
        }
    }, {
        key: 'burnToInvestment',
        value: function burnToInvestment() {
            var _this3 = this;

            this.dispatch({ type: 'BURN_INVESTMENT_IN_PROGRESS' });
            var potAmount = Number(this.selectedPotAmount.replace(',', '.'));
            var selectedAmount = this.pot.real > potAmount ? potAmount : this.pot.real;
            var burnToInvestment$ = this.Contract.burnToInvestment({ amount: selectedAmount }).$promise;
            burnToInvestment$.then(function (response) {
                // Save to sessionStorage before $state reload
                sessionStorage.setItem('potBurnConfirmed', JSON.stringify({
                    type: 'BURN_INVESTMENT_CONFIRMED',
                    amountBurned: selectedAmount,
                    economyKWA: response.economyKWA,
                    ecomonyAmount: response.ecomonyAmount,
                    expire: (0, _moment2.default)().add(1, 'minutes').toDate()
                }));
                _this3.PotManager.update();
                _this3.$state.go(_this3.$state.current, {}, { reload: true });
            });
            burnToInvestment$.catch(function (error) {
                _this3.ErrorCatcher.catchError(error);
                _this3.dispatch({ type: 'BURN_INVESTMENT_ERROR', error: error });
            });
        }

        // REDUCER

    }, {
        key: 'dispatch',
        value: function dispatch() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            switch (action.type) {
                case 'ON_INIT':
                    this.state = 'state_initial';
                    this.isBurningPot = false;
                    this.burningError = null;
                    this.isBurned = undefined;
                    this.pot = action.pot;
                    this.potUsable = this.userInfo.contractSelected.contractBalance.balance >= 0;
                    this.BURN_INVESTMENT_THRESHOLD = 10;
                    this.canBurnInvestment = this.pot.real >= this.BURN_INVESTMENT_THRESHOLD;
                    this.amountBurned = null;
                    this.economyKWA = null;
                    this.ecomonyAmount = null;
                    this.selectedPotAmount = this.$filter('frAmount')(Math.max(this.pot.real / 2, this.BURN_INVESTMENT_THRESHOLD));
                    break;
                case 'UPDATE_IS_BURNED':
                    this.isBurned = action.isBurned;
                    break;
                case 'UPDATE_POT':
                    this.pot = action.pot;
                    this.canBurnInvestment = this.pot.real >= this.BURN_INVESTMENT_THRESHOLD;
                    break;
                case 'DISPLAY_INITIAL_VIEW':
                    if (this.isBurned === true) {
                        this.state = 'state_burn_confirmed';
                    } else if (this.isBurned === false && this.pot) {
                        this.state = this.pot.real > 0 ? 'state_initial_burnable' : 'state_initial_not_burnable';
                    } else {
                        this.state = 'state_initial';
                    }
                    break;
                case 'SELECT_BURN_TYPE':
                    this.state = 'state_burn_type';
                    break;
                case 'BURN_TO_BILL_CONFIRM':
                    this.state = 'state_confirm_burn';
                    this.isBurningPot = false;
                    this.burningError = null;
                    break;
                case 'BURN_TO_BILL_IN_PROGRESS':
                    this.state = 'state_confirm_burn';
                    this.isBurningPot = true;
                    this.burningError = null;
                    break;
                case 'BURN_TO_BILL_CONFIRMED':
                    this.state = 'state_burn_confirmed';
                    this.isBurned = true;
                    this.isBurningPot = false;
                    this.burningError = null;
                    break;
                case 'BURN_TO_BILL_ERROR':
                    this.state = 'state_confirm_burn';
                    this.isBurningPot = false;
                    this.burningError = action.error;
                    break;
                case 'BURN_INVESTMENT_CONFIRM':
                    this.state = 'state_confirm_burn_investment';
                    this.isBurningPot = false;
                    this.burningError = null;
                    break;
                case 'BURN_INVESTMENT_IN_PROGRESS':
                    this.state = 'state_confirm_burn_investment';
                    this.isBurningPot = true;
                    this.burningError = null;
                    break;
                case 'BURN_INVESTMENT_CONFIRMED':
                    this.state = 'state_burn_investment_confirmed';
                    this.isBurned = true;
                    this.isBurningPot = false;
                    this.burningError = null;
                    this.amountBurned = action.amountBurned;
                    this.economyKWA = action.economyKWA;
                    this.ecomonyAmount = action.ecomonyAmount;
                    break;
                case 'BURN_INVESTMENT_ERROR':
                    this.state = 'state_confirm_burn_investment';
                    this.isBurningPot = false;
                    this.burningError = action.error;
                    break;
                default:
                    break;
            }
        }
    }]);

    return PotBurnCtrl;
}();

exports.default = {
    template: __webpack_require__(1188)(),
    controller: PotBurnCtrl,
    bindings: {
        userInfo: '<'
    }
};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.state === 'state_initial'\"\u003E\u003Ci class=\"spinner spinner-form margin-tb-50\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'state_initial_not_burnable'\"\u003E\u003Cp\u003EVous n'avez pour l'instant pas d'argent disponible dans votre cagnotte.\nRevenez ici dès que votre cagnotte sera créditée pour demander la réduction de vos prochains prélèvements.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'state_initial_burnable'\"\u003E\u003Cp\u003EVous avez cumulé un montant de\n\u003Cstrong\u003E{{ $ctrl.pot.real | frAmount }}€.\u003C\u002Fstrong\u003E\nVous pouvez l’utiliser pour diminuer vos prochains prélèvements\n\u003Cspan ng-if=\"!$ctrl.canBurnInvestment\"\u003E.\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.canBurnInvestment\"\u003Eou contribuer à la production d’énergie renouvelable.\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp\u003E\u003Cdiv class=\"btn-toolbar btn-right\"\u003E\u003Cbutton class=\"background-marine btn btn-right\" ng-click=\"$ctrl.displaySelectBurnType()\" ng-disabled=\"$ctrl.pot.real == 0 || !$ctrl.potUsable\" title=\"{{this.potUsable ? '' : 'Pour utiliser votre cagnotte, votre solde doit être régularisé. Réglez directement votre solde depuis votre espace client ou contactez notre service client pour planifier les paiements.'}}\"\u003EUtiliser ma cagnotte\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\" ng-if=\"$ctrl.state === 'state_burn_type'\"\u003E\u003Cp\u003EComment souhaitez vous utiliser votre cagnotte ?\u003C\u002Fp\u003E\u003Cdiv class=\"pot-burn-type\"\u003E\u003Cbutton class=\"btn btn-pot-burn\" ng-click=\"$ctrl.displayConfirmBurnToBill()\"\u003EJe veux réduire ma\u003Cbr\u003Eprochaine mensualité\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-pot-burn-renewable\" ng-click=\"$ctrl.displayConfirmBurnInvestment()\"\u003EJe contribue à la production\u003Cbr\u003Ed’énergie renouvelable\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'state_confirm_burn'\"\u003E\u003Cp class=\"fw-600 dark-pink\" ng-if=\"$ctrl.burningError\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\nUne erreur s'est produite pendant l'enregistrement : {{$ctrl.burningError.data.message}}\u003C\u002Fp\u003E\u003Cp\u003EVotre cagnotte sera utilisée pour diminuer\n\u003Cspan ng-if=\"!$ctrl.userInfo.contractSelected.nextPayment.date\"\u003Evotre prochaine mensualité.\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.userInfo.contractSelected.nextPayment.date &amp;&amp; !$ctrl.userInfo.contractSelected.nextPayment.isPaymentInProcess\"\u003Evotre mensualité du mois {{ $ctrl.userInfo.contractSelected.nextPayment.date | amDateFormat:'MMMM YYYY' | elision }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.userInfo.contractSelected.nextPayment.date &amp;&amp; $ctrl.userInfo.contractSelected.nextPayment.isPaymentInProcess\"\u003Evotre mensualité du mois {{ $ctrl.userInfo.contractSelected.nextPayment.date | amAdd: '1' : 'month' | amDateFormat:'MMMM YYYY' | elision }}\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp class=\"fs-12 italic\" ng-if=\"$ctrl.userInfo.contractSelected.nextPayment.isPaymentInProcess\"\u003E\u003Ci class=\"fa fa-question fa-3x fa-pull-left\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003EVotre cagnotte ne peut malheureusement pas être utilisée sur le mois\n{{ $ctrl.userInfo.contractSelected.nextPayment.date | amDateFormat:'MMMM YYYY' | elision }},\nl’ordre de prélèvement ayant déjà été envoyé à votre banque\u003C\u002Fp\u003E\u003Cp\u003ESi votre cagnotte est plus importante, le solde restera disponible pour réduire l’un des prélèvements suivants.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cdiv class=\"btn-toolbar btn-right\"\u003E\u003Cbutton class=\"background-bluegrey btn\" ng-click=\"$ctrl.displayInitialView()\" ng-disabled=\"$ctrl.isBurningPot\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"background-light-pink btn btn-spinner\" ng-click=\"$ctrl.burnToBill()\" ng-disabled=\"$ctrl.isBurningPot\" ng-class=\"{'btn-spinner-loading': $ctrl.isBurningPot}\"\u003EConfirmer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'state_burn_confirmed'\"\u003EVous avez demandé à utiliser votre cagnotte pour diminuer votre prochain prélèvement.\nVotre cagnotte sera alors débitée et le solde restant pourra être utilisé pour réduire l’un des prélèvements suivants.\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'state_confirm_burn_investment'\"\u003E\u003Cp class=\"fw-600 dark-pink\" ng-if=\"$ctrl.burningError\"\u003E\u003Ci class=\"fa fa-warning\"\u003E\u003C\u002Fi\u003E\nUne erreur s'est produite pendant l'enregistrement : {{$ctrl.burningError.data.message}}\u003C\u002Fp\u003E\u003Cp\u003EPlüm énergie vous propose d’utiliser votre cagnotte disponible pour soutenir les projets d’Akuo Energy,\nle premier producteur d’énergie renouvelable en France. En échange de ce don, vous bénéficiez tous les ans\nd’une remise sous la forme de kilowatt-heures offerts sur votre facture.\u003C\u002Fp\u003E\u003Cdiv class=\"flex flex-center flex-wrap\"\u003E\u003Cdiv class=\"flex-grow-1 flex flex-align-end margin-top-20\"\u003E\u003Ca class=\"white underline\" href=\"https:\u002F\u002Fplum.fr\u002Fconstruire-l-energie-de-demain\" target=\"_blank\"\u003ECliquez ici pour en savoir plus\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex flex-center flex-wrap\"\u003E\u003Cdiv class=\"margin-top-30\"\u003E\u003Cdiv class=\"fw-600 dark-pink\"\u003EQuel montant de votre cagnotte souhaitez-vous utiliser pour contrinuer à la production d’énergie renouvelable (minimum de {{$ctrl.BURN_INVESTMENT_THRESHOLD}}€) ?\u003C\u002Fdiv\u003E\u003Cdiv class=\"report-input report-input-small margin-top-20\"\u003E\u003Clabel\u003EMontant\u003C\u002Flabel\u003E\u003Cdiv class=\"fw-600\"\u003E\u003Cinput class=\"white border-white\" name=\"amount_cagnotte\" ng-model=\"$ctrl.selectedPotAmount\" ng-pattern=\"\u002F^[0-9]+([.,][0-9]+)?$\u002F\" min=\"10\" type=\"text\"\u003E\u003Cspan class=\"white\"\u003E&euro;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"error margin-top-20\" ng-if=\"$ctrl.selectedPotAmount &gt; $ctrl.pot.real\"\u003E\u003Cspan class=\"fw-600 red\"\u003E*Le montant inscrit est plus important que le montant total de votre cagnotte disponible\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"error margin-top-20\" ng-if=\"$ctrl.selectedPotAmount &lt; $ctrl.BURN_INVESTMENT_THRESHOLD\"\u003E\u003Cspan class=\"fw-600 red\"\u003E*Le montant doit être au minimum {{$ctrl.BURN_INVESTMENT_THRESHOLD}}&euro;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"error margin-top-20\" ng-if=\"$ctrl.selectedPotAmount == undefined\"\u003E\u003Cspan class=\"fw-600 red\"\u003E*Le montant doit être un nombre\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-20\"\u003E\u003Cdiv class=\"btn-toolbar btn-right\"\u003E\u003Cbutton class=\"background-bluegrey btn\" ng-click=\"$ctrl.displayInitialView()\" ng-disabled=\"$ctrl.isBurningPot\"\u003EAnnuler\u003C\u002Fbutton\u003E\u003Cbutton class=\"background-light-pink btn btn-spinner\" ng-click=\"$ctrl.burnToInvestment()\" ng-disabled=\"$ctrl.selectedPotAmount == undefined || $ctrl.isBurningPot || ($ctrl.selectedPotAmount &gt; $ctrl.pot.real) || ($ctrl.selectedPotAmount &lt; $ctrl.BURN_INVESTMENT_THRESHOLD)\" ng-class=\"{'btn-spinner-loading': $ctrl.isBurningPot}\"\u003EConfirmer\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.state === 'state_burn_investment_confirmed'\"\u003E\u003Cdiv class=\"margin-bottom-10\"\u003EFélicitation {{$ctrl.userInfo.givenname}} !\nVotre cagnotte de {{$ctrl.amountBurned | frAmount }}€ va servir à construire de nouvelles installations pour produire de l’énergie renouvelable.\nEn voilà un geste pour la planète !\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex flex-center flex-wrap\"\u003E\u003Cdiv class=\"flex flex-center padding-5\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Ftracking\u002Fcadeau.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex flex-center flex-grow-min-500\"\u003EDès 2019, vous recevrez une remise sur vos prochaines factures.\nPrès de {{$ctrl.economyKWA}}kWh d’énergie, soit environ {{$ctrl.ecomonyAmount | frAmount }}€, vous seront offerts tous les ans !\nUn e-mail de confirmation vous a été envoyé et vous recevrez bientôt des nouvelles de vos projets.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


trackingCtrl.$inject = ["$scope", "$state", "Chart", "Contract", "AlertManager", "PotManager", "ReportManager", "DeviceChecker", "PrmUtilsService", "ErrorCatcher", "userInfo", "contractCons", "userAction", "landscapeQuestions"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = __webpack_require__(8);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = trackingCtrl;

/** @ngInject */

function trackingCtrl($scope, $state, Chart, Contract, AlertManager, PotManager, ReportManager, DeviceChecker, PrmUtilsService, ErrorCatcher, userInfo, contractCons, userAction, landscapeQuestions) {
    $scope.data = { loading: true, graph: { data: null } };
    $scope.userInfo = userInfo;
    $scope.userContract = userInfo.contractSelected;
    $scope.userContract.isLinkyCommunicating = userInfo.contractSelected.prm.communicating;
    $scope.userIsBase = userInfo.contractSelected && userInfo.contractSelected.plan === 'Base';
    $scope.report = ReportManager;
    $scope.pot = PotManager.getPotBalance();

    $scope.isMobile = DeviceChecker.isMobile;

    $scope.isTab = DeviceChecker.isTab;

    $scope.isSelectedContractHasPot = function () {
        return userInfo.contractSelected.providerOffer.has_pot;
    };

    PotManager.watch(function (newPot) {
        $scope.pot = newPot;
    });

    var activate = function activate() {
        if (!$scope.data) {
            $scope.data = { loading: true, graph: { data: null } };
        }

        if (contractCons && contractCons.length > 0) {
            var opts = {
                nextReadingDate: $scope.userContract.prm.next_reading_date,
                plan: $scope.userContract.plan
            };
            $scope.data = {
                loading: false,
                graph: Chart.utils.generateGraphData(contractCons, opts)
            };
        } else {
            $scope.data = { loading: false, graph: { data: null } };
        }

        if (landscapeQuestions && landscapeQuestions.length) {
            $scope.landscapeQuestions = landscapeQuestions;
        }
    };

    activate();
}

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(5);

var _angular2 = _interopRequireDefault(_angular);

var _templateInfo = __webpack_require__(1191);

var _templateInfo2 = _interopRequireDefault(_templateInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
exports.default = _angular2.default.module('unergie.template', []).component('templateInfo', _templateInfo2.default).name;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TemplateInfoCtrl =
/** @ngInject */
["ContactTelephone", function TemplateInfoCtrl(ContactTelephone) {
    _classCallCheck(this, TemplateInfoCtrl);

    this.ContactTelephone = ContactTelephone;
}];

exports.default = {
    template: __webpack_require__(1192)(),
    controller: TemplateInfoCtrl,
    bindings: {}
};

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"visible-xs-block\"\u003E\u003Cheader class=\"navbar-mobile\"\u003E\u003Cdiv class=\"header-col header-col-logo\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg class=\"mobile-image\" alt=\"logo plüm\" src=\"\u002Fassets\u002Fimg\u002Fplum_white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"header-col header-col-title\"\u003E\u003Cspan\u003EUn titre à remplacer\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hidden-xs\"\u003E\u003Cnav class=\"navbar navbar-default\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"navbar-header col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"navbar-brand\"\u003E\u003Ca ui-sref=\"landing\"\u003E\u003Cimg alt=\"logo unergie\" src=\"\u002Fassets\u002Fimg\u002Flogo-plum-white.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"navbar-text\"\u003EUn titre à remplacer\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ETHIS IS A COMPONENT TITLE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cdiv class=\"text-center margin-top-20 darkish-pink\"\u003E\u003Ch4\u003EExemple de titre\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cp\u003ENunc sed nulla leo. Aliquam dapibus tempor nisl quis laoreet.\nSuspendisse lacinia purus in ipsum aliquam congue. Suspendisse vitae est augue.\nVestibulum venenatis eu enim vitae porta. Vivamus sit amet dignissim tellus, sit amet pretium nisi.\nCras nunc nulla, tristique a orci fringilla, dictum ornare lacus. Sed et efficitur libero.\nMaecenas et libero nulla.\u003C\u002Fp\u003E\u003Cul class=\"margin-top-20\"\u003E\u003Cli\u003ELorem ipsum dolor sit amet, consectetur adipiscing elit.\u003C\u002Fli\u003E\u003Cli\u003EMorbi in quam sed purus sodales viverra.\u003C\u002Fli\u003E\u003Cli\u003ENullam sollicitudin ligula eu posuere malesuada.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"text-center margin-top-20\"\u003E\u003Cstrong\u003EPhasellus rutrum urna ut arcu rhoncus !\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center margin-top-20\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsubscription\u002Frocket.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-container margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row margin-top-20 margin-bottom-20\"\u003E\u003Cdiv class=\"col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1\"\u003E\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ETHIS IS A COMPONENT TITLE\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12\"\u003E\u003Ch1\u003EExemple de niveau de titre\u003C\u002Fh1\u003E\u003Ch2\u003EExemple de niveau de titre\u003C\u002Fh2\u003E\u003Ch3\u003EExemple de niveau de titre\u003C\u002Fh3\u003E\u003Ch4\u003EExemple de niveau de titre\u003C\u002Fh4\u003E\u003Ch5\u003EExemple de niveau de titre\u003C\u002Fh5\u003E\u003Ch6\u003EExemple de niveau de titre\u003C\u002Fh6\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cspan class=\"background-dark-pink\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-dark-pink\u003Cbr\u003E\u003Cspan class=\"background-darkish-pink\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-darkish-pink\u003Cbr\u003E\u003Cspan class=\"background-white\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-white\u003Cbr\u003E\u003Cspan class=\"background-none\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-none\u003Cbr\u003E\u003Cspan class=\"background-bluegrey\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-bluegrey\u003Cbr\u003E\u003Cspan class=\"background-gold\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-gold\u003Cbr\u003E\u003Cspan class=\"background-gold-dark\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-gold-dark\u003Cbr\u003E\u003Cspan class=\"background-marine\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-marine\u003Cbr\u003E\u003Cspan class=\"background-waterblue\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-waterblue\u003Cbr\u003E\u003Cspan class=\"background-waterblue-dark\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-waterblue-dark\u003Cbr\u003E\u003Cspan class=\"background-beige\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-beige\u003Cbr\u003E\u003Cspan class=\"background-bluegrey-pale\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-bluegrey-pale\u003Cbr\u003E\u003Cspan class=\"background-blue-facebook\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-blue-facebook\u003Cbr\u003E\u003Cspan class=\"background-blue-dark-selectra\" style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E.background-blue-dark-selectra\u003Cbr\u003E\u003Cspan style=\"display: inline-block; width: 30px; height: 30px;\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cp class=\"waterblue\"\u003EExemple de niveau de titre .waterblue\u003C\u002Fp\u003E\u003Cp class=\"gold\"\u003EExemple de niveau de titre .gold\u003C\u002Fp\u003E\u003Cp class=\"light-pink\"\u003EExemple de niveau de titre .light-pink\u003C\u002Fp\u003E\u003Cp class=\"dark-pink\"\u003EExemple de niveau de titre .dark-pink\u003C\u002Fp\u003E\u003Cp class=\"light-green\"\u003EExemple de niveau de titre .light-green\u003C\u002Fp\u003E\u003Cp class=\"darkish-pink\"\u003EExemple de niveau de titre .darkish-pink\u003C\u002Fp\u003E\u003Cp class=\"marine\"\u003EExemple de niveau de titre .marine\u003C\u002Fp\u003E\u003Cp class=\"bluegrey\"\u003EExemple de niveau de titre .bluegrey\u003C\u002Fp\u003E\u003Cp class=\"showroom-red\"\u003EExemple de niveau de titre .showroom-red\u003C\u002Fp\u003E\u003Cp class=\"blue-light-selectra\"\u003EExemple de niveau de titre .blue-light-selectra\u003C\u002Fp\u003E\u003Cp class=\"blue-dark-selectra\"\u003EExemple de niveau de titre .blue-dark-selectra\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container-fluid background-white\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row background-beige\" style=\"margin-top: 20px\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Ch2\u003EBackground beige\u003C\u002Fh2\u003E\u003Ch4\u003EThis is an example with background beige\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cp\u003E00 11 22 33 44\u003C\u002Fp\u003E\u003Cp\u003Ecould you solutionize that for me, nor can you pimp this powerpoint\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Ch3\u003EInfo zone 1\u003C\u002Fh3\u003E\u003Chr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ENom\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003EDoe\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EPrénom\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003EJohn\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ENuméro de voie\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E{{ contractDraft.addr_num_street }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003EAdresse\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003E123 rue de la singularité\u003Cbr\u003EBatiment Intelligence Artificiel\u003Cbr\u003E2045 Quelque part dans le futur\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Ch3\u003EInfo zone 2\u003C\u002Fh3\u003E\u003Chr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ETitre\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003EValeur\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Ch3\u003EInfo zone 3\u003C\u002Fh3\u003E\u003Chr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-6 col-xs-12\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"col-sm-4\"\u003ETitre\u003C\u002Flabel\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cp\u003EValeur\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-top-20 margin-bottom-20\"\u003E\u003Ch3\u003EInfo zone 4\u003C\u002Fh3\u003E\u003Chr\u003E\u003Cdiv class=\"row\" ng-class=\"{'error top-error': value1 !== true}\"\u003E\u003Ci class=\"fa fa-warning\" ng-if=\"true\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput type=\"checkbox\" ng-model=\"value1\"\u003EOui\u002FNon\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-12 form-error\" ng-if=\"value1 !== true\"\u003E\u003Cp\u003ELa checkbox n'est pas coché\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Clabel\u003E\u003Cinput type=\"checkbox\"\u003EAnother checkbox\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Ch5\u003EMessage important\u003C\u002Fh5\u003E\u003Cp\u003ECeci est un exemple de boite contenant un message important à notifier\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ })
]),[352]);


// WEBPACK FOOTER //
// main-5d6863edd0b27ddc974e.js